/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 108);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(153);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export validateFields */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getImgUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return limitText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return compareDates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return shuffle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return geinstagramData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return asyncgetWeather; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getWeather; });
/* unused harmony export foundInString */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getBrowser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isMobile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_detect_browser__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_detect_browser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_detect_browser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Validator_Validator__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Axios_Axios__ = __webpack_require__(258);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var validateFields=function validateFields(fields){var errors=[];var v=new __WEBPACK_IMPORTED_MODULE_3__Validator_Validator__["a" /* default */]();for(var i in fields){var currentField=fields[i];var validationType=currentField.validationType;var res=null;if(validationType==="simple"){res=v.simpleValidation({val:currentField.val,err_1:currentField.err_1});}else if(validationType==="email"){res=v.regx_validation({val:currentField.val,err_1:currentField.err_1,err_2:currentField.err_2,expression:/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/});}else if(validationType==="phone"){res=v.regx_validation({val:currentField.val,err_1:currentField.err_1,err_2:currentField.err_2,expression:/^[0-9]{9,11}$/});}else if(validationType==="number"){res=v.regx_validation({val:currentField.val,err_1:currentField.err_1,err_2:currentField.err_2,expression:/^[0-9]+$/});}else if(validationType==="licence"){res=v.regx_validation({val:currentField.val,err_1:currentField.err_1,err_2:currentField.err_2,expression:/^[0-9]+(-?[0-9]+)+$/});}if(res!==true){errors.push("err");currentField.cssClass=currentField.cssClass+" err-border ";}else{currentField.cssClass=currentField.cssClass+"succses-border";}}// check to  see if error acourd
if(errors.length===0){return true;}else{return false;}};var getUrl=function getUrl(){var host=window.location.host;var protocol=window.location.protocol;//THe air url
// const url = protocol + "//" + host   + '/';
var url=protocol+"//"+host+'/';// local
// const url = protocol + "//" + host   ;
return url;};var getImgUrl=function getImgUrl(){var url='https://ch.goisrael.com/assets2/img/';return url;};var limitText=function limitText(string){var length=arguments.length>1&&arguments[1]!==undefined?arguments[1]:40;var trimmedString=string.substring(0,length);var dots="";if(string.length>length){dots="";}return trimmedString+""+dots;};var compareDates=function compareDates(date1,date2){var patt=new RegExp(/[0-9]{1,2}-[0-9]{2}./);var res=patt.test(date2);var enDateFormat=[];if(res===true){var dateToArr=date2.split('.');// console.log(dateToArr);
var days=dateToArr[0];var daysToArr=days.split("-");var lastDay=daysToArr[1];dateToArr.shift();// remove first arr cell
dateToArr.unshift(lastDay);// add first arr cell
enDateFormat[0]=dateToArr[1];enDateFormat[1]=dateToArr[0];enDateFormat[2]=dateToArr[2];var newDate=enDateFormat.join('.');var date2=new Date(newDate);// console.log(' newDate ', newDate);
}else{var dateToArr=date2.split('.');enDateFormat[0]=dateToArr[1];enDateFormat[1]=dateToArr[0];enDateFormat[2]=dateToArr[2];var newDate=enDateFormat.join('.');// console.log(' newDate ', newDate);
var date2=new Date(newDate);}var d1=date1.getTime();var d1FullDate=date1.getDate()+"."+(date1.getMonth()+1)+"."+date1.getFullYear();var d2=date2.getTime();var d2FullDate=date2.getDate()+"."+(date2.getMonth()+1)+"."+date2.getFullYear();var isTodayBigger=d1>d2;if(d1FullDate===d2FullDate){isTodayBigger=false;}return isTodayBigger;};var shuffle=function shuffle(){var o=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];for(var j,x,i=o.length;i;j=parseInt(Math.random()*i),x=o[--i],o[i]=o[j],o[j]=x){}return o;};// Prod
var geinstagramData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(callback){var res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return __WEBPACK_IMPORTED_MODULE_5__Axios_Axios__["a" /* default */].get("https://goisrael.com/assets/insta-images.php");case 2:res=_context.sent;return _context.abrupt('return',res.data);case 4:case'end':return _context.stop();}}},_callee,_this);}));return function geinstagramData(_x3){return _ref.apply(this,arguments);};}();var asyncgetWeather=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var weatherData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return __WEBPACK_IMPORTED_MODULE_5__Axios_Axios__["a" /* default */].get("https://goisrael.com/weather.php",{params:{method:"get_weather"}});case 2:weatherData=_context2.sent;// console.log('WEATHER:', typeof weatherData); // object
console.log('WEATHER:',_typeof(weatherData.data));// 
// return weatherData.data;
return _context2.abrupt('return',weatherData.data);case 5:case'end':return _context2.stop();}}},_callee2,_this);}));return function asyncgetWeather(){return _ref2.apply(this,arguments);};}();// Local 
// export const geinstagramData=  async callback => {
// 	const res 	= await  Http.get("https://view.activated.co.il/twocities/de/assets/insta-images.php");
// 	console.log('res' , res);
// 	return res.data;
// }
// export const asyncgetWeather = async  () => {
// 	const weatherData 	= await Http.get("https://view.activated.co.il/twocities/de/weather.php" , {params : {method: "get_weather"}});
// 	return weatherData.data;
// } 
// to do make  this async await 
var getWeather=function getWeather(callback){__WEBPACK_IMPORTED_MODULE_5__Axios_Axios__["a" /* default */].get("https://goisrael.com/weather.php",{params:{method:"get_weather",city:"deadsea"}}).then(function(res){var deadSeaWeather=res.data.temperature;__WEBPACK_IMPORTED_MODULE_5__Axios_Axios__["a" /* default */].get("https://goisrael.com/weather.php",{params:{method:"get_weather",city:"jerusalem"}}).then(function(res){var jerusalemWeather=res.data.temperature;var water_temp=res.data.water_temp;__WEBPACK_IMPORTED_MODULE_5__Axios_Axios__["a" /* default */].get("https://goisrael.com/weather.php",{params:{method:"get_weather",city:"Tel Aviv"}}).then(function(res){var telAvivWeather=res.data.temperature;var o={jerusalemWeather:jerusalemWeather,water_temp:water_temp,telAvivWeather:telAvivWeather,deadSeaWeather:deadSeaWeather};callback(o);});});});};// export const geinstagramData= callback => {
// 	Http.get("https://en.citiesbreak.com/assets/insta-images.php")
//     .then(res => {
//     	callback(res);
//     	// return res;        
//     });
// }
var foundInString=function foundInString(text,match){return new RegExp(match).test(text);};var getBrowser=function getBrowser(){var browser=Object(__WEBPACK_IMPORTED_MODULE_2_detect_browser__["detect"])();// handle the case where we don't detect the browser
if(!browser){browser.name='centDetectBrowser';browser.version='0';}return browser;};var isMobile=function isMobile(){var isMobile=false;var windowW=window.innerWidth;if(windowW<1000){isMobile=true;}return isMobile;};

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Input */
/* unused harmony export Select */
/* unused harmony export TopPart */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return Img; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return Logo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return HomeTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return WeatherIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ResponsiveYouTubeIframe; });
/* unused harmony export VideoSliderItem2 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return VideoSliderItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ConcertSliderItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return PostSliderItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return InstagremSliderItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GallerSideBarItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ImgAndText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FaqItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CoverSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return HomeDeals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return HomeSlider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AnimateCallToAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActivaImg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return TravelAlert; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SimpleSlider_SimpleSlider__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Deals_Deals__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_youtube__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UI_css__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UI_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__UI_css__);
var Input=function Input(props){var name=props.name;var labelProp=props.label;var cssWrapperClass='form-input-wrapper input-'+name+'-wrapper '+props.inputCssClass;var cssInputClass=' input-'+name+' ';var labelField='';var id="ac-input-"+new Date().getTime();if(labelProp!==undefined){cssWrapperClass+=' inputHasLabel ';labelField=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:id},' ',props.label,' ');}var html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssWrapperClass},labelField,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:id,'data-validation-type':props.validationType,onClick:props.click,onChange:props.change,type:props.type,name:name,className:cssInputClass,placeholder:props.placeholder,value:props.val}));if(props.type==="hidden"){html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:props.type,name:name,className:cssInputClass,placeholder:props.placeholder,value:props.val});}return html;};var Select=function Select(props){var name=props.name;var cssWrapperClass='form-input-wrapper input-'+name+'-wrapper select-'+name+'-wrapper'+props.cssClass;var cssInputClass='select-'+name+' ';var labelProp=props.label;var labelField='';var id="ac-input-"+new Date().getTime();if(labelProp!==undefined){cssWrapperClass+=' inputHasLabel ';labelField=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:id},' ',props.label,' ');}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssWrapperClass},labelField,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:props.change,name:props.name,className:cssInputClass},props.children,';'));};var TopPart=function TopPart(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'App-header alignCenter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'App-title'},props.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,props.text)));};var Img=function Img(props){var windowW=window.innerWidth;var desktopImg=props.desktopImg?Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["e" /* getImgUrl */])()+""+props.desktopImg:"";var mobileImg=props.mobileImg?Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["e" /* getImgUrl */])()+""+props.mobileImg:"";var html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:desktopImg,alt:''}));if(props.mobileImg!=undefined){if(windowW<1000){html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'show-on-mobile',src:mobileImg,alt:''}));}}return html;};var Btn=function Btn(props){var cssClass=props.cssClass?'ac-btn '+props.cssClass:props.cssClass;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:cssClass,onClick:props.onClick},props.children);};var Logo=function Logo(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logoWrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:"logo.png"}));};var HomeTitle=function HomeTitle(props){var cssClass='home-title-wrapper '+props.cssClass;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,props.children),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-border'}));};var WeatherIcon=function WeatherIcon(props){var p=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,props.temp,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('sup',null,'o'),'C');var imgPath="WeatherIcon.png";var weatherClass='weather-icon-wrapper';if(props.temp==="4h25"){p=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,props.temp);imgPath="WeatherIcon2.png";weatherClass='weather-icon-wrapper flight-icon-wrapper';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:weatherClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:imgPath}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,props.label),p);};var ResponsiveYouTubeIframe=function ResponsiveYouTubeIframe(props){// const videoSrc = 'https://www.youtube.com/embed/'+props.vidId+'/?autoplay=1&mute=1&rel=0&loop=1&playlist=' + props.vidId;
var youTubeOptions={playerVars:{// https://developers.google.com/youtube/player_parameters
'autoplay':1,'muted':1,'controls':1,'loopPlaylists':true,'loop':1,'playlist':props.vidId,'sandbox':"allow-same-origin allow-popups",'origin':'https://new.goisrael.com/'}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'responisve-iframe'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_youtube__["a" /* default */],{videoId:props.vidId,opts:youTubeOptions,onReady:function onReady(event){event.target.mute();event.target.playVideo();}}));};var VideoSliderItem2=function VideoSliderItem2(props){var youTubeOptions={playerVars:{// https://developers.google.com/youtube/player_parameters
autoplay:1,muted:1,sandbox:"allow-same-origin allow-popups",origin:'https://new.goisrael.com/'}};var desc=props.desc!=undefined?props.desc:"";var doBlank=props.doBlank!=undefined?props.doBlank:"";var title=props.title!=undefined?Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["i" /* limitText */])(props.title,30):"";var mobileId=props.mobileId!=''?props.mobileId:"";var cssClass='cites-slider video-slider-item '+props.cssClass;// console.log('props.mobileId' , props.mobileId);
// alert(mobileId);
var target='';if(doBlank){target='_blank';}var html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:props.link,target:target,className:'read-more-link'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-img-wrapper',onClick:props.click},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:props.img}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-play-img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:"Videos/play.png"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'desc-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["i" /* limitText */])(desc))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'book-now-wrappr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:props.link,target:target},'WEITERLESEN  >>'))));if(Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["h" /* isMobile */])()){// console.log('mobileId' , mobileId);
var ht=null;if(mobileId!=""){ht=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-make-vid-responsive'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_youtube__["a" /* default */],{videoId:mobileId,opts:youTubeOptions,onReady:function onReady(event){event.target.mute();event.target.playVideo();}}));}else{ht=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:props.img}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-play-img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:"Videos/play.png"})));}// alert('s');
html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-img-wrapper',onClick:props.clickMobile},ht),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'desc-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["i" /* limitText */])(desc))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'book-now-wrappr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:props.link,target:target},'WEITERLESEN  >>'))));}return html;};var VideoSliderItem=function VideoSliderItem(props){var desc=props.desc!=undefined?props.desc:"";var cssClass='cites-slider video-slider-item '+props.cssClass;var doBlank=props.doBlank!=undefined?props.doBlank:"";var target='';if(doBlank){target='_blank';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:props.link,target:target,className:'read-more-link'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-img-wrapper',onClick:props.click},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:props.img}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-play-img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:"Videos/play.png"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:props.link,target:target},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["i" /* limitText */])(props.title,50)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'desc-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["i" /* limitText */])(desc))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'book-now-wrappr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:props.link,target:target},'WEITERLESEN  >>'))));};var ConcertSliderItem=function ConcertSliderItem(props){var desc=props.desc;var cssClass='cites-slider concert-slider-item '+props.cssClass;if(props.isTodayBigger===true){cssClass+=' ac-disabled addOpacity ';}var doBlank=props.doBlank!=undefined?props.doBlank:"";var target='';if(doBlank){target='_blank';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:props.link,target:target,className:'read-more-link'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'concert-img-wrapper',onClick:props.click},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:props.img})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,props.title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'desc-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["i" /* limitText */])(props.desc))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'book-now-wrappr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:props.link},'WEITERLESEN  >>')));};var PostSliderItem=function PostSliderItem(props){var desc=props.desc!=undefined?props.desc:"";var cssClass='cites-slider concert-slider-item'+props.cssClass;var doBlank=props.doBlank!=undefined?props.doBlank:"";var target='';if(doBlank){target='_blank';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:props.link,target:target,className:'read-more-link'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'concert-img-wrapper',onClick:props.click},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:props.img})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,props.title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'desc-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["i" /* limitText */])(desc))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'book-now-wrappr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:props.link},'WEITERLESEN >>')));};var InstagremSliderItem=function InstagremSliderItem(props){var desc=props.desc;var cssEClass=props.cssClass!==undefined?props.cssClass:'';var cssClass='cites-slider concert-slider-item '+cssEClass;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'insta-img-wrapper',onClick:props.click},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:props.img}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'insta-icon-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:"insta-icon.png"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'@',props.title)));};var GallerSideBarItem=function GallerSideBarItem(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cites-slider gallery-slider-item align-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:props.link,className:'read-more-link'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gallery-img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:props.img})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,props.title)));};var ImgAndText=function ImgAndText(props){var cssClass='box col col-50 '+props.cssClass;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{target:'blank',to:props.link,className:'read-more-link'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:props.img,mobileImg:props.img_mob}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'link-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:props.link,target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,props.text)))));};var FaqItem=function FaqItem(props){var cssClass="faq-answer close";var cssClass2="icon-wrapper closeIcon";if(props.isOpen===true){cssClass="faq-answer open";cssClass2="icon-wrapper openIcon";}var ht=props.answer;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'faq-q-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'faq-q',onClick:props.click},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,props.q),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:"collpase-icon.jpg"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass,dangerouslySetInnerHTML:{__html:ht}}));};var CoverSection=function CoverSection(props){var desktopImg=props.desktopImg;var mobileImg=props.mobileImg;var cssClass=props.cssClass;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:"ac-cover-section ac-cover-section-"+props.cssClass,id:'part-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:props.desktopImg,mobileImg:props.mobileImg}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'weather-wrapper show-on-mobile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WeatherIcon,{label:"WASSERTEMPERATUR",temp:props.waterTemp}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WeatherIcon,{label:"TEL AVIV",temp:props.telAvivWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WeatherIcon,{label:"JERUSALEM",temp:props.jerusalemWeather})));};var HomeDeals=function HomeDeals(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'home-section caruasel-wrapper  home-section-padding',id:'deals'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HomeTitle,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:'/Pages/bestDeals',className:'ac-book-holiday'},'BUCHE JETZT DEINE REISE')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Deals_Deals__["a" /* default */],null)));};var HomeSlider=function HomeSlider(props){var bannerSliderSettings={dots:false,infinite:true,fade:true,cssEase:'linear',autoplay:true,lazyLoad:"ondemand",slidesToShow:1,slidesToScroll:1};var html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SimpleSlider_SimpleSlider__["a" /* default */],{settings:bannerSliderSettings},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:'/Pages/bestDeals'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:"HomeSlider/3.jpg",mobileImg:"HomeSlider/M/3.jpg"}))));var isHomeSlider=props.isHomeSlider!==undefined?props.isHomeSlider:false;if(isHomeSlider===true){if(window.innerWidth<1000){//   html = <Img mobileImg={'/HomeSlider/M/douze.jpg'} />;
// }else {
// html = <div className="ac-responsive-video">
// <iframe className="ac-responsive-item" width="560" height="315" src="https://www.youtube.com/embed/5PAjhoH0NWU?mute=1&autoplay=1&playlist=5PAjhoH0NWU&rel=0&controls=0&loop=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
//  </div>
//   html = <Img desktopImg={"/1920-500.jpg"} />;
// }
html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SimpleSlider_SimpleSlider__["a" /* default */],{settings:bannerSliderSettings},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{mobileImg:"HomeSlider/M/3.jpg"})));}else{html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SimpleSlider_SimpleSlider__["a" /* default */],{settings:bannerSliderSettings},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:"HomeSlider/Home/1.jpg"})));}}else{if(window.innerWidth<1000){html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SimpleSlider_SimpleSlider__["a" /* default */],{settings:bannerSliderSettings},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{mobileImg:"HomeSlider/M/3.jpg"})));}else{html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SimpleSlider_SimpleSlider__["a" /* default */],{settings:bannerSliderSettings},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:'/Pages/bestDeals'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:"HomeSlider/Home/1a.jpg"}))));}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'home-section caruasel-wrapper banners-caruasel-wrapper',id:'part-1'},html,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'weather-wrapper show-on-mobile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WeatherIcon,{label:"WASSERTEMPERATUR",temp:props.waterTemp}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WeatherIcon,{label:"Jerusalem",temp:props.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WeatherIcon,{label:"Tel Aviv",temp:props.telAvivWeather})));};var AnimateCallToAction=function AnimateCallToAction(props){var cssClass="hide-on-mobile"+props.cssClass;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:props.link,target:'_blank',className:cssClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:props.src}));};var ActivaImg=function ActivaImg(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-img-wrapper',onClick:props.click},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:props.src}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-play-img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:"Videos/play.png",className:'video-play-ggg'})));};var TravelAlert=function TravelAlert(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'home-section home-section-padding',id:'travel-alert'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container ac-flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-travel-alert-message col-80'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{exact:true,to:'/Pages/CoronaVirusPage'},'Reisehinweis: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Hier'),' erhalten Sie die neuesten Reisehinweise'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-travel-alert-close-wrapper col-20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-travel-alert-close',onClick:props.click},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'+'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'})));};

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Menu_css__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Menu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Menu_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var appCountrys=[{langCode:"de",subDomain:"de",countryName:"Deutsch"},{langCode:"nl",subDomain:"nl",countryName:"Dutch"},{langCode:"at",subDomain:"at",countryName:"Österreich"},{langCode:"pl",subDomain:"pl",countryName:"Polski"},{langCode:"ro",subDomain:"ro",countryName:"Română"},{langCode:"se",subDomain:"se",countryName:"Svenska"},{langCode:"ch",subDomain:"ch",countryName:"Schwyzerdütsch"},{langCode:"cz",subDomain:"cz",countryName:"Cseh"},{langCode:"dk",subDomain:"dk",countryName:"Danish"},{langCode:"hu",subDomain:"hu",countryName:"Magyar"},{langCode:"uk",subDomain:"uk",countryName:"English"},{langCode:"ru",subDomain:"ru",countryName:"Русский"},{langCode:"fr",subDomain:"fr",countryName:"Français"},{langCode:"es",subDomain:"es",countryName:"Español"},{langCode:"it",subDomain:"it",countryName:"Italiana"},{langCode:"eu",subDomain:"eu",countryName:"الإمارات العربية المتحدة"},{langCode:"eu-en",subDomain:"eu-en",countryName:"United Arab Emirates"}];var CurrentFlagIcon=function CurrentFlagIcon(props){var lang=props.lang?props.lang:"";var langName=props.langName?props.langName:"";var hideArrow=props.hideArrow===true?true:false;var arrow=null;if(hideArrow==false){arrow=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UI_UI__["j" /* Img */],{desktopImg:'/right-arrow-wb.png',cssclassName:'bottom-arrow'});}if(Object(__WEBPACK_IMPORTED_MODULE_3__Utility_Utility__["h" /* isMobile */])()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"flat-icon-div"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:'flat-icon-wrapper flat-icon-'+lang},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:props.setLangState},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UI_UI__["j" /* Img */],{desktopImg:'/flags/4x3/'+lang+'.svg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,langName)),arrow)));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:'flat-icon-wrapper flat-icon-'+lang},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:props.setLangState},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UI_UI__["j" /* Img */],{desktopImg:'/flags/4x3/'+lang+'.svg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,langName)),arrow));}};var Menu=function(_Component){_inherits(Menu,_Component);function Menu(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Menu);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Menu.__proto__||Object.getPrototypeOf(Menu)).call.apply(_ref,[this].concat(args))),_this),_this.state={isOpen:false,isLangOpen:false},_this.setMenuState=function(){if(_this.state.isLangOpen){_this.setState({isLangOpen:!_this.state.isLangOpen,isOpen:!_this.state.isOpen});}else{_this.setState({isOpen:!_this.state.isOpen});}},_this.redirect=function(subDomain){if(subDomain==="ru"||subDomain==="at"||subDomain==="ch"||subDomain==="en"||subDomain==="pl"||subDomain==="it"||subDomain==="es"||subDomain==="de"||subDomain==="fr"||subDomain==="eu"||subDomain==="eu-en"){window.location.href='https://new.goisrael.com/'+subDomain;}else{window.location.href='https://goisrael.com/?lang='+subDomain;// window.location.href =  'http://localhost:3000/international/?lang=' + subDomain;
}},_this.setLangState=function(){if(Object(__WEBPACK_IMPORTED_MODULE_3__Utility_Utility__["h" /* isMobile */])()){_this.setState({isLangOpen:!_this.state.isLangOpen,isOpen:!_this.state.isOpen});}else{_this.setState({isLangOpen:!_this.state.isLangOpen});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Menu,[{key:"render",value:function render(){var _this2=this;var isLangOpen=this.state.isLangOpen;var cssClass="inner";var parentCssClass="";if(this.state.isOpen===true){cssClass+=" open";}var countryContainer=null;var countryCssClass='country-close';if(isLangOpen){countryCssClass='country-open';countryContainer=appCountrys.map(function(o){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CurrentFlagIcon,{lang:o.langCode,langName:o.countryName,setLangState:function setLangState(){_this2.redirect(o.subDomain);},hideArrow:true});});}var langName='CH';var langCode='ch';var CurrentLang='ch';if(CurrentLang!=null){// langName = CurrentLang.toUpperCase();
// if ( CurrentLang == "ch"){
//   langCode = 'ch';
// }else {
//   langCode = CurrentLang;
// }
langName='CH';langCode='ch';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,this.state.isLangOpen&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"nav-trigger-overlay",onClick:this.setLangState}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"menu-outer-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col col-15 logo-outer-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{exact:true,className:"first",to:"/"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UI_UI__["m" /* Logo */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col col-100 menu-inner-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:cssClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{exact:true,className:"first",to:"/"},"STARTSEITE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{exact:true,to:"/Pages/bestDeals"},"BESTE ANGEBOTE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{exact:true,to:"/Pages/whereToGo"},"SEHEN"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{exact:true,to:"/Pages/thingsToDo"},"ERLEBEN"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{exact:true,to:"/Pages/Gallery/"},"GALERIE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{exact:true,to:"/Pages/Videos"},"VIDEOS"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{exact:true,to:"/Pages/TourisInfoPage"},"TOURISTENINFO"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CurrentFlagIcon,{lang:langCode,langName:langName,setLangState:this.setLangState,hideArrow:false})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"show-on-mobile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"open-mobile-menu navbar-toggle",onClick:this.setMenuState},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon-bar"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon-bar"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon-bar"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:'container country-container '+countryCssClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"country-container-inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"country-container-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,"Choose your language:")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"country-container-flags-wrapper"},countryContainer))));}}]);return Menu;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Menu);

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Footer_css__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Footer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Footer_css__);
var Footer=function Footer(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"Footer-outer-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col col-100 footer-menu-outer-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"footer-menu-inner-wrapper footer-menu-inner-wrapper-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"first"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{className:"first",to:"/Pages/whereToGo"},"SEHEN")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"show-on-mobile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,"|")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Pages/TelAvivPage"},"TEL AVIV")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"show-on-mobile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,"|")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Pages/JerusalemPage"},"JERUSALEM")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"show-on-mobile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,"|")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Pages/DeadSeaPage"},"DAS TOTE MEER")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"show-on-mobile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,"|"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{className:"first",to:"/Pages/thingsToDo"},"ERLEBEN")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"show-on-mobile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,"|")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Posts/telaviv/14"},"DIE STRA DIE STRANDE VON TLV")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"show-on-mobile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,"|")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Posts/telavivAndJerusalem/35"},"SCHAUEN SIE IM REISEFUHRER")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"show-on-mobile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,"|")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Posts/telaviv/36"},"EIN TAG IN TEL AVIV")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"show-on-mobile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,"|"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{className:"first",to:"/Pages/Videos"},"VIDEOS")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"show-on-mobile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,"|")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Posts/Videos/telaviv/20"},"TEL AVIV ABENTEUER")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"show-on-mobile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,"|")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Posts/Videos/deadsea/14"},"DAS TOTE MEER")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"show-on-mobile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,"|")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Posts/Videos/telaviv/3"},"DIE H\xC4FEN VON TEL AVIV")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"show-on-mobile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,"|"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-wrapper-telaviv-and-jerusalem-footer ac-flex ac-flex-row ac-flex-row-mob"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"telaviv-and-jerusalem-footer"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"jer-site",href:"https://www.itraveljerusalem.com/",target:"_blank"},"Offizielle Tourismus-Website der Stadt Jerusalem >>")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-verti-line hide-on-mobile"}," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"telaviv-and-jerusalem-footer"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"tlv-site",href:"https://visit.tel-aviv.gov.il/home",target:"_blank"},"Offizielle Tourismus-Website der Stadt Tel Aviv >>")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"telaviv-and-jerusalem-footer"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"ac-privacy-policy",href:"https://new.goisrael.com/de/Posts/telaviv/Privacy_Policy",target:"_blank"},"PRIVACY POLICY >>"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-social-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-inner-social-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-social-col ac-social-col-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://www.instagram.com/visit_israel/"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["j" /* Img */],{desktopImg:"social/i.png",mobileImg:"social/i.png"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-social-col ac-social-col-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://www.youtube.com/@goisraelofficial"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["j" /* Img */],{desktopImg:"social/y.png",mobileImg:"social/y.png"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-social-col ac-social-col-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://www.flickr.com/photos/israelphotogallery/sets/"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["j" /* Img */],{desktopImg:"social/fl.png",mobileImg:"social/fl.png"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-social-col ac-social-col-5"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://www.facebook.com/BesuchIsrael/"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["j" /* Img */],{desktopImg:"social/f.png",mobileImg:"social/f.png"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-social-col ac-social-col-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://www.tiktok.com/@visit_israel"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["j" /* Img */],{desktopImg:"social/tiktok.png",mobileImg:"social/tiktok.png"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-social-col ac-social-col-7"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://www.linkedin.com/company/israel-ministry-of-tourism/"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["j" /* Img */],{desktopImg:"social/linkedin.png",mobileImg:"social/linkedin.png"}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"cradit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Photographers: Guy Yehieli, Adam Primer, Kfir Boltin, Linnea Andres, Kfir Sivan, Haim Yafim, Dana Fridlander, refael Ben Ari, Itamar Greenberg, Moshik Lindbaum"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Video Credits: Israeli food channel")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",null,"F\xFCr Mehr Angebote:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"sites-logos"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"anoter-site-deal-logo"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{rel:"noopener noreferrer",target:"_blank",href:"https://www.tripadvisor.co.uk/Hotels-g293984-Tel_Aviv_Tel_Aviv_District-Hotels.html"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["j" /* Img */],{desktopImg:"Footer/1.png"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"anoter-site-deal-logo"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{rel:"noopener noreferrer",target:"_blank",href:"https://www.trivago.co.uk/?aDateRange%5Barr%5D=2016-10-13&aDateRange%5Bdep%5D=2016-10-14&r=&cpt=8494803&iRoomType=1&aPriceRange%5Bfrom%5D=0&aPriceRange%5Bto%5D=0&iPathId=84948&iViewType=0&bIsSeoPage=0&bIsSitemap=false"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["j" /* Img */],{desktopImg:"Footer/2.png"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"anoter-site-deal-logo"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{rel:"noopener noreferrer",target:"_blank",href:"https://www.booking.com/city/il/tel-aviv.de.html?label=gen173nr-1FCAMoakIIdGVsLWF2aXZIM1gEaGqIAQGYATHCAQp3aW5kb3dzIDEwyAEM2AEB6AEB-AECkgIBeagCAw;sid=c446e24035313eeb81920ae79c778a42;lang=de;soz=1;lang_click=other;cdl=en-gb"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["j" /* Img */],{desktopImg:"Footer/3.png"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"anoter-site-deal-logo"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{rel:"noopener noreferrer",target:"_blank",href:"https://www.expedia.com/Tourist-Information-Office-Tel-Aviv.d507139.Vacation-Attraction"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["j" /* Img */],{desktopImg:"Footer/4.png"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"anoter-site-deal-logo"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{rel:"noopener noreferrer",target:"_blank",href:"https://ch.hotels.com/de699178/hotels-tel-aviv-israel/?pos=HCOM_CH&locale=de_CH"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["j" /* Img */],{desktopImg:"Footer/5.png"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}))));};/* harmony default export */ __webpack_exports__["a"] = (Footer);

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(163)();
}


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export thingsToDoArr */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TouristInfoPosts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return newVideos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return showsArr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return faqData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return newPosts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Reminders; });
var thingsToDoArr=[];var TouristInfoPosts=[{"title":"VERKEHRSMITTEL",// "sml_desc": "",
"sml_desc":"","desc":"","img":"/PostCarousel/transportation.jpg","side_img":"/PostCarousel/transportation.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=Transport","ctg":"TouristInfo","isVid":false,"id":"Transport"},{"title":"REISEPASS UND VISUM",// "sml_desc": "",
"sml_desc":"","desc":"","img":"/PostCarousel/Passports-visa.jpg","side_img":"/PostCarousel/Passports-visa.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=Passport_Visa","ctg":"TouristInfo","isVid":false,"id":"Passport_Visa"},{"title":"WAS SOLLTEN SIE EINPACKEN?",// "sml_desc": "",
"sml_desc":"","desc":"","img":"/PostCarousel/what-to-pack.jpg","side_img":"/PostCarousel/what-to-pack.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=What_To_Pack","ctg":"TouristInfo","isVid":false,"id":"What_To_Pack"},{"title":"ELEKTRISCHE GERÄTE",// "sml_desc": "",
"sml_desc":"","desc":"","img":"PostCarousel/electrical-appliances.jpg","side_img":"PostCarousel/electrical-appliances.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=Electrical_Appliances","ctg":"TouristInfo","isVid":false,"id":"Electrical_Appliances"},{"title":"FAQ",// "sml_desc": "Welche papiere/visa benötige ich zur einreise nach Israel?",
"sml_desc":"","desc":"","img":"PostCarousel/faq.jpg","side_img":"PostCarousel/faq.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=F_A_Q","ctg":"TouristInfo","isVid":false,"id":"F_A_Q"},{"title":"EIN REISEZIEL FÜR JEDEN GESCHMACK","sml_desc":"","desc":"","img":"/PostCarousel/PlanYourTrip/destination-for-all.jpg","side_img":"/PostCarousel/PlanYourTrip/destination-for-all.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=20","css_class":"unic-post-Passports-visa","isVid":false,"ctg":'TouristInfo',"id":'Destination_For_All'}];var newVideos=[{"title":"Abenteuer im Freien",// "sml_desc": "Tel Aviv im Sattel",
"sml_desc":"",// "desc": "Eine actionreiche Stadt, die\n perfekt für aktive Menschen ist",
"desc":"","img":"Videos/12.jpg","img_mob":"/Videos/video_mob/12.jpg","side_img":"Videos/sidebar/12.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=20","vidId":"88OV6xU0vPI","ctg":"telaviv","forVidPage":true,"isVid":true,"id":20},{"title":"Auf der Suche nach dem ultimativen Nachtleben?",// "sml_desc": " Book your trip to Tel Aviv!",
"sml_desc":"",// "desc": "",
"desc":"","img":"Videos/crazy-night.jpg","img_mob":"/Videos/video_mob/crazy-night.jpg","side_img":"Videos/sidebar/crazy-night.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Crazy_Night","vidId":"ogEN7aRT0SM","ctg":"telaviv","forVidPage":true,"isVid":true,"id":9},{"title":"JERUSALEM",// "sml_desc": "THE HEART OF THE WORLD",
"sml_desc":"",// "desc": "",
"desc":"","img":"Videos/heart-of-the-world.jpg","img_mob":"/Videos/video_mob/heart-of-the-world.jpg","side_img":"Videos/sidebar/heart-of-the-world.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Heart_Of_The_World","vidId":"nLKWDp5uA-U","ctg":"jerusalem","isVid":true,"forVidPage":true,"id":10},{"title":"Modern und lebendig",// "sml_desc": "Es gibt so viel zu sehen in Jerusalems pulsierendem Stadtzentrum",
"desc":"","sml_desc":"","img":"Videos/c.jpg","img_mob":"/Videos/video_mob/c.jpg","side_img":"Videos/sidebar/c.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=19","vidId":"TeLJmRatQeM","ctg":"jerusalem","isVid":true,"forVidPage":true,"id":9},{"title":"DAS TOTE MEER",// "sml_desc": "Zeit für eine Auszeit in \n der glorreichen Natur",
// "desc": "Höchster Genuss am \n tiefstgelegenen Ort der Erde",
"sml_desc":"","desc":"","img":"Videos/f.jpg","img_mob":"/Videos/video_mob/f.jpg","side_img":"Videos/sidebar/f.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?postType=video&post=2","vidId":"ixFocykfYHo","ctg":"deadsea","forVidPage":true,"isVid":true,"id":14},{"title":"Hafenfreuden",// "sml_desc": "Die häfen von Tel Aviv",
// "desc": "Die verschiedenen Reize von \nTel Aviv und Jaffa Häfen",
"sml_desc":"","desc":"","img":"/PostCarousel/3.jpg","img_mob":"/PostCarousel/video_mob/3.jpg","side_img":"/PostCarousel/3.jpg","read_more":"Weiterlesen","vidId":"iHqD5eHDZm8","link":"/Posts/index.php?post=3","ctg":"telaviv","isVid":true,"forVidPage":true,"id":3},{"title":"DAS TOTE MEER",// "sml_desc": "Zeit für eine Auszeit in\nder glorreichen Natur",
// "desc": "Höchster Genuss am \ntiefstgelegenen Ort der Erde",
"sml_desc":"","desc":"","img":"/PostCarousel/100.jpg","img_mob":"/PostCarousel/video_mob/100.jpg","side_img":"/PostCarousel/100.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?postType=video&post=2","vidId":"ixFocykfYHo","css_class":"unic_video-post-3","isVid":true,"forVidPage":true,id:3,ctg:"deadsea"},{"title":"Sarona Tel Aviv",// "desc": "Eine riesige Auswahl von Attraktionen in \n der überwältigenden sanierten Templerkolonie",
// "sml_desc": "Eine atemberaubende urbane Oase",
"sml_desc":"","desc":"","img":"Videos/d.jpg","img_mob":"/Videos/video_mob/d.jpg","side_img":"Videos/sidebar/d.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?postType=video&post=1","vidId":"7JF0z2XPpz0","ctg":"telaviv","isVid":true,"forVidPage":true,"id":7},{"title":"Die Altstadt",// "sml_desc": "Spüre, wie die Geschichte \n zum Leben erwacht",
// "desc": "Lassen Sie sich von den weltberühmten Schätzen \n des historischen Jerusalem inspirieren",
"sml_desc":"","desc":"","img":"Videos/m.jpg","img_mob":"/Videos/video_mob/m.jpg","side_img":"Videos/sidebar/m.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=4","vidId":"1byfX1O7u4g","ctg":"jerusalem","isVid":true,"forVidPage":true,"id":13},{"title":"Neve Tzedek",// "sml_desc": "Schick und einzigartig",
// "desc": "Liebenswerte Cafés, Boutiquen, Kunstgalerien, \n Eleganz und coole Vibes",
"sml_desc":"","desc":"","img":"Videos/j.jpg","img_mob":"/Videos/video_mob/j.jpg","side_img":"Videos/sidebar/j.jpg","read_more":"Weiterlesen","vidId":"-ESCEVfOreY","link":"/Posts/index.php?postType=video&post=7","css_class":"unic_video-post-13","ctg":"telaviv","isVid":true,"forVidPage":true,"id":8},{"title":"Tel Aviv Am Srand",// "sml_desc": "Weil sich das Leben in Tel Aviv \n von der Sonnenseite zeigt",
// "desc": "Bereit für eine volle \nLadung Spaß in der Sonne?",
"sml_desc":"","desc":"","img":"Videos/a.jpg","img_mob":"Videos/video_mob/a.jpg","side_img":"Videos/sidebar/a.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?postType=video&post=3","css_class":"unic_video-post-4","vidId":"ExuWHatIrKE","ctg":"telaviv","isVid":true,"forVidPage":true,"id":4},{"title":"Die Stra Die Strande Von Tel Aviv",// "sml_desc": "Entspannen Sie Sich An Den\n Sonnigen Stranden Von Tel Aviv",
"sml_desc":"","desc":"","img":"/PostCarousel/14.jpg","side_img":"/PostCarousel/14.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=14","isVid":false,"forVidPage":true,"ctg":"telaviv","id":14},{"title":"Tel Aviv",// "sml_desc": "Mit dem Fahrrad in Tel Aviv",
"sml_desc":"","desc":"","img":"PostCarousel/39.jpg","side_img":"PostCarousel/39.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=38","ctg":"telaviv","vidId":"88OV6xU0vPI","forVidPage":true,"isVid":true,"id":39},{"title":"Absolutes Muss in Tel Aviv",// "sml_desc": "Top 5 Stätten, die Sie in der Nonstop-Stadt nicht verpassen wollen",
"sml_desc":"","desc":"","img":"/PostCarousel/17.jpg","side_img":"/PostCarousel/17.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=17","ctg":"telaviv","vidId":"LLOUxE-K_9Y","isVid":true,"forVidPage":true,"id":17},{"title":"Absolutes \'Muss\' in Jerusalem",// "sml_desc": "5 Top-Dinge zu tun und zu sehen in der atemberaubenden Stadt",
"sml_desc":"","desc":"","img":"/PostCarousel/18.jpg","side_img":"/PostCarousel/18.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=18","vidId":"k4OwoEk5wMw","isVid":true,"forVidPage":true,"ctg":"jerusalem","id":18},{"title":"Modern und lebendig",// "sml_desc": "Es gibt so viel zu sehen in Jerusalems pulsierendem Stadtzentrum",
"sml_desc":"","desc":"","img":"/PostCarousel/19.jpg","side_img":"/PostCarousel/19.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=19","vidId":"MXtcTm_JXus","isVid":true,"forVidPage":true,"ctg":"jerusalem","id":19},{"title":"Einkaufsfreuden",// "sml_desc": "Von Couture bis zu Souvenirs, Jerusalem hat alles",
"sml_desc":"","desc":"","img":"/PostCarousel/5.jpg","side_img":"/PostCarousel/5.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=5","ctg":"jerusalem","vidId":"MXtcTm_JXus","isVid":true,"forVidPage":true,"id":5},{"title":"Das Spirituelle Jerusalem",// "sml_desc": "Die Wichtigsten Sehenswurdigkeiten In Jerusalem",
"sml_desc":"","desc":"","img":"/PostCarousel/9.jpg","side_img":"/PostCarousel/9.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=9","isVid":true,"forVidPage":true,"vidId":"k4OwoEk5wMw","ctg":"jerusalem","id":99},{"title":"DIE WÜSTE NEGEV",// "sml_desc": "ein zauberhafter Ort",
"sml_desc":"","desc":"","img":"/PostCarousel/16.jpg","side_img":"/PostCarousel/16.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=16","isVid":true,"forVidPage":true,"vidId":"yXzhH92kREg","ctg":"eilat","id":"Die_Wuste_Negev"},{"title":"ERKUNDEN SIE MASADA",// "sml_desc": "Mythos im Herzen der Judäischen Wüste",
"sml_desc":"","desc":"","img":"/PostCarousel/masada.jpg","side_img":"/PostCarousel/masada.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=Masada","ctg":"eilat-negev","isVid":true,"forVidPage":true,"vidId":"i8IjojQ39u0","id":"Masada"},{"title":"NAZARETH",// "sml_desc": "DIE WIEGE DES CHRISTENTUMS",
"sml_desc":"","desc":"","img":"/PostCarousel/nazareth.jpg","side_img":"/PostCarousel/nazareth.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=Nazareth","ctg":"north","isVid":true,"forVidPage":true,"vidId":"aGMVTrHS8YA","id":"Nazareth"},{"title":"JERUSALEM ENTDECKEN",// "sml_desc": "Entdecken Sie die Geheimnisse des jüdischen Jerusalem in der geschichtsträchtigen Altstadt",
"sml_desc":"","desc":"","img":"PostCarousel/discover-jerusalem.jpg","side_img":"PostCarousel/discover-jerusalem.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=Discover_Jerusalem","ctg":"jerusalem","isVid":true,"forVidPage":true,"vidId":"1byfX1O7u4g","id":"Discover_Jerusalem"},{"title":"WAGEN SIE EINEN SPRUNG",// "sml_desc": "Erleben Sie die Wasserattraktionen in Eilat",
"sml_desc":"","desc":"","img":"PostCarousel/atractions-in-eilat.jpg","side_img":"PostCarousel/atractions-in-eilat.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=Atractions_In_Eilat","ctg":"eilat-negev","isVid":true,"forVidPage":true,"vidId":"wTR-9PxXn-E","id":"Atractions_In_Eilat"},{"title":"DAS DOLPHIN REEF EILAT",// "sml_desc": "Eine unvergessliche Begegnung mit der Tierwelt",
"sml_desc":"","desc":"","img":"PostCarousel/the-dolphin-reef.jpg","side_img":"PostCarousel/the-dolphin-reef.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=The_Dolphin_Reef","ctg":"eilat-negev","isVid":true,"forVidPage":true,"vidId":"HzBX-XW9T0c","id":"The_Dolphin_Reef"},{"title":"HAIFA BERAUSCHENDE SCHÖNHEIT",// "sml_desc": "",
"sml_desc":"","desc":"","img":"/PostCarousel/haifa-intoxicating-beauty.jpg","side_img":"/PostCarousel/haifa-intoxicating-beauty.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=Haifa_Intoxicating_Beauty","ctg":"north","isVid":true,"forVidPage":true,"vidId":"7_156GUZMF4","id":"Haifa_Intoxicating_Beauty"},{"title":"The Hula Valley Natural",// "sml_desc": "",
"sml_desc":"","desc":"","img":"/PostCarousel/the-hula-valley-natural.jpg","side_img":"/PostCarousel/the-hula-valley-natural.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=The_Hula_Valley_Natural","ctg":"north","isVid":true,"forVidPage":true,"vidId":"h5TV5VwQeWY","id":"The_Hula_Valley_Natural"},{"title":"DAS TOTE MEER",// "sml_desc": "Aufschwung für Geist und Seele am tiefst gelegenen Ort der Erde",
"sml_desc":"","desc":"","img":"/PostCarousel/aufschwung-fur-geist.jpg","side_img":"/PostCarousel/aufschwung-fur-geist.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=Aufschwung_Fur_Geist","ctg":"deadsea_2","isVid":true,"forVidPage":true,"vidId":"KijyxSgDpuY","id":"Aufschwung_Fur_Geist"},{"title":"TIMNA PARK",// "sml_desc": "Ein begeisterndes Wüstenabenteuer",
"sml_desc":"","desc":"","img":"/PostCarousel/park-timna.jpg","side_img":"/PostCarousel/park-timna.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=Park_Timna","ctg":"eilat-negev","isVid":true,"forVidPage":true,"vidId":"Id0U0OeDs7Y","id":"Park_Timna"},{"title":"SAFED",// "sml_desc": "wo Mystik und Weltliches aufeinandertreffen",
"sml_desc":"","desc":"","img":"/PostCarousel/mystic-and-worldly-meeting.jpg","side_img":"/PostCarousel/mystic-and-worldly-meeting.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=Mystic_And_Worldly_Meeting","ctg":"north","isVid":true,"forVidPage":true,"vidId":"i3_ihL51bHo","id":"Mystic_And_Worldly_Meeting"},// THESE THREE posts complite the missing posts for carousel THINGS TO DO
{"title":"Absolutes \'Muss\' in Jerusalem",// "sml_desc": "5 Top-Dinge zu tun und zu sehen in der atemberaubenden Stadt",
"sml_desc":"","desc":"","img":"/PostCarousel/18.jpg","side_img":"/PostCarousel/18.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=18","vidId":"k4OwoEk5wMw","isVid":true,"forVidPage":true,"isDouble":true,"ctg":"jerusalem","id":18},{"title":"NAZARETH",// "sml_desc": "DIE WIEGE DES CHRISTENTUMS",
"sml_desc":"","desc":"","img":"/PostCarousel/nazareth.jpg","side_img":"/PostCarousel/nazareth.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=Nazareth","ctg":"north","isVid":true,"forVidPage":true,"isDouble":true,"vidId":"aGMVTrHS8YA","id":"Nazareth"},{"title":"DAS DOLPHIN REEF EILAT",// "sml_desc": "Eine unvergessliche Begegnung mit der Tierwelt",
"sml_desc":"","desc":"","img":"PostCarousel/the-dolphin-reef.jpg","side_img":"PostCarousel/the-dolphin-reef.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=The_Dolphin_Reef","ctg":"eilat-negev","isVid":true,"forVidPage":true,"isDouble":true,"vidId":"HzBX-XW9T0c","id":"The_Dolphin_Reef"}];// start showsArr
// export const showsArr = [
//       {
//         title: "Pride Week 2020",
//         desc: "",
//         date: "12.06.20",
//         img:"Concerts/Pride_Parade_2019.jpg",
//         side_img:"Concerts/Pride_Parade_2019.jpg",
//         link:"/Posts/index.php?postType=concerts&post=Pride_Week_2020",
//         css_class: "unic-singer-Pride_Parade_2020",
//         id: "Pride_Week_2020",
//         book_now : "READ MORE"
//       },
//       {
//         title: "White Night",
//         desc: "",
//         date: "06.2020",
//         img:"Concerts/53.jpg",
//         side_img:"Concerts/53.jpg",
//         link:"/Posts/index.php?postType=concerts&post=White_Night_2020",
//         css_class: "unic-singer-white-night-2020",
//         id: "White_Night_2020",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Nick Cave & Bad Seeds",
//         desc: "",
//         date: "17.06.2020",
//         img: "Concerts/nickcave-badseeds.jpg",
//         side_img: "Concerts/nickcave-badseeds.jpg",
//         link: "",
//         css_class: "unic-singer-nickcave-badseeds",
//         book_now : "Weiterlesen"
//       },
//       {
//         title: "The Pixies",
//         desc: "",
//         date: "09.2020",
//         img: "Concerts/1.jpg",
//         side_img: "Concerts/1.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=The_Pixies_2020",
//         css_class: "unic-singer-pixies-2020",
//         id: "The_Pixies_2020",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Celine Dion",
//         desc: "",
//         date: "04.08.2020",
//         img: "Concerts/Celine_Dion.jpg",
//         side_img: "Concerts/Celine_Dion.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Celine_Dion",
//         css_class: "unic-singer-Celine_Dion",
//         book_now : "Weiterlesen"
//       },
//       {
//         title: "DGTL FESTIVAL",
//         desc: "",
//         date: "08.2020",
//         img: "Concerts/dgtl-festival.jpg",
//         side_img: "Concerts/dgtl-festival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=DGTL_Festival",
//         css_class: "unic-singer-dgtl2020",
//         id: "DGTL_Festival_2020",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Hutzot Hayotzer Jerusalem",
//         desc: "",
//         date: "08.2020",
//         img: "Concerts/international-arts.jpg",
//         side_img: "Concerts/international-arts.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Hutzot_Hayotzer_Jerusalem_2020",
//         css_class: "unic-singer-hutzot_hayotzer",
//         id: "Hutzot_Hayotzer_Jerusalem_2020", 
//         book_now : "READ MORE"
//       },
//       {
//         title: "Jerusalem Beer Festival",
//         desc: "",
//         date: "08.2020",
//         img: "Concerts/jer-beer-ferstival.jpg",
//         side_img: "Concerts/jer-beer-ferstival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Jerusalem_Beer_Festival_2020",
//         css_class: "unic-singer-jbf_2020",
//         id: "Jerusalem_Beer_Festival_2020",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Jerusalem Wine Festival",
//         desc: "",
//         date: "08.2020",
//         img:"Concerts/wineFestive.jpg",
//         side_img:"Concerts/wineFestive.jpg",
//         link: "/Posts/index.php?postType=concerts&post=Jerusalem Wine Festival_2020",
//         css_class: "unic-singer-jwf-2020",
//         id: "Jerusalem_Wine_Festival_2020",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Open Houses Festival",
//         desc: "",
//         date: "09.2020",
//         img: "Concerts/open-houses-festival.jpg",
//         side_img: "Concerts/open-houses-festival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Open_Houses_Festival_2020",
//         css_class: "unic-singer-openhf-2020",
//         id: "Open_Houses_Festival_2020",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Der Jerusalem-Marsch",
//         desc: "",
//         date: "03.09.2020",
//         img: "Concerts/jerusalem-march.jpg",
//         side_img: "Concerts/jerusalem-march.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Open_Houses_Festival_2020",
//         css_class: "unic-singer-jerusalem-march-2020",
//         id: "The_Jerusalem_March_2020",
//         book_now : "READ MORE"
//       },
//       /*----------------OLD SINGERS------------------*/
//       {
//         title: "Natalia Oreiro",
//         desc: "Natalia to Wow Tel Aviv in March",
//         date: "20.03.2018",
//         img: "Concerts/32.jpg",
//         side_img: "Concerts/Sidebar/46.jpg",
//         link:  "/Posts/index.php?postType=concerts&post=44",
//         css_class: "unic-singer-13",
//         id:44,
//         book_now: "Weiterlesen"
//       },
//        {
//         title: "Backstreet Boys",
//         desc: "The Backstreet Boys are Back and Larger Than Life",
//         date: "22.04.2018",
//         img: "Concerts/51.jpg",
//         side_img: "Concerts/Sidebar/53.jpg",
//         link:  "/Posts/index.php?postType=concerts&post=51",
//         css_class: "unic-singer-20",
//         id:51,
//         a_star: true,
//         book_now: "Weiterlesen"
//       },
//       {
//        title: "Led Zeppelin 2",
//        desc : "Don’t Miss the Zeps in Tel Aviv!" ,
//        date : "07-10.01.2018",
//        img  : "Concerts/20.jpg",
//        side_img  : "Concerts/Sidebar/29.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=29" ,
//        css_class: "unic-singer-3",
//        id:29,
//        book_now : "Weiterlesen"
//       },
//       {
//         title: "Chris Rock",
//         desc: "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH",
//         date: "08-09.01.2018",
//         img: "Concerts/6.jpg",
//         side_img: "Concerts/Sidebar/16.jpg",
//         link:  "/Posts/index.php?postType=concerts&post=17",
//         css_class: "unic-singer-4",
//         id:17,
//         book_now: "Weiterlesen"
//       },
//       {
//        title: "Jerry Seinfeld",
//        desc : "Live in Tel Aviv for the first time ever!" ,
//        date : "30.12.2017",
//        img  : "Concerts/jerry.jpg",
//        side_img  : "Concerts/Sidebar/jerry.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=36" ,
//        css_class: "unic-singer-2",
//        id:36,
//        book_now : "Weiterlesen"
//       },
//       {
//        title: "Buena Vista",
//        desc : "Live in Tel Aviv for the first time ever!" ,
//        date : "21-26.12.2017",
//        img  : "Concerts/buena.jpg",
//        side_img  : "Concerts/Sidebar/buena.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=35" ,
//        id:35,
//        book_now : "Weiterlesen"
//       },
//      {
//        title: "Justin Bieber",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "03.05.2017",
//        img  : "Concerts/justin.jpg",
//        side_img  : "Concerts/Sidebar/9.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=9" ,
//        a_star  : true,
//        id:9,
//        book_now : "Weiterlesen"
//       },
//       {
//        title: "AEROSMITH",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "28.06.2017",
//        img  : "Concerts/aerosmith3.jpg",
//        side_img  : "Concerts/Sidebar/10.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=10" ,
//        a_star  : true,
//        id:10,
//        book_now : "Weiterlesen"
//       },
//       {
//        title: "Britney Spears ",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "03.07.2017",
//        img  : "Concerts/britney.jpg",
//        side_img  : "Concerts/Sidebar/2.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=2" ,
//        a_star  : true,
//        id: 2,
//        book_now : "Weiterlesen"
//       },
//       {
//        title: "Guns N' Roses",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "15.07.2017",
//        img  : "Concerts/Guns-N-roses.jpg",
//        side_img  : "Concerts/Sidebar/4.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=4" ,
//        a_star  : true,
//        id:4,
//        book_now : "Weiterlesen"
//       },
//       {
//        title: "Bryan Adams ",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "04-06.12.2017",
//        img  : "Concerts/7.jpg",
//        side_img  : "Concerts/Sidebar/15.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=16" ,
//        a_star  : true,
//        id:16,
//        book_now : "Weiterlesen"
//       },
//       {
//        title: "NICK CAVE ",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "19.11.2017",
//        img  : "Concerts/4.jpg",
//        side_img  : "Concerts/Sidebar/8.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=8" ,
//        id:8,
//        book_now : "Weiterlesen"
//       },
//       {
//         title: "RADIOHEAD ",
//         desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//         date : "19.07.2017",
//         img  : "Concerts/360x539.jpg",
//         side_img  : "Concerts/Sidebar/5.jpg" ,
//         link :  "/Posts/index.php?postType=concerts&post=5" ,
//         a_star  : true,
//         id:5,
//         book_now : "Weiterlesen"
//       },
//       {
//        title: "The Chainsmokers",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "3.08.2017",
//        img  : "Concerts/9.jpg",
//        side_img  : "Concerts/Sidebar/14.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=13" ,
//        id:13,
//        book_now : "Weiterlesen"
//       },
//       {
//        title: "Blue Man Group",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "7-23.08.2017",
//        img  : "Concerts/14.jpg",
//        side_img  : "Concerts/Sidebar/22.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=19" ,
//        id:19,
//        book_now : "Weiterlesen"
//       },
//       {
//        title: "Regina Spektor",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "19.08.2017",
//        img  : "Concerts/2.jpg",
//        side_img  : "Concerts/Sidebar/7.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=7" ,
//        id:7,
//        book_now : "Weiterlesen"
//       },
//       {
//        title: "Sean Paul",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "22.08.2017",
//        img  : "Concerts/13.jpg",
//        side_img  : "Concerts/Sidebar/21.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=20" ,
//       id:20,
//        a_star  : true,
//        book_now : "Weiterlesen"
//       },
//         {
//         title: "Pride Parade 2019",
//         desc: "",
//         date: "14.06.2019",
//         img:"Concerts/Pride_Parade_2019.jpg",
//         side_img:"Concerts/Pride_Parade_2019.jpg",
//         link:"/Posts/index.php?postType=concerts&post=Pride_Parade_2019",
//         css_class: "unic-singer-Pride_Parade_2019",
//         id: "Pride_Parade_2019",
//         book_now : "Weiterlesen"
//       },
//       {
//         title: "Daddy Yankee",
//         desc: "",
//         date: "26.06.2019",
//         img: "Concerts/daddyyanke.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-daddyyanke",
//         book_now : "Weiterlesen"
//       },
//       {
//         title: "Tom Jones",
//         desc: "",
//         date: "03.07.2019",
//         img: "Concerts/tomjones.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-tomjones",
//         book_now : "Weiterlesen"
//       },
//       {
//         title: "Paul Anka",
//         desc: "",
//         date: "11.07.2019",
//         img: "Concerts/paul.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-paul",
//         book_now : "Weiterlesen"
//       },
//       {
//         title: "Sean Paul",
//         desc: "",
//         date: "13.07.2019",
//         img: "Concerts/seanpaul.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-seanpaul",
//         book_now : "Weiterlesen"
//       },
//       {
//         title: "Ozuna",
//         desc: "",
//         date: "24.07.2019",
//         img: "Concerts/ozuna.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-ozuna",
//         book_now : "Weiterlesen"
//       },
//       {
//         title: "J Balvin",
//         desc: "",
//         date: "30.07.2019",
//         img: "Concerts/balvin.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-balvin",
//         book_now : "Weiterlesen"
//       },
//        {
//         title: "Jerusalem Film Festival",
//         desc: "36 Years of Cinema Magic!",
//         date: "04.08.2019",
//         img:"Concerts/filmFestive.jpg",
//         side_img:"Concerts/filmFestive.jpg",
//         link: "/Posts/index.php?postType=concerts&post=68",
//         css_class: "unic-singer-68",
//         id:68,
//         book_now : "Weiterlesen"
//       },
//       {
//         title: "Bon Jovi",
//         desc: "Bon Jovi are Back to take over the hot hot hot Tel Aviv Summer!",
//         date: "25.07.2019",
//         img: "Concerts/bon-j.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-76",
//         id: 76,
//         book_now : "Weiterlesen"
//       },
//       {
//         title: "Jerusalem Wine Festival",
//         desc: "Wine and dine in the holy city!",
//         date: "30.07.2019",
//         img:"Concerts/wineFestive.jpg",
//         side_img:"Concerts/wineFestive.jpg",
//         link: "/Posts/index.php?postType=concerts&post=69",
//         css_class: "unic-singer-69",
//         id:69,
//         book_now : "Weiterlesen"
//       },
//       {
//         title: "J.Lo",
//         desc: "",
//         date: "01.08.2019",
//         img:"Concerts/jlo.jpg",
//         side_img:"Concerts/jlo.jpg",
//         link:"/Posts/index.php?postType=concerts&post=jlo",
//         css_class: "unic-singer-jlo",
//         id: "J_Lo",
//         book_now : "Weiterlesen"
//       },
//       {
//         title: "Lionel Richie",
//         desc: "",
//         date: "12.09.2019",
//         img:"Concerts/lionel-richie.jpg",
//         side_img:"Concerts/lionel-richie.jpg",
//         link:"/Posts/index.php?postType=concerts&post=lionelrichie",
//         css_class: "unic-singer-lionel-richie",
//         book_now : "Weiterlesen"
//       },
//       {
//         title: "Open Restaurants Jerusalem",
//         desc: "",
//         date: "19-23.11.2019",
//         img:"Concerts/Open_Restaurants_Jerusalem.jpg",
//         side_img:"Concerts/Open_Restaurants_Jerusalem.jpg",
//         link:"/Posts/index.php?postType=concerts&post=Open_Restaurants_Jerusalem",
//         css_class: "unic-singer-Open_Restaurants_Jerusalem",
//         id: "Open_Restaurants_Jerusalem",
//         book_now : "Weiterlesen"
//       },
//       {
//         title: "Jim Jeffries",
//         desc: "",
//         date: "21.12.2019",
//         img:"Concerts/jim-jeffries.jpg",
//         side_img:"Concerts/jim-jeffries.jpg",
//         link:"/Posts/index.php?postType=concerts&post=jimjeffries",
//         css_class: "unic-singer-jim-jeffries",
//         book_now : "Weiterlesen"
//       },
//       // {
//       //   title: "Open Restaurants TLV",
//       //   desc: " Feed Your Curiosity!",
//       //   date: "2019",
//       //   img:"Concerts/openRestTlv.jpg",
//       //   side_img:"Concerts/openRestTlv.jpg",
//       //   link: "/Posts/index.php?postType=concerts&post=70",
//       //   css_class: "unic-singer-70",
//       //   id:70,
//       //   book_now : "Weiterlesen"
//       // },
//       {
//         title: "Open Restaurants TLV",
//         desc: " Feed Your Curiosity!",
//         date: "2019",
//         img:"Concerts/openRestTlv.jpg",
//         side_img:"Concerts/openRestTlv.jpg",
//         link: "/Posts/index.php?postType=concerts&post=70",
//         css_class: "unic-singer-70",
//         id:70,
//         book_now : "Weiterlesen"
//       },
//       {
//         title: "Tel Aviv Marathon",
//         desc: "",
//         date: "28.02.2020",
//         img: "Concerts/tlv-marathon.jpg",
//         side_img: "Concerts/tlv-marathon.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=97",
//         css_class: "unic-singer-tlv-marathon2020",
//         id: "TelAviv_Marathon",
//         book_now : "Weiterlesen"
//       },
//       {
//         title: "Purim 2020",
//         desc: "",
//         date: "09-10.03.20",
//         img: "Concerts/purim2019.jpg",
//         side_img: "Concerts/purim2019.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Purim_2020",
//         css_class: "unic-purim2020",
//         id: "Purim_2020",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Tel Aviv Fashion Week",
//         desc: "",
//         date: "03.2020",
//         img: "Concerts/fationWeek.jpg",
//         side_img: "Concerts/fationWeek.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=TelAviv_Fashion_Week_2020",
//         css_class: "unic-fashion-week-2020",
//         id: "TelAviv_Fashion_Week_2020",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Jerusalem Marathon",
//         desc: "",
//         date: "20.03.2020",
//         img: "Concerts/jer-marathon.jpg",
//         side_img: "Concerts/jer-marathon.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=95",
//         css_class: "unic-singer-jer-marathon2019",
//         id: "Jerusalem_Marathon",
//         book_now : "READ MORE"
//       },
// ];
// End showsArr
var showsArr=[];var faqData=[{id:1,q:"Häufig gestellte Fragen (FAQ)",answer:"\n      <ol start=\"1\">\n        <li>\n                <strong>Ich bin als Tourist in Israel und bin besorgt, dass ich COVID-19 haben k\xF6nnte, an wen wende ich mich?</strong><br/>\n                Wenn Sie 38 \xB0C Fieber oder h\xF6her, Husten, Atembeschwerden oder andere Atemwegssymptome haben, m\xFCssen Sie sich sofort in Quarant\xE4ne begeben und die Notfall-Hotline 101 anrufen, um medizinischen Rat zu erhalten.<strong className=\"ac-pink\">Gehen Sie auf keinen Fall in eine HMO-Klinik oder eine Notfallstation.</strong>\n              </li>\n              <li>\n                <strong>Wann wird Israel wieder f\xFCr Besucher von au\xDFerhalb zug\xE4nglich sein?</strong><br/>\n                Zum gegenw\xE4rtigen Zeitpunkt ist kein Datum bekannt, an dem Israel f\xFCr Besucher von au\xDFerhalb zug\xE4nglich sein wird.\n              </li>\n       \n      </ol>\n      ",isOpen:false},{id:2,q:"DAUERT DIE REISE NACH TEL AVIV UND JERUSALEM LANGE?  ",answer:"\n      <p>\n        Im Gegenteil! Es geht schneller als Sie denken: Nach gerade einmal 4-5 Stunden Flugzeit k\xF6nnen Sie die sonnigen Str\xE4nde Tel Avivs und beeindruckenden Sehensw\xFCrdigkeiten Jerusalems genie\xDFen. Und das Beste daran: Tel Aviv und Jerusalem sind nur eine Autostunde voneinander entfernt.\n      </p>\n      ",isOpen:false},{id:3,q:"WIE KOMME ICH IN TEL AVIV UND JERUSALEM VON A NACH B?",answer:"\n      \n      <p>\n       Die bequemsten und beliebtesten Verkehrsmittel sind Busse, Sammeltaxis und die staatliche Bahn. Jerusalem verf\xFCgt dar\xFCber hinaus \xFCber eine komfortable Stadtbahn mit Haltestellen an vielen beliebten Orten der Stadt.\n      </p>\n      <p>\n       Informationen zu Bahnh\xF6fen, Routen und Fahrpl\xE4nen besuchen Sie <a target=\"_blank\" href=\"//www.rail.co.il\">www.rail.co.il</a>\n      </p>\n      <p>\n       Informationen zu Buslinien und Fahrpl\xE4nen finden Sie unter <a target=\"_blank\" href=\"//www.bus.gov.il\">www.bus.gov.il</a>  \n      </p>\n      <p>\n       Hotline f\xFCr \xF6ffentliche Verkehrsmittel <a href=\"tel:*8787\">*8787</a>  \n      </p>\n      <p>\n       App f\xFCr den \xF6ffentlichen Nahverkehr -'Moovit'. \n      </p>\n      <h4>\n      Taxis \n      </h4>\n      <p>\n        Taxis f\xFCr Stadt- und \xDCberlandfahrten k\xF6nnen Sie auf der Stra\xDFe heranwinken oder telefonisch beziehungsweise \xFCber Apps wie Gett (GetTaxi) rufen.\n      </p>\n\n      <h4>\n      Sherut Taxis \n      </h4>\n      <p>\n         \"Sherut\" (Sammel)Taxis sind 10- bis 12-sitzige Kleinbusse, die in der Regel auf den Strecken der wichtigen Buslinien verkehren, innerst\xE4dtisch ebenso wie zwischen Gro\xDFst\xE4dten. Sherut Taxis bieten, \xE4hnlich der \xF6ffentlichen Buslinien einen Festpreis an.\n      </p>\n\n      <h4>\n         Mietwagen \n      </h4>\n      <p>\n        Die meisten Autovermietungen im Stadtgebiet von Tel Aviv finden sich entlang der Hayarkon Street sowie in Strandn\xE4he. In den meisten anderen Gro\xDFst\xE4dte sind sie in der N\xE4he der Hotels zu finden .\n      </p>\n\n      <h4>\n      Tel-O-Fun \n      </h4>\n      <p>\n        Tel-O-Fun ist ein Fahrrad-Sharing-Service der Stadt Tel Aviv, der f\xFCr Einwohner und Besucher der Stadt angeboten wird. Tel-O-Fun verf\xFCgt \xFCber 2.000 Fahrr\xE4der an 200 Stationen an denen Sie ein Rad mieten k\xF6nnen, um die 130 Kilometer ausgewiesener Radwege zu erkunden. Mit Ihrer Kreditkarte k\xF6nnen Sie eine Tages- oder Wochenkarte an den Terminals der Vermietstationen erwerben.\n      </p>\n      .\n      ",isOpen:false},{id:4,q:"WIE BEZAHLE ICH IN ISRAEL? ",answer:"\n      <p>\n        Die israelische W\xE4hrung ist der Schekel. Bargeld k\xF6nnen Sie an Geldautomaten bei Banken in der ganzen Stadt abheben. An Kiosken gibt es dar\xFCber hinaus private Geldautomaten, die eine Provision von 5,90-7,90 NIS pro Auszahlung berechnen. M\xF6glichkeiten Geld zu wechseln finden Sie in privaten, provisionsfreien Wechselstuben in touristischen Gebieten, die in der Regel bis sp\xE4t abends ge\xF6ffnet haben. Nat\xFCrlich werden allerorten auch Kreditkarten akzeptiert. Und f\xFCr Geldtransfers bietet in den meisten Post\xE4mtern Western Union seine Dienste an. \n      </p>\n      ",isOpen:false},{id:5,q:"IN VERBINDUNG BLEIBEN",answer:"\n\n        <h4>\n          Mobiltelefone nutzen\n        </h4>\n        <p>\n          Falls gew\xFCnscht, k\xF6nnen Sie in Telefonl\xE4den oder bei den Informationszentren der Stadt eine lokale SIM-Karte erwerben. Viele kleine Gesch\xE4fte und Wechselstuben bieten auch Prepaid-Karten zum Verkauf an.\n        </p>\n\n        <h4>\n          Hotspots \u2013 Kostenloses W-LAN\n        </h4>\n        <p>\n         Tel Aviv ist eine zukunftsweisende, smarte Stadt \u2013 und sehr stolz darauf. Kostenloses W-LAN steht Ihnen an 80 verschiedenen Orten im Stadtgebiet zur Verf\xFCgung (einschlie\xDFlich dem Strand, den Ausgehvierteln und den meisten touristischen Stadtbereichen).\n        </p>\n        <p>\n          Jerusalem bietet kostenloses Wi-Fi an Bahnh\xF6fen, in Universit\xE4ten, Museen, Besucherzentren, Kongresshallen, Tourismus- und Einkaufszentren sowie im lokalen Besucherinformationszentrum.\n        </p>\n\n      ",isOpen:false},{id:6,q:"WIE IST DAS WETTER?",answer:"\n        <p>\n        Das Wetter in Tel Aviv ist das ganze Jahr \xFCber sch\xF6n und angenehm. Der Sommer ist lang und bietet sich f\xFCr Tage am Strand und Erkundungstouren an, der Winter ist freundlich und ohne nennenswerte Niederschl\xE4ge. Durchschnittstemperaturen im Winter 9-17 \xB0C, im Sommer 24-30 \xB0C.\n        </p>\n        <p>\n          In Jerusalem erfreut man sich langer sonniger Sommer (Mai-September), hat aber auch teils kalte und regnerische Winter (November-M\xE4rz) mit gelegentlichen Schneest\xFCrmen und Temperaturen um den Gefrierpunkt. Aktuelle Wetterinformationen finden Sie auf der Website des Israelischen Meteorologischen Dienstes unter <a target=\"_blank\" href=\"//www.ims.gov.il\">www.ims.gov.il</a>\n\n        </p>\n      ",isOpen:false},{id:7,q:"SIND DIE ARBEITSZEITEN ANDERS? ",answer:"\n        \n        <p>\n           Ja, die Werktage sind Sonntag bis Donnerstag, w\xE4hrend an Freitagen und Samstagen Wochenende ist. Die meisten Gesch\xE4fte haben freitags bis zum fr\xFChen Nachmittag ge\xF6ffnet \u2013 im Einklang mit dem j\xFCdischen Sabbat, der von Freitag bei Sonnenuntergang bis Samstag kurz nach Sonnenuntergang dauert. Weitere Informationen finden Sie unter <a target=\"_blank\" href=\"//www.timeanddate.com/worldclock/Israel\">www.timeanddate.com/worldclock/Israel</a>\n        </p>\n      ",isOpen:false}];var newPosts=[// videos
{"title":"Abenteuer im Freien",// "sml_desc": "Tel Aviv im Sattel",
"sml_desc":"",// "desc": "Eine actionreiche Stadt, die\n perfekt für aktive Menschen ist",
"desc":"","img":"Videos/12.jpg","img_mob":"/Videos/video_mob/12.jpg","side_img":"Videos/sidebar/12.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=20","vidId":"88OV6xU0vPI","ctg":"telaviv","forVidPage":true,"isVid":true,"id":20},{"title":"Auf der Suche nach dem ultimativen Nachtleben?",// "sml_desc": " Book your trip to Tel Aviv!",
"sml_desc":"",// "desc": "",
"desc":"","img":"Videos/crazy-night.jpg","img_mob":"/Videos/video_mob/crazy-night.jpg","side_img":"Videos/sidebar/crazy-night.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Crazy_Night","vidId":"ogEN7aRT0SM","ctg":"telaviv","forVidPage":true,"isVid":true,"id":9},{"title":"JERUSALEM",// "sml_desc": "THE HEART OF THE WORLD",
"sml_desc":"",// "desc": "",
"desc":"","img":"Videos/heart-of-the-world.jpg","img_mob":"/Videos/video_mob/heart-of-the-world.jpg","side_img":"Videos/sidebar/heart-of-the-world.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Heart_Of_The_World","vidId":"nLKWDp5uA-U","ctg":"jerusalem","isVid":true,"forVidPage":true,"id":10},{"title":"Modern und lebendig",// "sml_desc": "Es gibt so viel zu sehen in Jerusalems pulsierendem Stadtzentrum",
"desc":"","sml_desc":"","img":"Videos/c.jpg","img_mob":"/Videos/video_mob/c.jpg","side_img":"Videos/sidebar/c.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=19","vidId":"TeLJmRatQeM","ctg":"jerusalem","isVid":true,"forVidPage":true,"id":9},{"title":"DAS TOTE MEER",// "sml_desc": "Zeit für eine Auszeit in \n der glorreichen Natur",
// "desc": "Höchster Genuss am \n tiefstgelegenen Ort der Erde",
"sml_desc":"","desc":"","img":"Videos/f.jpg","img_mob":"/Videos/video_mob/f.jpg","side_img":"Videos/sidebar/f.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?postType=video&post=2","vidId":"ixFocykfYHo","ctg":"deadsea","forVidPage":true,"isVid":true,"id":14},{"title":"Hafenfreuden",// "sml_desc": "Die häfen von Tel Aviv",
// "desc": "Die verschiedenen Reize von \nTel Aviv und Jaffa Häfen",
"sml_desc":"","desc":"","img":"/PostCarousel/3.jpg","img_mob":"/PostCarousel/video_mob/3.jpg","side_img":"/PostCarousel/3.jpg","read_more":"Weiterlesen","vidId":"iHqD5eHDZm8","link":"/Posts/index.php?post=3","ctg":"telaviv","isVid":true,"forVidPage":true,"id":3},{"title":"Machne Yehuda-Markt",// "sml_desc": "Ein Fest für alle Sinne",
// "desc": "Lassen Sie sich die erstaunlichen visuellen \nEindrücke und die Geräuschkulisse des Marktes",
"sml_desc":"","desc":"","img":"Videos/b.jpg","img_mob":"/Videos/video_mob/b.jpg","side_img":"Videos/sidebar/b.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=7","vidId":"2CSCe2WC7Ns","ctg":"culinary","isVid":true,"forVidPage":true,"id":12},{"title":"DAS TOTE MEER",// "sml_desc": "Zeit für eine Auszeit in\nder glorreichen Natur",
// "desc": "Höchster Genuss am \ntiefstgelegenen Ort der Erde",
"sml_desc":"","desc":"","img":"/PostCarousel/100.jpg","img_mob":"/PostCarousel/video_mob/100.jpg","side_img":"/PostCarousel/100.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?postType=video&post=2","vidId":"ixFocykfYHo","css_class":"unic_video-post-3","isVid":true,"forVidPage":true,id:3,ctg:"deadsea"},{"title":"EIN KULINARISCHER URLAUB IN GALILÄA",// "sml_desc": "Ein Paradies für Foodies",
"sml_desc":"","desc":"","img":"PostCarousel/culinary-in-galilee.jpg","side_img":"PostCarousel/culinary-in-galilee.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=Culinary_In_Galilee","ctg":"culinarynorth","isVid":false,"id":"Culinary_In_Galilee"},{"title":"Sarona Tel Aviv",// "desc": "Eine riesige Auswahl von Attraktionen in \n der überwältigenden sanierten Templerkolonie",
// "sml_desc": "Eine atemberaubende urbane Oase",
"sml_desc":"","desc":"","img":"Videos/d.jpg","img_mob":"/Videos/video_mob/d.jpg","side_img":"Videos/sidebar/d.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?postType=video&post=1","vidId":"7JF0z2XPpz0","ctg":"telaviv","isVid":true,"forVidPage":true,"id":7},{"title":"Die Altstadt",// "sml_desc": "Spüre, wie die Geschichte \n zum Leben erwacht",
// "desc": "Lassen Sie sich von den weltberühmten Schätzen \n des historischen Jerusalem inspirieren",
"sml_desc":"","desc":"","img":"Videos/m.jpg","img_mob":"/Videos/video_mob/m.jpg","side_img":"Videos/sidebar/m.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=4","vidId":"1byfX1O7u4g","ctg":"jerusalem","isVid":true,"forVidPage":true,"id":13},{"title":"Neve Tzedek",// "sml_desc": "Schick und einzigartig",
// "desc": "Liebenswerte Cafés, Boutiquen, Kunstgalerien, \n Eleganz und coole Vibes",
"sml_desc":"","desc":"","img":"Videos/j.jpg","img_mob":"/Videos/video_mob/j.jpg","side_img":"Videos/sidebar/j.jpg","read_more":"Weiterlesen","vidId":"-ESCEVfOreY","link":"/Posts/index.php?postType=video&post=7","css_class":"unic_video-post-13","ctg":"telaviv","isVid":true,"forVidPage":true,"id":8},{"title":"Tel Aviv Am Srand",// "sml_desc": "Weil sich das Leben in Tel Aviv \n von der Sonnenseite zeigt",
// "desc": "Bereit für eine volle \nLadung Spaß in der Sonne?",
"sml_desc":"","desc":"","img":"Videos/a.jpg","img_mob":"Videos/video_mob/a.jpg","side_img":"Videos/sidebar/a.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?postType=video&post=3","css_class":"unic_video-post-4","vidId":"ExuWHatIrKE","ctg":"telaviv","isVid":true,"forVidPage":true,"id":4},//No translation 
// {
//     "title": "ULTIMATE BEACH FUN",
//     "sml_desc": "",
//     "desc": "Join the ride in the city that doesn't stop \n Get your wheels on and go anywhere they take you in this fabulous city",
//     "img": "/PostCarousel/101.jpg",
//     "side_img": "/PostCarousel/101.jpg",
//     "read_more": "Weiterlesen",
//     "link": "/Posts/index.php?post=24",
//     "css_class": "unic_video-post-1",
//     "vidId": "88OV6xU0vPI",
//     "isVid": true,
//     id: 24,
//     "ctg": "telaviv",
//     "showOnHome": false,
// },
// culinary 
{"title":"FEINSCHMECKERSZENE TEL AVIV","sml_desc":"",// "sml_desc": "Dem köstlichen Frühstück in Tel Aviv kann auch Jamie Oliver nicht widerstehen.",
"desc":"","img":"Videos/JamieOliver.jpg","img_mob":"/Videos/video_mob/JamieOliver.jpg","side_img":"Videos/sidebar/JamieOliver.jpg","vidId":"gGe4W8WaIiQ","read_more":"Weiterlesen","link":"/Posts/index.php?post=86","ctg":"culinary","isVid":true,"forVidPage":true,"id":86},{"title":"Die Vegane Szene In Tel Aviv",// "sml_desc": " Genieße die riesige Auswahl veganer Köstlichkeiten - \n vegane Eiscreme inklusive!",
"sml_desc":" ",// "desc": "Gewählt als bestes Reiseziel \n  für Veganer weltweit",
"desc":"","img":"Videos/h.jpg","img_mob":"/Videos/video_mob/h.jpg","side_img":"Videos/sidebar/h.jpg","vidId":"tNl2QXNOHMk","read_more":"Weiterlesen","link":"/Posts/index.php?post=6","ctg":"culinary","isVid":true,"forVidPage":true,"id":5},{"title":"Jerusalem",// "sml_desc": "Kulinarische Highlights in Jerusalem",
"sml_desc":"","desc":"","img":"/PostCarousel/37.jpg","img_mob":"/PostCarousel/video_mob/37.jpg","side_img":"/PostCarousel/37.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=38","ctg":"culinary","vidId":"2CSCe2WC7Ns","isVid":true,"forVidPage":true,"id":15},{"title":"Ein Feinschmeckerparadies",// "sml_desc": " Komm heraus in Tel Avivs \n genialer kulinarischer Szene",
"sml_desc":"","desc":"","img":"/PostCarousel/99.jpg","img_mob":"/PostCarousel/video_mob/99.jpg","side_img":"/PostCarousel/99.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=21","ctg":"culinary","vidId":"n4kCnPXEX7g","isVid":true,"forVidPage":true,"id":21},{"title":"Küche in Jerusalem",// "sml_desc": "Küche in Jerusalem",
// "desc": "Aufregend, vielfältig und \nach so lecker",
"sml_desc":"","desc":"","img":"/PostCarousel/13.jpg","img_mob":"/PostCarousel/video_mob/13.jpg","side_img":"/PostCarousel/13.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=13","ctg":"culinary","vidId":"2CSCe2WC7Ns","isVid":true,"forVidPage":true,"id":13},// NO TRANSLATION
// {
//     "title": "Kaffee in Tel Aviv",
//     "sml_desc": "Tel Aviv over a fresh coffee",
//     "desc": "Coffee shop culture is fundamental",
//     "img": "Videos/coffee.jpg",
//     "side_img": "Videos/sidebar/coffee.jpg",
//     "read_more": "Weiterlesen",
//     "link": "/Posts/index.php?postType=video&post=16",
//     "vidId": "rVr0gqFC364",
//     "ctg": "culinary",
//     "isVid": true,
//     "id": 10
// },
{"title":"Feinschmeckerszene Tel Aviv",// "sml_desc": "Der perfekte Ort, an dem Sie die bunte Vielfalt der hochkarätigen Restaurants von Tel Aviv genießen können",
"sml_desc":"",// "desc": "Verwöhnen Sie Ihren Gaumen in Tel Aviv",
"desc":"","img":"Videos/e.jpg","img_mob":"/Videos/video_mob/e.jpg","side_img":"Videos/sidebar/e.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?postType=video&post=33","vidId":"jfyHxk8ZRrI","ctg":"culinary","isVid":true,"forVidPage":true,"id":11},{"title":"Susshuka Zeit",// "sml_desc": "Susshuka Zeit",
"sml_desc":"",// "desc": "Lerne Sie, wie man das weltberühmte\n Shakshuka-Gericht zubereitet!",
"desc":"","img":"/PostCarousel/22.jpg","img_mob":"/PostCarousel/video_mob/22.jpg","side_img":"/PostCarousel/22.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=22","ctg":"culinary","vidId":'n4kCnPXEX7g',"isVid":true,"forVidPage":true,"id":22},//  non videos
{"title":"Die Stra Die Strande Von Tel Aviv",// "sml_desc": "Entspannen Sie Sich An Den\n Sonnigen Stranden Von Tel Aviv",
"sml_desc":"","desc":"","img":"/PostCarousel/14.jpg","side_img":"/PostCarousel/14.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=14","isVid":false,"forVidPage":true,"ctg":"telaviv","id":14},{"title":"Jerusalem- Stadt der Überraschungen",// "sml_desc": "Eine Stadt, die alle Erwartungen übertrifft",
"sml_desc":"","desc":"","img":"/PostCarousel/38.jpg","side_img":"/PostCarousel/38.jpg","read_more":"Weiterlesen","link":this.url+"/Posts/index.php?post=30","ctg":"jerusalem","isVid":false,"id":38},{"title":"DAS TOTE MEER",// "sml_desc": "Zeit für eine Auszeit in \n der glorreichen Natur",
// "desc": "Höchster Genuss am tiefstgelegenen Ort der Erde",
"sml_desc":"","desc":"","img":"Videos/34.jpg","side_img":"Videos/sidebar/34.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?postType=video&post=15","vidId":"ixFocykfYHo","css_class":"unic_video-post-10","isVid":false,id:34,ctg:"deadsea"},{"title":"Ein Tag in Tel Aviv",// "sml_desc": "Vom Hafen zum Hafen",
"sml_desc":"","desc":"","img":"/PostCarousel/35.jpg","side_img":"/PostCarousel/35.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=36","ctg":"telaviv","isVid":false,"id":36},//No translation
// {
//     "title": "First Time in Jerusalem",
//     "sml_desc": "The must list for the first time visitor",
//     "desc": "",
//     "img": "/PostCarousel/43.jpg",
//     "side_img": "/PostCarousel/43.jpg",
//     "read_more": "Weiterlesen",
//     "link": "/Posts/index.php?post=43",
//     "isVid": false,
//     "ctg": "jerusalem",
//     "id": 43
// },
{"title":"Tel Aviv",// "sml_desc": "Die ultimative Luxus-Destination",
"sml_desc":"","desc":"","img":"/PostCarousel/36.jpg","side_img":"/PostCarousel/36.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=37","ctg":"telaviv","isVid":false,"id":37},// No translation
// {
//     "title": "UNFORGETTABLE YAD VASHEM",
//     "sml_desc": "",
//     "img": "thingsToDo/10.jpg",
//     "side_img": "thingsToDo/sidebar/10.jpg",
//     "read_more": "Weiterlesen",
//     "link": "/Posts/index.php?post=20",
//     "css_class": "unic_video-post-1",
//     "vidId": "88OV6xU0vPI",
//     "isVid": false,
//     id: 31,
//     "showOnHome": false,
//     "ctg": "jerusalem"
// },
{"title":"Tourist info",// "sml_desc": "Alles was Sie wissen sollten",
"sml_desc":"","desc":"","img":"/PostCarousel/touristinfo.jpg","side_img":"/PostCarousel/touristinfo.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=Tourist_info","isVid":false,"ctg":"telaviv","id":"Tourist_info"},{"title":"Tel Aviv",// "sml_desc": "Mit dem Fahrrad in Tel Aviv",
"sml_desc":"","desc":"","img":"PostCarousel/39.jpg","side_img":"PostCarousel/39.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=38","ctg":"telaviv","forVidPage":true,"isVid":false,"id":39},//No translation
// {
//     "title": "TOWER OF DAVID MUSEUM",
//     "sml_desc": "",
//     "img": "thingsToDo/7.jpg",
//     "side_img": "thingsToDo/sidebar/7.jpg",
//     "read_more": "Weiterlesen",
//     "link": "/Posts/index.php?post=20",
//     "css_class": "unic_video-post-1",
//     "vidId": "88OV6xU0vPI",
//     "isVid": false,
//     id: 29,
//     "showOnHome": false,
//     "ctg": "jerusalem"
// },
// No translation
// {
//     "title": "Upscale Jerusalem",
//     "sml_desc": "Modern luxuries for the pampered traveler",
//     "desc": "",
//     "img": "/PostCarousel/45.jpg",
//     "side_img": "/PostCarousel/45.jpg",
//     "read_more": "Weiterlesen",
//     "link": "/Posts/index.php?post=45",
//     "isVid": false,
//     "ctg": "jerusalem",
//     "id": 45
// },
{"title":"Tel Aviv Adventures",// "sml_desc": "Tel Aviv ist cool, Tel Aviv ist anders",
"sml_desc":"","desc":"","img":"/PostCarousel/40.jpg","side_img":"/PostCarousel/40.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=40","ctg":"telaviv","isVid":false,"id":40},{"title":"Die Museen Von Yel Aviv",// "sml_desc": "Zeit Fur Kultur",
"sml_desc":"","desc":"","img":"/PostCarousel/10.jpg","side_img":"/PostCarousel/10.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=10","isVid":false,"ctg":"telaviv","id":10},{"title":"Absolutes Muss in Tel Aviv",// "sml_desc": "Top 5 Stätten, die Sie in der Nonstop-Stadt nicht verpassen wollen",
"sml_desc":"","desc":"","img":"/PostCarousel/17.jpg","side_img":"/PostCarousel/17.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=17","ctg":"telaviv","isVid":false,"forVidPage":true,"id":17},{"title":"Absolutes \'Muss\' in Jerusalem",// "sml_desc": "5 Top-Dinge zu tun und zu sehen in der atemberaubenden Stadt",
"sml_desc":"","desc":"","img":"/PostCarousel/18.jpg","side_img":"/PostCarousel/18.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=18","isVid":false,"forVidPage":true,"ctg":"jerusalem","id":18},//   No Translation
// {
//     "title": "Nonstop-Aufregung",
//     "sml_desc": "Schönes, buntes und \n unvergessliches Tel Aviv",
//     "desc": "",
//     "img": "/PostCarousel/2.jpg",
//     "side_img": "/PostCarousel/2.jpg",
//     "read_more": "Weiterlesen",
//     "link": "/Posts/index.php?post=2",
//     "ctg": "telaviv",
//     "isVid": false,
//     "id": 2
// },
{"title":"Modern und lebendig",// "sml_desc": "Es gibt so viel zu sehen in Jerusalems pulsierendem Stadtzentrum",
"sml_desc":"","desc":"","img":"/PostCarousel/19.jpg","side_img":"/PostCarousel/19.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=19","isVid":false,"forVidPage":true,"ctg":"jerusalem","id":19},{"title":"Einkaufsfreuden",// "sml_desc": "Von Couture bis zu Souvenirs, Jerusalem hat alles",
"sml_desc":"","desc":"","img":"/PostCarousel/5.jpg","side_img":"/PostCarousel/5.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=5","ctg":"jerusalem","isVid":false,"forVidPage":true,"id":5},// No TRanslation
//  {
//     "title": "Jerusalem’s Calling",
//     "sml_desc": "The most radiant city on Earth",
//     "desc": "",
//     "img": "/PostCarousel/4.jpg",
//     "side_img": "/PostCarousel/4.jpg",
//     "read_more": "Weiterlesen",
//     "link": "/Posts/index.php?post=4",
//     "ctg": "jerusalem",
//     "isVid": false,
//     "id": 13
// },
{"title":"Das Spirituelle Jerusalem",// "sml_desc": "Die Wichtigsten Sehenswurdigkeiten In Jerusalem",
"sml_desc":"","desc":"","img":"/PostCarousel/9.jpg","side_img":"/PostCarousel/9.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=9","isVid":false,"forVidPage":true,"ctg":"jerusalem","id":99},{"title":"Mit Kindern reisen",// "sml_desc": "Ununterbrochene Spannung\n für die ganze Familie",
"sml_desc":"","desc":"","img":"/PostCarousel/33.jpg","side_img":"/PostCarousel/33.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=25","isVid":false,"ctg":"telavivAndJerusalem","id":41},//No translation
// {
//     "title": "WESTERN WALL WONDERS",
//     "sml_desc": "",
//     "img": "thingsToDo/4.jpg",
//     "side_img": "thingsToDo/sidebar/4.jpg",
//     "read_more": "Weiterlesen",
//     "link": "/Posts/index.php?post=20",
//     "css_class": "unic_video-post-1",
//     "vidId": "88OV6xU0vPI",
//     "isVid": false,
//     id: 27,
//     "ctg": "jerusalem",
//     "showOnHome": false,
// },
//No translation
// {
//     "title": "WHITE CITY SPLENDOR",
//     "sml_desc": "",
//     "img": "thingsToDo/6.jpg",
//     "side_img": "thingsToDo/sidebar/6.jpg",
//     "read_more": "Weiterlesen",
//     "link": "/Posts/index.php?post=20",
//     "css_class": "unic_video-post-1",
//     "vidId": "88OV6xU0vPI",
//     "isVid": false,
//     id: 28,
//     "showOnHome": false,
//     "ctg": "telaviv"
// },
//No translation
// {
//     "title": "ALL SENSORY MARKETS",
//     "sml_desc": "",
//     "img": "thingsToDo/8.jpg",
//     "side_img": "thingsToDo/sidebar/8.jpg",
//     "read_more": "Weiterlesen",
//     "link": "/Posts/index.php?post=20",
//     "css_class": "unic_video-post-1",
//     "vidId": "88OV6xU0vPI",
//     "isVid": false,
//     id: 30,
//     "showOnHome": false,
//     "ctg": "telavivAndJerusalem"
// },
//No translation
//  {
//     "title": "Go To Guide",
//     "sml_desc": "Travel from Tel Aviv and Jerusalem",
//     "desc": "",
//     "img": "/PostCarousel/34.jpg",
//     "side_img": "/PostCarousel/34.jpg",
//     "read_more": "Weiterlesen",
//     "link": "/Posts/index.php?post=35",
//     "ctg": "telavivAndJerusalem",
//     "isVid": false,
//     "id": 35
// },
{"title":"DIE WÜSTE NEGEV",// "sml_desc": "ein zauberhafter Ort",
"sml_desc":"","desc":"","img":"/PostCarousel/16.jpg","side_img":"/PostCarousel/16.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=16","isVid":false,"forVidPage":true,"ctg":"eilat","id":"Die_Wuste_Negev"},// No translate
// {
//     "title": "TRAVELLING ON A BUDGET",
//     "sml_desc": "Making it count in Tel Aviv and Jerusalem!",
//     "desc": "",
//     "img": "/PostCarousel/44.jpg",
//     "side_img": "/PostCarousel/44.jpg",
//     "read_more": "Weiterlesen",
//     "link": "/Posts/index.php?post=44",
//     "isVid": false,
//     "ctg": "telavivAndJerusalem",
//     "id": 44
// },
// {
//     "title": "Die HÄFEN von Tel Aviv",
//     // "sml_desc": "Der Hafen Von Tel Aviv \n And Der Haven Von Jaffa",
//     "sml_desc": "",
//     "desc": "",
//     "img": "/PostCarousel/1.jpg",
//     "side_img": "/PostCarousel/1.jpg",
//     "read_more": "Weiterlesen",
//     "link": "/Posts/index.php?post=1",
//     "ctg": "telavivAndJerusalem",
//     "isVid": false,
//     "id": 1
// },
// No translate
// {
//     "title": "Party Capital",
//     "sml_desc": "Epic Nights in the non stop city",
//     "desc": "",
//     "img": "/PostCarousel/42.jpg",
//     "side_img": "/PostCarousel/42.jpg",
//     "read_more": "Weiterlesen",
//     "link": "/Posts/index.php?post=42",
//     "isVid": false,
//     "ctg": "telaviv",
//     "id": 42
// },
// No needed
// {
//     "title": "Eurovision",
//     "sml_desc": "The opportunity to visit Tel Aviv ",
//     "desc": "As it hosts the Eurovision song contest",
//     "img": "/PostCarousel/eurovision.jpg",
//     "side_img": "/PostCarousel/eurovision.jpg",
//     "read_more": "Weiterlesen",
//     "link": "/Posts/index.php?post=eurovision",
//     "isVid": false,
//     "ctg": "eurovision",
//     "id": "eurovision"
// },
// No needed
// {
//     "title": "Get ready to party",
//     "sml_desc": "The best Eurovision parties to be at",
//     "desc": "",
//     "img": "/PostCarousel/getreadytoparty.jpg",
//     "side_img": "/PostCarousel/getreadytoparty.jpg",
//     "read_more": "Weiterlesen",
//     "link": "/Posts/index.php?post=Get_ready_to_party",
//     "isVid": false,
//     "ctg": "eurovision",
//     "id": "Get_ready_to_party"
// },
// No needed
// {
//     "title": "White night",
//     "sml_desc": "White Night Lights Up",
//     "desc": "Tel Aviv on 16th May",
//     "img": "/PostCarousel/whitenight.jpg",
//     "side_img": "/PostCarousel/whitenight.jpg",
//     "read_more": "Weiterlesen",
//     "link": "/Posts/index.php?post=White_night",
//     "isVid": false,
//     "ctg": "eurovision",
//     "id": "White_night"
// },
//GO POSTS
{"title":"DIE WEIHRAUCHSTRAßE",// "sml_desc": "Eine 2.000 Jahre alte Geschichte des Erfolgs",
"sml_desc":"","desc":"","img":"/PostCarousel/the-incense-road.jpg","side_img":"/PostCarousel/the-incense-road.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=The_Incense_Road","ctg":"eilat-negev","isVid":false,"id":"The_Incense_Road"},{"title":"DIE NEGEV WÜSTE",// "sml_desc": "DIE NEGEV WÜSTE – NICHT VERPASSEN",
"sml_desc":"","desc":"","img":"/PostCarousel/the-negev-desert.jpg","side_img":"/PostCarousel/the-negev-desert.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=The_Negev_Desert","ctg":"eilat-negev","isVid":false,"id":"The_Negev_Desert"},{"title":"ERKUNDEN SIE MASADA",// "sml_desc": "Mythos im Herzen der Judäischen Wüste",
"sml_desc":"","desc":"","img":"/PostCarousel/masada.jpg","side_img":"/PostCarousel/masada.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=Masada","ctg":"eilat-negev","isVid":false,"forVidPage":true,"id":"Masada"},{"title":"ENTDECKEN SIE DIE VERBORGENEN JUWELEN VON GALILÄA",// "sml_desc": "Ihr Traumurlaub in Israel voller Überraschungen",
"sml_desc":"","desc":"","img":"/PostCarousel/hidden-galilee.jpg","side_img":"/PostCarousel/hidden-galilee.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=Hidden_Galilee","ctg":"north","isVid":false,"id":"Hidden_Galilee"},{"title":"NAZARETH",// "sml_desc": "DIE WIEGE DES CHRISTENTUMS",
"sml_desc":"","desc":"","img":"/PostCarousel/nazareth.jpg","side_img":"/PostCarousel/nazareth.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=Nazareth","ctg":"north","isVid":false,"forVidPage":true,"id":"Nazareth"},{"title":"ROSH PINA",// "sml_desc": "Pastoraler Geheimtipp für Touristen in Galiläa",
"sml_desc":"","desc":"","img":"PostCarousel/rosh-pina.jpg","side_img":"PostCarousel/rosh-pina.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=Rosh_Pina","ctg":"north","isVid":false,"id":"Rosh_Pina"},{"title":"EIN MAGISCHER ORT",// "sml_desc": "DIE NEGEV-WÜSTE ",
"sml_desc":"","desc":"","img":"PostCarousel/a-magic-place.jpg","side_img":"PostCarousel/a-magic-place.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=A_Magic_Place","ctg":"eilat-negev","isVid":false,"id":"A_Magic_Place"},{"title":"DIE ARAVA: ÜBERRASCHE DICH SELBST!",// "sml_desc": "",
"sml_desc":"","desc":"","img":"PostCarousel/the-arava.jpg","side_img":"PostCarousel/the-arava.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=The_Arava","ctg":"eilat-negev","isVid":false,"id":"The_Arava"},{"title":"ACTION-SPAß IN DER WÜSTE ISRAELS",// "sml_desc": "",
"sml_desc":"","desc":"","img":"PostCarousel/action-fun.jpg","side_img":"PostCarousel/action-fun.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=Action_Fun_In_Desert","ctg":"eilat-negev","isVid":false,"id":"Action_Fun_In_Desert"},{"title":"SENSATIONELL - EIN ENDLOS LANGER SOMMER",// "sml_desc": "Eilat",
"sml_desc":"","desc":"","img":"PostCarousel/sensational.jpg","side_img":"PostCarousel/sensational.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=Eilat_Sensational","ctg":"eilat-negev","isVid":false,"id":"Eilat_Sensational"},{"title":"JERUSALEM ENTDECKEN",// "sml_desc": "Entdecken Sie die Geheimnisse des jüdischen Jerusalem in der geschichtsträchtigen Altstadt",
"sml_desc":"","desc":"","img":"PostCarousel/discover-jerusalem.jpg","side_img":"PostCarousel/discover-jerusalem.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=Discover_Jerusalem","ctg":"jerusalem","isVid":false,"forVidPage":true,"id":"Discover_Jerusalem"},{"title":"WAGEN SIE EINEN SPRUNG",// "sml_desc": "Erleben Sie die Wasserattraktionen in Eilat",
"sml_desc":"","desc":"","img":"PostCarousel/atractions-in-eilat.jpg","side_img":"PostCarousel/atractions-in-eilat.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=Atractions_In_Eilat","ctg":"eilat-negev","isVid":false,"forVidPage":true,"id":"Atractions_In_Eilat"},{"title":"DAS DOLPHIN REEF EILAT",// "sml_desc": "Eine unvergessliche Begegnung mit der Tierwelt",
"sml_desc":"","desc":"","img":"PostCarousel/the-dolphin-reef.jpg","side_img":"PostCarousel/the-dolphin-reef.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=The_Dolphin_Reef","ctg":"eilat-negev","isVid":false,"forVidPage":true,"id":"The_Dolphin_Reef"},{"title":"ABENTEUER DURCH DIE ZEIT",// "sml_desc": "",
"sml_desc":"","desc":"","img":"PostCarousel/jeru-salem.jpg","side_img":"PostCarousel/jeru-salem.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=Jerusalem_","ctg":"jerusalem","isVid":false,"id":"Jerusalem_"},{"title":"HAIFA BERAUSCHENDE SCHÖNHEIT",// "sml_desc": "",
"sml_desc":"","desc":"","img":"/PostCarousel/haifa-intoxicating-beauty.jpg","side_img":"/PostCarousel/haifa-intoxicating-beauty.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=Haifa_Intoxicating_Beauty","ctg":"north","isVid":false,"forVidPage":true,"id":"Haifa_Intoxicating_Beauty"},{"title":"The Hula Valley Natural",// "sml_desc": "",
"sml_desc":"","desc":"","img":"/PostCarousel/the-hula-valley-natural.jpg","side_img":"/PostCarousel/the-hula-valley-natural.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=The_Hula_Valley_Natural","ctg":"north","isVid":false,"forVidPage":true,"id":"The_Hula_Valley_Natural"},{"title":"Fühlen Sie sich pudelwohl",// "sml_desc": "am tiefstgelegenen Ort der Erde",
"sml_desc":"","desc":"","img":"/PostCarousel/feel-pudelwohl.jpg","side_img":"/PostCarousel/feel-pudelwohl.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=Feel_Pudelwohl","ctg":"deadsea","isVid":false,"id":"Feel_Pudelwohl"},{"title":"DAS TOTE MEER",// "sml_desc": "Aufschwung für Geist und Seele am tiefst gelegenen Ort der Erde",
"sml_desc":"","desc":"","img":"/PostCarousel/aufschwung-fur-geist.jpg","side_img":"/PostCarousel/aufschwung-fur-geist.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=Aufschwung_Fur_Geist","ctg":"deadsea_2","isVid":false,"forVidPage":true,"id":"Aufschwung_Fur_Geist"},{"title":"TEL AVIV & JERUSALEM",// "sml_desc": "Impuls und Inspiration ergänzen sich zu DEM perfekten Reisepaket",
"sml_desc":"","desc":"","img":"/PostCarousel/telaviv-and-jerusalem.jpg","side_img":"/PostCarousel/telaviv-and-jerusalem.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=TelAviv_And_Jerusalem","ctg":"telavivAndJerusalem","isVid":false,"id":"TelAviv_And_Jerusalem"},{"title":"CAESAREA EINE ZEITREISE",// "sml_desc": "",
"sml_desc":"","desc":"","img":"/PostCarousel/caesarea-time-travel.jpg","side_img":"/PostCarousel/caesarea-time-travel.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=Caesarea_A_Time_Travel","ctg":"north","isVid":false,"id":"Caesarea_A_Time_Travel"},{"title":"ISRAELS MAJESTÄTISCHE WÜSTE",// "sml_desc": "Wo Abenteuer und Inspiration Sie erwarten",
"sml_desc":"","desc":"","img":"/PostCarousel/majestic-desert.jpg","side_img":"/PostCarousel/majestic-desert.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=Majestic_Desert","ctg":"eilat-negev","isVid":false,"id":"Majestic_Desert"},{"title":"EINZIGARTIGES KAUFERLEBNIS IN ISRAEL",// "sml_desc": "",
"sml_desc":"","desc":"","img":"/PostCarousel/shoping-in-israel.jpg","side_img":"/PostCarousel/shoping-in-israel.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=Shoping_In_Israel","ctg":"jerusalem","isVid":false,"id":"Shoping_In_Israel"},{"title":"TIMNA PARK",// "sml_desc": "Ein begeisterndes Wüstenabenteuer",
"sml_desc":"","desc":"","img":"/PostCarousel/park-timna.jpg","side_img":"/PostCarousel/park-timna.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=Park_Timna","ctg":"eilat-negev","isVid":false,"forVidPage":true,"id":"Park_Timna"},{"title":"ÜBERNACHTEN IN DER NEGEV WÜSTE",// "sml_desc": "",
"sml_desc":"","desc":"","img":"/PostCarousel/stay-in-negev.jpg","side_img":"/PostCarousel/stay-in-negev.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=Stay_In_THe_Negev","ctg":"eilat-negev","isVid":false,"id":"Stay_In_THe_Negev"},{"title":"DER NEGEV",// "sml_desc": "er perfekte Ort für Ihr persönliches Wüstenabenteuer",
"sml_desc":"","desc":"","img":"/PostCarousel/desert-adventure.jpg","side_img":"/PostCarousel/desert-adventure.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=Desert_Adventure","ctg":"eilat-negev","isVid":false,"id":"Desert_Adventure"},{"title":"AKTIVURLAUB IN GALILÄA",// "sml_desc": "Aktiv Abenteuer erleben in Galiläa",
"sml_desc":"","desc":"","img":"/PostCarousel/adventures-in-galilea.jpg","side_img":"/PostCarousel/adventures-in-galilea.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=Adventures_In_Galilea","ctg":"north","isVid":false,"id":"Adventures_In_Galilea"},{"title":"WAS MACHT EILAT ZUM ULTIMATIVEN URLAUBSZIEL?",// "sml_desc": "Erkunden Sie die Stadt des ewigen Sonnenscheins",
"sml_desc":"","desc":"","img":"/PostCarousel/eilat1.jpg","side_img":"/PostCarousel/eilat1.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=Eilat_","ctg":"eilat-negev","isVid":false,"id":"Eilat_"},{"title":"SAFED",// "sml_desc": "wo Mystik und Weltliches aufeinandertreffen",
"sml_desc":"","desc":"","img":"/PostCarousel/mystic-and-worldly-meeting.jpg","side_img":"/PostCarousel/mystic-and-worldly-meeting.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=Mystic_And_Worldly_Meeting","ctg":"north","isVid":false,"forVidPage":true,"id":"Mystic_And_Worldly_Meeting"},{"title":"NAZARETH: EIN JUWEL MIT VIELEN FACETTEN",// "sml_desc": "Das historische Zentrum mit aufregenden modernen Seiten",
"sml_desc":"","desc":"","img":"/PostCarousel/nazareth-the-historical-center.jpg","side_img":"/PostCarousel/nazareth-the-historical-center.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=Nazareth_The_Historical_Center","ctg":"north","isVid":false,"id":"Nazareth_The_Historical_Center"},// THESE TWO posts complite the missing posts for carousel TEL AVIV
{"title":"Sarona Tel Aviv",// "desc": "Eine riesige Auswahl von Attraktionen in \n der überwältigenden sanierten Templerkolonie",
// "sml_desc": "Eine atemberaubende urbane Oase",
"sml_desc":"","desc":"","img":"Videos/d.jpg","img_mob":"/Videos/video_mob/d.jpg","side_img":"Videos/sidebar/d.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?postType=video&post=1","vidId":"7JF0z2XPpz0","ctg":"telaviv","isVid":true,"isDouble":true,"forVidPage":true,"id":7},{"title":"Tel Aviv Am Srand",// "sml_desc": "Weil sich das Leben in Tel Aviv \n von der Sonnenseite zeigt",
// "desc": "Bereit für eine volle \nLadung Spaß in der Sonne?",
"sml_desc":"","desc":"","img":"Videos/a.jpg","img_mob":"Videos/video_mob/a.jpg","side_img":"Videos/sidebar/a.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?postType=video&post=3","css_class":"unic_video-post-4","vidId":"ExuWHatIrKE","ctg":"telaviv","isVid":true,"isDouble":true,"forVidPage":true,"id":4},// End THESE TWO posts complite the missing posts for carousel TEL AVIV
// End This post complite the missing posts for carousel JERUSALEM
{"title":"Absolutes \'Muss\' in Jerusalem",// "sml_desc": "5 Top-Dinge zu tun und zu sehen in der atemberaubenden Stadt",
"sml_desc":"","desc":"","img":"/PostCarousel/18.jpg","side_img":"/PostCarousel/18.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=18","vidId":"k4OwoEk5wMw","isVid":true,"forVidPage":true,"isDouble":true,"ctg":"jerusalem","id":18},// End This post complite the missing posts for carousel JERUSALEM
// End THESE TWO posts complite the missing posts for carousel NEGEV AND EILAT
{"title":"DAS DOLPHIN REEF EILAT",// "sml_desc": "Eine unvergessliche Begegnung mit der Tierwelt",
"sml_desc":"","desc":"","img":"PostCarousel/the-dolphin-reef.jpg","side_img":"PostCarousel/the-dolphin-reef.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=The_Dolphin_Reef","ctg":"eilat-negev","isVid":false,"forVidPage":true,"isDouble":true,"id":"The_Dolphin_Reef"},{"title":"TIMNA PARK",// "sml_desc": "Ein begeisterndes Wüstenabenteuer",
"sml_desc":"","desc":"","img":"/PostCarousel/park-timna.jpg","side_img":"/PostCarousel/park-timna.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=Park_Timna","ctg":"eilat-negev","isVid":false,"forVidPage":true,"isDouble":true,"id":"Park_Timna"},// End THESE TWO posts complite the missing posts for carousel NEGEV AND EILAT
// End THESE TWO posts complite the missing posts for carousel NORTH
{"title":"NAZARETH",// "sml_desc": "DIE WIEGE DES CHRISTENTUMS",
"sml_desc":"","desc":"","img":"/PostCarousel/nazareth.jpg","side_img":"/PostCarousel/nazareth.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=Nazareth","ctg":"north","isVid":false,"forVidPage":true,"isDouble":true,"id":"Nazareth"},{"title":"ROSH PINA",// "sml_desc": "Pastoraler Geheimtipp für Touristen in Galiläa",
"sml_desc":"","desc":"","img":"PostCarousel/rosh-pina.jpg","side_img":"PostCarousel/rosh-pina.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=Rosh_Pina","ctg":"north","isVid":false,"isDouble":true,"id":"Rosh_Pina"}];var Reminders=[// Tel Aviv
{"quote":"One of the world's 25 best cities for foodies","site":"Business Insider","img":"/References/1.jpg","ctg":"Tel Aviv"},// Jerusalem
{"quote":"TripAdvisor Traveler's Choice Award 2015","site":"TripAdvisor","img":"/References/9.jpg","ctg":"Jerusalem"},{"quote":"One of the world's leading party cities","site":"Telegraph","img":"/References/2.jpg","ctg":"Tel Aviv"},{"quote":"One of the cities with most beautiful people","site":"Conde Nast","img":"/References/3.jpg","ctg":"Tel Aviv"},{"quote":"One of the 20 must visit destinations in the world  TNS","site":"The National Student","img":"/References/10.jpg","ctg":"Jerusalem"},{"quote":"One of the best beach party spots on the planet","site":"USA Today","img":"/References/4.jpg","ctg":"Tel Aviv"},{"quote":"One of the world's top 10 beach cities","site":"National Geographic","img":"/References/5.jpg","ctg":"Tel Aviv"},{"quote":"3rd Of 6 Top world’s holiest sites","site":"National Geographic","img":"/References/11.jpg","ctg":"Jerusalem"},{"quote":"One of the world's top ten cities","site":"Lonely Planet","img":"/References/6.jpg","ctg":"Tel Aviv"},{"quote":"One of the world's top ten hedonistic city breaks ","site":"Lonely Planet","img":"/References/7.jpg","ctg":"Tel Aviv"},{"quote":"I just thought it was magical… It instantly turned into my favorite trip.","site":"TripAdvisor","img":"/References/12.jpg","ctg":"Jerusalem","job":"CEO, Stephen Kaufer about Jerusalem","cssClass":"make-it-smller"},{"quote":"The World’s New Dining Hotspot","site":"Bloomberg.com","img":"/References/8.jpg","ctg":"Tel Aviv"}];

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line no-undef
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func
  Function('return this')();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(100);
var isBuffer = __webpack_require__(197);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(7);
var shared = __webpack_require__(74);
var has = __webpack_require__(12);
var uid = __webpack_require__(42);
var NATIVE_SYMBOL = __webpack_require__(80);
var USE_SYMBOL_AS_UID = __webpack_require__(128);

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name)) {
    if (NATIVE_SYMBOL && has(Symbol, name)) WellKnownSymbolsStore[name] = Symbol[name];
    else WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(162);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(170);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(91);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(171);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(173);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(175);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(177);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(92);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(51);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(179);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(181);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(183);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(184);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(185);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_13__withRouter__["a"]; });





























/***/ }),
/* 11 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 12 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;

module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(17);
var IE8_DOM_DEFINE = __webpack_require__(70);
var anObject = __webpack_require__(19);
var toPrimitive = __webpack_require__(69);

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(13);

// Thank's IE8 for his funny defineProperty
module.exports = !fails(function () {
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(17);
var definePropertyModule = __webpack_require__(15);
var createPropertyDescriptor = __webpack_require__(37);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 21 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(154);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(169);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(7);
var createNonEnumerableProperty = __webpack_require__(18);
var has = __webpack_require__(12);
var setGlobal = __webpack_require__(39);
var inspectSource = __webpack_require__(72);
var InternalStateModule = __webpack_require__(28);

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) createNonEnumerableProperty(value, 'name', key);
    enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});


/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_slick__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_slick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_slick_carousel_slick_slick_css__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_slick_carousel_slick_slick_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_slick_carousel_slick_slick_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel_slick_slick_theme_css__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel_slick_slick_theme_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_slick_carousel_slick_slick_theme_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SimpleSlider_css__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SimpleSlider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SimpleSlider_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// note 
// npm install react-slick
// npm install slick-carousel
// https://github.com/akiran/react-slick
/**
  use 

  import SimpleSlider from './components/SimpleSlider/SimpleSlider';
  
 <SimpleSlider settings={customSliderSettings}>
      <div><h3>Hey Man 1</h3></div>
      <div><h3>Hey Man 2</h3></div>
      <div><h3>Hey Man 3</h3></div>
      <div><h3>Hey Man 4 </h3></div>
      <div><h3>Hey Man 5 </h3></div>
      <div><h3>Hey Man  6 </h3></div>
       </SimpleSlider>
*/var SimpleSlider=function(_Component){_inherits(SimpleSlider,_Component);function SimpleSlider(props){_classCallCheck(this,SimpleSlider);var _this=_possibleConstructorReturn(this,(SimpleSlider.__proto__||Object.getPrototypeOf(SimpleSlider)).call(this,props));_this.settings=Object.assign({accessibility:false,autoplay:false,dots:true,infinite:true,speed:500,slidesToShow:1,slidesToScroll:1},_this.props.settings);return _this;}_createClass(SimpleSlider,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Slider-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_slick___default.a,this.settings,this.props.children));}}]);return SimpleSlider;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SimpleSlider);

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(118);
var requireObjectCoercible = __webpack_require__(38);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__(119);
var global = __webpack_require__(7);
var isObject = __webpack_require__(14);
var createNonEnumerableProperty = __webpack_require__(18);
var objectHas = __webpack_require__(12);
var sharedKey = __webpack_require__(40);
var hiddenKeys = __webpack_require__(29);

var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP) {
  var store = new WeakMap();
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 30 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(32);

var _utils2 = _interopRequireDefault(_utils);

var _animateScroll = __webpack_require__(97);

var _animateScroll2 = _interopRequireDefault(_animateScroll);

var _scrollEvents = __webpack_require__(57);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __mapped = {};
var __activeLink = void 0;

exports.default = {

  unmount: function unmount() {
    __mapped = {};
  },

  register: function register(name, element) {
    __mapped[name] = element;
  },

  unregister: function unregister(name) {
    delete __mapped[name];
  },

  get: function get(name) {
    return __mapped[name] || document.getElementById(name) || document.getElementsByName(name)[0] || document.getElementsByClassName(name)[0];
  },

  setActiveLink: function setActiveLink(link) {
    return __activeLink = link;
  },

  getActiveLink: function getActiveLink() {
    return __activeLink;
  },

  scrollTo: function scrollTo(to, props) {

    var target = this.get(to);

    if (!target) {
      console.warn("target Element not found");
      return;
    }

    props = _extends({}, props, { absolute: false });

    var containerId = props.containerId;
    var container = props.container;

    var containerElement = void 0;
    if (containerId) {
      containerElement = document.getElementById(containerId);
    } else if (container && container.nodeType) {
      containerElement = container;
    } else {
      containerElement = document;
    }

    props.absolute = true;

    var scrollOffset = _utils2.default.scrollOffset(containerElement, target) + (props.offset || 0);

    /*
     * if animate is not provided just scroll into the view
     */
    if (!props.smooth) {
      if (_scrollEvents2.default.registered['begin']) {
        _scrollEvents2.default.registered['begin'](to, target);
      }

      if (containerElement === document) {
        window.scrollTo(0, scrollOffset);
      } else {
        containerElement.scrollTop = scrollOffset;
      }

      if (_scrollEvents2.default.registered['end']) {
        _scrollEvents2.default.registered['end'](to, target);
      }

      return;
    }

    /*
     * Animate scrolling
     */

    _animateScroll2.default.animateTopScroll(scrollOffset, props, to, target);
  }
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var pushHash = function pushHash(hash) {
  hash = hash ? hash.indexOf("#") === 0 ? hash : "#" + hash : "";

  if (history.pushState) {
    var loc = window.location;
    history.pushState(null, null, hash ? loc.pathname + loc.search + hash : // remove hash
    loc.pathname + loc.search);
  } else {
    location.hash = hash;
  }
};

var getHash = function getHash() {
  return window.location.hash.replace(/^#/, "");
};

var filterElementInContainer = function filterElementInContainer(container) {
  return function (element) {
    return container.contains ? container != element && container.contains(element) : !!(container.compareDocumentPosition(element) & 16);
  };
};

var scrollOffset = function scrollOffset(c, t) {
  return c === document ? t.getBoundingClientRect().top + (window.scrollY || window.pageYOffset) : getComputedStyle(c).position !== "static" ? t.offsetTop : t.offsetTop - c.offsetTop;
};
exports.default = {
  pushHash: pushHash,
  getHash: getHash,
  filterElementInContainer: filterElementInContainer,
  scrollOffset: scrollOffset
};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.forceCheck = exports.lazyload = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(22);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _event = __webpack_require__(213);

var _scrollParent = __webpack_require__(214);

var _scrollParent2 = _interopRequireDefault(_scrollParent);

var _debounce = __webpack_require__(215);

var _debounce2 = _interopRequireDefault(_debounce);

var _throttle = __webpack_require__(216);

var _throttle2 = _interopRequireDefault(_throttle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * react-lazyload
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var defaultBoundingClientRect = { top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 };
var LISTEN_FLAG = 'data-lazyload-listened';
var listeners = [];
var pending = [];

// try to handle passive events
var passiveEventSupported = false;
try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function get() {
      passiveEventSupported = true;
    }
  });
  window.addEventListener('test', null, opts);
} catch (e) {}
// if they are supported, setup the optional params
// IMPORTANT: FALSE doubles as the default CAPTURE value!
var passiveEvent = passiveEventSupported ? { capture: false, passive: true } : false;

/**
 * Check if `component` is visible in overflow container `parent`
 * @param  {node} component React component
 * @param  {node} parent    component's scroll parent
 * @return {bool}
 */
var checkOverflowVisible = function checkOverflowVisible(component, parent) {
  var node = _reactDom2.default.findDOMNode(component);

  var parentTop = void 0;
  var parentLeft = void 0;
  var parentHeight = void 0;
  var parentWidth = void 0;

  try {
    var _parent$getBoundingCl = parent.getBoundingClientRect();

    parentTop = _parent$getBoundingCl.top;
    parentLeft = _parent$getBoundingCl.left;
    parentHeight = _parent$getBoundingCl.height;
    parentWidth = _parent$getBoundingCl.width;
  } catch (e) {
    parentTop = defaultBoundingClientRect.top;
    parentLeft = defaultBoundingClientRect.left;
    parentHeight = defaultBoundingClientRect.height;
    parentWidth = defaultBoundingClientRect.width;
  }

  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;
  var windowInnerWidth = window.innerWidth || document.documentElement.clientWidth;

  // calculate top and height of the intersection of the element's scrollParent and viewport
  var intersectionTop = Math.max(parentTop, 0); // intersection's top relative to viewport
  var intersectionLeft = Math.max(parentLeft, 0); // intersection's left relative to viewport
  var intersectionHeight = Math.min(windowInnerHeight, parentTop + parentHeight) - intersectionTop; // height
  var intersectionWidth = Math.min(windowInnerWidth, parentLeft + parentWidth) - intersectionLeft; // width

  // check whether the element is visible in the intersection
  var top = void 0;
  var left = void 0;
  var height = void 0;
  var width = void 0;

  try {
    var _node$getBoundingClie = node.getBoundingClientRect();

    top = _node$getBoundingClie.top;
    left = _node$getBoundingClie.left;
    height = _node$getBoundingClie.height;
    width = _node$getBoundingClie.width;
  } catch (e) {
    top = defaultBoundingClientRect.top;
    left = defaultBoundingClientRect.left;
    height = defaultBoundingClientRect.height;
    width = defaultBoundingClientRect.width;
  }

  var offsetTop = top - intersectionTop; // element's top relative to intersection
  var offsetLeft = left - intersectionLeft; // element's left relative to intersection

  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API

  return offsetTop - offsets[0] <= intersectionHeight && offsetTop + height + offsets[1] >= 0 && offsetLeft - offsets[0] <= intersectionWidth && offsetLeft + width + offsets[1] >= 0;
};

/**
 * Check if `component` is visible in document
 * @param  {node} component React component
 * @return {bool}
 */
var checkNormalVisible = function checkNormalVisible(component) {
  var node = _reactDom2.default.findDOMNode(component);

  // If this element is hidden by css rules somehow, it's definitely invisible
  if (!(node.offsetWidth || node.offsetHeight || node.getClientRects().length)) return false;

  var top = void 0;
  var elementHeight = void 0;

  try {
    var _node$getBoundingClie2 = node.getBoundingClientRect();

    top = _node$getBoundingClie2.top;
    elementHeight = _node$getBoundingClie2.height;
  } catch (e) {
    top = defaultBoundingClientRect.top;
    elementHeight = defaultBoundingClientRect.height;
  }

  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;

  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API

  return top - offsets[0] <= windowInnerHeight && top + elementHeight + offsets[1] >= 0;
};

/**
 * Detect if element is visible in viewport, if so, set `visible` state to true.
 * If `once` prop is provided true, remove component as listener after checkVisible
 *
 * @param  {React} component   React component that respond to scroll and resize
 */
var checkVisible = function checkVisible(component) {
  var node = _reactDom2.default.findDOMNode(component);
  if (!(node instanceof HTMLElement)) {
    return;
  }

  var parent = (0, _scrollParent2.default)(node);
  var isOverflow = component.props.overflow && parent !== node.ownerDocument && parent !== document && parent !== document.documentElement;
  var visible = isOverflow ? checkOverflowVisible(component, parent) : checkNormalVisible(component);
  if (visible) {
    // Avoid extra render if previously is visible
    if (!component.visible) {
      if (component.props.once) {
        pending.push(component);
      }

      component.visible = true;
      component.forceUpdate();
    }
  } else if (!(component.props.once && component.visible)) {
    component.visible = false;
    if (component.props.unmountIfInvisible) {
      component.forceUpdate();
    }
  }
};

var purgePending = function purgePending() {
  pending.forEach(function (component) {
    var index = listeners.indexOf(component);
    if (index !== -1) {
      listeners.splice(index, 1);
    }
  });

  pending = [];
};

var lazyLoadHandler = function lazyLoadHandler() {
  for (var i = 0; i < listeners.length; ++i) {
    var listener = listeners[i];
    checkVisible(listener);
  }
  // Remove `once` component in listeners
  purgePending();
};

// Depending on component's props
var delayType = void 0;
var finalLazyLoadHandler = null;

var isString = function isString(string) {
  return typeof string === 'string';
};

var LazyLoad = function (_Component) {
  _inherits(LazyLoad, _Component);

  function LazyLoad(props) {
    _classCallCheck(this, LazyLoad);

    var _this = _possibleConstructorReturn(this, (LazyLoad.__proto__ || Object.getPrototypeOf(LazyLoad)).call(this, props));

    _this.visible = false;
    return _this;
  }

  _createClass(LazyLoad, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // It's unlikely to change delay type on the fly, this is mainly
      // designed for tests
      var scrollport = window;
      var scrollContainer = this.props.scrollContainer;

      if (scrollContainer) {
        if (isString(scrollContainer)) {
          scrollport = scrollport.document.querySelector(scrollContainer);
        }
      }
      var needResetFinalLazyLoadHandler = this.props.debounce !== undefined && delayType === 'throttle' || delayType === 'debounce' && this.props.debounce === undefined;

      if (needResetFinalLazyLoadHandler) {
        (0, _event.off)(scrollport, 'scroll', finalLazyLoadHandler, passiveEvent);
        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        finalLazyLoadHandler = null;
      }

      if (!finalLazyLoadHandler) {
        if (this.props.debounce !== undefined) {
          finalLazyLoadHandler = (0, _debounce2.default)(lazyLoadHandler, typeof this.props.debounce === 'number' ? this.props.debounce : 300);
          delayType = 'debounce';
        } else if (this.props.throttle !== undefined) {
          finalLazyLoadHandler = (0, _throttle2.default)(lazyLoadHandler, typeof this.props.throttle === 'number' ? this.props.throttle : 300);
          delayType = 'throttle';
        } else {
          finalLazyLoadHandler = lazyLoadHandler;
        }
      }

      if (this.props.overflow) {
        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
        if (parent && typeof parent.getAttribute === 'function') {
          var listenerCount = 1 + +parent.getAttribute(LISTEN_FLAG);
          if (listenerCount === 1) {
            parent.addEventListener('scroll', finalLazyLoadHandler, passiveEvent);
          }
          parent.setAttribute(LISTEN_FLAG, listenerCount);
        }
      } else if (listeners.length === 0 || needResetFinalLazyLoadHandler) {
        var _props = this.props,
            scroll = _props.scroll,
            resize = _props.resize;


        if (scroll) {
          (0, _event.on)(scrollport, 'scroll', finalLazyLoadHandler, passiveEvent);
        }

        if (resize) {
          (0, _event.on)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        }
      }

      listeners.push(this);
      checkVisible(this);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return this.visible;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.overflow) {
        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
        if (parent && typeof parent.getAttribute === 'function') {
          var listenerCount = +parent.getAttribute(LISTEN_FLAG) - 1;
          if (listenerCount === 0) {
            parent.removeEventListener('scroll', finalLazyLoadHandler, passiveEvent);
            parent.removeAttribute(LISTEN_FLAG);
          } else {
            parent.setAttribute(LISTEN_FLAG, listenerCount);
          }
        }
      }

      var index = listeners.indexOf(this);
      if (index !== -1) {
        listeners.splice(index, 1);
      }

      if (listeners.length === 0 && typeof window !== 'undefined') {
        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        (0, _event.off)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.visible ? this.props.children : this.props.placeholder ? this.props.placeholder : _react2.default.createElement('div', { style: { height: this.props.height }, className: 'lazyload-placeholder' });
    }
  }]);

  return LazyLoad;
}(_react.Component);

LazyLoad.propTypes = {
  once: _propTypes2.default.bool,
  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  offset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)]),
  overflow: _propTypes2.default.bool,
  resize: _propTypes2.default.bool,
  scroll: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  throttle: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
  debounce: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
  placeholder: _propTypes2.default.node,
  scrollContainer: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  unmountIfInvisible: _propTypes2.default.bool
};

LazyLoad.defaultProps = {
  once: false,
  offset: 0,
  overflow: false,
  resize: false,
  scroll: true,
  unmountIfInvisible: false
};

var getDisplayName = function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

var decorator = function decorator() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function lazyload(WrappedComponent) {
    return function (_Component2) {
      _inherits(LazyLoadDecorated, _Component2);

      function LazyLoadDecorated() {
        _classCallCheck(this, LazyLoadDecorated);

        var _this2 = _possibleConstructorReturn(this, (LazyLoadDecorated.__proto__ || Object.getPrototypeOf(LazyLoadDecorated)).call(this));

        _this2.displayName = 'LazyLoad' + getDisplayName(WrappedComponent);
        return _this2;
      }

      _createClass(LazyLoadDecorated, [{
        key: 'render',
        value: function render() {
          return _react2.default.createElement(
            LazyLoad,
            options,
            _react2.default.createElement(WrappedComponent, this.props)
          );
        }
      }]);

      return LazyLoadDecorated;
    }(_react.Component);
  };
};

exports.lazyload = decorator;
exports.default = LazyLoad;
exports.forceCheck = lazyLoadHandler;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(22);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getOnDemandLazySlides = exports.getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
  var onDemandSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
      onDemandSlides.push(slideIndex);
    }
  }
  return onDemandSlides;
};

// return list of slides that need to be present
var getRequiredLazySlides = exports.getRequiredLazySlides = function getRequiredLazySlides(spec) {
  var requiredSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    requiredSlides.push(slideIndex);
  }
  return requiredSlides;
};

// startIndex that needs to be present
var lazyStartIndex = exports.lazyStartIndex = function lazyStartIndex(spec) {
  return spec.currentSlide - lazySlidesOnLeft(spec);
};
var lazyEndIndex = exports.lazyEndIndex = function lazyEndIndex(spec) {
  return spec.currentSlide + lazySlidesOnRight(spec);
};
var lazySlidesOnLeft = exports.lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};
var lazySlidesOnRight = exports.lazySlidesOnRight = function lazySlidesOnRight(spec) {
  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
};

// get width of an element
var getWidth = exports.getWidth = function getWidth(elem) {
  return elem && elem.offsetWidth || 0;
};
var getHeight = exports.getHeight = function getHeight(elem) {
  return elem && elem.offsetHeight || 0;
};
var getSwipeDirection = exports.getSwipeDirection = function getSwipeDirection(touchObject) {
  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var xDist, yDist, r, swipeAngle;
  xDist = touchObject.startX - touchObject.curX;
  yDist = touchObject.startY - touchObject.curY;
  r = Math.atan2(yDist, xDist);
  swipeAngle = Math.round(r * 180 / Math.PI);
  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }
  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return "left";
  }
  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return "right";
  }
  if (verticalSwiping === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return "up";
    } else {
      return "down";
    }
  }

  return "vertical";
};

// whether or not we can go next
var canGoNext = exports.canGoNext = function canGoNext(spec) {
  var canGo = true;
  if (!spec.infinite) {
    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
      canGo = false;
    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
      canGo = false;
    }
  }
  return canGo;
};

// given an object and a list of keys, return new object with given keys
var extractObject = exports.extractObject = function extractObject(spec, keys) {
  var newObject = {};
  keys.forEach(function (key) {
    return newObject[key] = spec[key];
  });
  return newObject;
};

// get initialized state
var initializedState = exports.initializedState = function initializedState(spec) {
  // spec also contains listRef, trackRef
  var slideCount = _react2.default.Children.count(spec.children);
  var listWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.listRef)));
  var trackWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.trackRef)));
  var slideWidth = void 0;
  if (!spec.vertical) {
    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
      centerPaddingAdj *= listWidth / 100;
    }
    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
  } else {
    slideWidth = listWidth;
  }
  var slideHeight = _reactDom2.default.findDOMNode(spec.listRef) && getHeight(_reactDom2.default.findDOMNode(spec.listRef).querySelector('[data-index="0"]'));
  var listHeight = slideHeight * spec.slidesToShow;
  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
  if (spec.rtl && spec.currentSlide === undefined) {
    currentSlide = slideCount - 1 - spec.initialSlide;
  }
  var lazyLoadedList = spec.lazyLoadedList || [];
  var slidesToLoad = getOnDemandLazySlides({ currentSlide: currentSlide, lazyLoadedList: lazyLoadedList }, spec);
  lazyLoadedList.concat(slidesToLoad);

  var state = {
    slideCount: slideCount,
    slideWidth: slideWidth,
    listWidth: listWidth,
    trackWidth: trackWidth,
    currentSlide: currentSlide,
    slideHeight: slideHeight,
    listHeight: listHeight,
    lazyLoadedList: lazyLoadedList
  };

  if (spec.autoplaying === null && spec.autoplay) {
    state["autoplaying"] = "playing";
  }

  return state;
};

var slideHandler = exports.slideHandler = function slideHandler(spec) {
  var waitForAnimate = spec.waitForAnimate,
      animating = spec.animating,
      fade = spec.fade,
      infinite = spec.infinite,
      index = spec.index,
      slideCount = spec.slideCount,
      lazyLoadedList = spec.lazyLoadedList,
      lazyLoad = spec.lazyLoad,
      currentSlide = spec.currentSlide,
      centerMode = spec.centerMode,
      slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      useCSS = spec.useCSS;

  if (waitForAnimate && animating) return {};
  var animationSlide = index,
      finalSlide = void 0,
      animationLeft = void 0,
      finalLeft = void 0;
  var state = {},
      nextState = {};
  if (fade) {
    if (!infinite && (index < 0 || index >= slideCount)) return {};
    if (index < 0) {
      animationSlide = index + slideCount;
    } else if (index >= slideCount) {
      animationSlide = index - slideCount;
    }
    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
      lazyLoadedList.push(animationSlide);
    }
    state = {
      animating: true,
      currentSlide: animationSlide,
      lazyLoadedList: lazyLoadedList
    };
    nextState = { animating: false };
  } else {
    finalSlide = animationSlide;
    if (animationSlide < 0) {
      finalSlide = animationSlide + slideCount;
      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
      animationSlide = finalSlide = currentSlide;
    } else if (centerMode && animationSlide >= slideCount) {
      animationSlide = infinite ? slideCount : slideCount - 1;
      finalSlide = infinite ? 0 : slideCount - 1;
    } else if (animationSlide >= slideCount) {
      finalSlide = animationSlide - slideCount;
      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
    }
    animationLeft = getTrackLeft(_extends({}, spec, { slideIndex: animationSlide }));
    finalLeft = getTrackLeft(_extends({}, spec, { slideIndex: finalSlide }));
    if (!infinite) {
      if (animationLeft === finalLeft) animationSlide = finalSlide;
      animationLeft = finalLeft;
    }
    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_extends({}, spec, { currentSlide: animationSlide })));
    if (!useCSS) {
      state = {
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
        lazyLoadedList: lazyLoadedList
      };
    } else {
      state = {
        animating: true,
        currentSlide: finalSlide,
        trackStyle: getTrackAnimateCSS(_extends({}, spec, { left: animationLeft })),
        lazyLoadedList: lazyLoadedList
      };
      nextState = {
        animating: false,
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
        swipeLeft: null
      };
    }
  }
  return { state: state, nextState: nextState };
};

var changeSlide = exports.changeSlide = function changeSlide(spec, options) {
  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
  var slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      slideCount = spec.slideCount,
      currentSlide = spec.currentSlide,
      lazyLoad = spec.lazyLoad,
      infinite = spec.infinite;

  unevenOffset = slideCount % slidesToScroll !== 0;
  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

  if (options.message === "previous") {
    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
    targetSlide = currentSlide - slideOffset;
    if (lazyLoad && !infinite) {
      previousInt = currentSlide - slideOffset;
      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
    }
  } else if (options.message === "next") {
    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
    targetSlide = currentSlide + slideOffset;
    if (lazyLoad && !infinite) {
      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
    }
  } else if (options.message === "dots") {
    // Click on dots
    targetSlide = options.index * options.slidesToScroll;
    if (targetSlide === options.currentSlide) {
      return null;
    }
  } else if (options.message === "children") {
    // Click on the slides
    targetSlide = options.index;
    if (targetSlide === options.currentSlide) {
      return null;
    }
    if (infinite) {
      var direction = siblingDirection(_extends({}, spec, { targetSlide: targetSlide }));
      if (targetSlide > options.currentSlide && direction === "left") {
        targetSlide = targetSlide - slideCount;
      } else if (targetSlide < options.currentSlide && direction === "right") {
        targetSlide = targetSlide + slideCount;
      }
    }
  } else if (options.message === "index") {
    targetSlide = Number(options.index);
    if (targetSlide === options.currentSlide) {
      return null;
    }
  }
  return targetSlide;
};
var keyHandler = exports.keyHandler = function keyHandler(e, accessibility, rtl) {
  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
  if (e.keyCode === 37) return rtl ? "next" : "previous";
  if (e.keyCode === 39) return rtl ? "previous" : "next";
  return "";
};

var swipeStart = exports.swipeStart = function swipeStart(e, swipe, draggable) {
  e.target.tagName === "IMG" && e.preventDefault();
  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
  return {
    dragging: true,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};
var swipeMove = exports.swipeMove = function swipeMove(e, spec) {
  // spec also contains, trackRef and slideIndex
  var scrolling = spec.scrolling,
      animating = spec.animating,
      vertical = spec.vertical,
      swipeToSlide = spec.swipeToSlide,
      verticalSwiping = spec.verticalSwiping,
      rtl = spec.rtl,
      currentSlide = spec.currentSlide,
      edgeFriction = spec.edgeFriction,
      edgeDragged = spec.edgeDragged,
      onEdge = spec.onEdge,
      swiped = spec.swiped,
      swiping = spec.swiping,
      slideCount = spec.slideCount,
      slidesToScroll = spec.slidesToScroll,
      infinite = spec.infinite,
      touchObject = spec.touchObject,
      swipeEvent = spec.swipeEvent,
      listHeight = spec.listHeight,
      listWidth = spec.listWidth;

  if (scrolling) return;
  if (animating) return e.preventDefault();
  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
  var swipeLeft = void 0,
      state = {};
  var curLeft = getTrackLeft(spec);
  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
    return { scrolling: true };
  }
  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;

  var dotCount = Math.ceil(slideCount / slidesToScroll);
  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
  var touchSwipeLength = touchObject.swipeLength;
  if (!infinite) {
    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
      touchSwipeLength = touchObject.swipeLength * edgeFriction;
      if (edgeDragged === false && onEdge) {
        onEdge(swipeDirection);
        state["edgeDragged"] = true;
      }
    }
  }
  if (!swiped && swipeEvent) {
    swipeEvent(swipeDirection);
    state["swiped"] = true;
  }
  if (!vertical) {
    if (!rtl) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft - touchSwipeLength * positionOffset;
    }
  } else {
    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
  }
  if (verticalSwiping) {
    swipeLeft = curLeft + touchSwipeLength * positionOffset;
  }
  state = _extends({}, state, {
    touchObject: touchObject,
    swipeLeft: swipeLeft,
    trackStyle: getTrackCSS(_extends({}, spec, { left: swipeLeft }))
  });
  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
    return state;
  }
  if (touchObject.swipeLength > 10) {
    state["swiping"] = true;
    e.preventDefault();
  }
  return state;
};
var swipeEnd = exports.swipeEnd = function swipeEnd(e, spec) {
  var dragging = spec.dragging,
      swipe = spec.swipe,
      touchObject = spec.touchObject,
      listWidth = spec.listWidth,
      touchThreshold = spec.touchThreshold,
      verticalSwiping = spec.verticalSwiping,
      listHeight = spec.listHeight,
      currentSlide = spec.currentSlide,
      swipeToSlide = spec.swipeToSlide,
      scrolling = spec.scrolling,
      onSwipe = spec.onSwipe;

  if (!dragging) {
    if (swipe) e.preventDefault();
    return {};
  }
  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping);
  // reset the state of touch related state variables.
  var state = {
    dragging: false,
    edgeDragged: false,
    scrolling: false,
    swiping: false,
    swiped: false,
    swipeLeft: null,
    touchObject: {}
  };
  if (scrolling) {
    return state;
  }
  if (!touchObject.swipeLength) {
    return state;
  }
  if (touchObject.swipeLength > minSwipe) {
    e.preventDefault();
    if (onSwipe) {
      onSwipe(swipeDirection);
    }
    var slideCount = void 0,
        newSlide = void 0;
    switch (swipeDirection) {
      case "left":
      case "up":
        newSlide = currentSlide + getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 0;
        break;
      case "right":
      case "down":
        newSlide = currentSlide - getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 1;
        break;
      default:
        slideCount = currentSlide;
    }
    state["triggerSlideHandler"] = slideCount;
  } else {
    // Adjust the track back to it's original position.
    var currentLeft = getTrackLeft(spec);
    state["trackStyle"] = getTrackAnimateCSS(_extends({}, spec, { left: currentLeft }));
  }
  return state;
};
var getNavigableIndexes = exports.getNavigableIndexes = function getNavigableIndexes(spec) {
  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
  var indexes = [];
  while (breakpoint < max) {
    indexes.push(breakpoint);
    breakpoint = counter + spec.slidesToScroll;
    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
  }
  return indexes;
};
var checkNavigable = exports.checkNavigable = function checkNavigable(spec, index) {
  var navigables = getNavigableIndexes(spec);
  var prevNavigable = 0;
  if (index > navigables[navigables.length - 1]) {
    index = navigables[navigables.length - 1];
  } else {
    for (var n in navigables) {
      if (index < navigables[n]) {
        index = prevNavigable;
        break;
      }
      prevNavigable = navigables[n];
    }
  }
  return index;
};
var getSlideCount = exports.getSlideCount = function getSlideCount(spec) {
  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
  if (spec.swipeToSlide) {
    var swipedSlide = void 0;
    var slickList = _reactDom2.default.findDOMNode(spec.listRef);
    var slides = slickList.querySelectorAll(".slick-slide");
    Array.from(slides).every(function (slide) {
      if (!spec.vertical) {
        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      } else {
        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      }

      return true;
    });

    if (!swipedSlide) {
      return 0;
    }
    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
    return slidesTraversed;
  } else {
    return spec.slidesToScroll;
  }
};

var checkSpecKeys = exports.checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : console.error("Keys Missing:", spec);
};

var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var trackWidth = void 0,
      trackHeight = void 0;
  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
  if (!spec.vertical) {
    trackWidth = getTotalSlides(spec) * spec.slideWidth;
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }
  var style = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };
  if (spec.useTransform) {
    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
    style = _extends({}, style, {
      WebkitTransform: WebkitTransform,
      transform: transform,
      msTransform: msTransform
    });
  } else {
    if (spec.vertical) {
      style["top"] = spec.left;
    } else {
      style["left"] = spec.left;
    }
  }
  if (spec.fade) style = { opacity: 1 };
  if (trackWidth) style.width = trackWidth;
  if (trackHeight) style.height = trackHeight;

  // Fallback for IE8
  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + "px";
    } else {
      style.marginTop = spec.left + "px";
    }
  }

  return style;
};
var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var style = getTrackCSS(spec);
  // useCSS is true by default so it can be undefined
  if (spec.useTransform) {
    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
  } else {
    if (spec.vertical) {
      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    } else {
      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    }
  }
  return style;
};
var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
  if (spec.unslick) {
    return 0;
  }

  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);

  var slideIndex = spec.slideIndex,
      trackRef = spec.trackRef,
      infinite = spec.infinite,
      centerMode = spec.centerMode,
      slideCount = spec.slideCount,
      slidesToShow = spec.slidesToShow,
      slidesToScroll = spec.slidesToScroll,
      slideWidth = spec.slideWidth,
      listWidth = spec.listWidth,
      variableWidth = spec.variableWidth,
      slideHeight = spec.slideHeight,
      fade = spec.fade,
      vertical = spec.vertical;


  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;

  if (fade || spec.slideCount === 1) {
    return 0;
  }

  var slidesToOffset = 0;
  if (infinite) {
    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
    }
    // shift current slide to center of the frame
    if (centerMode) {
      slidesToOffset += parseInt(slidesToShow / 2);
    }
  } else {
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
    }
    if (centerMode) {
      slidesToOffset = parseInt(slidesToShow / 2);
    }
  }
  slideOffset = slidesToOffset * slideWidth;
  verticalOffset = slidesToOffset * slideHeight;

  if (!vertical) {
    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
  } else {
    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
  }

  if (variableWidth === true) {
    var targetSlideIndex;
    var trackElem = _reactDom2.default.findDOMNode(trackRef);
    targetSlideIndex = slideIndex + getPreClones(spec);
    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
    if (centerMode === true) {
      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
      targetSlide = trackElem && trackElem.children[targetSlideIndex];
      targetLeft = 0;
      for (var slide = 0; slide < targetSlideIndex; slide++) {
        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
      }
      targetLeft -= parseInt(spec.centerPadding);
      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
    }
  }

  return targetLeft;
};

var getPreClones = exports.getPreClones = function getPreClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }
  if (spec.variableWidth) {
    return spec.slideCount;
  }
  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};

var getPostClones = exports.getPostClones = function getPostClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }
  return spec.slideCount;
};

var getTotalSlides = exports.getTotalSlides = function getTotalSlides(spec) {
  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
};
var siblingDirection = exports.siblingDirection = function siblingDirection(spec) {
  if (spec.targetSlide > spec.currentSlide) {
    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
      return "left";
    }
    return "right";
  } else {
    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
      return "right";
    }
    return "left";
  }
};

var slidesOnRight = exports.slidesOnRight = function slidesOnRight(_ref) {
  var slidesToShow = _ref.slidesToShow,
      centerMode = _ref.centerMode,
      rtl = _ref.rtl,
      centerPadding = _ref.centerPadding;

  // returns no of slides on the right of active slide
  if (centerMode) {
    var right = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) right += 1;
    if (rtl && slidesToShow % 2 === 0) right += 1;
    return right;
  }
  if (rtl) {
    return 0;
  }
  return slidesToShow - 1;
};

var slidesOnLeft = exports.slidesOnLeft = function slidesOnLeft(_ref2) {
  var slidesToShow = _ref2.slidesToShow,
      centerMode = _ref2.centerMode,
      rtl = _ref2.rtl,
      centerPadding = _ref2.centerPadding;

  // returns no of slides on the left of active slide
  if (centerMode) {
    var left = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) left += 1;
    if (!rtl && slidesToShow % 2 === 0) left += 1;
    return left;
  }
  if (rtl) {
    return slidesToShow - 1;
  }
  return 0;
};

var canUseDOM = exports.canUseDOM = function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 38 */
/***/ (function(module, exports) {

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(7);
var createNonEnumerableProperty = __webpack_require__(18);

module.exports = function (key, value) {
  try {
    createNonEnumerableProperty(global, key, value);
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(74);
var uid = __webpack_require__(42);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 42 */
/***/ (function(module, exports) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__(44);
var global = __webpack_require__(7);

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(7);

module.exports = global;


/***/ }),
/* 45 */
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(9);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(15).f;
var has = __webpack_require__(12);
var wellKnownSymbol = __webpack_require__(9);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(19);
var defineProperties = __webpack_require__(135);
var enumBugKeys = __webpack_require__(46);
var hiddenKeys = __webpack_require__(29);
var html = __webpack_require__(137);
var documentCreateElement = __webpack_require__(71);
var sharedKey = __webpack_require__(40);

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(66);
var createIteratorConstructor = __webpack_require__(139);
var getPrototypeOf = __webpack_require__(87);
var setPrototypeOf = __webpack_require__(84);
var setToStringTag = __webpack_require__(48);
var createNonEnumerableProperty = __webpack_require__(18);
var redefine = __webpack_require__(24);
var wellKnownSymbol = __webpack_require__(9);
var IS_PURE = __webpack_require__(41);
var Iterators = __webpack_require__(25);
var IteratorsCore = __webpack_require__(86);

var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
          createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator);
  }
  Iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};


/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(52);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _scrollSpy = __webpack_require__(55);

var _scrollSpy2 = _interopRequireDefault(_scrollSpy);

var _scroller = __webpack_require__(31);

var _scroller2 = _interopRequireDefault(_scroller);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _scrollHash = __webpack_require__(98);

var _scrollHash2 = _interopRequireDefault(_scrollHash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var protoTypes = {
  to: _propTypes2.default.string.isRequired,
  containerId: _propTypes2.default.string,
  container: _propTypes2.default.object,
  activeClass: _propTypes2.default.string,
  spy: _propTypes2.default.bool,
  smooth: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
  offset: _propTypes2.default.number,
  delay: _propTypes2.default.number,
  isDynamic: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  duration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
  absolute: _propTypes2.default.bool,
  onSetActive: _propTypes2.default.func,
  onSetInactive: _propTypes2.default.func,
  ignoreCancelEvents: _propTypes2.default.bool,
  hashSpy: _propTypes2.default.bool
};

exports.default = function (Component, customScroller) {

  var scroller = customScroller || _scroller2.default;

  var Link = function (_React$PureComponent) {
    _inherits(Link, _React$PureComponent);

    function Link(props) {
      _classCallCheck(this, Link);

      var _this = _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this, props));

      _initialiseProps.call(_this);

      _this.state = {
        active: false
      };
      return _this;
    }

    _createClass(Link, [{
      key: 'getScrollSpyContainer',
      value: function getScrollSpyContainer() {
        var containerId = this.props.containerId;
        var container = this.props.container;

        if (containerId && !container) {
          return document.getElementById(containerId);
        }

        if (container && container.nodeType) {
          return container;
        }

        return document;
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (this.props.spy || this.props.hashSpy) {
          var scrollSpyContainer = this.getScrollSpyContainer();

          if (!_scrollSpy2.default.isMounted(scrollSpyContainer)) {
            _scrollSpy2.default.mount(scrollSpyContainer);
          }

          if (this.props.hashSpy) {
            if (!_scrollHash2.default.isMounted()) {
              _scrollHash2.default.mount(scroller);
            }
            _scrollHash2.default.mapContainer(this.props.to, scrollSpyContainer);
          }

          _scrollSpy2.default.addSpyHandler(this.spyHandler, scrollSpyContainer);

          this.setState({
            container: scrollSpyContainer
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        _scrollSpy2.default.unmount(this.stateHandler, this.spyHandler);
      }
    }, {
      key: 'render',
      value: function render() {
        var className = "";

        if (this.state && this.state.active) {
          className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
        } else {
          className = this.props.className;
        }

        var props = _extends({}, this.props);

        for (var prop in protoTypes) {
          if (props.hasOwnProperty(prop)) {
            delete props[prop];
          }
        }

        props.className = className;
        props.onClick = this.handleClick;

        return _react2.default.createElement(Component, props);
      }
    }]);

    return Link;
  }(_react2.default.PureComponent);

  var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.scrollTo = function (to, props) {
      scroller.scrollTo(to, _extends({}, _this2.state, props));
    };

    this.handleClick = function (event) {

      /*
       * give the posibility to override onClick
       */

      if (_this2.props.onClick) {
        _this2.props.onClick(event);
      }

      /*
       * dont bubble the navigation
       */

      if (event.stopPropagation) event.stopPropagation();
      if (event.preventDefault) event.preventDefault();

      /*
       * do the magic!
       */
      _this2.scrollTo(_this2.props.to, _this2.props);
    };

    this.spyHandler = function (y) {

      var scrollSpyContainer = _this2.getScrollSpyContainer();

      if (_scrollHash2.default.isMounted() && !_scrollHash2.default.isInitialized()) {
        return;
      }

      var to = _this2.props.to;
      var element = null;
      var elemTopBound = 0;
      var elemBottomBound = 0;
      var containerTop = 0;

      if (scrollSpyContainer.getBoundingClientRect) {
        var containerCords = scrollSpyContainer.getBoundingClientRect();
        containerTop = containerCords.top;
      }

      if (!element || _this2.props.isDynamic) {
        element = scroller.get(to);
        if (!element) {
          return;
        }

        var cords = element.getBoundingClientRect();
        elemTopBound = cords.top - containerTop + y;
        elemBottomBound = elemTopBound + cords.height;
      }

      var offsetY = y - _this2.props.offset;
      var isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
      var isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
      var activeLink = scroller.getActiveLink();

      if (isOutside) {
        if (to === activeLink) {
          scroller.setActiveLink(void 0);
        }

        if (_this2.props.hashSpy && _scrollHash2.default.getHash() === to) {
          _scrollHash2.default.changeHash();
        }

        if (_this2.props.spy && _this2.state.active) {
          _this2.setState({ active: false });
          _this2.props.onSetInactive && _this2.props.onSetInactive(to, element);
        }
      }

      if (isInside && (activeLink !== to || _this2.state.active === false)) {
        scroller.setActiveLink(to);

        _this2.props.hashSpy && _scrollHash2.default.changeHash(to);

        if (_this2.props.spy) {
          _this2.setState({ active: true });
          _this2.props.onSetActive && _this2.props.onSetActive(to, element);
        }
      }
    };
  };

  ;

  Link.propTypes = protoTypes;

  Link.defaultProps = { offset: 0 };

  return Link;
};

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(190);

var _lodash2 = _interopRequireDefault(_lodash);

var _passiveEventListeners = __webpack_require__(56);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The eventHandler will execute at a rate of 15fps
var eventThrottler = function eventThrottler(eventHandler) {
  return (0, _lodash2.default)(eventHandler, 66);
};

var scrollSpy = {

  spyCallbacks: [],
  spySetState: [],
  scrollSpyContainers: [],

  mount: function mount(scrollSpyContainer) {
    if (scrollSpyContainer) {
      var eventHandler = eventThrottler(function (event) {
        scrollSpy.scrollHandler(scrollSpyContainer);
      });
      scrollSpy.scrollSpyContainers.push(scrollSpyContainer);
      (0, _passiveEventListeners.addPassiveEventListener)(scrollSpyContainer, 'scroll', eventHandler);
    }
  },
  isMounted: function isMounted(scrollSpyContainer) {
    return scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer) !== -1;
  },
  currentPositionY: function currentPositionY(scrollSpyContainer) {
    if (scrollSpyContainer === document) {
      var supportPageOffset = window.pageXOffset !== undefined;
      var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
      return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
    } else {
      return scrollSpyContainer.scrollTop;
    }
  },
  scrollHandler: function scrollHandler(scrollSpyContainer) {
    var callbacks = scrollSpy.scrollSpyContainers[scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)].spyCallbacks || [];
    callbacks.forEach(function (c) {
      return c(scrollSpy.currentPositionY(scrollSpyContainer));
    });
  },
  addStateHandler: function addStateHandler(handler) {
    scrollSpy.spySetState.push(handler);
  },
  addSpyHandler: function addSpyHandler(handler, scrollSpyContainer) {
    var container = scrollSpy.scrollSpyContainers[scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)];

    if (!container.spyCallbacks) {
      container.spyCallbacks = [];
    }

    container.spyCallbacks.push(handler);

    handler(scrollSpy.currentPositionY(scrollSpyContainer));
  },
  updateStates: function updateStates() {
    scrollSpy.spySetState.forEach(function (s) {
      return s();
    });
  },
  unmount: function unmount(stateHandler, spyHandler) {
    scrollSpy.scrollSpyContainers.forEach(function (c) {
      return c.spyCallbacks && c.spyCallbacks.length && c.spyCallbacks.splice(c.spyCallbacks.indexOf(spyHandler), 1);
    });

    if (scrollSpy.spySetState && scrollSpy.spySetState.length) {
      scrollSpy.spySetState.splice(scrollSpy.spySetState.indexOf(stateHandler), 1);
    }

    document.removeEventListener('scroll', scrollSpy.scrollHandler);
  },


  update: function update() {
    return scrollSpy.scrollSpyContainers.forEach(function (c) {
      return scrollSpy.scrollHandler(c);
    });
  }
};

exports.default = scrollSpy;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Tell the browser that the event listener won't prevent a scroll.
 * Allowing the browser to continue scrolling without having to
 * to wait for the listener to return.
 */
var addPassiveEventListener = exports.addPassiveEventListener = function addPassiveEventListener(target, eventName, listener) {
  var supportsPassiveOption = function () {
    var supportsPassiveOption = false;
    try {
      var opts = Object.defineProperty({}, 'passive', {
        get: function get() {
          supportsPassiveOption = true;
        }
      });
      window.addEventListener('test', null, opts);
    } catch (e) {}
    return supportsPassiveOption;
  }();
  target.addEventListener(eventName, listener, supportsPassiveOption ? { passive: true } : false);
};

var removePassiveEventListener = exports.removePassiveEventListener = function removePassiveEventListener(target, eventName, listener) {
  target.removeEventListener(eventName, listener);
};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var Events = {
	registered: {},
	scrollEvent: {
		register: function register(evtName, callback) {
			Events.registered[evtName] = callback;
		},
		remove: function remove(evtName) {
			Events.registered[evtName] = null;
		}
	}
};

exports.default = Events;

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/*!
 * reactjs-popup v1.5.0
 * (c) 2019-present Youssouf EL AZIZI <youssoufelazizi@gmail.com>
 * Released under the MIT License.
 */


function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

/* Algo to calculate position
  1. center position for popup content : the center of the trigger will be the center of the content content
      so the popup content position will be like this :
      top => the y of the center for the trigger element : trigger.top + trigger.height/2
      left => the x of the center for the trigger element : trigger.left + trigger.width/2

  2. translate position according to the first  position attribute  passed  in the function argument
      for example :
        position = 'left top'
        we need to handle the first argument in the position: 'left' => that's mean we need to translate the popup content according to the X axis by - content.width/2

  3.translate position according to the first  position attribute  passed  in the function argument
    for example :
      position = 'left top'
      the second argument 'top' => translate popup content by + content.height*4/5

  4. check if calculated position is going out of bounds of wrapper box or not. If yes repeat 1-3 for next position enum. By default wrapper box is window element
*/
function getCoordinatesForPosition(triggerBounding, ContentBounding, position, arrow, _ref) {
  var offsetX = _ref.offsetX,
      offsetY = _ref.offsetY;
  var margin = arrow ? 8 : 0;
  var args = position.split(' '); // the step N 1 : center the popup content => ok

  var CenterTop = triggerBounding.top + triggerBounding.height / 2;
  var CenterLeft = triggerBounding.left + triggerBounding.width / 2;
  var height = ContentBounding.height,
      width = ContentBounding.width;
  var top = CenterTop - height / 2;
  var left = CenterLeft - width / 2;
  var transform = '';
  var arrowTop = '0%';
  var arrowLeft = '0%'; // the  step N 2 : => ok

  switch (args[0]) {
    case 'top':
      top -= height / 2 + triggerBounding.height / 2 + margin;
      transform = "rotate(45deg)";
      arrowTop = '100%';
      arrowLeft = '50%';
      break;

    case 'bottom':
      top += height / 2 + triggerBounding.height / 2 + margin;
      transform = "rotate(225deg)";
      arrowLeft = '50%';
      break;

    case 'left':
      left -= width / 2 + triggerBounding.width / 2 + margin;
      transform = " rotate(-45deg)";
      arrowLeft = '100%';
      arrowTop = '50%';
      break;

    case 'right':
      left += width / 2 + triggerBounding.width / 2 + margin;
      transform = "rotate(135deg)";
      arrowTop = '50%';
      break;

    default:
  }

  switch (args[1]) {
    case 'top':
      top = triggerBounding.top;
      arrowTop = "".concat(triggerBounding.height / 2, "px");
      break;

    case 'bottom':
      top = triggerBounding.top - height + triggerBounding.height;
      arrowTop = "".concat(height - triggerBounding.height / 2, "px");
      break;

    case 'left':
      left = triggerBounding.left;
      arrowLeft = "".concat(triggerBounding.width / 2, "px");
      break;

    case 'right':
      left = triggerBounding.left - width + triggerBounding.width;
      arrowLeft = "".concat(width - triggerBounding.width / 2, "px");
      break;

    default:
  }

  top = args[0] === 'top' ? top - offsetY : top + offsetY;
  left = args[0] === 'left' ? left - offsetX : left + offsetX;
  return {
    top: top,
    left: left,
    transform: transform,
    arrowLeft: arrowLeft,
    arrowTop: arrowTop
  };
}

function calculatePosition(triggerBounding, ContentBounding, positions, arrow, _ref2, wrapperBox) {
  var offsetX = _ref2.offsetX,
      offsetY = _ref2.offsetY;
  var bestCoords;
  var i = 0;

  while (i < positions.length) {
    bestCoords = getCoordinatesForPosition(triggerBounding, ContentBounding, positions[i], arrow, {
      offsetX: offsetX,
      offsetY: offsetY
    });
    var contentBox = {
      top: bestCoords.top,
      left: bestCoords.left,
      width: ContentBounding.width,
      height: ContentBounding.height
    };

    if (contentBox.top <= wrapperBox.top || contentBox.left <= wrapperBox.left || contentBox.top + contentBox.height >= wrapperBox.top + wrapperBox.height || contentBox.left + contentBox.width >= wrapperBox.left + wrapperBox.width) {
      i++;
    } else {
      break;
    }
  }

  return bestCoords;
}

var styles = {
  popupContent: {
    tooltip: {
      position: 'absolute',
      zIndex: '2',
      width: '200px',
      background: "rgb(255, 255, 255)",
      border: "1px solid rgb(187, 187, 187)",
      boxShadow: "rgba(0, 0, 0, 0.2) 0px 1px 3px",
      padding: '5px'
    },
    modal: {
      position: 'relative',
      background: "rgb(255, 255, 255)",
      width: '50%',
      margin: 'auto',
      border: "1px solid rgb(187, 187, 187)",
      padding: '5px'
    }
  },
  popupArrow: {
    height: '10px',
    width: '10px',
    position: 'absolute',
    background: 'rgb(255, 255, 255)',
    transform: 'rotate(45deg)',
    margin: '-5px',
    zIndex: '-1',
    boxShadow: 'rgba(0, 0, 0, 0.2) 1px 1px 1px'
  },
  overlay: {
    tooltip: {
      position: 'fixed',
      top: '0',
      bottom: '0',
      left: '0',
      right: '0'
    },
    modal: {
      position: 'fixed',
      top: '0',
      bottom: '0',
      left: '0',
      right: '0',
      background: "rgba(0, 0, 0,0.5)",
      display: 'flex',
      zIndex: '999'
    }
  }
};

var POSITION_TYPES = ['top left', 'top center', 'top right', 'right top', 'right center', 'right bottom', 'bottom left', 'bottom center', 'bottom right', 'left top', 'left center', 'left bottom', 'center center'];

var Popup =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Popup, _React$PureComponent);

  function Popup(props) {
    var _this;

    _classCallCheck(this, Popup);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Popup).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "repositionOnResize", function () {
      _this.setPosition();
    });

    _defineProperty(_assertThisInitialized(_this), "onEscape", function (e) {
      if (e.key === 'Escape') _this.closePopup();
    });

    _defineProperty(_assertThisInitialized(_this), "lockScroll", function () {
      var lockScroll = _this.props.lockScroll;
      var modal = _this.state.modal;
      if (modal && lockScroll)
        /* eslint-disable-next-line no-undef */
        document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    });

    _defineProperty(_assertThisInitialized(_this), "resetScroll", function () {
      var lockScroll = _this.props.lockScroll;
      var modal = _this.state.modal;
      if (modal && lockScroll)
        /* eslint-disable-next-line no-undef */
        document.getElementsByTagName('body')[0].style.overflow = 'auto';
    });

    _defineProperty(_assertThisInitialized(_this), "togglePopup", function (e) {
      // https://reactjs.org/docs/events.html#event-pooling
      e.persist();
      if (_this.state.isOpen) _this.closePopup(e);else _this.openPopup(e);
    });

    _defineProperty(_assertThisInitialized(_this), "openPopup", function (e) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onOpen = _this$props.onOpen;
      var isOpen = _this.state.isOpen;
      if (isOpen || disabled) return;
      onOpen(e);

      _this.setState({
        isOpen: true
      }, function () {
        _this.setPosition();

        _this.lockScroll();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closePopup", function (e) {
      var onClose = _this.props.onClose;
      var isOpen = _this.state.isOpen;
      if (!isOpen) return;
      onClose(e);

      _this.setState({
        isOpen: false
      }, function () {
        _this.resetScroll();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseEnter", function () {
      clearTimeout(_this.timeOut);
      var mouseEnterDelay = _this.props.mouseEnterDelay;
      _this.timeOut = setTimeout(function () {
        return _this.openPopup();
      }, mouseEnterDelay);
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function () {
      clearTimeout(_this.timeOut);
      var mouseLeaveDelay = _this.props.mouseLeaveDelay;
      _this.timeOut = setTimeout(function () {
        return _this.closePopup();
      }, mouseLeaveDelay);
    });

    _defineProperty(_assertThisInitialized(_this), "getTooltipBoundary", function () {
      var keepTooltipInside = _this.props.keepTooltipInside;
      var boundingBox = {
        top: 0,
        left: 0,

        /* eslint-disable-next-line no-undef */
        width: window.innerWidth,

        /* eslint-disable-next-line no-undef */
        height: window.innerHeight
      };

      if (typeof keepTooltipInside === 'string') {
        /* eslint-disable-next-line no-undef */
        var selector = document.querySelector(keepTooltipInside);

        if (false) {
          if (selector === null) throw new Error("".concat(keepTooltipInside, " selector is not exist : keepTooltipInside must be a valid html selector 'class' or 'Id'  or a boolean value"));
        }

        boundingBox = selector.getBoundingClientRect();
      }

      return boundingBox;
    });

    _defineProperty(_assertThisInitialized(_this), "setPosition", function () {
      var _this$state = _this.state,
          modal = _this$state.modal,
          isOpen = _this$state.isOpen;
      if (modal || !isOpen) return;
      var _this$props2 = _this.props,
          arrow = _this$props2.arrow,
          position = _this$props2.position,
          offsetX = _this$props2.offsetX,
          offsetY = _this$props2.offsetY,
          keepTooltipInside = _this$props2.keepTooltipInside,
          arrowStyle = _this$props2.arrowStyle,
          className = _this$props2.className;

      var helper = _this.HelperEl.getBoundingClientRect();

      var trigger = _this.TriggerEl.getBoundingClientRect();

      var content = _this.ContentEl.getBoundingClientRect();

      var boundingBox = _this.getTooltipBoundary();

      var positions = Array.isArray(position) ? position : [position]; // keepTooltipInside would be activated if the  keepTooltipInside exist or the position is Array

      if (keepTooltipInside || Array.isArray(position)) positions = [].concat(_toConsumableArray(positions), POSITION_TYPES);
      var cords = calculatePosition(trigger, content, positions, arrow, {
        offsetX: offsetX,
        offsetY: offsetY
      }, boundingBox);
      _this.ContentEl.style.top = "".concat(cords.top - helper.top, "px");
      _this.ContentEl.style.left = "".concat(cords.left - helper.left, "px");

      if (arrow) {
        _this.ArrowEl.style.transform = cords.transform;
        _this.ArrowEl.style['-ms-transform'] = cords.transform;
        _this.ArrowEl.style['-webkit-transform'] = cords.transform;
        _this.ArrowEl.style.top = arrowStyle.top || cords.arrowTop;
        _this.ArrowEl.style.left = arrowStyle.left || cords.arrowLeft;

        _this.ArrowEl.classList.add("popup-arrow");

        if (className !== '') {
          _this.ArrowEl.classList.add("".concat(className, "-arrow"));
        }
      }

      if (
      /* eslint-disable-next-line no-undef */
      window.getComputedStyle(_this.TriggerEl, null).getPropertyValue('position') === 'static' ||
      /* eslint-disable-next-line no-undef */
      window.getComputedStyle(_this.TriggerEl, null).getPropertyValue('position') === '') _this.TriggerEl.style.position = 'relative';
    });

    _defineProperty(_assertThisInitialized(_this), "addWarperAction", function () {
      var _this$props3 = _this.props,
          contentStyle = _this$props3.contentStyle,
          className = _this$props3.className,
          on = _this$props3.on;
      var modal = _this.state.modal;
      var popupContentStyle = modal ? styles.popupContent.modal : styles.popupContent.tooltip;
      var childrenElementProps = {
        className: "popup-content ".concat(className !== '' ? "".concat(className, "-content") : ''),
        style: Object.assign({}, popupContentStyle, contentStyle),
        ref: _this.setContentRef,
        onClick: function onClick(e) {
          e.stopPropagation();
        }
      };

      if (!modal && on.indexOf('hover') >= 0) {
        childrenElementProps.onMouseEnter = _this.onMouseEnter;
        childrenElementProps.onMouseLeave = _this.onMouseLeave;
      }

      return childrenElementProps;
    });

    _defineProperty(_assertThisInitialized(_this), "renderTrigger", function () {
      var triggerProps = {
        key: 'T',
        ref: _this.setTriggerRef
      };
      var _this$props4 = _this.props,
          on = _this$props4.on,
          trigger = _this$props4.trigger;
      var isOpen = _this.state.isOpen;
      var onAsArray = Array.isArray(on) ? on : [on];

      for (var i = 0, len = onAsArray.length; i < len; i++) {
        switch (onAsArray[i]) {
          case 'click':
            triggerProps.onClick = _this.togglePopup;
            break;

          case 'hover':
            triggerProps.onMouseEnter = _this.onMouseEnter;
            triggerProps.onMouseLeave = _this.onMouseLeave;
            break;

          case 'focus':
            triggerProps.onFocus = _this.onMouseEnter;
            break;

          default:
        }
      }

      if (typeof trigger === 'function') return !!trigger && __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(trigger(isOpen), triggerProps);
      return !!trigger && __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(trigger, triggerProps);
    });

    _defineProperty(_assertThisInitialized(_this), "renderContent", function () {
      var _this$props5 = _this.props,
          arrow = _this$props5.arrow,
          arrowStyle = _this$props5.arrowStyle,
          children = _this$props5.children;
      var _this$state2 = _this.state,
          modal = _this$state2.modal,
          isOpen = _this$state2.isOpen;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({}, _this.addWarperAction(), {
        key: "C"
      }), arrow && !modal && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        ref: _this.setArrowRef,
        style: Object.assign({}, styles.popupArrow, arrowStyle)
      }), typeof children === 'function' ? children(_this.closePopup, isOpen) : children);
    });

    _this.setTriggerRef = function (r) {
      return _this.TriggerEl = r;
    };

    _this.setContentRef = function (r) {
      return _this.ContentEl = r;
    };

    _this.setArrowRef = function (r) {
      return _this.ArrowEl = r;
    };

    _this.setHelperRef = function (r) {
      return _this.HelperEl = r;
    };

    _this.timeOut = 0;
    var open = props.open,
        _modal = props.modal,
        defaultOpen = props.defaultOpen,
        _trigger = props.trigger;
    _this.state = {
      isOpen: open || defaultOpen,
      modal: _modal ? true : !_trigger // we create this modal state because the popup can't be a tooltip if the trigger prop doesn't exist

    };
    return _this;
  }

  _createClass(Popup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props6 = this.props,
          closeOnEscape = _this$props6.closeOnEscape,
          defaultOpen = _this$props6.defaultOpen,
          repositionOnResize = _this$props6.repositionOnResize;
      if (defaultOpen) this.setPosition();

      if (closeOnEscape) {
        /* eslint-disable-next-line no-undef */
        window.addEventListener('keyup', this.onEscape);
      }

      if (repositionOnResize) {
        /* eslint-disable-next-line no-undef */
        window.addEventListener('resize', this.repositionOnResize);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props7 = this.props,
          open = _this$props7.open,
          disabled = _this$props7.disabled;
      var isOpen = this.state.isOpen;

      if (prevProps.open !== open) {
        if (open) this.openPopup();else this.closePopup(undefined, true);
      }

      if (prevProps.disabled !== disabled && disabled && isOpen) {
        this.closePopup();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // kill any function to execute if the component is unmounted
      clearTimeout(this.timeOut);
      var _this$props8 = this.props,
          closeOnEscape = _this$props8.closeOnEscape,
          repositionOnResize = _this$props8.repositionOnResize; // remove events listeners

      if (closeOnEscape) {
        /* eslint-disable-next-line no-undef */
        window.removeEventListener('keyup', this.onEscape);
      }

      if (repositionOnResize) {
        /* eslint-disable-next-line no-undef */
        window.removeEventListener('resize', this.repositionOnResize);
      }

      this.resetScroll();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props9 = this.props,
          overlayStyle = _this$props9.overlayStyle,
          closeOnDocumentClick = _this$props9.closeOnDocumentClick,
          className = _this$props9.className,
          on = _this$props9.on,
          trigger = _this$props9.trigger;
      var _this$state3 = this.state,
          modal = _this$state3.modal,
          isOpen = _this$state3.isOpen;
      var overlay = isOpen && !(on.indexOf('hover') >= 0);
      var ovStyle = modal ? styles.overlay.modal : styles.overlay.tooltip;
      return [this.renderTrigger(), isOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        key: "H",
        style: {
          position: 'absolute',
          top: '0px',
          left: '0px'
        },
        ref: this.setHelperRef
      }), overlay && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        key: "O",
        className: "popup-overlay ".concat(className !== '' ? "".concat(className, "-overlay") : ''),
        style: Object.assign({}, ovStyle, overlayStyle),
        onClick: closeOnDocumentClick ? this.closePopup : undefined
      }, modal && this.renderContent()), isOpen && !modal && this.renderContent()];
    }
  }]);

  return Popup;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

_defineProperty(Popup, "defaultProps", {
  trigger: null,
  onOpen: function onOpen() {},
  onClose: function onClose() {},
  defaultOpen: false,
  open: false,
  disabled: false,
  closeOnDocumentClick: true,
  repositionOnResize: true,
  closeOnEscape: true,
  on: ['click'],
  contentStyle: {},
  arrowStyle: {},
  overlayStyle: {},
  className: '',
  position: 'bottom center',
  modal: false,
  lockScroll: false,
  arrow: true,
  offsetX: 0,
  offsetY: 0,
  mouseEnterDelay: 100,
  mouseLeaveDelay: 100,
  keepTooltipInside: false
});

if (false) {
  var PropTypes = require('prop-types');

  var TRIGGER_TYPES = ['hover', 'click', 'focus'];
  Popup.propTypes = {
    arrowStyle: PropTypes.object,
    contentStyle: PropTypes.object,
    overlayStyle: PropTypes.object,
    className: PropTypes.string,
    modal: PropTypes.bool,
    arrow: PropTypes.bool,
    closeOnDocumentClick: PropTypes.bool,
    repositionOnResize: PropTypes.bool,
    disabled: PropTypes.bool,
    closeOnEscape: PropTypes.bool,
    lockScroll: PropTypes.bool,
    offsetX: PropTypes.number,
    offsetY: PropTypes.number,
    mouseEnterDelay: PropTypes.number,
    mouseLeaveDelay: PropTypes.number,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    open: PropTypes.bool,
    defaultOpen: PropTypes.bool,
    trigger: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
    // for uncontrolled component we don't need the trigger Element
    on: PropTypes.oneOfType([PropTypes.oneOf(TRIGGER_TYPES), PropTypes.arrayOf(PropTypes.oneOf(TRIGGER_TYPES))]),
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.element, PropTypes.string]).isRequired,
    position: PropTypes.oneOfType([PropTypes.oneOf(POSITION_TYPES), PropTypes.arrayOf(PropTypes.oneOf(POSITION_TYPES))]),
    keepTooltipInside: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Popup);


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(196);

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(8);
var normalizeHeaderName = __webpack_require__(199);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(101);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(101);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)))

/***/ }),
/* 61 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShowsPostsData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return newPostdata; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utility_Utility__ = __webpack_require__(1);
// start live shows
// export const ShowsPostsData = [
// 	{
// 		id:1,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Tom Jones \n Tel Aviv ",
//         smltitle: "The one and only Tom Jones returns to Tel Aviv for one live performance",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											28.06.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.tomjones.com/">
// 												www.tomjones.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 						<div class="img-wrapper">
// 							<img src=${getImgUrl() +  "/Concerts/1/1.jpg"} class="img-responsive" />
// 						</div>
// 						<p>
// 							At the request of the audience and after the success of his sold-out show in 2013, the legendary performer Tom Jones returns to Israel for one live performance, to be held in Tel Aviv on Wednesday, June 28, 2017.
// 						</p>
// 						<p>
// 							Tom Jones, a world-famous living legend, is known for not allowing the diverse audience that fills his halls to sit quietly for a moment. He is a performer who captures the hearts of men and women of all ages, crosses generations and genres with his infinite inherent talent and his powerful and unique voice.
// 						</p>
// 						<p>
// 							Tom Jones has had an amazing stage career and sold over 100 million records. He has been awarded many titles including the Brit Awards for his immense musical contribution and Lifetime Achievement Award for his many achievements in the world of music and live performances at the Silver Clef (annual British Music Awards). For his contribution to the music industry, he won a star on the Hollywood Walk of Fame. In 1999, Tom Jones was awarded the Order of the British Empire (OBE) and in 2006 His Royal Highness Queen Elizabeth gave him the title of nobility and he became Sir Tom Jones.
// 						</p>
// 						<p>
// 							Jones, recognized across the world as a "hit machine", will be hitting the 24/7 city this June for the second time. As he did in his last sold out show in Tel Aviv to the delight of his audience, will be performing his all-time greatest hits.
// 						</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:2,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Britney Spears \n  Live in Concert",
//         smltitle: "Britney Spears- performing all her greatest hits in the fabulous city of Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											03.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.britneyspears.com">
// 												www.britneyspears.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 						<div class="img-wrapper">
// 							<img src=${getImgUrl() +  "/Concerts/2/1.jpg"} class="img-responsive" />
// 						</div>
// 						<p>
// 							Pop Icon Britney Spears is coming to Tel Aviv for the first time ever, for one show only, as part of her international tour of Asia. The show will take place in stunning Ha’Yarkon Park in central Tel Aviv and will include the Pop Princesses’ greatest hits.
// 						</p>
// 						<p>
// 							Pop Icon Britney Spears will be coming to Israel for the first time ever for one show only as part of her international tour of Asia. The show will take place in Ha’Yarkon Park in central Tel Aviv and will include the Pop Princesses’ greatest hits.
// 						</p>
// 						<p>
// 							Multi-platinum, Grammy Award-winning pop icon Britney Spears was born in Mississippi and raised in Louisiana, Spears became a household name as a teenager when she released her first single “…Baby One More Time,” a Billboard Hot 100 No. 1 smash and international hit that broke sales records with more than 20 million copies sold worldwide and is currently 14x Platinum in the U.S.
// 						</p>
// 						<p>
// 							Spears is one of the most successful and celebrated entertainers in pop history with nearly 150 million records worldwide. In the U.S. alone, she has sold more than 70 million albums, singles and songs, according to Nielsen Music.
// 						</p>
// 						<p>
// 							Britney’s live concerts are renowned for their amazing production and nonstop energy. Her first ever show in Tel Aviv is likely to feature some of her most recent songs from her Glory Album, including massive 2016 hit ‘Slumber Party’, and also some of her massive all-time hits such as ‘Baby One More Time’ and ‘Oops I Did It Again’!
// 						</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:3,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Tears for Fears",
//         smltitle: "Tear for Fears in Tel Aviv for the first time ever!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											05.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.tearsforfears.com">
// 												www.tearsforfears.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 						<p>
// 							This summer, the trendy city of Tel Aviv is embracing it’s 80s vibe for one performance only by the incomparable Tears for Fears. The legendary British pop/rock band that is responsible for many unforgettable hits is coming to the rocking city of Tel Aviv for a single awesome performance!
// 						</p>
// 						<p>
// 							Originally from Bath, Avon, Tears for Fears was founded in 1981 and was associated at first with the new wave synthesizer bands but later on became a part of mainstream rock and pop and hit international success. During the 80's the band released 3 albums that were a combination of pop, new wave and rock. Their first album from 1983, "The Hurting", reached number one in the UK albums chart and was a platinum-selling album. It included major hits such as "Pale Shelter", "Change", and "Mad World". Their second album, "Songs from the Big Chair", followed the same path and reached number one on the US Billboard 200, getting multi-platinum status in the UK and the US. It contained unforgettable hits such as "Shout", "Head Over Heels" and "Everybody Wants to Rule the World" which won the Brit Award for best British single in 1986. Their third successful album "The Seeds of Love" that came out in 1989 included the epic songs "The Seeds of Love", "Sowing Woman in Chains" and many more.
// 						</p>
// 						<p>
// 							In the early 90's, Curt Smith left the band and Roland Orzabal kept releasing more albums under the name of the band. In 2004 the two went back to working together under the name "Tears for Fears" and released the album "Everybody Loves Happy Ending". Since then, the band has been touring around the world to the delight of their fans
// 						</p>
// 						<p>
// 						Tears for Fears’ albums and singles were sold in tens of millions of copies and their songs were covered by other artists countless times. Last year the band announced they are working on a new album to be released during 2017. This July they will be gracing the nonstop city of Tel Aviv for the first time with a single performance, guaranteed to be a night to remember.
// 						</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:4,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: " Guns N' Roses  \"Not in this Lifetime\"",
//         smltitle: "Legendary Guns N' Roses is Coming Back to Rock Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											15.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.gunsnroses.com">
// 											www.gunsnroses.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/4/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								After their celebrated reunion tour last summer, which became the most profitable musical rock concert in 2016, Guns N' Roses, one of the world's most important and beloved rock bands, is coming to Tel Aviv as part of its successful tour with has already added more than 30 shows in the US and Europe.
// 							</p>
// 							<p>
// 								The concert in Tel Aviv will take place on Saturday, July 15 and, 17 at the Yarkon Park, and will close the European tour.
// 							</p>
// 							<p>
// 								Twenty-three years after standing together on the stage in Tel Aviv for the first time, the three original members of the ensemble will come back again: vocalist Axel Rose, guitarist Slash and bassist Duff McGinn, along with an impressive ensemble of musicians including drummer Frank Ferrer, keyboardist Dizzy Red (who was an integral part of the band in the 1990s) Guitarist Richard Fortus and keyboardist Melissa Reyes.
// 							</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/4/2.jpg"} class="img-responsive" />
// 							</div>
// 							<h3>
// 							"Not in this Lifetime"
// 							</h3>
// 							<p>
// 							Since their first reunion concert at Cochlea Festival last April, the band's tour has become one of the most sought-after shows in America with more than 2 million tickets sold.
// 							</p>
// 							<p>
// 								The success and numbers of the current tour show more than anything else that the audience's love of the band's music and rock music is more relevant and bigger than ever. The historic tour last summer visited 21 cities (25 performances) in North America.
// 							</p>
// 							<p>
// 								The band has recently completed a successful tour in South America, Brazil, Argentina and Mexico. All of band's new tour dates are completely sold out, generating massive interest among audiences. In January, the band will continue to Japan and from there to Australia, Thailand, Singapore, Dubai and will arrive in the “nonstop city” of Tel Aviv in July.
// 							</p>
// 						`
// 			}
// 		}
// 	},
// 	{
//         id:5,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: " RADIOHEAD  \n Tel Aviv",
//         smltitle: "The trailblazing RADIOHEAD bringing their iconic repertoire to Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											19.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.radiohead.com">
// 											www.radiohead.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/5/1.jpeg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Preforming in Tel Aviv for the second time ever, Radiohead has managed to remain innovative, relevant and especially moving since first visiting here 17 years ago . It is a band blessed with superhuman ability to meld together distant musical influences to create a new identity for themselves and their listeners; A band whose compulsive tendency to experiment with groundbreaking sound echoed the impact of entire generations of artists and shattered it to the walls of superfluous genres; A band that changed the way we listen to music, make music, see music, think music and even buy music. Now, 17 years after they last visited here, Radiohead is coming to a concert in Tel Aviv.
// 							</p>
// 							<p>
// 								Watching Radiohead's show, it becomes clear that first and foremost, they are the authors and performers of a huge amount of unforgettable songs. Their repertoire manages to be on the one hand familiar, classical - most of us know it by heart - and on the other hand revolutionary, developing and surprising. The tight performance of the ensemble, along with the unique energy of the soloist, Tom York, transforms each performance into a one-time live experience that attracts huge audiences, to participate in the celebration of artistic evolution, to see how they grew, evolved and reinvented themselves time and time again.
// 							</p>
// 							<p>
// 								Today's Radiohead is a band with a more contemporary presence than ever before, with a glorious past and a variety that transcends all cataloging: a band that began with the Immortal Grange anthem of Creep; Slapped critics over the head with the alternative masterpiece The Bends and then committed commercial suicide - and reached heaven - twice! - with two of the best albums of all time, OK Computer and Kid A.
// 							</p>
// 							<p>
// 								The new generations who discover Radiohead through their new works - In Rainbows a favorite in Israel or the new and acclaimed album A Moon Shaped Pool - discover a band whose influences have permeated every musical genre today: rock, electronic, world, hip hop. Today's Radiohead is more than just another band, it is a world - with a unique visual language, exceptional imagery, an unreplaceable atmosphere and inner humor. Especially in Israel - a country that has always enjoyed an intimate and warm relationship with the band - Radiohead's performance is a cultural experience of the rarest kind.
// 							</p>
// 							<p>
// 							This concert will not have assigned seats, Golden Ring, VIP, unfair prices or any other division of class. Anyone who wants to sit is welcome to bring a blanket, and anyone who wants to stand close to the stage is welcome to arrive early, the ticket price is equal to all, and as many people as possible will be able to enjoy this momentous musical event.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:6,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "The Pixies",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											25-26.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.pixiesmusic.com">
// 											www.pixiesmusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<p>
// 								The Israeli summer is always hot, but the Pixies are returning to Tel Aviv after 3 years to make it even hotter!
// 							</p>
// 							<p>
// 								The famous rock band was founded in 1986 in Boston and released its first EP "Come on Pilgrim" in 1987. A year later, when their first album "Surfer Rose" came out, they became a unique voice in the American Rock. 2 years later, they released their second album "Doolittle" that is considered one of the best rock albums of all times. Their third album "Bossanova" came out in 1990 and included unforgettable songs such as "Hang Wire", "Stormy Weather", and "All Over the World".
// 							</p>
// 							<p>
// 							A year later they released their fourth album "Trompe le Monde" that featured songs such as "Planet of Sound", "Distance Equals Rate Times Time" and many more. They fell apart in 1993 but went back to performing together in 2004. After a decade of touring the world, they released their fifth album "Indie Cindy" which included songs like "Another Toe in The Ocean", "Blue Eyed Hexe", and "Jaime Bravo". To this date they released six albums, the last one, "Head Carrier" came out last year. Their biggest hits include "Hey", "Where Is My Mind", "Monkey Gone to Heaven" and "Here Comes Your Man".
// 							</p>
// 							<p>
// 								The band that is known to influence artists such as PJ Harvey and Kurt Kobain will perform this summer in Tel Aviv, giving only 7000 lucky fans the opportunity to see them live and after the rave reviews of their 2014 performance, it’s shaping up to be an unmissable night!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:7,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Regina Spektor – Back in Israel",
//         smltitle: "Regina Spektor – Back in Israel",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											19.08.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.reginaspektor.com">
// 											www.reginaspektor.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<p>
// 								Beloved pianist, songwriter and singer Regina Spektor is coming back to Tel Aviv for the third time, closing the worldwide tour of her recent 2016 album “Remember Us to Life” that has gotten excellent reviews.
// 							</p>
// 							<p>
// 								Regina Spektor, whose past concerts in Israel were sold out in 2007 and 2013, will perform again for one time only in Ra’anana Amphitheater on Saturday, August 19.
// 							</p>
// 							<p>
// 								Grammy and VMA nominee Regina Spektor was born in Russia, where she started her classical music training at the age of six and immigrated shortly after to the New York, where she began writing her own original songs. Her first Album came out in 2001 and a year later she already released her second album, “songs”, but her real success started after her third album, Soviet Kitsch, was out in 2004 and the fans started pouring in.
// 							</p>
// 							<p>
// 								Her international breakthrough came in 2006 with her album “Begin to Hope” that reached gold status and sold more than 500,000 copies (!!!). The album includes the single “Fidelity” that is very popular in Israel and in the rest of the world to this day and was used as part of the soundtrack of TV shows such as “Grey’s Anatomy”. Her success only became stronger when her fifth album “Far” and her sixth album “What We Saw From The Cheap Seats” got to the third place in Billboard's album chart.
// 							</p>
// 							<p>
// 								In 2013 Spektor created the theme song of the successful Netflix series “Orange Is the New Black”, called “You’ve Got Time” that also became a radio hit and got her her first Grammy Award nomination. The following year, she sang “Love Me or Leave Me” for the HBO historical crime series “Boardwalk Empire”.
// 							</p>
// 							<p>
// 								Regina Spektor is coming to the non-stop city of Tel Aviv after her sold-out tour in the United States and her old and new fans can’t wait for her show, guaranteed to light up the beautiful summer night of Tel Aviv with it’s amazing infectious energy.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:8,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Nick Cave & The Bad Seeds",
//         smltitle: "Rock legend Nick Cave & The Bad Seeds returning to Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											19-20.11.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.nick-cave.com">
// 											www.nick-cave.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<p>
// 								19 years after his last performance in Tel Aviv, the prince of darkness returns once again with his band The Bad Seeds for two shows only to the joy of his fans in what are set to be intimate and unique performances.
// 							</p>
// 							<p>
// 								Australian musician, singer-songwriter, author, screenwriter, composer and film actor Nick Cave is well known as rock musics' "Prince of Darkness" because of his dark, intense tunes. His music is known to be emotionally intense and is characterized by a variety of influences such as death, religion, love and violence. He was called by NME "the grand lord of gothic lushness".
// 							</p>
// 							<p>
// 							In the early 90's, Curt Smith left the band and Roland Orzabal kept releasing more albums under the name of the band. In 2004 the two went back to working together under the name "Tears for Fears" and released the album "Everybody Loves Happy Ending". Since then, the band has been touring around the world to the delight of their fans.
// 							</p>
// 							<p>
// 								Cave started his musical path in the 1970's when he formed "the Boys Next Door" which became a huge success in Melbourne's post-punk scene. Their name was changed to "the Birthday Party" and the band's sound and shows took a rather violent direction and they became known as one of the darkest groups of the 1980's, they fell apart in 1983
// 							</p>
// 							<p>
// 								The end of the Birthday Party was the beginning of Nick Cave and the Bad Seeds in 1983 and they released their debut album the following year. In 1996 the band released its album "Murder Ballads" which featured "Where the Wild Roses Grow", a duet with Kylie Minogue that is also Cave's biggest commercial success to date.
// 							</p>
// 							<p>
// 								Many artists have covered Cave's songs over the years, including Metallica, Johnny Cash, and even the Arctic Monkeys.
// 							</p>
// 							<p>
// 								Nick Cave & The Bad Seeds will perform at the Menora Arena in Tel Aviv on November 19 and an additional date has been added on November 20 due to high demand. For the mere 7,000 fans who will get the chance to look the legendary Nick Cave in the eyes, this is guaranteed to be an unforgettable show!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:9,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Justin Bieber",
//         smltitle: "Justin Bieber, is landing in Tel Aviv for a single breathtaking concert",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											03.05.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.justinbiebermusic.com">
// 											www.justinbiebermusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/9/1.png"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The artist with the most followers on Twitter 90,149,014
// 								The artist with the most watched official music channel online 13,518,849,954
// 								The artist with the most mentions on Youtube music channel
// 							</p>
// 							<p>
// 							Justin Bieber, the biggest international star of our day, arrives in Israel for just one concert as part of the PURPOSE WORLD TOUR, a tour bearing the name of his last album, which has sold 640,000 copies in just a week and became his bestselling album.
// 							</p>
// 							<p>
// 								Bieber, born in Ontario, Canada, learned to play piano, guitar and drums as a child. At the age of 13, with the help of his mother, he began posting videos on YouTube where he sang covers to artists such as Asher, Stevie Wonder, Chris Brown and others.
// 							</p>
// 							<p>
// 								Scooter Browne, a former marketing director at “So So Def”, was the first to spot Bieber’s talent and invited him and his mother to recordings in Atlanta.
// 							</p>
// 							<p>
// 								In 2008, Bieber was signed by Universal Records, and in 2009, "My World", the first mini-album by Bieber, including "One Time Lonely", "Love Me" and "Favorite Girl" topped the Canadian Billboard charts and the top 40 Billboard Hot 100 hits
// 							</p>
// 							<p>
// 								In 2010, he released his second album, "My World 2.0" with the single "Baby", which became a huge hit and was accompanied by the most watched YouTube video by November 24, 2012.
// 							</p>
// 							<p>
// 								In October 2015, Bieber released the second single from the album "Sorry". The dance clip for the song accumulated over 10 million views in the first 24 hours since its release.
// 							</p>
// 							<p>
// 								In November 2015 he released his fourth album "Purpose", which sold 640,000 copies in the first week and became Bieber’s best-selling album with hits such as "Love Yourself." That same month Bieber made history by placing 17 songs on the American charts and breaking the record held by the Beatles since 1964.
// 							</p>
// 							<p>
// 								In December 2015, Bieber and Skrillex won the Grammy Award for "Where are You Now".
// 							</p>
// 							<p>
// 								Justin Bieber will be performing in Israel on May 3 at Hayarkon Park, with his latest hits "love yourself" and "Sorry" and with the hits "Baby" and "As long as you love me".
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:10,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "AEROSMITH \n \"AERO-VEDERCI BABY\" ",
//         smltitle: " Aerosmith launching its tour in the rocking city of Tel Aviv  ",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											28.06.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.aerosmith.com">
// 											www.aerosmith.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/10/1.png"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Aerosmith’s farewell concerts began several months ago in South America and will continue in 2017 in the United States and Europe. the European leg of the tour will begin in Tel Aviv and the band will go on to perform in Georgia, Russia, Germany, Poland, Denmark, Ireland, Italy, Portugal and Spain, including appearances in some of the world's leading rock festivals.
// 							</p>
// 							<p>
// 								For over 45 years, Aerosmith has been the quintessential Rock & Roll band, becoming one of the most influential and loved groups in the world. An endless list of amazing songs, many of them becoming massive worldwide hits, and their groundbreaking live shows have gained the band mass appeal for nearly half a century. Rock & Roll Hall of Fame inductees, Aerosmith, have sold over 100 million albums and won countless awards (including four Grammy Awards, eight American Music Awards, six Billboard Awards, and 12 MTV Awards).
// 							</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/10/2.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								<strong>Steven Tyler</strong> – "Aerosmith just got done ripping through South America like true ambassadors of rock...The band is unstoppable right now and in Europe, we're going to keep doing what we do best... Let The Music Do The Talking...Living On The Edge, and living to rock another day."
// 							</p>
// 							<p>
// 								<strong>Joe Perry </strong> – “It’s been 3 years since we have been on tour in Europe and I can speak for my brothers that we can’t wait to get over there and take it up a few notches. Last tour in South America we were running on all cylinders and I can see no reason to let up now." ;
// 							</p>
// 							<p>
// 							This May, the city of Tel Aviv will be hosting Steven Tyler, Joe Perry, Joey Kramer, Tom Hamilton and Brad Whitford in the beautiful Ganei Yehoshua Park for what promises to be an unforgettable experience and the concert of a lifetime.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:11,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Frankie Valli & The Four Seasons  ",
//         smltitle: " An American Legend in the heart of Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											4.007.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.frankievallifourseasons.com/">
// 											www.frankievallifourseasons.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/11/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The American legend comes to the rocking city of Tel Aviv for the first time ever for an unforgettable 4th of July celebration with the best timeless classics!
// 							</p>
// 							<p>
// 								The original Jersey boy, musical legend Frankie Valli, comes Tel Aviv for the first time for one single performance. Back in the 50’s, Valli started singing in harmonies with different bands in New Jersey, but the success only struck him when he grabbed the microphone in the early 60’s as the lead singer for The Four Seasons that rocked the music world in the next decades with major hits such as “Big Girls Don’t Cry”, “Sherry”, “Walk Like a Man” and more. Valli scored 29 Top 40 hits with The Four Seasons and nine Top 40 hits as a solo artist. The band sold more than 175 million albums and Valli, Tommy DeVito, Nick Massi and Bob Gaudio – the original members of The Four Seasons – were inducted into the Rock and Roll Hall of Fame in 1990 and the Vocal Group Hall of Fame in 1999.
// 							</p>
// 							<p>
// 								At the same time, Valli also has a successful solo career with songs such as the theme song for Grease, and “Can’t Take My Eyes Off You” that was covered by hundreds of artists, from The Pet Shop Boys to Muse. Younger generations got to know Valli from the remarkable musical “Jersey Boys” that tell the story of the band that is responsible for songs that became a part of our life’s soundtrack for over four decades and was turned into a movie which was directed by Clint Eastwood.
// 							</p>
// 							<p>
// 								Ever since he began, Frankie has been performing all over the world, and soon the magic will come to Tel Aviv for one unforgettable show.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:12,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Unite With Tomorrowland",
//         smltitle: "The world’s number one leading EDM festival is coming to Tel Aviv! ",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											29.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.tomorrowland.com/en/unite-israel/en/welcome">
// 											www.tomorrowland.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/12/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The famous Tomorrowland festival might take place in Belgium, but Tel Aviv is also up for the party! Unite with Tomorrowland brings the party to the hottest city in the Middle East with live connection from the Tomorrowland Mainstage, live local and international DJ’s on the UNITE stage and of course – the magical Tomorrowland atmosphere.
// 							</p>
// 							<p>
// 								The live connection with the Mainstage in Belgium will give the People of Tomorrow the chance to connect with the crowd in Israel and vice versa. 3 mainstage headliners will be broadcasted live on a unique UNITE with Tomorrowland stage and special effects will be synchronized with the show in Belgium, creating a special global connection.
// 							</p>
// 							<p>
// 								The main headliners in Belgium will be Armin Van Buuren who has won best trance DJ at the DJ Awards 9 years in a row, was ranked among the world’s top 4 DJ’s at DJ Magazine 13 years in a row, the known electro-house duo Dimitri Vegas & Like Mike and the house sensation KSHMR. On the UNITE stage in Israel the DJs will be Steve Angello who won the DJ award for best house in 2010, the Israeli trance artist Alien Project, DJ Tomer Maizner, Dor Dekel, Teamworx, and TRIPL.
// 							</p>
// 							<p>
// 								EUnite with Tomorrowland isn’t just a livestream, it’s a one of a kind show that allows you to escape reality and join the magical world of tomorrow.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:13,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "The Chainsmokers",
//         smltitle: "The world’s number one leading EDM festival is coming to Tel Aviv! ",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											NEAR Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											3.08.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.thechainsmokers.com/">
// 											www.thechainsmokers.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/13/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Tel Aviv is known for its great dance scene, so it makes perfect sense that the hottest DJ/production duo that everyone is talking about to come to get the city on its feet! The duo is responsible for many current hits such as “Don’t let me go”, “Roses”, and their recent collaboration with Coldplay “Something Just Like This”, and they will perform in Israel as part of their international tour “Memories Do Not Open”.
// 							</p>
// 							<p>
// 								The Chainsmokers consists of Andrew Taggart and Alex Pall. The duo performed live for the first time as the opening for Timeflies in 2014, and their single "#Selfie" was re-released at the same year, leading to breakthrough success as "#Selfie" became a worldwide hit and peaked on the Dance/Electronic chart. In 2015 they released their first EP “Bouquet”, featuring “New York City”, “Until You Were Gone, “Good Intentions” and “Roses”, all of which climbed the international charts and became major hits.
// 							</p>
// 							<p>
// 								A year later, the duo released their singles “Don’t Let Me Down” featuring Daya, “Inside Out”, featuring Charlee, and “Closer” featuring Halsey. The latter peaked at number one in the United Kingdom and the United States. Their success didn’t stop there and after releasing “All We Know” featuring Phoebe Ryan, they were ranked 18th in DJ Magazine’s annual list of “Top 100 DJ’s” in 2016. The same year the duo won favorite electronic/dance music artist at the American Music Awards and top dance/electronic artist at the Billboard Music Awards. A year later “Closer” also won top hot 100 songs, top collaboration and top electronic/dance song at the same Awards ceremony.  “Don’t Let Me Down” also won best dance recording in 2017 at the Grammy awards.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:14,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "The Dire Straits Experience",
//         smltitle: "Get a shiver in the dark in Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											14.09.17
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.direstraitsexperience.com/">
// 											www.direstraitsexperience.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/14/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								25 years have passed since Dire Straits disbanded and we last heard that unmistakable sound of Mark Knopfler’s guitar…
// 							</p>
// 							<p>
// 								Close your eyes and get transported back to an original Dire Straits gig. Beautiful inspiring tracks, quality sound, amazing atmosphere, spine tingling riffs, vocals, instrumentals and an outstanding performance.
// 							</p>
// 							<p>
// 								After selling over 25,000 tickets in Israel within the past three years, and in light of the high demand for yet another show, The Dire Straits Experience are coming to Tel Aviv for only one night.  A single performance on the 14th of September at the Menora Mivtachim Arena.
// 							</p>
// 							<p>
// 							   The Dire Straits Experience was founded by saxophonist Chris White after their successful debut playing for a charity event at the Royal Albert Hall where members of the legendary band got back together on stage. News travelled fast, and an increasing global demand to hear the most dramatic songs in rock history played live eventually led to a worldwide tour.
// 							</p>
// 							<p>
// 							    Chris White, who recorded and performed with the rock legends for over a decade, joined Dire Straits for their record breaking “Brothers in Arms” world tour in 1985. This included their famous performance at Live Aid and later the renowned Nelson Mandela 70th birthday concert. White has played with some of the greatest rock stars the world has known, such as Paul Mccartney, Joe Cocker, Mick Jagger, Robbie Williams and many others. Joining Chris White is a stellar band consisting of some of the finest professional musicians the UK has to offer.
// 							</p>
// 							<p>
// 							   “When I was first approached to put together a band to play Dire Straits songs, I didn’t believe it would be possible to find someone who would be able to stand in Mark’s shoes without sounding like an imposter. I was wrong. In Terence Reis, I think we may have found the only person on the planet that is able to play and sing like Mark but maintain his own integrity and identity.”
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:15,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Alan Parsons",
//         smltitle: "The man that said no to Pink Floyd, live in TA",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											11.11.17
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.alanparsonsmusic.com/">
// 											 www.alanparsonsmusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/15/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The musical legend Alan Parsons and his band are coming to Israel for two shows, the first at the Congress Centre in Haifa and the second at the Menorah Mivtachim Arena in Tel Aviv.
// 							</p>
// 							<p>
// 								Parsons has a large following in Israel. In fact, this will be his third visit to the country in order to play on stage. This time they’ll be performing their new “I Robot” tour, commemorating 40 years for the release of the similarly titled mythological album in 1977. You can expect to hear all of their greatest hits of course.
// 							</p>
// 							<p>
// 								Alan Parsons is a renowned musician and one of the most influential musical producers in history. He started out as a sound technician working in the notorious Abbey Road recording studio. Alan became famous after helping to produce Pink Floyd’s masterpiece album “Dark Side of the Moon”. He has worked as a sound technician with others such as The Beatles, Wings, Al Stewart and many more.
// 							</p>
// 							<p>
// 							   In 1975, Pink Floyd invited him to work on their next album “Wish You Were Here”. Alan declined the offer in order to form his progressive rock band “The Alan Parsons Project”. The band succeeded immediately, receiving international acclaim for their huge hits “Eye in the Sky”, “Time” and “Old and Wise” to name a few.
// 							</p>
// 							<p>
// 							   An accomplished vocalist, keyboardist, bassist, guitarist and flautist receiving gold and platinum awards from many nations, Parsons also has ten Grammy Award nominations for engineering and production. Up until today The Alan Parsons Project is one of the most popular events in Europe, with tickets being sold out within hours.
// 							</p>
// 							<p>
// 							   Come indulge your ears and listen firsthand to some of the classics of our time. You can catch the concerts either in Haifa on the 9th of November or in Tel Aviv on the 11th of November.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:16,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Bryan Adams",
//         smltitle: "Bryan Adams to warm our winter with 3 shows",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv & Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											4+5+6.12.17
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.bryanadams.co.il/">
// 											 www.bryanadams.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/16/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								With the summer days way behind us and the days getting shorter, a little winter comfort is necessary. What better way to warm up from the inside than with some romantic ballads and timeless rock anthems. Treat yourself (and someone you love) to a throwback of nostalgia from our younger days, reminding us those sweet moments of slow dancing, first crushes and innocent youth.
// 							</p>
// 							<p>
// 								The Canadian pop rock icon with hits spanning over four decades is coming to Israel for three consecutive shows! Two will performances in Tel Aviv on the 4th and 5th of December at the Menora Mivtachim Arena and one more concert in Jerusalem on the 6th of December at the Pais Arena.
// 							</p>
// 							<p>
// 								Born in 1959 in Kingston, Ontario, Bryan Adams’ music career took off in the early 80’s with the release of his third album “Cuts Like A Knife” which included the hit “Straight From The Heart”. It was his following album “Reckless” that skyrocketed his career and brought his rise to stardom with the hits “Run To You”, “Heaven” and “Summer of ‘69”. Following these hits Adams later brought us the U.S. Billboard Hot 100 number-one singles "Heaven", "All for Love" and "Have You Ever Really Loved a Woman?".
// 							</p>
// 							<p>
// 							  Besides topping the charts in North America and Europe, his songs were nominated for several Grammy, Golden Globe and Academy Awards. His records have collectively sold over 100 million copies worldwide, making him one of the best-selling music artists of all time.
// 							</p>
// 							<p>
// 							   He’ll be performing songs from the “Get Up” tour being held for his similarly titled thirteenth (and most recent) album from 2015. No reason to worry though, we’re sure he’ll serenade us with his biggest hits and favorite crowd pleasers.
// 							</p>
// 							<p>
// 							   He’ll be performing songs from the “Get Up” tour being held for his similarly titled thirteenth (and most recent) album from 2015. No reason to worry though, we’re sure he’ll serenade us with his biggest hits and favorite crowd pleasers.
// 							</p>
// 							<p>
// 							   Make sure you don’t miss this time-defying legend.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:17,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Chris Rock",
//         smltitle: "Coming to Tel Aviv to rock your world ",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											8+9.01.18
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.chrisrock.com/">
// 											 www.chrisrock.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/17/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Chris Rock, one of the greatest standup comedians of all time and the funniest people in the world is going on a rare, highly awaited tour for the first time in 9 years. One of his few stops will be in Tel Aviv.
// 							</p>
// 							<p>
// 								The hilarious comedian has put on a new live act, after nearly a decade of focusing on television and film. Chris Rock will make his first ever live on stage appearance in Israel as part of his 2017 “Total Blackout” tour.
// 							</p>
// 							<p>
// 								Born in 1965, he made his breakthrough on SNL (Saturday Night Live) starring next to Adam Sandler, David Spade and Chris Farley. Eddie Murphy helped accelerate his stardom by giving him a role in Beverly Hills Cop 2. Since then it’s been a long line of success, from Lethal Weapon 4, Madagascar, Scary Movie, Nurse Betty and the list goes on. He’s hosted the Academy Awards twice and has also written, directed and produced several movies and TV shows. Despite all this, Chris Rock has and always will shine brightest where he truly belongs, on stage with a microphone.
// 							</p>
// 							<p>
// 							  His previous standup acts: Bigger and Blacker, Born Suspect, Bring the Pain and Kill the Messenger all broke records and are considered to be classics, with bits that are still quoted today.
//                               Rock is often compared to the greatest comedians in the field, alongside Jerry Seinfeld, Louis CK and Dave Chappelle (all of which he’s also collaborated with).
// 							</p>
// 							<p>
// 							   He made it to the top 5 in Rolling Stone magazine’s 50 greatest comedians of all time.
// 							</p>
// 							<p>
// 							   When he gets on stage it’s like seeing a boxer, a preacher and a poet all bundled together into one man. Chris delivers powerful, fast paced, side-splitting punches. His views on relationships, race and politics challenge his listeners and make them rethink everything they know. Rock dares to cross boundaries with his material and is not afraid to shock and surprise.
// 							</p>
// 							<p>
// 							   In an interview he recently gave to Rolling Stone magazine, he talked about his divorce after 18 years of marriage and how he decided to devote himself to standup again. According to him, these events gave rise to the world tour in which he will be performing in Tel Aviv.
// 							</p>
// 							<p>
// 							   Catch Chris live on January 8th at the Menorah Mivtachim Arena.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:18,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Patricia Kaas",
//         smltitle: "The great French singer returns to the white city once again",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											28.09.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.patriciakaas.net/">
// 											  www.patriciakaas.net
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/18/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The famous French singer and actress Patricia Kaas is coming back to Tel Aviv for the third time after her previous performance three years ago became a huge success and recieved incredible reviews. Kaas is considered one of the all-time most successful French singers and her music is a mix of pop, cabaret, jazz, and chanson. She started her career in the late 80’s and very quickly she climbed the charts in France.
// 							</p>
// 							<p>
// 								Kaas’s first single “Mademoiselle chante le blues” that came out in 1987 became a huge hit and got to the top 10 in the French chart. A year later she released her second single “D’Allemagne”, followed by her first album “Mademoiselle chante…” that was ranked number two at the French chart. The album sold over 100,000 copies within less than two months and became a gold album. It didn’t take long and within less than three months more than 350,000 copies were sold and it became a platinum album. Kaas received a platinum album status in Belgium, Switzerland and Canada as well, and at the same year she won the most important French music award – Victories de la Musique.
// 							</p>
// 							<p>
// 								Since then the French phenomenon sold more than 17 million albums worldwide. Her third album “Je te dis vous” brought her major success in Germany, Belgium, Switzerland, Canada, Russia, Finland, Ukraine and Korea. In 2002 she acted in a movie for the first time, it was “And now… Ladies and Gentlemen” in which she performed with the British actor Jeremy Irons. In 2009 she represented France at the Eurovision contest and got to the 8th place.
// 							</p>
// 							<p>
//                                    Patricia Kaas is responsible for many hits and her songs became a part of our lives. The talented musician is coming back to Tel Aviv to sing her famous repertoire and bring back the nostalgia to the nonstop city.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:19,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Blue Man Group",
//         smltitle: "The phenomenal musical group is returning to Tel Aviv once again for a show like no other!  ",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											 7-23.08.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.blueman.com/">
// 											  www.blueman.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/19/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Blue Man Group is coming to Tel Aviv as a part of their 25 years of living in full-color tour! This is a show unlike anything you have ever seen before that combines music, theater, art and technology.
// 							</p>
// 							<p>
// 								Originally Formed in New York in 1988 by three close friends, Chris Wink, Matt Goldman and Phil Stanton, Blue Man Group originated as a celebration of the end of the 1980s. The three men wore blue masks and led a procession that included the burning of a Rambo doll and a piece of the Berlin Wall. They caught the eye of an MTV reporter and gained attention. They started with small acts on the streets of New York, growing into shows at downtown clubs, eventually becoming a full performance at the Astor Place Theatre in 1991.
// 							</p>
// 							<p>
// 								In 1999 the band released its first gold album “Audio” and it was nominated for the Grammy Award for Best Pop Instrumental Performance. Their second album, “The Complex” (2003), features collaborations with various musicians like Gavin Rossdale, Dave Matthews and many others. It charted four songs on the Billboard charts. In 2006 they released “Live at The Venetian – Las Vegas” which was an iTunes exclusive, and their most recent album, “THREE”, came out in 2016 and was also nominated for the Grammy Award.
// 							</p>
// 							<p>
//                                  Currently, the Blue Man Group is performing on a regular basis in five theaters around the world- in Vegas, New York, Boston, Orlando and Berlin. They recently launched their new book “Blue Man World” that tells the story of the blue man from their perspective.  Three blue people that will take you on a crazy adventure full of music, laughter and surprises. More than 35 million people worldwide have already seen them, not it’s your turn!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:20,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Sean Paul",
//         smltitle: "The international mega star is coming to make our summer sizzle!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv Outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											22.08.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.allseanpaul.com/">
// 											  www.allseanpaul.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/20/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The Grammy winner dancehall artist, Sean Paul will return to Tel Aviv for a single hot hot hot hot performance.
// 							</p>
// 							<p>
// 								Sean Paul will arrive in Tel Aviv for the third time as part of his new international tour. The artist is currently storming the international charts with a string of hits that including collaborations with some of the most popular names in music including Sia, Anne-Marie and more.
// 							</p>
// 							<p>
// 							    His extraordinary voice, rhythms, catchy songs and super-polished productions all combine the winning recipe of the Grammy winner and international star - Sean Paul. Originally known as Sean Paul Ryan Francis Henriques, Sean Paul was born in Jamaica in 1973. His musical career soared in 2002 with the tremendous success of his second studio album, "Dutty Rock," mainly for the songs "Gimmie The Light" and "Get Busy" Hot 100 chart toppers). Sean Paul has managed to maintain his relevance in the music industry since breaking into fame in the year 2000 until now with a string hits such as Cheap Thrills, Rockabye, No Lie, and Body.
// 							</p>
// 							<p>
// 							   Sean Paul studied at the University of Technology in Jamaica with aspirations for a career in the hotel industry, but his passion for music took over. The single ‘Baby Girl’ was the first to mark his successful career as a recording artist and led to his debut album ‘Stage One’ at VP Records. To date, he has released six studio albums; the last five were all nominated for the Grammy Award.
// 							</p>
// 							<p>
// 							   The album "Dutty Rock," 2002, earned him the Grammy Best Reggae Album. "The Trinity," 2005, reached platinum status in Europe and the Recording Industry Association in the United States. His albums, "Imperial Blaze" in 2009 "Tomahawk Technique" in 2012, and the last one was released in 2014 - "Recent Full Frequency" – were all warmly received and highly acclaimed.
// 							</p>
// 							<p>
//                                   His hard work, perseverance, and dedication over the years have earned him several nominations for the Grammy and Billboard awards. His most notable accomplishments include An American Music Award, Mobo Awards, Soul Train Awards, MTV Music Awards, ASCAP Rhythm and Soul Music Awards, a Source Award and a BET Award.
// 							</p>
// 							<p>
//                                 Sean Paul maintains a multinational presence thanks to his collaborations with artists in a wide variety of genres such as EDM, Soca, Pop, Afro-Beat and Latin music. His icon status allows him to maintain an immense fan base in Latin America, Japan, Europe and the US and his relationship with the Spanish audience received a serious boost, following his collaboration with the singer Farruko in the single Passion Whine and of course the legendary collaboration with Enrico Iglesias ‘Bailando’ which became no.1 in 33 (!) countries and gained millions of views on YouTube.
// 							</p>
// 							<p>
//                                Sean's collaborations throughout his career include numerous international collaborations with hip-hop stars such as Busta Rhymes, Beyoncé, Rihanna, Keyshia Cole, Kelly Rowland, Juicy J, 2Chainz and Nicki Minaj.
// 							</p>
// 							<p>
//                                Sean Paul performs regularly on the biggest most respectable venues in the world and enjoys a huge following from a worldwide audience of all ages.
// 							</p>
// 							<p>
//                                His last performance in Tel Aviv received fantastic revues from critics and fans alike, and he is back on popular demand, promising to make the hot summer scorch even more with a what is guaranteed to be a party like no other!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:21,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "The Pretenders",
//         smltitle: "The legendary rock band and Chrissie Hynde are coming to rock out Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											23.09.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.thepretenders.com/">
// 											  www.thepretenders.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/21/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								For the past three decades Chrissie Hynde and The Pretenders stayed at the top of the British rock and won the hearts of millions of fans. Hynde took a long break from writing and recording new materials but after the raving reviews the band’s most recent album, “Alone” got, she and The Pretenders are back on a world tour and are now coming for one unforgettable show in Tel Aviv!
// 							</p>
// 							<p>
// 								The band started its way in the music world in England in 1978 and experienced numerous subsequent personnel changes, with Chrissie Hynde being the only consistent member. The original band was active until 1982 and released its first album (Pretenders) that was a success in the United Kingdom and the United States both critically and commercially. The band got to No. 1 in the UK with its single "Brass in Pocket", which was also successful in the US, reaching No. 14 on the Billboard Hot 100.
// 							</p>
// 							<p>
// 								Later on the band released nine more albums - Pretenders II (1981), Learning to Crawl (1984), Get Close (1986), Packed! (1990), Last of the Independents (1994) which was rated gold in the US, Viva el Amor (1999), Loose Screw (2002), Break Up the Concrete (2008) which was among the Top 40 album in the US, and The Pretenders’ most recent album - Alone (2016). During March 2005, the Pretenders were inducted into the Rock and Roll Hall of Fame. Among their most famous song one can remember “Brass in pocket”, “Hymn to her”, “Don’t get me wrong”, “I’ll stand by you”, and many others.
// 							</p>
// 							<p>
//                                   The Pretenders worked carefully on their new show and started their new tour at the Royal Albert Hall in London, which was full with fans that showed how much they missed the incredible band. Hynde and The Pretenders performed in music festivals all over the world, and they’ll start the second part of their tour right here in the rocking city of Tel Aviv, make sure not to miss it!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:22,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Cliff Richard",
//         smltitle: "The incomparable Cliff Richard coming back to Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											10.10.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.cliffrichard.org/">
// 											  www.cliffrichard.org
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/22/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Cliff Richard, the beloved British artist who previously performed in the fabulous city of Tel Aviv more than 20 years back, is coming back to the delight of his local fans.
// 							</p>
// 							<p>
// 								Over his long and illustrious career, the 72-year-old Cliff Richard has sold more than 260 million records worldwide and is best known for his tunes "Fallen angel Woman," "We Don't Talk Anymore," "The Young Ones," "Summer Holiday," and "Congrats" .
// 							</p>
// 							<p>
// 								Richard has a long list of hits and is responsible for many worldwide beloved songs. He has sold over 21 million singles in the UK and has become an intrinsic part of the nation’s soundtrack.
// 							</p>
// 							<p>
//                                  Richard has had eight US Top 40 singles, including the million-offering "Demon Woman" and "We Don't Talk Anymore". In Canada, Richard made a real splash during the mid-1960s, and again in the late 1970s and mid-1980s with a few singles and collections achieving gold and platinum status. He has remained a prominent music, film, and TV character in Australia, New Zealand, South Africa, Northern Europe and Asia, and has a strong following.
// 							</p>
// 							<p>
// 							   Throughout his career, spanning over 50 years, Richard has amassed numerous gold and platinum records and awards, including three Brit Awards—winning Best British Male Singer twice and the Brit Award for Outstanding Contribution to Music, as well as two Ivor Novello Awards. He has had more than 130 singles, collections and EPs make the UK Top 20, more than any other artist.
// 							</p>
// 							<p>
// 							   Richard has had 67 UK top ten singles, including one written for the great Elvis Presley.  He has had 14 UK No. 1 singles and is the leading vocalist to have had a No. 1 single in the UK in five back to back decades: the 1950s through to the 1990s.
// 							</p>
// 							<p>
// 							   This October, after much anticipation, Cliff Richard is coming to Tel Aviv to sing his mind-blowing songs live, in his unmatchable performing style. Come watch the living legend himself on-stage in the exciting city of Tel-Aviv!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:23,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "DGTL Festival",
//         smltitle: "An awesome digital celebration in the one of the world’s Digital Capitals",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											05.10.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://tlv.dgtl.nl/en/?skip_portal=1">
// 											  www.tlv-digital.nl
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/23/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The first ever of its kind in the country, the DGTL festival is a dream come true for the music and nightlife scene of this buzzing metropolis. The DGTL festival is set to be by far the biggest electronic music event held in Tel Aviv, which is considered one of the nightlife capitals of the world.
// 							</p>
// 							<p>
// 								DGTL Festival, making its Tel Aviv debut this October originates in Holland and takes place each year in the most trendy capitals including Amsterdam, Sau Paulo, and Barcelona.
// 							</p>
// 							<p>
// 								The festival is an innovative technology centered event showcasing some of the world’s greatest biggest names in the digital scene alongside new hot up and comers from the industry. Tickets are often sold out in advance, and dozens of DJs and leading artists show off their talents in this a multi-sensory experience of art, music, lighting and uncompromising production standards throughout the:
// 							</p>
// 							<p>
//                                The festival has a unique and electrifying atmosphere, and audiences will also get to enjoy a variety of food stalls, art, and meticulous sound.
// 							</p>
// 							<p>
// 							   The festival will include three stages featuring excellent music at any given moment.
// 							</p>
// 							<p>
// 							   The fantastic international line up is set to include:
// 							</p>
// 							<p>
// 							  Maslow Flux, Marcel Dettman, John Talabot, Red Access, Jennifer Cardini, Avalon Emerson, Young Marko, Yotam Avni, Otarki, Joba Jobsa and many others.
// 							</p>
// 							<p>
// 							  This huge production will be launched for the first time in October 2017. In addition to being an innovative music festival, DGTL is held under the theme of environmental preservation and sustainability and is considered the greenest festival in Europe. Also, DGTL festival promotes vegetarian food only and develops a unique program for recycling materials. Alongside the local audience, the festival will be marketed in 50 countries, and thousands of music fans from all over the world are expected to arrive in Tel Aviv to take part in the party.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:24,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Richard Clayderman",
//         smltitle: "The famous pianist returns to perform in Israel with all his unforgettable hits!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											17.11.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.clayderman.co.uk/">
// 											  www.clayderman.co.uk
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/24/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Romance lovers, prepare yourselves – after his last show in Israel three years ago, the famous French pianist Richard Clayderman returns to the holy land as a part of his new tour that marks 40 years of an outstanding career!
// 							</p>
// 							<p>
// 								Clayderman recently turned 63 and he is one of the world’s most successful pianists with a rich and diverse career that started four decades ago. He recorded over 1200 songs and his biggest hit ever is “Ballade Pour Adeline” that was sold in 22 million copies in 38 different countries. Clayderman is considered one of the world’s most successful instrumental artists along with others like Kenny G and more.
// 							</p>
// 							<p>
// 								During his career, Richard Clayderman sold more than 85 million albums and had more than 340 gold and platinum albums. He created a new romantic style through a repertoire that combines his original melodies with classics and pop standards. The phenomenal artist devoted much of his time to performing, going as far as playing 200 shows in 250 days. The Guinness Book of World Records noted him as “the most successful pianist in the world”.
// 							</p>
// 							<p>
//                                His previous visits in Israel were extremely successful with multiple sold out concerts. In his upcoming shows in Israel, Clayderman will play a selection of his best pieces, including the 12 minutes of the “Titanic Symphony”, “Don’t Cry for Me Argentina”, “Love Story”, “Ballade Pour Adeline”, and song from other famous movies such as “West Side Story”, “Harry Potter Melody” and “The Schindler List”. Come listen to the outstanding pianist who has touched the heart of millions around the world!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:25,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Smokie",
//         smltitle: "Smokie, coming to light up the stage this fall in Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv + Jerusalim
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											28+31.10.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//smokie.co.uk/Band">
// 											  www.smokie.co.uk
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/25/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Smokie, the iconic British rock band is coming back to Tel Aviv to rock it out in the city this fall.
// 							</p>
// 							<p>
// 								Smokie initially rose to fame in the 1970's and is most know for its chart topping hits 'Living Next Door to Alice', 'Lay Back in the Arms of Someone', and "If You Think You Know How to Love Me.'
// 							</p>
// 							<p>
// 								The band has had 13 top twenty hits during the 1970s and has sold more than 30 million albums.
// 							</p>
// 							<p>
//                               Initially formed in Yorkshire, England, in 1966, Smokie hit the British pop charts a few times amid the late '70s with a fresh pop style.  The quartet recorded many singles amid the late '60s and mid '70s, and in 1975 hit number three in the U.K. with "If You Think You Know How to Love Me."
// 							</p>
// 							<p>
// 							   After another Top Ten hit, "Don't Play Your Rock’n’ Roll to Me,” the band made it big with three Top 20 hits, including "Living Next Door to Alice." Smokie hit number five both in 1977 ("It's Your Life") and 1978 ("Oh Carol(".
// 							</p>
// 							<p>
// 							   The band has performed in Tel Aviv several times and are returning shortly after their last visit to the non stop city with an extremely successful run two years ago. The Tel Aviv concert will be a part of the band’s new tour which includes England and many countries around Europe and which also includes musicians Martin Bullard, Mick McConnell, Mike Craft, Steve Pinnell and Terry Uttley.
// 							</p>
// 							<p>
// 							    Smokie’s songs have gained iconic status over the years and have been covered multiple times due to their catchy style. The band enjoys a strong fan base in the country and regularly fills every seat in the house in each of their performances. The band will be playing its greatest hits to the joy of their fans which will flock to see the rock legends in action in Tel Aviv.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:26,
//         bgImage :"/posts/bank/15/1.jpg",
//         mobBgImage :"/posts/bank/15/M.jpg",
//         title: "Foreigner",
//         smltitle: "The 80's are back to rock Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											02.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.foreigneronline.com/">
// 											  www.foreigneronline.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/26/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The 80's are coming back! The British-American hard rock group is returning once again to the amazing city of Tel Aviv. The band is returning to Israel again after 3 sold out concerts in the past – one in 2014 and two in 2016, which got incredible reviews.
// 							</p>
// 							<p>
// 								Foreigner was founded in New York in 1976 by veteran English musician Mick Jones, ex-King Crimson member Ian McDonald and American vocalist Lou Gramm. The band focused more on commercial rock and is remembered mostly for its soft ballads that topped the charts worldwide.
// 							</p>
// 							<p>
// 								The rock group released its debut album in 1977 which provided one of its most popular hits "Cold As Ice", but the band's real breakthrough happened in the early 1980's when they released the album "4". Their success continued as they released their next album "Agent Provocateur" in 1984, as well as in their last one- "Can't Slow Down", in 2009.
// 							</p>
// 							<p>
//                               The band has sold over 80 million records worldwide in the past 3 decades, out of them 37.5 were sold in the United States alone, making it one of the bestselling bands in the history. Their most memorable hits include "Waiting for a Girl Like You", "I Want to Know What Love Is", "Urgent", "Juke Box Hero", and "That Was Yesterday".
// 							</p>
// 							<p>
// 							  Come rock with the American-British legend and bring the 80's back to life in a one of a kind concert!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:27,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Carcass",
//         smltitle: "The British metal legends are coming <br>to rock the city that never sleeps!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											09.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.facebook.com/OfficialCarcass/">
// 											  facebook.com/OfficialCarcass
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/27/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The British extreme metal band was formed in 1985. They started as a school band by Bill Steer and Ken Owen, and the latter left the band soon after. Steer then joined the D-beat band Disattack and played with drummer Middie, bassist Paul and the lead singer Andrew Pek. The band later changed its name to Carcass as the members changed their musical direction. The band recorder only one album with Pek, who changed his name to Sanjiv, and shortly after "Flesh Ripping Sonic Torment" was released he left the group.
// 							</p>
// 							<p>
// 								The vocal duties were shared between Walker, Steer and Owen, and together they recorded a debut album in only four days.  The band wasn't pleased with the poor production of their album "Reek of Putrefaction" but it became a favorite of Radio 1 DJ John Peel. His interest in them made them participate in his first "Peel Session", in which they released materials for their second album.
// 							</p>
// 							<p>
// 								Carcass are considered to be the pioneers of the grindcore genre, although their early work is considered to be more splatter death metal, hardgore and goregrind. The band also became one of the pioneers of melodic death metal with their album "Heartwork" which was released in 1993. Their lyrics usually focus on animal rights issues, as both Jeff Walker and Bill Steer are vegetarians.
// 							</p>
// 							<p>
//                               In 2013 the band signed with Nuclear Blast, and in Japan they signed with Trooper Entertainment for the release of their new album. They released "Surgical Steel", which received extremely positive reviews and earned Top 50 position on the US Billboard 200 charts. Soon afterward they headlined Damnation Festival in Leeds and then performed at 70000 Tons of Metal in 2014 and headlined the Agglutination Festival the same year.
// 							</p>
// 							<p>
// 							   The band is coming to give only one show in the nonstop city of Tel Aviv, which is guaranteed to be an extraordinary experience for all the metal fans out there, make sure to get your ticket now!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:28,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Kygo",
//         smltitle: "The Norwegian house phenomena for the first time ever in Tal Aviv!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											02.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.kygomusic.com/">
// 											  www.kygomusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/28/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Kygo, originally a Norwegian pianist, became a tropical house music producer in no time. "Spotify" announced him as the biggest discovery of 2015 after his songs "Firestone" and "Stole the Show" were played over a billion times. Both of these songs also received gold and platinum status in 16 countries.
// 							</p>
// 							<p>
// 								His first album, "Cloud Nine", reached the top of the dance albums chart on "Itunes" and also on the electronic albums chart of Nielsen Soundscan. The house sensation preformed in the most popular TV shows in the United States such as "The Late Late Show" with James Corden, "The Tonight Show", "Good Morning America" with Jimmy Fallon and on Ellen Degeneres. Moreover, he was on the cover of the biggest magazines – "The Billboard", "Haute Living Magazine", "LA Times", "USA Today", "The Wall Street Journal", "The Rolling Stones", "Forbes" and more.
// 							</p>
// 							<p>
// 								Kygo started his musical journey at the age of 6 when he started learning how to play the piano. It took almost a decade for the classical music to step aside and for the new love in his life to take over – Electronic music. He only decided that he wants a career in the music industry a moment before he was about to graduate from his economics and business degree.
// 							</p>
// 							<p>
//                               His first significant breakthrough was with the hit "Firestone" that shortly grabbed the attention of tens of millions of listeners. Aviici played it in his sets and in festivals. Afterwards Coldplay's lead singer, Chris Martin, gave him permission to create a remix of their song "Midnight". Kygo's unique sound led him to incredible achievements, such as the hit "ID" that was featured in Ultra Festival's official trailer and in the playlist of FIFA 2016.
// 							</p>
// 							<p>
// 							  The extraordinary house sensation is coming to rock Tel Aviv for the first time ever, for one show only. His shows in New York and Hollywood were sold out, and the reviews were incredible. This is guaranteed to be a night to remember, you definitely want to be there!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:29,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Led Zeppelin 2",
//         smltitle: "Don’t Miss the Zeps in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv, Haifa and Be'er Sheva
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											07-10.01.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//zep2.com/">
// 											  www.zep2.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/29/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The tribute band from Chicago Led Zeppelin 2, which was named after the mythological band's second album, is coming to Israel for 4 shows only. Come feel the old Led Zeppelin vibes and kick it with the ultimate Led Zeppelin experience here in rocking Tel Aviv
// 							</p>
// 							<p>
// 								Led Zeppelin 2 have been performing  for over a decade and are considered to be the ultimate Led Zeppelin experience. The band consists of 4 musicians from the indie-rock, jazz and metal scene in Chicago. The lead singer, Bruce Lamont, who took the place of the legendary Robert Plant, is also a part of the avant-garde metal group "Yakuza", and he has collaborated with bands like "Dyslexic Apaches", and "Circle of Animals". His solo album "Feral Songs for The Epic Decline" was recently rated among SPIN magazine's top 20 metal albums.
// 							</p>
// 							<p>
// 								Greg Fundis, the group's drummer, is playing with leading musicians among which one can find the singer and jazz guitarist George Benson, the musician Joey De Francesco, the saxophonist Joe Lovano and more. The bassist Matthew Longbons participates in more than 200 shows a year next to leading international artists such as Alice Cooper and Matt Walker from the "Smashing Pumpkins". Paul Kamp, the group's guitarist, is known mostly from his collaboration with "Busker Soundcheck", a well-known alternative rock band.
// 							</p>
// 							<p>
//                              Led Zeppelin is considered until today to be one of the most revolutionary, influencing and successful bands in the history. They sold more than 300 million albums worldwide, with 'Led Zeppelin IV' alone selling over 37 million copies and being ranked as the third all-time best-selling album in the U.S. All 9 of the band's albums were rated in the top 10 in the U.S. chart, and 6 of them even top over the top 5. Their second album that was recorded during their first tour was a huge success both in the U.S. and in the UK, and it featured the hit 'Whole Lotta Love' that sold over a million copies.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:30,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Oh Wonder",
//         smltitle: "Live in Tel Aviv for the first time ever!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											16.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//ohwondermusic.com/">
// 											  www.ohwondermusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/30/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Oh Wonder consist of Josephine Vander Gucht and Anthony West. In 2014 they started releasing singles every month and then they combined all of them and released a debut album that's named after them and sold over 500 million copies. This year they released their second album, "Ultralife", which had even a bigger success and reached the Top 10 in the UK charts.
// 							</p>
// 							<p>
// 								In 2015 the duo was announced by Billboard as one of the 5 biggest breakthroughs. They come to Israel this year after a long tour and performing in the biggest festivals around the world as part of the promotion of their new album, which includes hits such as "Without You" and "Drive".
// 							</p>
// 							<p>
// 								Gutcht and West played sold out shows in New York, Los Angeles, Paris and London, and now they're coming for one show only to give the people of Tel Aviv a taste of their alt-pop hits. The successful duo is guaranteed to get you dancing and give the ultimate pop experience, this will be one night in Tel Aviv you are sure to remember.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:31,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Ott & The All Seeing I",
//         smltitle: "Electro explosion in the city that never sleeps",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											15.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//ottsonic.com/">
// 											  www.ottsonic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/31/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Ott and the All Seeing I are coming to take Tel Aviv by a storm this December.
// 							</p>
// 							<p>
// 								Ott is considered to be one of the pioneers of calm, groovy electronic music and likes to record the sounds of nature in his mobile studio, with which he tours England. The British record producer and musician has worked with Sinead O'Connor, The Orb, Brian Eno and Embrace, and has achieved recognition since 2002. He's known for psychedelic dub tracks and his collaborations with other artists. He has released two albums on Twisted Records – "Blumenkraft" in 2003 and "Skylon" in 2008, and two other albums on Ottsonic – "Mir" in 2011 and "Fairchildren" in 2015.
// 							</p>
// 							<p>
// 								The electro genius performed at the Glastonbury Festival in 2007, and then in 2011 he performed at Glade Festival, a show that was described as "the perfect opening act" in an article at Virtual Festivals. The same publication also called Ott a "Psy-dub maestro" and ranked his performance 10/10. The Israeli crowd was first exposed to Ott in the early 2000's with the album "Hallucinogen in Dub", the remix album he produced for Simon Posford. All the albums he released later only enhanced the effect he has with his powerful and addictive music.
// 							</p>
// 							<p>
// 							   The All Seeing I are an English electronic music group from Sheffield, consisting of Dean Honer, Jason Buckle and DJ Parrot. Their first single "I Walk" came out in 1997, but it was only in the following year that they gained mainstream commercial success with the song "Beat Goes On". The trio worked with artists such as Tony Christie, Jarvis Cocker, Babybird, Phillip Oakey and many others.
// 							</p>
// 							 <p>
// 							    Ott has performed Tel Aviv twice in the past and his shows received incredible reviews. This is guaranteed to be a one of a kind night that you definitely don't want to miss!
// 							 </p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:32,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Take That",
//         smltitle: "Take That – Taking Tel Aviv By Storm!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											27.11.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//takethat.com/">
// 											  www.takethat.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/32/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The legendary British pop band is this coming November to rock Tel Aviv for one show only!
// 							</p>
// 							<p>
// 								Take That started in Manchester in 1990 and currently includes Mark Owen, Gary Barlow, and Howard Donald. The original band also featured Robbie Williams and Jason Orange. Barlow is the band's lead singer and songwriter, while Owen and Donald act as backing vocals.
// 							</p>
// 							<p>
// 								Their most memorable songs include "Pray" which won The Guardian Music Award for Best Number 1 Single, "Back For Good" which won BRIT Award for Best British Single, "Everything Changes" and "Could It Be Magic." The band released 28 top 40 singles and 17 top 5 singles in the United Kingdom, out of which 12 reached number one, and they have 7 number one albums. Internationally, the band released 56 number one singles and 37 number one albums. They won 8 Brit Awards, including awards for Best British Live Act and Best British Group.
// 							</p>
// 							<p>
// 							   The British pop sensation set the record in 2011 for the fastest-selling tour of all time in the United Kingdom with "Progress Live", beating their own personal record from 2009 with their "Circus Live Tour". They were named as Amazon's top-selling music artist of all time, and in 2012 Forbes announced them as the fifth highest-earning music stars in the world. During the same year, the Official Charts Company announced the biggest-selling singles artists in the British music chart history with Take That being placed at 15th overall and having four of the best-selling albums of the millennium, which makes them the most successful boy band in the UK chart history.
// 							</p>
// 							 <p>
// 							   The band will come to Israel as a part of its international tour in order to promote its last album "Wonderland". Their previous tours have gotten raving reviews, with "Progress" winning Audio Pro International Awards for Best Live Sound Event and Audio Pro International Awards Grand Prix Award. Their performance in Tel Aviv will for sure be a one to remember, don't miss out!
// 							 </p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:33,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "The Kooks",
//         smltitle: "Getting it on with the Kooks in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											27-28.01.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.thekooks.com/">
// 											  www.thekooks.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/33/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The Kooks – one of the ultimate British rock/pop bands of the century are coming this January to rock Tel Aviv as a part of "The Best of The Kooks" tour that marks a decade to their existence.
// 							</p>
// 							<p>
// 								The band was formed in Brighton, UK, in 2004 by lead singer Luke Pritchard and consists of Hugh Harris the lead guitarist, drummer Alexis Nunez and bassist Peter Denton. The band released its debut album, "Inside In/Inside Out" in 2006, which included hits such as "Ooh La" and "She Moves in Her Own Way" and achieved quadruple platinum status in the UK within a year and also abroad in the form of a platinum certification in Australia and two times platinum in Ireland.
// 							</p>
// 							<p>
// 								The group released its second album "Konk" in 2008 which debuted at number one on the UK Albums Chart and recorded first week sales of 65000, achieving gold status in both the UK and Ireland, which continued to establish their reputation as one of the world's most beloved brit-pop and post-punk bands. In 2011 their third album "Junk of the Heart" came out, followed by "Listen" in 2014 which debuted at No. 16 on the UK Albums Chart. Besides the fact that they quickly signed with "Virgin Records" only 3 months after forming, they also won several awards, such as MTV's best band of 2006 award, Best UK & Ireland Act at the MTV Europe Music Awards 2006 and even a nomination for the famous Brits award.
// 							</p>
// 							<p>
// 							  The band's music is primarily influenced by the 1960s British Invasion movement and post-punk revival of the new millennium. The Kooks have experimented in genres such as pop, reggae, ska, Britpop, rock, funk and hip-hop, and released songs that were describes as "catchy as hell".
// 							</p>
// 							 <p>
// 							  The Kooks are known for their amazing sold out shows and this one is due to be no different, so make sure to get your ticket now!
// 							 </p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:34,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Willy William and Farruko",
//         smltitle: "The reggaetón superstars coming to get you movin’ in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											  Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											28.11.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.reggaetontelaviv.co.il/indexEN.php">
// 											  www.reggaetontelaviv.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/34/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The reggaetón superstars coming to get you movin’ in Tel Aviv!
// 							</p>
// 							<p>
// 								Willy William and Farruko, the reggaeton megastars are coming this fall to perform as a part of the "Reggaeton Tel Aviv" festival and get the people of Tel Aviv on their feet in one extraordinary show only!
// 							</p>
// 							<p>
// 								Farruko , the 26-year-old world famous reggaton singer comes from Puerto Rico. He started his professional career in 2009 through Myspace. Since then, he released six albums and collaborated with Sean Paul, Daddy Yankee, Maluma, Don Omar, Shaggy, Nicky Jam, Ky-Many Marley, Chino&Nacho, J Balvin, Ozuna and many other successful reggaeton legends, and he was nominated for the Latin Grammy awards in 2012. His hits got millions of views on Youtube, and among them, one can find the famous "6 AM", "Passion Wine", "Me Voy Enamorando", "Krippy Kush", "Sunset" and "Chillax".
// 							</p>
// 							<p>
// 							  The 36-year-old singer, producer and DJ, Willy William is coming to Tel Aviv all the way from France. He's known for his remixes and collaborations with dance artists. His big breakthrough was in 2003 when he collaborated with DJ Flex and released his hit "B Boyz Shake da Body" and right afterwards his next song "Tragedie" and the name "Lord William". His most famous hits are "EGO" and "Mi Gente" which topped the charts in many radio stations worldwide, including Israel.
// 							</p>
// 							 <p>
// 							  Come get the addictive reggaetón vibes in you and dance the night away in the city that just won't quit!
// 							 </p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:35,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Buena Vista",
//         smltitle: "The ultimate Cuban experience in Tel Aviv & Jerusalem!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv and Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											21-26.12.17
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.pasion-de-buena-vista.com/">
// 											  www.pasion-de-buena-vista.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/35/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   The ultimate Cuban experience in Tel Aviv & Jerusalem!
// 							</p>
// 							<p>
// 								After 600 shows worldwide -  the extraordinary Buena Vista Cuban sensation is coming for first time to give Tel Aviv and Jerusalem a taste of Cuba!
// 							</p>
// 							<p>
// 								The show is a one-of-a-kind experience that expresses love to the Cuban culture with all the known Cuban hits such as La Vida es un Carnaval. The Buena Vista Band includes 11 talented musicians, working together with a group of unbelievable dancers to provide an experience you never had before.
// 							</p>
// 							<p>
// 								The show will be held in two separate dates in Tel Aviv and Jerusalem, both awesome choices offering a huge host of activities and experiences in a unique unrivaled atmosphere. Jerusalem is known for its rich history, interesting architecture and incredible cultural diversity, while Tel Aviv is known for its fast tempo, warm exotic weather, amazing beaches and non-stop nightlife! Whatever city you'll choose- you visit is bound to be exciting and packed with unforgettable experiences!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:36,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Jerry Seinfeld",
//         smltitle: "Comedy King Closing 2017 in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											30.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.jerryseinfeld.com/">
// 											  www.jerryseinfeld.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/36/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  Comedy King Closing 2017 in Tel Aviv!
// 							</p>
// 							<p>
// 								Jerry Seinfeld, the undisputed king of American comedy is returning to Tel Aviv for two performances which will be held on the same night in Tel Aviv.
// 							</p>
// 							<p>
// 								Home to incredible comedy venues a sought-after location for many international comedians such as Eddie Izzard, Jim Jeffries, Chris Rock and many others, Tel Aviv has a hedonistic vibe, incredible vibrancy and energy and a liberal loose spirit making in a comedy heaven.
// 							</p>
// 							<p>
// 								Seinfeld, hailed as one of the top comedians of his generation has without a doubt shaped the way we watch television and sitcoms, with his iconic show “Seinfeld” which ran from 1990-1998 and reigned over primetime TV for nearly a decade.
// 							</p>
// 							<p>
// 							   However, Seinfeld is a man loyal to his roots and has often declared that performing live is one of his favorites and he’s coming to Tel Aviv to do Just that.
// 							</p>
// 							<p>
// 							  This December, Seinfeld will strut his stuff onstage live in his hilarious laugh- a – second style, performing two consecutive shows in the nonstop city of Tel Aviv, and what better city is there to close the 2017 with a smile?
// 							</p>
// 							<p>
// 							   For visitors coming to check out Seinfeld’s show, the city of Tel Aviv, with its winter sunshine and world-famous nightlife is without a doubt THE place to spend a fantastic and absolutely unforgettable Tel Aviv Style New Year’s Eve.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:37,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Alt-J",
//         smltitle: "Comedy King Closing 2017 in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											29.05.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.altjband.com/">
// 											  www.altjband.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/37/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  The British indie band is returning to Tel Aviv once again after their last successful sold-out show in Israel two years ago. The band was formed in 2007 in England, and their debut album “An Awesome Wave” was released in 2012 and won the Mercury award the same year. The band is a combination of electro-pop, psychedelic folk, African beats, post-dubstep and rock n’ roll. The band members met through their mutual love for Radiohead while they were in college, and their sound was affected by the fact that they weren’t allowed to use a bass guitar and drums when they were students.
// 							</p>
// 							<p>
// 								The band comes to rock Tel Aviv this spring and invites fans from all over the world to come and enjoy the wonderful alternative music scene that the city that never sleeps can offer. From extraordinary art galleries to unique theatre shows to live music concerts – the cultural scene in Tel Aviv is one of a kind. It’s a home for many musicians and artists, and now it welcomes every culture lover.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:38,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Ozzy Osbourne",
//         smltitle: "Ozzy O -  coming to say goodbye to Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											08.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.ozzy.com/">
// 											  www.ozzy.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/38/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  Ozzy O -  coming to say goodbye to Tel Aviv!
// 							</p>
// 							<p>
// 								Ozzy Osbourne, the world-famous metal legend returns to Tel Aviv for the last time as part of his farewell tour. While known to younger audiences mainly from the reality show “The Osbournes”, Ozzy was already a musical icon and a huge star since way before – from his role as the lead singer for Black Sabbath, to being the headliner in the international metal festival that was named after him, the “Ozzfest”.
// 							</p>
// 							<p>
// 							   After 2500 shows all around the world, the star comes to say goodbye to his fans in Tel Aviv, a city known around the world for its rich rock and metal scene. Being the most liberal city in Israel, Tel Aviv is always full of action and attracts both younger and older visitors who craving a taste of the underground culture. The rocking city is full of bars with rock themes, alternative clubs, live music venues and is known to attract music lovers from every country.
// 							</p>
// 							<p>
// 							   Don’t miss your chance to see the metal star for the very last time, make sure to get your ticket now and come rock it with ozzy in rockin’ Tel Aviv!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:39,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Jim Jefferies",
//         smltitle: "Jim Jefferies Kicks Off 2018 in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											16.01.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//jimjefferies.com/">
// 											  www.jimjefferies.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/39/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  Jim Jefferies Kicks Off 2018 in Tel Aviv!
// 							</p>
// 							<p>
// 								One of the most popular comedians worldwide, Jim Jefferies, is returning to Tel Aviv after only a year. He will be kicking off 2018 and unleashing his famous humor with new material in a new show, “The Unusual Punishment Tour”.
// 							</p>
// 							<p>
// 							  The show will take place on a special 360-degree platform at the Menorah Mivtachim Hall in Tel Aviv, the perfect location for a comedian of his stature. Catching the show with the hilarious Australian performer is just the right excuse to come visit Tel Aviv, renowned for its exciting atmosphere and diverse nightlife scene.
// 							</p>
// 							<p>
// 							  Take the opportunity to visit one of the exciting bars or clubs which attract top International DJs, or visit one of the smaller neighborhood bars or cafes with its atmospheres to suit all tastes. Whether it’s food, drink or dancing you are after, Tel Aviv has it all.
// 							</p>
// 							<p>
// 							    After creating, writing, producing and starring in the critically acclaimed FX series, Legit, Jefferies and his material have gained a cult following. His voice has become well-known in late-night entertainment, making his show a must-see in Tel Aviv. Those coming to the Tel Aviv for Jefferies’ show will enjoy some good laughs, set on a background of stunning warm winters and an exciting night vibe.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:40,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Gerard Depardieu & Isabelle Adjani",
//         smltitle: "“Love Letters” Coming to Tel Aviv from France!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											05.03.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="">
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/40/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 “Love Letters” Coming to Tel Aviv from France!
// 							</p>
// 							<p>
// 								From France with love! French actors, Gerard Depardieu and Isabelle Adjani, will be performing “Love Letters” in March in Tel Aviv. Written by the late A.R. Gurney, the show has been performed on and off-Broadway by actors and actresses around the world.
// 							</p>
// 							<p>
// 							 The Pulitzer Prize-nominated show is now coming to Israel and will be performed by Gerard Depardieu and Isabelle Adjani in French, with Hebrew and Russian subtitles. With the performance taking place in Tel Aviv, visitors to the city will have the chance to enjoy some of the exotic and exciting nightlife that makes Tel Aviv so popular.
// 							</p>
// 							<p>
// 							  With restaurants to suit all palettes, dinner is just the thing for before the show, and with a nightlife that just starts to come alive around midnight, those who are looking for some adventure after the show will have plenty of options open to them. Anyone visiting the city especially for the show is sure to come away dazzled, both by the liveliness of the atmosphere and from the two well-known French stars.
// 							</p>
// 							<p>
// 							   While this is Adjani’s first trip to Israel, Depardieu has been here a number of times, and this occasion is sure to be memorable.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:41,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "A-HA",
//         smltitle: "An Electric Summer with A-HA!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											21.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://a-ha.com/">
// 											  www.a-ha.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/41/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 An Electric Summer with A-HA!
// 							</p>
// 							<p>
// 								Israel will be treated to an exciting performance from Norwegian band, A-HA, in June, 2018. Coming to Israel as part of their Electric Summer Tour 2018, the band will perform in Tel Aviv at the Exhibition Grounds in a show that promises to be a hit.
// 							</p>
// 							<p>
// 							 Formed in Oslo in 1982, A-HA has been talked about for more than three decades, and since their hit “Take On Me” in 1985, they have grown to be one of the most popular Scandinavian bands in the world. While they originally split up in 2010, they have come back together again for a number of tours and Tel Aviv is honored to be among their stops this time around.
// 							</p>
// 							<p>
// 							 Fans of the band will be treated to an exciting performance by the well-known group, while having the chance to enjoy some of the best entertainment venues in the country. From museums to theatres, restaurants to clubs, there is something to suit everyone in the bustling city of Tel Aviv.
// 							</p>
// 							<p>
// 							  Take the opportunity to enjoy a walk along the brilliant beachfront as the city’s locals get ready for the summer sun, and enjoy the vibe as diverse cultures come together for the band’s latest show.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:42,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Ringo Starr",
//         smltitle: "Ringo’s All Starr Band Headed to Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											23-24.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.ringostarr.com/">
// 											 www.ringostarr.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/42/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 Ringo’s All Starr Band Headed to Tel Aviv!
// 							</p>
// 							<p>
// 								It’s been a year of stars in Tel Aviv and the latest concert to come to the dynamic city, has everyone talking! Ringo Starr will be coming to Israel as part of his European Tour and will be performing two concerts with his All Starrs Band at the Menorah Mivtachim Arena in June 2018.
// 							</p>
// 							<p>
// 							Starr, an English songwriter, singer and actor, first became famous as the drummer for the Beatles; however, since 1989, he has toured with his All Starr Band. The 77-year old released his 19th studio album in September, known as “Give More Love.”
// 							</p>
// 							<p>
// 							Tel Aviv is the ideal location for a concert with such a big name. Known as the New York City of Israel, Tel Aviv is the center of excitement, fun and initiatives in the country. As the city that attracts over a million tourists each year, whether for business or pleasure, Tel Aviv offers a beautiful beach, unique restaurants, theatres, museums and pulsing bars.
// 							</p>
// 							<p>
// 							  If you are joining the many fans who are coming to Tel Aviv to hear Ringo and his All Starrs Band perform, make sure not to miss out on the rest of what Tel Aviv has to offer and come away with an experience to remember.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:43,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "The Scorpions",
//         smltitle: "Tel Aviv to Go Crazy in July with The Scorpions!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											19.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.the-scorpions.com/">
// 											 www.the-scorpions.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/43/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 Tel Aviv to Go Crazy in July with The Scorpions!
// 							</p>
// 							<p>
// 								One of the most well-known heavy metal bands in history, The Scorpions, will be coming to the Menorah Mivtachim Arena in Tel Aviv in July 2018, as part of their Crazy World Tour.
// 							</p>
// 							<p>
// 							One of the most well-known heavy metal bands in history, The Scorpions, will be coming to the Menorah Mivtachim Arena in Tel Aviv in July 2018, as part of their Crazy World Tour.
// 							</p>
// 							<p>
// 							Those looking to make a day of it in Tel Aviv, will have their pick of food and entertainment venues. The spirited city has become a melting pot of cultures and this is reflected in the museums, restaurants and street stalls that can be found all around the city. Enjoy cuisine to suit every palate, stroll around the interesting streets or pop into one of the many unique exhibitions that can be found around the city.
// 							</p>
// 							<p>
// 							  With the show scheduled for the beginning of the summer, it will be daylight until late and the locals will be out enjoying the sunshine. Soak up the vibe before you go on to rock the night away with The Scorpions!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:44,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Natalia Oreiro",
//         smltitle: "Natalia to Wow Tel Aviv in March",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											20.03.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.nataliaoreiro.com/">
// 											 www.nataliaoreiro.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/44/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							Natalia to Wow Tel Aviv in March
// 							</p>
// 							<p>
// 								South American singer and actress, Natalia Oreiro, is headed to Israel in March, where she will be performing a live concert at Menora Mivtachim Arena in Tel Aviv. Coming back to Tel Aviv, straight from Argentina, fans are looking forward to seeing the Latin star once again.
// 							</p>
// 							<p>
// 							Having performed in numerous daily series, including telenovelas and movies, and after producing 3 CDs, she will bring some of her biggest hits to the show, such as Cambio dolor, Corazon Valiente, Me Muero de Amor and Rio de la Plata y más, as she opens her new World Tour.
// 							</p>
// 							<p>
// 							Tel Aviv, which attracts celebrity singers, actors and performers from around the world, is the perfect location for the Grammy-nominated singer from Uruguay. The pumping city offers entertainment beyond the walls of the Menora Mivtachim Arena, with its trendy restaurants, upscale bars, and clubs.
// 							</p>
// 							<p>
// 							 Natalia, who has performed in Israel many times in the last 20 years, already has a following here. The show is sure to attract a large audience. Join the excitement before the performance by satisfying your taste buds in one of the many highly-acclaimed restaurants in the area or continue the celebration after the curtains have closed with a drink at a pub. Whatever your tastes, Tel Aviv is a great complement to Natalia Oreiro.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:45,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "André Rieu",
//         smltitle: "Tel Aviv to Be Treated to Rieu in 2018",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											04-05.04.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.andrerieu.com/">
// 											 www.andrerieu.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/45/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 Tel Aviv to Be Treated to Rieu in 2018
// 							</p>
// 							<p>
// 								World-class Dutch composer and violinist, André Rieu, is coming to Tel Aviv with his Johann Strauss Orchestra for a performance that promises to be unforgettable. The two events, which are Rieu’s first in Israel, will be held at the Menora Mivtachim Arena in Tel Aviv.
// 							</p>
// 							<p>
// 							Rieu will be conducting his 60-piece orchestra while playing his famous Stradivarius violin, treating the audience to their repertoire of renowned ballads and waltzes. The event will be particularly captivating as Rieu will be presenting his new album, “Amore,” which includes a unique interpretation of Naomi Shemer’s “Jerusalem of Gold.”
// 							</p>
// 							<p>
// 							Tel Aviv, with its many facets, is just the right location for the range of musical pieces that Rieu and the Johann Strauss Orchestra will be performing. From the beach to the theater, classy restaurants to lively pubs, Tel Aviv has it all. Sit down to a posh dinner, visit a charming cafe, or enjoy a drink at a chic bar, before you end off your evening with a concert that promises no shortage of exquisite music.
// 							</p>
// 							<p>
// 							  André Rieu has become one of the most popular live acts around the world and Tel Aviv is about to find out why! Make sure you don’t miss out on the experience!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:46,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Foreigner",
//         smltitle: "Foreigner Returning to Israel in May!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											05.05.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.foreigneronline.com/">
// 											 www.foreigneronline.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/46/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 Foreigner Returning to Israel in May!
// 							</p>
// 							<p>
// 								Popular British hard rock band, Foreigner, is returning to Tel Aviv in May 2018. After recently playing 2 concerts in Caesarea, the band will now be performing in the entertainment capital of the country, Tel Aviv.
// 							</p>
// 							<p>
// 							Since being founded in 1976 by Mick Jones, Foreigner has sold nearly 80 million albums across the globe. It reached the height of its popularity in the 1980s, with some of its most well-known hits including “I Want to Know What Love Is,” “I Don’t Want to Live Without You,” “That Was Yesterday” and “Waiting for a Girl Like You.”
// 							</p>
// 							<p>
// 							With the band performing at the Menora Mivtachim Arena in Tel Aviv, fans and visitors will be able to make the most of the concert and enjoy the vibe and energy of the city. Soak up the rays on the beach as the summer sun starts to make an appearance or spend the day in one of the many museums or exhibitions of the city.
// 							</p>
// 							<p>
// 							 You will be transported back to the 80’s with this popular band, while enjoying the best that Tel Aviv has to offer. Don’t miss out on the great nightlife of the clubs and pubs after the show, as you complete your evening with style!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:47,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Don Mclean",
//         smltitle: "Enjoy a Piece of “American Pie” in June!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											16.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://don-mclean.com/">
// 											 www.don-mclean.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/47/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Enjoy a Piece of “American Pie” in June!
// 							</p>
// 							<p>
// 								Famous American songwriter, Don McLean, will perform in the outskirts of Tel Aviv in June, 2018. After almost 60 years of career, McLean remains most famous for his hit song, American Pie, which came out in 1972 and is still covered by big names in the industry, such as Madonna.
// 							</p>
// 							<p>
// 							   McLean has released 40 gold and platinum records, but it is his attachment to Israel that makes him so popular here. This is particularly clear with his song, Jerusalem, which he wrote in support of the country. This time, he will be performing closer to the entertainment capital of Israel, Tel Aviv.
// 							</p>
// 							<p>
// 							    With the show taking place only 10 minutes from the hustle and bustle of the lively city, there are plenty of options for fans to make a full day of the concert. Visit one of a number of world-class museums or take in one of the many temporary exhibitions that come to the city. If you’re looking for food, there is certainly no shortage in Tel Aviv with a range of styles and tastes to suit all visitors. Soak up the sun as summer begins to arrive or enjoy the sounds and scenes of the nightlife that Tel Aviv is famous for.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:48,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Enrique Iglesias",
//         smltitle: "Tel Aviv to Host Spanish Pop Legend!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											28.05.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://enriqueiglesias.com/">
// 											 www.enriqueiglesias.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/48/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Tel Aviv to Host Spanish Pop Legend!
// 							</p>
// 							<p>
// 								Spanish pop legend, Enrique Iglesias, will be returning to Israel for his fourth visit, this time to perform at the Yarkon Park in Tel Aviv. While this won’t be his first time in the entertainment capital of the country, it is expected to be his largest performance to date.
// 							</p>
// 							<p>
// 							  This visit comes close on the heels of the Hebrew remix of his popular piece, “Subleme La Radio,” together with Israeli singer, Rotem Cohen. Concert-goers can look forward to hearing some of Iglesias’ hit songs which may include “Bailamos,” “Hero,” “Be With You” and “I Like It.” He is expected to perform together with his long-time guitarist, Israeli Sean Hurwitz.
// 							</p>
// 							<p>
// 							   Iglesias is predicted to be one of the most popular concerts of the year judging by the fact that it will be held in the Yarkon Park venue which can accommodate up to 100,000 people. Those looking to make a whole evening of the event will find plenty to keep them entertained in Tel Aviv before the concert starts.
// 							</p>
// 							<p>
// 							    With a wide range of eateries and pubs, there is something to suit all tastes. Enjoy the limitless choices when it comes to restaurants and pick up the vibe of the city before heading off to the main event.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:49,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Blood Sweat and Tears",
//         smltitle: "Blood, Sweat & Tears Headed to Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											22.10.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//bloodsweatandtears.com/">
// 											 www.bloodsweatandtears.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/49/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   Blood, Sweat & Tears Headed to Tel Aviv!
// 							</p>
// 							<p>
// 								Legendary rock band, Blood, Sweat & Tears, is heading to Israel for one concert to be held in Hangar 11 in Tel Aviv. The band was last in Israel 10 years ago when they played in Tel Aviv and Caesarea.
// 							</p>
// 							<p>
// 							  Established in 1967 in New York City, their best-known hits include “I Love You More than You’ll Ever Know,” “I Cannot Quit Her,” “When I Die” and “You’ve Made Me So Very Happy.” There are no original members of the band left, but seven current members will take to the stage when they perform in March. These include lead vocalist and popular runner-up to American Idol in 2005, Bo Bice.
// 							</p>
// 							<p>
// 							   Tel Aviv promises a full day of excitement for concert-goers with the opportunity to enjoy the beautiful beaches, parklands and entertainment options that the city offers before the concert even begins. Make sure to eat in one of the many restaurants scattered around the city and immerse yourself in the character of Tel Aviv by visiting one of the popular pubs or clubs that make up its charming nightlife.
// 							</p>
//                             <p>
//                                 Create the perfect night out as you combine the atmosphere of Tel Aviv with jazz and rock in a unique concert from Blood, Sweat & Tears.
//                             </p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:50,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Jamiroquai",
//         smltitle: "Jamiroquai Heads to Israel in May!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											02.05.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.jamiroquai.com/">
// 											 www.jamiroquai.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/50/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Jamiroquai Heads to Israel in May!
// 							</p>
// 							<p>
// 								British band, Jamiroquai, is heading to Israel in May 2018, where they will perform in the outskirts of the bustling city of Tel Aviv. With only one performance in Israel, the popular band from the 90s is expected to attract a large crowd.
// 							</p>
// 							<p>
// 							  The band has published 8 studio albums, with “Automaton” being their latest from 2017. The hip city of Tel Aviv is the ideal location for a concert that promises an exciting performance by the group that introduced “future funk” and took the world by storm. Founded in 1992 by Jay Kay, Jamiroquai holds the Guinness Book of World Records listing for “Best Selling Funk Album” of all time.
// 							</p>
// 							<p>
// 							   Anyone looking for a lively night out will do well to head to this concert. Being held a short drive from the center of Tel Aviv, concert-goers will be able to begin the party early at one of the city’s top-notch restaurants, clubs or pubs. Start your evening with a quality dinner at any one of dozens of stylish restaurants and then move onto one of Tel Aviv’s famous clubs before making your way to the concert for an unforgettable night out.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:51,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Backstreet Boys",
//         smltitle: "The Backstreet Boys are Back and Larger Than Life",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											22.04.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.backstreetboys.com/">
// 												www.backstreetboys.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/51/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    The Backstreet Boys are Back and Larger Than Life
// 							</p>
// 							<p>
// 									The Backstreet Boys will be back in Israel this year for a concert. To be held in the outskirts of Tel Aviv in April, concert-goers will be able to enjoy the incredible vibe of the city together with some of the greatest hits in history.
// 							</p>
// 							<p>
// 									Tel Aviv is one of the most sought-after locations for big names in the entertainment industry, with its energy, vitality and spirit. There is no shortage of eateries, pubs and coffee shops for those looking for a culinary experience. Or, if you prefer to make a full day of it, you can visit some of the world-class museums, theaters or galleries around the city.
// 							</p>
// 							<p>
// 									Formed almost 20 years ago, the Backstreet Boys have produced 7 multi-platinum albums and sold more than 130 million records worldwide, with some of their most popular hits such as “I Want It That Way,” “As Long as You Love Me” and “Larger Than Life”.
// 							</p>
// 							<p>
// 									Visitors heading to the concert will be able to enjoy Tel Aviv at its best with beautiful Spring weather enticing locals and guests to the beach, before making their way to hear the best-selling boy band of all times!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:52,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Alice in Chains",
//         smltitle: "Alice in Chains Announces Debut Show in Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											17.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.aliceinchains.com/">
// 												www.aliceinchains.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/52/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Alice in Chains Announces Debut Show in Tel Aviv
// 							</p>
// 							<p>
// 									Making their debut appearance in Israel, rock band and grunge pioneer, Alice in Chains, will perform in July, north of Tel Aviv, in what promises to be an electrifying concert.
// 							</p>
// 							<p>
// 									Having come together in the late 80’s, Alice in Chains is one of four major groups that led the grunge revolution, and they became one of the most influential bands of all time. With music that combines rock, alternative rock and metal, the band was nominated for 9 Grammy awards and sold more than 20 million albums.
// 							</p>
// 							<p>
// 									Taking place in the middle of summer, Tel Aviv is the perfect location to start the day’s activities. If you’re looking for some indoor entertainment, visit one of the city’s world-class museums or galleries, or head over to one of the many restaurants around the city. For something a bit different, soak up the rays walking along the promenade of a beautiful beach or pop into a club or pub in the area before heading north for the concert.
// 							</p>
// 							<p>
// 									This show is part of the first European tour the band has been on in four years, and being its first appearance ever in Israel, it promises to be a night full of excitement.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:53,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Hardwell",
//         smltitle: "Hardwell Headed to Israel in April",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											06.04.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.djhardwell.com/">
// 												www.djhardwell.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/53/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Hardwell Headed to Israel in April
// 							</p>
// 							<p>
// 									Number 1 ranking DJ, Hardwell, is coming to Israel in April where he will thrill crowds just outside Tel Aviv. This will be his third concert in the country, after performing to sell-out audiences in 2013 and 2017.
// 							</p>
// 							<p>
// 									Robbert van de Corput, better known as DJ Hardwell, first made a name for himself at the young age of 14, but it was at age 25 when he truly became famous, named World’s #1 DJ by the 2013 DJ Mag. Hardwell has become an International name, hosting his own radio show which is broadcast around the world, and producing a consistently top 10 iTunes podcast. He is also well known for his remix of The Wanted’s “Chasing the Sun”.
// 							</p>
// 							<p>
// 									Tel Aviv is the ideal location for a concert of this type with the natural vibe and energy of the city adding to the excitement that will be in the air. Tel Aviv in Spring is full of blue skies and warm weather, attracting crowds to the beach and the outdoor cafes and restaurants that can be found throughout the city. Enjoy a full day out or join the gathering of people at one of the city’s world-class restaurants before heading to the concert.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:54,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Jethro Tull",
//         smltitle: "Jethro Tull’s 50th Anniversary Tour Heads to Israel",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv and Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											27-28.10.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.jethrotull.com/">
// 												jethrotull.com/
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/54/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Jethro Tull’s 50th Anniversary Tour Heads to Israel
// 							</p>
// 							<p>
// 									Ian Anderson, vocalist, flutist, and guitarist of the popular British rock band, Jethro Tull, is coming to Israel for the band’s 50th anniversary tour. Performances will take place at Heichal Hatarbut in Tel Aviv on October 27, followed by the International Convention Center in Jerusalem on October 28.
// 							</p>
// 							<p>
// 									Formed in 1967, the band initially played blues rock, but later evolved and developed elements of hard rock. Their greatest success came in the 1970s with hit songs such as “Bungle In The Jungle,” “Living In The Past,” and “The Witch’s Promise.” The band has performed in Israel numerous times in the past, and Anderson who is the only remaining member of the band who is coming on tour, is expected to receive a warm welcome.
// 							</p>
// 							<p>
// 									Performing in both Tel Aviv and Jerusalem will appeal to a wide audience. Join the energy and vibe of the lively city of Tel Aviv with its nightlife, culinary experiences and beautiful beaches, or enjoy the concert in the cultural and historic center of the country, which is Jerusalem. No matter which flavor of the region you prefer, there are plenty of restaurants, cafes, museums or galleries to visit in each of the cities before the venues open their doors.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:55,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Israel Calling",
//         smltitle: "Good Evening Europe, This is Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											08-10.04.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 						<!--	<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="">
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>-->
// 							<h2>
// 							   Good Evening Europe,<br class="show-on-mobile"> This is Tel Aviv!
// 							</h2>
// 							<p>
// 								Eurovision fever is sweeping over Tel Aviv as it confirms hosting the star and glitter studded event - “Israel Calling”, for the 3rd consecutive year!
// 							</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/55/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								About 30 delegates from Eurovision participating countries worldwide will be gathering at the beginning of April in the nonstop city of Tel Aviv, for the largest Eurovision promo-event to ever take place in front of a crowd of thousands from Israel and around Europe.
// 							</p>
// 							<p>
// 								This unique and exciting event, held only in Tel Aviv, will give Eurovision fans from far and wide an amazing and completely free of charge opportunity to take part in the glamour of the Eurovision right here in the beautiful city of Tel Aviv.
// 						</p>
// 						<div class="img-wrapper">
// 							<img src=${getImgUrl() +  "/Concerts/55/2.jpg"} class="img-responsive" />
// 						</div>
// 						<p>
// 						The event will be held for three days starting on the 8th of April. The main stage will be set in Rabin Square, Tel Aviv’s main square and one of the city’s favorite outdoor venues, located at the heart of the buzzing city.
// 						</p>
// 						<p>
// 						The main event will take place on Tuesday and will include a mini Eurovision show in front of a live audience, featuring performances by the various Eurovision contenders performing the songs they will be competing with on the main event in May.
// 						</p>
// 						<p>
// 						This much anticipated pre-Eurovision event is set to take place just a few minutes’ walk from the stunning Tel Aviv beach. Fans and music lovers coming to see the show will get to take in all the city has to offer, including the excellent bars, restaurants and the awesome nightlife in this world-famous ultimate vacation destination called Tel Aviv.
// 						</p>
// 						<div class="img-wrapper">
// 							<img src=${getImgUrl() +  "/Concerts/55/3.jpg"} class="img-responsive" />
// 						</div>
// 						`
// 			}
// 		}
//     },
//     {
//       id:56,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Clean Bandit",
//         smltitle: "Clean Bandit Announces First Visit to Israel",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											26.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//cleanbandit.co.uk/">
// 												cleanbandit.co.uk
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/56/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   Clean Bandit Announces First Visit to Israel
// 							</p>
// 							<p>
// 									British electro-pop group, Clean Bandit, which has become one of the leading dance acts around the world, has announced their debut performance in Israel. Visiting as part of their European tour, the band will play on the outskirts of Tel Aviv on June 26.
// 							</p>
// 							<p>
// 									Formed in 2008, they became well-known for merging classical instruments and pop with a unique and masterful outcome and they became a sensation with their smash hits “Rather Be,” “Real Love,” “Rockabye,” and “Symphony.” Since its release in 2016, “Rockabye” has been viewed almost 2 billion times on YouTube, while they won a Grammy for “Rather Be” in 2015.
// 							</p>
// 							<p>
// 									The band has been together for ten years and has seen incredible success in the that time. Join the throngs of people heading to Tel Aviv for the group’s first visit.
// 						    </p>
// 						    <p>
// 									Tel Aviv is just the venue for the unforgettable night that this concert offers. With cafes, bars, clubs, and pubs throughout the city, there is no shortage of activities in Tel Aviv. Known as “the city that doesn’t stop”, you can take advantage of the buzz of the nightlife and enjoy the vibe of the bustling beachfront at any hour before or after the concert.
// 						    </p>
// 						`
// 			}
// 		}
//     },
//     {
//        id:57,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Alanis Morissette",
//         smltitle: "Alanis Morissette to Turn Up The Heat with Summer Performance in Israel",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											30.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//alanis.com/">
// 												alanis.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/57/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   Alanis Morissette to Turn Up The Heat with Summer Performance in Israel
// 							</p>
// 							<p>
// 									Canadian singer and songwriter, Alanis Morissette, will return to Israel in the summer for one show which will take place on the outskirts of the lively city of Tel Aviv. Morissette has performed in Israel a number of times, including in 2000 and 2012, since she released her first album, “Jagged Little Pill” in 1995.
// 							</p>
// 							<p>
// 									The popular alternative rock singer is expected to rock Tel Aviv with some of her top hits, including “All I Really Want,” “Hand in My Pocket,” “Head Over Feet,” “Ironic,” “You Learn,” and “You Ought to Know.” Having taken home seven Grammy Awards and with eight albums having sold more than 60 million copies across the globe, her upcoming visit is already causing much excitement.
// 							</p>
// 							<p>
// 									The Tel Aviv area is the perfect location for a concert of this calibre, with visitors to the city given an exceptional choice of wining, dining and entertainment options. Begin your night at one of the many world-class restaurants or head out to one of the quaint coffee shops or bustling bars to end off your evening. The music scene will be hotter than ever with Alanis Morissette this July!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//        id:58,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Marc Almond",
//         smltitle: "Marc Almond’s Amazing Summer Concert",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											14.08.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.marcalmond.co.uk/news/index.html">
// 												marcalmond.co.uk
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/58/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   Marc Almond’s Amazing Summer Concert
// 							</p>
// 							<p>
// 									English musician, Marc Almond, will be heading to Israel in the summer for a much-awaited concert. The singer, who is most famous for his part in the new wave duo Soft Cell, will be playing north of Just north of the nonstop city of Tel Aviv in August.
// 							</p>
// 							<p>
// 									Soft Cell became famous for its 80’s hits “Tainted Love,” “Torch,” “Say Hello, Wave Goodbye,” and others, while Almond’s solo career took off when the duo split in the mid-80’s with hits including “Jacky” and “Something’s Gotten Hold of My Heart.” In another tribute to the decade, the Israeli rock group, Tattoo, which broke up in 1989, will open the concert in a historic reunion.
// 							</p>
// 							<p>
// 									Fans have been waiting for this performance since 2011, when his planned concert was canceled due to technical reasons. The 2018 concert promises to be an experience to remember.
// 							</p>
// 						    <p>
// 									From music to art, culture to fun, Tel Aviv has something for everyone. Spend the day wandering the vibrant streets of the city or pop into one of the many museums, theatres or galleries downtown. Make sure to stop off for a bite to eat at any of the city’s many world-class restaurants so you’ll be energized for what is sure to be an awesome concert.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:59,
//         bgImage:"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title : "Shakira",
//         smlTitle : "Shakira to heat up the summer in sizzling Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											09.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.shakira.com/">
// 												shakira.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/59/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  Shakira to heat up the summer in sizzling Tel Aviv
// 							</p>
// 							<p>
// 									The worldwide sensation Shakira is set to perform for the first time on the big stage in Tel Aviv this coming July and the city’s a buzz. The 41-year-old Colombian superstar who has sold close to 200 million albums and has won over 250 awards including three Grammys is just the perfect fit for a summertime concert in Tel Aviv.
// 							</p>
// 							<p>
// 									With a long and illustrious list of hit songs, including “Waka-Waka”, “Chantage” and “Whenever, whenever” Shakira is one of the most celebrated artists in the world today and nearly every song she records tops the international charts and receives hundreds of millions of Youtube views.
// 							</p>
// 							<p>
// 									Shakira’s concert is due to be held on July 9th in Yarkon Park, Tel Aviv’s massive park also dubbed the city’s “Green Lung”, which boasts, in addition to beautiful greenery, a stunning lake and excellent bike trails, a huge outdoor live music venue.
// 							</p>
// 							<p>
// 							        The party atmosphere of the nonstop city in July, the beautiful beaches and amazing nightlife and cool street vibe, all set the scene for perfectly Shakira’s show-stopping style and what is guaranteed to be an explosive musical celebration in the heart of cool city of Tel Aviv.
// 							</p>
// 	                    `
// 			}
// 		}
//       },
//   //     {
//   //     id: 60,
//   //     bgImage:"/posts/bank/16/1.jpg",
//   //     mobBgImage:"/posts/bank/16/M.jpg",
//   //     title: "White Night TLV",
//   //     smlTitle: "A “White Night” Rager In the Non-Stop City!",
//   //     html: function(){
// 		// 	return {
// 		// 		__html: `
// 		// 					<h2 class="align-center">
// 		// 					   16.05.2019
// 		// 					</h2>
// 		// 					<h1 class="align-center">
// 		// 					   A “White Night” Rager In the<br class="show-on-mobile"/> Non-Stop City!
// 		// 					</h1>
// 		// 					<div class="responisve-iframe">
// 		// 						<iframe width="560" height="315" src="https://www.youtube.com/embed/T0ugqxG5UaM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
// 		// 					</div>
// 		// 					<p>
// 		// 						When a city renowned across the world as the “City that never sleeps” holds an event like “White Night” – you know you’re in for a treat. “White Night”, one of Tel Aviv’s biggest events of the year, is a traditional annual citywide celebration which keeps the city up all night – everything is open and everything is happening across the city at the same time…
// 		// 					</p>
// 		// 					<p>
// 		// 						From the early evening and until dawn, the city becomes packed with tourists and locals, high on life and enjoying everything on offer, from shops and eateries to cinemas and culture venues – free of charge or at reduced rates, all night long!
// 		// 					</p>
// 		// 					<div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/60/1.jpg"} class="img-responsive" />
// 		// 					</div>
// 		// 					<small>
// 		// 						Photo By: Adam Primer
// 		// 					</small>
// 		// 					<p>
// 		// 						The origin of this now world-famous event dates back to 2003 when UNESCO declared the "White City", Tel Aviv’s largest architectural collection of Bauhaus style buildings a world cultural heritage site, giving it a unique status in the architectural heritage of the modern era.
// 		// 					</p>
// 		// 					<p>
// 		// 						This historic declaration has been celebrated yearly ever since by Tel Aviv-Jaffa in a series of white night events, named after the "White City" and Tel Aviv’s other well-known characteristic: being “The City That Doesn’t Stop”.
// 		// 					</p>
// 		// 					<div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/60/2.jpg"} class="img-responsive" />
// 		// 					</div>
// 		// 					<small>
// 		// 						Photo By: Kfir Sivan
// 		// 					</small>
// 		// 					<p>
// 		// 						The White Night is a celebration of numerous events held throughout the city, which seems to expand with every passing year. In recent years, the celebrations  included (to name just a few): a unique midnight public picnic, an epic headphones party in the city’s main square, countless live music concerts, amazing indoor as well as street theatre performances, fascinating nighttime tours, night sports classes , Yoga at sunrise, and of course countless epic parties, all taking place all night across the city at the same time.
// 		// 					</p>
// 		// 					<div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/60/3.jpg"} class="img-responsive" />
// 		// 					</div>
// 		// 					<small>
// 		// 						Photo by Moshik Lindenbaum
// 		// 					</small>
// 		// 					<p>
// 		// 						So you better get your rest on- you’re gonna need all your energy to keep up with “White Night” in the awesome city of Tel Aviv!
// 		// 					</p>
// 		// 					<div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/60/4.jpg"} class="img-responsive" />
// 		// 					</div>
// 		// 					<small>
// 		// 						Photo by: Guy Yechiely‎.
// 		// 					</small>
// 		// 			               `
// 		// 	}
// 		// }
//   //   },
//       {
//       id: 60,
//       bgImage:"/posts/bank/16/1.jpg",
//       mobBgImage:"/posts/bank/16/M.jpg",
//       title: "White Night TLV",
//       smlTitle: "All Night Citywide party in Tel Aviv on Eurovision Semifinal!",
//       html: function(){
// 			return {
// 				__html: `
// 							<h2 class="align-center">
// 							   16.05.2019
// 							</h2>
// 							<h1 class="align-center">
// 							   All Night Citywide party in Tel Aviv on Eurovision Semifinal!
// 							</h1>
// 							<div class="responisve-iframe">
// 								<iframe width="560" height="315" src="https://www.youtube.com/embed/T0ugqxG5UaM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
// 							</div>
// 							<p>
// 								When a city renowned across the world as the “City that never sleeps” holds an event like “White Night” – you know you’re in for a treat, and this year the treat is going to be especially epic!
// 							</p>
// 							<p>
// 								As part of the warm and exciting welcome awaiting visitors during Eurovision week, the powers that be have decided to combine Tel Aviv’s annual “White Night” extravaganza with the Eurovision Semifinal set to be held on 16.05.2019.
// 							</p>
// 							<p>
// 								“White Night”, one of Tel Aviv’s biggest events of the year, is a traditional annual citywide celebration which keeps the city up all night – everything is open, and everything is happening throughout the city simultaneously.
// 							</p>
// 							<p>
// 								The origin of this now world-famous event dates back to 2003 when UNESCO declared the "White City as a world cultural heritage site, setting off annual citywide celebration in a series of white night events in the city that (truly) doesn’t sleeps.
// 							</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/1.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo By: Adam Primer
// 							</small>
// 							<p>
// 								From the early evening and until dawn, the city becomes packed with tourists and locals, high on life and enjoying everything on offer, from shops and eateries to cinemas and culture venues – free of charge or at reduced rates, all night long!
// 							</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/2.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo By: Kfir Sivan
// 							</small>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/3.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo by Moshik Lindenbaum
// 							</small>
// 							<p>
// 								So you better get some rest - you’re gonna need all your energy to keep up with “White Night” in the awesome city of Tel Aviv!
// 							</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/4.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo by: Guy Yechiely‎.
// 							</small>
// 					               `
// 			}
// 		}
//     },
//     {
//         id:61,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Brian Wilson",
// 	    smlTitle: "The legendary Brian Wilson returning to rock Tel Aviv!",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											07.08.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.brianwilson.com/">
// 												brianwilson.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/61/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 The legendary Brian Wilson returning to rock Tel Aviv!
// 							</p>
// 							<p>
// 									He returns to the white city with Al Jardine and Blondie Chaplin as a part of his world tour that celebrates his biggest hits from the last 54 years. The Beach Boys is one of the world’s most successful bands, the band has won many Grammy awards, got their own star in Hollywood and entered the Rock N’ Roll hall of fame.
// 							</p>
// 							<p>
// 									The band sold over 100 million records over the years and produced more hits than any other American band. They’re known especially for their hits “God Only Knows”, “Get Around”, “California Girls” and “Good Vibrations”. Wilson’s solo career is also successful, he recorded 11 albums and won 2 Grammy awards.
// 							</p>
// 							<p>
// 									Wilson’s concert will take place in Tel Aviv on August’s 7th. The summertime provides long daylight hours that give visitors the perfect opportunity to see what Tel Aviv has to offer; from an incredible art scene to fantastic theatres, to phenomenal live music shows and world-class restaurants – there are so many options in the spectacular city of Tel Aviv for  everyone will to find their brand of fun and excitement in the nonstop city.
//                             </p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 62,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Jason Derulo and Rita Ora",
// 	    smlTitle: "Jason Derulo and Rita Ora to raise it up in Tel Aviv!",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											The outskirts of Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											01.08.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.jasonderulo.com/">
// 												jasonderulo.com
// 											</a><br>
// 											<a target="_blank" href="//ritaora.com/">
// 												ritaora.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/62/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 						         	Jason Derulo and Rita Ora to raise it up in Tel Aviv!
// 							</p>
// 							<p>
// 									The two mega pop stars will perform at the “Lollipop” festival that will take place at the outskirts of Tel Aviv on the first of August. Derulo, that made his big breakthrough in 2009 with the hit “Whatcha Say”, became over the last decade one of the biggest stars in the international music industry with his huge hits such as “Wiggle”, “Want to Want Me”, “Swalla”, “Tip Toe” and “Talk Dirty”. The popular British Pop star, Rita Ora, is known especially for her famous hits “I Will Never Let You Down”, “Anywhere”, “R.I.P” and “Hot Right Now”.
// 							</p>
// 							<p>
// 									The festival provides a great opportunity to explore the city that never sleeps and enjoy its famous nightlife scene – from world-class bars, to secret underground clubs, to live music shows and various culinary options and even alternative art galleries, Tel Aviv for sure has something for everyone to enjoy. Whether you’re following a map or letting yourself get lost in the streets, you’re sure to fall in love with Tel Aviv!
// 							</p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 63,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Julio Iglesias",
// 	    smlTitle: "The Latin legend returning to wow Tel Aviv!",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											06.10.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.julioiglesias.com/">
// 												julioiglesias.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/63/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 						             The Latin legend returning to wow Tel Aviv!
// 							</p>
// 							<p>
// 									Tel Aviv can’t wait for the return of the beloved Spanish star! With a great cultural scene, incredible culinary options, amazing beaches, phenomenal museums and galleries and plenty of unique spots to explore – those who come to enjoy Iglesias’s concert have plenty of different ways to spend their time in the cultural capital.
// 							</p>
// 							<p>
// 									The hot climate and long daylight hours just reminiscent of the phenomenal singer’s origin country, Tel Aviv offers a variety of options that suit all ages and therefore attracts a big amount of visitors all around the year.
// 							</p>
// 							<p>
// 							        Iglesias has an ongoing love affair with the nonstop city and his past shows were sold out. He’s one of the most successful singers in the history and during his career became a phenomenal success story all around the world. He has 77 different albums that sold over 300 million copies!
// 							</p>
// 							<p>
// 							         Many of the Spanish phenomenon’s hits have reached the top of the charts and he won numerous awards, such as the Grammy. His fans are incredibly excited about his return and tickets are selling like hot falafels. This is guaranteed to be a show to remember!
// 							</p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 64,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Maluma",
// 	    smlTitle: "The Reggaeton sensation returns to the white city!",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											28.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//fame.malumaofficial.com/">
// 												fame.malumaofficial.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/64/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 						           The Reggaeton sensation returns to the white city!
// 							</p>
// 							<p>
// 									After winning over the crowd’s hearts during his last visit, the Colombian reggaetón singer and songwriter Juan Luis Londoño Arias, better known by his stage name Maluma returns to the city that never stops for one show only!
// 							</p>
// 							<p>
// 									Maluma has several singles that have charted within the top 10 on Billboard Hot Latin Songs, including "Felices los 4", "Borro Cassette", "El Perdedor" and "Corazón". During his career he won several awards, among which there is MTV Europe’s award for best world tour. The phenomenal performer is known among his fans as “the Latin lover” despite being only 24 years old.
// 							</p>
// 							<p>
// 							       His show will be held on June’s 28th in HaYarkon Park, located in the heart of Tel Aviv. Fans from all over the world who come to the show can enjoy the lovely beaches the city has to offer, the variety of restaurants and cafes, the remarkable art scene, the world-class bars and clubs, the various shopping venues spread all across the city – Tel Aviv has something for everyone.
// 						    </p>
// 							<p>
// 							         The Latin superstar is known to be quite a charmer and win everyone over in his shows – don’t miss this fantastic mix of Maluma and Tel Aviv -  come see the legend live in the hot hot city!
// 						    </p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 65,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Martin Garrix",
// 	    smlTitle: "The 1# DJ comes to the nonstop city!",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											10.09.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Weitere Informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.martingarrix.com/">
// 												martingarrix.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/65/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 						           The 1# DJ comes to the nonstop city!
// 							</p>
// 							<p>
// 									Martin Garrix , hailed as “the world’s best DJ” by DJMag is coming to get the party going in the nightlife capital of the middle east! With tons of world known clubs, bars, pubs and a one of a kind atmosphere, Tel Aviv is known for its vibrant vibe and incredible night scene.
// 							</p>
// 							<p>
// 									At 20 years old, the Dutch wonderkid is coming at the height of his career for one unforgettable show in Tel Aviv! The international hits machine became famous when he was only 17 and since then has released many loved tracks and climbed the charts all over the world.
// 							</p>
// 							<p>
// 							       Garrix is considered by many is the undeniable king of the industry. With remarkable hits such as “Animals”, “Tremor”, “In the Name of Love” and “Scared to Be Lonely”, the phenomenal DJ is one of the most popular performers in the world and is a must-have headliner for every well-known festival.
// 							</p>
// 							<p>
// 							        The show will be held in HaYarkon Park, in the heart of the awesome city, on September 10th. The international vibe, gorgeous location and great nightlife scene attract an extraordinary crowd that comes from different corners of the world and is guaranteed to make this show a once in a lifetime experience!
// 						    </p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 66,
// 	    bgImage:"/posts/bank/59/1.jpg",
// 	    mobBgImage:"/posts/bank/59/M.jpg",
// 	    title: "Eurovision Tel Aviv",
// 	    smlTitle: "Epic song contest in the Non-Stop City",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											14-18.05.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<!--<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="">
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>-->
// 							<h3>A once in a lifetime opportunity to visit Tel Aviv as it hosts the Eurovision song contest.</h3>
// 							<p>
// 						     Epic song contest in the Non-Stop City
// 							</p>
// 							<p>Semi-final 1: 14 May 2019</p>
//                             <p>Semi-final 2: 16 May 2019</p>
//                             <p>Grand Final: 18 May 2019</p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/67/1.svg"} class="img-responsive" />
// 							</div>
//                             <p>It’s getting hot hot hot in Fabulous Tel Aviv! The nonstop city is teaming with excitement as it is getting ready to host the 2019 Eurovision Song Contest in what promises to be one of the most epic events ever held in the famous party city. </p>
//                             <p>Tel Aviv, known for its amazing energy, stunning beaches, great year round weather and gorgeous people, is the perfect destination for an unforgettable citybreak.  Tel Aviv is known world over for its open mindedness and liberal spirit, making it the ideal host for the Eurovision song contest, offering visitors from far and wide the perfect opportunity to enjoy this vibrant and energetic city at its finest. </p>
//                             <div class="img-wrapper">
// 							    <img src=${getImgUrl() + "/Concerts/67/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>Major productions centered around the Eurovision contest month are already well on their way. Some of the exciting events planned include an amazing opening ceremony, a prestigious red-carpet event, and even a mega “Euro Village” which will be situated merely a minutes’ walk from the awesome Tel Aviv baordwalk and beach. The Euro Village will be open for 10 days and will include live performances from past and present mega stars as well as live screenings of the Eurovision contest’s semifinal and final. The contest itself will take place in the Expo Tel Aviv. </p>
//                             <p>The Eurovision Song contest in Tel Aviv is guaranteed to be an event of a lifetime, so make sure to book your trip now to the most amazing Eurovision contest yet, in the most amazing city of all! </p>
// 					               `
// 			}
// 		}
//     },
//    {
//         id: 68,
// 	    bgImage:"/posts/bank/68/1.jpg",
// 	    mobBgImage:"/posts/bank/68/M.jpg",
// 	    title: "",
// 	    smlTitle: "36 Years of Cinema Magic!",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											25.07-04.08.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.jff.org.il/en">
// 												www.jff.org.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Jerusalem Film Festival (JFF)</h2>
// 							<p>Time to start preparing your Summer 2019 checklist: Buy suntan lotion, pick wildflowers, host a barbeque, make plans to attend the 36th Annual Jerusalem Film Festival! It’s 11 days, over 200 films, prizes awarded to the very best, and you’ll be a part of it all! From star-studded international features to independent productions and the best of Israeli cinema, this unique film fest showcases excellence from various genres. </p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/68/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>Take advantage of the opportunity to meet festival guests, including world-renown stars, writers, directors, cinematographers and other movie-making professionals. Film enthusiasts will enjoy Jerusalem’s many cinema spaces and be delighted by JFF on the Go, which presents films under the stars throughout the festival, and Cinema Park, which includes a 300 square meter pool with rubber boats, a giant LED screen, and a concert stage featuring live musical performances nightly. </p>
//                             <p>As you travel across the city to attend screenings, workshops, master classes, parties, musical shows and other festival events, you’ll experience how ancient cultures give modern spice to the contemporary vibe and personality of this global city. Fill your spare time strolling through neighborhood streets, exploring local shops, and taking your pick of Jerusalem’s wide variety of restaurants and cafes. You may have attended other film fests, but you won’t find one quite like this and, certainly, none other can boast the grandeur of the eternal City of Peace! </p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 69,
// 	    bgImage:"/posts/bank/69/1.jpg",
// 	    mobBgImage:"/posts/bank/69/M.jpg",
// 	    title: "",
// 	    smlTitle: "Jerusalem Wine Festival (JWF)",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											01-31.08.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.imj.org.il/en/events/wine-festival-1">
// 												www.imj.org.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Jerusalem Wine Festival (JWF)</h2>
// 							<p>
// 								Relaxing summer evenings were made for an exquisite glass of fine wine! And for four days in August, you can enjoy world class selections and award-winning food at the 16th Annual JWF. Hosted in the beauty of the Japanese Art Garden of the Israel Museum, this is considered by many to be Jerusalem’s premiere social event. It’s a wine festival unlike any other, whose ambiance and stunning views of this historic city combine to make the JWF a not-to-be-missed experience.
// 							</p>
//                            <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/69/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Hundreds of wines will be served by dozens of well-known and boutique wineries. There’ll be free wine tasting opportunities, along with a culinary oasis of stalls offering cheeses, chocolates, olive oils, exceptional sauces, and tasty jams. And speaking of tasty jams, the festival will get your party started every night with two different live music concerts.
// 							</p>
//                            <p>
// 								Every year, the JWF welcomes a diverse and refined crowd of over 20,000 wine and culture lovers to Jerusalem. Many attend over multiple evenings simply to soak in the atmosphere. You could even build your stay in the city around the festival! Certainly, your days will be filled with sightseeing, shopping, and loads of walking about. The perfect way to unwind after your busy days might well be several fun-filled nights at the Jerusalem Wine Festival!
// 							</p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 70,
// 	    bgImage:"/posts/bank/70/1.jpg",
// 	    mobBgImage:"/posts/bank/70/M.jpg",
// 	    title: "OPEN RESTAURANTS TLV",
// 	    smlTitle: "Feed Your Curiosity!",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											2019 y.
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://open-restaurants.co.il/?lang=en">
// 												open-restaurants.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Feed Your Curiosity!</h2>
// 							<p>
// 								Ever wanted to get more than a taste of what gets created in a truly fine restaurant? Have you ever fantasized about what it would be like to be a top chef? Well, now’s your chance!
// 							</p>
// 							<p>
// 								OpenRestaurants is more than a culinary event, it’s a cultural happening that showcases Tel Aviv’s wide array of restaurants, chefs, and local culinary personalities. Guests get to meet with chefs from around the city, wander through open markets, and try their hands at cooking up flagship dishes under the supervision of first-class professionals. It’s your opportunity to experience a day in the life of the sophisticated chefs, line cooks, restaurateurs, food vendors, and others who make gastronomy in Tel Aviv as palate pleasing as it is.
// 							</p>
//                            <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/70/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Beyond peeking behind many kitchen curtains, OpenRestaurants hosts a range of events that include curated dinners, history presentations, and exhibitions of culinary-themed art, design, music, and technology!
// 							</p>
//                            <p>
// 								Many events are available at no charge, including the Culinary Innovation Summit, the Food & Hospitality Hackathon, and various food talks. There are also family-oriented events that focus on cooking activities for children and several market tours.
// 							</p>
//                            <p>
// 								Everyone’s gotta eat and there’s no one who doesn’t enjoy good food that’s well prepared. So, whether you like to understand the process behind the preparation, you like to do the preparing, or you just have a hearty appetite, there’ll be plenty to delight your senses at OpenRestaurants: Tel Aviv!
// 							</p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 71,
// 	    bgImage:"/posts/bank/71/1.jpg",
// 	    mobBgImage:"/posts/bank/71/M.jpg",
// 	    title: "CULINARY FESTIVAL",
// 	    smlTitle: "Round Tables Culinary Festival",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											09-23.11.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://open-restaurants.co.il/?lang=en">
// 												open-restaurants.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Round Tables Culinary Festival</h2>
// 							<p>
// 								The 4th edition of this celebrated culinary experience that brings renowned chefs from around the globe and invites them to take over the kitchens of several of Tel Aviv’s most notable restaurants.
// 							</p>
// 							<p>
// 								This year offers a new twist: The eight visiting chefs are all women – hailing from Mexico, South Korea, Italy, Switzerland, Colombia, Slovenia, Spain, and the United States. They’ll work with their local counterparts in the creation of culture crossover chowdowns featuring signature dishes from the guest chefs alongside flavors offered by the local chefs from the host restaurants.
// 							</p>
//                            <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/71/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Everyone involved agrees that creative cooking is always intensely steeped cultural context and a deeply felt sense of place. All of them are passionate about using local ingredients. Of course, each of these chefs has received accolades and awards from international critics and guides.
// 							</p>
//                            <p>
// 								There’s no better way to showcase Tel Aviv’s growing prominence on the global stage of gastronomy than the annual Round Table event. Seats get reserved quickly and must be made in advance. So, don’t miss your chance for a place at these prestigious tables – your taste buds will never forgive you!
// 							</p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 72,
// 	    bgImage:"/posts/bank/72/1.jpg",
// 	    mobBgImage:"/posts/bank/72/M.jpg",
// 	    title: "TEL AVIV FASHION WEEK",
// 	    smlTitle: "Tel Aviv Fashion Week (TAFW)",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//fashionweektelaviv.com/">
// 												fashionweektelaviv.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Tel Aviv Fashion Week (TAFW)</h2>
// 							<p>
// 								Fashion events are always occasions for the celebration of elegance, imagination, creativity, and style. But the TAFW has been making its mark in the international fashion industry with its recent attention to changing ideals of beauty, featuring models, both male and female, of different ages, sizes, heights, colors, and religions. The 4-day event showcases uncommon displays from around the world and those close to home in and around Tel Aviv’s vibrant design scene.
// 							</p>
//                            <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/72/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								TAFW also embraces leading edge fashion concepts by exhibiting innovative uses of technology and textiles. And it’s especially proud of the support it provides to young designers. As in past editions, this 7th annual event will feature an Upcoming Designers show in which new talent will have an opportunity to share their wares with you!
// 							</p>
//                            <p>
// 								In 2019, Tel Aviv Fashion Week will once again take place in the historic Tachana complex. Formerly the final stop of the old Jaffa-to-Jerusalem railway, the station has been transformed into one of Tel Aviv’s coolest and most lively public spaces. Located in a trendy neighborhood of pastel-colored homes, unique boutiques, and numerous cafes, you’ll want to explore the entire area while you’re getting your vogue on at the TAFW!
// 							</p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 73,
// 	    bgImage:"/posts/bank/73/1.jpg",
// 	    mobBgImage:"/posts/bank/73/M.jpg",
// 	    title: "DGTL FESTIVAL",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://tlv.dgtl.nl/en/dgtl-tel-aviv-returns-to-israel/">
// 												tlv.dgtl.nl/en
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                             <p>After its stellar debut in Tel Aviv, DGTL Festival is back, bringing yet another excellent musical program to Yarkon Park, accompanied by the latest sustainable and technological innovations and fresh art projects.</p>
//                             <p>The DGTL festival is a global event at the forefront of the music and festivals scene, showcasing in an exclusive list of cities around the world: Amsterdam, Sao Paulo, Barcelona, Santiago and now Tel Aviv and bringing together the worlds of music, technology and art, as well as the latest discoveries in production and sound. </p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/73/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>The DGTL festival will be held in an expanded edition with a huge lineup and will include three stages which will operate simultaneously at any given moment.</p>
//                             <p>In addition to being an innovative music festival, DGTL champions environmental protection and sustainability and has won prizes for being the greenest festival in Europe. The festival has a revolutionary program for saving electricity, vegetarian food only, a recycling plan and more. </p>
//                             <p>The Festival will be held in the fabulous Yarkon Park in the heart of the buzzing city of Tel Aviv, a hub of innovation, trendiness and exciting nightlife scene, making it the host for DGTL. </p>
//                             <p>Come and get your groove on in the most cutting-edge festival on the planet, held in heart of the most exciting city in the world! </p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 74,
// 	    bgImage:"/posts/bank/74/1.jpg",
// 	    mobBgImage:"/posts/bank/74/M.jpg",
// 	    title: "Tel Aviv Marathon",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											22.02.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.tlvmarathon.co.il/MenuDefault.aspx?id=5418">
// 												www.tlvmarathon.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                             <h2>Run and fun in the city that doesn’t stop</h2>
//                             <p>Tel Aviv Marathon is the country’s biggest international sports event and a unique and exciting celebration for runners worldwide. The Marathon is held in the heart of the fabulous city of Tel Aviv, giving participants the opportunity to take in its awesome sites and views and feel their heart beat become one with the pulse of this adrenaline charged metropolis. </p>
//                             <p>The Tel Aviv Marathon is city wide celebration stretching along the stunning beachfront, the amazing sites of the white city - a UNESCO World Heritage Site, and the city’s many buzzing stylish streets, packed with over 150,000 people taking part in the many side events, cheering the runners along the race’s flat and friendly course.   </p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/74/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>Around 40,000 runners come from far and wide to take part in this multi-course annual even. Allowing runners in all levels and styles, from professional long-distance runners to beginners, to take part.</p>
//                             <p>Much more than just a run, the marathon is in fact a huge festival featuring a host of dedicated lively events before and after the race, full of live music, dancing and many other attractions to the delight of runners and supporters alike.  </p>
//                             <p>Dubbed ‘The Mediterranean Capital of Cool’ By the New York Times and among Lonely Planet’s ‘Top 10 Action-Packed Cities’. Tel Aviv offers a host of fascinating attractions from all walks of life including dazzling stretches of golden beaches, colorful markets, cutting edge culture and entertainment, outstanding nightlife & an exciting culinary scene. </p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 75,
// 	    bgImage:"/posts/bank/75/1.jpg",
// 	    mobBgImage:"/posts/bank/75/M.jpg",
// 	    title: "Jerusalem Marathon",
// 	    smlTitle: "The Ultimate Race against time in this spectacular Marathon held in the 3,000-Year-old magnificent city of Jerusalem",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											15.03.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://jerusalem-marathon.com/Register.aspx">
// 												jerusalem-marathon.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                             <h2>The Ultimate Race against time in this spectacular Marathon held in the 3,000-Year-old magnificent city of Jerusalem</h2>
//                             <p>The International Jerusalem Winner Marathon is one of Israel's largest marathons, with 30,000 participants including hundreds of elite runners from Israel and around the world.</p>
//                             <p>The marathon offers a variety of tracks, from professional to family friendly, which pass by fascinating historical sites that illuminate 3,000 years of the history of Jerusalem, Israel's capital guaranteeing a challenging, thrilling and unforgettable experience for all runners. </p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/75/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>With a series of cultural happenings planned around the central event, the Jerusalem International Marathon provides international runners with the perfect opportunity to visit the ancient city while participating in a truly modern and excitement-filled competitive sporting event. </p>
//                             <p>The Jerusalem marathon allows runners the chance to compete in a setting of unparalleled natural and cultural beauty unlike any other international marathon course. The topography of the city lends itself to a challenging route that will test even the most experienced of runners.</p>
//                             <p>The course takes the runner on a unique path through Jerusalem’s 3,000-year historical narrative, on the cobblestones of the ancient and holy walled city of Jerusalem and through the modern city center of Israel’s capital. The course includes the city’s best known sites including, among others, the Knesset, the Old City, Sultan's Pool, Mount Zion, the German Colony, the Jerusalem Promenade and the Mount of Olives.</p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 76,
// 	    bgImage:"/posts/bank/76/1.jpg",
// 	    mobBgImage:"/posts/bank/76/M.jpg",
// 	    title: "Bon Jovi",
// 	    smlTitle: "Bon Jovi are Back to take over the hot hot hot Tel Aviv Summer!",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											HaYarkon Park, TLV
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											25.07.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.bonjovi.com/">
// 												bonjovi.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                             <h2>Bon Jovi are Back to take over the hot hot hot Tel Aviv Summer!</h2>
//                             <p>Bon Jovi, all-time favorites in Tel Aviv, are making their way back to the city, famed for its lively music scene once more to appear in the famous Yarkon Park, the beautiful green lung of the city.
//                             <p>Currently touring America to sold out venues, Bon Jovi will arrive here as part of a new European tour in the summer of 2019, entitled "This House is not for Sale". The tour is set will begin on May 31, 2019 in Moscow and will probably end on July 25, 2019 with their show in Tel Aviv.
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/76/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>The band, considered e one of the most successful American bands of all times has sold more than 100 million copies, performed in over 2700 concerts in 50 different countries to more than 34 million viewers worldwide.
//                             <p>This is not Bon Jovi's first stint in the city. The band gave a truly memorable performance about three years ago at the Hayarkon Park in Tel Aviv to 50,000 adoring fans, singing along to every lyric .
//                             <p>Those coming to see the band play in Tel Aviv are in for a special treat as they will get to experience Tel Aviv in July, the city’s summer finest,  sunbathe on the fabulous beaches, enjoy the awesome culinary options, take in  the epic hot night life and best of all see Bon Jovi raise it live on stage in the city that doesn’t stop!
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 77,
// 	    bgImage:"/posts/bank/77/1.jpg",
// 	    mobBgImage:"/posts/bank/77/M.jpg",
// 	    title: "TAG 2019",
// 	    smlTitle: "Tel Aviv Games are Back!",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											TAG 2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											27-30.3.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.bonjovi.com/">
// 												www.telavivgames.org
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                            <h2>
//                             	Tel Aviv Games are Back!
//                           	 </h2>
//                             <p>
// 								Tel Aviv, declared one of the best gay travel destinations in the world, is joining a list of renowned capitals such as Paris, New York, Berlin and Rome, organizing its own LGBT multinational sports event – Tel Aviv Games – TAG2019. TAG 2019 offering the LGBT+ traveler a unique and exciting sports experience.
//                             </p>
//                             <p>
// 								With over 250 athletes from all over the world already signed up, and an estimated 500 more expected, Tel Aviv Games 2019 is anticipated to become the biggest LGBT+ Sports event in the middle east and one of the biggest in Europe.
//                             </p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/77/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>
// 								LGBT+ athletes from more than 17 countries (including France, Germany, UK, US, Australia, Canada, Belgium, Czech Rep., Greece, Netherlands, Norway, Spain, Russia, Surnami and more) will come together for a 3-day multi-national celebration of participation, inclusion and personal best.
//                             </p>
//                             <p>
// 								The tournament will include individual and team events in 7 sporting categories: Swimming, Tennis, Basketball, Soccer, Volleyball, Same Sex Dance, and 5K and 10K Competitive Running.
//                             </p>
//                             <p>
// 								This year Tel Aviv Games will also introduce the city’s first ever “Pride Run - Running for the youth”, supporting Healthy LGBT+ Youth lifestyle in a 5K race along Tel Aviv’s beautiful shore.
// 							 </p>
// 					               `
// 			}
// 		}
//     },
//   //   {
//   //       id: 78,
// 	 //    bgImage:"/posts/bank/100/1.jpg",
// 	 //    mobBgImage:"/posts/bank/100/M.jpg",
// 	 //    title: "Purim 2019",
// 	 //    smlTitle: "",
// 	 //    html: function(){
// 		// 	return {
// 		// 		__html: `
// 		// 					<div class="col col-30">
// 		// 						<div class="top-box yellow">
// 		// 							<h2>Ort</h2>
// 		// 							<div class="text">
// 		// 								<p>
// 		// 									Tel Aviv and Jerusalem
// 		// 								</p>
// 		// 							</div>
// 		// 						</div>
// 		// 					</div>
// 		// 					<div class="col col-30">
// 		// 						<div class="top-box yellow">
// 		// 							<h2>Datum</h2>
// 		// 							<div class="text">
// 		// 								<p>
// 		// 									20-22.03.2019
// 		// 								</p>
// 		// 							</div>
// 		// 						</div>
// 		// 					</div>
// 		// 					<div class="col col-30">
// 		// 						<div class="top-box yellow">
// 		// 							<h2>weitere informationen</h2>
// 		// 							<div class="text info">
// 		// 								<p>
// 		// 									<a target="_blank" href="https://www.tel-aviv.gov.il/en/Pages/MainItemPage.aspx?WebID=9336473c-1537-4ab6-8a69-d299b5db8bcc&ListID=0ac6b290-896c-4fcb-bb36-0c5252101eff&ItemId=123">
// 		// 										Tel Aviv Purim 2019
// 		// 									</a>
// 		// 								</p>
// 		// 							</div>
// 		// 						</div>
// 		// 					</div>
// 		// 					<div class="clear"></div>
//   //                          <p>Every year in March, the people of Tel Aviv & Jerusalem dress up in costumes, the cities are a party and it’s all because of Purim – the most colorful and fun holiday of them all!
//   //                           <div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/78/1.jpg"} class="img-responsive" />
// 		// 					</div>
//   //                           <p>As expected, the party capital doesn’t disappoint, as there are tons of events to choose from – the annual street party is Tel Aviv’s biggest event. Thousands of dressed up people will gather together in “Kikar Hamedina” (State’s Square)  to enjoy performances from top musicians and dance together! The best part? It’s free of charge! If you won’t be too exhausted, you can also participate in Tel Aviv’s Zombie Walk. The name is self-explanatory, as the walk features hundreds of zombies walking through the streets of the city that never sleeps. Other events include Tel Aviv Street Party in Rothschild boulevard and many more.
//   //                           <div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/78/2.jpg"} class="img-responsive" />
// 		// 					</div>
//   //                           <p>If your prefer to spend the holiday in the city of gold, have no fear as there are plenty of events taking place across Jerusalem – from carnivals to parties there is something for everyone: The official Jerusalem Purim events is at Safra Square, featuring activities and performances for kids. Another option is the event at the Israel Museum that’s meant for the whole family. There’s also a Purim Rave Party at The Tower of David, the traditional parade at Nachlaot street, a party at Downtown Jerusalem building, a Purim party at the Shuka and more events to be confirmed!
//   //                           <div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/78/3.jpg"} class="img-responsive" />
// 		// 					</div>
//   //                           <p>So choose your costume and come celebrate with us!
//   //                           <div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/78/4.jpg"} class="img-responsive" />
// 		// 					</div>
// 		// 			               `
// 		// 	}
// 		// }
//   //   },
//     {
//         id: "J_Lo",
// 	    bgImage:"/posts/bank/J_Lo/1.jpg",
// 	    mobBgImage:"/posts/bank/J_Lo/M.jpg",
// 	    title: "J.LO",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Hayarkon Park
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											01.08.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h3>
// 								J.LO HEADING TO TEL AVIV TO SET THE SUMMER ON FIRE!
// 							</h3>
// 							<p>
// 								Yes, it's true! after weeks of rumors flying around it is officially confirmed the J.Lo, AKA Jeniffer Lopes, AKA Jenny from the block, the hottest name worldwide as queen of pop for the past 2 decades, is coming to light up your summer in Tel Aviv!
// 							</p>
//                          <p>
// 								Performing for the first time in this country, J.Lo will be getting loud on the floor on August 1st at the Yarkon Park. The show, part of the maga star’s “It’s My Party” worldwide tour is expected to be one of the summer’s biggest concerts, along with Bon Jovi’s highly anticipated performance on the very same Tel Aviv stage on the 25th July.
// 							</p>
// 							<p>
// 								Hayarkon park is Tel Aviv’s green lung. This is the perfect place to get some respite after spending a wild night in Tel Aviv. Here you can spend the day cycling, walking or relaxing in the beautiful outdoor scenery and even enjoy flying high on a hot air balloon before heading to take your place in the stunning amphitheater. Whatever you choose, make sure to come packed with energy for J.Lo’s once in a lifetime performance in sunny awesome Tel Aviv!
// 							</p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: "Pride_Parade_2019",
// 	    bgImage:"/posts/bank/Pride_Parade_2019/1.jpg",
// 	    mobBgImage:"/posts/bank/Pride_Parade_2019/M.jpg",
// 	    title: "Pride Parade 2019",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											14.6.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h3>
// 								The  most fabulous event of the Year
// 							</h3>
// 							<p>
// 								<strong>
// 									Tel Aviv 2019 Pride Celebrations – guaranteed to blow your mind!
// 								</strong>
// 							</p>
// 							<p>
// 								Tel Aviv, one of the most celebrated gay capitals in the world, is famous for its round the clock energy and extravagant nonstop parties. One of the biggest and hottest events, by far in the city is the ‘Gay Pride Week’ parties ending with the awesome Friday Pride Parade.
// 							</p>
//                          <p>
// 								The parade, a tradition which began as early as 1998, draws a huge crowd of the coolest people and thousands of participants from around the world. All them come together to celebrate and support freedom and embrace all lifestyles and genres in an open minded, off the charts, celebration.
// 							</p>
// 							<p>
// 								The parade is the highlight of a week of gay pride events which take place around the city of Tel Aviv and include pride-themed parties, exhibitions, movie festivals, music concerts and so much more.
// 							</p>
// 							<p>
// 								The parade itself takes place along the buzzing main streets of marvelous Tel Aviv, and features, in the tradition of pride parades from across the world, fantastic extravagant floats, live music, dance performances and revelers dressed in a colorful festival dress.
// 							</p>
// 							<p>
// 								The parade stops and rests at the stunning Tel Aviv promenade by the shores of the beautiful coastline, where it turns into an epic adrenaline-charged beach party featuring leading DJs and live performances, lasting well into the small hours of the night.
// 							</p>
// 							<p>
// 								The 2019 parade will take place on June 14th 2019 and participation, as always, will be completely free of charge.
// 							</p>
// 					               `
// 			}
// 		}
//     },
//     {
// 	              id: "TelAviv_Marathon",
// 	              bgImage:"/posts/bank/tlv-marathon2020/1.jpg",
// 	              mobBgImage:"/posts/bank/tlv-marathon2020/M.jpg",
// 	              title: "Tel Aviv Marathon",
// 	              smlTitle: "",
// 	              html: function(){
// 			              return {
// 				              __html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Ort</h2>
// 											<div class="text">
// 												<p>
// 													Tel Aviv
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Datum</h2>
// 											<div class="text">
// 												<p>
// 													28.02.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>WeiteRe informationen</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="https://www.tlvmarathon.co.il/MenuDefault.aspx?id=6607">
// 														www.tlvmarathon.co.il
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="clear"></div>
//                                       <h2>SPORT UND SPASS IN DER STADT DIE NIEMALS SCHLÄF</h2>
//                                       <p>Der Tel Aviv Marathon ist das größte internationale Sportereignis des Landes. Ein einzigartiges und spannendes Event für Läufer aus aller Welt. Der Marathon findet im Herzen der wunderschönen Stadt Tel Aviv statt und gibt den Teilnehmern die Möglichkeit, deren berühmte Sehenswürdigkeiten und traumhafte Ausblicke zu genießen, während ihr Herzschlag eins wird mit dem Puls der aufregenden Metropole.</p>
//                                       <p>Rund 40.000 Läuferinnen und Läufer kommen aus aller Herren Länder, um an diesem jährlich stattfindenden Wettbewerb mit seinen diversen Rennen teilzunehmen. Es ist für jeden etwas dabei, vom echten Marathon-Profi bis zum Anfänger.</p>
//                                       <p>Während des Tel Aviv Marathon wird die ganze Stadt zu einem einzigen großen Fest, das sich entlang der traumhaften Strandpromenade, dem beeindruckenden UNESCO-Weltkulturerbe der "Weißen Stadt" und den vielen belebten, stilvollen Straßen der Stadt erstreckt, in denen mehr als 150.000 Menschen am Rahmenprogramm teilnehmen – und die Läufer auf der flachen, entspannten Marathonstrecke anfeuern.</p>
//                                       <p>So ist der Marathon ein riesiges Festival mit einer Vielzahl einzigartiger und besonderer Events vor und nach dem Rennen, mit Live-Musik, Tanz sowie vielen weiteren Erlebnissen. Sehr zur Freude der Läufer und der Fans an der Strecke.</p>
//                                       <p>Von der New York Times als "Mediterrane Hauptstadt der Coolness" bezeichnet und von Lonely Planet unter die Top 10 der erlebenswertesten Städte der Welt gewählt, bietet Tel Aviv in allen Lebensbereichen eine Vielzahl faszinierender Attraktionen: Golden schimmernde Strände, farbenfrohe Märkte, eine lebendige Kulturlandschaft und abwechslungsreiche Unterhaltung, ein überragendes Nachtleben und eine aufregende kulinarische Szene.</p>
// 	                            `
// 			}
// 		}
//     },
//     {
// 	              id: "Jerusalem_Marathon",
// 	              bgImage:"/posts/bank/jerusalem5/1.jpg",
// 	              mobBgImage:"/posts/bank/jerusalem5/M.jpg",
// 	              title: "JERUSALEM MARATHON",
// 	              smlTitle: "",
// 	              html: function(){
// 			return {
// 				__html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Ort</h2>
// 											<div class="text">
// 												<p>
// 													Jerusalem
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Datum</h2>
// 											<div class="text">
// 												<p>
// 													20.03.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>WeiteRe informationen</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="https://jerusalem-marathon.com/default.aspx">
// 														jerusalem-marathon.com
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="clear"></div>
//                                     <h2>EIN FASZINIERENDER LAUF DURCH 3.000 JAHRE GESCHICHTE</h2>
//                                     <p>Mit 30.000 Teilnehmern, darunter viele der weltbesten Läufer, feiert der International Jerusalem Marathon ein großartiges Miteinander von Körper und Geist im Herzen einer der bezauberndsten Städte der Welt.</p>
//                                     <p>Der Lauf bietet den Teilnehmern eine perfekte Gelegenheit, diese Jahrtausende alte Stadt im Zuge eines ebenso richtungsweisenden wie spannenden sportlichen Wettbewerbs zu entdecken – und ein facettenreiches kulturellen Rahmenprogramm zu erleben.</p>
//                                     <p>Mit einer Vielzahl von Streckenführungen eignet sich dieser Marathon für Läufer jeden Levels – ob Profi oder Einsteiger, ob Ausnahmeathlet oder laufbegeisterte Familie. Die Route führt mitten durch die 3.000jährige Geschichte, vorbei an faszinierenden historischen Stätten, über das Kopfsteinpflaster des alten, heiligen Jerusalem und durch das moderne Zentrum der israelischen Hauptstadt.</p>
//                                     <p>Und natürlich liegen einige ihrer berühmtesten Sehenswürdigkeiten auf dem Weg, darunter die Knesset, die Alte Stadt, das Merrill Hassenfeld Amphitheater (auch bekannt als Sultan‘s Pool), der Berg Zion, die Deutsche Kolonie, die Haas-Promenade und der Ölberg.</p>
//                                     <p>Mit großartiger Natur und Kultur, wie sie bei keinem anderen Marathon zu finden sind, ermöglicht der Jerusalem Marathon den Teilnehmern einen Lauf in unvergleichlicher Umgebung. Die Topographie der Stadt sorgt für einen anspruchsvollen Streckenverlauf, der auch noch die erfahrensten Läufer in seinen Bann zieht – und zu einem herausfordernden, spannenden und unvergesslichen Erlebnis wird.</p>
// 	                            `
// 			}
// 		}
//     },
//     {
// 	              id: "Celine_Dion",
// 	              bgImage:"/posts/bank/Celine_Dion/1.jpg",
// 	              mobBgImage:"/posts/bank/Celine_Dion/M.jpg",
// 	              title: "Our Heart Goes On \n for Celine Dion in Tel Aviv!",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                              <div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											HaYarkon Park, Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											04.08.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>WeiteRe informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.celinedion.com">
// 												www.celinedion.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                                     <h2>Our Heart Goes On – for Celine Dion in Tel Aviv!</h2>
// 										<p>The Diva is coming! Now it’s official: Celine Dion will perform in Tel Aviv on August 4th of next summer and it’s going to be a hot one! This will be Dion’s first ever concert here, and boy are we excited.</p>
//                                         <p>The 6 Grammy award-winner will visit Tel Aviv, the city that never sleeps, to keep the party going all Night. Dion’s countless hits, “Because you Loved Me”, “Just Walk Away” and of course her all-time greatest hit – “My Heart Will Go On” – will hopefully make their debut live in Tel Aviv.</p>
//                                         <p>Tel Aviv has also hosted some of the largest art exhibitions, live shows and festivals, making it one of the liveliest cities in the world. With a combination of sun, rich nightlife scene, spectacular sights in every corner and the Dion’s first appearance – Tel Aviv is the place to be next summer.</p>
//                                         <p>Ticket sales have yet to open, but it’s never too early to start planning your next visit to Tel Aviv!
// 	                            `
// 			}
// 		}
//     },
//     {
// 	              id: "Nickcave-Badseeds",
// 	              bgImage:"/posts/bank/Nickcave_Badseeds/1.jpg",
// 	              mobBgImage:"/posts/bank/Nickcave_BadseedsM.jpg",
// 	              title: "NICK CAVE & BAD SEEDS",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                              <div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Bloomfield Stadium, Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											17.06.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>WeiteRe informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.celinedion.com">
// 												www.celinedion.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                                     <h2>NICK CAVE AND THE BAD SEEDS LIVE IN TEL AVIV!</h2>
//                                     <p>Nick Cave is coming to Tel Aviv to blow the roof off! Returning to the city that never sleeps in June 2020, the Australian pop-punk musician is coming to rock you.</p>
//                                     <p>Having recorded no less than 17 studio albums with his band, the talented musician is excited about his visit – which will be hotter than ever.</p>
//                                     <p>Coming back just a little more than two years after his previous performance here, this time, lighting up the newly renovated Bloomfield Stadium (which has hosted a long line of international artists). Judging by the last performance, this one should be truly sensational.</p>
//                                     <p>Tel Aviv has been known to attract and feature some of the biggest names in the world, making it one of the hottest cities when it comes to live concerts and the nightlife scene. This performance shouldn’t be any different and is a great opportunity to catch Nick Cave live, as part of his summer tour.</p>
//                                     <p>Warm summer nights, soft sand beaches and the mesmerizing music of a world-renowned artist – what more could you ask for? Tel Aviv has it all!</p>
// 	                            `
// 			}
// 		}
//     },
//     {
//         id: "Open_Restaurants_Jerusalem",
// 	    bgImage:"/posts/bank/Open_Restaurants_Jerusalem/1.jpg",
// 	    mobBgImage:"/posts/bank/Open_Restaurants_Jerusalem/M.jpg",
// 	    title: "Open Restaurants Jerusalem",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											19-23.11.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>weitere informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://open-restaurants.co.il/?lang=en">
// 												www.open-restaurants.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h3>
// 								Open Restaurants Jerusalem
// 							</h3>
// 							<p>
// 								Taking place in the iconic city of Jerusalem at varying hours, \‘Open Restaurants\’ is a unique culinary festival giving visitors a glimpse into the fascinating cultural and culinary diversity of Jerusalem.
// 							</p>
// 							<p>
// 								The festival includes about 100 different events held all over the city of Jerusalem, even in places which are less culinary oriented, as well as in culinary adequate venues and combine food with art, culture, innovation and technology.
// 							</p>
//                          <p>
// 								Festival-goers will also have a chance to participate in a series of meetings, workshops and lectures by prominent local personalities, and visits to the city\'s famous restaurant kitchens.
// 							</p>
// 							<p>
// 								As part of the festival program, day and night tours will be held at various culinary centers throughout Jerusalem including flavors tours in the Old City,Ein Kerem and more. You are encouraged to take at least one of them!
// 							</p>
// 							<p>
// 								In addition, FoodTalks meetings will be held with leading culinary experts (we can’t reveal who they are, so keep guessing…), photographers and chefs. The top hotels in Jerusalem will also collaborate with their private chefs at special prices.
// 							</p>
// 							<p>
// 								Whether you’re a foodie or just a curious visitor, you are sure to enjoy this unique taste of magical Jerusalem’s culinary side happening between the 19th -23rd , November,2019.
// 							</p>
// 					               `
// 			}
// 		}
//     },
//     {
// 	              id: "Purim_2020",
// 	              bgImage:"/Concerts/bank/purim2020/1.jpg",
// 	              mobBgImage:"/Concerts/bank/purim2020/M.jpg",
// 	              title: "Purim 2020",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Ort</h2>
// 											<div class="text">
// 												<p>
// 													Tel Aviv und Jerusalem
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Datum</h2>
// 											<div class="text">
// 												<p>
// 													09-10.03.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									</div><div class="clear"></div>
//                                     <p>Jedes Jahr im März verkleiden sich die Menschen in Tel Aviv und Jerusalem und feiern in den Städten eine große und vor allem großartige Party – und all das dank Purim, dem buntesten und lustigsten Feiertag von allen!</p>
//                                     <div class="img-wrapper">
// 										<img src=${getImgUrl() + "/Concerts/purim2020/1.jpg"} class="img-responsive" />
// 									</div>
//                                     <p>Erwartungsgemäß enttäuscht die Party-Hauptstadt dabei in keinster Weise, schließlich gibt es unsagbar viele Veranstaltungen zur Auswahl – wobei das jährliche Straßenfest eines von Tel Avivs größten Ereignissen ist. Tausende verkleideter Menschen versammeln sich auf dem Kikar Hamedina Platz – dem „Rodeo Drive“ von Tel Aviv-, um die Auftritte von Top-Musikern zu erleben und gemeinsam zu tanzen! Das Beste daran? Es ist kostenlos! Wenn Sie danach nicht zu erschöpft sind, können Sie am Zombie Walk teilnehmen. Der Name ist Programm, wanken doch bei diesem Event hunderte von Zombies durch die Straßen der Stadt, die niemals schläft. Weitere Veranstaltungen sind die Tel Aviv Street Party auf dem Rothschild-Boulevard und viele andere.</p>
//                                     <div class="img-wrapper">
// 										<img src=${getImgUrl() + "/Concerts/purim2020/2.jpg"} class="img-responsive" />
// 									</div>
//                                     <p>Wenn Sie Ihren Urlaub lieber in der Goldenen Stadt verbringen möchten, seien Sie unbesorgt! In ganz Jerusalem finden zahlreiche Veranstaltungen statt – vom Karneval bis hin zu den zahlreichen Partys ist für jeden etwas dabei: Die offiziellen Purim-Veranstaltungen finden auf dem Safra-Platz statt, mit zusätzlichen Aktivitäten und Aufführungen für Kinder. Eine weitere Möglichkeit ist die Veranstaltung für die ganze Familie im Israel Museum. Darüber hinaus gibt es eine Purim Rave Party im Davidsturm, die traditionelle Parade in der Nachlaot Straße, eine Party in Downtown Jerusalem, eine Purim Party in der Shuka Bar – und ständig kommen weitere Veranstaltungen hinzu!</p>
//                                    <div class="img-wrapper">
// 										<img src=${getImgUrl() + "/Concerts/purim2020/4.jpg"} class="img-responsive" />
// 									</div>
//                                     <p>Wählen Sie Ihr Kostüm aus und feiern Sie mit uns!</p>
// 	                            `
// 			}
// 		}
//     },
//     {
//         id: "TelAviv_Fashion_Week_2020",
// 	    bgImage:"/Concerts/bank/fashion-week-2020/1.jpg",
// 	    mobBgImage:"/Concerts/bank/fashion-week-2020/M.jpg",
// 	    title: "TEL AVIV FASHION WEEK",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											03.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>WeiteRe informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//fashionweektelaviv.com/">
// 												fashionweektelaviv.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Voll im Trend!</h2>
//                             <p>Viele Mode-Events stellen Glamour, Extravaganz, Kreativität und Stil ins Rampenlicht. Der  Tel Aviv Fashion Week kommt jedoch eindeutig eine Sonderstellung innerhalb der  internationalen Modeszene zu. Hier wird das aktuelle Schönheitsdeal neu- und umgedacht. Weibliche und männliche Models verschiedenen Alters, verschiedener Hautfarbe, Religion und Konfektionsgrößen präsentieren in der Fashion City die neuesten Trends. Auf dem 4-tägigen Event begeistern die bis dato ungesehene Entwürfe aus aller Welt wie auch aus Tel Avivs lebhafter Design-Szene das Publikum.</p>
//                             <p>Indem sie den innovativen Umgang mit Technologien und Textilien präsentiert, ist die Tel Aviv Fashion Week ein Synonym für richtungsweisende Mode-Ideen. Besonders stolz ist man dabei auf die Unterstützung junger Designer. Wie bereits in der Vergangenheit wird es auch bei der achten Auflage eine Newcomer Show geben, in deren Rahmen der Design-Nachwuchs Gelegenheit hat, das Publikum mit seinen Entwürfen zu begeistern.</p>
//                             <p>Einmal mehr findet die Tel Aviv Fashion Week 2020 in der historischen Bahnstation „Tachana“ statt. Ehemals Endstation der Strecke Jaffa – Jerusalem, zählt sie heute zu den coolsten und dynamischsten Locations in Tel Aviv. Dank ihrer Lage in einem Viertel mit pastellfarbenen Häusern, außergewöhnlichen Boutiquen und zahlreichen Cafés, lädt der Besuch bei der Tel Aviv Fashion Week gleichzeitig ein, die Gegend ausgiebig zu erkunden. Trends finden hier schließlich nicht nur auf dem Catwalk statt!</p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: "The_Jerusalem_March_2020",
// 	    bgImage:"/Concerts/bank/jerusalem-march/1.jpg",
// 	    mobBgImage:"/Concerts/bank/jerusalem-march/M.jpg",
// 	    title: "Der Jerusalem-Marsch",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											30.09.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<p>Der im Oktober stattfindende Jerusalem-Marsch ist eines der farbenfrohsten und faszinierendsten Ereignisse des Landes, das Zehntausende Teilnehmer aus aller Welt zusammenbringt.</p>
//                              <p>Der Jerusalem-Marsch umfasst drei Veranstaltungen – einen Morgenspaziergang auf Naturpfaden, ein Happening im Sacher-Park und eine festliche Parade, die im Zentrum von Jerusalem stattfindet.</p>
//                              <p>Damit alle, die mitmachen wollen, auch dabei sein können, bietet der Marsch eine Vielzahl von Routen unterschiedlicher Länge und Schwierigkeitsgrade.</p>
//                              <p><strong>Morgen-Routen</strong><br/>
//                              <u>Route A </u>– Für erfahrene Läufer, ungefähr 12 km (07:00 bis 09:00 Uhr)</p>
//                               <p><strong>Vom Munitionshügel zum Sacher Park.</strong><br/>
//                              <u>Route B</u> – Mittlerer Schwierigkeitsgrad, ungefähr 9 km (07:30 bis 09:30 Uhr)</p>
//                              <p><strong> Vom Skopusberg zum Sacher Park.</strong><br/>
//                              <u>Route C</u> – Einfach, für Familien geeignet, ungefähr 4 km (08:00 bis 10:00 Uhr)</p>
//                              <p>Vom Safra Platz zum Sacher Park.<br/>
//                              Sacher Park Festival </p>
//                              <p>Zwischen 10:00 und 16:00 Uhr findet im Sacher Park ein Festival mit Auftritten, Live-Musik und Kindershows sowie einem eigens für Kinder eingerichteten Bereich statt.</p>
//                              <p>Die Parade beginnt um 15:00 Uhr und folgt dem Verlauf der Bezalel-, Hillel- und König-David-Straße und endet neben dem Glockenpark. Auch dieses Jahr nehmen wieder zahlreiche Festwagen, bunte Teilnehmergruppen aus Israel und der ganzen Welt, verschiedene Orchester und Tanzgruppen, IDF-Soldaten, Straßenkünstler, Sportmannschaften und mehr an diesem farbenfrohen Festumzug teil.</p>
//                              <p>Lassen Sie sich die Chance nicht entgehen, an diesem wunderschönen und fröhlichen Jerusalem-Fest teilzunehmen!</p>
// 				`
// 			}
// 		}
//     },
//     {
//         id:"The_Pixies_2020",
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "The Pixies",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											14.07.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>WeiteRe informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.pixiesmusic.com">
// 											www.pixiesmusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>The Pixies sind zurück um Tel Aviv zu rocken!</h2>
// 							<p>The Israeli summer is always hot, but the Pixies are returning to Tel Aviv after 3 years to make it even hotter!</p>
// 			                         <p>The famous American band, well known for its signature style of aggressive punk rock and pop, is responsible for some of the most iconic tunes in music history, including their all-time audience favorite ‘where is my mind’. The pixies are returning to Tel Aviv for the third time as part of their promotional tour for their new album, ‘Beneath the Eyrie’. </p>
// 			                         <p>The pixies will be giving a single performance in the nonstop city of Tel Aviv, the perfect way to rock your beach, sun and fun Tel Aviv holiday.  The concert is set to be held in July, a fabulous time to enjoy the famous Tel Aviv summer, the parties, the amazing cuisine, and the stunning beaches. </p>
// 			                         <p>Tickets are selling fast so hurry up and book your trip today!  </p>
// 						`
// 			}
// 		}
// 	},
// 	{
//         id:"White_Night_2020",
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "White Night",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											06.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Die Party des Jahres in der Party-Hauptstadt der Welt!</h2>
// 							<div class="responisve-iframe">
// 								<iframe width="560" height="315" src="https://www.youtube.com/embed/T0ugqxG5UaM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
// 							</div>
// 							<p>Feiert die weltbekannte “Stadt, die niemals schläft” ein Event wie die „White Night“, dann wartet ein unvergessliches Erlebnis auf Sie! Als eine der größten Veranstaltungen Tel Avivs macht die jährliche „White Night“ die Nacht zum Tag – in der alles in der Stadt geöffnet hat und es jede Menge zu erleben gibt!</p>
//                             <p>Von den frühen Abendstunden bis zum Morgengrauen wird die City zur belebten Partymeile für Besucher und Einheimische, die das Leben und die facettenreichen Angebote genießen. In Geschäften und Restaurants, in Kinos und an kulturellen Schauplätzen – und das entweder kostenlos oder zu vergünstigten Preisen!</p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/1.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo By: Adam Primer
// 							</small>
// 							<p>Die Wurzeln des mittlerweile schon weltberühmten Events reichen zurück in das Jahr 2003, als die “Weiße Stadt” – Tel Avivs größte Sammlung weißer Bauten im Bauhaus-Stil von der UNESCO zum Weltkulturerbe erklärt wurde und ihr damit einen einzigartigen Status im architektonischen Kontext der Gegenwart verlieh.</p>
//                             <p>Seit dieser Zeit feiert Tel Aviv-Jaffa den historischen Anlass mit den “White Night”-Events, benannt nach der “Weißen Stadt” und einer weiteren Charakteristik Tel Avivs – als “Stadt, die niemals stillsteht“.</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/2.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo By: Kfir Sivan
// 							</small>
// 							<p>Während der “White Night” findet überall in der Stadt eine Vielzahl von Events statt – und es werden Jahr für Jahr mehr. In der Vergangenheit gehörten dazu zum Beispiel ein einzigartiges Mitternachtspicknick, eine Silent Disco auf dem zentralen Platz der Stadt, unzählige Live-Konzerte, großartige Theater-Aufführungen sowohl auf der Hauptbühne als auch in den Straßen, faszinierende Nachtspaziergänge, nächtliche Sportkurse, Yoga-Sessions bei Sonnenaufgang und natürlich viele coole Parties, die die ganze Nacht und überall in der Stadt gefeiert werden.</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/3.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo by Moshik Lindenbaum
// 							</small>
// 							<p>Tanken Sie Kraft – wir versprechen Ihnen, Sie werden sie für die erlebnisreiche „White Night“ in der fantastischen Stadt Tel Aviv brauchen!</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/4.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo by: Guy Yechiely‎.
// 							</small>
// 						`
// 			}
// 		}
// 	},
// 	{
//         id: "Pride_Week_2020",
// 	    bgImage:"/posts/bank/Pride_Parade_2019/1.jpg",
// 	    mobBgImage:"/posts/bank/Pride_Parade_2019/M.jpg",
// 	    title: "Pride Week 2020",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											12.6.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<div class="responisve-iframe">
// 					             <iframe width="560" height="315" src="https://www.youtube.com/embed/U8KwXVP3Xng" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
// 				             </div>
// 				             <div class="ac-cradit" style="margin-top: -15px;margin-bottom: 40px;">
// 							<span class="ac-cradit-text">Credits:</span>
// 								<span class="ac-cradit-text-1"><a href="https://www.youtube.com/channel/UCWN-mUP4IzdHLH7gaXHEKVw" target="_blank">Basti Hansen</a><br/>
// 							</div>
// 							<p></p>
// 							</div>
// 							<h2 class="ac-align-center">Das schillerndste Event des Jahres</h2>
// 							<p class="ac-align-center ac-margin-bottom-20"><strong>Die Tel Aviv 2020 Pride Celebrations – einzigartig und unvergesslich!</strong></p>
// 							<p>Tel Aviv ist unter den LGBT-Hauptstädten der Welt weit vorn und bekannt für seine einzigartig energiegeladene Atmosphäre und ausgefallenen Nonstop-Partys. Eines der größten und angesagtesten Events der Stadt ist die „Gay Pride Week", die ihr grandioses Finale mit der Pride Parade am Freitag feiert.</p>
//                             <p>Bereits seit 1998 treffen bei dieser Parade unzählige ausgelassene Menschen und tausende Teilnehmern aus aller Welt zusammen. Sie feiern die Freiheit und setzen sich im Rahmen dieses grandiosen Happenings für Offenheit gegenüber allen Lebensstilen und Orientierungen ein.</p>
//                             <p>Die Parade ist der Höhepunkt einer Woche von Gay Pride Events, die in ganz Tel Aviv stattfinden und zu denen unter anderem Themen-Partys, Ausstellungen, Filmfestivals, Konzerte und vieles mehr gehören.</p>
//                             <p>In schönster Tradition der Gay Pride-Paraden in aller Welt findet die Pride Parade entlang der pulsierenden Hauptstraßen Tel Avivs statt – mit extravaganten Wagen, Live-Musik, Tanz-Performances und bunt gekleideten Feiernden.</p>
//                             <p>Ihren Endpunkt findet die Parade an Tel Avivs traumhafter Promenade direkt am Meer und wird dort zur unvergesslich aufregenden Beachparty, die mit Top-DJs und Live-Auftritten bis in die frühen Morgenstunden dauert.</p>
//                             <p>Die Parade findet am 12. Juni 2020 statt und wie in jedem Jahr ist die Teilnahme absolut kostenlos!</p>
// 					               `
// 			}
// 		}
//     },
//     {
// 	              id: "Hutzot_Hayotzer_Jerusalem_2020",
// 	              bgImage:"/posts/bank/international-arts/1.jpg",
// 	              mobBgImage:"/posts/bank/international-arts/M.jpg",
// 	              title: "Hutzot Hayotzer Jerusalem",
// 	              smlTitle: "",
// 	              html: function(){
// 			return {
// 				__html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Ort</h2>
// 											<div class="text">
// 												<p>
// 													Merrill Hassenfeld Amphitheater
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Datum</h2>
// 											<div class="text">
// 												<p>
// 													08.2020
// 												</p></p>
// 											</div>
// 										</div>
// 									</div>
// 							        <div class="clear"></div>
// 							        <h2>Internationale Kunsthandwerksmesse</h2>
//                                     <p>Den ganzen Sommer über bietet Jerusalem eine Vielzahl großartiger Veranstaltungen. Eine der bekanntesten ist die bunte internationale Kunsthandwerksmesse "Hutzot Hayotzer".</p>
//                                       <p>Das große jährliche Festival findet in der Gegend Hutzot Hayotzer und im Merrill Hassenfeld Amphitheater (auch bekannt als The Sultan’s Pool) gegenüber dem Davidsturm und am Fuße der Altstadt-Mauern statt.</p>
//                                       <p>Seit mehr als 35 Jahren in Folge lockt das mittlerweile schon legendäre Hutzot Hayotzer Besucher aus aller Welt an – und ist längst zu einer der beliebtesten touristischen und künstlerischen Veranstaltungen Jerusalems geworden.</p>
//                                       <p>Regelmäßig gibt es hier die Werke von weit mehr als 150 einheimischen Künstler zu bewundern, darunter Gemälde, Drucke, Keramik, Schmuck und mehr. Darüber hinaus präsentiert eine internationale Ausstellung die Arbeiten ausländischer Künstler.</p>
//                                       <p>Nehmen Sie als Gast an den inspirierenden Kunstgesprächen und einzigartigen Workshops teil und erleben Sie die zahlreichen Live-Performances, einen irischen Pub, gigantische Skulpturen, Live-Jazzmusik und eine echte europäische Karnevalsatmosphäre.</p>
//                                       <p>Das Festival ist jeden Abend (außer freitags) zwischen 18:00 und 23:00 Uhr sowie samstagabends von 21:00 bis 24:00 Uhr im Hutzot Hayotzer, Mitchell Park und im Merrill Haasenfeld Amphitheater geöffnet.</p>
//                                       <p>Last but not least sollten Sie sich keinesfalls "Food around the world" entgehen lassen: Diese internationale Kulinarik-Messe bringt an ihren zahlreichen Ständen Genüsse aus aller Welt für Sie nach Jerusalem, darunter natürlich israelisch, als auch thailändisch, chinesisch, koreanisch und viele weitere Nationen.</p>
// 	                            `
// 			}
// 		}
//     },
//     {
//                   id: "Jerusalem_Beer_Festival_2020",
// 	              bgImage:"/posts/bank/jerusalem-beer-festival/1.jpg",
// 	              mobBgImage:"/posts/bank/jerusalem-beer-festival/M.jpg",
// 	              title: "Jerusalem Beer Festival",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Time</h2>
// 											<div class="text">
// 												<p>
// 													18:00 – 00:00
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Datum</h2>
// 											<div class="text">
// 												<p>
// 													08.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="clear"></div>
// 							        <p>Jerusalem ist stolz darauf, bereits im 16. Jahr (!) in Folge das großartige und weithin beliebte "Beer Festival“ auszurichten – ein weltbekanntes Event, bei dem sich alles um gute Musik, gutes Essen und, wie Sie sicher erraten haben, natürlich um gutes Bier dreht.</p>
//                                     <p>Zur unvergleichlichen Atmosphäre des Festivals trägt selbstverständlich auch der Veranstaltungsort bei: die zauberhafte 3.000 Jahre alte Stadt Jerusalem sorgt für ein wahrhaft unvergessliches Erlebnis!</p>
//                                     <p>Über die Jahre ist das Festival geradezu legendär geworden und nicht mehr aus der Unterhaltungskultur Jerusalems wegzudenken. Es bietet Besuchern aus aller Welt die einzigartige Gelegenheit, eine erfrischende Auswahl kühler Biere, köstlicher Speisen und geselliger Menschen unter freiem Himmel zu genießen.</p>
//                                     <p>In eigens für die Veranstaltung errichteten Pop-up-Bars haben Sie die Möglichkeit, diverse (oder alle) der unterschiedlichen und besonderen Biere aus dem ganzen Land und der ganzen Welt zu probieren – von denen wir mehr als 120 für Sie kaltgestellt haben!</p>
//                                     <p>Das Jerusalem Beer Festival ist das einzige Event seiner Art in Israel. Diverse einheimische Brauereien präsentieren hier Jahr für Jahr ihre Erzeugnisse. Hinzu kommt eine immense Vielfalt internationaler Marken, die man unbedingt probiert und erlebt haben sollte.</p>
//                                     <p>Machen Sie sich auf den Weg und werden Sie Teil der mehr als 15.000 Besucher, die sich an der einzigartigen Atmosphäre, fantastischen Live-Shows, dem leckere Essen und den herzlichen Menschen erfreuen und dabei das weltweite Lieblingsgetränk Bier feiern.</p>
// 	                            `
// 			}
// 		}
//     },
//     {
//         id: "Jerusalem_Wine_Festival_2020",
// 	    bgImage:"/Concerts/bank/jer-wine-festival-2020/1.jpg",
// 	    mobBgImage:"/Concerts/bank/jer-wine-festival-2020/M.jpg",
// 	    title: "Jerusalem Wine Festival",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Ort</h2>
// 									<div class="text">
// 										<p>
// 											Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Datum</h2>
// 									<div class="text">
// 										<p>
// 											08.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>WeiteRe informationen</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.imj.org.il/en/events/wine-festival-1">
// 												www.imj.org.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Genussvolle Stunden in der Heiligen Stadt!</h2>
// 							<p>Entspannte Sommerabende sind wie geschaffen für ein Glas hervorragenden Weins – und deshalb können Sie auch in diesem Jahr wieder für vier Tage im August die erstklassige Weinauswahl und preisgekrönte Küche des 17. Jerusalem Wine Festival genießen. Ausgerichtet im traumhaften Japanischen Garten des Israel Museums, gilt es vielen als das gesellschaftliche Ereignis Jerusalems. Seine Atmosphäre und die grandiosen Ausblicke auf die geschichtsträchtige Stadt, machen das JWF zu einem einzigartigen Wein Event, das man einfach erlebt haben muss.</p>
//                             <p>Dabei werden hunderte verschiedener Weine von Dutzenden renommierter, wie auch kleiner, feiner Weingüter angeboten. Freuen Sie sich auf kostenlose Weinverkostungen und auf die kulinarische Vielfalt verschiedener Stände, an denen Käse, Schokolade, Olivenöl, ausgezeichnete Soßen und köstliche Konfitüren angeboten werden. Neben dem Gaumen kommen aber auch die Ohren zu ihrem Recht: Im Rahmen des Festivals erwarten Sie jeden Abend zwei verschiedene Livemusik-Acts.</p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/69/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>Jedes Jahr zieht das JWF eine facettenreiche Schar von weit mehr als 20.000 Wein- und Kulturliebhabern nach Jerusalem. Viele nutzen die Zeit und sind gleich mehrere Abende vor Ort, um die einzigartige Atmosphäre des Festivals zu genießen.</p>
//                             <p>Planen auch Sie bereits jetzt Ihren Aufenthalt während des Festivals. </p>
//                             <p>Tagsüber erwartet Sie eine Fülle an Möglichkeiten zum Sightseeing, Shopping und abwechslungsreichen Ausflügen in die Umgebung, während das Jerusalem Wine Festival den perfekten Ausklang am Abend bietet – ganz entspannt, mit bester Unterhaltung und jeder Menge Spaß!</p>
// 					     `
// 			}
// 		}
//     },
//     {
// 	              id: "Open_Houses_Festival_2020",
// 	              bgImage:"/posts/bank/openhf/1.jpg",
// 	              mobBgImage:"/posts/bank/openhf/M.jpg",
// 	              title: "Open Houses Festival",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Ort</h2>
// 											<div class="text">
// 												<p>
// 													Tel Aviv, stadtweit
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Datum</h2>
// 											<div class="text">
// 												<p>
// 													09.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>WeiteRe informationen</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="//www.batim-il.org/DefaultEng.aspx?batim=">
// 														www.batim-il.org
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div><div class="clear"></div>
//                                     <h2>Ein großartiges Erlebnis für Designliebhaber aus aller Welt</h2>
//                                     <p>Bereits zum 15. Mal in Folge findet im September dieses Jahres in Tel Aviv – der Stadt, die niemals schläft – das fantastische Architektur- und Designfestival "Open House" statt.</p>
//                                     <p>Die Teilnehmer erwartet ein spannendes Programm mit unvergesslichen Besuchen und Touren einiger der beeindruckendsten Gebäude der Stadt, darunter Privathäuser, Appartements, historische Gebäude sowie städtische Bauten. Darüber hinaus werden spezielle Führungen und besondere Aktionen an verschiedenen ungewöhnlichen Orten angeboten.</p>
//                                     <p>„Open Houses" öffnet Türen, die die meiste Zeit verschlossen sind und gewährt einen Blick hinter die Kulissen von Design, Lebensentwürfen, Geschichte, Kultur, Technologie, Ökologie und in Häuser mit jenem gewissen Etwas, das sie so anziehend und ansprechend macht.</p>
//                                     <p>Unter den vielen Gebäuden und Bauwerken, die für die Öffentlichkeit zugänglich gemacht werden, sind einige, die nie zuvor geöffnet wurden: das Tel Aviv Velodrome zählt ebenso dazu, wie das Innere eines Schiffes oder eine 1840 erbaute Synagoge in der Altstadt von Jaffa. Zu den Favoriten der Festival Fans zählen u. a. der Hubschrauberlandeplatz auf dem Azrieli-Dach und ein Atomschutzbunker im Dizengoff Center.</p>
//                                     <p>„Open Houses" ist Teil der Open House Worldwide Organisation, die in New York, London, Chicago, Rom, Barcelona, Melbourne, Dublin, Helsinki und anderen Städten rund um den Globus aktiv ist.</p>
//                                     <p>Erleben Sie ein einzigartiges und unvergessliches Fest urbaner Lebenskultur in der großartigen Stadt Tel Aviv!</p>
// 	                            `
// 			}
// 		}
//     },
//     {
// 	              id: "DGTL_Festival_2020",
// 	              bgImage:"/posts/bank/dgtl-festival2019/1.jpg",
// 	              mobBgImage:"/posts/bank/dgtl-festival2019/M.jpg",
// 	              title: "DGTL FESTIVAL",
// 	              smlTitle: "",
// 	              html: function(){
// 			return {
// 				__html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Ort</h2>
// 											<div class="text">
// 												<p>
// 													Hayarkon Park Tel Aviv
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Datum</h2>
// 											<div class="text">
// 												<p>
// 													08.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>WeiteRe informationen</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="https://tlv.dgtl.nl/en/dgtl-tel-aviv-returns-to-israel/">
// 														www.tlv.dgtl.nl
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="clear"></div>
// 							        <p> Das DGTL Festival is zurück in Tel Aviv und bringt einmal mehr ein hochkarätiges Musikprogramm in den Yarkon Park – begleitet von den aktuellsten nachhaltigen und technologischen Neuerungen und innovativen Kunstprojekten.</p>
//                                     <p>Als weltweite Veranstaltungsreihe gehört das DGTL Festival zu den Vorreitern der Musik- und Festivalszene und präsentiert sich in Hot Spots rund um den Globus: Amsterdam, Sao Paulo, Barcelona, Santiago und Tel Aviv. DGTL bringt Musik, Technik und Kunst sowie neueste Errungenschaften aus den Bereichen Musikproduktion und Sound zusammen.</p>
//                                     <p>In Tel Aviv präsentiert sich das DGTL Festival in einer erweiterten Ausgabe mit einem gigantischen Line-Up von Künstlern – und mit einem großartigen Programm, das auf vier Bühnen gleichzeitig stattfindet.</p>
//                                     <p>Darüber hinaus ist DGTL nicht nur ein innovatives Musikfestival, sondern setzt sich intensiv für Umweltschutz und Nachhaltigkeit ein und wurde dafür als umweltfreundlichstes Festival Europas ausgezeichnet. Das Festival hat ein richtungsweisendes Programm zur Reduzierung des Stromverbrauchs, bietet ausschließlich vegetarisches Essen, verfügt über einen Recyclingplan und vieles mehr.</p>
//                                     <p>Veranstaltungsort des Festivals ist der wunderschöne Yarkon Park im Herzen Tel Avivs. Als Schauplatz von Innovationen, Trends und aufregendem Nachtleben ist die pulsierende Metropole der perfekte Gastgeber für das DGTL Festival.</p>
//                                     <p>Erleben Sie es am besten selbst und feiern Sie mit bei einem der weltweit außergewöhnlichsten Festivals – im Herzen der aufregendsten Stadt der Welt!</p>
// 	                            `
// 			}
// 		}
//     },
// ];
// End live shows
var ShowsPostsData=[];var newPostdata=[{id:"eurovision",bgImage:"/posts/bank/eurovision/1.jpg",mobBgImage:"/posts/bank/eurovision/M/1.jpg",title:"EUROVISION TEL AVIV",ctg:"eurovision",isVid:false,smlTitle:"",html:function html(){return{__html:"\n\n                   \t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/eurovision/logo.png")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tA ONCE IN A LIFETIME OPPORTUNITY TO VISIT TEL AVIV AS IT HOSTS THE EUROVISION SONG CONTEST\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\t\t\t\t\t\n\t\t\t\t\t\tEpic song contest in the Non-Stop City\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tSemi-final 1: 14 May 2019\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tSemi-final 2: 16 May 2019\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tGrand Final: 18 May 2019\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tIt\u2019s getting hot hot hot in Fabulous Tel Aviv! The nonstop city is teaming with excitement as it is getting ready to host the 2019 Eurovision Song Contest in what promises to be one of the most epic events ever held in the famous party city.\n\t\t\t\t\t</p>\t\t\t\t\t\n\t\t\t\t\t<p>\n\t\t\t\t\t\tTel Aviv, known for its amazing energy, stunning beaches, great year round weather and gorgeous people, is the perfect destination for an unforgettable citybreak. Tel Aviv is known world over for its open mindedness and liberal spirit, making it the ideal host for the Eurovision song contest, offering visitors from far and wide the perfect opportunity to enjoy this vibrant and energetic city at its finest.\n\t\t\t\t\t</p>            \n                   \t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/eurovision/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tMajor productions centered around the Eurovision contest month are already well on their way. Some of the exciting events planned include an amazing opening ceremony, a prestigious red-carpet event, and even a mega \u201CEuro Village\u201D which will be situated merely a minutes\u2019 walk from the awesome Tel Aviv baordwalk and beach. The Euro Village will be open for 10 days and will include live performances from past and present mega stars as well as live screenings of the Eurovision contest\u2019s semifinal and final. The contest itself will take place in the Expo Tel Aviv.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tThe Eurovision Song contest in Tel Aviv is guaranteed to be an event of a lifetime, so make sure to book your trip now to the most amazing Eurovision contest yet, in the most amazing city of all!\n\t\t\t\t\t</p>\n\n            \t"};}},{id:"Get_ready_to_party",bgImage:"/posts/bank/Get_ready_to_party/1.jpg",mobBgImage:"/posts/bank/Get_ready_to_party/M/1.jpg",title:"The best Eurovision parties to be at",ctg:"eurovision",isVid:false,smlTitle:"",html:function html(){return{__html:"\n\n               <h3>\n               \tYour Total Guide to Tel Aviv Eurovision parties\n               </h3>\n               <p>\n\t\t\t\t\tFrom the Eurovision Village to the EXPO Centre, these are all the key places you need to know about for Eurovision 2019 in Tel Aviv\u2026\n\t\t\t\t</p>\n\t\t\t\t<h3>\n\t\t\t\t\tCHARLES CLORE PARTY VENUE\n\t\t\t\t</h3>\n\t\t\t\t<h3>\n\t\t\t\t\tCharles Clore Park: home to the largest Eurovision Village to have ever been made.\n\t\t\t\t</h3>\n\t\t\t\t<p>\n\t\t\t\t\tCharles Clore Park is located on the sea-front in the south-west of Tel Aviv. It\u2019s a beautiful green space overlooking Old Jaffa, one of the most ancient places in Tel Aviv. \n\t\t\t\t\tDuring Eurovision week it will be home to the Eurovision Village, where free concerts from the biggest Eurovision stars will take place. Highlights include Dana International and Conchita Wurst, plus parties and screenings of the live Eurovision TV shows will take place outside, right in-front of the beautiful Mediterranean sea! \n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tAlso, some of Israel\u2019s best chefs will be opening food stalls for the public to get first-hand experience of-mouth-watering Israeli and Middle-Eastern cuisine.\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tCharles Clore is easy to get to: It\u2019s a five minute walk from the Carmelit bus terminal, so any bus terminating there is a good choice. Then you can just walk towards the sea and you\u2019ll see the village. If coming by foot, walk along the beach promenade. Or you can cycle or scoot along the sea front to get there. \n\t\t\t\t\tIt\u2019s a big park and will be having a Eurovision makeover, so you won\u2019t be able to miss it! In fact, this is the largest village to ever have been made for the Eurovision!\n\t\t\t\t</p>\n\t\t\t\t<h3>\n\t\t\t\t\tTEL AVIV PORT VENUE (\u201CThe Namal\u201D)\n\t\t\t\t</h3>\n\t\t\t\t<h3>\n\t\t\t\t\tHome to 2019\u2019s official Eurovision Euro Club\n\t\t\t\t</h3>\n\t\t\t\t<p>\n\t\t\t\t\tWith its huge venues, gorgeous decking and sea-side views, Tel Aviv Port is the perfect place to party the night away on Eurovision week!\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tWith its huge venues, gorgeous decking and sea-side views, Tel Aviv Port is the perfect place to party the night away on Eurovision week!\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tThe club will feature theme parties, live performances, screenings of the Eurovision live shows and many more surprises to be revealed. Former Eurovision acts and winners, both Israeli and international, are set to perform there during the Eurovision week, so the venue will offer much more than just a traditional night-club. Entry to the Euroclub is free for accredited fans, journalists, delegations and artists. Members of the general public can get in to the Euroclub by purchasing a special weekly bracelet, here:\n\t\t\t\t\t<a href=\"https://www.eventer.co.il/euroclub?fbclid=IwAR37-d_19OE7bsq0rQ_gPHAW-sRfn1QAMi-cxp_ID2pFtDODBYzbf5NB6S0\" target=\"_blank\">https://www.eventer.co.il</a>\n\t\t\t\t</p>\n\t\t\t\t<h3>\n\t\t\t\t\tEUROVISION VENUE\n\t\t\t\t</h3>\n\t\t\t\t<h3>\n\t\t\t\t\tExpo Tel Aviv: home to the Eurovision Song Contest itself\n\t\t\t\t</h3>\n\t\t\t\t<p>\n\t\t\t\t\tThe 2019 Eurovision Song Contest will be held at the Tel Aviv Expo center on the14th, 16th and 18th May. If you\u2019ve got tickets, this is the place you\u2019ll need to get to.\n\t\t\t\t\tIt\u2019s located on Rokach Boulevard in the north of the city, past HaYarkon Park and near to Tel Aviv University. To get there, use a journey planning app to find a bus route that will drop you right outside. Or, if travelling by train, get off at Tel Aviv University Train Station which is just a few minutes\u2019 away from the convention centre.\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tDon\u2019t forget about the White Night, all the details are in the next article.\n\t\t\t\t</p>\n\n         \t"};}},{id:"Tourist_info",bgImage:"/posts/bank/Tourist_info/1.jpg",mobBgImage:"/posts/bank/Tourist_info/M/1.jpg",title:"BESUCHER-INFORMATIONEN",ctg:"telaviv",isVid:false,smlTitle:"",html:function html(){return{__html:"\n\n\t\t\t\t\t<h3>\n                    Der Weg vom Flughafen nach Tel Aviv:\n                  </h3>\n                  <p>\n                    Die g\xFCnstigste M\xF6glichkeit vom Flughafen Ben Gurion ins Zentrum von Tel Aviv, ist per Zug. Folgen Sie am Flughafen der gut sichtbaren Beschilderung zum angrenzenden Bahnhof und besteigen Sie einen der folgenden Z\xFCge: Tel Aviv-HaHagana (f\xFCr Ziele im S\xFCden der Stadt), Tel Aviv-HaShalom (um ins Zentrum zu fahren), Tel Aviv-Savidor Center (f\xFCr den alten n\xF6rdlichen Bereich) oder Tel Aviv-Universit\xE4t (um direkt zum Eurovision Song Contest zu gelangen). Bitte beachten Sie, dass Tel Aviv HaShalom bis September 2019 freitags geschlossen ist. \n                    Ein Einzelfahrschein in eine Richtung kostet 13 Schekel 50, die Fahrt dauert etwa 25 Minuten. Um vom jeweiligen Bahnhof zu Ihrer Unterkunft zu kommen, empfiehlt es sich ein Taxi zu nehmen. Bitten Sie den Fahrer dabei stets das Taxameter (\"monet\") einzuschalten und halten Sie Bargeld zur Bezahlung des Fahrpreises bereit. Alternativ k\xF6nnen Sie untenstehend mehr \xFCber diverse Taxi-Apps erfahren. F\xFCr weitere Informationen und die Planung Ihrer Reise lohnt es sich <a href=\"https://www.rail.co.il/en\" target=\"_blank\">https://www.rail.co.il/en</a> zu besuchen (in englischer Sprache).\n                  </p>\n                  <p>\n                      Sie m\xF6chten mit dem Taxi vom Flughafen nach Tel Aviv fahren? In diesem Fall stellen Sie sich im Wartebereich f\xFCr registrierte Taxis vor der Ankunftshalle an. Ein Mitarbeiter wird Sie nach Ihrem Fahrziel fragen, wieviel Mitreisende und wieviel Gep\xE4ck Sie haben und Ihnen ein entsprechendes Ticket aush\xE4ndigen, das Sie Ihrem Fahrer geben. Sie k\xF6nnen mit ihm entweder die Nutzung des Taxameters oder auch einen festen Fahrpreis vereinbaren. Fahrten kosten in der Regel 150-170 Schekel f\xFCr einen Fahrgast.\n                  </p>\n                  <h3>\n                    Der Weg von Tel Aviv nach Jerusalem:\n                  </h3>            \n                  <h3>\n                    Bus\n                  </h3> \n                  <p>\n                    Fahren Sie zum Hauptbahnhof Tel Aviv Savidor und besteigen Sie den Bus Nr. 480. Die Fahrzeit nach Jerusalem betr\xE4gt ca. 45 Minuten. Die Buslinie endet am Jerusalemer Busbahnhof an der Jaffa Road. Von dort k\xF6nnen Sie mit der Stra\xDFenbahn oder anderen Verkehrsmitteln an Ihr Ziel in der Stadt gelangen.\n                  </p>\n                  <h3>\n                    Zug\n                  </h3> \n                  <p>\n                    Sie haben auch die M\xF6glichkeit den ganz neuen Zug zu nehmen! Um direkt vom Flughafen Ben Gurion nach Jerusalem zu fahren, besteigen Sie den Zug zur Navon Station in Jerusalem. Die Fahrzeit betr\xE4gt ca. 25 Minuten. Von anderen Stationen in Tel Aviv, nehmen Sie einfach einen Zug zum Bahnhof Ben Gurion Airport und steigen dort um in eine Verbindung nach Navon.\n                  </p>\n                  <h3>\n                    Innerhalb Tel Avivs\n                  </h3> \n                  <p>\n                    Die Stadtverwaltung von Tel Aviv bietet am Wochenende des Eurovision Song Contest kostenlose \xF6ffentliche Verkehrsmittel in der ganzen Stadt an. \n                    Kostenlose Busse fahren am Freitag und Samstag, dem 17. und 18. Mai. In der Regel fahren jedoch am Samstag keine \xF6ffentlichen Verkehrsmittel in Tel Aviv (mit Ausnahme von Taxis).\n                    W\xE4hrend der anderen Tage der Eurovisions-Woche ben\xF6tigen Sie eine Rav-Kav-Karte: Dabei handelt es sich um eine Smart Card, die mit einem Guthaben aufgeladen wird \u2013 und Ihnen erlaubt bargeldlos mit Bussen fahren zu k\xF6nnen. Da Busfahrer keine Barzahlung mehr akzeptieren, ist es wichtig eine Rav-Kav-Karte zu erwerben, sobald Sie in Tel Aviv ankommen.\n                    Um die Karte zu bekommen, steigen Sie in einen Bus an einer beliebigen Haltestelle und fragen Sie den Fahrer danach \u2013 sie kostet 5 Schekel (bitte halten Sie diesen Betrag in bar bereit). Steigen Sie aus dem Bus aus und f\xFChren Sie die Karte immer mit sich. Einige \xF6rtliche 7/11 Kioske bieten die Aufladung an, lassen Sie sich hier ein kleines Guthaben auf die Karte buchen. 50 Schekel sind meist ausreichend f\xFCr einen einw\xF6chigen Aufenthalt, da sie die Kosten f\xFCr diverse lokale Fahrten decken (jede Fahrt kostet 5 Schekel 90).\n                    Sie haben auch die M\xF6glichkeit eine Rav-Kav-Karte im Rav-Kav-B\xFCro in der Iban Gabirol Stra\xDFe 35 zu kaufen (ge\xF6ffnet Sonntag bis Donnerstag von 8:00 bis 20:00 Uhr, Freitag und an Feiertagen von 8:00 bis 13:00 Uhr). Dar\xFCber hinaus ist sie am Tel Aviv Savidor Bahnhof und im zentralen Bahnhof Carmelit erh\xE4ltlich. Die Aufladung mit Guthaben kann an jedem Bahnhof erfolgen. \n                  </p>\n                  <h3>\n                    Fahrrad\n                  </h3> \n                  <p>\n                    Tel Aviv ist ein Fahrradfahrer-Paradies und bietet Radwege in der ganzen Stadt, einschlie\xDFlich eines, der entlang der Strandpromenade von Jaffa im S\xFCden bis in Tel Avivs Norden und noch weiter verl\xE4uft \u2013 und sich f\xFCr eine wundersch\xF6ne Fahrradtour eignet, bei der Sie die Atmosph\xE4re und Architektur von Tel Aviv genie\xDFen k\xF6nnen. Wenn Sie einen eigenen Fahrradhelm besitzen, bringen Sie ihn gerne mit.\n                  </p>\n                  <h3>\n                    Elektro-Roller\n                  </h3> \n                  <p>\n                    Roller sind voll im Trend in Tel Aviv \u2013 und bieten eine bequeme und coole M\xF6glichkeit, die Stadt zu erkunden. Es gibt verschiedene Anbieter und alles was Sie tun m\xFCssen, ist die entsprechende App herunterzuladen, den Anweisungen zu folgen und loszurollern. Um besser Balance halten zu k\xF6nnen, tauschen Sie Ihre Handtasche gegen einen Rucksack und denken Sie immer daran den Verkehr zu beachten und beim Scooten keine Musik zu h\xF6ren. Wenn Sie einen Helm haben, empfiehlt es sich diesen beim Scooten zu tragen. \n                  </p>\n                  <h3>\n                    Laufen\n                  </h3>\n                  <p>\n                    Laufen ist ebenfalls eine gute M\xF6glichkeit die Stadt, die niemals schl\xE4ft zu erkunden \u2013 und Sie werden sehen, wie Ihre Strecken Tag f\xFCr Tag l\xE4nger werden. Einen Stadtplan, einen Sonnenhut und eine Flasche Wasser \u2013 mehr braucht es nicht, damit es losgehen kann!\n                  </p>\n                  <h3>\n                    Verkehrsmittel-Apps\n                  </h3>\n                  <p>\n                    Es gibt diverse Verkehrsmittel-Apps, die Sie im Vorfeld herunterladen k\xF6nnen, um Ihnen bei der Planung Ihrer Reise zu helfen. W\xE4hlen Sie aus jeder Kategorie ihren Favoriten: Es gibt Taxi-Apps, Fahrradverleih-Apps, Roller-Verleih-Apps und Fahrplan-Apps. Und nat\xFCrlich k\xF6nnen Sie auch den Concierge Ihres Hotels oder dem Vermieter Ihres Ferien-Appartements fragen, wie man in Tel Aviv am besten von A nach B kommt \u2013 sie helfen Ihnen gerne weiter!\n                  </p>\n                  <h3>\n                    WIFI\n                  </h3>\n                  <p>\n                    Tel Aviv verf\xFCgt \xFCber ein kostenloses WLAN-Netz in der gesamten Stadt. Suchen Sie auf Ihrem Smartphone nach dem \u201AFreeTLV\u2018-Netz \u2013 es ist an \xFCber 80 Standorten verf\xFCgbar. Dar\xFCber hinaus haben die meisten Caf\xE9s und Bars kostenlose \xF6ffentliche WLAN-Netze, die Sie ebenfalls nutzen k\xF6nnen: Fragen Sie beim Bestellen einfach nach dem Passwort. Und auch die Hotels bieten kostenloses WLAN \u2013 beim Check-in gibt man Ihnen gerne die entsprechenden Informationen.\n                  </p>\n\n         \t"};}},{id:"White_night",bgImage:"/posts/bank/White_night/1.jpg",mobBgImage:"/posts/bank/White_night/M/1.jpg",title:"White night",ctg:"eurovision",isVid:false,smlTitle:"",html:function html(){return{__html:"\n\n\t\t\t\t\t\t\t<h1 class=\"align-center\">\n\t\t\t\t\t\t\t  White Night Lights Up Tel Aviv on 16th May \n\t\t\t\t\t\t\t</h1>\n        \t\t\t\t\t<div class=\"responisve-iframe\">\n\t\t\t\t\t\t\t\t<iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/T0ugqxG5UaM\" frameborder=\"0\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<p>What do you get when you cross a Eurovision Semi-Final with an all-night party in a city that is famous for its 24/7 party energy? The answer is White Night, which will hit Tel Aviv this year on Thursday 16th May, just two days before the 2019 Eurovision Song Contest grand final.</p>\n                            <p>Featuring pop-up art installations, live music, dance parties, cultural events, food and drink, all fused together with Tel Aviv\u2019s eclectic atmosphere, White Night is one of the biggest cultural events of the year. </p>\n                            <p>And for 2019, it\u2019s taking place a month earlier than usual, so that visitors coming for the Eurovision Song Contest can also experience this magical experience in the White City of Tel Aviv.</p>\n\n\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/White_night/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<small>\n\t\t\t\t\t\t\t\tPhoto By: Adam Primer\n\t\t\t\t\t\t\t</small>\n\n\t\t\t\t\t\t\t<p>From sunset until sunrise, the city will be wide-awake with cultural activities. Locals and visitors alike are invited to explore the city and soak up all the activities on offer. Many bars, restaurants and shops will be offering experiences free of charge or at reduced rates, so it\u2019s definitely worth stocking up on sleep so you\u2019re ready to party all night long!</p>\n                            <p>And at the Eurovision Village in Charles Clore Park, there\u2019ll be an extra sparkle of Eurovision magic, as several icons of the competition take to the stage to entertain visitors during the night. </p>\n                            <p>Last year\u2019s runner-up, Eleni Foureira, who narrowly missed out to Tel Aviv\u2019s own Neta Barzilai with her smash-hit song \u201CFuego\u201D, will be performing, as will 2014 winner, Conchita Wurst from Austria, who will most likely perform his iconic winning song, \u201CRise Like a Phoenix\u201D while showcasing his new-look for 2019!</p>\n                            <p>They\u2019ll be joined by three more Queens of Eurovision, in the form of 1970s pop icon Anne-Marie David, who won for Luxembourg in 1973, Swedish pop star Carola H\xE4ggkvist, who won the contest in 1991, and Loreen, who also won for Sweden in 2012 with her song Euphoria. The performances will take place on the coast, overlooking the Mediterranean; the live semi-final will also be shown on big-screens in the Eurovision Village, off-set by jaw-dropping light compositions, created by the competition\u2019s official lighting partner OSRAM.</p>\n                            <p>All in all, White Night is a night not to be missed. So make the 15th May your duvet day and get-set to party all night long on Thursday 16th May 2019. Tel Aviv is ready and waiting to celebrate with you!</p>\n\n\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/White_night/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<small>\n\t\t\t\t\t\t\t\tPhoto By: Kfir Sivan\n\t\t\t\t\t\t\t</small>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/White_night/3.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<small>\n\t\t\t\t\t\t\t\tPhoto by Moshik Lindenbaum\n\t\t\t\t\t\t\t</small>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/White_night/4.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<small>\n\t\t\t\t\t\t\t\tPhoto by: Guy Yechiely\u200E.\n\t\t\t\t\t\t\t</small>\n\n         \t"};}},// //No translation
// {
// 	id:13,
//         bgImage : "/posts/bank/25/1.jpg",
//         mobBgImage : "/posts/bank/25/M.jpg",
//         vidId : "k4OwoEk5wMw",
//        	ctg : "jerusalem",
//        	isVid:true,
//         title : "Jerusalem’s Calling",
//         smltitle : "The most magical and radiant city on Earth ",
//         html: function(){
// 			return {
// 				__html: `
// 					<p>
// 						What else can you say about the world’s most unique city? Simply put: Welcome to Jerusalem – where a glorious history is intertwined with modern and dynamic life.
// 					</p>
// 					<p>
// 						Jerusalem is home to innumerable fascinating historic sites, magical walkways, breathtaking views at sunset, a wide variety of entertainment options, restaurants that offer culinary excitement, spirited nightlife and a tremendous offering of centers for the arts and culture.
// 					</p>
// 					<h3>
// 					   The Old City
// 					</h3>
// 					<p>
// 						No other place offers as many attractions and emotionally inspiring sites in a single square kilometer. The Old City of Jerusalem brims with opportunities for you to connect with the city’s resplendent past, history, culture and spirituality. In the Old City, you’ll find archaeological treasures that are thousands of years old, contemporary art and bustling markets where you can purchase delectable delights.
// 					</p>
// 					<h3>
// 					  The Western Wall:
// 					</h3>
// 					<p>
// 						Believed to be the only remaining segment of the Second Temple, the Western Wall has become truly synonymous with Jerusalem. Thousands of years old, it is the most important Jewish prayer site in the world, where thirteen-year-old boys come to celebrate their bar mitzvahs, and where millions of visitors and tourists from around the world place notes with requests and prayers into its cracks.
// 					</p>
// 					<h3>
// 					  Western Wall Tunnels:
// 					</h3>
// 					<p>
// 						Visiting the tunnels is like entering a time machine. Located beneath the Western Wall and the Muslim Quarter, provides visitors with a glimpse of the various periods in the history of Jerusalem.
// 					</p>
// 					<h3>
// 					   City of David:
// 					</h3>
// 					<p>
// 						Located next to the Dung Gate, this site presents the story of Jerusalem during the reigns of King David, King Solomon and King Hezekiah. Many archeological treasures were unearthed in the excavation, including a two-thousand year-old gold earring.
// 					</p>
// 					<p>
// 					   A visit to the site will enable you to take a flashlight and wade through the flowing water of the Siloam Tunnel, which was built during the reign of King Hezekiah.
// 					</p>
// 					<h3>
// 					 Via Dolorosa
// 					</h3>
// 					<p>
// 						Christian faithful follow in the footsteps of Jesus down the Via Dolorosa and the 14 Stations of the Cross, reenacting the fateful path that had an unprecedented impact on the course of history.
// 					</p>
// 					<h3>
// 					  Church of the Holy Sepulchre:
// 					</h3>
// 					<p>
// 						According to Christian tradition, the Church is the site where Jesus was crucified, buried and where he resurrected from the dead. It has long been and continues to be a major pilgrimage center for Christians world over.
// 					</p>
// 					<h3>
// 					 The market in the Old City:
// 					</h3>
// 					<p>
// 						This must-see attraction is made up of a series of alleyways, with numerous stalls offering a staggering variety of souvenirs, clothing, foods (baked goods, spices, sweets, tehini and more); stands hawking juices of all kinds, Armenian ceramics, drums and other musical instruments, earthenware jugs and much more. The colorful market delivers an authentic and extremely enjoyable experience that simply cannot be missed.
// 					</p>
// 					<div class="img-wrapper">
// 						<img src=${getImgUrl() +  "/posts/4/2.jpg"} class="img-responsive" />
// 					</div>
// 					<h3>
// 						Attractions
// 					</h3>
// 					<h3>
// 						Segway tours:
// 					</h3>
// 					<p>
// 						This adrenaline-packed method of seeing the city will allow you to take in the beauty of Jerusalem from an entirely different perspective. The Segway tours leave from various central spots, including the Armon HaNatziv Promenade (East Talpiot), Yemin Moshe, and the Old City, as well as near the Knesset and the museum area.
// 					</p>
// 					<h3>
//                         First Station (Hatachana):
// 					</h3>
// 					<p>
// 					   If you like amusement park rides, you love having your senses scintillated by the Time Elevator. It’s an interactive experience that takes visitors on fabulous voyages to fascinating places, with motion-based seating in a unique hall that is filled with special effects.
// 					</p>
// 					<h3>
//                         Time Elevator:
// 					</h3>
// 					<p>
// 					   The First Station is right in the heart of Jerusalem, between the Old City and the city center, and between the historical neighborhoods of the German Colony and Yemin Moshe. It is the site of the first train station in Jerusalem, which was built in 1892. After undergoing renovation and preservation, the First Station was reopened as a lively entertainment spot.
// 					</p>
// 					<h3>
// 					   Machane Yehuda Market:
// 					</h3>
// 					<p>
// 					   To experience the city as authentically as possible, your itinerary must include a stop at Machane Yehuda Market. It represents Jerusalem of the present and the future. Machane Yehuda uniquely brings together old and new, with its fruit and vegetable market, along with an excellent food and a vibrant entertainment area.
// 					</p>
// 					<h3>
// 					   Museums
// 					</h3>
// 					<p>
// 					   In a city filled with a large number of museums, you have every opportunity to experience and learn about the events of the past and to visit modern and contemporary exhibits.
// 					</p>
// 					<h3>
// 					   Israel Museum
// 					</h3>
// 					<p>
// 					   The Israel Museum is the largest cultural institution in the country. It has many wings and very large collections of art, archeology and Judaica. One of the highlights of any visit to the museum is the Shrine of the Book, with its unique design that has come to be closely associated with the city itself.
// 					</p>
// 					<h3>
// 					   Tower of David Museum:
// 					</h3>
// 					<p>
// 					  Thousands of years ago, Jerusalem was a small city, where kings and prophets walked or rode their horses down the alleys. Since that time, one of the best-known symbols of the city is David’s Tower, with its turret standing proudly above the ancient fortress that has also become one of the city’s important museums.
// 					</p>
// 					<div class="img-wrapper">
// 						<img src=${getImgUrl() +  "/posts/4/3.jpg"} class="img-responsive" />
// 					</div>
// 					<h3>
// 					   Restaurants
// 					</h3>
// 					<p>
// 					  Jerusalem boasts many restaurants, where you can dine on a wide array of delicacies –local and international, standard and exotic. And if you are looking for the gourmet experience, you can reserve a spot at exclusive chef restaurants. The following are five of Jerusalem’s finest and most popular spots, which attract crowds all day long:
// 					</p>
// 					<h3>
// 					   Café Kadosh
// 					</h3>
// 					<p>
// 					 Highly popular, the café serves kosher dairy cuisine – all made in house, and all delicious!
// 					</p>
// 					<h3>
// 					   Tmol Shilshom
// 					</h3>
// 					<p>
// 					  A dairy bookstore café in the city center, favored for its warmth, delicious food and friendly service. Don’t miss the shakshuka or salmon fillet in fig sauce!
// 					</p>
// 					<h3>
// 					   The Eucalyptus
// 					</h3>
// 					<p>
// 					  The kosher restaurant, located in the Artist’s Quarter, serves Chef Moshe Basson’s interpretation of biblical cuisine. Every dish has its origins in biblical scenes and all the spices and herbs used grow, as in ancient times, in the surrounding hills of Jerusalem and Judea. An unforgettable experience.					</p>
// 					<h3>
// 					   Darna
// 					</h3>
// 					<p>
// 					  An authentic, glatt kosher, Moroccan restaurant, located in the heart of the city. Experience the warm welcome and the true meaning of Moroccan hospitality, while enjoying the culinary excellence of the Maghreb.
// 					</p>
// 					<h3>
// 					   Ima Restaurant
// 					</h3>
// 					<p>
// 					  Right down the street from Machane Yehuda market, Ima offers excellent kosher Middle Eastern food, served in a relaxed family atmosphere
// 					</p>
// 					<h3>
// 					   And no visit to Jerusalem is complete without scooping up some hummus with a pita right out of the oven. The following are a few centrally located hummus spots:
// 					</h3>
// 					<div class="cradit">
// 							<p>
// 							<strong>Azura,</strong><small> in the Iraqi section of the Mahane Yehuda Market </small><br>
// 							<strong>Lina,</strong><small> in the Christian Quarter of the Old City</small><br>
// 							<strong>Hummus Acramawi,</strong><small>  in the Muslim Quarter of the Old City </small><br>
// 							<strong>Hummus</strong><small> Ben Sira, in the city center next to the Mamilla Hotel</small><br>
// 							<strong>Abu Shukri,</strong><small> in the Muslim Quarter in the Old City of Jerusalem </small><br>
// 							</p>
// 				    </div>
// 				    <h3>
// 				        Nightlife
// 				    </h3>
// 				    <p>
// 				         Jerusalem is filled with scores of restaurants and entertainment spots that are also open on Friday nights (the Jewish Sabbath). All of Jerusalem’s entertainment areas have excellent options for weekend fun on Friday nights as well as Saturdays, and you can most definitely enjoy a delightful evening over a cold beer or dance to great music.
//                          Below is a small selection of bars and clubs that are hopping on Friday nights and will leave you wanting more…
// 				    </p>
// 				    <h3>
// 				       Mantra
// 				    </h3>
// 				    <p>
// 				       An intimate restaurant and wine bar, where a friendly atmosphere meets superb cuisine.
// 				    </p>
// 				    <h3>
// 				       Gatsby Cocktail Room
// 				    </h3>
// 				    <p>
// 				       The cocktail lounge and bar evokes the magic of the Roaring 20’s and the days of cabarets.
// 				    </p>
// 				    <h3>
// 				        HaTaklit
// 				    </h3>
// 				    <p>
// 				       With a name means “the record” in Hebrew, the trendy bar is decorated with record sleeves. Enjoy full bar, live music, DJs and even independent performers.
// 				    </p>
// 				    <h3>
// 				       Toy Bar (HaTza’atzua)
// 				    </h3>
// 				    <p>
// 				      Centrally located, Toy Bar offers great drinks, great music by some of the best local DJs and great dance bar experience.
// 				    </p>
// 				    <h3>
//                         Sira
// 				    </h3>
// 				    <p>
//                        One of the city’s most eclectic underground clubs, with an arcade room and dance floor. The pub also hosts events and performances.
// 				    </p>
// 				    <h3>
//                         Even / Juke
// 				    </h3>
// 				    <p>
// 				       A music club that showcases the most creative bands in Israel, with an emphasis on jazz, blues and funk.
// 				    </p>
// 				    <h3>
//                        Video Pub
// 				    </h3>
// 				    <p>
// 				       Jerusalem’s only “official” gay bar is home to some of the wildest parties in the city.
// 				    </p>
// 				    <p>
// 				       Jerusalem is the ultimate vacation destination! With so much to see and do, so much to stimulate your senses and pique your curiosity, your trip to Jerusalem promises us an unforgettable experience. Book your vacation now!
// 				    </p>
// 				    <div class="img-wrapper">
// 						<img src=${getImgUrl() +  "/posts/4/4.jpg"} class="img-responsive" />
// 					</div>
// 					<h3>Box:</h3>
// 					<h3>
// 					   Annual events
// 					</h3>
// 					<p>
// 					   Jerusalem plays host to a variety of unique annual events. Check the Internet for dates and further information.
// 					</p>
// 					<h3>
// 					   Festival of Light
// 					</h3>
// 					<p>
// 					   Held in the Old City – May 25, 2016 to June 2, 2016. Come and be part of the enchanting games of light and color, with dozens of displays by Israeli and international artists. Follow the paths set up throughout the Old City, guiding visitors from one mesmerizing work to another.
// 					</p>
// 					<h3>
// 					   International Arts and Crafts Fair (Khutsot Hayotser):
// 					</h3>
// 					<p>
// 					  August 15, 2016 – August 29, 2016. Held against the backdrop of the Old City walls, visitors enjoy a very special nighttime atmosphere and happening with musical performances. Walk through the gardens and stop at the various stands, where artists from Israel and the world exhibit paintings, prints, ceramics, metalwork and jewelry, weaving and textiles, Judaica, toys, crafts in various techniques, woodwork and more.
// 					</p>
// 					<h3>
// 					   The Israel Festival
// 					</h3>
// 					<p>
// 					   May 24, 2016 – June 11, 2016. The festival is Israel’s premiere multi-disciplinary international festival. It takes place annually in the spring, presenting outstanding theater performances, contemporary dance, classical music and performances from around the world, along with ground breaking Israeli works. Numerous festival events are held at unique Jerusalem locations that have historic significance of hundreds, if not thousands, of years. There are also many street performances that are open to the public.
// 					</p>
// 					<h3>
// 					  Jerusalem Film Festival
// 					</h3>
// 					<p>
// 					   July 7, 2016 – July 17, 2016. The festival sprinkles star dust across the city, with quality cinema, actors and writers that are guests. Many famous stars have come to the festival of the years. Over 200 Israeli and foreign films will be screened during the festival, highlighting various genres and competing for prizes. The festival offers opportunities for meetings with artists, workshops, parties and musical events.
// 					</p>
// 					<div class="img-wrapper">
// 						<img src=${getImgUrl() +  "/posts/4/5.jpg"} class="img-responsive" />
// 					</div>
//          `
//     }
//   }
// },
{id:20,bgImage:"/posts/bank/40/1.jpg",mobBgImage:"/posts/bank/40/M.jpg",player_id_post:"20",title:"Tel Aviv Abenteuer",ctg:"telaviv",vidId:"88OV6xU0vPI",isVid:true,smltitle:"",html:function html(){return{__html:"\n\n\t\t\t\t<h2>Actionreiche Stadt - perfekt f\xFCr aktive Menschen.</h2>\n               \n\t\t\t<p>\n\t\t\t\t\t\t\t\tMenschen in Tel Aviv leben das Leben in vollen Z\xFCgen - und sie tun es drau\xDFen. Diese Stadt ist randvoll mit Outdoor-Aktivit\xE4ten und Sie k\xF6nnen daher sehr w\xE4hlerisch sein. Es ist eine actionreiche Stadt - perfekt f\xFCr aktive Menschen\n          </p>\n          <h3>\n                Hayarkon Park\n          </h3>\n          <p>\n\t\t\t\t\t\t\t\tDer Hayarkon Park, der als \"Central Park\" von Tel Aviv bekannt ist, wird j\xE4hrlich von etwa sechzehn Millionen Menschen besucht. Die Attraktionen reichen von Picknicks auf den riesigen Rasenfl\xE4chen \xFCber Tretbootfahren auf dem wundersch\xF6nen k\xFCnstlichen See bis hin zu Radwegen und Touren durch die vielen wundersch\xF6nen G\xE4rten, die die Natur im Herzen der Stadt darstellen.\n          </p>\n          <h3>\n                Die Fahrradszene\n          </h3>\n          <p>\n\t\t\t\t\t\t\t\tEine der ultimativen M\xF6glichkeiten, Tel Aviv zu entdecken, ist durch seine 100 km langen Radwege, wo Sie das \xF6ffentliche Tel-O-Fun Fahrradverleihsystem nutzen k\xF6nnen, welches erm\xF6glicht, dass die Bewohner und auch Besucher die gr\xFCnen Fahrr\xE4der beliebig an den 150 Stationen der Stadt abholen und abstellen k\xF6nnen.  Wenn Sie es genie\xDFen, Ihre Zeit auf R\xE4dern zu verbringen, sollten Sie auch die vielen Eislaufparks besuchen, wo Sie den lokalen Draufg\xE4ngern bei der Sache zusehen k\xF6nnen, oder Sie k\xF6nnen sich Ihr eigenes Skateboard oder Rollerblades holen und an der Aktion teilnehmen.\n          </p>\n\n         "};}},{id:14,bgImage:"/posts/videos/deadsea/1/1.jpg",mobBgImage:"/posts/videos/deadsea/1/M.jpg",title:"DAS TOTE MEER",vidId:"ixFocykfYHo",ctg:"deadsea",isVid:true,smlTitle:"",html:function html(){return{__html:"\n\t\t\t                            <h2>H\xF6chster Genuss am  tiefstgelegenen Ort der Erde</h2>\n\n\t\t\t                            <p>\n\t\t\t\t\t                         Ein geologisches Wunder in einer einzigartig ruhigen Umgebung \u2013 das Tote Meer ist eine sehr beliebte Touristenattraktion. Erleben Sie die Ruhe des Wassers mit seinen einzigartigen heilenden Eigenschaften und genie\xDFen Sie die unvergleichliche Sch\xF6nheit der umliegenden Landschaft. <strong>Das Tote Meer, auch bekannt als das \xE4lteste nat\xFCrliche Heilbad der Welt, ist mit einer extrem hohen Salzkonzentration von 31,5% gesegnet, was Touristen von nah und fern das erstaunliche Erlebnis erm\xF6glicht, m\xFChelos auf den Gew\xE4ssern des niedrigsten Ortes der Erde zu schweben. W\xE4hrend Sie hier sind, k\xF6nnen Sie auch im gesunden schwarzen Schlamm der Gegend baden</strong> oder die faszinierende und historisch reiche Landschaft in der Umgebung erkunden.\n\t\t\t\t\t                  </p>\n\n\t\t\t\t\t                  <p>\n\t\t\t\t\t                          Luxuri\xF6se Hotels, eine abwechslungsreiche K\xFCche von Gourmet-Restaurants bis hin zu Fastfood-Restaurants, gro\xDFartige Souvenirl\xE4den, die au\xDFergew\xF6hnliche Geschichte der nahegelegenen Festung Masada und viele kulturelle Aktivit\xE4ten w\xE4hrend des ganzen Jahres machen das Tote Meer zu einem beliebten Ziel f\xFCr Touristen und internationale Besucher.\n\t\t\t\t\t                  </p>\n\t\t\t"};}},{id:3,bgImage:"/posts/bank/23/1.jpg",mobBgImage:"/posts/bank/23/M.jpg",vidId:"iHqD5eHDZm8",player_id_post:"3",title:"DIE HÄFEN VON TEL AVIV",isVid:true,ctg:"telaviv",smltitle:"",html:function html(){return{__html:"\n\t\t\t\t<p>Hafen Tel Aviv oder der Hafen von Jaffa. Zwei faszinierende Hafenviertel mit jeweils eigenem Charakter und Charme.</p>\n\t\t\t\t\t<p>\n          Zwei faszinierende Hafenviertel mit jeweils eigenem Charakter und Charme.\n          </p>\n\n          <h3>\n            Zwei faszinierende Hafenviertel mit jeweils eigenem Charakter und Charme.\n          </h3>\n          <p>\n            Die bescheidenen Wurzeln der modernen Stadt Tel Aviv liegen im Hafen von Jaffa, in dem Immigranten, Armeen und H\xE4ndler von ihren Schiffen an Land kamen. Der Hafen geh\xF6rt zu den \xE4ltesten seiner Art weltweit und wird immer noch von den lokalen Fischern genutzt, w\xE4hrend sich sein historisches Umfeld zu einem beliebten Tourismusziel entwickelt hat.\n          </p>\n          <div class=\"img-wrapper\">\n            <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/3/1.jpg")+" class=\"img-responsive\" />\n          </div>\n\n          <p>\n          In die Lagerhallen am Kai sind Galerien und Kulturzentren eingezogen, z. B. das von Geh\xF6r- und Sehbehinderten betriebene Nalaga\u2018at Zentrum und die Galerie Dvir. Zu den Kaianlagen winden sich gepflasterte Stra\xDFen und Gassen zwischen den gemauerten Geb\xE4uden, die das alte Jerusalem lebendig werden lassen. Zwischen den historischen Geb\xE4uden finden sich zahlreiche Galerien, Spezialit\xE4tengesch\xE4fte und hervorragende Restaurants. In den h\xF6her gelegenen Teilen des alten Hafenbezirks erwarten Sie die Kirche des Sankt Peter, die Wunschbr\xFCcke, das Old-Jaffa-Museum und das Ilana-Goor-Museum.\n          </p>\n          <div class=\"img-wrapper\">\n            <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/3/2.jpg")+" class=\"img-responsive\" />\n            <div class=\"cradit\">\n\t\t\t\t\t\t\t\t<small>Dana Friedlander</small>\n\t\t\t\t\t    </div>\n          </div>\n          <h3>\n            Hafen Tel Aviv\n          </h3>\n          <p>\n            Im Gegensatz zum Hafen von Jaffa herrscht im Hafen Tel Aviv ein modernes Gesch\xE4ftsklima. Der Hafen war von 1938 bis 1965 in Betrieb und wurde im Rahmen der darauf folgenden Sanierung in ein Einkaufs- und Freizeitviertel umgewandelt. Direkt am Wasser stehen umgebaute Lagerh\xE4user an einer gro\xDFz\xFCgigen K\xFCstenpromenade. Sehr beliebt bei Familien ist ein Besuch im Dyada-Center f\xFCr Kinder. Andere suchen die Zentren f\xFCr Yoga, Frauen, Konferenzen oder das Cavim Institut f\xFCr Design und Architektur. Auf der Promenade herrscht immer lebhaftes Treiben mit Stra\xDFenk\xFCnstlern, Musikern und Marktst\xE4nden. Der Hafen ist ein modernes und dynamisches Viertel f\xFCr kreative und kulturelle Aktivit\xE4ten. Nach Sonnenuntergang wird der Hafen Tel Aviv mit seinen Bars und Clubs zu einem beliebten Ziel f\xFCr Nachtschw\xE4rmer.\n          </p>\n          <div class=\"img-wrapper\">\n            <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/3/3.jpg")+" class=\"img-responsive\" />\n            <div class=\"cradit\">\n                <small>Dana Friedlander</small>\n              </div>\n          </div>\n\n\n         "};}},{id:4,bgImage:"posts/bank/17/1.jpg",mobBgImage:"posts/bank/17/M.jpg",title:"TEL AVIV AM STRAND",vidId:"XDei1Zy_cu4",isVid:true,ctg:"telaviv",smlTitle:"",html:function html(){return{__html:"\n\t\t\t\n\t\t\t        <h3>\n\t\t\t\t\t\tTel Aviv Str\xE4nde\n\n\t\t\t\t\t\tNational Geographic Magazine \"Eine der 10 besten Strandst\xE4dte der Welt\"\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>Weil sich das Leben in Tel Aviv von der Sonnenseite zeigt  Bereit f\xFCr eine volle Ladung Spa\xDF in der Sonne?</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tMit klarem Wasser und actionreichen Str\xE4nden hat jeder der 16 Str\xE4nde von Tel Aviv seinen eigenen Stil und zieht bestimmte Pers\xF6nlichkeiten an - von Hippie-Casual bis Riviera Chic. Ob Tag oder Nacht, am Strand zu h\xE4ngen ist eine der besten M\xF6glichkeiten, Zeit in Tel Aviv zu verbringen.\n\t\t\t\t\t</p>\n\n\t\t\t"};}},{id:7,bgImage:"posts/bank/36/1.jpg",mobBgImage:"posts/bank/36/M.jpg",title:"Sarona Tel Aviv",isVid:true,ctg:"telaviv",// vidId: "AcjsyamDZL8",
vidId:"MJ-gsGs1tqA",smlTitle:"",html:function html(){return{__html:"\n\t\t\t<p>\n\t\t\t\tEine atemberaubende urbane Oase Eine riesige Auswahl von Attraktionen in der \xFCberw\xE4ltigenden sanierten Templerkolonie\n\t\t\t</p>\n\t\t\t"};}},{id:8,bgImage:"posts/bank/4/1.jpg",mobBgImage:"posts/bank/4/M.jpg",title:"Neve Tzedek",// vidId: "bHQwLO6cefs",
vidId:"5jl13Z-38eE",smlTitle:"",isVid:true,ctg:"telaviv",html:function html(){return{__html:"\n\n                      \t<h2>Schick und einzigartig. Liebenswerte Caf\xE9s, Boutiquen, Kunstgalerien, Eleganz und coole Vibes</h2>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tMachen Sie eine Pause von der Hektik von Tel Aviv; dieses versteckte Juwel eines Viertels besticht durch seinen wundersch\xF6nen orientalischen Architekturstil und die charmanten engen Gassen, die Neve Tzedek zu einer wahren Oase im Herzen der gesch\xE4ftigen Stadt machen.\n\t\t\t\t\t</p>\n              \n\t\t\t"};}},{id:9,bgImage:"posts/bank/5/1.jpg",mobBgImage:"posts/bank/5/M.jpg",title:"Modern und lebendig",isVid:true,ctg:"jerusalem",// vidId: "MXtcTm_JXus",
vidId:"V0Acsw3Hf_M",smlTitle:"",html:function html(){return{__html:"\n            <h2>Es gibt so viel zu sehen in Jerusalems pulsierendem Stadtzentrum</h2>\n\t\t\t<p>\n\t\t\t\t\t\t\tDie Innenstadt von Jerusalem ist das Herz der modernen Metropole, voller Nachtleben, Restaurants und kulturellen M\xF6glichkeiten, die es mit jeder gr\xF6\xDFeren Stadt der Welt aufnehmen k\xF6nnen.\n          </p>\n          <p>\n\t\t\t\t\t\t\tDie Gegend besteht aus mehreren Stadtvierteln und den angesagtesten Orten, wie dem charmanten Nachlat Shiva, der belebte Yafo Stra\xDFe und der Ben Yehuda Stra\xDFe mit ihrer einzigartigen Pers\xF6nlichkeit und Atmosph\xE4re, die man nicht verpassen sollte.\n          </p>\n          <p>\n\t\t\t\t\t\t\tDas Zentrum von Jerusalem umfasst einige der charmantesten Viertel der Stadt und faszinierende Sehensw\xFCrdigkeiten. F\xFCr eine unschlagbare kulturelle Erfahrung, sehen Sie sich Jerusalems faszinierende Museen an, darunter das weltber\xFChmte Israel Museum, das Bible-Land-Museum und  Wissenschafts Museum.\n          </p>\n          <h3>\n\t\t\t\t\t\t\tMachane Yehuda Market\n          </h3>\n          <p>\n\t\t\t\t\t\t\tEntdecken Sie die unvergleichliche Atmosph\xE4re und Vielfalt dieses Marktes, die jeden Tag Tausende von Touristen anzieht. Sobald die Eink\xE4ufe erledigt sind und die Verk\xE4ufer die L\xE4den zumachen, treffen sich den jungen trendigen Menschen, sowohl aus dem Ausland als auch aus der Region, die auf den Markt kommen, um bis in die fr\xFChen Morgenstunden in den Bars, Restaurants und Gassen zu trinken und zu feiern.\n          </p>\n          <h3>\n\t\t\t\t\t\t\tNahalat Shiv\u2019a\n          </h3>\n          <p>\n\t\t\t\t\t\t\tDieses charmante gepflasterte Viertel im Herzen der Stadt bietet eine exzellente Auswahl an Gesch\xE4ften, Restaurants, Bars und Stra\xDFencaf\xE9s an. Nahalat Shiva ist die Heimat von Kikar Hamusica (Musikplatz)- ein lebhafter und trendiger Platz im Freien, wo jeden Tag w\xE4hrend der Woche Live-Musik spielt.\n          </p>\n          <h3>\n\t\t\t\t\t\t\tYemin Moshe\n          </h3>\n          <p>\n\t\t\t\t\t\t\tDieses sch\xF6ne Viertel mit Blick auf die alten Stadtmauern wurde urspr\xFCnglich im 19. Jahrhundert erbaut, um dem Problem der \xDCberf\xFCllung entgegenzuwirken. Yemin Moshe, Heimat von K\xFCnstlern, Schriftstellern und Akademikern, ist bekannt f\xFCr seine sch\xF6nen Windm\xFChlen und H\xE4user im orientalischen Stil, gr\xFCne Parks, lebhaftes Musikzentrum und atemberaubende Ausblicke.\n          </p>\n          <h3>\n\t\t\t\t\t\t\tEin Kerem\n          </h3>\n          <p>\n\t\t\t\t\t\t\tIn einem friedlichen Tal zwischen den Bergen und den terrassierten H\xFCgeln s\xFCdwestlich von Jerusalem gelegen, ist Ein Kerem eines der malerischsten Viertel von Jerusalem. Mit ihren verwinkelten, gepflasterten Gassen, ihren charmanten Steinh\xE4usern, die mit B\xF6gen geschm\xFCckt sind, Kirchen, deren Glocken in der klaren Luft l\xE4uten, strahlt Ein Kerem Charme und Sch\xF6nheit aus, wie eine Insel in einem Meer aus gr\xFCnem Wald.\n          </p>  \n\n\t\t\t"};}},{id:12,bgImage:"posts/bank/10/1.jpg",mobBgImage:"posts/bank/10/M.jpg",title:"Der Markt In Jerusalem",vidId:"2CSCe2WC7Ns",isVid:true,ctg:"culinary",smlTitle:"",html:function html(){return{__html:"\n                    <h2>Donnerstag Nacht auf dem Mahane Yehuda Markt</h2>\n\t\t\t\t\t<p>\n                          Scharen von Einheimischen und Touristen zieht es tags\xFCber hierher, um Zeuge der authentischen Atmosph\xE4re des Marktes zu werden, ihn von innen kennenzulernen und nat\xFCrlich auch um einzukaufen. Und sobald die Verk\xE4ufer ihre St\xE4nde schlie\xDFen, kommen die Nachtschw\xE4rmer zum Markt \u2013 ausl\xE4ndische und einheimische gleicherma\xDFen \u2013um in den Bars, Restaurants und Gassen Spa\xDF zu haben.\n                          <br/>\n                          Der Shuk ist unter Woche praktisch immer ge\xF6ffnet, aber wenn Sie eine wirklich elektrisierende Nacht erleben m\xF6chten, dann ist Donnerstagabend das Richtige f\xFCr Sie. F\xFCr die Einheimischen ist dies die einzige Nacht an der man richtig ausgehen kann ohne sich Gedanken machen zu m\xFCssen am n\xE4chsten Morgen aufzustehen und zur Arbeit zu gehen. Und das zeigt sich darin, dass die Bars und Restaurants bis sp\xE4t in die Nacht ge\xF6ffnet sind, Partys veranstalten, die sich bis auf die Stra\xDFe erstrecken und besondere Events organisieren.\n\n\n                          <br/>\n                          Mein \u201EDate\u201C und ich kamen um 19:20 Uhr an, als viele der St\xE4nde noch offen waren und die Gassen mit Kunden, die f\xFCr das Wochenende noch nach guten Angeboten suchten, \xFCberf\xFCllt waren. Doch als die Verk\xE4ufer dichtmachten, verschwanden die Kunden schnell und machten Platz f\xFCr das Partyvolk.\n                          <br/>\n                          Obwohl es scheint als w\xE4re es erst gestern gewesen, dass der Shuk noch ein Ort war, an dem man einkaufen ging und sich vielleicht noch einen Bissen von einem der lokalenImbisse geholt hat, ist die Anzahl an hippen Bars und Restaurants in den letzten f\xFCnf Jahren explodiert. Mittlerweile kann man kaum noch mit den st\xE4ndig neuen geheimen Hot-Spots, die in irgendeiner, nur den Einheimischen bekannten, Ecke versteckt sind, mithalten.\n                           <br/>\n                          \u201EWenn Sie an einem Donnerstagabend die Massen von Partyw\xFCtigen sehen, kann man leicht vergessen, dass noch vor ein paar Jahren nachts keine Menschenseele zu finden war,\u201C sagt der \xF6rtliche Touristenf\xFChrer Joel Haber. \u201EAber die Wahrheit ist, dass dies nicht nur der n\xE4chste logische Schritt ist, f\xFCr die sich st\xE4ndig entwickelnde Geschichte des Mahane Yehuda Markt ist, sondern auch der dynamischste und neueste Beitrag zum Nachtleben der Stadt. Der Shuk war immer ein Schmelztiegel, in dem sich alle Jerusalemer getroffen haben. Nun finden sich junge und alte, s\xE4kulare und religi\xF6se Menschen zusammen um nebeneinander ein Bier zu trinken und die spezielle Atmosph\xE4re zu genie\xDFen.\u201D\n                           <br/>\n                           Hier finden Sie einige der Lokale die mehr oder weniger Star-Status erreicht haben und immer eine gute Zeit versprechen.\n                      </p>\n                      <h3>\n                         Gediegen essen und tanzen\n                      </h3>\n\n                      <div class=\"img-wrapper\">\n                           <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/7/1.jpg")+" class=\"img-responsive\" />\n                      </div>\n\n                        <h3>\n                            Das CASINO DE PARIS\n                        </h3>\n\n                        <p>\n                            Versteckt in den Tiefen des georgischen Shuks zwischen den bedeckten und unbedeckten Marktstra\xDFen, liegt das Casino de Paris, das eine bunte Geschichte aufweisen kann. Das Geb\xE4ude, in dem es liegt, hat einst als Kasino, Hotel, britischer Offiziersclub und Bordell gedient, doch jetzt ist es einfach einer der nobleren Locations im Shuk. Hier finden sich haupts\xE4chlich berufst\xE4tige Leute um die 30 bis 40, aber an Donnerstagabenden ist die Stimmung hier dennoch ausgelassen und jung. Die Bar bleibt bis 2 oder 3 Uhr fr\xFCh ge\xF6ffnet und serviert gut zubereitete, originelle Haus-Cocktails inspiriert vom Shuk, Bier und ein paar anst\xE4ndige Weine.\n                        </p>\n\n                        <h3>\n                            Das CINCO DE MAYO\n                        </h3>\n                        <p>\n                            Wenn Sie nach einer anst\xE4ndigen Party-Atmosph\xE4re suchen, dann ist das Cinco De Mayo ganz sicher eine gute Adresse. Es bietet regelm\xE4\xDFig eine B\xFChne f\xFCr DJs, die eine Bandbreite von verschiedenen Musikstilen spielen und Sie werden hier immer G\xE4ste finden die bis um 2.00 Uhr fr\xFCh trinken, essen und vielleicht sogar tanzen. Die Nachtschw\xE4rmer beginnen ab 22.30 Uhr das Lokal zu f\xFCllen, seien Sie also nicht \xFCberrascht, wenn Sie Schwierigkeiten haben einen Sitzplatz zu finden. Aber man kann es immer wie die Einheimischen machen und ein Getr\xE4nk (von der Innenbar) drau\xDFen in den Gassen genie\xDFen.\n                            <br/>\n                            Trotz des Namens, hat Cinco de Mayo eigentlich nichts mit Mexiko oder dem 5. Mai zu tun. Die Gruppe von Freunden, die die Bar ins Leben gerufen haben, w\xE4hlten den Namen als Erinnerung an ihre Zeit in einer Kommune au\xDFerhalb von Jerusalem, wo niemand am 5. Mai arbeitete.\n                        </p>\n\n                        <h3>\n                            Die SHUKA BAR\n                        </h3>\n                        <p>\n                            Trotz ihrer Lage abseits der Hauptstra\xDFe und relativ kleinem Format, ist die Shuka Bar an der Egozstra\xDFe einer der beliebtesten Orte auf dem Shuk. Es ist eine eher bodenst\xE4ndige Bar, die nur israelische Biere, Spirituosen und kleine Snacks anbietet, doch am Donnerstagabend verwandelt sich die Shuk Bar von einer einfachen Bar zu einer Riesenparty.\n                        </p>\n\n                       <div class=\"img-wrapper\">\n                           <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/7/2.jpg")+" class=\"img-responsive\" />\n                       </div>\n\n\n\n                        <h3>\n                           Das QUE PASA\n                        </h3>\n                        <p>\n                            Gleich nebenan liegt das Que Pasa. Dieses Lokal ist der ehrenhafte Versuch von Besitzer Yaniv Kovenshtein die vielgeliebte Tapas-Kultur Spaniens nach Jerusalem zu bringen. <br/>\n\n                            Mitinhaber und K\xFCchenchef Avi Betito Golansky bringt diese Vision mit einem Men\xFC voller Tapasgerichte aus Fisch und Milchprodukten, inklusive des Bruschetta Cuca (Sardinen, Zwiebeln, Paprika Oliven\xF6l auf k\xF6stlich knusprigem Brot) und Porcini Bruschetta (in Butter sautierte Steinpilze mit Knoblauch, Mandel\xF6l und Petersilie), feine Artischockenscheiben mit Tr\xFCffeln, filetierte Sardinen mit Saint Moore K\xE4se gef\xFCllt und in Salbeibutter gebraten auf einem \xFCppigen Tomatensalat serviert, Meer\xE4schenringe mit ger\xF6steten Paprika gebraten, und vieles mehr. Wenn Sie richtigen Hunger haben, gibt es hier auch gro\xDFe Portionen, wie z. B. Gnocci, Seebarschfilet oder Rotbarbe. <br/>\n\n                            Auch wenn das Motto der Bar \u201Eein Bier am Nachmittag vertreibt alle Sorgen\u201C ist, lohnt sich ein Besuch im Que Pasa am Donnerstagabend, wenn hier regelm\xE4\xDFig lokale K\xFCnstler auftreten.<br/>\n                        </p>\n                        <h3>\n                            das SHEM TOV\n                        </h3>\n\n                        <p>\n                            Auf der Eshkolstra\xDFe, einer Nebenstra\xDFe des offenen Shuks,, f\xE4ngt das Shem Tov wahrlich die Atmosph\xE4re des Shuks ein, mit einem reichen orientalischen Men\xFC und einer ausgedehnten Auswahl an israelischem Bier, Wein, Spirituosen und Musik aus der ganzen Welt l\xE4dt es ein bis in die fr\xFChen Morgenstunden zu verweilen. <br/>\n\n                            Es ist auch ein erstklassiger Ort, um ein Glas kaltes Sahleb zu trinken, ein Getr\xE4nk hergestellt aus dem Mehl von Knollen der Orchideen mit Rosenwasser, Milch und Zimt vermischt, das im Shuk in der Regel hei\xDF serviert wird.. Mhmm. K\xF6stlich!\n                        </p>\n                        <h3>\n                            N\xC4CHTLICHE K\xD6STLICHKEITEN\n                        </h3>\n                        <p>\n                            Wenn Sie den ganzen Abend getrunken haben, sind Sie wahrscheinlich gegen Mitternacht in der Stimmung f\xFCr ein paar Knabbereien. Gl\xFCcklicherweise gibt es noch viele Restaurants, die bei Ihren verschiedenen  Gel\xFCsten helfen k\xF6nnen:\n                        </p>\n\n                        <div class=\"img-wrapper\">\n                          <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/7/3.jpg")+" class=\"img-responsive\" />\n                        </div>\n\n                        <h3>\n                          Das SORAMELO\n                        </h3>\n                        <p>\n                          Wenn Sie nach einer intensiven Nacht Lust auf etwas S\xFC\xDFes bekommen haben, holen Sie sich doch bei Soramelo am Aggripas Eingang zum Shuk ein paar Shuk-inspirierte Waffeln.  <br/>\n\n                          Das Soramelo ist nach einer Nachbarschaftslegende benannt, die daf\xFCr bekannt war immer eine Geschichte \xFCber alles auf Lager zu haben und hat mittlerweile ohne Zweifel auch selbst die eine oder andere Geschichte hervorgebracht.<br/>\n\n                         Das Soramelo ist die ganze Nacht hindurch mit Menschen gef\xFCllt, die f\xFCr ein Bier, einen Kaffee und auf einen s\xFC\xDFen Happen vorbeikommen. Aber wirklich voll wird es, wenn die Leute sp\xE4t in der Nacht zum Naschen kommen. Wenn Sie einer dieser Leute sind, haben Sie bis um 3 Uhr morgens Zeit, um das getrunkene Bier und den Arak zu neutralisieren. Probieren Sie eine Waffel mit Schokolade und Tahina \u2013 Sie werden nicht entt\xE4uscht sein!<br/>\n                        </p>\n\n                        <h3>\n                          Das MICHI\u2019S\n                        </h3>\n\n                        <p>\n                          Michi\u2019s is a simple, yet delicious concept that makes for the perfect late-night eatery \u2014 high-quality hamburgers and meat sandwiches at a shockingly good price. You can get a simple 100-gram burger on a fresh bun with some serious fixings for just 17 NIS. If you\u2019re really hungry, you can also get larger portions of meat, roast beef and chicken sandwiches and much more. Michi\u2019s is open until 12 am.\n                        </p>\n\n                        <h3>\n                          MEORAV YERUSHALMI\n                        </h3>\n\n                        <p>\n                         Dies ist der wahrscheinlich beste Ort f\xFCr den ber\xFChmten Jerusalem Grillteller, der aus verschiedenen Fleischsorten und Innereien besteht und im Fladenbrot mit Fritten und Salat als Beilage serviert wird. Neben dem traditionellen Rezept bietet das Lokal auch eine gemischte Grillplatte mit Fisch. Die Portionen sind wirklich beeindruckend und perfekt f\xFCr all die, die einen gro\xDFen Appetit haben. Stellen Sie nur sicher, dass Sie hier vor Mitternacht erscheinen.\n                        </p>\n\n                        <h3>\n                         das PASTA BASTA\n                        </h3>\n                        <p>\n                         Pasta Basta ist mit Abstand eines der beliebtesten Restaurants im Shuk und serviert k\xF6stliche, frische hausgemachte Pasta Gerichte die nebenbei auch Ihren Geldbeutel schonen. Alles was Sie tun m\xFCssen, ist eine Art von Pasta und Sauce w\xE4hlen und schon ist Ihr Essen fertig. Die Preise h\xE4ngen von der Sauce ab und variieren zwischen 19 und 26 NIS. Gnocchi, Ravioli und zus\xE4tzliche Beilagen kosten extra.\n                         <br/>\n                         Pasta Basta ist bis Mitternacht ge\xF6ffnet, und seien Sie nicht \xFCberrascht, wenn Sie eine Schlange vor der T\xFCr stehen sehen.\n                        </p>\n\n              \n\t\t\t"};}},{id:13,bgImage:"posts/bank/24/1.jpg",mobBgImage:"posts/bank/24/M.jpg",title:"Die Altstadt",isVid:true,ctg:"jerusalem",vidId:"k4OwoEk5wMw",smlTitle:"",html:function html(){return{__html:"\n\n\t\t\t<h2>Feel the story come alive</h2>\n\t\t\t<p>\n\t\t\t   Become inspired by the world renowned treasures of the ancient city of Jerusalem.\n\t\t\t</p>\n              \n\t\t\t"};}},{id:14,bgImage:"posts/bank/32/1.jpg",mobBgImage:"posts/bank/32/M.jpg",title:"DAS TOTE MEER",vidId:"DzEJxjnC_UQ",isVid:true,ctg:"deadsea",smlTitle:"",html:function html(){return{__html:"\n\t\t\t<p>\n\t\t\t   Zeit f\xFCr eine Auszeit in der glorreichen Natur H\xF6chster Genuss am tiefstgelegenen Ort der Erde\n\t\t\t</p>\n              \n\t\t\t"};}},{id:3,bgImage:"/posts/bank/deadsea1/1.jpg",mobBgImage:"/posts/bank/deadsea1/M.jpg",title:"DAS TOTE MEER",vidId:"DzEJxjnC_UQ",isVid:true,ctg:"deadsea",smlTitle:"",html:function html(){return{__html:"\n\n\t\t\t<h2>H\xF6chster Genuss am tiefstgelegenen Ort der Erde</h2>\n              <p>\n\t\t\t\t\t\tThe Dead Sea is one of the most unique natural phenomena on the planet. A crevice in the earth\u2019s crust that is part of the Great Rift Valley allows the waters of the River Jordan to flow south into a lozenge-shaped lake at the lowest point on our planet. With no outlet, the rays of the blazing sun evaporates the Jordan water to a point where its mineral content is highly concentrated; and it is this density of minerals and salt that makes it impossible to sink in the sea: bathers float effortlessly on the water\u2019s surface. Because the sun has to travel an additional 1,200 feet to reach the shore, ultra-violet rays are filtered out and oxygen is enriched to a point where even the fairest skins tan but do not burn.\n              </p>\n              <p>\n              \t\tThis is why a visit to the Dead Sea enables sufferers of rheumatic diseases to breathe better, and why victims of psoriasis and other serious skin ailments receive temporary cures by bathing in the Dead Sea, slathering themselves with Dead Sea mud and baking in the non-burning sun.\n              </p>\n              <p>\n              \t\tThe Dead Sea is lined with spas, bathing beaches and spa hotels.\n              </p>\n\t\t\t"};}},//No translation
{id:35,bgImage:"/posts/bank/47/1.jpg",mobBgImage:"/posts/bank/47/M/1.jpg",title:"Go To Guide",ctg:"telavivAndJerusalem",isVid:false,smltitle:"",html:function html(){return{__html:"\n                      <h2>Travel from Tel Aviv and Jerusalem</h2>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tOne of the best things in visiting Tel Aviv and Jerusalem is how incredibly different yet amazingly close are these two fabulous destinations. In fact, the two cities are less than one hour\u2019s drive(!) from one another, which means that should you wish, you could spend the day exploring the awesome and world-famous sites of Jerusalem and be back in time to watch the sunset from one of Tel Aviv stunning beaches before heading on to an all-night rager in one of the city\u2019s hottest clubs. Talk about a full day\u2019s fun\u2026\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/36/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tGetting to and from Tel Aviv and Jerusalem is easy and there are several ways depending on your preference and budget:\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\t<strong>By Car:</strong> \n\t\t\t\t\t\tShould you choose to hire a car you will find route 1 connects the two cities directly, and road signs to be pretty clear and come in three languages. However, you may want to use one of the local navigation apps to show you the way and help you avoid heavy traffic. \n\t\t\t\t\t</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/36/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<p>\n\t\t\t\t\t\t<strong>By Bus:</strong> \n\t\t\t\t\t\tthere are several public buses which travel to and from Tel Aviv and Jerusalem. This is by far one of the most convenient and budget-friendly means of travel. \n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\t<strong>By Train:</strong> \n\t\t\t\t\t\tA convenient train service operates in several main stations to and from Tel Aviv and Jerusalem. Works are currently underway and soon a fast new direct route will begin operating between the two cities. \n\t\t\t            \t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\t<strong>By Taxi:</strong> \n\t\t\t\t\t\tTaxis for interurban travel can be flagged on the street or booked via phone or designated apps such as Gett (GetTaxi).\n\t\t\t            \t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\t<strong>Sherut Taxis:</strong> \n\t\t\t\t\t\t\u201CSherut\u201D (service) taxis are 10 - 12 seater vans which generally follow major bus routes, in and between major cities. Pricewise, sherut taxi fares have a fixed price, similar to public bus fares. Sherut taxis also offer a replacement to service to buses on Fridays.  \n\t\t\t            \t</p>\n\t\t\t            \t<p>\n\t\t\t            \t\tFor information regarding train stations, routes and schedules, visit <a href=\"https://www.rail.co.il\" target=\"_blank\">www.rail.co.il</a>\n\t\t\t            \t</p>\n\t\t\t            \t<p>\n\t\t\t            \t\tFor information regarding bus routes and schedules visit  <a href=\"https://www.bus.co.il\" target=\"_blank\">www.bus.co.il</a>\n\t\t\t            \t</p>\n\t\t\t            \t<p>\n\t\t\t            \t\tPublic transport helpline   <a href=\"tel:*8787\">*8787</a>\n\t\t\t            \t</p>\n\t\t\t            \t<p>\n\t\t\t            \t\tLocal public transport app - \u2018Moovit\u2019\n\t\t\t            \t</p>\n\t\t\t            \t<p>\n\t\t\t\t\t\t        So come check out Epic Tel Aviv and unforgettable Jerusalem, less than one hour away from each other!\n\t\t\t            \t</p>\n\n            \t"};}},{id:36,bgImage:"/posts/bank/48/1.jpg",mobBgImage:"/posts/bank/48/M/1.jpg",title:"Ein Tag in Tel Aviv",isVid:false,ctg:"telaviv",smltitle:"",html:function html(){return{__html:"\n                 <h2>Vom Hafen zum Hafen</h2>\n\t\t\t\t <p>Beginnen Sie Ihren Tag im Jaffa-Hang-Park mit einem herrlichen Panorama \xFCber den gr\xF6\xDFten Teil der israelischen K\xFCste und dem historischen Ausgangspunkt der Metropole vor etwa 4000 Jahren. G\xF6nnen Sie sich eine Tasse Kaffee im renovierten antiken Hafen und fahren Sie nach Norden, um einen sch\xF6nen Spaziergang entlang der Promenade zu machen und den fantastischen Strand zu genie\xDFen.</p>\n                    <div class=\"img-wrapper\">\n                      <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/37/2.jpg")+" class=\"img-responsive\" />\n                    </div>\n                    <p>\xDCberqueren Sie die Stra\xDFe zum \"Tachana Compound\", einem fabelhaft renovierten Einkaufszentrum im Freien, das in einem ehemaligen Bahnhof untergebracht ist, der in den 1890er Jahren als Tel Aviv und Jaffas Hauptbahnhof erbaut wurde. </p>\n                    <p>Begeben Sie sich in das malerische Viertel Neve Tzedek und spazieren Sie durch die malerischen Gassen. G\xF6nnen Sie sich etwas Sch\xF6nes in den lokalen L\xE4den, bis Sie die bunte Hektik des Hacarmel Marktes erreichen. Halten Sie f\xFCr ein ausgezeichnetes Stra\xDFenessen an, und wenn es zuf\xE4lligerweise ein Dienstag oder Freitag ist - dann sch\xE4tzen Sie sich gl\xFCcklich und shoppen Sie auf der traditionellen Nachlat Binyamin Meile, wo lokale Handwerker ihre Arbeit pr\xE4sentieren. </p>\n                    <p>Weiter geht es zum wundersch\xF6nen Rothschild Boulevard, dem Herzst\xFCck der Bauhaus-Architektur, und zum UNESCO-Weltkulturerbe. Hier k\xF6nnen Sie sich ein Fahrrad ausleihen und sich den Einheimischen anschlie\xDFen, bis zum Habima-Platz, der Heimat des Nationaltheaters und des israelischen Philharmonischen Orchesters. Flanieren Sie auf der trendigen, belebten Dizengoff Street,nehmen Sie ein H\xE4ppchen in einem der Caf\xE9s rund um den Platz und laufen oder radeln Sie entlang des Hen Boulevard bis zum Rabin Square. </p>\n                    <div class=\"img-wrapper\">\n                      <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/37/1.jpg")+" class=\"img-responsive\" />\n                    </div>\n                    <p>Besuchen Sie die Eben Gabiroll Street, ein angesagtes Zentrum dieser fabelhaften Stadt. Hier gibt es eine gro\xDFe Auswahl an preisgekr\xF6nten Restaurants und ausgezeichnete Pubs und Bars, in denen Sie eine Mahlzeit oder einen fr\xFChen Drink genie\xDFen und mit den Einheimischen zusammensitzen k\xF6nnen. </p>\n                    <p>Nehmen Sie die Linie Nummer 5, eine urbane Ikone f\xFCr sich selbst, und steigen Sie am Hafen von Tel Aviv aus. Genie\xDFen Sie den Sonnenuntergang und schauen Sie nach S\xFCden Richtung der Skyline von Jaffa, wo der Tag begann. Verbringen Sie Ihren Abend in der Umgebung und beobachten Sie gespannt, wiesich diese pl\xF6tzlich in das aufregendste Nachtleben der Stadt verwandelt, mit fabelhaften Bars und Clubs - wie gemacht f\xFCr lange legend\xE4re N\xE4chte. </p>\n\n\n            \t"};}},{id:15,bgImage:"/posts/bank/50/1.jpg",mobBgImage:"/posts/bank/50/M/1.jpg",title:"Jerusalem",ctg:"culinary",isVid:true,vidId:"2CSCe2WC7Ns",smlTitle:"",html:function html(){return{__html:"\n                    <h2>Kulinarische Highlights in Jerusalem </h2>\n\t\t\t\t <p>Jerusalem ist eine faszinierende und magische Stadt. Viele Menschen, die Jerusalem besuchen, schw\xE4rmen von der unglaublichen Atmosph\xE4re, den unvergesslichen Sehensw\xFCrdigkeiten, den atemberaubenden Aussichten und vielem mehr. Aber, um Jerusalem wirklich kennenzulernen, gibt es noch einige Dinge, die Sie einfach mit Ihrem Gaumen erfahren m\xFCssen. Hier sind nur einige Leckerbissen, die Sie wirklich probieren sollten, w\xE4hrend Ihres Aufenthals in Jerusalem:</p>\n                    <div class=\"img-wrapper\">\n                      <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/39/1.jpg")+" class=\"img-responsive\" />\n                    </div>\n                    <p>Malabi: Eine einzigartige Kombination aus Getr\xE4nk und Dessert, hergestellt aus einer Mischung aus Rosenwasser, Milch, Maisst\xE4rke und Zucker. Malabi ist ein sehr beliebtes Gericht aus Jerusalem, das in vielen \xF6stlichen Restaurants und Kiosken in der ganzen Stadt angeboten wird. Sie k\xF6nnen sicher sein, dass Sie etwas \xC4hnliches bestimmt noch nie probiert haben. </p>\n                    <p>Knafeh: Ein sehr interessantes und sensationell leckeres Gericht, wird ganz frisch zubereitet und zum Essen serviert. Knafeh ist im Grunde eine arabische S\xFC\xDFigkeit dieaus einer Art geschmolzenem Ziegenk\xE4se besteht, der mit feinen orangefarbenen Teigf\xE4den umh\xFCllt ist und schlie\xDFlich mit s\xFC\xDFem Rosenwassersirup \xFCbertr\xE4ufelt wird. </p>\n                    <p>Jerusalem Brezel: Wenn Sie die faszinierenden Sehensw\xFCrdigkeiten der Altstadt erkunden, m\xFCssen Sie nach einem der kleinen gr\xFCnen Karren schauen um eine authentische Jerusalem-Brezel zu kaufen. Dazu gibt es ein duftendes regionales Gew\xFCrz namens Zaatar, das perfekt zum k\xF6stlichen warmen Geb\xE4ck passt. </p> \n                    <p>Meorav Yerushalmi: Direkt \xFCbersetzt bedeutet es \u201EMixed Jerusalem\".Eine k\xF6stliche Mischung aus verschiedenen Fleischsorten in einer speziellen lokalen Gew\xFCrzmischung - einfach der Himmel auf Erden f\xFCr alle Fleischliebhaber.</p>\n                    <p> \u201CAshtanur\u201D: kurz in Hebr\xE4isch f\xFCr \"Feuer im Ofen\", Ashtanur ist ein authentisches Pitta-Brot, das Sie auf den M\xE4rkten w\xE4hrend der Mittagszeit finden k\xF6nnen. Wenn Sie besonders hungrig sind, versuchen Sie es mit einer Portion Shawarma oder Falafel.</p> \n                    <p>Sabich: Ein absolutes Original! Das Sabich ist ein wirklich einzigartiges lokales Gericht, das aus einem Pitta-Brot besteht, das mit gebratenen Auberginen, hart gekochten Eiern und Essiggurken gef\xFCllt ist und \xFCblicherweise mit Amba - einer w\xFCrzigen Sauce gekr\xF6nt wird. Sobald Sie es probieren, werden Sie f\xFCr immer s\xFCchtig sein. </p>\n\n\n            \t"};}},{id:86,bgImage:"/posts/bank/86/1.jpg",mobBgImage:"/posts/bank/86/M/1.jpg",title:"FEINSCHMECKERSZENE TEL AVIV",ctg:"culinary",isVid:true,vidId:"gGe4W8WaIiQ",smlTitle:"",html:function html(){return{__html:"\n                        <h2>Dem k\xF6stlichen Fr\xFChst\xFCck in Tel Aviv kann auch Jamie Oliver nicht widerstehen.</h2>\n\t\t\t\t\t\t<small style=\"color:#000; display:block;position: relative;top: 5px;\">\n\t\t\t\t\t\tCredit:  Israeli food channel\n\t\t\t\t\t\t</small>\n\n            \t"};}},{id:37,bgImage:"/posts/bank/49/1.jpg",mobBgImage:"/posts/bank/49/M/1.jpg",title:"Tel Aviv",isVid:false,ctg:"telaviv",smltitle:"",html:function html(){return{__html:"\n                     <h2>Die ultimative Luxus-Destination</h2>\n\t\t\t\t\t<p>Vergessen Sie die Karibik, Cannes oder die Malediven. Wenn Sie einen Luxusurlaub wollen, ist Tel Aviv der richtige Ort f\xFCr Sie! </p>\n\n                    <p>Als allererstes ist zu erw\xE4hnen, dass diese Stadt, die von der NY Times \"die Hauptstadt der Coolness\" genannt wird, nur knappe 4 flugstunden entfernt ist. Das bedeutet f\xFCr Sie, keine Sorgen auch nur eine Minute Ihres Traumurlaubs mit dem Jet Leg verschwenden zu m\xFCssen.</p>\n                    <p>Sobald Sie hier sind, ist Ihre erste gro\xDFe Freude das herrliche, ganzj\xE4hrig sonnige Wetter - genau richtig f\xFCr uneingeschr\xE4nktes Urlaubsvergn\xFCgen. </p>\n                    <p>Entspannen Sie sich in einem der erstklassigen Hotels. Tel Aviv bietet eine gro\xDFen Auswahl an luxuri\xF6sen Unterk\xFCnften - von Weltklasse-5-Sterne-Hotels mit Blick auf den Strand bis hin zu den zahlreichen atemberaubenden Boutique-Hotels an den interessantesten Orten in der ganzen Stadt. </p>\n                    <div class=\"img-wrapper\">\n                      <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/38/1.jpg")+" class=\"img-responsive\" />\n                    </div>\n                    <p> Was macht das Erlebnis perfekt? Nat\xFCrlich ein Besuch an Tel Avivs wundersch\xF6nem Strand ,  der Ihnen jeglichen Komfort f\xFCr einen fabelhaften Tag bietet. Das wunderbar blaue Mittelmeer empf\xE4ngt Sie mit angenehmen Temperaturen und sorgt doch gleichzeitig f\xFCr Erfrischung. </p>\n                    <p>F\xFChlen Sie sich hungrig? Eine gro\xDFe Auswahl an Gourmetgerichten wartet auf Sie, die von lokaler bis zur Fusion-K\xFCche reichen. Tel Aviv ist weltweit f\xFCr seine qualitativ hochwertige K\xFCche bekannt, die in preisgekr\xF6nten, exquisit gestalteten Chef-Restaurants angeboten wird. </p>\n                    <p>Zeit f\xFCr einen Einkaufsbummel - schnappen Sie sich Ihre Geldb\xF6rse und besuchen Sie die Designer-Boutiquen, die schicken Shops und Luxus-Einkaufszentren, in denen Sie alles finden werden, von Haute Couture bis zu den neuesten internationalen Trends. </p>\n                    <p>Um den Tag ausklingen zu lassen, g\xF6nnen Sie sich ein Craft-Bier oder genie\xDFen einen exzellenten  Cocktail in einem der grandiosen Nachtclubs oder einer glamour\xF6sen Bar in der Stadt und tanzen Sie die Nacht durch, bevor Sie sich in Ihr Hotel begeben, um bei einen wohlverdienten 5-Sterne-Schlaf neue Energie zu sch\xF6pfen. </p>\n\n                    <p>Luxus? Stil? Glanz? Wir haben alles! Warum Zeit verlieren? Buchen Sie noch heute Ihre Reise nach Tel Aviv! </p>\n\n\n            \t"};}},{id:38,bgImage:"/posts/bank/jerusalem3/1.jpg",mobBgImage:"/posts/bank/jerusalem3/M.jpg",title:"Jerusalem- Stadt der Überraschungen",ctg:"jerusalem",isVid:false,smltitle:"",html:function html(){return{__html:"\n\n\t\t\t\t<h2>Eine Stadt, die alle Erwartungen \xFCbertrifft</h2>\n\n\t\t\t\t<p>Jerusalem ist eine weltweit bekannte Stadt und eines der beliebtesten Urlaubsziele der Welt. Viele Menschen besuchen Jerusalem jedes Jahr wegen seiner historischen Bedeutung, heiligen St\xE4tten, seiner wundersch\xF6nen und einzigartigen Architektur und bemerkenswerten Atmosph\xE4re.</p>\n                  <p>Jerusalem ist aber auch eine Stadt der \xDCberraschungen, und es gibt diverse Themen, die die meisten Menschen nicht sofort mit dieser erstaunlichen Stadt \xFCberhaupt in Verbindung bringen w\xFCrden. Hier sind nur einige der Dinge, die Sie nicht unbedingt in Jerusalem erwarten w\xFCrden:</p>\n                  <div class=\"img-wrapper\">\n                    <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/40/1.jpg")+" class=\"img-responsive\" />\n                  </div>\n\n                   <h3>Sommerfeste</h3>\n                  <p>Jedes Jahr im Sommer wird das Zentrum von Jerusalem mit vielen Partys am Freitagmittag \xFCberflutet, gef\xFCllt mit Musik, Tanz und gro\xDFartigen Menschen aus der ganzen Welt. Ein mitrei\xDFender Party-Vibe f\xE4ngt mit einem lauten Knistern an, entflammt jeden Feierfreudigen und das Wochenende kann starten. </p>\n\n\n                   <h3>Der verr\xFCckte Markt</h3>\n                  <p>Eine unvergessliches Erlebnis findet jede Donnerstagnacht statt, wenn der gesch\xE4ftige Tagesmarkt von Machne Yehuda zu einer lebhaften Late-Night-Szene wird, vollgepackt mit fantastischen Bars, Pubs und Live-Musik die ganze Nacht lang. </p>\n\n\n                   <h3>Festivals</h3>\n                  <p>Jerusalem ist eine Stadt voller Festivals - vom ber\xFChmten Filmfestival bis zum Weinfestival, einem internationalen Puppenspielfestival und sogar einem Happening-Festival. Was auch immer Sie interessiert, Jerusalem bietet etwas das zu Ihrem Geschmack passt und irgendwo in der Stadt stattfindet. </p>\n\n                   <h3>Jerusalem Marathon</h3>\n                  <p>Ein fantastischer und \xE4u\xDFerst beliebter Marathon, der eine Vielzahl von Strecken bietet, von professionell bis familienfreundlich, die an faszinierenden historischen St\xE4tten vorbeiziehen, die 3.000 Jahre Geschichte Jerusalems beleuchten. Wir garantieren eine herausfordernde, spannende und unvergessliche Erfahrung f\xFCr alle L\xE4ufer und Zuschauer.</p>\n                   <h3>Museen und Ausstellungen</h3>\n                  <p>Die Vielf\xE4ltigkeit der Natur erstreckt sich ebenso auf die Museen und Kulturveranstaltungen in der ganzen Stadt. Vom weltber\xFChmten Israel Museum bis Yad Vashem, zum unvergesslichen Licht- und Soundspektakel in der Zitadelle, der Wanderung \xFCber die Stdatmauern mit fantastischem Blick und noch vielem mehr. Die Stadt ist einfach \xFCbers\xE4t mit gro\xDFartigen kulturellen Erfahrungen.</p>\n\n                   <h3>Der Bauernmarkt</h3>\n                  <p>Jeden Freitag finden Sie in der deutschen Kolonie, im Herzen der Stadt, den \xF6rtlichen Bauernmarkt . Er bietet eine eindrucksvolle Auswahl an erstklassigen Produkten, lokalen K\xF6stlichkeiten und reizvollen Schn\xE4ppchen.</p>\n\n                   <h3>Ein Aquarium der Weltklasse</h3>\n                  <p>Es ist eines der gr\xF6\xDFten Aquarien im Nahen Osten. Diese fabelhafte Attraktion f\xFCr Kinder und Erwachsene \xF6ffnete dieses Jahr zum ersten Mal seine T\xFCren f\xFCr die \xD6ffentlichkeit. Das Aquarium ist 7.000qm gro\xDF und beherbergt 40 Meeresarten in 33 Wasserbecken, von denen der gr\xF6\xDFte 1,6 Millionen Liter enth\xE4lt. </p>\n\n\n            \t"};}},{id:39,bgImage:"/posts/bank/52/1.jpg",mobBgImage:"/posts/bank/52/M/1.jpg",//   vidId: "88OV6xU0vPI",
vidId:"5nqL-oIC0GA",isVid:true,ctg:"telaviv",title:"Tel Aviv",smltitle:"",html:function html(){return{__html:"\n\n\t\t\t\t\t<h2>Mit dem Fahrrad in Tel Aviv</h2>\n\t\t\t\t\t<p> Als eine der angesagtesten St\xE4dte der Welt ist es keine \xDCberraschung, dass sich Tel Aviv in den letzten Jahren ebenfalls dem Trend angeschlossen hat, der die ber\xFChmtesten St\xE4dte der Welt erobert hat - den Fahrradtrend. </p>\n                    <p> In fast allen ber\xFChmten St\xE4dten der Welt hat sich ein Trend durchgesetzt: Der Fahrrad-Trend. Wen wundert es also, dass Tel Aviv \u2013 eine der angesagtesten Metropolen \u2013 sich diesem Trend angeschlossen hat. </p>\n                    <p> Die Erkundung der Stadt mit dem Fahrrad hat viele Vorteile - es ist umweltbewusst und reduziert den CO2-Fu\xDFabdruck erheblich, erspart Ihnen aber ebens kostbare Urlaubszeit, die ansonsten im Kampf gegen den Verkehr aufgebracht werden m\xFCsste. Und nat\xFCrlich ist Fahrradfahren gesund. Das Fahrrad ist ein unkompliziertes Fortbewegungsmittel und bietet Besuchern und Touristen eine tolle M\xF6glichkeit, die Stadt und ihre Umgebung im eigenen Tempo  zu erkunden. Ein ausgezeichneter Weg, die Sehensw\xFCrdigkeiten und Attraktionendie Ger\xE4usche und Ger\xFCche der Stadt aus n\xE4chster N\xE4he zu genie\xDFen. </p>\n                    <div class=\"img-wrapper\">\n                      <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/41/1.jpg")+" class=\"img-responsive\" />\n                    </div>\n                    <p> Hier sind nur einige der Dinge, die Tel Aviv zu einer fantastischen Stadt zum Radfahren machen: </p>\n                    <p> Die Fahrradwege: Die Stadt Tel Aviv unterst\xFCtzt das Radfahrern im Stra\xDFenverkehr sehr, und diese Unterst\xFCtzung kann sich sehen lassen, weil es in der ganzen Stadt \xFCber 100 km Fahrradwege gibt, die f\xFCr die Sicherheit und Bequemlichkeit der Radfahrer der Stadt angelegt wurden.</p>\n                    <p> Das fantastische Wetter: Tel Aviv genie\xDFt das ganze Jahr \xFCber fantastische Wetterbedingungen mit sehr wenig Regen, und deshalb bietet es ideale Bedingungen zum Radfahren, w\xE4hrend man die frische Luft vom Strand auf der sch\xF6nen Promenade genie\xDFen kann, oder die atemberaubenden Innenstra\xDFen mit ihrer fabelhaften Bauhaus-Architektur durchf\xE4hrt. </p> \n                    <p> Tel-O-Fun: Der Tel-O-Fun ist ein einfaches und kosteng\xFCnstiges \xF6ffentliches Leihsystem f\xFCr Fahrr\xE4der. Mit Tel-O-Fun k\xF6nnen Bewohner und Besucher mit einer Kreditkarte an 150 g\xFCnstigen Stationen in der ganzen Stadt ausgezeichnete Qualit\xE4tsfahrr\xE4der abholen und abgeben.</p>\n                    <p> Das Beste ist, dass in Tel Aviv alles nahe beieinanderliegt. Sie k\xF6nnen mit dem Fahrrad zum Strand fahren und entlang der herrlichen Promenade radeln. Nehmen Sie Ihr Rad und machen Sie ein fantastisches Picknick im Park Ha'Yarkon oder fahren Sie abends in die Stadt um die fabelhaften Clubs und Bars von Dizengoff zu sehen oder zum Hafen. </p>\n                    <p> Radfahren war noch nie einfacher, ges\xFCnder oder spa\xDFiger als hier in der wundersch\xF6nen Stadt Tel Aviv. </p>\n\n\n            \t"};}},{id:40,bgImage:"/posts/bank/53/1.jpg",mobBgImage:"/posts/bank/53/M/1.jpg",title:"Tel Aviv",smltitle:"",isVid:false,ctg:"telaviv",html:function html(){return{__html:"\n                    <h2>Tel Aviv ist cool, Tel Aviv ist anders</h2>\n\t\t\t\t\t<p>Tel Aviv ist weltber\xFChmt als eine Stadt, die niemals schl\xE4ft und bekannt f\xFCr ihr aufregendes Nachtleben, die fabelhaften Str\xE4nde, die gro\xDFartige Kultur, die Kunst und vieles mehr. Aber hier kommen einige Insider-Tipps, die den Sommer in Tel Aviv f\xFCr Sie noch aufregender machen.</p>\n                    <div class=\"img-wrapper\">\n                      <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/42/1.jpg")+" class=\"img-responsive\" />\n                    </div>\n                    <p>In Germany this \u201EFlat-drinking\u201C is forbitten by law because some younger people died of this drinking excess \u2013 it has a very bad Image \u2013 please think about if you want to mention it. And if you mention, so  not at first but at last.</p>\n                    <h3>Freitagnachmittag Trommelkreise</h3>\n                    <p>Begeben Sie sich am Freitagnachmittag zum ber\xFChmten Banana- Beach und g\xF6nnen Sie sich gleich doppelt Spa\xDF - genie\xDFen Sie die gro\xDFartige Trommel-Session am Strand und schauen Sie sich den wundersch\xF6nen Sonnenuntergang an - beides v\xF6llig kostenlos! </p>\n                    <h3>Rooftop - Spa\xDF</h3>\n                    <p>Vielleicht liegt es am Wetter, vielleicht ist es die sch\xF6ne Aussicht - eines ist sicher, die Tel Aviver lieben die Natur, vor allem mit einem Drink in der Hand. W\xE4hrend des Sommers, finden Sie die meisten Bars und Pubs hoch auf die D\xE4cher verlegt (buchst\xE4blich!) oder umgestaltet in Veranstaltungsorte im Freien. Oft tauchen diese Bars auf den D\xE4chern von Gesch\xE4fts- und B\xFCrogeb\xE4uden auf. Folgen Sie einfach den Kl\xE4ngen von Musik, Tanz und Lebensfreude, dann finden Sie einen dieser fantastischen Rooftop-Orte. </p>\n                    <h3>Outdoor- Fitness</h3>\n                    <p>Nichts ist wichtiger als Ihre Gesundheit.Warum also nicht zu jeder Tages- und Nachtzeit, wann immer sie wollen, einige Trainingseinheiten absolvieren? Tel Aviv bietet einige gro\xDFartige M\xF6glichkeiten, um genau das zu tun -  Sie k\xF6nnen im Meer schwimmen, entlang der Promenade laufen und durch die fabelhaften Stra\xDFen der Stadt radeln.  Sie k\xF6nnen sogar in einem der vielen Outdoor-Fitnessstudios der Stadt trainieren, die kostenlos zu Verf\xFCgung stehen. </p>\n                    <h3>Unglaubliche Veranstaltungen in Sommer</h3>\n                    <p>Von weltber\xFChmten internationalen K\xFCnstlern \xFCber fantastische Electronic-, Kunst- und Bierfestivals bis zu Galerien, Ausstellungen, Live-Stra\xDFenmusik, Open Air Kinos und Strandpartys, die die ganze Nacht dauern, ist Tel Aviv im Sommer eine endlose Quelle an Spa\xDF und Unterhaltung, die Sie nicht verpassen d\xFCrfen! </p>\n\n\n            \t"};}},{id:1,bgImage:"/posts/bank/27/1.jpg",mobBgImage:"/posts/bank/27/M.jpg",title:"DIE HÄFEN VON TEL AVIV",smltitle:"",isVid:"true",vidId:"88OV6xU0vPI",ctg:"telavivAndJerusalem",html:function html(){return{__html:"\n                    <h2>Der hafen von Tel aviv and der haven von Jaffa. Zwei faszinierende Hafengebiete, jedes mit seinem eigenen Charakter und Charme</h2>\n\t\t\t\t\t<!--<div class=\"responisve-iframe\">\n\t\t\t\t\t\t<iframe src=\"https://www.youtube.com/embed/88OV6xU0vPI/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1\" height=\"315\" width=\"560\" allowfullscreen=\"\" frameborder=\"0\"></iframe>\n\t\t\t\t\t</div>-->\n\t\t\t\t\t<p>\n                          Tel Aviv, a bustling a highly modern metropolis, boasts beaches with fine golden sand, a hip atmosphere and ample opportunities for fun infused with authentic Middle Eastern flavor, not to mention great food and coffee. Just forty minutes away, experience an entirely different beat and pulse: Jerusalem, a city of such unparalleled beauty, it will be easy to understand why for millennia it has been so inspirational for so many.\n                          <br/>\n                          While both Tel Aviv and Jerusalem are two busy, vital and intriguing cities that offer a multitude of must-see attractions, they couldn\u2019t be more different. Despite their geographic proximity, they have entirely different landscapes, scents and flavors. Where else could you so easily combine the ultimate beach destination with one of the most ancient and holiest cities in history?\n                          <br/>\n                          So here\u2019s a sample menu of what you can do on a vacation in both cities.\n                      </p>\n                      <h3>\n                          Tel Aviv \u2013 the city that never sleeps\n                      </h3>\n                      <p>\n                          So you\u2019ve landed in Tel Aviv\u2026 Experience all the excitement the first Hebrew city dishes up. Discover the stunning azure hues of the Mediterranean, the quaint spots in the White City, its markets, restaurants, special flavors and scintillating night life. Catch a few waves and see exactly why Tel Aviv is known as the non-stop city, living and breathing vitality, 24 hours a day. <br/>\n                          So let\u2019s go.\n                      </p>\n                      <h3>\n                          Neve Tzedek:\n                      </h3>\n                      <p>\n                           Discover the magic of this spectacular and beautifully renovated neighborhood, located on the southern end of the Tel Aviv Promenade, next to Jaffa. Start your morning with a culinary experience that includes a typical Israeli breakfast: delicious baked goods, eggs, cheeses and dips, green salad or chopped salad, orange juice and, of course, excellent coffee. The recommended tour of Neve Zedek takes you to historical landmarks and small, wonderful museums.\n                      </p>\n                      <div class=\"img-wrapper\">\n                        <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/1/1.jpg")+" class=\"img-responsive\" />\n                      </div>\n                      <h3>\n                          Hatachana:\n                      </h3>\n                      <p>\n                          After recharging, go visit Hatachana, which is close by. There you can visit renovated Templar buildings, as well as Jaffa\u2019s old train station, completely redone. The site tells the tale of the train station, with its Jaffa-Jerusalem line, that operated here from 1892-1948.\n                      </p>\n                      <h3>\n                          Jaffa\n                      </h3>\n                      <p>\n                          Next, take a walk along the stunning Tel Aviv beach promenade to Jaffa. We recommend visiting Jaffa Port, considered to be one of the world\u2019s most ancient ports. Lounge at one of the many cafes that dot the wharf, and watch the fisherman at work. Then, continue towards the colorful flea market, where you can treat yourself to a vintage item, Armenian ceramics, a hamsa or any of a multitude of souvenirs. At night, the area transforms itself into a hopping bar and restaurant scene.\n                      </p>\n                      <h3>\n                          Pedal down the beach:\n                      </h3>\n                      <p>\n                          Tel Aviv is known as Israel\u2019s bicycle capital. On a nice day, those of you with a sporty spirit can rent a bike at a one of the Tel-O-Fun stations or any other rental spot around town. Biking from Neve Zedek to Tel Baruch beach in the northern part of the city is a phenomenally fun experience.\n                      </p>\n                      <div class=\"img-wrapper\">\n                        <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/1/2.jpg")+" class=\"img-responsive\" />\n                      </div>\n                      <h3>\n                          Eretz Israel Museum\n                      </h3>\n                      <p>\n                          If you find yourself in the northern section of town, we suggest you visit the Eretz Israel Museum. It is a multidisciplinary museum that focuses on the history and culture of Israel through permanent and temporary exhibits dedicated to archeology, ethnography, post and philately, folklore, Judaica, traditional crafts, popular art, cultural history and local identity.\n                      </p>\n                      <h3>\n                          Rothschild Boulevard\n                      </h3>\n                      <p>\n                          Looking for an inviting location where you can enjoy a great meal? Try eating at one of the fine restaurants on or around Rothschild Boulevard, right in the heart of the city, it is one of the three zones that make up the White City, recognized by UNESCO as a World Cultural Heritage Site. This street, which perfectly defines the essence of Tel Aviv, offers you a prime opportunity for people watching. You can also take a stroll and take in the impressive Bauhaus architecture, the old kiosk and the small museums that relate the fascinating story of Tel Aviv and its first neighborhood, Ahuzat Bayit.\n                      </p>\n                      <h3>\n                          Nightlife\n                      </h3>\n                      <p>\n                           If you plan on staying in the city, you can opt to take a room at one of the big hotels located on the beach, near the promenade, or at one of the lovely boutique hotels. And if you\u2019re still energized and raring to go, now\u2019s the time to enjoy yourself at one of the popular bars, nightclubs, the Opera House, a dance performance or any of the many events and festivals in Tel Aviv.\n                           <br/>\n                           Done sampling the good life in Tel Aviv? Now enjoy the best of both worlds by heading out to Jerusalem. It\u2019s only 40 minutes away!  The Holy City awaits you!\n                      </p>\n                      <div class=\"img-wrapper\">\n                        <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/1/3.jpg")+" class=\"img-responsive\" />\n                      </div>\n                      <h3>\n                        Jerusalem \u2013 the world\u2019s most beautiful city\n                      </h3>\n                      <p>\n                        Discover the city most sacred to three religions: Judaism, Islam and Christianity. Visit the historic sites, breathe in the dizzying scents, taste the special dishes, inhale the clean mountain air and have fun at the many entertainment hot spots around the city.\n                      </p>\n                      <h3>\n                        Ein Kerem\n                      </h3>\n                      <p>\n                        Even before reaching the city, you can visit the picturesque neighborhood of Ein Kerem. Just a 20-minute drive from the city center, it is known for its idyllic character. Nestled in greenery, Ein Kerem brings you breathtaking views, charming stone houses, churches and mosques, fascinating historical sites, enchanting alleys, galleries and special boutique shops, cafes and fine restaurants, as well as exquisite hotels, both old and new.\n                      </p>\n                      <h3>\n                        Bloomfield Science Museum\n                      </h3>\n                      <p>\n                        Jerusalem\u2019s science museum is a magical kingdom for adults and children alike, filled with moving objects, optical illusions, electrical experiments and everything that has made our world a user-friendly place.\n                      </p>\n                      <h3>\n                        The Old City\n                      </h3>\n                      <p>\n                        At the top of any Jerusalem itinerary! The Old City of Jerusalem is, simply put, an ancient treasure trove of discovery and delight. The true essence of Jerusalem is hidden in the narrow, winding alleyways of the Old City: the special atmosphere, fascinating history and secrets are revealed among its ancient stones. Visit the Western Wall to be moved by the sanctity of the remains of the Temple and to place a note with a request to the Holy One between the stones.\n                      </p>\n                      <div class=\"img-wrapper\">\n                        <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/1/4.jpg")+" class=\"img-responsive\" />\n                      </div>\n                      <p>\n                        Follow in the footsteps of Jesus, down the Via Dolorosa, to the Church of the Holy Sepulchre \u2013 home to the two holiest sites of Christianity: the site where Jesus of Nazareth was crucified and the empty tomb, from which he is believed to have resurrected. Continue to Mount Zion, where you can visit the Cenacle (also known as the Upper Room), traditionally held to be the site of the Last Supper. Then, as Jesus did frequently, visit the Mount of Olives for a moment of meditation at Gethsemane, where Jesus prayed and his disciples slept the night before the crucifixion. And, ascend to the rooftop of the Austrian Hospice of the Holy Family for a truly magnificent view of Jerusalem and the Old City.\n                        To immerse you even deeper into the roots of ancient Jerusalem, tour the Western Wall tunnels, visit the Dome of the Rock, the holy site where Muhammad is believed to have ascended to Heaven, and the Lutheran Church of the Redeemer, home to one of the most beautiful organs in Israel.\n                      </p>\n                      <h3>\n                        Machane Yehuda Market\n                      </h3>\n                      <p>\n                        You\u2019ve been busy today. Starting to feel hungry? Now you can visit Machane Yehuda Market \u2013 Jerusalem\u2019s bustling and vibrant open air market. Alongside the market\u2019s well-known stands, many cafes and upscale food shops have sprung up in recent years.\n                      </p>\n                      <h3>\n                        Shopping in Jerusalem:\n                      </h3>\n                      <p>\n                        Ready for some shopping and souvenirs? Buy Armenian ceramics or Judaica in the special and beautiful stores in the Old City. You will also find stores selling a plethora of souvenirs from Israel in the city center. You\u2019ll find numerous clothing stores located on the Ben-Yehuda Promenade. And don\u2019t forget to check out the second hand shops if you want to purchase something a little more authentic. What\u2019s more, don\u2019t miss a visit to the upscale Mamila mall, considered one of the city\u2019s most active shopping centers.\n                      </p>\n                      <p>\n                        So diverse, so distinct and any yet just a short commute apart, Jerusalem and Tel Aviv make the perfect destination package. Together, they bring you history and modernity, ancient artifacts and modern arts, fun in the sun and the most spiritual journey of your life. It doesn\u2019t get any better than that! So what are you waiting for? Book your vacation now!\n                      </p>\n\n\n           "};}},{id:21,bgImage:"/posts/bank/99/1.jpg",mobBgImage:"/posts/bank/99/M.jpg",player_id_post:"21",ctg:"culinary",isVid:true,// vidId: "n4kCnPXEX7g",
vidId:"JQD9JpMaw9g",title:"Ein Feinschmeckerparadies",smltitle:"",html:function html(){return{__html:"\n\n                     <h2>Komm heraus in Tel Avivs genialer kulinarischer Szene</h2>\n\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tWenn Sie zu den Feinschmeckern geh\xF6ren (wir m\xFCssen ehrlich sein, das tun wir doch alle), m\xFCssen Sie unbedingt in Tel Aviv essen gehen.\n          </p>\n          <p>\n\t\t\t\t\t\t\t\tDie K\xFCchenchefs von Israel sind weltweit f\xFCr ihre innovativen Gerichte bekannt und die Gourmetszene in Tel Aviv ist absolut im Kommen.\n          </p>\n          <p>\n\t\t\t\t\t\t\t\tMit \xFCber 4.500 Speiselokalen ist Tel Aviv ein Mekka f\xFCr Feinschmecker. Viele Restaurants sind im Besitz von exzellenten, weltweit anerkannten K\xFCchenchefs, die in den besten K\xFCchen der Welt gelernt haben, bevor Sie nach Israel zur\xFCckgekehrt sind, um die lokale Gourmetszene zu pr\xE4gen.\n          </p>\n          <p>\n\t\t\t\t\t\t\t\tTel Aviv hat etwas f\xFCr jeden Geschmack zu bieten. Von der US-Gourmet-Website The Daily Meal als \u201ETop-Adresse f\xFCr Veganer\u201C ausgezeichnet, hat Tel Aviv hat ungef\xE4hr 400 veganerfreundliche Restaurants zu bieten. Sie m\xFCssen unbedingt die exzellenten Favoriten der traditionellen Stra\xDFenk\xFCchen wie Falafel und Hummus probieren, aber auch unz\xE4hligen Delikatessen auf den lokalen M\xE4rkten. Wenn Sie sich ein fantastisches kulinarisches Erlebnis w\xFCnschen, sollten Sie sich die trendigen Restaurants im Hafen von Tel Aviv, an der Rothschild Avenue, in Neve Tzedek oder im atemberaubend renovierten Tachana-Komplex nicht entgehen lassen.\n          </p>\n          <p>\n\t\t\t\t\t\t\t\tAuf dem Markt von Sarona - einer ehemaligen Kolonie deutscher Templer - findet man mit Abstand die modernste K\xFCche der Stadt. Dieser 8.700 m2 gro\xDFe Markt wurde sorgf\xE4ltig restauriert und beherbergt heute 91 Gesch\xE4fte aller Kategorien, St\xE4nde und Restaurants, in denen Sie neue Gerichte erleben k\xF6nnen, die nicht nur k\xF6stlich, sondern auch au\xDFergew\xF6hnlich originell sind.\n          </p>\n\n         "};}},// No translation
// {
//         id:2,
//         bgImage : "/posts/bank/35/1.jpg",
//         mobBgImage : "/posts/bank/35/M.jpg",
//         title : "Tel Aviv: Nonstop excitement.",
//         vidId_post : "88OV6xU0vPI",
//         player_id_post :"2",
//         smltitle : "Beautiful, colorful and unforgettable Tel Aviv",
//         ctg: "telaviv",
//         html: function(){
// 			return {
// 				__html: `
// 					<div class="responisve-iframe">
// 					<iframe src="https://www.youtube.com/embed/88OV6xU0vPI/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
// 					</div>
// 					<p>
// 					Energetic, inspirational or funfilled relaxation - Your holiday in the vibrant city of Tel Aviv can be
// 					anything you want it to be. With great weather virtually all year round, you can chill on dazzling
// 					stretches of golden beaches, take in the colorful markets, cutting edge culture and entertainment,
// 					outstanding nightlife and an exciting culinary scene. You can also enjoy simply making your way through the streets with their fascinating Bauhaus buildings and just feel the city’s unique ‘non-stop’ vibe, which has made it one of the trendiest destinations for tourists worldwide.<br>
// 					So get energized, get inspired, get ready – you’re gonna fall in love with Tel Aviv!
// 					</p>
// 					<div class="img-wrapper">
// 					<img src=${getImgUrl() +  "/posts/2/3.jpg"} class="img-responsive" />
// 					</div>
// 					<h3>
// 					NON-STOP Tel Aviv<br> Ultimate Beach Fun
// 					</h3>
// 					<p>
// 					Voted National Geographic Magazine “One of the ten best beach cities in the world” - with clear waters and action-packed beaches, each one of Tel Aviv’s 16 beaches has its own style and attracts certain personalities - from hippie casual to Riviera chic. Day or night, hanging out on the beach is one of the best ways to spend the time in Tel Aviv.
// 					</p>
// 					<div class="img-wrapper">
// 					<img src=${getImgUrl() +  "/posts/2/2.jpg"} class="img-responsive" />
// 					</div>
// 					<h3>
// 					Sensational Nightlife
// 					</h3>
// 					<p>
// 					The Israeli weekend starts on Thursday evening and continues until nearly the crack of dawn on Sunday—when the work week resumes. But pretty much every night is “party night” in Tel Aviv. The city that doesn’t stop keeps going all night long and is constantly buzzing with trendy, vibrant hotspots, home to some of the most epic clubs and parties in the world.
// 					</p>
// 					<div class="img-wrapper">
// 					<img src=${getImgUrl() +  "/posts/2/4.jpg"} class="img-responsive" />
// 					</div>
// 					<br>
// 					<div class="img-wrapper">
// 					<img src=${getImgUrl() +  "/posts/2/5.jpg"} class="img-responsive" />
// 					</div>
// 					<br>
// 					<div class="img-wrapper">
// 					<img src=${getImgUrl() +  "/posts/2/6.jpg"} class="img-responsive" />
// 					</div>
// 					<br>
// 					<div class="img-wrapper">
// 					<img src=${getImgUrl() +  "/posts/2/7.jpg"} class="img-responsive" />
// 					</div>
//          `
//     }
//   }
// },
{id:5,bgImage:"posts/bank/8/1.jpg",mobBgImage:"posts/bank/8/M.jpg",title:"DIE VEGANE SZENE IN TEL AVIV",ctg:"culinary",isVid:true,vidId:"tNl2QXNOHMk",smlTitle:"",html:function html(){return{__html:"\n                    <h2>Probieren Sie diese Top-Auswahl an veganen Restaurants in Tel Aviv</h2>\n\t\t\t\t\t<p>\n                          Dieses Jahr hat die Amerikanische Feinschmeckerwebseite The Daily Meal Tel Aviv als Top-Destination f\xFCr vegane Touristen gek\xFCrt. Mit mehr als 400 vegan freundlichen Restaurants werden Sie in Tel Aviv nie hungrig sein m\xFCssen.\n                        </p>\n                        <h3>\n                          Nanutschka\n                        </h3>\n                        <p>\n                          2014 hat dieses traditionelle Georgische Restaurant den Wechsel zur veganen K\xFCche gemacht. Jetzt serviert es vegane Georgische Gerichte, wie z.B. traditionelles  georgisches Geb\xE4ck gef\xFCllt mit Pilzen anstatt von Rindfleisch.\n                        </p>\n\n                        <div class=\"img-wrapper\">\n                            <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/6/2.jpg")+" class=\"img-responsive\" />\n                        </div>\n\n                        <h3>\n                           HaSchawarma HaTsimchonit\n                        </h3>\n                        <p>\n                            Das vegane Schawarma ist eine Alternative f\xFCr Veganer die traditionelle lokale Gerichte probieren m\xF6chten. Das scharfe Tofu- und Seitan-\u201CFleisch\u201D kann in einem Br\xF6tchen, Pita, Tortilla, oder Focaccia bestellt werden. Aba Gil ist ein anderes Tel Aviver Restaurant das traditionelles Nah\xF6stliches Essen in veganer Version anbietet.\n                        </p>\n\n                        <h3>\n                            Buddha Burgers\n                        </h3>\n                        <p>\n                            Diese Kette von veganfreundlichen Hamburger-Restaurants verf\xFCgt \xFCber Niederlassungen in Haifa und Eilat. Die vielf\xE4ltige Speisekarte bietet Fast-Food-Favoriten aus der ganzen Welt, darunter indische, italienische und amerikanische Burger und Hot Dogs \u2013 nat\xFCrlich komplett fleischfrei. Sie k\xF6nnen sogar einen koscheren (Soja) Cheeseburger bekommen.\n                        </p>\n                        <h3>\n                            Zakaim\n                        </h3>\n\n                        <div class=\"img-wrapper\">\n                          <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/6/3.jpg")+" class=\"img-responsive\" />\n                        </div>\n\n                        <p>\n                            This boutique restaurant serves innovative dishes prepared with the freshest ingredients. The restaurant uses no plastic products and serves vegan variations on favorites like Caesar salad, stuffed cabbage and freekeh.\n                        </p>\n\n                        <p>\n                            This restaurant serves up authentic Ethiopian cuisine but vegan-friendly. The delicious teff flour injera bread (gluten-free) will make you fall in love with this style of food. Visit on a Monday night and you\u2019ll be treated to a live jazz performance.\n                        </p>\n\n\n\t\t\t"};}},{id:13,bgImage:"/posts/bank/28/1.jpg",mobBgImage:"/posts/bank/28/M.jpg",title:"Küche in Jerusalem",ctg:"culinary",isVid:true,vidId:"2CSCe2WC7Ns",smltitle:"",html:function html(){return{__html:"\n                    <h2>Aufregend, vielf\xE4ltig und ach so lecker</h2>\n\t\t\t\t\t<!--<div class=\"responisve-iframe\">\n\t\t\t\t\t\t<iframe src=\"https://www.youtube.com/embed/2CSCe2WC7Ns/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1\" height=\"315\" width=\"560\" allowfullscreen=\"\" frameborder=\"0\"></iframe>\n\t\t\t\t\t</div>-->\n\t\t\t\t\t<p>\n\t\t\t\t\t\t\tIn Jerusalem gibt es viele lebendige und trendige Restaurants und Unterhaltungsm\xF6glichkeiten. Die Stadt ist vollgepackt mit Bereichen, die hervorragende M\xF6glichkeiten f\xFCr jede Art von Tag- und Nachtunterhaltung bieten, wo Sie einen herrlichen Abend bei einem guten Essen, einem k\xFChlen Bier oder Tanz zu guter Musik genie\xDFen k\xF6nnen.\n          </p>\n          <p>\n\t\t\t\t\t\t\tIn Jerusalem, viele sagen, dass sie f\xFCr den Hummus kommen, aber wegen die unglaublich vielf\xE4ltige K\xFCche bleiben. Von traditionellem orientalischen und nordafrikanischen bis hin zu s\xFCdamerikanischer, asiatischer Fusions- und kontinentaleurop\xE4ischer K\xFCche; Vom Streetfood bis zur feine Speisen hat Jerusalem alles zu bieten. Jerusalems gro\xDFe Auswahl an kulinarischen Optionen finden Sie buchst\xE4blich \xFCberall; von lokale Delikatessen auf Stra\xDFenst\xE4nden bis hin authentische Restaurants auf den M\xE4rkten, und wenn Sie nach dem Gourmet-Erlebnis suchen, k\xF6nnen Sie einen Platz in einem der vielen exklusiven Chef-Restaurants der Stadt reservieren.\n          </p>\n\n         "};}},//No translation
// {
// 	id:10,
// 	bgImage : "posts/bank/42/1.jpg",
// 	mobBgImage : "posts/bank/42/M.jpg",
// 	title: "Kaffee in Tel Aviv",
// 	ctg:"culinary",
// 	isVid:true,
// 	vidId: "rVr0gqFC364",
// 	smlTitle: "",
// 	html: function(){
// 		return {
// 			__html:`
// 			<p>
// 			  Coffee shop culture is fundamental to Tel Aviv. So slow down the pace and soak up the vibe.
// 			</p>
// 			`
// 		}
// 	}
// },
{id:11,bgImage:"posts/bank/33/1.jpg",mobBgImage:"posts/bank/33/M.jpg",title:"Feinschmeckerszene Tel Aviv",ctg:"culinary",isVid:true,vidId:"jfyHxk8ZRrI",smlTitle:"",html:function html(){return{__html:"\n\t\t\t<small style=\"color:#000; display:block\">\n                      \t\tA film by VIA TOLILA\n                      \t</small>\n\n\t\t\t<p>\n\t\t\t   Der perfekte Ort, an dem Sie die bunte Vielfalt der hochkar\xE4tigen Restaurants von Tel Aviv genie\xDFen k\xF6nnen\n\t\t\t</p>\n              \n\t\t\t"};}},{id:34,bgImage:"/posts/bank/deadsea1/1.jpg",mobBgImage:"/posts/bank/deadsea1/M.jpg",title:"Vergnügen am Toten Meer",ctg:"deadsea",isVid:false,smltitle:"",html:function html(){return{__html:"\n            \n\t\t\t\t    <h2>F\xFCr eine schwimmend gute Zeit</h2>\n                  <p>\n                    Ein geologisches Wunder in einer einzigartig ruhigen Umgebung \u2013 das Tote Meer ist eine sehr beliebte Touristenattraktion. Erleben Sie die Ruhe des Wassers mit seinen einzigartigen heilenden Eigenschaften und genie\xDFen Sie die unvergleichliche Sch\xF6nheit der umliegenden Landschaft. <strong>Das Tote Meer, auch bekannt als das \xE4lteste nat\xFCrliche Heilbad der Welt, ist mit einer extrem hohen Salzkonzentration von 31,5% gesegnet, was Touristen von nah und fern das erstaunliche Erlebnis erm\xF6glicht, m\xFChelos auf den Gew\xE4ssern des niedrigsten Ortes der Erde zu schweben. W\xE4hrend Sie hier sind, k\xF6nnen Sie auch im gesunden schwarzen Schlamm der Gegend baden</strong> oder die faszinierende und historisch reiche Landschaft in der Umgebung erkunden.\n                  </p>\n\n                  <p>\n                      Luxuri\xF6se Hotels, eine abwechslungsreiche K\xFCche von Gourmet-Restaurants bis hin zu Fastfood-Restaurants, gro\xDFartige Souvenirl\xE4den, die au\xDFergew\xF6hnliche Geschichte der nahegelegenen Festung Masada und viele kulturelle Aktivit\xE4ten w\xE4hrend des ganzen Jahres machen das Tote Meer zu einem beliebten Ziel f\xFCr Touristen und internationale Besucher.\n                  </p>\n\t\t\t\t\n            \t "};}},{id:22,bgImage:"/posts/bank/43/1.jpg",mobBgImage:"/posts/bank/43/M.jpg",title:"Susshuka Zeit",ctg:"culinary",isVid:true,vidId:"n4kCnPXEX7g",smltitle:"",html:function html(){return{__html:"\n\n\t\t\t\t<h2>\n\t\t\t\tLerne Sie, wie man das weltber\xFChmte Shakshuka-Gericht zubereitet!</h2>\n\t\t\t\t<!--<div class=\"responisve-iframe\">\n\t\t\t\t\t\t<iframe src=\"https://www.youtube.com/embed/n4kCnPXEX7g/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1\" height=\"315\" width=\"560\" allowfullscreen=\"\" frameborder=\"0\"></iframe>\n\t\t\t\t\t</div>-->\n\n      \t\t<p>\n\t\t\t\t\tWenn man Leute fragt, die Tel Aviv und Jerusalem besuchen, was war ihr Lieblingsgericht, dass sie auf ihrer Reise probiert haben, die Antwort wird meistens Shkshuka sein. Diese mediterrane Delikatesse, ein definitiver lokaler Favorit, ist im Wesentlichen ein Gericht aus Eiern, die in einer Sauce aus Tomaten, Chilischoten und w\xFCrzigen Zwiebeln pochiert werden und oft mit Brot und Tahini serviert werden. Nat\xFCrlich gibt es viele Variationen zu diesem Gericht nach lokalen Stilen und Geschm\xE4cken und es wird normalerweise zum Fr\xFChst\xFCck oder Brunch serviert, wobei Sie feststellen werden, dass es auch f\xFCr ein fantastisches Abendessen sorgt.\n      \t\t</p>\n      \t\t<p>\n\t\t\t\t\tDie beste Art, Shakshuka zu essen, ist definitiv unter der fantastischen ganzj\xE4hrigen Sonne von Tel Aviv oder Jerusalem, w\xE4hrend Sie eine erstaunliche St\xE4dtereise voller Aromen und unvergesslicher Erlebnisse genie\xDFen.\n      \t\t</p>\n      \t\t<p>\n\t\t\t\t\tSollten Sie jedoch Lust auf selbstgemachtes haben und den Geschmack des sensationellen Shakshuka in Ihrer eigenen K\xFCche nachmachen wollen, so wirds gemacht:\n      \t\t</p>\n      \t\t<h3>\n            Zutaten\n          </h3>\n          <ul>\n             <li>2 Essl\xF6ffel Oliven\xF6l</li>\n             <li>1 Zwiebel, gehackt</li>\n             <li>1 rote Paprika, entkernt und gew\xFCrfelt</li>\n             <li>4 Knoblauchzehen, gehackt</li>\n             <li>2 Dosen gew\xFCrfelter Tomaten</li>\n             <li>6 Eier</li>\n             <li>2 Essl\xF6ffel frischer Koriander, gehackt</li>\n             <li>\xBE Teel\xF6ffel Salz</li>\n             <li>1 Teel\xF6ffel Paprika</li>\n             <li>\xBC Teel\xF6ffel schwarzer Pfeffer</li>\n             <li>\u2022\t1 Jalapeno (optional)</li>\n          </ul>\n          <h3>\n             Anleitung\n          </h3>\n          <ol>\n              <li>Ofen auf 375 Grad vorheizen, w\xE4hrend Sie warten.</li>\n              <li>Erhitzen Sie das Oliven\xF6l in einer schweren ofenfesten Pfanne bei mittlerer Hitze. F\xFCgen Sie Zwiebel, Paprika und Jalapeno hinzu und braten Sie, bis Zwiebeln durchsichtig sind.</li>\n              <li>F\xFCgen Sie Knoblauch und Paprika hinzu. F\xFCgen Sie Tomaten, Salz und schwarzen Pfeffer hinzu.</li>\n              <li>Zum Kochen bringen und Hitze reduzieren. Kochen Sie f\xFCr 10-15 Minuten.</li>\n              <li>Erstellen Sie 6 kleine Leerfelder in der Sauce und knacken Sie vorsichtig jedes Ei in die Leerfelder.</li>\n              <li>Stellen Sie die Pfanne in den vorgeheizten Ofen und garen Sie, bis die Eier wei\xDF sind - ungef\xE4hr 10 Minuten.</li>\n              <li>Vor dem Servieren Koriander als Beilage hinzuf\xFCgen.</li>\n              <li>Mit Brot und Tahini servieren und genie\xDFen! </li>\n          </ol>\n\n         "};}},{id:5,ctg:"jerusalem",isVid:true,// vidId: "MXtcTm_JXus",
vidId:"V0Acsw3Hf_M",bgImage:"/posts/bank/30/1.jpg",mobBgImage:"/posts/bank/30/M.jpg",title:"Einkaufsfreuden",smltitle:"",html:function html(){return{__html:"\n\t\t\t\t<h2>Andenken aus Jerusalem. Was w\xE4re ein Besuch in Jerusalem ohne ein tolles Shopping-Erlebnis?</h2>\n\t\t\t\t  \t<!--<div class=\"responisve-iframe\">\n\t\t\t\t\t\t<iframe src=\"https://www.youtube.com/embed/V0Acsw3Hf_M/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1\" height=\"315\" width=\"560\" allowfullscreen=\"\" frameborder=\"0\"></iframe>\n\t\t\t\t\t</div>-->\n\t\t\t\t\t<p>\n                            Es gibt in Jerusalem mehrere Gegenden mit Shoppingpromenaden und ebenfalls einige Einkaufszentren. Wenn Sie in Jerusalem shoppen gehen, k\xF6nnen Sie sich sicher sein f\xFCr jedes Budget immer das Richtige zu finden.\n                        </p>\n\n                        <h3>\n                            Im STADTZENTRUM: BEN YEHUDA UND BENACHBARTE STRASSEN\n                        </h3>\n                        <p>\n                            Das gesamte Stadtzentrum von Jerusalem ist mittlerweile eine gro\xDFe Fu\xDFg\xE4ngerzone. Der Kern des Stadtzentrums ist die Ben-Yehuda-Stra\xDFe, eine Fu\xDFg\xE4ngerzone voller Gesch\xE4fte und Restaurants. Durch die Sanierung der Stra\xDFe vor einigen Jahren, entstand eine einladende Gegend mit neu gepflasterten Fu\xDFwegen aus Meleke, eleganten Laternenmasten, erh\xF6hten Sitzm\xF6glichkeiten und einem  kleinen Springbrunnen. Die Stra\xDFen in der Umgebung wurden ebenso mit schicken, grau gekachelten Fu\xDFwegen und denselben eleganten Laternenmasten wie auf der Ben-Yehuda-Stra\xDFe saniert. Diese Sanierungsarbeiten wurden \xFCbrigens alle in Vorbereitung auf den Start der st\xE4dtischen Lightrail Stra\xDFenbahn auf der Jaffastra\xDFe durchgef\xFChrt.\n                        </p>\n\n                        <p>\n                            In Anbetracht der gro\xDFen sanierten Gegend, ist eigentlich jede der Stra\xDFen im Zentrum einen Besuch wert, wenn Sie in Jerusalem shoppen gehen: Die Shatzstra\xDFe, die King-George-Stra\xDFe, die Hillelstra\xDFe, die Ben-Yehuda-Stra\xDFe, die Jaffastra\xDFe, die Yoel-Salomon-Stra\xDFe und all ihre benachbarten Stra\xDFen. Tip: freitags sollten Sie tags\xFCber dem K\xFCnstlermarkt auf den Shatz und Betzalel Stra\xDFen einen Besuch abstatten \u2013 ein ausgezeichneter Ort um Jerusalemer Geschenke von lokalen Kunsthandwerkern zu erstehen.\n                        </p>\n\n                        <p>\n                            Die Ben-Yehuda-Stra\xDFe selbst ist ein H\xFCgel, der die King-George-Stra\xDFe an ihrem oberen Ende und die Jaffastra\xDFe an ihrem unteren Ende verbindet, wo sie sich schlie\xDFlich dem Zionplatz (Kikar Zion) \xF6ffnet. Highlights auf der Ben Yehuda sind unter anderem die Zweige von zwei bekannten israelischen Gesch\xE4ftsketten: Zum einen die Sch\xF6nheits- und Pflegeprodukte des Toten Meeres von Ahava und die von Teva-Naot angebotenen Qualit\xE4tslederschuhe. Die Ben-Yehuda-Stra\xDFe ist au\xDFerdem ein guter Ort um Judaika und christliche Souvenirs zu guten Preisen zu erstehen \u2013 hier sollten Sie auf jeden Fall verhandeln! In diesem Viertel finden Sie au\xDFerdem praktische Gegenst\xE4nde des t\xE4glichen Gebrauchs, von H\xFCten und Schirmen bis hin zu elektronischen Ger\xE4ten.\n                        </p>\n\n                        <p>\n                            Am Fu\xDFe der Ben-Yehuda-Stra\xDFe, am Zionplatz, befindet sich das neu errichtete HaMashbir LaTzarchan Kaufhaus (auch als \u2018HaMashbir\u2019 bekannt), wo sich das umfangreiche Angebot auf mehreren Etagen erstreckt. In der N\xE4he des Zionplatzes ist au\xDFerdem der Juwelier Baltinester (auf der Jaffa Stra\xDFe), der f\xFCr seine bestellbaren gravierten Namensketten bekannt ist. Vom Zionplatz gelangen Sie zudem direkt in das Viertel Nachalat Shiva, wo Sie insbesondere auf der Yoel Salomon Stra\xDFe zahlreiche T\xF6pfereien, Juweliere, kleine K\xFCnstlerl\xE4den und Boutiquen finden k\xF6nnen.\n                        </p>\n\n                        <div class=\"img-wrapper\">\n                          <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/5/2.jpg")+" class=\"img-responsive\" />\n                        </div>\n\n                        <h3>\n                          MAMILLA EINKAUFSZENTRUM & DER CARDO in DER ALTSTADT: GEHOBENES SHOPPING\n                        </h3>\n\n                        <p>\n                           Wenn Sie sich vom Ben-Yehuda-Viertel Richtung Altstadt wegbewegen, treffen Sie auf die ausgesprochen edle Alrov Mamilla Shoppingmeile, deren stilvolle Architektur zum Flanieren an der frischen Luft einl\xE4dt. Sie beginnt am Mamilla 5-Sternehotel und zieht sich bis zum Jaffator, am Eingang der Altstadt. Hier sind renommierte internationale Marken wie Versace, H. Stern, Nike und Gap ebenso zu finden, wie hochwertige Judaika-Geschenke. Die noble Mamilla Shoppingmeile stellt au\xDFerdem regelm\xE4\xDFig Kunstwerke aus, bietet in ihrem Amphitheater Livemusik an und ist Sponsor von familienfreundlichen Events und Aktivit\xE4ten, insbesondere zur Ferienzeit. Werfen Sie einfach einen Blick in unseren <a href=\"//www.itraveljerusalem.com/de/eventcategory/cat_events_de/\" target=\"_blank\"><strong>Veranstaltungskalender</strong></a> f\xFCr weitere Informationen.\n                        </p>\n                        <h3>\n                           DAS JERUSALEMer MALCHA EINKAUFSZENTRUM\n                        </h3>\n                        <p>\n                           Das Jerusalemer Malcha Einkaufszentrum ist eine solide Wahl f\xFCr jeden, der lieber etwas au\xDFerhalb der Innenstadt einkaufen gehen m\xF6chte, sowie auch f\xFCr Familien die es nach drinnen zieht. Das Jerusalem Malcha Einkaufszentrum ist zwar mittlerweile schon \xFCber 20 Jahre alt, wurde aber zum Zeitpunkt seiner Einweihung als \u2018Gr\xF6\xDFtes Einkaufszentrum im Nahen Osten\u2019 bezeichnet. Heute hat das Malcha Einkaufszentrum definitiv seinen Platz als den gr\xF6\xDFten Zusammenschluss von Gesch\xE4ften in Jerusalem sicher. Insgesamt stehen hier \xFCber 250 Gesch\xE4fte zur Auswahl.\n                        </p>\n\n                        <p>\n                           Das Einkaufszentrum beherbergt internationale und israelische Gesch\xE4fte, die eine Preisspanne von relativ niedrig \xFCber mittlere Budgets bis hin zu exklusiv und hochpreisig umfassen. Weltbekannte Markennamen wie H&M, Zara, Home Depot und Toys\u2019R\u2019Us haben hier Zweigstellen. Mehrere israelische Warenh\xE4user f\xFCr verschiedenste Budgets sind hier vertreten, darunter auch eine Zweigstelle vom HaMashbir LaTzarchan Warenhaus (das selbe wie auch auf dem Zionplatz) und der Mega Supermarkt. Au\xDFerdem finden sich hier praktische Anlaufpunkte wie eine Synagoge, ein Postamt und eine Zweigstelle der Bank Hapoalim. F\xFCr die Verpflegung gibt es auf dem Food Court eine breite Auswahl an Lokalen und Imbissen, die allesamt koscher sind.\n                        </p>\n\n                        <p>\n                           Zu den Freizeitaktivit\xE4ten geh\xF6rt im Winter eine Eislaufbahn sowie Unterhaltungsangebote und Handwerksworkshops in der Ferienzeit \u2013 schauen Sie in unseren Veranstaltungskalender, um Ihren Ausflug zu planen. Zus\xE4tzlich gibt es im Shilav Babygesch\xE4ft ein Spiel- und Lerncenter f\xFCr Kinder bis zu sechs Jahren. Das Malcha Einkaufszentrum ist in wenigen Minuten mit dem Bus vom Stadtzentrum aus, oder mit dem Taxi aus ganz Jerusalem zu erreichen.\n                        </p>\n\n                        <div class=\"img-wrapper\">\n                           <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/5/3.jpg")+" class=\"img-responsive\" />\n                        </div>\n\n                        <p>\n                          Activities include an indoor ice skating rink during winter, and entertainment and crafts workshops during holiday seasons \u2013 check our&nbsp;<a href=\"//www.itraveljerusalem.com/jerusalem-events\" target=\"_blank\"><strong>events schedule</strong></a>&nbsp;to plan your outing. In addition, the Shilav baby store has a gymboree area good for ages up to six. <br>\n                          Malcha Mall is an easy bus ride from center city or cab ride from anywhere.\n                        </p>\n\n                        <h3>\n                            DER ARABISCHE SUQ IN DER ALTSTADT\n                        </h3>\n                        <p>\n                             Wenn Sie auf der Suche nach authentischen, lokalen Produkten sind, ist der arabische Suq in der Altstadt genau das richtige f\xFCr Sie. Betreten Sie die Altstadt durch das Jaffator um zu dem im muslimischen und christlichen Vierteln gelegen Suq zu gelangen. Gehen Sie vom Jaffator aus, direkt auf das muslimische Viertel zu. Wenn Sie dann hoch aufgeh\xE4ngte Kleider und Gew\xE4nder sehen, wissen Sie, dass Sie am richtigen Ort sind. Man k\xF6nnte es auch \u201EKlein Istanbul\u201C nennen \u2013 der arabische Suq in der Altstadt ist einfach ein typischer nah\xF6stlicher Markt, in dem die heimische Kunstfertigkeit sich besonders bei der Kleidung und beim Essen zeigt. Sie finden hier auch christliche, j\xFCdische und muslimische Souvenirs, oft zu einem g\xFCnstigeren Preis als auf der Ben-Yehuda-Stra\xDFe \u2013 das h\xE4ngt ganz von Ihrem Knowhow und Ihren Verhandlungsf\xE4higkeiten ab (Tip: Starten Sie bei der H\xE4lfte des zuerst angebotenen Preises).\n                        </p>\n                        <p>\n                            Im arabischen Suq bekommen Sie einen Eindruck davon wie es fr\xFCher einmal war. H\xE4ndler sind bereits seit Jahrtausenden tagein, tagaus in den engen G\xE4sschen der Altstadt aktiv und die W\xFCrde dieses jahrhundertealten nah\xF6stlichen Marktplatzes ist etwas Unerreichtes; in der westlichen Kultur im Allgemeinen und sogar ganz konkret innerhalb Israels.\n                        </p>\n                        <h3>\n                             DerMAHANE YEHUDA Suq (MARKT)\n                        </h3>\n\n                        <p>\n                            Der Mahane Yehuda Markt (oder Suq) ist haupts\xE4chlich f\xFCr sein Angebot von lokalem Jerusalemer Essen \u2013 frische Erzeugnisse und N\xFCsse, B\xE4ckereien (beispielweise die B\xE4ckerei \u2018Marzipan\u2019) und Schawarma- und Falafel-Lokale bekannt. Innerhalb der letzten Jahre haben sich die Lokale auf dem Mahane Yehuda Markt in eine noble Richtung entwickelt, so dass sich hier mittlerweile spezialisierte Wein- und K\xE4segesch\xE4fte, Bio-M\xE4rkte, vegetarische Restaurants und sogar eine Zweigstelle der internationalen israelischen Kette Caf\xE9 Aroma tummeln. Zus\xE4tzlich zum Essen, finden Sie hier Geschenke, die Sie nach Hause mitbringen k\xF6nnen, darunter Judaika, Schmuck und T\xF6pferwaren. Sie k\xF6nnen au\xDFerdem Elektronik, Handys und Zubeh\xF6r sowie g\xFCnstige Bekleidung finden, darunter Levi\u2019s Jeans f\xFCr rund 10 Euro (sie sehen jedenfalls wie Levi\u2019s aus). Auch mit der Verwandlung hin zu einem etwas nobleren Ort der letzten Jahre, ist einfach nicht an der absolut authentischen und bodenst\xE4ndigen Jerusalemer Atmosph\xE4re des Mahane Yehuda Marktes zu r\xFCtteln und das macht den Mahane Yehuda Suq einfach zu einem Muss.\n                        </p>\n\n                        <h3>\n                            ZUsammenfassung\n                        </h3>\n                        <p>\n                            Insgesamt spiegelt das Shoppingangebot in Jerusalem die Stadt selbst wieder: Hier gibt es das gesamte Spektrum von antik bis modern, mit vielen Optionen vom kleineren Budget bis hin zum gehobenem Shopping. Sie werden sehen, Shopping in Jerusalem ist auf jeden Fall eine aufregende und vielf\xE4ltige Erfahrung.\n                        </p>\n\n         "};}},{id:17,ctg:"telaviv",isVid:true,// vidId: "LLOUxE-K_9Y",
vidId:"tgF0zMUYY2g",bgImage:"/posts/bank/37/1.jpg",mobBgImage:"/posts/bank/37/M.jpg",title:"Absolutes Muss in Tel Aviv",smltitle:"",html:function html(){return{__html:"\n\t\t\t\t<H2>Top 5 St\xE4tten, die Sie in der Nonstop-Stadt nicht verpassen wollen</H2>\n\t\t\t\t\t<!--<div class=\"responisve-iframe\">\n\t\t\t\t\t\t<iframe src=\"https://www.youtube.com/embed/tgF0zMUYY2g/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1\" height=\"315\" width=\"560\" allowfullscreen=\"\" frameborder=\"0\"></iframe>\n\t\t\t\t\t</div>-->\n\t\t\t\t\t<h3>\n            Die Altstadt von Jaffa\n          </h3>\n          <p>\n\t\t\t\t\t\tObwohl es sich um Tausende von Jahren handelt, ist ein Besuch in der Altstadt von Jaffa immer eine aufregende Entdeckung. Bezaubernde verwinkelte Gassen, durchzogen mit Kunstgalerien, historischen Geb\xE4uden, au\xDFergew\xF6hnlichen Sehensw\xFCrdigkeiten und einer Vielzahl von uriger authentischer Restaurants. Eine Tour durch das alte Jaffa ist eine beeindruckende Erfahrung, ein absolutes Muss f\xFCr jeden Touristen, der Israel besucht.\n          </p>\n          <h3>\n\t\t\t\t\t\tJaffa-Hafen\n          </h3>\n          <p>\n\t\t\t\t\t\tDer Hafen von Jaffa, der als einer der \xE4ltesten H\xE4fen der Welt gilt, diente schon seit Jahrtausenden Fischern, Seeleuten, Kaufleuten, Kreuzfahrern, Eroberern und Einwanderern. Heute dient der Hafen weiterhin als Fischereihafen und wird auch als st\xE4dtische Attraktion renoviert und bietet Kultur- und Freizeitaktivit\xE4ten, Shopping und Tourismus unter Beibehaltung seines einzigartigen historischen und faszinierenden Charakters.\n          </p>\n          <h3>\n\t\t\t\t\t\tTA - Hafen\n          </h3>\n          <p>\n\t\t\t\t\t\tK\xFCrzlich restauriert, hat das trendige Hafengebiet wirklich alles. W\xE4hrend des Tages k\xF6nnen Sie durch bemerkenswerte H\xE4nger-Stil-R\xE4ume f\xFCr Marken- und Boutiquen-Shopping wandern und eine Mahlzeit teilen in Restaurants mit herrlichem Meerblick und an vielen Aktivit\xE4ten f\xFCr die ganze Familie teilnehmen. Jede Nacht str\xF6men unz\xE4hlige Clubg\xE4nger durch das Stadtgebiet, dass sich zu einem der beliebtesten Hotspots der Stadt mit einigen der coolsten Clubs und Bars in Tel Aviv entwickelt.\n          </p>\n          <h3>\n\t\t\t\t\t\tDie wei\xDFe Stadt\n          </h3>\n          <p>\n\t\t\t\t\t\tBegeben Sie sich auf eine faszinierende Tour durch die \"Wei\xDFe Stadt\" von Tel Aviv und entdecken Sie, warum sie zum UNESCO-Weltkulturerbe erkl\xE4rt wurde. Die Wei\xDFe Stadt beheimatet auch die weltweit gr\xF6\xDFte Ansammlung von Geb\xE4ude im Internationalen Stil, dass auch als Bauhaus-Stil bekannt wurde. Das Viertel \"Wei\xDFe Stadt\", dass zu seinem urspr\xFCnglichen Glanz restauriert wurde, ist ein wahrhaft einzigartiger und unvergesslicher architektonischer Schatz.\n          </p>\n          <h3>\n             Neve Tzedek\n          </h3>\n          <p>\n\t\t\t\t\t\tMachen Sie eine Pause von der Hektik des Tel Avivs; Dieses versteckte Juwel eines Viertels besticht durch seinen wundersch\xF6nen orientalischen Architekturstil und die bezaubernden engen Gassen, die das Viertel Neve Tzedek, (was w\xF6rtlich \xFCbersetzt \"Oase der Gerechtigkeit\" bedeutet), zu einer wahren Oase inmitten der hektischen Gro\xDFstadt machen.\n\t\t\t\t\t</p>\n\n         "};}},{id:88,bgImage:"/posts/bank/18/1.jpg",mobBgImage:"/posts/bank/18/M.jpg",title:"Die Nachtklubs Von Tel Aviv",ctg:"telaviv",isVid:true,vidId:"ogEN7aRT0SM",// vidId:"WKfjMATNH8Q", - this is an old youtube video
smltitle:"",html:function html(){return{__html:"\n                    <h2>Finden Sie die besten Pl\xE4tze in Tel Aviv, wo rund Tel Aviv Portsum die Uhr gefeiert wird und die Musik nie verstummt</h2>\n\t\t\t\t\t<!--<div class=\"responisve-iframe\">\n\t\t\t\t\t\t<iframe src=\"https://www.youtube.com/embed/WKfjMATNH8Q/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1\" height=\"315\" width=\"560\" allowfullscreen=\"\" frameborder=\"0\"></iframe>\n\t\t\t\t\t</div>-->\n\n\t\t\t\t\t<p>\n\t\t\t\t\t\tDu hast das kulturelle Leben von Tel Aviv nicht wirklich kennengelernt, bevor Du bis zum Sonnenaufgang in einem der ber\xFChmten Nachtklubs durchgetanzt hast.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/8/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<p>\n                        <strong>HaOman 17 (88 Abarbanel St.)</strong> \u2013 In diesem unvergleichliche Mega-Club toben sich internationale DJs auf mehreren Tanzfl\xE4chen aus, und jede Nach findet eine andere Art von Party statt.\n                    </p>\n\n\t\t\t\t\t<p>\n                    \t<strong>Dizingoff (Dizingoff Square)</strong> \u2013 Ein echter Mega-Club mit wundersch\xF6nen G\xE4sten und viel Mainstream-Musik.\n                    </p>\n\n                    <p>\n                    \t<strong>Cat and Dog (23 Carlibach St.) </strong> \u2013 Nichts f\xFCr Zartbesaitete, denn hier beginnt die Party erst richtig, wenn andere Klubs ihre T\xFCren schlie\xDFen. Die Musik ist so vielseitig wie die G\xE4ste.\n                    </p>\n\n                    <p>\n                    \t<strong>Biggy-Z (18 Bugrashov St.)  </strong> \u2013 Inspiriert vom Mardi Gras in New Orleans, mit Innen- und Au\xDFenbereich sowie einer sehr beliebten Nachf\xFCllpolitik f\xFCr die Besucher, die dass Armband des Klubs kaufen.\n                    </p>\n\n                    <p>\n                    \t<strong>Dream Exhibition (30 Ibn Gvirol St.)   </strong>\u2013 Ein eleganter Klub mit allen modernen Komforts. Hier tanzen die \xFCber 23-J\xE4hrigen zu Rock, Mainstream und House-Musik.\n                    </p>\n\n                    <div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/8/3.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<p>\n                    \t<strong>Valium (1 Ben Yehuda St.) </strong> \u2013 Ein Luxus-Nachtklub in gro\xDFz\xFCgigen R\xE4umlichkeiten im obersten Geschoss des Magdalor-Geb\xE4udes. Genie\xDFe die Musik auf der Tanzfl\xE4che oder dem ruhigeren Dach.\n                    </p>\n\n                    <p>\n                    \t<strong>KTOVT (Mikveh Israel)  </strong> \u2013 Ein alternativer Klub mit interessantem Dekor und Musik von internationalen und lokalen DJs f\xFCr diejenigen, die einfach nur tanzen m\xF6chten.\n                    </p>\n\n                     <p>\n                    \t<strong>The Block (157 Salame St.) </strong>  \u2013  Techno-Trance ist die Musikrichtung der Wahl in diesem Klub, der f\xFCr sein Soundsystem der Spitzenklasse ber\xFChmt ist.\n                    </p>\n\n\n                    <div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/8/4.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<p>\n                    \t<strong>Kuli Alma (10 Mikveh Israel St.) </strong>  \u2013 In diesem k\xFCnstlerischen Treffpunkt mit Innen- und Au\xDFenbereichen wird lokale Kunst ausgestellt, es gibt vegetarische Speisen und unterschiedliche Musikrichtungen.\n                    </p>\n\n                    <p>\n                    \t<strong>Schwule Nachtklubs \u2013 Das Evita (31 Yavne St.) </strong>  ist f\xFCr alle Mitglieder der LGBT-Community da. Ein reiner M\xE4nnerklub ist die\n                    </p>\n\n                 \t<p>\n                    \t<strong>Apolo Bar (Allenby 46),  </strong>  und im\n                    </p>\n\n                     <p>\n                    \t<strong>Barvaz (Ha\u2019Mehoga 10)  </strong> bleiben Frauen unter sich. Das\n                    </p>\n\n                     <p>\n                    \t<strong>Amazona (23 Lilienblum St.) </strong> \xF6ffnet seine T\xFCren f\xFCr alle \xFCber 23-J\xE4hrigen.\n                    </p>\n         "};}},{id:10,bgImage:"/posts/bank/12/1.jpg",mobBgImage:"/posts/bank/12/M.jpg",ctg:"telaviv",isVid:false,title:"Zeit für etwas Kultur",smltitle:"",html:function html(){return{__html:"\n\n\t\t\t\t\t\n                     <h2>Die Museen Von Yel Aviv. Tel Aviv bietet eine gro\xDFe Anzahl von Museen zu einer Vielfalt von Themen</h2>\n\t\t\t\t     <h3>\n                               Tel-Aviv Museum of Art\n                        </h3>\n                        <p>\n                                Das Tel Aviv Museum of Art pr\xE4sentiert eine Vielfalt an permanenten und tempor\xE4ren Ausstellungen im Helena Rubenstein Pavillon am Shaul Hamelech Boulevard, direkt neben dem Mann Auditorium. Die permanente Ausstellung beinhaltet einige der besten israelischen Kunstwerke, sowie Skulpturen von den 1920ern bis Heute. Das Museum bietet europ\xE4ische Kunstwerke \u2013 Impressionismus und Post-Impressionismus \u2013 vom 16ten bis zum 19ten Jahrhundert, sowie europ\xE4ische und amerikanische Arbeiten aus dem 20ten Jahrhundert. Die graphische Sammlung des Museums beinhaltet mehr als 20.000 Drucke und Zeichnungen. Unter den vielen ausgezeichneten Arbeiten des Museums ist auch eine einzigartige Auswahl an fr\xFChen gemalten Reliefs von Alexander Archipenko und Arbeiten von Chagall, die er dem Museum vor seiner Gr\xFCndung gespendet hat. Helena Rubinsteins bekannte Kollektion von Miniatuzimmern ist im, nach ihr benannten Pavillon, dauerhaft ausgestellt.\n\n                               7716408316_f5987e72cc_z\n                        </p>\n                        <h3>\n                                \xD6FFNUNGSZEITEN:\n                        </h3>\n                        <p>\n                                So geschlossen <br/>\n\n                                Mo, Mi, Sa 10:00-18:00<br/>\n\n                                Di, Do 10:00-22:00<br/>\n\n                                Fr 10:00-14:00<br/>\n\n                                Sa 10:00-16:00 (Juli-August am Sa geschlossen)\n                        </p>\n\n                        <p>\n                                <a href=\"//www.tamuseum.org.il/en/default.aspx\" target=\"_blank\"><strong>www.tamuseum.org.il</strong></a>\n                        </p>\n\n                        <h3>\n                                 Beit Hatfutsot: Das Diaspora Museum\n\n                        </h3>\n\n                        <p>\n                                 Beit Hatefutsot \u2013 Das j\xFCdische Diaspora Museum am Campus der Universit\xE4t Tel Aviv gelegen, hat als das erste Museum der Geschichte des j\xFCdischen Volkes, das den j\xFCdischen Beitrag zur menschlichen Kreativit\xE4t und Kultur \xFCber einen Zeitraum von mehr als 2000 Jahren ausstellt, Ehrenauszeichnungen aus der gesamten j\xFCdischen Welt erhalten. Die permanente Ausstellung des Museums bringt durch Zeichnungen, Videoclips, Filme, rekonstruierte Modelle und andere Mittel, die Geschichte des j\xFCdischen Volkes w\xE4hrend der Diaspiora zum Leben. Die Ausstellung konzentriert sich auf verschiedene Themen \u2013 darunter \u201CDer Lebenszyklus der j\xFCdischen Familie\u201D, \u201CGemeinschaft\u201D, \u201CGlauben\u201D und \u201Cdie R\xFCckkehr nach Zion\u201D.\n                        </p>\n\n                        <p>\n                                 <a href=\"//www.bh.org.il/\" target=\"_blank\">Beit Hatfutsot: The Diaspora Museum</a>\n                        </p>\n\n                       <div class=\"img-wrapper\">\n                                 <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/10/2.jpg")+" class=\"img-responsive\" />\n                       </div>\n\n                        <p>\n\n                                  For more information, click to the&nbsp;<a href=\"//www.bh.org.il/\" target=\"_blank\">Beit Hatfutsot: The Diaspora Museum</a>\n\n                       </p>\n\n                       <h3>\n                                 Eretz Israel Museum\n                        </h3>\n                        <p>\n                                  Das Eretz Israel Museum Tel Aviv ist eine multidisziplin\xE4re Institution. Es pr\xE4sentiert die Geschichte des Landes und seiner Kultur in einer umfangreichen Dauerausstellung, zus\xE4tzlich zu einer Vielzahl von tempor\xE4ren Ausstellungen zu Themen wie Arch\xE4ologie, Ethnographie, Folklore, Judaica, Kulturgeschichte, lokaler Identit\xE4t, traditionellem Handwerk und funktionaler Kunst. Die Pavillons des Museums sind \xFCber einem gro\xDFen Innenhof verstreut, in dessen Mitte der antike Ausgrabungsh\xFCgel Tel Kassile, bei dem Ausgrabungen wertvolle Artefakte hervorbrachten, liegt. Das Museum beherbergt eine Vielzahl von rekonstruierten alten Produktionseinrichtungen, einschlie\xDFlich Weinpressen, einer \xD6lpresse und einer Getreidem\xFChle, zusammen mit einem \u201CHandwerker Marktplatz\u201D, der traditionelle Arbeitsinstrumente zeigt, die in Eretz Israel und der gesamten Region verwendet wurden. Es gibt auch ein modernes Planetarium mit einem \u201CReise zum Universum\u201D Programm und einen Museumsshop, der eine einzigartige Auswahl an lokal produzierten Geschenken und Verzierungen anbietet.\n                                  <br/>\n                                  \xD6FFNUNGSZEITEN: <br/>\n\n                                  So-Mi 10:00-16:00 <br/>\n\n                                  Do 10:00-20:00 <br/>\n\n                                  Fr-Sa 10:00-14:00\n                        </p>\n                        <p><strong>&nbsp;</strong><a href=\"//www.eretzmuseum.org.il/e/\" target=\"_blank\">Eretz Israel Museum&nbsp;</a></p>\n                        <h3>\n                                  Beit Ha\u2019ir\n                        </h3>\n                        <p>\n                                    Das von der Stadtverwaltung renovierte Beit Ha\u2019ir, war einmal das Rathaus von Tel Aviv-Jaffa in der Bialikstrasse und dient heutzutage als lebendige Ausstellung zur Geschichte der Stadt. Beit Ha\u2019ir hat eine neue Ausstellung, die die umfangreiche Sammlung von Fotos und Geschichten \xFCber Geschehnisse, Orte und Erfahrungen der Anwohner, die sich im Laufe der Jahre angesammel haben, zusammenfasst. Das Projekt war sogar ein Teil der Hundertjahrfeier der Stadt. Der gro\xDFe Saal verf\xFCgt \xFCber eine visuelle Ausstellung mit hunderten von Dokumentarfilmen und tausenden an seltenen Fotos und Dokumenten welche die wichtigsten Ereignisse der ersten Jahre der Stadt zeigen. Im Beit Ha\u2019ir k\xF6nnen Sie auch das Dizengoff Haus, die restaurierte Residenz von Tel Aviv-Jaffas erstem B\xFCrgermeister Meir Dizengoff besuchen. Auch hier gibt es eine Dauerausstellung zu besuchen.\n                                    <br/>\n                                    \xD6FFNUNGSZEITEN:\n                                    Sun Closed\n\n                                    Mo-Do 9:00-17:00 <br/>\n\n                                    Fr-Sa 10:00-14:00<br/>\n                        </p>\n\n                        <p> <a href=\"//beithair.org\" target=\"_blank\">Beit Ha\u2019ir</a></p>\n\n                        <h3>\n                                    Das Olympic Experience Museum\n                        </h3>\n                        <p>\n                                    Das Olympic Experience Museum, ein neues Museum in Tel Aviv-Jaffa, bietet eine einst\xFCndige Reise durch die besten olympischen Rekorde, mit einem besonderen Fokus auf Israels gr\xF6\xDFten Momente. Die Olympia-Erfahrung bietet State-of-the-Art High-Tech-Imaging und Illustrationen, audio-visuelle Pr\xE4sentationen, Hologramme, interaktive Bildschirme  und vieles, vieles mehr. <br/>\n\n                                    F\xFChrungen f\xFCr Gruppen alle 30 Minuten. Es wird empfohlen im Voraus Reservierungen aufzugeben.\n\n                                    <br/>\n                                    \xD6ffnungszeiten: Sonntag-Donnerstag: 10:00-18:00, Freitag:  10:00-14:00\n                                    <br/>\n                                    The Olympic Experience, 6 Shitrit Strasse, Hadar-Yosef. Tel: +972-3-6498385\n                        </p>\n\n                        <p><a href=\"//www.olympic.one.co.il/General/Page.aspx?id=86&amp;siteid=2\" target=\"_blank\">The Olympic Experience Museum</a></p>\n                        <h3>\n                                    Ilana Goor Museum in Jaffa\n                        </h3>\n                        <p>\n                                    Ilana Goor Museum in Jaffa\n                                    The private home of this world renowned artist has been turned into a museum. You can see her sculptures, furniture, jewelry and get a glimpse into this unique Jaffa home <br/>\n                                    OPENING HOURS: <br/>\n                                    Sun-Fri 10:00-16:00 <br/>\n                                    Sat 10:00-18:00<br/>\n                                    <a href=\"//www.ilanagoormuseum.org/eng/\">www.ilanagoormuseum.org</a>\n                        </p>\n\n                        <h3>\n                                     Palmach Museum\n                        </h3>\n                        <p>\n                                    Die Privatwohnung der weltbekannten K\xFCnstlerin wurde in ein Museum umgewandelt. Hier k\xF6nnen Sie ihre Skulpturen, M\xF6bel undSchmuck sehen und bekommen einen Einblick in dieses einzigartige Haus in Jaffa.\n                                    <br/>\n                                    \xD6FFNUNGSZEITEN:\n                                    So-Fr 10:00-16:00 <br/>\n                                    Sa 10:00-18:00\n                                    <a href=\"www.ilanagoormuseum.org\">www.ilanagoormuseum.org</a>\n                        </p>\n                        <h3>\n                                    Palmach Museum\n                        </h3>\n                        <p>\n                                    Dieses Museum wurde von Trip Advisor als DAS Top Museum in Tel Aviv gew\xE4hlt. Hier dreht sich alles um den Palmach, den milit\xE4rischen Arm der Zionistischen Bewegung, der bis zur Gr\xFCndung des Staates Israel aktiv war.\n                        </p>\n                                    <a href=\"info.palmach.org.il\">info.palmach.org.il</a>\n\n\n                        <h3>\n                                     Andere einzigartige Museen\n                        </h3>\n                        <p>\n                                     In Tel Aviv-Jaffa gibt es eine Vielzahl an kleineren, auf bestimmte Themen spezialisierte Museen, wie zum Beispiel das Beit Ben Gurion (Das David Ben Gurion, Israels erstem Premierminister), Beit Hatanach (Das Haus der Bibel), Das Haganah (Verteitigungs-) Museum, Das I.Z.L. (die Irgun Tzwa\u2019i Le\u2019umi \u2013 Nationale Milit\xE4rorganisation) Museum, Beit Hasofer (Haus des Autors), Beit Reuven, Das Jabotinsky Museum, und viele andere. Jedes dieser kleinen Museum ist eine Fundgrube f\xFCr Artefakte. Zum Beispie: Beit Bialik, das Haus des israelischen Nationalpoeten, stellt die B\xFCcher, M\xF6bel und Habseligkeiten von Israels renommierten nationalen Dichter aus. Bialiks pers\xF6nliche Bibliothek, die mehr als 3000 B\xFCcher umfasst, ist ebenso erhalten geblieben und die Archive des Museums beinhalten tausende an Manuskripten, inklusive der umfangreichsten Sammlung seiner Arbeiten.\n                        </p>\n\n                        <h3>\n                                     \xD6FFNUGSZEITEN VON MUSEEN IN TEL AVIV:\n                        </h3>\n                        <p>\n                                    Etzel Museum: <br/>\n                                    King George 38: So-Do 8:30-16:00 <br/>\n                                    <a href=\"www.goisrael.com\">www.goisrael.com</a>\n                        </p>\n                        <h3>\n                                     Ben Gurion Haus:\n                        </h3>\n                        <p>\n                                     So, Di-Do 8:00-15:00<br/>\n\n                                      Mo 8:00-17:00<br/>\n\n                                      Fr 8:00-13:00<br/>\n\n                                      Sat 11:00-14:00<br/>\n                                      <A HREF=\"www.bg-house.org\">www.bg-house.org</A>\n                        </p>\n\n                        <h3>\n                                       Jabotinsky Institut in Israel:\n                        </h3>\n                        <p>\n                                      So-Do 8:00-16:00\n                        </p>\n                                      <a href=\"//en.jabotinsky.org\">en.jabotinsky.org</a>\n\n                        <h3>\n                                      Das Israel Museum:\n                        </h3>\n                        <p>\n                                      So, Mo, Mi 9:00-17:00<br/>\n                                      <br/>\n                                      Di, Do 9:00-19:00\n                                      <br/>\n                                      Fr 9:00-14:00\n                                      <br/>\n                                      <A href=\"//www.imj.org.il\">www.imj.org.il</A>\n                        </p>\n                        <h3>\n                                      Jaffa Besucherzentrum:\n                        </h3>\n                        <p>\n                                      Sommer So-Do, Sat 9:00-20:00<br/>\n\n                                      Fr 9:00-17:00<br/>\n\n                                      Winter So-Do, Sat 9:00-18:00<br/>\n\n                                      Fr 9:00-15:00<br/>\n                                      <a href=\"//www.touristisrael.com\">www.touristisrael.com</a>\n                        </p>\n\n                        <h3>\n                                      Dizengoff Hause:\n                        </h3>\n                        <p>\n                                      So-Do 9:00-17:00<br/>\n                                      <br/>\n                                      Fr 9:00-14:00<br/>\n                                      <a href=\"//eng.ihi.org.il\">eng.ihi.org.il</a>\n                        </p>\n                        <h3>\n                                      Das Bibel Museum:\n                        </h3>\n                        <p>\n                                      So-Fr 10:00-13:00 + 16:00-18:30 <br/>\n                                      <a href=\"//www.blmj.org\">www.blmj.org</a>\n                        </p>\n                        <h3>\n                                      Joseph Bau Haus:\n                        </h3>\n                        <p>\n                                      Nur mit Termin (auch am Wochenende)\n                        </p>\n                                      <a href=\"//www.josephbau.com\">www.josephbau.com</a>\n                        <h3>\n                                      Rubin Museum:\n                        </h3>\n                        <p>\n                                      So geschlossen <br/>\n\n                                      Mo, Mi, Do 10:00-15:00<br/>\n                                      <br/>\n                                      Di 10:00-20:00\n                                      <br/>\n                                      Sat 11:00-14:00\n                                      <br/>\n                                      <a href=\"//www.rubinmuseum.org.il\">www.rubinmuseum.org.il</a>\n                        </p>\n                        <h3>\n                                      Kunstgalerien\n                        </h3>\n                        <p>\n                                      Verpassen Sie nicht die dutzenden von edlen Galerien, die haupts\xE4chlich entlang der Gordon Street und in der Altstadt von Jaffa gelegen sind. Hier finden Sie das Allerneueste an zeitgen\xF6ssischer israelischer Kunst. Und jetzt sagen wir nichts mehr \u2013 jetzt lassen wir die Kunst f\xFCr sich selbst sprechen.\n                        </p>\n\n         "};}},{id:99,bgImage:"/posts/bank/20/1.jpg",mobBgImage:"/posts/bank/20/M.jpg",ctg:"jerusalem",isVid:true,vidId:"k4OwoEk5wMw",title:"Das Spirituelle Jerusalem",smltitle:"",html:function html(){return{__html:"\n\t\t\t\t<h2>Die Wichtigsten Sehenswurdigkeiten In Jerusalem. Entdecken Sie die Jahrtausende alte Geschichte</h2>\n\t\t\t\t\t<!--<div class=\"responisve-iframe\">\n\t\t\t\t\t\t<iframe src=\"https://www.youtube.com/embed/k4OwoEk5wMw/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1\" height=\"315\" width=\"560\" allowfullscreen=\"\" frameborder=\"0\"></iframe>\n\t\t\t\t\t</div>-->\n\t\t\t\t\t<p>\n             Wie in jeder Stadt l\xE4sst sich der Charme und der Charakter von Jerusalem am besten zu Fu\xDF in den Stra\xDFen erkunden. Je nach Ihren pers\xF6nlichen Interessen sollten Sie aber einige der folgenden Sehensw\xFCrdigkeiten auf keinen Fall auslassen.\n            Bei Besuchen religi\xF6ser Orte ist eine zur\xFCckhaltende Bekleidung, die Ihre Knie und Ellbogen bedeckt, empfehlenswert.\n            Ein guter Ausgangspunkt ist die Altstadt von Jerusalem mit ihrer einzigartigen und besonderen Atmosph\xE4re. Hier finden Sie die wichtigsten Sehensw\xFCrdigkeiten der Stadt.\n          </p>\n\n          <div class=\"img-wrapper\">\n            <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/9/2.jpg")+" class=\"img-responsive\" />\n          </div>\n\n          <h3>\n          DIE KLAGEMAUER\n          </h3>\n          <p>\n            Die westliche Au\xDFenmauer des Zweiten Tempels ist auch als Klagemauer oder Kotel bekannt. Sie gilt als heiligster Ort des Judentums. Die Mauer ist in Abschnitte f\xFCr M\xE4nner und Frauen unterteilt, an denen sich Gl\xE4ubige im Laufe des Tages f\xFCr Morgen-, Nachmittags- und Abendandachten versammeln. Menschen unterschiedlicher Herkunft beten an der Mauer, stecken kleine Zettel mit Gebeten in die Fugen zwischen den Steinen oder nehmen einfach die Atmosph\xE4re des Ortes in sich auf. <br/>\n            Adresse: J\xFCdisches Viertel, Altstadt<br/>\n            Tel.: +972-2-627-3515<br/>\n            \xD6ffnungszeiten: Immer ge\xF6ffnet\n\n          </p>\n\n          <div class=\"img-wrapper\">\n            <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/9/3.jpg")+" class=\"img-responsive\" />\n          </div>\n\n           <h3>\n          VIA DOLOROSA\n          </h3>\n          <p>\n            Diese Stra\xDFe verl\xE4uft von Osten nach Westen durch das muslimische Viertel, entlang der letzten Schritte von Jesus Christus auf seinem Weg an das Kreuz. Die Strecke ist sowohl bei Pilgern als auch bei Touristen beliebt und markiert 14 Stationen entlang des letzten Gangs von Jesus. Au\xDFerdem ist sie von zahlreichen L\xE4den und St\xE4nden ges\xE4umt. Ein Besuch lohnt sich besonders am Freitagnachmittag (15:00 Uhr im Winter, 16:00 Uhr im Sommer), wenn eine Prozession der Franziskaner \xFCber die Stra\xDFe zieht.\n            <br/>\n            Adresse: Via Dolorosa, Muslimisches Viertel, Altstadt\n\n          </p>\n\n          <h3>\n            GRABESKIRCHE JERUSALEM\n          </h3>\n\n          <p>\n            Dieses eindrucksvolle Geb\xE4ude geh\xF6rt zu den heiligsten Orten des Christentums und wird jedes Jahr von Millionen Pilgern aufgesucht. Der Geb\xE4udekomplex soll auf dem H\xFCgel von Golgatha (dem Kalvarienberg) stehen, wo dem Neuen Testament zufolge Jesus Christus gekreuzigt und begraben wurde und wieder auferstand.\n            <br/>\n            Adresse: Zwischen der Suq Khan e-Zeit und der Christian Quarter Road, Christliches Viertel, Altstadt <br/>\n            Tel.: +972-2-627-3314<br/>\n            \xD6ffnungszeiten: So - Sa: 5:00 Uhr - 20:00 / 21:00 Uhr\n\n          </p>\n\n          <div class=\"img-wrapper\">\n            <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/9/4.jpg")+" class=\"img-responsive\" />\n          </div>\n\n          <h3>\n            FELSENDOM\n          </h3>\n          <p>\n            Der Felsendom ist das dritte Heiligtum des Islam und steht auf dem Gipfel des Tempelbergs. Er pr\xE4gt die Silhouette der Stadt Jerusalem. Im Herzen des Heiligtums befindet sich der Gr\xFCndungsfels, von dem aus der islamischen Tradition zufolge der Prophet Mohammed seine Himmelsfahrt antrat. Ausl\xE4nder erhalten keinen direkten Zugang zum Gr\xFCndungsfels, k\xF6nnen aber f\xFCr eine begrenzte Anzahl von Stunden den Felsendom betreten.\n            <br/>\n            Adresse: Zugang zwischen Klagemauer und Dungtor, Altstadt <br/>\n            Tel.: +972-2-628-3292 oder +972-2-628-3313<br/>\n            \xD6ffnungszeiten: So - Do: 7:30 Uhr \u2013 11:00 Uhr, 13:30 Uhr \u2013 14:30 Uhr (April - September), So - Do: 8:00 Uhr \u2013 10:00 Uhr, 12:30 Uhr \u2013 14:00 Uhr (Oktober - M\xE4rz), Fr - Sa: Geschlossen.\n\n          </p>\n\n          <h3>\n            AUSSERHALB DER STADTMAUERN DER ALTSTADT\n          </h3>\n\n          <h3>\n            DAVIDSZITADELLE\n          </h3>\n          <p>\n              Die Davidszitadelle (auch f\xFCr den Davidsturm bekannt) wurde urspr\xFCnglich im zweiten Jahrhundert v. Chr. errichtet, um einen schwachen Punkt in der Stadtverteidigung zu st\xE4rken. Sie wurde in den folgenden Jahrhunderten zahlreiche Male zerst\xF6rt und wieder aufgebaut. Seit 1989 befindet sich hier ein faszinierendes Museum mit einer Ausstellung zur Geschichte Jerusalems. Sie sollten sich au\xDFerdem den hervorragenden Blick von den Mauern \xFCber Jerusalem nicht entgehen lassen.\n            <br/>\n             Adresse: Jaffator, Christliches Viertel, Altstadt<br/>\n            Tel.: +972-2-626-5333<br/>\n            \xD6ffnungszeiten: So - Do: 10:00 Uhr - 16:00 Uhr, Fr: Geschlossen, Sa: 10:00 Uhr - 14: 00 Uhr (September - Juni), So - Do: 10:00 Uhr - 17:00 Uhr, Fr: 10:00 Uhr - 14:00 Uhr, Sa: 10:00 Uhr - 17:00 Uhr (Juli - August)\n\n          </p>\n\n          <h3>\n              DAVIDSSTADT\n          </h3>\n\n          <p>\n            Tief unter den Fundamenten des arabischen Dorfes Silwan befinden sich die Ruinen der ehemals pr\xE4chtigen Zitadelle, in der eine Dynastie j\xFCdischer K\xF6nige ihren Sitz hatte. Das enorme Besucherzentrum bietet eine Tour an, die an einem Aussichtspunkt mit Blick \xFCber die \xDCberreste des historischen Jerusalem beginnt, dann unter die Erde zu den neuen arch\xE4ologischen Funden f\xFChrt und bei der Quelle Gihon endet, an der den \xDCberlieferungen zufolge Salomo zum K\xF6nig gekr\xF6nt wurde. Besucher k\xF6nnen auch durch das Wasser des 2.700 Jahre alten Hiskiatunnels waten\n            <br/>\n            Adresse: Silwan, Ost-Jerusalem<br/>\n            Tel.: +972-2-626-2341<br/>\n            \xD6ffnungszeiten: So - Do: 8:00 Uhr \u2013 17:00 Uhr (Winter), 8:00 Uhr \u2013 19:00 Uhr (Sommer), Fr: 8:00 Uhr \u2013 13:00 Uhr (Winter), 8:00 Uhr \u2013 15:00 Uhr (Sommer)\n\n\n          </p>\n\n\n          <h3>\xD6LBERG</h3>\n          <p>\n          Der \xD6lberg ist ein H\xFCgel, der sich im Osten der Altstadt erhebt und einen gro\xDFartigen Ausblick auf die Altstadt und den Felsendom bietet. Entlang seiner H\xE4nge liegen zahlreiche Heiligt\xFCmer, Begr\xE4bnisst\xE4tten und einige gro\xDFe Kirchen, unter anderem die Kirche aller Nationen. Um alle Sehensw\xFCrdigkeiten genie\xDFen zu k\xF6nnen, beginnt man am besten ganz oben in der N\xE4he der Himmelfahrtsmoschee und geht zu Fu\xDF h\xFCgelabw\xE4rts zum Mariengrab. Der Ausblick auf die Altstadt ist morgens am besten.\n          <br/>\n          Adresse: \xD6lberg, Ost-Jerusalem\n          </p>\n\n          <h3>YEMIN MOSHE </h3>\n          <p>\n          Dieses charmante Viertel entlang der alten Stadtmauer wurde urspr\xFCnglich erreichtet, um die \xDCberbev\xF6lkerung im 19. Jahrhundert aufzufangen. Es ist f\xFCr seine Windm\xFChle und seinen als Mishkenot Shaananim bekannten kommunalen Wohnblock bekannt, der heute als Kunst- und Kulturveranstaltungsort genutzt wird. Das Viertel ist bei K\xFCnstlern, Schriftstellern und Akademikern beliebt und ber\xFChmt f\xFCr seine im orientalischen Stil errichteten H\xE4user, gr\xFCnen Parks, ein Musik-Zentrum, das YMCA, das King David Hotel und das Grabmal der Herod-Familie.\n          </p>\n\n          <h3>STADTZENTRUM </h3>\n          <p>\n          MAMILLA ALROV AVENUE\n          Die Mamilla Alrov Avenue ist eine zwischen dem Stadtzentrum und der Altstadt gelegene Fu\xDFg\xE4ngerzone mit Luxusgesch\xE4ften und eleganten Restaurants und Cafes. Die Mamilla ist f\xFCr ihren Schick und die geschmackvolle europ\xE4ische Atmosph\xE4re bekannt und bietet einen spektakul\xE4ren Ausblick auf die Mauern der Altstadt.\n           <br/>Adresse: 6 Yitzhak Kariv Street, Jerusalem<br/>\n          Tel.: +972-2-636-0000<br/>\n          \xD6ffnungszeiten: So - Do: 10:00 Uhr \u2013 21:30 Uhr (Winter), 10:00 Uhr \u2013 22:30 Uhr (Sommer), Fr: 9:00 Uhr \u2013 14:00 Uhr (Winter), 9:30 Uhr \u2013 15:30 Uhr (Sommer), Sa: Eine Stunde nach Sabbat \u2013 23.00 Uhr\n          </p>\n          <h3>BEN YEHUDA STREET </h3>\n          <p>Einer der beliebtesten Treffpunkte in Jerusalem f\xFCr Einheimische und Touristen gleicherma\xDFen. Die Ben Yehuda Street ist eine Fu\xDFg\xE4ngerzone zwischen der King George Street und der Jaffa Road im Stadtzentrum von Jerusalem. Die Stra\xDFe wird von zahllosen Geschenkartikell\xE4den, Falafel- und Eisverk\xE4ufern, Stra\xDFenmusikanten, Bettlern und Stra\xDFenk\xFCnstlern belebt. </p>\n\n          <h3>NACHALAT SHIVA </h3>\n          <p>Dieses charmante Kopfsteinpflasterviertel s\xFCdlich der Ben Yehuda Street im Stadtzentrum bietet eine gro\xDFe Auswahl an L\xE4den, Restaurants, Bars und Stra\xDFencaf\xE9s. Hier l\xE4sst sich das lebhafte Treiben der Stadt im Sommer und bis sp\xE4t in die Nacht genie\xDFen. </p>\n\n          <h3>MEAH SHEARIM </h3>\n          <p>Obwohl sie nur wenige Minuten zu Fu\xDF von der modernen Ben Yehuda Street liegt, f\xFChlt sich die ultraorthodoxe Enklave von Mea Shearim wie eine andere Welt an. Durch den Anblick der orthodoxen Juden in vollst\xE4ndiger traditioneller Kleidung mit langen schwarzen M\xE4nteln, schwarzen Fellh\xFCten und Str\xFCmpfen werden Sie sich f\xFChlen, als w\xE4ren Sie in das Europa des 18. Jahrhunderts getreten. Bei Besuchen sollten Sie ich sehr zur\xFCckhaltend kleiden, so dass Sie bis zu den Handgelenken und Kn\xF6cheln bedeckt sind, und Fotos diskret aufnehmen.\n          Adresse: Meah Shearim Road, Jerusalem</p>\n\n          <h3>Mahane Yehuda-Markt </h3>\n          <p>H\xE4ufig als \u201Eder Shuk\u201C bezeichnet, bietet der Mahane Yehuda-Markt eine riesenhafte Auswahl frischer Feldfr\xFCchte und Lebensmittel und eine Vielzahl anderer L\xE4den z. B. f\xFCr Bekleidung, K\xFCchenartikel, Schmuck, Keramik und hochwertige Speiselokale. Der Shuk umfasst einen Freiluft- und einen geschlossenen Bereich, grenzt auf der einen Seite an die Jaffa Road und auf der anderen Seite an die gesch\xE4ftige Agripas Street an. Es lohnt sich, mit \xF6ffentlichen Verkehrsmitteln zum Shuk zu fahren, weil Parkpl\xE4tze knapp sind und der Verkehr sehr dicht ist. Wenn Ihnen Gedr\xE4nge kein Problem bereitet, gehen Sie am Freitag, um das Gewimmel der letzten Eink\xE4ufe vorm Sabbat zu erleben.\n          Adresse: Agripas Street und Jaffa Street, Jerusalem</p>\n\n          <h3>\n              ANDERE BEREICHE IN JERUSALEM\n           </h3>\n\n          <h3>\n             YAD VASHEM\n          </h3>\n          <p>\n              In Yad Veshem, der nationalen Holocaust-Gedenkst\xE4tte Israels, wird den sechs Millionen von den Nazis und deren Alliierten ermordeten M\xE4nnern, Frauen und Kindern gedacht. Am Fu\xDF des Herzlbergs gelegen, umfasst Yad Vashem mehrere bewegende Gedenkst\xE4tten, wie die Halle der Erinnerung und das beklemmende Denkmal der Kinder, das Holocaust-Geschichtsmuseum, das Museum der Holocaust-Kunst, Skulpturen und Installationen, ein riesiges Archiv und ein Forschungsinstituts. Achten Sie auf angemessene Kleidung und nehmen Sie sich mindestens ein paar Stunden f\xFCr den Museumsbesuch Zeit. Adresse: Har Hazikaron\n              Tel.: +972-2-644-3400\n          </p>\n          <h3>\n               ISRAEL-MUSEUM\n          </h3>\n          <p>\n              F\xFCr die gr\xF6\xDFte Kulturinstitution Israels, das im Sommer nach einer gro\xDFen Modernisierung wieder er\xF6ffnete Israel-Museum, wollen Sie sich mindestens einen Tag reservieren. Das Museum besteht aus mehreren unterschiedlichen Trakten und einer riesigen Kunstsammlung, arch\xE4ologischen Funden und Judaica. Eines der wichtigsten Highlights ist der einzigartig gestaltete Schreib des Buches, der zahlreiche uralte Manuskripte wie die Schriftrollen vom Toten Meer beherbergt. Weitere H\xF6hepunkte sind der Jugendtrakt f\xFCr Kinder, der Billy Rose Art Garden, in dem die Entwicklung der westlichen Bildhauerei im Laufe der Jahrhunderte pr\xE4sentiert wird, der Trakt der feinen K\xFCnste des Museums und sein Arch\xE4ologietrakt.\n          </p>\n\n         "};}},{id:14,ctg:"telaviv",isVid:true,vidId:"XDei1Zy_cu4",bgImage:"/posts/bank/17/1.jpg",mobBgImage:"/posts/bank/17/M.jpg",title:"Die Stra Die Strande Von Tel Aviv",smltitle:"",html:function html(){return{__html:"\n\t\t\t\t<h2>Packen Sie Ihren Sonnenschutz ein, schnappen Sie sich die Softball-Schl\xE4ger, und auf geht's zum Strand</h2>\n\t\t\t\t\t<!--<div class=\"responisve-iframe\">\n\t\t\t\t\t\t<iframe src=\"https://www.youtube.com/embed/XDei1Zy_cu4/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1\" height=\"315\" width=\"560\" allowfullscreen=\"\" frameborder=\"0\"></iframe>\n\t\t\t\t\t</div>-->\n\t\t\t\t\t<p>\n                          Tel Aviv r\xFChmt sich mit einer langen Promenade die der K\xFCste entlang verl\xE4uft und die westliche Grenze der Stadt bildet. Leute spazieren, joggen, fahren Fahrrad, oder sitzen auf B\xE4nken und genie\xDFen die frische Luft. Und das alles, auf weitl\xE4ufigen 14 Kilometern mit fantastischer Aussicht, blauem Horizont und wei\xDFen Segeln, die auf den Wellen schaukeln.\n                          <br/>\n                          Dutzende von Restaurants, Caf\xE9s und Eisdielen sind den ganzen Tag lang gut besucht, w\xE4hrend Pubs, Diskotheken und Jazz-Clubs nach Einbruch der Dunkelheit aufbl\xFChen. Hier ist \u2013 v\xF6llig unabh\xE4ngig von der Uhrzeit \u2013 immer etwas los. Clowns, Karikaturisten, T\xE4towierer, Haar-Flechter, Zauberer und nat\xFCrlich der st\xE4ndig wechselnde Fluss von Menschen, die an den nahe gelegenen Str\xE4nden spazieren gehen, laden zum Verweilen ein.\n                          <br/>\n                          Direkt an der Promenade finden Sie sauberen Sand, Liegest\xFChle, Eisverk\xE4ufer, und ganzjahres Badeurlauber, die t\xE4glich hier schwimmen gehen, ganz egal ob Winter oder Sommer, da komme was wolle. Jeder von Tel Avivs 13 sch\xF6nen Str\xE4nden verf\xFCgt \xFCber einzigartige Eigenschaften und bietet eine Vielzahl von Dienstleistungen, einschlie\xDFlich Kiosken, Restaurants, Kinderspielpl\xE4tzen, Open-Air Fitness-Studios, Rettungsposten und vieles mehr.\n                          <br/>\n                          Ein paar Tipps\n                      </p>\n\n                      <div class=\"img-wrapper\">\n                          <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/13/2.jpg")+" class=\"img-responsive\" />\n                      </div>\n\n                      <h3>\n                           Ein paar Tipps\n                      </h3>\n                      <ul>\n                              <li>Freitagnachmittags k\xF6nnen Sie am Dolfinarium Beach bei einem improvisierten Trommel-Festival und Capoeira, einer brasilianischen Kombination aus Kampfkunst, Tanz und Musikmitmachen.</li>\n                              <li>Gordon Beach ist gro\xDFartig f\xFCr Volleyball.</li>\n                              <li>F\xFCr religi\xF6se Besucher gibt es am Hof Hadatiyim (Nordau Beach), s\xFCdlich vom Tel Aviv Hafen, geschlechterspezifische Schwimmzeiten. Frauen und M\xE4dchen baden hier sonntags, dienstags und donnerstags, w\xE4hrend M\xE4nner und Jungen montags, mittwochs und freitags das Wasser genie\xDFen k\xF6nnen. Beide Geschlechter sind am Samstag willkommen.</li>\n                              <li>Die Schwulen- und Lesbencommunity zieht es f\xFCr gew\xF6hnlich zum Standabschnitt vor dem Hilton Hotel, was ihm den inoffiziellen Titel als schwulenfreundlichster Strand der Stadt eingebracht hat.</li>\n                              <li>Der schmale Sandstreifen in der N\xE4he der Marina ist weniger \xFCberf\xFCllt und ruhiger als die anderen Str\xE4nde. Am Yachthafen k\xF6nnen Sie Windsurfbretter, Surfbretter, Segelboote, Motorboote und Tauchausr\xFCstung ausleihen.</li>\n                              <li>Surfen ist sehr beliebt am Hilton Beach, wo vor kurzem ein spezielles Lichtsystem installiert wurde, um Surfen auch nachts m\xF6glich zu machen.</li>\n                              <li>Kiteboarden ist am Aviv Beach beliebt.</li>\n                              <li>Zum Windsurfen geht man zum Dolfinarium Beach.</li>\n                              <li>Volleyball kann man am Aviv Beach und am Gordon Beach spielen.</li>\n                              <li>Die Str\xE4nde der Stadt sind gro\xDFz\xFCgig mit Umkleidekabinen, Duschen und Toiletten ausgestattet. Rettungsschwimmer sind w\xE4hrend der Badesaison (Mai-Oktober) im Dienst und eine Touristenpolizei steht bereit um Sicherheit, Unterst\xFCtzung und Informationen zu bieten.</li>\n                      </ul>\n\n                      <h3>\n                           Lustiges und Interessantes\n                      </h3>\n\n                      <ul>\n                            <li>8,500,000 Badeg\xE4ste kommen j\xE4hrlich an die Str\xE4nde.</li>\n                            <li>Die offizielle Badesaison geht von Mai-Oktober.</li>\n                            <li>Es gibt 13 Str\xE4nde entlang der K\xFCste von Tel Aviv-Jaffa</li>\n                            <li>Vier Str\xE4nde sind f\xFCr Menschen mit Einschr\xE4nkungen zug\xE4nglich: Tzuk, Northern Tzuk, Metzizim und Hilton (alle im n\xF6rdlichen Teil der Stadt).</li>\n                            <li>Die Str\xE4nde von Tel Aviv-Jaffa belegen hohe R\xE4nge in den Tests des israelischen Ministeriums f\xFCr Umwelt und werden als sehr sauber angesehen.</li>\n                            <li>Eine israelische Version von Racquetball, <a href=\"//www.gomatkot.com/the-game/\" target=\"_blank\">Matkot</a> genannt, ist ein beliebter Sport der auf vielen Str\xE4nden gespielt wird (passen Sie auf Ihren Kopf auf!).</li>\n                            <li>Wassermelone mit Fetak\xE4se ist ein sehr beliebter Strandsnack. Artikim, oder Eis am Stiel, sind ebenfalls beliebt, wobei das Eis mit Banane-Schokolade-Geschmack bei den meisten Leuten den Top-Platz einnimmt.</li>\n                      </ul>\n                      <h3>\n                            Strand-Richtlinien\n                      </h3>\n\n                      <ul>\n                            <li>Badeg\xE4ste m\xFCssen sich an die Anweisungen der Rettungsschwimmer und Rettungswachen halten.</li>\n                            <li>Baden an Str\xE4nden ohne Rettungsdienst ist verboten.</li>\n                            <li>Das Baden im Meer ist untersagt, wenn die schwarze Flagge gehisst wurde.</li>\n                            <li>Die Aus\xFCbung JEGLICHEN Motorsports (Jet Skis, Boote) ist untersagt.</li>\n                            <li>Motorisierte Fahrzeuge sind sowohl auf dem Strand wie auch auf der Promenade untersagt.</li>\n                            <li>Die Errichtung von Lagerfeuern am Strand ist untersagt.</li>\n                      </ul>\n\n\n\n                      <h3>\n                           Badesaison\n                      </h3>\n\n                      <div class=\"img-wrapper\">\n                            <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/13/3.jpg")+" class=\"img-responsive\" />\n                      </div>\n\n                      <p>\n                            W\xE4hrend der gesamten Badesaison stehen Rettungsdienste, Badeaufsicht und Erste Hilfe an den folgenden Str\xE4nden zur Verf\xFCgung: North Beach Cliff, South Beach Cliff, Tel Baruch Beach, Hilton Beach, Gordon Beach, Frishman Beach, Borgashov Beach (Er\xF6ffnung auf Grund von Renovierungsarbeiten verz\xF6gert), Jerusalem Beach, Charles Clore Beach, Givat Aliyah Beach.\n                      </p>\n                      <h3>\n                            Betriebszeiten:\n                      </h3>\n                      <p>\n                           9-31 Mai: 7:00-17:00 <br/>\n                          Juni: 7:00-18:00<br/>\n                          Juli-August: 7:00-19:00<br/>\n                          September-Oktober: 7:00-17:00\n                          <br/>\n                          Inspektionen und Reinigungsdienste werden an allen oben genannten Str\xE4nden von 7:00 bis in die Abendstunden verf\xFCgbar gemacht.\n                      </p>\n                      <h3>\n                           Die Preisliste der Str\xE4nde ist:\n                      </h3>\n                      <p>\n                            Pita oder Brot mit Hummus oder Salat \u2013 12 NIS <Br/>\n                            Kleine Flasche Mineralwasser \u2013 7 NIS<Br/>\n                            Eis am Stiel \u2013 5 NIS<Br/>\n                            Strandliege f\xFCr den gesamten Tag \u2013 12 NIS<Br/>\n                            Strandstuhl f\xFCr den gesamten Tag \u2013 6 NIS<Br/>\n                            Sonnenschirm f\xFCr den gesamten Tag \u2013 6 NIS<Br/>\n                      </p>\n\n         "};}},{id:19,bgImage:"/posts/bank/39/1.jpg",mobBgImage:"/posts/bank/39/M.jpg",ctg:"jerusalem",isVid:true,vidId:"TeLJmRatQeM",title:"Modern und lebendig",smltitle:"",html:function html(){return{__html:"\n                   <h2>Es gibt so viel zu sehen in Jerusalems pulsierendem Stadtzentrum</h2>\n                   <!--<div class=\"responisve-iframe\">\n\t\t\t\t\t\t<iframe src=\"https://www.youtube.com/embed/TeLJmRatQeM/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1\" height=\"315\" width=\"560\" allowfullscreen=\"\" frameborder=\"0\"></iframe>\n\t\t\t\t\t</div>-->\n\n\t\t\t\t\t<p>\n\t\t\t\t\t\t\tDie Innenstadt von Jerusalem ist das Herz der modernen Metropole, voller Nachtleben, Restaurants und kulturellen M\xF6glichkeiten, die es mit jeder gr\xF6\xDFeren Stadt der Welt aufnehmen k\xF6nnen.\n\t\t\t\t\t          </p>\n\t\t\t\t\t          <p>\n\t\t\t\t\t\t\t\t\t\t\t\tDie Gegend besteht aus mehreren Stadtvierteln und den angesagtesten Orten, wie dem charmanten Nachlat Shiva, der belebte Yafo Stra\xDFe und der Ben Yehuda Stra\xDFe mit ihrer einzigartigen Pers\xF6nlichkeit und Atmosph\xE4re, die man nicht verpassen sollte.\n\t\t\t\t\t          </p>\n\t\t\t\t\t          <p>\n\t\t\t\t\t\t\t\t\t\t\t\tDas Zentrum von Jerusalem umfasst einige der charmantesten Viertel der Stadt und faszinierende Sehensw\xFCrdigkeiten. F\xFCr eine unschlagbare kulturelle Erfahrung, sehen Sie sich Jerusalems faszinierende Museen an, darunter das weltber\xFChmte Israel Museum, das Bible-Land-Museum und  Wissenschafts Museum.\n\t\t\t\t\t          </p>\n\t\t\t\t\t          <h3>\n\t\t\t\t\t\t\t\t\t\t\t\tMachane Yehuda Market\n\t\t\t\t\t          </h3>\n\t\t\t\t\t          <p>\n\t\t\t\t\t\t\t\t\t\t\t\tEntdecken Sie die unvergleichliche Atmosph\xE4re und Vielfalt dieses Marktes, die jeden Tag Tausende von Touristen anzieht. Sobald die Eink\xE4ufe erledigt sind und die Verk\xE4ufer die L\xE4den zumachen, treffen sich den jungen trendigen Menschen, sowohl aus dem Ausland als auch aus der Region, die auf den Markt kommen, um bis in die fr\xFChen Morgenstunden in den Bars, Restaurants und Gassen zu trinken und zu feiern.\n\t\t\t\t\t          </p>\n\t\t\t\t\t          <h3>\n\t\t\t\t\t\t\t\t\t\t\t\tNahalat Shiv\u2019a\n\t\t\t\t\t          </h3>\n\t\t\t\t\t          <p>\n\t\t\t\t\t\t\t\t\t\t\t\tDieses charmante gepflasterte Viertel im Herzen der Stadt bietet eine exzellente Auswahl an Gesch\xE4ften, Restaurants, Bars und Stra\xDFencaf\xE9s an. Nahalat Shiva ist die Heimat von Kikar Hamusica (Musikplatz)- ein lebhafter und trendiger Platz im Freien, wo jeden Tag w\xE4hrend der Woche Live-Musik spielt.\n\t\t\t\t\t          </p>\n\t\t\t\t\t          <h3>\n\t\t\t\t\t\t\t\t\t\t\t\tYemin Moshe\n\t\t\t\t\t          </h3>\n\t\t\t\t\t          <p>\n\t\t\t\t\t\t\t\t\t\t\t\tDieses sch\xF6ne Viertel mit Blick auf die alten Stadtmauern wurde urspr\xFCnglich im 19. Jahrhundert erbaut, um dem Problem der \xDCberf\xFCllung entgegenzuwirken. Yemin Moshe, Heimat von K\xFCnstlern, Schriftstellern und Akademikern, ist bekannt f\xFCr seine sch\xF6nen Windm\xFChlen und H\xE4user im orientalischen Stil, gr\xFCne Parks, lebhaftes Musikzentrum und atemberaubende Ausblicke.\n\t\t\t\t\t          </p>\n\t\t\t\t\t          <h3>\n\t\t\t\t\t\t\t\t\t\t\t\tEin Kerem\n\t\t\t\t\t          </h3>\n\t\t\t\t\t          <p>\n\t\t\t\t\t\t\t\t\t\t\t\tIn einem friedlichen Tal zwischen den Bergen und den terrassierten H\xFCgeln s\xFCdwestlich von Jerusalem gelegen, ist Ein Kerem eines der malerischsten Viertel von Jerusalem. Mit ihren verwinkelten, gepflasterten Gassen, ihren charmanten Steinh\xE4usern, die mit B\xF6gen geschm\xFCckt sind, Kirchen, deren Glocken in der klaren Luft l\xE4uten, strahlt Ein Kerem Charme und Sch\xF6nheit aus, wie eine Insel in einem Meer aus gr\xFCnem Wald.\n\t\t\t\t\t          </p>\n\n         "};}},{id:18,bgImage:"/posts/bank/38/1.jpg",mobBgImage:"/posts/bank/38/M.jpg",ctg:"jerusalem",isVid:true,vidId:"k4OwoEk5wMw",title:"Absolutes 'Muss' in Jerusalem",smltitle:"",html:function html(){return{__html:"\n\t\t\t\t<h2>5 Top-Dinge zu tun und zu sehen in der atemberaubenden Stadt</h2>\n\t\t\t\t\t<!--<div class=\"responisve-iframe\">\n\t\t\t\t\t\t<iframe src=\"https://www.youtube.com/embed/k4OwoEk5wMw/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1\" height=\"315\" width=\"560\" allowfullscreen=\"\" frameborder=\"0\"></iframe>\n\t\t\t\t\t</div>-->\n\t\t\t\t\t<h3>\n\t\t\t\t\t\t\t\t\t                Segway-Touren\n\t\t\t\t\t\t\t\t\t          </h3>\n\t\t\t\t\t\t\t\t\t          <p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tDiese adrenalingeladene Art, die Stadt zu sehen, erlaubt es Ihnen, die Sch\xF6nheit Jerusalems aus einer ganz eigenen Perspektive zu betrachten. Die Segway-Touren starten von verschiedenen zentralen Orten aus, einschlie\xDFlich des Armon HaNatziv Promenade (Ost-Talpiot), Yemin Moshe und die Altstadt, sowie in der N\xE4he die Knesset und der Museumsbereich.\n\t\t\t\t\t\t\t\t\t          </p>\n\t\t\t\t\t\t\t\t\t          <h3>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tDie erste Station (Hatachana)\n\t\t\t\t\t\t\t\t\t          </h3>\n\t\t\t\t\t\t\t\t\t          <p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tDie Erste Station befindet sich im Herzen von Jerusalem, zwischen der Altstadt und dem Stadtzentrum, zwischen den historischen Vierteln der deutschen Kolonie und Yemin Moshe. Es ist der Standort des ersten Bahnhofs in Jerusalem, der im Jahr 1892 gebaut wurde. Nach der Renovierung und Konservierung, die Erste Station wurde als lebhafter Unterhaltungsort wiederer\xF6ffnet, der sieben Tage die Woche ge\xF6ffnet ist.\n\t\t\t\t\t\t\t\t\t          </p>\n\t\t\t\t\t\t\t\t\t          <h3>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tDer Zeit-Aufzug\n\t\t\t\t\t\t\t\t\t          </h3>\n\t\t\t\t\t\t\t\t\t          <p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tWenn Sie ein Fan von Vergn\xFCgungsfahrten sind, werden Sie es lieben, Ihre Sinne durch den Zeit-Aufzug zu verwirren. Es ist ein interaktives Erlebnis, das die Besucher auf fabelhafte Reisen zu faszinierenden Orten bringt, in einer einzigartigen Halle der mit beweglichen Sitzen und mit zahlreichen Spezialeffekten ausgestattet ist.\n\t\t\t\t\t\t\t\t\t          </p>\n\t\t\t\t\t\t\t\t\t          <h3>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tDer biblische Zoo\n\t\t\t\t\t\t\t\t\t          </h3>\n\t\t\t\t\t\t\t\t\t          <p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tDieser sch\xF6ne zweist\xF6ckige Zoo erstreckt sich \xFCber 62 Hektar und liegt an einem riesigen k\xFCnstlichen See mit Wasserf\xE4llen und seitlichen Pools, umgeben von weitl\xE4ufigen Rasenfl\xE4chen und schattigen Rastpl\xE4tzen. Zur Freude der Kinder und Erwachsene,  dort leben \xFCber 200 Tierarten, von denen die meisten in der Bibel erw\xE4hnt und in der Zwischenzeit fast ausgestorben sind.\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tDies bedeutet nicht, dass normale Tiere nicht anwesend sind, sie haben sogar Pinguine hier. In der N\xE4he des Zoos befindet sich ein sch\xF6nes, riesiges und eindrucksvolles Aquarium, das tags\xFCber und abends f\xFCr Besucher ge\xF6ffnet ist und Unterwasserwelt des Mittelmeers, Rotes Meer und noch mehr, darstellt.\n\t\t\t\t\t\t\t\t\t          </p>\n\t\t\t\t\t\t\t\t\t          <h3>\n\t\t\t\t\t\t\t\t\t                Teddy Park\n\t\t\t\t\t\t\t\t\t          </h3>\n\t\t\t\t\t\t\t\t\t          <p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tBenannt nach Teddy Kollek, der von 1965-1995 B\xFCrgermeister von Jerusalem war; Teddy Park ist lustig, sch\xF6n und historisch bedeutsam. Der Park ist ein bedeutender Treffpunkt zwischen dem Alten und Neuen Jerusalem und beinhaltet einen Wunschteich, eine beeindruckende Sonnenuhr Originalskulptur, sanierte historische Geb\xE4ude und eine fantastische Wasserbrunnenattraktion mit einer spektakul\xE4ren Licht- und Musik-Abendshow.\n\t\t\t\t\t\t\t\t\t          </p>\n\n         "};}},{id:"Die_Wuste_Negev",bgImage:"/posts/bank/34/1.jpg",ctg:"eilat",isVid:true,vidId:"yXzhH92kREg",mobBgImage:"/posts/bank/34/M.jpg",title:"DIE WÜSTE NEGEV",smltitle:"",html:function html(){return{__html:"\n                      <h2>Ein zauberhafter Ort</h2>\n\t\t\t\t\t<!--<div class=\"responisve-iframe\">\n\t\t\t\t\t\t<iframe src=\"https://www.youtube.com/embed/yXzhH92kREg/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1\" height=\"315\" width=\"560\" allowfullscreen=\"\" frameborder=\"0\"></iframe>\n\t\t\t\t\t</div>-->\n\t\t\t\t\t<h3 class=\"negev-secondary-title\">\n\t\t\t\t\t\t\t\tDie W\xFCste Negev - ein zauberhafter Ort\n\t\t\t\t\t\t\t</h3>\n\n\n\t\t\t\t\t\t\t\n\n\n                            <!--negev text-->\n\n\t\t\t\t\t\t      <p>\n\t\t\t\t\t\t             Die israelische W\xFCste mit ihrer atemberaubenden Landschaft und verschiedenen Sehensw\xFCrdigkeiten bietet den perfekten Ort f\xFCr einen Urlaub. In der Negev finden Besucher zahlreiche M\xF6glichkeiten f\xFCr viele spannende Erlebnisse.\n\t\t\t\t\t\t      </p>\n\t\t\t\t\t\t      <p>\n\t\t\t\t\t\t             Israel ist ein kleines Land, 62% der Gesamtfl\xE4che nimmt davon der Negev ein. Das r\xF6tliche schimmerndes W\xFCstengebiet wird von vielen beeindruckenden geologischen Felsformationen gepr\xE4gt. Die Besucher genie\xDFen hier einen einzigartigen Blick auf eine unber\xFChrte Weite - still und majest\xE4tisch.\n\t\t\t\t\t\t      </p>\n\t\t\t\t\t\t      <p class=\"p-margin\">\n\t\t\t\t\t\t             Spuren von vergangener Zivilisationen und ihrer Landwirtschaft sowie arch\xE4ologische St\xE4tten finden sich \xFCberall. Die Negev bildet einen unverwechselbaren Hintergrund f\xFCr die Begegnung mit den Nomadenst\xE4mmen - dem Volk der W\xFCste.\n\t\t\t\t\t\t      </p>\n\n\t\t\t\t\t\t      <h2>\n\t\t\t\t\t\t             Gr\xFCnde, warum die W\xFCste Israels so besonders ist:\n\t\t\t\t\t\t      </h2>\n\n\t\t\t\t\t\t      <ul class=\"p-margin\">\n\t\t\t\t\t\t             <li>\n\t\t\t\t\t\t                  <b> Die W\xFCste liegt ganz in der N\xE4he:</b> nur 4 Flugstunden von Europa entfernt. Israel hat zwei internationale Flugh\xE4fen - Ben Gurion und Ovda, die allen Reisenden einen kurzen Trip in die W\xFCste garantieren (eine Stunde bis 90 Minuten).\n\t\t\t\t\t\t                  Ab November gibt es mehrere Direktfl\xFCge von Europa und Russland nach Ovda, z. B. mit Monarch, Ryanair, Wizzair und SAS.\n\t\t\t\t\t\t             </li>\n\t\t\t\t\t\t             <li>\n\t\t\t\t\t\t                  <b> Leichte Wanderung und radeln. :</b> In der W\xFCste gibt es viele markierte Wege. In Israel gibt es einige der eindrucksvollsten Wanderwege der Welt und Hunderte von sicheren Routen f\xFChren durch die israelische W\xFCste. Eine Auswahl von Wanderwegen finden sie auf den folgenden Websites:<br>\n\t\t\t\t\t\t                  <a href=\"//www.negevtour.co.il\" target=\"_blank\">www.negevtour.co.il</a>\n\t\t\t\t\t\t             </li>\n\t\t\t\t\t\t             <li>\n\t\t\t\t\t\t                  <b>Freundliche Bev\xF6lkerung:</b> Die W\xFCstenbewohner sind sehr gastfreundlich und machen das W\xFCstenerlebnis angenehm und spannend f\xFCr alle Besucher.\n\t\t\t\t\t\t             </li>\n\t\t\t\t\t\t             <li>\n\t\t\t\t\t\t                  <b> Aktivit\xE4ten f\xFCr Touristen:</b> Zusammen mit der Entwicklung von Unterk\xFCnften hat ein enormes Angebot touristischer Aktivit\xE4ten die Negev in den letzten Jahren zu einem beliebten, interessanten, vielseitigen und kreativen Reiseziel gemacht.\n\t\t\t\t\t\t             </li>\n\t\t\t\t\t\t             <li>\n\t\t\t\t\t\t             <b> Herrliche Landschaften:</b> Heute genie\xDFen zahlreichen Touristen den Charme der Negev-W\xFCste mit ihren vielf\xE4ltigen Landschaften <br>\n\t\t\t\t\t\t      <ul>\n\t\t\t\t\t\t             <li>\n\t\t\t\t\t\t                   Im Norden gibt es spektakul\xE4re Sandd\xFCnen.\n\t\t\t\t\t\t             </li>\n\t\t\t\t\t\t             <li>\n\t\t\t\t\t\t                   Im Zentrum liegt der Ramon-Krater mit seinen rauen Klippen und saisonalen Wasserquellen.\n\t\t\t\t\t\t             </li>\n\t\t\t\t\t\t             <li>\n\t\t\t\t\t\t                   Im Osten erlebt man die afrikanische W\xFCste mit weiten Savannen und Akazien \xFCberall.\n\t\t\t\t\t\t             </li>\n\t\t\t\t\t\t             <li>\n\t\t\t\t\t\t                   Und im S\xFCden findet man roten und schwarzen Granit, der mit dem Sandstein des Vorgebirges angenehme Farbspiele bildet.\n\t\t\t\t\t\t             </li>\n\t\t\t\t\t\t      </ul>\n\t\t\t\t\t\t             Bei einer ca. 3-st\xFCndigen Fahrt durch die W\xFCste k\xF6nnen sie das gesamte Spektrum der W\xFCstenlandschaft erleben und ihre Vielfalt genie\xDFen die man in anderen W\xFCsten oft nur mit einer langen Reise von mehreren Kilometern erlebt.\n\t\t\t\t\t\t             Viele Touristen entscheiden sich, 2 bis 3 Tage in der Negev-Region zu verbringen.\n\n\t\t\t\t\t\t      </li>\n\t\t\t\t\t\t            <li>\n\t\t\t\t\t\t                 <b> Der Negev ist sehr sicher zu reisen.</b> Die Rettungsteams, die bei Notf\xE4llen in der Region vor Ort sind, geh\xF6ren zu den am besten ausgebildeten Rettungskr\xE4ften der Welt und sind immer in der N\xE4he. Sollte jemand medizinische Hilfe ben\xF6tigen, bietet Israel hochwertige, erstklassige westliche medizinische Dienstleistungen an.\n\t\t\t\t\t\t            </li>\n\t\t\t\t\t\t      </ul>\n\t\t\t\t\t\t      <h2>\n\t\t\t\t\t\t            Weitere Informationen und Hinweise f\xFCr \xDCbernachtungen und sonstige Empfehlungen:\n\t\t\t\t\t\t      </h2>\n\t\t\t\t\t\t     \n\t\t\t\t\t\t      <p>\n\t\t\t\t\t\t           <a href=\"//www.negevtour.co.il/homepage/accommodation/?lang=en\" target=\"_blank\">www.negevtour.co.il</a><br>\n\t\t\t\t\t\t           <a href=\"https://en.aravaway.co.il/business/category/1/\" target=\"_blank\">www.en.aravaway.co.il</a>\n\t\t\t\t\t\t      </p>\n\n\n\n\n                            <!--Negev - Transportations-->\n\n\t\t\t\t\t\t\t  <h3>\n\t\t\t\t\t\t            NEGEV \u2013 STANDORT UND ANFAHRT\n\t\t\t\t\t\t      </h3>\n\t\t\t\t\t\t      <p class=\"p-margin\">\n\t\t\t\t\t\t            Landung auf den Flugh\xE4fen von Ovda oder Eilat mit der Weiterreise nach Mitzpe Ramon oder Sde Boker:\n\t\t\t\t\t\t      </p>\n\n\t\t\t\t\t\t      <h2>\n\t\t\t\t\t\t            \xD6ffentliche Verkehrsmittel:\n\t\t\t\t\t\t      </h2>\n\t\t\t\t\t\t      <p>\n\t\t\t\t\t\t            Bus 392 von Eilat nach Mitzpe Ramon und Be'erSheva, h\xE4lt am Flughafen von Ovda am Sonntag um 07:13, 08:41, 09:43, 14:12, 15:41, 17:43.\n\t\t\t\t\t\t      </p>\n\t\t\t\t\t\t      <p>\n\t\t\t\t\t\t            Ankunft am zentralen Busbahnhof von Mitzpe Ramon nach ungef\xE4hr anderthalb Stunden.\n\t\t\t\t\t\t      </p>\n\t\t\t\t\t\t      <p>\n\t\t\t\t\t\t            Montags - Donnerstags um 07:13, 07:41, 09:43, 14:12, 15:41, 17:43.\n\t\t\t\t\t\t      </p>\n\t\t\t\t\t\t      <p class=\"p-margin\">\n\t\t\t\t\t\t            <a href=\"//www.egged.co.il/HomePage.aspx\" target=\"_blank\">Bus service </a><br>\n\t\t\t\t\t\t            <a href=\"//www.egged.co.il/HomePage.aspx\" target=\"_blank\"> Shuttle-Service vom Ovda Flughafen </a>\n\t\t\t\t\t\t      </p>\n\t\t\t\t\t\t      <h2>\n\t\t\t\t\t\t            Autovermietung in Eilat, Mitzpe Ramon und Be'er Sheva:\n\t\t\t\t\t\t      </h2>\n\t\t\t\t\t\t      <p>\n\t\t\t\t\t\t            Mehrere Optionen ein Auto in diesen St\xE4dten zu mieten sind m\xF6glich.\n\t\t\t\t\t\t            Es stehen internationale und israelische Anbieter zur Auswahl.\n\t\t\t\t\t\t      </p>\n\t\t\t\t\t\t      <p class=\"p-margin\">\n\t\t\t\t\t\t            Landung am Ben Gurion International Airport in der N\xE4he von Tel Aviv und Weiterreise nach Negev nach Mashabei Sadeh / Sde Boker / Mitzpe Ramon\n\t\t\t\t\t\t      </p>\n\t\t\t\t\t\t      <h2>\n\t\t\t\t\t\t            \xD6ffentliche Verkehrsmittel:\n\t\t\t\t\t\t      </h2>\n\t\t\t\t\t\t      <p>\n\t\t\t\t\t\t            Buslinien 370/380 von Tel Aviv nach Be'erSheva, Routen 446/470 von Jerusalem nach Be'erSheva.\n\t\t\t\t\t\t      </p>\n\t\t\t\t\t\t      <p>\n\t\t\t\t\t\t            Von Be'erSheva fahren Buslinien 60, 64, 65, 660 jeden Morgen ab 6 Uhr (ca. alle 20 Minuten).\n\t\t\t\t\t\t            Ankunft in Mashabei Sadeh nach 35 Minuten / SdeBoker Gebiet in 55 Minuten / Mitzpe Ramon in 1 Stunde 20 Minuten.\n\t\t\t\t\t\t      </p>\n\t\t\t\t\t\t      <p class=\"p-margin\">\n\t\t\t\t\t\t            Weitere Informationen zu den \xF6ffentlichen Verkehrsmitteln sind unter den folgenden Links vorhanden <a href=\"https://www.bus.co.il/otobusimmvc?Language=en\" target=\"_blank\">here</a> or <a href=\"//www.egged.co.il/HomePage.aspx\">here</a>\n\t\t\t\t\t\t      </p>\n\n\n\n\n\n\n\n                             <!--NEGEV DESERT-don't miss-->\n\n\n                              <h3 class=\"margin-h\">\n\t\t\t\t\t\t            NEGEV STRASSENENFERNUNGEN\n\t\t\t\t\t\t      </h3>\n\t\t\t\t\t\t      <table>\n\t\t\t\t\t\t            <tr>\n\t\t\t\t\t\t      <th></th>\n\t\t\t\t\t\t      <th>Tel Aviv</th>\n\t\t\t\t\t\t      <th>Jerusalem</th>\n\t\t\t\t\t\t      <th>Bee'r Sheva</th>\n\t\t\t\t\t\t      <th>Eilat</th>\n\t\t\t\t\t\t      </tr>\n\t\t\t\t\t\t      <tr>\n\t\t\t\t\t\t      <td class=\"place-table\"> <strong>Old Town <br class=\"auf-Handy-zeigen\"> Beer Sheva</strong></td>\n\t\t\t\t\t\t      <td>113 Km</td>\n\t\t\t\t\t\t      <td>122 Km</td>\n\t\t\t\t\t\t      <td></td>\n\t\t\t\t\t\t      <td>232 Km</td>\n\t\t\t\t\t\t      </tr>\n\t\t\t\t\t\t      <tr>\n\t\t\t\t\t\t      <td class=\"place-table\"><strong>Tel Arad</strong></td>\n\t\t\t\t\t\t      <td>134 Km</td>\n\t\t\t\t\t\t      <td>144 Km</td>\n\t\t\t\t\t\t      <td>40 Km</td>\n\t\t\t\t\t\t      <td>229 Km</td>\n\t\t\t\t\t\t      </tr>\n\t\t\t\t\t\t      <tr>\n\t\t\t\t\t\t      <td class=\"place-table\"><strong>Ben-Gurion's Haus <br class=\"auf-Handy-zeigen\">im Sde Boker</strong></td>\n\t\t\t\t\t\t      <td>162 Km</td>\n\t\t\t\t\t\t      <td>171 Km</td>\n\t\t\t\t\t\t      <td>49 Km</td>\n\t\t\t\t\t\t      <td>185 Km</td>\n\t\t\t\t\t\t      </tr>\n\t\t\t\t\t\t      <tr>\n\t\t\t\t\t\t      <td class=\"place-table\"><strong>Ramon Krater</strong></td>\n\t\t\t\t\t\t      <td>210 Km</td>\n\t\t\t\t\t\t      <td>192 Km</td>\n\t\t\t\t\t\t      <td>97 Km</td>\n\t\t\t\t\t\t      <td>141 Km</td>\n\t\t\t\t\t\t      </tr>\n\t\t\t\t\t\t      <tr>\n\t\t\t\t\t\t      <td class=\"place-table\"><strong>Hai Bar Wildlife <br class=\"show-on-mobile\"> Reservieren Yotvata</strong></td>\n\t\t\t\t\t\t      <td>323 Km</td>\n\t\t\t\t\t\t      <td>288 Km</td>\n\t\t\t\t\t\t      <td>202 Km</td>\n\t\t\t\t\t\t      <td>35 Km</td>\n\t\t\t\t\t\t      </tr>\n\t\t\t\t\t\t      <tr>\n\t\t\t\t\t\t      <td class=\"place-table\"><strong>Timna Park</strong></td>\n\t\t\t\t\t\t      <td>330 Km</td>\n\t\t\t\t\t\t      <td>294 Km</td>\n\t\t\t\t\t\t      <td>208 Km</td>\n\t\t\t\t\t\t      <td>30 Km</td>\n\t\t\t\t\t\t      </tr>\n\t\t\t\t\t\t      </table>\n\n\t\t\t\t\t\t      <h3>\n\t\t\t\t\t\t            DIE W\xDCSTE NEGEV - NICHT VERPASSEN</h3>\n\n\t\t\t\t\t\t      <h2>\n\t\t\t\t\t\t            Ramon Krater\n\t\t\t\t\t\t      </h2>\n\n\t\t\t\t\t\t      <p>\n\t\t\t\t\t\t            Im Herzen der riesigen Negev-W\xFCste Israels liegt der Ramon-Krater, der gr\xF6\xDFte Erosionskrater der Welt, der auch unter dem Namen Machtesch Ramon bekannt ist.\n\t\t\t\t\t\t            Er umfasst eine enorme Gesteinsvielfalt aus fantastischen Farben und Formen und ist ein faszinierendes Naturph\xE4nomen mit einem Ausma\xDF von 40 km L\xE4nge und zwischen 2 bis 10 km Breite. Er hat die Form eines langen Herzens und bildet Israels gr\xF6\xDFten Nationalpark: das Ramon-Naturreservat.\n\t\t\t\t\t\t            Weit weg von den Lichtern und Menschenmassen der Stadt beeindruckt der Ramon-Krater durch seinen mehrfarbigen Sandstein, seinen Vulkanfelsen und Fossilien und wird oft als Israels eigener Grand Canyon bezeichnet.\n\t\t\t\t\t\t            Die wahrhaftig atemberaubende Aussicht vom 300 m hohen Aussichtspunkt des Machtesch Ramon, der an eine Hollywood-Kulisse erinnert, bietet ganzj\xE4hrig ein beeindruckendes Erlebnis f\xFCr Touristen aus der ganzen Welt.\n\t\t\t\t\t\t      </p>\n\n                            <div class=\"img-wrapper img-page3\">\n\t\t\t\t\t\t      <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/7.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t      Bildnachweis: Daphna Tal\n\t\t\t\t\t\t      </div>\n\n\t\t\t\t\t\t      <h2>\n\t\t\t\t\t\t      Timna Park\n\t\t\t\t\t\t      </h2>\n\n\t\t\t\t\t\t      <p>\n\t\t\t\t\t\t      In einem hufeisenf\xF6rmigen Tal, das von steilen Klippen umgeben ist, ist der Timna Park ein atemberaubendes Erlebnis und ein absolutes Muss f\xFCr Wanderfreunde. Hier werden Sie Zeuge der wunderbaren Naturschauspiele, der erstaunlichen Tierwelt, der Pflanzen und B\xE4ume, die in der W\xFCste heimisch sind und unter extremen, trockenen Bedingungen leben.\n\t\t\t\t\t\t      Mit seinen vielen touristischen Attraktionen, bunten Sandstr\xE4nden und schroffen Bergen ist der Timna Park ein unvergleichlicher Besuchermagnet.\n\t\t\t\t\t\t      </p>\n\n\t\t\t\t\t\t      <div class=\"img-wrapper img-page3\">\n\t\t\t\t\t\t      <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/9.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t      Bildnachweis: Daphna Tal\n\t\t\t\t\t\t      </div>\n\n\t\t\t\t\t\t\t<h2 class=\"title-to-play\">\n\t\t\t\t\t\t\t\t KLICKEN SIE AUF \u201CPLAY\u201D: Timna Park - Ein aufregendes W\xFCstenabenteuer\n\t\t\t\t\t\t\t</h2>\n\t\t\t\t\t\t\t<div class=\"responisve-iframe\">\n\t\t\t\t\t\t\t    <iframe src=\"https://www.youtube.com/embed/i_4QKtXIeto/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1\" height=\"315\" width=\"560\" allowfullscreen=\"\" frameborder=\"0\"></iframe>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\n\n                            <h2>\n\t\t\t\t\t\t\t    Sandboarding in der W\xFCste\n\t\t\t\t\t\t\t</h2>\n\t\t\t\t\t\t\t <p>\n\t\t\t\t\t\t      Eine kultige W\xFCstenerfahrung. Die schwungsvollen Sandd\xFCnen der W\xFCste Negev laden zum heruntergleiten ein, egal ob sitzend oder stehend, aber immer unglaublich schnell. Es ist eine fantastische und besondere Herausforderung, und sobald Sie sie meistern (es ist wirklich sehr einfach), k\xF6nnen Sie sich bedenkenlos Sandsurfer nennen \u2013 ziemlich cool, oder?\n\t\t\t\t\t\t      </p>\n\t\t\t\t\t\t      <div class=\"img-wrapper img-page3\">\n\t\t\t\t\t\t      <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t      </div>\n\t\t\t\t\t\t      <div class=\"img-wrapper img-page3\">\n\t\t\t\t\t\t      <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t      </div>\n\n\t\t\t\t\t\t      <h2>\n\t\t\t\t\t\t      Negev bei Nacht\n\t\t\t\t\t\t      </h2>\n\t\t\t\t\t\t      <p>\n\t\t\t\t\t\t      Der Himmel \xFCber dem Negev bietet einen atemberaubenden Anblick. Schauen Sie einfach hinauf, sobald die Dunkelheit einbricht, und Sie werden augenblicklich von dem Pracht von Millionen funkelnder Sterne \xFCberw\xE4ltigt, die die blau-schwarze Dunkelheit mit einem Schein aufhellen, den man nur in der W\xFCste sehen kann.\n\t\t\t\t\t\t      </p>\n\n\t\t\t\t\t\t      <div class=\"img-wrapper img-page3\">\n\t\t\t\t\t\t      <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/4.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t      </div>\n\n\t\t\t\t\t\t      <h2>\n\t\t\t\t\t\t      Sonnenaufgang auf Masada\n\t\t\t\t\t\t      </h2>\n\t\t\t\t\t\t      <p>\n\t\t\t\t\t\t      Nur f\xFCr diejenigen, die mutig genug sind, auf die Spitze zu Fu\xDF zu klettern \u2013 der Sonnenaufgang auf Masada ist zweifellos eines der unvergesslichsten Erlebnisse in Israel. Die Sonne steigt langsam \xFCber den jordanischen Moab Bergen und dem Toten Meer auf und verbreitet ihr Licht \xFCber die W\xFCstenlandschaft. Es ist ein spektakul\xE4rer Anblick, den Sie nicht so schnell vergessen werden.\n\t\t\t\t\t\t      </p>\n\n\t\t\t\t\t\t      <div class=\"img-wrapper img-page3\">\n\t\t\t\t\t\t      <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/6.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t      </div>\n\n\n\t\t\t\t\t\t      <h3>\n\t\t\t\t\t\t      DER NEGEV - ISRAELS MAJEST\xC4TISCHE W\xDCSTE\n\t\t\t\t\t\t      </h3>\n\t\t\t\t\t\t      <h2>\n\t\t\t\t\t\t      Wo Abenteuer und Inspiration warten\n\t\t\t\t\t\t      </h2>\n\t\t\t\t\t\t      <p>\n\t\t\t\t\t\t      Ein ideales Ziel f\xFCr Reisende, die Abenteuer in der freien Natur lieben.\n\t\t\t\t\t\t      Der S\xFCden von Israel ist d\xFCnn besiedelt, aber vollgepackt mit faszinierenden Sehensw\xFCrdigkeiten und Aktivit\xE4ten.\n\n\t\t\t\t\t\t      </p>\n\t\t\t\t\t\t      <p class=\"p-margin\">\n\t\t\t\t\t\t      Mit erstaunlichen Naturwundern und Sch\xF6nheiten bietet der S\xFCden Israels einen herrlichen Blick, der Ihnen den Atem rauben wird: von Sonnenauf- bis Sonnenuntergang.\n\t\t\t\t\t\t      Doch nur eine W\xFCste, aber definitiv keine \xD6dnis: Hier gibt es so viel zu sehen und zu tun. Der Negev zeichnet sich durch seine au\xDFergew\xF6hnlichen Gesteine und Formationen, bedeutenden Kulturdenkm\xE4ler und wunderbaren Naturschutzgebiete aus, wo Sie wandern, radfahren und kamelreiten, oder auch aufregende Safaritouren in der W\xFCste genie\xDFen k\xF6nnen.\n\t\t\t\t\t\t      Einfach gesagt, ist diese majest\xE4tische S\xFCdregion eine der gr\xF6\xDFten Vorz\xFCge des Landes und ein absolutes Muss auf der Reiseroute.\n\n\t\t\t\t\t\t      </p>\n\n\n\t\t\t\t\t\t      <h2>\n\t\t\t\t\t\t      Sde Boker\n\t\t\t\t\t\t      </h2>\n\n\t\t\t\t\t\t      <p class=\"p-margin\">\n\t\t\t\t\t\t      Ein bemerkenswerter R\xFCckblick in die Geschichte des Staates Israel ist Sede Boker, ein Kibbuz, der urspr\xFCnglich von Siedlern gegr\xFCndet wurde, mit der Mission, den Negev in den fr\xFChen 50er Jahren zu besiedeln.\n\t\t\t\t\t\t      Sde Boker ist bekannt als die Heimat von David Ben Gurion, Israels erstem Premierminister, dessen Heimat nun ein \xF6ffentlich zug\xE4ngliches Museum ist.\n\n\n\t\t\t\t\t\t      </p>\n\n\t\t\t\t\t\t      <h2>\n\t\t\t\t\t\t      Vidor Center\n\t\t\t\t\t\t      </h2>\n\n\t\t\t\t\t\t      <p class=\"p-margin\">\n\t\t\t\t\t\t      Eine wirklich einzigartige Attraktion, die eine multisensorische Erfahrung der au\xDFergew\xF6hnlichen Natur der Region Arava bietet. Center-Besucher k\xF6nnen fortschrittliche Landwirtschaftsmethoden, heimische Pflanzen- und Tierarten, klimatische Herausforderungen, und besondere Eigenschaften des Bodens und des Wassers in der W\xFCste erkunden.</p>\n\n\n\n\t\t\t\t\t\t      <h2>\n\t\t\t\t\t\t      Nevatim\n\t\t\t\t\t\t      </h2>\n\n\t\t\t\t\t\t      <p class=\"p-margin\">\n\t\t\t\t\t\t      Ein Besuch in Nevati, der Heimat der Cochiner Juden, ist eine faszinierende Erfahrung. Die Cochin-Juden stammen urspr\xFCnglich aus Indien und sind nach der Staatsgr\xFCndung Israels immigriert. Cochin Juden betrachten sich selbst als eine der \xE4ltesten j\xFCdischen Gemeinden der Welt.\n\t\t\t\t\t\t      Das Zentrum f\xFCr das Cochin-Kulturgut in der Moshav Nevatim erz\xE4hlt die Geschichte dieser einzigartigen Gemeinschaft.\n\t\t\t\t\t\t      </p>\n\n\t\t\t\t\t\t      <h2>\n\t\t\t\t\t\t      MidBurn Festival\n\t\t\t\t\t\t      </h2>\n\n\t\t\t\t\t\t      <p class=\"p-margin\">\n\t\t\t\t\t\t      Israels eigene Version des ber\xFChmten \"Burning Man\" Festivals; 6 Tage lang wird eine tempor\xE4re Stadt aufgebaut, die eine Plattform f\xFCr gemeinschaftliches Miteinanderleben, mit Kreativit\xE4t, Kunst und expressivem Selbstausdruck erschafft.\n\t\t\t\t\t\t      </p>\n\n\t\t\t\t\t\t\t<div class=\"responisve-iframe\">\n\t\t\t\t\t\t\t    <iframe src=\"https://www.youtube.com/embed/QL3BGy2p77g/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1\" height=\"315\" width=\"560\" allowfullscreen=\"\" frameborder=\"0\"></iframe>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<br>\n\n                            <h2>\n\t\t\t\t\t\t      Das Beduinen-Erlebniss\n\t\t\t\t\t\t      </h2>\n\n\t\t\t\t\t\t      <p>\n\t\t\t\t\t\t      Die Gastfreundschaft der Beduinen ist sowohl unter emotionalen als auch unter kulturellen Aspekten ein unvergleichliches Erlebniss.\n\t\t\t\t\t\t      Beduinen in Israel sind eine Gruppe von Nomadenst\xE4mmen, die vor vielen hundert Jahren dort gelebt haben und hier immer noch auf traditionelle Weise leben. Sie werden Sie willkommen hei\xDFen in ihren H\xE4usern und in ihrem Leben und machen Sie mit ihren Sitten und Gebr\xE4uchen vertraut. Vom Kamelreiten \xFCber traditionelle Beduinen bis hin zu \xDCbernachtungen in traditionellen Beduinenzelten - all dies sind bei Touristen in der Region \xE4u\xDFerst beliebte Attraktionen und eine Gelegenheit, um eine lange vergessene Lebensweise zu entdecken und zu verbinden.\n\n\t\t\t\t\t\t      </p>\n\n\t\t\t\t\t\t      <div class=\"img-wrapper img-page3\">\n\t\t\t\t\t\t      <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/8.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t      Bildnachweis: Daphna Tal\n\t\t\t\t\t\t      </div>\n\n\t\t\t\t\t\t      <h2>\n\t\t\t\t\t\t      Die kulinarischen K\xF6niginnen von Yeruham\n\t\t\t\t\t\t      </h2>\n\n\t\t\t\t\t\t      <p class=\"p-margin\">\n\t\t\t\t\t\t      F\xFCr ein wirklich denkw\xFCrdiges Erlebnis m\xFCssen Sie unbedingt \u201EDie kulinarischen K\xF6niginnen von Yeruham\u201C besuchen \u2013 Ein einzigartiges Projekt, wo wundervolle Frauen aus Yeruham Touristen aller Welt mit einer hervorragenden traditionellen Mahlzeiten in ihren H\xE4usern begr\xFC\xDFen und f\xFCr unvergessliche Momente voller D\xFCfte, Farben und Geschmack sorgen.\n\t\t\t\t\t\t      Lernen Sie das wahre Leben der Einheimischen durch ihre faszinierenden Geschichten kennen, w\xE4hrend Sie die ethnischen K\xF6stlichkeiten probieren und ihre erstaunliche Gastfreundschaft genie\xDFen.\n\n\t\t\t\t\t\t      </p>\n\t\t\t\t\t\t      <h2>\n\t\t\t\t\t\t      Die Altstadt Be'er Sheva\n\t\t\t\t\t\t      </h2>\n\n\t\t\t\t\t\t      <p class=\"p-margin\">\n\t\t\t\t\t\t      -Angeblich vom biblischen Abraham gegr\xFCndet- ist Be'er Sheva eine der \xE4ltesten St\xE4dte des Landes die nachweislich vor tausenden von Jahren schon besiedelt wurde. So bezaubernd wie historisch, die alte Stadt Be'er Sheva bietet ein faszinierendes Mosaik st\xE4dtischer R\xE4ume an und die Erkundung der Altstadt wird einen seltenen Reichtum an einzigartiger Architektur, eine lange Geschichte, die so alt ist wie die Zeit selbst, enth\xFCllen.\n\t\t\t\t\t\t      </p>\n\t\t\t\t\t\t      <h2>\n\t\t\t\t\t\t      Carasso Science Park\n\t\t\t\t\t\t      </h2>\n\n\t\t\t\t\t\t      <p>\n\t\t\t\t\t\t      Neu in der Altstadt von Be'er Sheva ist der Carasso Science Park, der sich \xFCber 4,25 Hektar erstreckt, der gr\xF6\xDFte Wissenschaftspark Israels.\n\t\t\t\t\t\t      Der Carasso Science Park begeistert und besch\xE4ftigt Besucher jedes Alters mit Attraktionen, wie einem interaktiven Museum und einem wissenschaftlichen Garten mit Spielen und Mitmach-Aktivit\xE4ten. Der Park bietet auch zehn Ausstellungen \xFCber verschiedene Themen an, wie: Gen-Technik, Kommunikation, Mikroelektronik, Kernenergie und anderem.\n\n\t\t\t\t\t\t      </p>\n\t\t\t\t\t\t      <h2>\n\t\t\t\t\t\t      Arad\n\t\t\t\t\t\t      </h2>\n\n\t\t\t\t\t\t      <p class=\"p-margin\">\n\t\t\t\t\t\t      Arad des neuen Jahrtausends ist eine Stadt mit jungem Geist und reicher Erfahrung. Arad ist von wundersch\xF6nen Landschaften, der Beschaulichkeit einer W\xFCste und vielen Wanderwegen umgeben, die f\xFCr jedermann jeglichen Alters und jeden Stil geeignet sind.\n\t\t\t\t\t\t      Mit vielen Attraktionen und vielen touristischen Sehensw\xFCrdigkeiten in und um die Stadt, Arad ist der perfekte Ausgangspunkt und Ihr echtes Tor zu den perfekten W\xFCstenurlaub.\n\n\t\t\t\t\t\t      </p>\n\n\n\t\t\t\t\t\t      <h2>\n\t\t\t\t\t\t      Yotvata Hai-Bar\n\t\t\t\t\t\t      </h2>\n\n\t\t\t\t\t\t      <p>\n\t\t\t\t\t\t      Das Naturreservat Chai-Bar Yotvata ist das in dieser Region gr\xF6\xDFte Zucht- und Ansiedlungszentrum f\xFCr Tiere, bevor sie wieder in die Natur entlassen werden. Das Reservat ist stolz auf seine wundervollen Attraktionen, die Tierliebhaber begeistern werden. Es umfasst ein Gehege mit Raubtieren und kleinen W\xFCstentieren, ein Observatorium f\xFCr nachtaktive Tiere, das sich auf 12 Quadratkilometer erstreckt und freilaufende Huf- und Weidetiere beherbergt.\n\n\t\t\t\t\t\t      </p>\n\n\t\t\t\t\t\t      <div class=\"img-wrapper img-page3\">\n\t\t\t\t\t\t      <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/10.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t      Bildnachweis: Daphna Tal\n\t\t\t\t\t\t      </div>\n\n\n\t\t\t\t\t\t      <h2>\n\t\t\t\t\t\t      Extremabenteuer\n\t\t\t\t\t\t      </h2>\n\n\t\t\t\t\t\t      <p>\n\t\t\t\t\t\t      Der S\xFCden Israels ist ein absolutes Traumziel f\xFCr abenteuerlustige Reisende. Sein einzigartiges und anspruchsvolles Terrain eignet sich ideal f\xFCr verschiedene Extremsportarten und -aktivit\xE4ten, darunter das Abseilen von Schluchten, Querfeldein- und Mountain-Biking, die in dieser Region \xE4u\xDFerst beliebt sind, ebenso wie Gel\xE4ndefahren, f\xFCr Einheimische und Touristen gleicherma\xDFen.\n\n\t\t\t\t\t\t      </p>\n\n\t\t\t\t\t\t      <div class=\"img-wrapper img-page3\">\n\t\t\t\t\t\t      <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/11.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t      Bildnachweis: Daphna Tal\n\t\t\t\t\t\t      </div>\n\n\t\t\t\t\t\t      <h2>\n\t\t\t\t\t\t      Kamelreiten\n\t\t\t\t\t\t      </h2>\n\t\t\t\t\t\t      <p>\n\t\t\t\t\t\t      Wie eine R\xFCckkehr in die Vergangenheit, dies ist immer noch die authentischste Art, die wunderbare W\xFCstenumgebung zu erkunden. Das Reiten auf dem R\xFCcken eines Kamels, das in vielen Kamelfarmen angeboten wird, bleibt Ihnen sicher in Erinnerung.\n\t\t\t\t\t\t      </p>\n\n\t\t\t\t\t\t      <div class=\"img-wrapper img-page3\">\n\t\t\t\t\t\t      <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/5.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t      </div>\n\n\t\t\t\t\t\t      \n\n\n                            <!--NEGEV - \u05D5PDATED TEXT SITES-->\n\n                            <h3>\n\t\t\t\t\t\t         VERANSTALTUNGEN IN DER NEGEV: KALENDER\n\t\t\t\t\t\t    </h3>\n\t\t\t\t\t\t\n\n\n\t\t\t\t\t\t\t<div class=\"row-1 mounth-row\">\n\t\t\t\t\t\t      <div class=\"mounths active\">\n\t\t\t\t\t\t      <p id=\"myHeader1\" data-div=\"newboxes1\" href=\"\">January <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/icon/a-down.png")+" class=\"img-responsive icon-a-down\" /></p>\n\t\t\t\t\t\t      </div>\n\n\n\t\t\t\t\t\t      <div class=\"mounths month-mid\">\n\t\t\t\t\t\t      <p id=\"myHeader2\" data-div=\"newboxes2\" href=\"\">February <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/icon/a-down.png")+" class=\"img-responsive icon-a-down\" /></p>\n\t\t\t\t\t\t      </div>\n\n\n\t\t\t\t\t\t      <div class=\"mounths\" >\n\t\t\t\t\t\t      <p id=\"myHeader3\" data-div=\"newboxes3\" href=\"\">May <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/icon/a-down.png")+" class=\"img-responsive icon-a-down\" /></p>\n\t\t\t\t\t\t      </div>\n\n\t\t\t\t\t\t      <div class=\"mounths month-mid\">\n\t\t\t\t\t\t      <p id=\"myHeader1\" data-div=\"newboxes4\" href=\"\">June <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/icon/a-down.png")+" class=\"img-responsive icon-a-down\" /></p>\n\t\t\t\t\t\t      </div>\n\n\t\t\t\t\t\t      <div class=\"mounths\">\n\t\t\t\t\t\t      <p id=\"myHeader2\" data-div=\"newboxes5\" href=\"\">July <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/icon/a-down.png")+" class=\"img-responsive icon-a-down\" /></p>\n\t\t\t\t\t\t      </div>\n\t\t\t\t\t\t      </div>\n\n\n\n\t\t\t\t\t\t      <div class=\"row-2 mounth-row\">\n\t\t\t\t\t\t      <div class=\"mounths\" >\n\t\t\t\t\t\t      <p id=\"myHeader3\" data-div=\"newboxes6\" href=\"\">August <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/icon/a-down.png")+" class=\"img-responsive icon-a-down\" /></p>\n\t\t\t\t\t\t      </div>\n\n\t\t\t\t\t\t      <div class=\"mounths month-mid\">\n\t\t\t\t\t\t      <p id=\"myHeader1\" data-div=\"newboxes7\" href=\"\">October <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/icon/a-down.png")+" class=\"img-responsive icon-a-down\" /></p>\n\t\t\t\t\t\t      </div>\n\n\t\t\t\t\t\t      <div class=\"mounths\">\n\t\t\t\t\t\t      <p id=\"myHeader2\" data-div=\"newboxes8\"a href=\"\">November <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/icon/a-down.png")+" class=\"img-responsive icon-a-down\" /></p>\n\t\t\t\t\t\t      </div>\n\n\n\t\t\t\t\t\t      <div class=\"mounths month-mid\" >\n\t\t\t\t\t\t      <p id=\"myHeader3\" data-div=\"newboxes9\" href=\"\">December <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/icon/a-down.png")+" class=\"img-responsive icon-a-down\" /></p>\n\t\t\t\t\t\t      </div>\n\n\t\t\t\t\t\t      </div>\n\n\n\n\t\t\t\t\t         <div class=\"newboxes\" id=\"newboxes1\"> <!--Jen-->\n\t\t\t\t\t\t      \xDCber das Arava Radrennen - Das nach Yoni Friedman benannte 63 Kilometer lange Radrennen bietet Ihnen atemberaubenden Blick auf eine W\xFCstenlandschaft, sowie die M\xF6glichkeit endlose Weiten der Natur, die Kraft der Spiritualit\xE4t, Gelassenheit und eine Verbindung zu einem au\xDFergew\xF6hnlichen sportlichen Erlebnis zu f\xFChlen.<br>\n\t\t\t\t\t\t      <a href=\"https://www.arava-active.co.il/MenuDefault.aspx?id=4240\" target=\"_blank\">www.arava-active.co.il</a>\n\t\t\t\t\t\t      </div>\n\t\t\t\t\t\t      <div class=\"newboxes\" id=\"newboxes2\"><!--Feb-->\n\t\t\t\t\t\t      Darom Adom ist ein j\xE4hrliches Festival, die tritt w\xE4hrend der Bl\xFCte der roten Anemone Blumen. Das Festival bietet landwirtschaftlichen Fachexkursionen, Bauernm\xE4rkte und Unterk\xFCnfte auf dem Land, sowie sportliche Aktivit\xE4ten an; von den M\xE4rschen, Rennen, bis hin zur Fahrradtouren durch die roten Felder des n\xF6rdlichen Negevs und auch noch viele andere Aktivit\xE4ten sowie k\xFCnstlerische Darbietungen stehen zur Verf\xFCgung. Der lokale Tourismusverband \"Shikma Besor\" ist verantwortlich f\xFCr das Festival und seine j\xE4hrlichen Aktivit\xE4tenassociation.<br>\n\t\t\t\t\t\t      <a href=\"//daromadom.habsor.co.il/\" target=\"_blank\">www.daromadom.habsor.co.il</a>\n\t\t\t\t\t\t      </div>\n\t\t\t\t\t\t      <div class=\"newboxes\" id=\"newboxes3\"><!--May-->\n\t\t\t\t\t\t      Das Kirschfest findet im Yatir-Wald statt, dem gr\xF6\xDFten Wald in Israel, in dem gro\xDFe Obstplantagen wachsen und der nur 5-Fahrminuten vom Be'er Sheva entfernt ist. Die Veranstaltung umfasst eine Kirschernte f\xFCr die ganze Familie, s\xFC\xDF-saure Snacks, Pita-Brotbacken, Schafhirten, Gibbon, lokalen Bauernmarkt, Klezmer-Melodien, Kletterwand, Omega und viele andere Aktivit\xE4ten f\xFCr die ganze Familie.<br>\n\t\t\t\t\t\t      <a href=\"//kinderland.co.il/events/%D7%A4%D7%A1%D7%98%D7%99%D7%91%D7%9C-%D7%93%D7%95%D7%91%D7%93%D7%91%D7%9F-%D7%91%D7%99%D7%A2%D7%A8-2017-%D7%A7%D7%98%D7%99%D7%A3-%D7%A2%D7%A6%D7%9E%D7%99-%D7%A9%D7%9C-%D7%93%D7%91%D7%93%D7%91%D7%A0/\" target=\"_blank\">www.kinderland.co.il</a>\n\t\t\t\t\t\t      </div>\n\n\t\t\t\t\t\t      <div class=\"newboxes\" id=\"newboxes4\"><!--June-->\n\t\t\t\t\t\t      Erleben Sie den Zauber des Ramadan Nacht in Rahat - wenn die Nacht zum Tag wird und die Stra\xDFen voller Leben sind. Erleben Sie eine unvergessliche Tour zur sch\xF6nsten Zeit des Jahres, die Ihnen einen einzigartigen Einblick in die Kultur der Beduinen in Rahat erm\xF6glicht. Finden Sie die authentischen Gerichte, saugen Sie die D\xFCfte von Gew\xFCrzen und ger\xF6stetem Kaffee in sich auf. Entdecken Sie die Geheimnisse von Rahat von lokalen F\xFChrern und genie\xDFen Sie Stra\xDFenauff\xFChrungen, Debka-Musik und noch mehr.<br>\n\t\t\t\t\t\t      <a href=\"//ramadan-nights.co.il/\" target=\"_blank\">www.ramadan-nights.co.il</a><br>\n\t\t\t\t\t\t      Das Kino S\xFCd Festival, das von der School of Sound and Screen Arts an Sapir College realisiert wird, begann im Jahr 2002 mit einem Schwerpunkt Studentenfilme. Innerhalb weniger Jahre ist das Festival jedoch zu einem internationalen Filmfestival gewachsen das eine zentrale B\xFChne f\xFCr israelisches Kino, internationale Qualit\xE4t und radikales Kino anbietet. Das Festival dauert f\xFCnf Tage lang und findet jedes Jahr im Juni an verschiedenen Orten im n\xF6rdlichen und westlichen Negev statt. Dies ist ein Festival, das kostenlos und mit offenen T\xFCren allem  G\xE4sten zur verf\xFCgung steht. Das South Cinema Festival wird von einer einzigartigen Kulturagenda produziert und ist wichtig f\xFCr den Ort, wo es geschaffen wurde.<br>\n\t\t\t\t\t\t      <a href=\"//csf.sapir.ac.il/csf2017/csf.sapir.ac.il/index.html\" target=\"_blank\">www.csf.sapir.ac.il</a>\n\t\t\t\t\t\t      </div>\n\t\t\t\t\t\t      <div class=\"newboxes\" id=\"newboxes5\"><!--July-->\n\t\t\t\t\t\t      Das Internationale Fringe Festival Beer Sheva ist ein multidisziplin\xE4res Festival das f\xFCr alle Altersgruppen und Publikum geeignet ist und eine Qualit\xE4tsb\xFChne f\xFCr die besten israelischen und internationalen K\xFCnstler aus den Bereichen Theater, Tanz, Musik, Street Art und der bildenden Kunst darstellt. Das Festival gilt als eines der wichtigsten Rahmenveranstaltungen in Israel und als das gr\xF6\xDFte und f\xFChrende Kulturfestival im S\xFCden des Landes. Das Festival wurde vor kurzem von der EFFE (European Festivals Association) empfangen und gewinnt einen Ruf als eine prestigetr\xE4chtige europ\xE4ische Veranstaltung.<br>\n\t\t\t\t\t\t      <a href=\"https://www.iffb7.com/\" target=\"_blank\">www.iffb7.com</a>\n\t\t\t\t\t\t      </div>\n\t\t\t\t\t\t      <div class=\"newboxes\" id=\"newboxes6\"> <!--Aug-->\n\t\t\t\t\t\t      Negev der Sterne - Wie in jedem Sommer, die Splitter - die vom Kometen SWIFT-TATTLE zur\xFCckgelassen wurden - treffen die Erde. Diese Fragmente durchdringen unsere Atmosph\xE4re und schaffen einen spektakul\xE4ren Blick auf \"Shooting Stars\". W\xE4hrend dieser Zeit in der Negev feiern die Menschen die erstaunliche Erfahrung der Perseiden-Sternschnuppen und eine ganze Reihe von astronomischen Ereignissen - eine gemeinsame Beobachtung der Meteoritenschauer, Beobachtungspunkte mit aufwendigen Teleskopen, Vortr\xE4ge und viele andere Aktivit\xE4ten.\n\t\t\t\t\t\t      </div>\n\t\t\t\t\t\t      <div class=\"newboxes\" id=\"newboxes7\"><!--Oct-->\n\t\t\t\t\t\t      Das Tamar Festival ist eine Kombination aus dem idealen israelischen Soundtrack und der spektakul\xE4ren Aussicht auf Masada und die Region des Toten Meeres. Das au\xDFergew\xF6hnliche Erlebnis dauert 24 Stunden \xFCber 4 Tage lang und Konzerten finden immer an verschiedenen Orten und zu verschiedenen Zeiten statt, was beitr\xE4gt dass das Publikum sich schlie\xDFlich wagt die au\xDFergew\xF6hnlichsten Landschaften des Landes zu besuchen.<br>\n\t\t\t\t\t\t      <a href=\"//www.tamarfestival.com/\" target=\"_blank\">www.tamarfestival.com</a><br>\n\t\t\t\t\t\t      Desert Magic Festival - Das erste Beduinen-Festival: Eine Vielzahl von Erlebnisaktivit\xE4ten f\xFCr die ganze Familie, die einen authentischen Einblick in die alte Beduinen-Tradition bieten.<br>\n\t\t\t\t\t\t      <a href=\"//www.kesem-hamidbar.co.il/\" target=\"_blank\">www.kesem-hamidbar.co.il</a>\n\t\t\t\t\t\t      </div>\n\t\t\t\t\t\t      <div class=\"newboxes\" id=\"newboxes8\"><!--Nov-->\n\t\t\t\t\t\t      Das Arava Film Festival ist ein einzigartiges Ereignis, das seit einigen Jahren jeden November im Herzen des Naturschutzgebietes Arush, neben Tzukim, stattfindet. Die Filme des Festivals werden am Abend und in der Nacht unter freiem Sternenhimmel gezeigt. Sie sind die erste Linie der internationalen Produktion, die letztes Jahr auf Weltfilmfestivals gezeigt wurde. Zu den Filmen des Festivals geh\xF6ren Filme f\xFCr Kinder und Jugendliche sowie Kurzfilme, die im letzten Jahr in Arava produziert und gefilmt wurden. Die Filme werden auf einem riesigen Bildschirm gezeigt und das Publikum kann sich auf einer ger\xE4umigen und \xFCberraschend komfortablen Plattform entspannen, die speziell f\xFCr diesen Zweck im Tal zwischen den Klippen des \xF6stlichen Negev gebaut wurde.<br>\n\t\t\t\t\t\t      <a href=\"https://www.aravaff.co.il/\" target=\"_blank\">www.aravaff.co.il</a>\n\t\t\t\t\t\t      </div>\n\t\t\t\t\t\t      <div class=\"newboxes\" id=\"newboxes9\"><!--Dec-->\n\t\t\t\t\t\t      Ben-Gurions Marsch findet seit mehr als 20 Jahren auf Initiative des Ramat Negev Regionalrats statt, nach dem t\xE4glichen Sport Marsch des ersten Premierministers, David Ben-Gurion, w\xE4hrend seines Aufenthalts im Kibbuz Sde-Boker. Der Marsch findet auf drei Strecken statt - eine kurze Strecke f\xFCr Familien (7 km), mittlere (15 km) und lange (22 km).<br>\n\t\t\t\t\t\t      <a href=\"//www.zaadatbg.org.il/\" target=\"_blank\">www.zaadatbg.org.il</a><br>\n\t\t\t\t\t\t      Docaviv Negev - Docaviv, das internationale Dokumentarfilmfestival von Tel Aviv, ist das gr\xF6\xDFte Filmfestival in der Stadt Tel Aviv und das einzige Festival in Israel, das in seiner Gesamtheit Dokumentarfilmen gewidmet ist. Damit ein m\xF6glichst breites Publikum mit diesem dokumentarischem Arbeit angesprochen wird, organisiert die NPO auch eine regionalen Fest: Docaviv Negev, der in Yeruham gehalten wird, sowie Dutzende von dokumentarischen Filmvorf\xFChrungen in Kulturzentrum im ganzen Land. Jedes Jahr vergibt Docaviv BSC Auszeichnungen f\xFCr originale israelische Dokumentarfilmproduktion und, daneben, auch die Preise f\xFCr den besten internationalen Film Award, Preise f\xFCr die herausragende, noch studierende Filmemacher und ein zus\xE4tzlicher Preis innerhalb des Depth of Field-Rahmens f\xFCr innovative, inspirierende Dokumentarfilme aus der ganzen Welt.<br>\n\t\t\t\t\t\t      <a href=\"//www.docaviv.co.il/\" target=\"_blank\">www.docaviv.co.il</a>\n\t\t\t\t\t\t      </div>\n\n\n\n\n\t\t\t\t\t\t      <a href=\"//graphics-lapam.org.il/clients/tayarut/negev/files/assets/basic-html/page-1.html#\" target=\"_blank\"> F\xDCR WEITERE INFORMATIONEN KLICKEN SIE HIER </a>\n\n\n         "};}},{ctg:"telavivAndJerusalem",isVid:false,id:41,bgImage:"/posts/bank/46/1.jpg",mobBgImage:"/posts/bank/46/M/1.jpg",title:"Mit Kindern reisen -",smltitle:"",html:function html(){return{__html:"\n\n              \t\t\n                              <h2>Ununterbrochene Spannung f\xFCr die ganze Familie</h2>\n              \t\t          <p>Mit Kindern nach Tel Aviv und Jerusalem zu reisen ist ein fantastisches Erlebnis. Beide St\xE4dte sind extrem familienorientiert und von der Natur bis zur Kultur gibt es jede Menge tolle Attraktionen und spannende Aktivit\xE4ten.</p>\n\n                              <p>Mit bis zu 300 Sonnentagen im Jahr, bieten die wundersch\xF6nen Str\xE4nde eine fabelhafte Kombination aus Sonne und Spa\xDF. Die Strandpromenade ist ein gro\xDFartiger Ort f\xFCr Kinder zum Spazieren, Laufen, Fahrradfahren oder gar mit einem Mini-Scooter durch die Gegend rauschen. Vergessen Sie nicht das reiche Angebot an Museen und Stra\xDFenauff\xFChrungen zu erforschen, und einen wundersch\xF6nen Tag im Freien, im HaYarkon Park zu verbringen. </p>\n\n                              <p>Ein Besuch in Jerusalem wird mit seinen malerischen Gassen, seinen einzigartigen Museen und mit seiner faszinierender Geschichte wird Ihre Phantasie befl\xFCgeln. Schattige Parks, Wasserspiele und Ausstellungen f\xFCr Kinder und Shows - es ist f\xFCr jeden Alter etwas dabei.</p>\n\n                              <p>Das gro\xDFe Angebot an spannenden Aktivit\xE4ten garantiert einen unvergesslichen Besuch in Tel Aviv und Jerusalem f\xFCr die ganze Familie. </p>\n                              <p> Ein Besuch in Jerusalem und Tel Aviv ist das perfekte Ziel f\xFCr Familien, die Spa\xDF und Spannung suchen. Beide St\xE4dte sind ganz einfach vollgepackt mit tollen Aktivit\xE4ten und Attraktionen f\xFCr die ganze Familie. Hier finden Sie nur einige jener fabelhaften M\xF6glichkeiten, wie Sie die Zeit mit Ihrer Familie gro\xDFartig in Jerusalem und Tel Aviv verbringen k\xF6nnen - alles, was Sie und Ihre Familie machen m\xFCssen, ist zu eine Aktivit\xE4t zu w\xE4hlen und schon geht\u2019s los: </p>\n                              <div class=\"img-wrapper\">\n                                                <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/35/1.jpg")+" class=\"img-responsive\" />\n                                </div>\n                              <h3>\n                                              Tel Aviv\n                              </h3>\n                              <p><strong>\"Luna Park\":</strong> Ein fantastischer Vergn\xFCgungspark im Herzen der Stadt, mit einer Reihe von lustigen und aufregenden Achterbahnen und Attraktionen f\xFCr die ganze Familie. Direkt gegen\xFCber dem wundersch\xF6nen Hayarkon Park, der auch die gr\xFCne Lunge von Tel Aviv genannt wird.</p>\n                              <p><strong>HaYarkon Park:</strong> Der ruhige Yarkon Park am Rande der ewig lebendigen Stadt, bietet wundersch\xF6ne Gr\xFCnfl\xE4chen, Bootsfahrten auf dem Fluss, Radtouren entlang den ausgebauten Radwegen, Sportpl\xE4tze und vieles mehr f\xFCr die ganze Familie. Genie\xDFen Sie ihr Picknick mit einem atemberaubenden Blick auf Tel Aviv.</p>\n                              <p><strong>Hei\xDFluftballon:</strong> Nachdem Sie sich im wundersch\xF6nen HaYarkon Park erholt haben, g\xF6nnen Sie sich doch einen Blick auf das wundersch\xF6ne Tel Aviv, n\xE4mlich so, wie Sie es noch zuvor nie erlebt haben \u2013 lassen Sie sich \xFCber den Yarkon Park treiben \u2013 das Erlebnis f\xFCr romantische Ausfl\xFCge, oder einfach nur aus Spa\xDF mit Ihrer Familie.</p>\n                              <p><strong>Observatorium:</strong> Wenn Sie in Azrieli sind, sollten Sie unbedingt das fantastische Observatorium im obersten Stockwerk besuchen, um einen 360\xB0-Blick auf Tel Aviv zu werfen, den die Kleinen nicht so schnell vergessen werden. </p>\n                              <p><strong>Das Planetarium:</strong> Mit einer lustigen Einf\xFChrung in die Astronomie werden Sie mit interaktiven Ausstellungen, Drehsitzen und informativen Pr\xE4sentationen f\xFCr die ganze Familie in den Weltraum entf\xFChrt.</p>\n                              <p><strong>Safari:</strong> Mit der gr\xF6\xDFten Sammlung von Tieren im Nahen Osten k\xF6nnen Sie einen wundersch\xF6nen Tag in freier Wildbahn verbringen, nur 15 Minuten vom Herzen Tel Avivs entfernt, wo Sie sich auch die anderen Sehensw\xFCrdigkeiten der Stadt ansehen k\xF6nnen.</p>\n                              <p><strong>HaTachana, Tel Avivs alter Bahnhof:</strong> Ein Genuss f\xFCr die ganze Familie - der alte Bahnhof bietet f\xFCr jeden etwas - mit Restaurants, Kinderaktivit\xE4ten, Kunstgalerien, Stra\xDFenauff\xFChrungen und sogar einer Zugfahrt.</p>\n                              <p><strong>Der Hafen von Tel Aviv:</strong> Atmen Sie die Seeluft ein und genie\xDFen Sie den herrlichen Yachthafen, holen Sie sich etwas zu essen in einem der vielen Restaurants oder Caf\xE9s, und schauen Sie sich die fantastischen Stra\xDFenauff\xFChrungen mit Musik, Zaubertheater und vieles mehr an, die speziell f\xFCr die Freude der Kleinen ausgerichtet sind.</p>\n                              <p><strong>Nachlat Binyamin Stra\xDFenmesse:</strong> Dies ist die gr\xF6\xDFte Messe ihrer Art in Israel, sie ist eine heitere und belebende Erfahrung mit Kunsthandwerkern, Live-Musik, Stra\xDFenauff\xFChrungen und Caf\xE9s, die Menschen jeden Alters ansprechen wird.</p>\n                              <p><strong>Sarona: </strong>Der \xFCberdachte Markt ist ein beliebtes Ziel f\xFCr Paare, Gruppen und Familien, die die beliebtesten Orte der Stadt suchen.</p></p>\n\n                              <h3>\n                                    Museen: \n                              </h3>\n                              <p><strong>Tel Aviv Kunstmuseum:</strong> Mit einer Vielzahl von Sammlungen, F\xFChrungen, kreativen und interaktiven Aktivit\xE4ten und Spielen ist das Museum eine wahre Schatztruhe f\xFCr Eltern und Kinder.</p>\n                              <p><strong>Naturhistorisches Museum:</strong> Das 2018 er\xF6ffnete, 5-st\xF6ckige Museum mit seinen 3.000 Ausstellungsobjekten bietet den Kindern die M\xF6glichkeit, die Kreaturen des Landes hautnah zu erleben.</p>\n                              <p><strong>Das Olympische Erlebnismuseum:</strong> Die F\xFChrungen bieten einen interaktiven Einblick in die Geschichte des Sports in Israel mit tollen Multimedia-Ausstellungen, die der ganzen Familie Spa\xDF machen.</p>\n                              <p><strong>Independence Hall (Halle der Unabh\xE4ngigkeit) -</strong> der Geburtsort des Staates Israel und der Geburtsort der ersten hebr\xE4isch-sprachigen Stadt, Tel Aviv. Eine faszinierende Reise durch die Geschichte f\xFCr die ganze Familie. </p>\n\n                               <div class=\"img-wrapper\">\n                                    <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/35/2.jpg")+" class=\"img-responsive\" />\n                                </div>\n                              <h3>\n                                            Jerusalem  \n                              </h3>\n                              <p><strong>Die Stadt Davids:</strong> Ein eindringliches arch\xE4ologisches Erlebnis im Herzen des alten Jerusalems, mit arch\xE4ologischen Ausgrabungen, F\xFChrungen und einem Spaziergang durch einen unterirdischen Wassertunnel.</p>\n                              <p><strong>Nachtspektakel - Sound & Light Show:</strong> Eine atemberaubende Show die die erste ihrer Art ist, bei der die Mauern der Zitadelle zur B\xFChne f\xFCr eine n\xE4chtliche Show werden, wo die 4.000 Jahre alte Geschichte Jerusalems mit Sehensw\xFCrdigkeiten und Klangeffekten gefeiert wird.</p>\n                              <p><strong>Das Aquarium: </strong>Eine der hei\xDFesten Attraktionen in Jerusalem, die Ende 2017 er\xF6ffnet wurde, bietet ein fesselndes Abenteuer durch die vier Meere Israels, das jeden, von jung bis alt begeistern wird.</p>\n                              <p><strong>Der Zeitaufzug:</strong> Tauchen Sie ein in die virtuelle Realit\xE4t auf einer Reise durch die faszinierende Geschichte Jerusalems, mit sich r\xFCttelnden Sitzen und Spezialeffekten, die die Jugendlichen unter Ihnen verbl\xFCffen werden.</p>\n                              <p><strong>Der Botanische Garten: </strong>Ein atemberaubendes Juwel im Herzen der Stadt mit mehr als 6.000 Pflanzenarten aus der ganzen Welt - dies ist ein interessanter und ruhiger Ort f\xFCr jedermann.</p>\n                              <p><strong>Segway Tours:</strong> Geeignet f\xFCr Jugendliche und Erwachsene \u2013 Segway Touren bieten ein unvergessliches Erlebnis mit der Fahrt durch die faszinierende Gegenden, die Ihnen erm\xF6glichen, sowohl den modernen, aber auch den antiken Charakter der Stadt zu genie\xDFen.</p>\n                              <p><strong>Mini-Israel: </strong>Mit hunderten von Mini-Repliken von israelischen Sehensw\xFCrdigkeiten, bietet es eine einzigartige Sicht aus der Vogelperspektive auf die historischen, religi\xF6sen und modernen Gebiete im ganzen Land.</p>\n\n                              <h3>\n                                   Museen:\n                              </h3>\n                              <p><strong>Israel Museum: </strong>Ein f\xFChrendes Kunst- und Arch\xE4ologiemuseum, das Sie in die reiche Geschichte und Kultur des Landes und seiner Menschen einweiht, mit Ausstellungen f\xFCr Besucher jeden Alters.</p>\n                              <p><strong>Der Turm Davids Museum:</strong> Der historische Eingang zur Altstadt von Jerusalem - die mittelalterliche Zitadelle bietet 3D-Modelle, versteckte G\xE4nge, Familienf\xFChrungen und auch andere Aktivit\xE4ten.</p>\n                              <p><strong>Ein Yael Living Museum:</strong> Eine erlebnisreiche Reise durch eine alte r\xF6mische Stra\xDFe, kreative Workshops, Pita-Backen und Einzelgespr\xE4che mit zeitgen\xF6ssischen Schauspielern \u2013 Familien werden diesen Tag lieben.</p>\n                              <p><strong>Das Bloomfield Wissenschaftsmuseum:</strong> Ein fantastisches, kindgerechtes Kultur- und Bildungsmuseum, das herk\xF6mmliche, aber auch interaktive Ausstellungen zu den Themen der Wissenschaft und Technik pr\xE4sentiert.</p>\n\n\n            \t"};}},// No translation
{ctg:"telaviv",isVid:false,id:42,bgImage:"/posts/bank/78/1.jpg",mobBgImage:"/posts/bank/78/M.jpg",title:"Party Capital",smltitle:"",html:function html(){return{__html:"\n\n\t\t\t\t<h2>Epic Nights in the non stop city</h2>\n\n              \t\t<p>\n\t\t\t\t\t\tTel Aviv\u2019s awesome nightlife scene has become famous worldwide. The city the doesn\u2019t stop is teaming up with endless possibilities designed for an epic night out!\n              \t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tStart slow and easy in a bar at the chilled out Port of Tel Aviv, or grab yourself a shoreline table, perhaps at Jerusalem Beach. Order a beer, feel the sand between your toes, and watch the sunset.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tNow that you\u2019re in a mellow mood, it\u2019s time to get your groove on. you\u2019ll be spoiled for choice with upscale clubs, bracelet bars, and other hangouts around Tel Aviv\u2019s White City, Rothschild Boulevard and nearby streets (Levontin, Yehuda HaLevi, Lillenblum, and Allenby), with their trendy see and be seen vibe, filled with young party people all night long.\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/78/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tA five-minute cab ride southwest and you can visit the more mellow upscale bars in Neve Tzedek. Alternatively, a ten-minute ride south takes you to the underground scene in the newly-trendy hipster heaven of the Florentin neighborhood, and of course don\u2019t miss the up and coming hipster style Flea Market area in Jaffa.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tWant a more mainstream approach to a night on the town? Three streets \u2013 King George, Dizengoff, and Ibn Gabirol \u2013 will be just right for you, allowing you a chance to interact with the locals and be part of the authentic nightlife scene of the city.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tWherever you go, you will always find where to have an awesome night in nonstop Tel Aviv!\n\t\t\t\t\t</p>\n            \t"};}},//No translation
// {
// 	ctg :"jerusalem",
// 	isVid:false,
// 	id:43,
//               bgImage: "/posts/bank/79/1.jpg",
//               mobBgImage: "/posts/bank/79/M.jpg",
//               title :"FIRST TIME IN JERUSALEM",
//               smltitle : "The must list for the first-time visitor",
//               html: function(){
// 			return {
// 				__html: `
//               		<p>
// 						Scour the globe it’s hard to match Jerusalem for history, culture, and significance! So rich in sites and activities, it’s difficult to know where to begin. Here are a few suggestions…
//               		</p>
// 					<p>
// 						Jerusalem is the nexus of three of the world’s great faiths. As such, you might want to consider religious, spiritual, or historical locations that will be meaningful to you.
// 					</p>
// 					<p>
// 						Almost any itinerary will include Old City. Famous as the home of the Western Wall, and the Church of the Holy Sepulcher, you could spend days exploring its four quarters – Jewish, Christian, Muslim, and Armenian – and only see but a small part of its many treasures. Make sure to download the free Audio Tours of Jerusalem app, which offers dozens of walking routes, GPS maps, and geo-location alerts as you approach each site.
// 					</p>
// 					<div class="img-wrapper">
// 						<img src=${getImgUrl() +  "/thingsToDo/posts/79/1.jpg"} class="img-responsive" />
// 					</div>
// 					<p>
// 						A five-minute cab ride southwest and you can visit the more mellow upscale bars in Neve Tzedek. Alternatively, a ten-minute ride south takes you to the underground scene in the newly-trendy hipster heaven of the Florentin neighborhood, and of course don’t miss the up and coming hipster style Flea Market area in Jaffa.
// 					</p>
// 					<p>
// 						Want a more mainstream approach to a night on the town? Three streets – King George, Dizengoff, and Ibn Gabirol – will be just right for you, allowing you a chance to interact with the locals and be part of the authentic nightlife scene of the city.
// 					</p>
// 					<p>
// 						Wherever you go, you will always find where to have an awesome night in nonstop Tel Aviv!
// 					</p>
//             	`   }
//   }
// },
// No translation
// {
// 	ctg :"telavivAndJerusalem",
// 	isVid:false,
// 	id:44,
//               bgImage: "/posts/bank/80/1.jpg",
//               mobBgImage: "/posts/bank/80/M.jpg",
//               title :"TRAVELLING ON A BUDGET",
//               smltitle : "Making It Count in Tel Aviv and Jerusalem!",
//               html: function(){
// 			return {
// 				__html: `
//               		<p>
// 						So you’ve heard of the stunning beaches, the amazing sights and the fabulous cuisine and you are looking to travel to Jerusalem and Tel Aviv, but affordability is a concern. Well, pack your bags and worry no more! Both cities offer low-cost accommodations, transportation, and meals, as well as countless sites to see and things to do, which require little or no expense.
//               		</p>
// 					<p>
// 						For affordable accommodation you can choose from the many hostels and smaller hotels, many of which are located only a few minutes’ walk from Tel Aviv’s Beaches and Jerusalem’s main attractions.
// 					</p>
// 					<p>
// 						Getting around? In both cities it’s a snap with a Rav Kav card. Purchase one for little more than a dollar at”Al Hakav” (on the line) Service centers at central stations and other locations around the city. Jerusalem also offers an affordable City Pass option, and in Tel Aviv, the Tel Ofan bicycle rental municipal service is a great and low cost way to get around in the city.
// 					</p>
// 					<div class="img-wrapper">
// 						<img src=${getImgUrl() +  "/thingsToDo/posts/80/1.jpg"} class="img-responsive" />
// 					</div>
// 					<p>
// 						What to do? Jerusalem and Tel Aviv are packed with sites, marketplaces, parks, nearby nature reserves and hiking trails. There are endless ways to not spend a dime and fill your trip with unforgettable experiences.
// 					</p>
// 					<p>
// 						Finally, everyone’s gotta eat, from hummus to gourmet, both cities are famous for great street food and low-price restaurants offering cheap lunch time dining.
// 					</p>
// 					<p>
// 						So come visit Tel Aviv and Jerusalem where you are guaranteed a fantastic time without breaking the bank.
// 					</p>
//             	`   }
//   }
// },
//No translation
// {
// 	ctg :"jerusalem",
// 	isVid:false,
// 	id:45,
//               bgImage: "/posts/bank/81/1.jpg",
//               mobBgImage: "/posts/bank/81/M.jpg",
//               title :"UPSCALE JERUSALEM",
//               smltitle : "Modern luxuries for the pampered traveler",
//               html: function(){
// 			return {
// 				__html: `
//               		<p>
// 						When it comes to luxury travel, high class accommodations, fine dining, and top-drawer shopping options Jerusalem is a city that’s truly arrived.
//               		</p>
// 					<p>
// 						The city features numerous 5-star and boutique hotels ready to custom cater to your needs for comfort and relaxation, offering amazing rooftop views and inhouse spa treatments to boot.
// 					</p>
// 					<div class="img-wrapper">
// 						<img src=${getImgUrl() +  "/thingsToDo/posts/81/1.jpg"} class="img-responsive" />
// 					</div>
// 					<p>
// 						Looking to delight your palette? Well, in 2018, several Jerusalem establishments were listed in the prestige French restaurant guide, Gault & Millau. Beyond that, the city features and is increasingly attracting some of the world’s best chefs.
// 					</p>
// 					<p>
// 						When it comes to style, fashion, and swanky shopping, Jerusalem has any number of places you’ll want to visit. Among these are Arlov Mamilla Avenue. This happening and trendy outdoor mall complex is a must for your go-to city destinations. Even better, it’s situated just steps away from the Old City’s Jaffa Gate.
// 					</p>
// 					<p>
// 						Another not-to-be-missed stop on your itinerary is the elegant The First Station. For over 100 years a railway depot, the site has been transformed into an urban shopping and culinary mecca that’s chock-a-block with restaurants, shops, art galleries and an artists’ marketplace three days a week, as well as live performances and more.
// 					</p>
// 					<p>
// 						And as long as you’re in the neighborhood, treat yourself to a romantic afternoon or evening on Emek Refaim Street, the German Colony’s main thoroughfare. Its beguiling architecture laid back mood, stylish boutiques, intimate restaurants, and 1920s-era cinema offer an absolute treat for all the senses.
// 					</p>
//             	`   }
//   }
// },
// End Posts
{id:5,ctg:"deadsea",isVid:false,bgImage:"posts/bank/100/1.jpg",mobBgImage:"posts/bank/100/M.jpg",title:"Dead Sea Joys",smlTitle:"",html:function html(){return{__html:"\n                          <h2>For a floating good time</h2>\n\t\t\t              <p>\n\t\t\t                              A geological wonder in a uniquely serene setting, the Dead Sea is an extremely popular tourist attraction. \n\t\t\t                              Experience the calm tranquility of the water with its distinct healing properties while enjoying the unparalleled beauty of the surrounding landscape. \n\t\t\t                              <strong>The Dead Sea, also known as the oldest natural spa in the world, is blessed with an extremely high salt concentration of 31.5%, \n\t\t\t                              allowing tourists from far and wide the amazing experience of effortlessly floating on the waters of the lowest place on Earth. \n\t\t\t                              While here, you can bathe</strong> in the healthy black mud of the area or explore the fascinating and historically rich nearby landscapes.\n\t\t\t              </p>\n\n\t\t\t              <p>\n\t\t\t                              Luxury hotels, varied cuisine from gourmet restaurants to fast food eateries, great souvenir shops, the extraordinary history of the nearby Masada, and many cultural activities throughout the year, make the Dead Sea a popular destination for local tourists as well as International visitors.\n\t\t\t              </p>\n\t\t\t              \n\t\t\t"};}},//No translation
// {
// 	id:24,
//                bgImage : "/posts/bank/17/1.jpg",
//         	mobBgImage : "/posts/bank/17/M.jpg",
//               title : "ULTIMATE BEACH FUN",
//               ctg:"telaviv",
//               isVid:false,
//               player_id_post :"",
//               smltitle : "",
//               html: function(){
// 			return {
// 				__html: `
//                 <div class="responisve-iframe">
// 					<iframe src="https://www.youtube.com/embed/I9a4BFWO_6w/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
// 				</div>
//             		<p>
//                 		Israel has a wide selection of beaches to choose from. The wide Mediterranean stretch along the west side of the country boasts wide golden sands and the gorgeous blue waves of the med.
//             		</p>
//         		 	<div class="img-wrapper">
// 						<img src=${getImgUrl() +  "/thingsToDo/posts/24/1.jpg"} class="img-responsive" />
// 					</div>
//             		<p>
//                 		The beaches by the main cities as offer the hustle and bustle, beach bars, restaurants, sporting activities and festivals alternatively if you just want to find a quiet spot there are plenty of coves and vast stretches that are untouched, popular with those who just want to relax. If you are into surfing there are certain beaches that have great spots to ride the waves.
//             		</p>
//             		<div class="img-wrapper">
// 						<img src=${getImgUrl() +  "/thingsToDo/posts/24/2.jpg"} class="img-responsive" />
// 					</div>
//             		<p>
//                 		Up North the Sea of Galilee have some lovely beaches where you can camp out, barbeque and really make a day of it. The Galilee offer boat hire and water sport equipment for some water fun!
//             		</p>
// 	                <p>
// 	                	The Dead Sea’s desert beaches possess a unique atmosphere in the clear air and of course a sea which is not for swimming but for floating and taking care of your skin.
// 	                </p>
// 	                <p>
// 	                	Last but not least the beaches in Eilat boast crystal clear blue waters of the Red Sea that are very seldom wavey. Eilat is known for its beautiful diving spots and swimming with dolphins. They have wonderful beach bars, restaurants, water sports and attractions a perfect destination for holiday makers.
// 	                </p>
//             	 `
//     }
//   }
// },
// No translation
// {
// 	id:27,
//               bgImage : "/posts/bank/30/1.jpg",
//               mobBgImage : "/posts/bank/30/M.jpg",
//               title : "WESTERN WALL WONDERS",
//               ctg :"jerusalem",
//               isVid:false,
//               player_id_post :"",
//               smltitle : "",
//               html: function(){
// 			return {
// 				__html: `
// 				<p>
// 					The Western Wall (or Kotel, in Hebrew) was part of the most magnificent building Jerusalem had ever seen, which was the Second Temple, built by the great King Herod.
// 				</p>
// 				<p>
// 					The Second Temple was destroyed in the year 70 CE and despite the destruction that took place, all four of the Temple Mount support walls remained standing.  Throughout the generations since the Temple’s destruction, the Western Wall was the remnant closest to the site of the Temple’s ‘holies of holies - a place where only the Jewish High Priests were allowed, as it was there they believed God was present.  The actual remains of the Temple can be found the Western Wall Tunnels, which are an extraordinary journey through time.
// 				</p>
//              	<div class="img-wrapper">
// 						<img src=${getImgUrl() +  "/thingsToDo/posts/27/1.jpg"} class="img-responsive" />
// 				</div>
// 				<p>
// 					For centuries Jewish People from around the world have been going there to mourn the loss of this grand temple. You will often find hundreds of people of different nationalities and religions’ pouring out their heart with prayers as the wall is believed to have enormous spiritual significance.
// 				</p>
// 				<p>
// 					It is tradition for the people that visit to write a note and place it in the cracks of the Western Wall, as it is believed the message will be taken to God. You will often find doves resting in the crevices of this impressive structure, which are a symbol of peace.
// 				</p>
// 				<div class="img-wrapper">
// 						<img src=${getImgUrl() +  "/thingsToDo/posts/27/2.jpg"} class="img-responsive" />
// 				</div>
// 				<p>
// 					The Western Wall is a national symbol as the ancient bricks have seen Israel and the Jewish peoples  birth, exile and redemption. It’s a very popular location for national ceremonies and even Bar Mitzvah to take place
// 				</p>
// 				<p>
// 					For more information   <a  target="_blank" href="//www.thekotel.org">www.thekotel.org</a>
// 				</p>
//             	 `
//     }
//   }
// },
// No translation
// {
// 	id:28,
//              bgImage : "/posts/bank/30/1.jpg",
//               mobBgImage : "/posts/bank/30/M.jpg",
//               title : "WHITE CITY SPLENDOR",
//               ctg:"telaviv",
//               isVid:false,
//               player_id_post :"",
//               smltitle : "",
//               html: function(){
// 			return {
// 				__html: `
// 				<div class="responisve-iframe">
// 					<iframe src="https://www.youtube.com/embed/MJ-gsGs1tqA/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
// 				</div>
// 				<p>
// 					Tel Aviv’s “WHITE CITY” is a UNESCO World Heritage Site, because the city is home to more Bauhaus, modern and “International” architecture than any city on earth.
// 				</p>
//              	<div class="img-wrapper">
// 						<img src=${getImgUrl() +  "/thingsToDo/posts/28/1.jpg"} class="img-responsive" />
// 				</div>
// 				<p>
// 					Tel Aviv was founded in 1909 as a garden suburb of the crowded port city of Jaffa. Very quickly it grew into a bustling metropolis so that by 1929, it was a flourishing city that was the apex of the Zionist dream. With the rise to power of Hitler in 1933, dozens of German Jewish architects escaped to Palestine – many of whom were students or graduates of the legendary Bauhaus school of design. The burgeoning of Tel Aviv required more and more buildings, and the arriving architects very quickly adapted their northern European Bauhaus design to the needs of the eastern Mediterranean heat. A walk through central Tel Aviv will bring you face to face with dozens of these extraordinary office buildings, apartment buildings and stores.
// 				</p>
// 				<p>
// 					<a  target="_blank" href="//www.bauhaus-center.com/">www.bauhaus-center.com/</a>
// 				</p>
//             	 `
//     }
//   }
// },
// No translation
// {
// 	id:29,
//               bgImage : "/posts/bank/30/1.jpg",
//               mobBgImage : "/posts/bank/30/M.jpg",
//               title : "TOWER OF DAVID MUSEUM",
//               ctg:"jerusalem",
//               isVid:false,
//               player_id_post :"",
//               smltitle : "",
//               html: function(){
// 			return {
// 				__html: `
// 				<p>
// 					Jerusalem’s Citadel, known as the “Tower of David”, is a historical and archaeological asset of international significance. The Tower is a medieval fortress that is located near the Jaffa Gate, the historical entrance to the Old City and has been the symbol for the city of Jerusalem for generations.
// 				</p>
//              	<div class="img-wrapper">
// 						<img src=${getImgUrl() +  "/thingsToDo/posts/29/1.jpg"} class="img-responsive" />
// 				</div>
// 				<p>
// 					At the Tower of David Museum you are presented with Jerusalem’s astounding story. While absorbing yourself in legends of the past and their dramatic chronicles it will not take you long to realise that the very stones of the museum are part of this city’s living history.
// 				</p>
// 				<div class="img-wrapper">
// 						<img src=${getImgUrl() +  "/thingsToDo/posts/29/2.jpg"} class="img-responsive" />
// 				</div>
// 				<p>
// 					The 500-year-old walls are part of the Turkish citadel; its name derives from a tower so massive that early Jerusalemites ascribed it to their great King David and despite the name being ‘The Tower of David’ it was actually build by King Herod.
// 				</p>
// 				<div class="img-wrapper">
// 						<img src=${getImgUrl() +  "/thingsToDo/posts/29/3.jpg"} class="img-responsive" />
// 				</div>
// 				<p>
// 					Your visit can begin with a breath-taking view of old and new Jerusalem from the top of the tower. Each ancient room has been revamped to showcase a different period, allowing the tempestuous events of 4,000 years to fall perfectly into place in your mind.
// 				</p>
// 				<div class="img-wrapper">
// 						<img src=${getImgUrl() +  "/thingsToDo/posts/29/4.jpg"} class="img-responsive" />
// 				</div>
// 				<p>
// 					The windows frame glimpses of modern Jerusalem, and with each doorway you exit, you look down into the citadel’s central courtyard, where archaeologists have unearthed remains dating from the Maccabees to the Middle Ages. This incredible site really is a maze of time!
// 				</p>
// 				<p>
// 					The museum also utilizes its unique space for multi-sensory exhibits by leading designers and artists from Israel and abroad. This One of a kind museum hosts the annual ‘Night Spectacular’ which is a unique sound and light show where the whole of the Citadel is lit up with stunning designs!
// 				</p>
// 				<p>
// 					For more information:   <a href="//www.tod.org.il/en/">www.tod.org.il/en/</a>
// 				</p>
//             	 `
//     }
//   }
// },
// No translation
// {
// 	id:30,
//              bgImage : "/posts/bank/55/1.jpg",
//               mobBgImage : "/posts/bank/55/M.jpg",
//               ctg :"telavivAndJerusalem",
//               isVid:false,
//               title : "ALL SENSORY MARKETS",
//               player_id_post :"",
//               smltitle : "",
//               html: function(){
// 			return {
// 				__html: `
// 				<p>
// 					For a genuine Middle Eastern experience you can’t beat a visit to one of Israel’s many markets (Shuks).  The different colours, textures, smells, tastes and sounds of these hives of activity can be a highlight of any Israel visit.
// 				</p>
// 				<p>
// 					These markets are a melting pot of cultures and a great place to give your bartering skills a go. Through the winding cobbled streets you will find, fresh produce, souvenirs, art and handmade jewellery…the list is endless. Bring home a gift for your friends and family or just enjoy walking around and tasting different flavours.
// 				</p>
//              	<div class="img-wrapper">
// 					<img src=${getImgUrl() +  "/thingsToDo/posts/30/1.jpg"} class="img-responsive" />
// 				</div>
// 				<h3>
// 					Tel Aviv
// 				</h3>
// 				<p>
// 					The Carmel Market, or Shuk HaCarmel, is the most famous of all Tel Aviv’s marketplaces. In recent years, it’s even joined the ranks of Tel Aviv’s trendy spots for bars, restaurants, coffee shops and chef-owned food stalls. It’s no wonder Shuk HaCarmel is Tel Aviv’s largest and most-centrally located shuk: From hand-made Jachnun, a traditional Yemenite dish, to boutique cheeses, and from one-off cotton clothes to designer threads, HaCarmel has it all. Plan your visit around your tastebuds and food preferences - salted fish, cured meats, Middle Eastern fare, fresh baked French pastries, and local-roasted coffee or fresh-pressed fruit or vegetable juice blends to wash it all down.
// 				</p>
// 				<p>
// 					<a target="_blank" href="//www.shuktlv.co.il/en/category/carmel-market">
// 						www.shuktlv.co.il/en/category/carmel-market
// 					</a>
// 				</p>
// 				<div class="img-wrapper">
// 					<img src=${getImgUrl() +  "/thingsToDo/posts/30/2.jpg"} class="img-responsive" />
// 				</div>
// 				<p>
// 					Nachlat Binyamin arts and crafts fair was established in 1988. It is the oldest and biggest of its kind in Israel, and one of the nicest in the world. The market is home to over two hundred artists who use materials such as wood, glass, fabric, plastic, paper…even rocks (almost anything) to hand-make what they sell on their stall.
// 				</p>
// 				<p>
// 					<a target="_blank" href="//www.shuktlv.co.il/en/category/carmel-market">
// 						www.shuktlv.co.il/en/category/carmel-market
// 					</a>
// 				</p>
// 				<div class="img-wrapper">
// 					<img src=${getImgUrl() +  "/thingsToDo/posts/30/3.jpg"} class="img-responsive" />
// 				</div>
// 				<h3>
// 					Jerusalem
// 				</h3>
// 				<p>
// 					The Machane Yehuda market is widely recognized as a symbol of the Jerusalem, and for a very good reason: Jerusalemites see it as a place that represents them, symbolizes them, and gives them a unique identity in a larger Israeli social context. Jerusalem today has many shopping and entertainment centres, but there is something about the Machane Yehuda market that attracts people, even without a shopping list.  From the heady scent of spices to the colourful displays of fruits and vegetables, a trip to this market is pleasing for all your senses.
// 				</p>
// 				<div class="img-wrapper">
// 					<img src=${getImgUrl() +  "/thingsToDo/posts/29/4.jpg"} class="img-responsive" />
// 				</div>
// 				<p>
// 					One option of experiencing this market is by buying a ‘Machane Yehuda Bites Card’.  This card is comprised of vouchers curated in order to give you a chance to try a variety of products, flavours and the aromas of the market - without having to depend on an organized group or tour.  For more information please click here:
// 				</p>
// 				<p>
// 					<a target="_blank" href="//www.machne.co.il/en/">
// 						http://www.machne.co.il/en/
// 					</a>
// 				</p>
//             	 `
//     }
//   }
// },
//No translation
// {
// 	id:31,
//               bgImage : "/posts/bank/20/1.jpg",
//               mobBgImage : "/posts/bank/20/M.jpg",
//               title : "UNFORGETTABLE YAD VASHEM",
//               ctg :"jerusalem",
//               isVid:false,
//               player_id_post :"",
//               smltitle : "",
//               html: function(){
// 			return {
// 				__html: `
// 				<p>
// 					Yad Vashem, Israel’s main Holocaust remembrance and education centre is situated on the green slopes of Har HaZikaron, (the Mount of Remembrance) in Jerusalem.
// 				</p>
// 				<p>
// 					Israel’s Holocaust commemoration project began in 1953 with the task of perpetuating the memory of Holocaust victims and documenting the history of the Jewish people during the Holocaust so that it will be remembered by future generations. This project was an important step for the young nation of Israel at the time and was significant for the citizens of Israel, particularly for the survivors of the ghettos and concentration camps.
// 				</p>
//              	<div class="img-wrapper">
// 					<img src=${getImgUrl() +  "/thingsToDo/posts/31/1.jpg"} class="img-responsive" />
// 				</div>
// 				<p>
// 					The new Yad Vashem museum was opened to the public in 2005. The museum is designed in the shape of a prism penetrating the mountain. Divided into nine galleries, the museum relates the stories of the Jewish communities before the Second World War and the series of events beginning from the rise of the Nazis to power, the pursuit of the Jews, their eviction to the ghettos and ending with “the Final Solution” and mass genocide
// 				</p>
// 				<div class="img-wrapper">
// 					<img src=${getImgUrl() +  "/thingsToDo/posts/31/2.jpg"} class="img-responsive" />
// 				</div>
// 				<p>
// 					The personal experiences and feelings of the victims of the Holocaust constitute the groundwork for the museum’s exhibits. Photographs, films, documents, letters, works of art, and personal items found in the camps and ghettos are all an integral part of the exhibits. As you exit the Museum itself is the Hall of Names, an inspiring memorial containing over three million names of Holocaust victims that were submitted by their families and relatives. Names can still be submitted by visitors to the memorial and added to the computerized archive.
// 				</p>
// 				<p>
// 					In addition to the Holocaust History Museum Yad Vashem has other memorials and monuments including  the Hall of Remembrance, where the ashes of the dead are buried and an eternal flame burns in commemoration; Yad Layeled, the children’s memorial, commemorating the one and a half million Jewish children who were murdered in the Holocaust;
// 				</p>
// 				<div class="img-wrapper">
// 					<img src=${getImgUrl() +  "/thingsToDo/posts/31/3.jpg"} class="img-responsive" />
// 				</div>
// 				<p>
// 					The Memorial to the Deportees, an authentic railroad car hanging over the cliff on the road winding down from the mountain. The car was used to transport Jews who had been banished from their homes to the concentration camps.
// 				</p>
// 				<p>
// 					The Avenue of the Righteous Among the Nations has over 2,000 trees which were planted in honor of non-Jews who endangered their lives in order to rescue Jews from the Nazis; The archives and library of Yad Vashem House the world’s largest repository of material about the Holocaust;
// 				</p>
// 				<p>
// 					Visiting the Yad Vashem museum is an emotional and heartrending experience, but seeing the exhibits and remembering the Holocaust gives the more than one million individuals, world leaders and dignitaries who pass through its doors annually a meaningful way to commemorate the six million Jewish victims of the Holocaust.
// 				</p>
// 				<p>
// 					For more information   <a target="_blank" href="//www.yadvashem.org/">www.yadvashem.org</a>
// 				</p>
//             	 `
//     }
//   }
// },
// GO POSTS
{id:"The_Incense_Road",bgImage:"/posts/bank/negev3/1.jpg",mobBgImage:"/posts/bank/negev3/M.jpg",title:"DIE WEIHRAUCHSTRAßE",ctg:"eilat-negev",isVid:false,vidId:"",smlTitle:"",html:function html(){return{__html:"\n                        <h2>Eine 2.000 Jahre alte Geschichte des Erfolgs</h2>\n\n                        <p>Die legend\xE4re Weihrauchstra\xDFe erz\xE4hlt eine 2.000 Jahre alte Geschichte wirtschaftlichen Erfolgs.</p>\n\t\t\t\t\t\t\n\t\t\t\t\t\t<p>In Ermangelung verl\xE4sslicher Transportmittel Stra\xDFen oder Karten wurden damals lange Kamelkaravanen \xFCber gef\xE4hrliche Pfade gef\xFChrt, unter der steten Gefahr, R\xE4ubern, Pl\xFCnderern, anderen Hindernissen oder unduldsamen Herrschern zum Opfer zu fallen. Wertvolle G\xFCter wurden auf dieser Route, die im Osten im Jemen begann, durch Saudi-Arabien und Jordanien f\xFChrte und in Israel im Hafen von Gaza endete, transportiert und dort schlie\xDFlich auf Handelsschiffe verladen, die nach Europa segelten. Dort kamen die Frauen im r\xF6mischen Reich in den Genuss des Parf\xFCms aus Weihrauch und Myrrhe und bereicherten die K\xFCche mit den Gew\xFCrzen aus dem Osten und dem n\xFCtzlichen Salz, mit dem auch die Lebensmittel haltbar gemacht wurden.</p>\n\t\t\t\t\t\t<div class=\"img-wrapper\">\n                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/the-incense-road/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t \t</div>\n\t\t\t\t\t\t<p>Die Reise \xFCber die 2.400 Kilometer lange Weihrauchstra\xDFe dauerte ungef\xE4hr sechs Monate. Die Kamelkaravanen setzten sich aus Tausenden von Personen zusammen, die sich langsam entlang der 56 Wegpunkte bewegten, wo sie anhielten um zu rasten, die Tiere zu versorgen und Kraft f\xFCr die n\xE4chsten Tage zu sammeln.</p>\n\t\t\t\t\t\t<p>Der israelische Abschnitt der Weihrauchstra\xDFe ist ungef\xE4hr 150 Kilometer lang. Die Spuren der Route sind in der Negev-W\xFCste immer noch zu finden, und es gibt viele Reisende, die ihnen folgen, um die W\xFCste zu erkunden und den Lebensstil der W\xFCstenschiffer zu erleben. Auch einige Anlaufpunkte haben \xFCberdauert, angefangen mit Moa, der Oase in der Arava Steinw\xFCste an der Grenze nach Jordanien, wo die Ruinen eines Gasthauses, eines Wachpostens, von H\xF6hlen, Lagerr\xE4umen und eines Aqu\xE4dukts immer noch zu erkennen sind. Von hier aus verlief die Weihrauchstra\xDFe nordwestlich nach Mamshit, einer gro\xDFen Stadt, wo sie auf die eindrucksvollen Ruinen eines Gasthauses, von Kirchen, einem Badehaus, Zisternen und anderen Bauwerken sto\xDFen.</p>\n\t\t\t\t\t\t<p>Der n\xE4chste Halt lag in der Stadt Ovdat, die auf einer Anh\xF6he lag. Auch hier finden sich die Ruinen einer Befestigungsanlage, von Kirchen, einer \xD6lpresse, einer Keramikwerkstatt, von H\xE4usern, einem Badehaus und sogar H\xF6hlengr\xE4ber.</p>\n\t\t\t\t\t\t<div class=\"img-wrapper\">\n                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/the-incense-road/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t \t</div>\n\t\t\t\t\t\t<p>Die Karavanen reisten weiter von Ovdat nach Shivta, einer kleinen Stadt mit gut entwickeltem Bew\xE4sserungssystem, Teichen, \xD6lpressen und einigen Kirchen. Die vorletzte und n\xF6rdlichste Station war Halutsa, wo die Ruinen eines Theaters und einer Kirche erhalten sind. Von hier aus ging es direkt nach Gaza. Es &nbsp;siedelten sich einige kleine Rastst\xE4tten entlang der Route \u2013 Kasra, Nekarot, Makhmal und Grafon \u2013 an sowie ein zus\xE4tzliches Gasthaus, Ein-Saharonim. Hier gibt es immer noch den von Werkst\xE4tten und einem Bad umgebenen Innenhof.</p>\n\t\t\t\t\t\t<p>Entlang der Stra\xDFe gibt es Zisternen, Wacht\xFCrme, religi\xF6se St\xE4tten, Badem\xF6glichkeiten und Meilensteine, die den Verlauf markierten.</p>\n\t\t\t\t\t\t<p>Moa, Mamshit, Ovdat, Shivta und Haluza sowie Ein-Saharonim sind mit allen Fahrzeugtypen zu erreichen. Die Weihrauchstra\xDFe selbst ist in den W\xFCstengebieten nur mit einem Jeep passierbar, obwohl die faszinierende Route nat\xFCrlich auch mit dem Fahrrad oder zu Fu\xDF erkundet werden kann. Im Jahr 2005 hat die UNESCO die Weihrauchstra\xDFe zu einem Weltkulturerbe erkl\xE4rt. Israel l\xE4dt sie ein, in Negev und Arava in die Fu\xDFspuren der Nomaden zu treten und die eindrucksvollen Erz\xE4hlungen sowie die gro\xDFartigen historischen Zeugnisse eines st\xFCrmischen Zeitalters zu genie\xDFen.</p>\n\t\t\t\t\t\t                        \n\n\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\n\n         \t"};}},{id:"The_Negev_Desert",bgImage:"/posts/bank/negev3/1.jpg",mobBgImage:"/posts/bank/negev3/M.jpg",title:"DIE NEGEV WÜSTE – NICHT VERPASSEN",ctg:"eilat-negev",isVid:false,smlTitle:"",html:function html(){return{__html:"\n                        <h3>Sandboarding in der W\xFCste</h3>\n\t\t\t\t\t\t<p>Eine kultige W\xFCstenerfahrung. Die schwungsvollen Sandd\xFCnen der W\xFCste Negev laden zum heruntergleiten ein, egal ob sitzend oder stehend, aber immer unglaublich schnell. Es ist eine fantastische und besondere Herausforderung, und sobald Sie sie meistern (im Grunde genommen ist es ganz einfach), k\xF6nnen Sie sich bedenkenlos Sandsurfer nennen \u2013 ziemlich cool, oder?</p>\n\t\t\t\t\t\t<div class=\"img-wrapper\">\n\n\t\t\t\t\t         <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/the-negev-desert/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t \t</div>\n\t\t\t\t\t\t<h3>Negev bei Nacht</h3>\n\t\t\t\t\t\t<p>Der Himmel \xFCber dem Negev bietet einen atemberaubenden Anblick. Schauen Sie einfach hinauf, sobald die Dunkelheit einbricht, und Sie werden augenblicklich von dem Glanz von Millionen funkelnder Sterne \xFCberw\xE4ltigt, die die blau-schwarze Dunkelheit mit einem Schein aufhellen, den man nur in der W\xFCste erleben kann.</p>\n\t\t\t\t\t\t\n\t\t\t\t\t\t<h3>Kamelreiten</h3>\n\t\t\t\t\t\t<p>R\xFCckblickend ist es wohl noch der authentischste Weg die wundervolle W\xFCstenumgebung zu erkunden. Das Reiten auf dem R\xFCcken eines Kamels, das in vielen Kamelfarmen angeboten wird, bleibt Ihnen garantiert in Erinnerung.</p>\n\t\t\t\t\t\t<div class=\"img-wrapper\">\n\n\t\t\t\t\t         <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/the-negev-desert/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t \t</div>\n\t\t\t\t\t\t\n\t\t\t\t\t\t<h3>MidBurn Festival</h3>\n\t\t\t\t\t\t<p>Das ist Israels eigene Version des Festivals \u201EBurning Man\u201C; 6 Tage lang wird eine Stadt vor\xFCbergehend aufgebaut, die eine Plattform f\xFCr gemeinschaftliches Miteinanderleben, mit Kreativit\xE4t, Kunst, Musik und expressivem Selbstausdruck erschafft.</p>\n\t\t\t\t\t\t<h3>Sonnenaufgang auf Masada</h3>\n\t\t\t\t\t\t<p>Nur f\xFCr diejenigen, die es wagen, auf die Spitze zu Fu\xDF zu klettern \u2013 der Sonnenaufgang auf Masada ist zweifellos eines der unvergesslichsten Erlebnisse in Israel. Die Sonne steigt langsam \xFCber den jordanischen Moab Bergen und dem Toten Meer auf und verbreitet ihr Licht \xFCber die W\xFCstenlandschaft. Es ist ein spektakul\xE4rer Anblick, den man so schnell nicht wieder vergisst.</p>\n\t\t\t\t\t\t\n\t\t\t\t\t\t\t\n\n         \t"};}},{id:"Masada",bgImage:"/posts/bank/negev2/1.jpg",mobBgImage:"/posts/bank/negev2/M.jpg",title:"ERKUNDEN SIE MASADA",ctg:"eilat-negev",isVid:true,vidId:"i8IjojQ39u0",smlTitle:"",html:function html(){return{__html:"\n                        <h2>Mythos im Herzen der Jud\xE4ischen W\xFCste</h2>\n                        <p>Im Masada Nationalpark finden Sie die einzige, isolierte und antike Festung auf einem Hochplateau in der Jud\xE4ischen W\xFCste vor mit wunderbarem Blick auf die Oase des Toten Meeres. F\xFCr den Aufstieg nutzen Sie den Schlangenpfad oder die r\xF6mische Treppe am Fu\xDF der Festung. Zudem besteht die M\xF6glichkeit mit der Seilbahn auf das Plateau zu gelangen.das ca 40-30 v.Chr. erbaut wurde.</p>\n\t\t\t\t\t\t<div class=\"img-wrapper\">\n                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/masada/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t \t</div>\n\t\t\t\t\t\t<h3>Erkunden Sie majest\xE4tische Ruinen und f\xFChlen Sie sich als Teil der Geschichte</h3>\n\t\t\t\t\t\t<p>Auf Masada befand sich einst ein prachtvolles Burgensemble. Hier wohnten zudem die Freiheitsk\xE4mpfer, die sich nach der Zerst\xF6rung des Zweiten Tempels mutig im Krieg gegen das R\xF6mische Imperium aufgelehnt haben. Die k\xFChlen Steinmauern Masadas erz\xE4hlen die Geschichte jener k\xFChnen M\xE4nner und Frauen, die lieber freiwillig einen fr\xFChen Tod w\xE4hlten als erneut in die Sklaverei durch das feindliche Regime zu gelangen, das bereits dabei war, die oberen Klippen zu erst\xFCrmen</p>\n\t\t\t\t\t\t<h3>Kultur und Religion auf neuen H\xF6hen</h3>\n\t\t\t\t\t\t<p>Erkunden Sie die Burgruinen und entdecken Sie die R\xE4ume und Bauten, sowie die arch\xE4ologischen Funde, die das Leben von Masada w\xE4hrend der r\xF6mischen Belagerung kennzeichnen. Im n\xF6rdlichen Bereich betreten Sie die Ruinen des Privatpalastes von K\xF6nig Herodes. &nbsp;</p>\n\t\t\t\t\t\t<div class=\"img-wrapper\">\n                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/masada/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t \t</div>\n\t\t\t\t\t\t<p>Ein Raum zeugt von einem tragischen Teil der Historie. Im \u201EAuslosungsraum\u201C wurde die Reihenfolge gezogen, in welcher die M\xE4nner nach und nach den Freitod w\xE4hlten.</p>\n\t\t\t\t\t\t<p>Auch finden sich auf Masada die \xDCberreste einer byzantinischen Kirche mit kunstvollen Mosaiken, die wahrscheinlich jahrhundertelang von geflohenen christlichen M\xF6nchen im 1. Jahrhundert genutzt wurde</p>\n\t\t\t\t\t\t<p>Erleben Sie Masada als eines der UNESCO Weltkulturerbe, beenden Sie den Tag mit einem Sonnenuntergang und einer Lichtshow am Fu\xDF der Festung, die einen in das Leben und die Schlachten vergangener Jahrhunderte zur\xFCckversetzt.</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\n\n         \t"};}},// {
// 	      id:"Masada",
//               bgImage: "/HomeSlider/Home/3.jpg",
//               mobBgImage: "/HomeSlider/M/3.jpg",
//               title :"Masada",
//               ctg:"eilat-negev",
//               isVid:true,
//               vidId:"i8IjojQ39u0",
//               smlTitle : "",
//               html: function(){
// 			return {
// 				__html: `
//                         <h2>Mythos im Herzen der Judäischen Wüste</h2>
//                         <p>Im Masada Nationalpark finden Sie die einzige, isolierte und antike Festung auf einem Hochplateau in der Judäischen Wüste vor mit wunderbarem Blick auf die Oase des Toten Meeres. Für den Aufstieg nutzen Sie den Schlangenpfad oder die römische Treppe am Fuß der Festung. Zudem besteht die Möglichkeit mit der Seilbahn auf das Plateau zu gelangen.das ca 40-30 v.Chr. erbaut wurde.</p>
// 						<div class="img-wrapper">
//                              <img src=${getImgUrl() +  "/posts/masada/1.jpg"} class="img-responsive" />
// 					 	</div>
// 						<h3>Erkunden Sie majestätische Ruinen und fühlen Sie sich als Teil der Geschichte</h3>
// 						<p>Auf Masada befand sich einst ein prachtvolles Burgensemble. Hier wohnten zudem die Freiheitskämpfer, die sich nach der Zerstörung des Zweiten Tempels mutig im Krieg gegen das Römische Imperium aufgelehnt haben. Die kühlen Steinmauern Masadas erzählen die Geschichte jener kühnen Männer und Frauen, die lieber freiwillig einen frühen Tod wählten als erneut in die Sklaverei durch das feindliche Regime zu gelangen, das bereits dabei war, die oberen Klippen zu erstürmen</p>
// 						<h3>Kultur und Religion auf neuen Höhen</h3>
// 						<p>Erkunden Sie die Burgruinen und entdecken Sie die Räume und Bauten, sowie die archäologischen Funde, die das Leben von Masada während der römischen Belagerung kennzeichnen. Im nördlichen Bereich betreten Sie die Ruinen des Privatpalastes von König Herodes. &nbsp;</p>
// 						<div class="img-wrapper">
//                              <img src=${getImgUrl() +  "/posts/masada/2.jpg"} class="img-responsive" />
// 					 	</div>
// 						<p>Ein Raum zeugt von einem tragischen Teil der Historie. Im „Auslosungsraum“ wurde die Reihenfolge gezogen, in welcher die Männer nach und nach den Freitod wählten.</p>
// 						<p>Auch finden sich auf Masada die Überreste einer byzantinischen Kirche mit kunstvollen Mosaiken, die wahrscheinlich jahrhundertelang von geflohenen christlichen Mönchen im 1. Jahrhundert genutzt wurde</p>
// 						<p>Erleben Sie Masada als eines der UNESCO Weltkulturerbe, beenden Sie den Tag mit einem Sonnenuntergang und einer Lichtshow am Fuß der Festung, die einen in das Leben und die Schlachten vergangener Jahrhunderte zurückversetzt.</p>
//          	`   }
//   }
// },
{id:"Hidden_Galilee",bgImage:"/posts/bank/north2/1.jpg",mobBgImage:"/posts/bank/north2/M.jpg",title:"ENTDECKEN SIE DIE VERBORGENEN JUWELEN VON GALILÄA",ctg:"north",isVid:false,smlTitle:"",html:function html(){return{__html:"\n                        <h2>Ihr Traumurlaub in Israel voller \xDCberraschungen</h2>\n                        \n\t\t\t\t\t\t\n\t\t\t\t\t\t<p>Entdecken Sie die fruchtbare Landschaft im Norden Israels, wo malerische St\xE4dte die sanften H\xFCgel des oberen und unteren Galil\xE4a kr\xF6nen und Boutique-Weing\xFCter und Restaurants gleich neben uralten, historischen St\xE4tten zu finden sind. \xDCbernachten Sie in einem Luxushotel oder genie\xDFen Sie einen authentischen Urlaub auf dem Land in einem der ber\xFChmten \u201E<em>Zimmer</em>\u201C-Ferienh\xE4uschen, die in den kleinen D\xF6rfern von Familien betrieben werden \u2013 und Sie werden Israel mit anderen Augen sehen.</p>\n\t\t\t\t\t\t<div class=\"img-wrapper\">\n                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/hidden-galilee/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t \t</div>\n\t\t\t\t\t\t<h3>Wo Geschichte zum Leben erwacht</h3>\n\t\t\t\t\t\t<p>Galil\xE4a ist voll von historischen St\xE4tten. Reisen Sie in die alten D\xF6rfer Kfar Nahum (Kapernaum) und Migdal (Magdala) und besuchen Sie das Haus des heiligen Petrus in Kapernaum. Besichtigen Sie die beeindruckenden Kirchen und Kl\xF6ster rund um den See von Galil\xE4a, die in die fr\xFChesten Tage des Christentums zur\xFCckf\xFChren. In Safed, einer der vier antiken spirituellen St\xE4dte des Judentums, k\xF6nnen Sie den Glauben nahezu mit H\xE4nden fassen, w\xE4hrend Sie das wichtigste kabbalistische Zentrum der Welt erkunden. Entdecken Sie die \xE4ltesten Synagogen der Welt an Orten wie Baram und die Kreuzritterfestungen von Montfort und Nimrod. Besuchen Sie die Gedenkst\xE4tte von Maimonides in der antiken Stadt Tiberias und bestaunen Sie die Wunder des alten Akko (Acre), z.&nbsp;B. die unterirdische Stadt der Kreuzritter sowie die Festung und den Tunnel der Tempelritter.</p>\n\t\t\t\t\t\t<div class=\"img-wrapper\">\n                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/hidden-galilee/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t \t</div>\n\n\t\t\t\t\t\t<h3>Ein Paradies f\xFCr Gourmets in Galil\xE4a</h3>\n\t\t\t\t\t\t<p>Boutique-Weing\xFCter und handwerklich betriebene Molkereien begr\xFC\xDFen Sie in Galil\xE4a \xFCberall, wie auch die authentischen, am offenen Feuer zubereiteten Gerichte der Drusen und Araber. Probieren Sie Lebensmittel direkt vom Erzeuger auf Biobetrieben, verweilen Sie in den im Familienbetrieb gef\xFChrten Gourmet-Restaurants und genie\xDFen Sie die frischen Fr\xFCchte der Obstg\xE4rten. Entdecken Sie Israel, wo nicht nur Milch und Honig flie\xDFen, sondern auch Wein, Oliven\xF6l, Ziegenk\xE4se und verf\xFChrerisches Obst zuhause sind.</p>\t\t\t\t\t\n\n         \t"};}},{id:"Nazareth",bgImage:"/posts/bank/north1/1.jpg",mobBgImage:"/posts/bank/north1/M.jpg",title:"NAZARETH",ctg:"north",isVid:true,vidId:"aGMVTrHS8YA",smlTitle:"",html:function html(){return{__html:"\n                        <h2>DIE WIEGE DES CHRISTENTUMS</h2>\n                        \n\t\t\t\t\t\t\n\n\t\t\t\t\t \t<p>Eine antike Stadt, die von Geschichte, faszinierender Arch\xE4ologie, moderner Kultur und orientalischem Charme gepr\xE4gt ist.</p>\n\t\t\t\t\t\t<p>Nazareth, oder Natsrat, wie der Name auf Hebr\xE4isch ausgesprochen wird, ist die Wiege des Christentums. Die Stadt, in der laut Tradition der Erzengel Gabriel Maria erschien und prophezeite, dass Sie durch die Kraft des Heiligen Geistes ein Kind empfangen wird, und der Ort, an dem Jesus seine Kindheit und Jugend verbracht hat. Nazareth, im Unteren Galil\xE4a, befindet sich im Herzen eines Tals inmitten von Bergen. Es ist eine Stadt der Religion und des Glaubens, Spiritualit\xE4t und Heiligkeit, aber auch eine Stadt, die von Geschichte, faszinierender Arch\xE4ologie, moderner Kultur und orientalischem Charme gepr\xE4gt ist.</p>\n\t\t\t\t\t\t<!--<div class=\"img-wrapper\">\n                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/nazareth/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t \t</div>-->\n\t\t\t\t\t\t<h3>Die Wiege des Christentums</h3>\n\t\t\t\t\t\t<p>Nazareth war vor etwa 2.000 Jahren ein kleines j\xFCdisches Dorf und wurde w\xE4hrend der byzantinischen Zeit f\xFCr mehrere Jahrhunderte zur Hochburg des Christentums. W\xE4hrend dieser Zeit hat sich der Name von Nazareth \xFCberall verbreitet und der Wunsch der Pilger, den Ort zu sehen, an dem die Jungfrau Maria und Jesus Christus lebten, haben die Stadt zu einem beliebten Wallfahrtsort gemacht. Diese Besuche f\xFChrten zum Bau der ersten Kirche der Stadt - die Verk\xFCndigungsbasilika an der traditionellen Heimatst\xE4tte von Joseph und Maria.&nbsp; Viele weitere Kirchen wurden in der Stadt gebaut, und w\xE4hrend der jahrhundertelangen wechselnden Herrschaft durch Muslime und Christen zum Teil zerst\xF6rt und wieder aufgebaut. Im 19. Jahrhundert hat Nazareth neues Interesse geweckt, als Christen in die Stadt zur\xFCckgekehrt sind und Kirchen und Kl\xF6ster neu errichteten. Heute ist Nazareth die gr\xF6\xDFte arabische Stadt in Israel mit \xFCber 30 Kirchen und Kl\xF6stern sowie Moscheen und antiken Synagogen.</p>\n\t\t\t\t\t\t<h3>Eine Kostprobe der Altstadt</h3>\n\t\t\t\t\t\t<p>Bei jedem Rundgang durch Nazareth leben seine verschiedenen Epochen wieder auf. Jede \xC4ra hinterlie\xDF ein m\xE4chtiges Symbol, das im modernen Zeitalter zu einer beliebten Touristenst\xE4tte wurde. Die meisten St\xE4tten konzentrieren sich auf die Altstadt und wurden Mitte des 19. Jahrhunderts im orientalischen Baustil errichtet. Ein Spaziergang durch die engen Gassen zwischen den bezaubernden H\xE4usern ist beeindruckend und es lohnt sich, langsam zu gehen, um die Sch\xF6nheit zu genie\xDFen.</p>\n\t\t\t\t\t\t\n\t\t\t\t\t\t<p>In der Altstadt gibt es viele alte Kirchen, wobei die Verk\xFCndigungsbasilika die \xE4lteste ist. In der wieder aufgebauten Kirche konnten Teile der vorherigen Kirchen aus den Zeiten der Kreuzritter und Byzantiner erhalten werden. Zudem beherbergt die Kirche eine beeindruckende Gem\xE4ldesammlung.</p>\n\t\t\t\t\t\t<p>Direkt neben dieser Kirche steht die St. Joseph Kirche, die auf den Ruinen landwirtschaftlicher Geb\xE4ude errichtet wurde und in der, Joseph (Marias Ehemann) der \xDCberlieferung nach, seine Zimmerwerkstatt hatte. W\xE4hrend die Verk\xFCndigungsbasilika am Haus von Maria erbaut wurde, wurde die griechisch orthodoxe Verk\xFCndigungsbasilika oberhalb von Marias Brunnen errichtet, aus dem Jesus\u2018 Mutter getrunken haben soll. Dies ist ein Bau aus der Zeit der Kreuzritter, der einige interessante Fresken aufweist. Direkt neben Marias Brunnen steht die griechisch-orthodoxe Verk\xFCndigungsbasilika in einem Kreuzrittersaal. Der \xDCberlieferung nach ist das der Standort der Synagoge, in der Jesus betete.</p>\n\t\t\t\t\t\t<p>Zu den vielen anderen Kirchen in Nazareth geh\xF6ren die Mensa&#8203; Christi Kirche, die Syrisch-Maronitische Kirche, St. Gabriel Kirche und die Salesianer Kirche. Des Weiteren stehen in der Altstadt wichtige Geb\xE4ude aus der osmanischen Zeit, wie etwa das Regierungsgeb\xE4ude Saraya, das von Daher el Omar erbaut wurde, der im 18. Jahrhundert Statthalter von Galil\xE4a war, und die Wei\xDFe Moschee, die heute als Gebetshaus sowie Ausbildungs- und Kulturzentrum genutzt wird. Die Wei\xDFe Moschee beherbergt au\xDFerdem ein Museum mit Ausstellungen zur Geschichte Nazareths.</p>\n\t\t\t\t\t\t<p>Bei einem Rundgang durch die Altstadt von Nazareth darf ein Besuch des Basars nicht fehlen, der dank seiner bunten Marktst\xE4nde und Warenvielfalt sehr beliebt und bekannt ist. Der Basar ist mit seinen hochmodischen Trendstoffen, Gew\xFCrzen und regionalen Speisen, seinen Kunstwerken und Souvenirs ein einziger Augen- und Gaumenschmaus.&nbsp; Die Kl\xE4nge, Ger\xFCche und Aromen versprechen ein wahrhaft orientalisches Erlebnis.</p>\n\t\t\t\t\t\t<h3>Orientalischer Charme zieht alle Blicke auf sich</h3>\n\t\t\t\t\t\t<p>Nazareth steckt voller faszinierender und wundersch\xF6ner Ecken, die Ihr Herz erw\xE4rmen werden. Ein weiterer lohnenswerter Ort ist ein Spaziergang auf der Nabi Sain Ridge Promenade, von der aus Sie einen herrlichen Blick auf Galil\xE4a haben. Sie k\xF6nnen das antike T\xFCrkische Badehaus besichtigen, das w\xE4hrend Sanierungsarbeiten an einem der Gesch\xE4fte der Stadt entdeckt wurde. Schauen Sie sich eins der schicken Herrenh\xE4user an, die von den Reicht\xFCmern und Br\xE4uchen der osmanischen Oberschicht im 19. Jahrhundert verk\xFCnden und einige erstaunliche Fresken aufweisen. Dar\xFCber hinaus lohnt sich eine Besichtigung des griechisch-orthodoxen Bischofshauses, in dem Sie durch verschiedene unterirdische G\xE4nge in den Hof gelangen. Eine weitere interessante, von den Russen erbaute St\xE4tte ist ein Hostel f\xFCr Wallfahrer.</p>\n\t\t\t\t\t\t<p>Nazareth, in dem jahrhundertelang Wallfahrer begr\xFC\xDFt wurden, hat christliche Hostels und schicke Hotels f\xFCr Touristen, die sich an dieser wichtigen St\xE4tte tummeln, vor allem um die Weihnachtszeit. Dutzende Restaurants mit k\xF6stlichen Delikatessen locken das ganze Jahr \xFCber Besucher an. Nazareth ist an Weihnachten pr\xE4chtig dekoriert f\xFCr die Festtage. Die Farben der Stadt und die aus den Kirchen ert\xF6nenden Gebete tragen zur besonderen Atmosph\xE4re bei.</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\n         \t"};}},{id:"Culinary_In_Galilee",bgImage:"/posts/bank/north3/1.jpg",mobBgImage:"/posts/bank/north3/M.jpg",title:"EIN KULINARISCHER URLAUB IN GALILÄA",ctg:"culinarynorth",isVid:false,smlTitle:"",html:function html(){return{__html:"\n                        <h2>Ein Paradies f\xFCr Foodies</h2>\n                        \n\t\t\t\t\t\t<p>Ein Besuch in Galil\xE4a wird Sie mit Geschmacksrichtungen und Aromen in Ber\xFChrung bringen, die Sie bisher noch nie erlebt haben. Vom handgemachten K\xE4se der K\xE4semanufakturen bis zu den Weltklasseweinen der Boutique-Weing\xFCter, von den Gourmetrestaurants im Familienbetrieb bis zu frisch geerntetem Obst und Gem\xFCse, das vor Aroma strotzt: Galil\xE4a ist ein Paradies f\xFCr Foodies.</p>\n\t\t\t\t\t\t<div class=\"img-wrapper\">\n                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/culinary-in-galilee/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t \t</div>\n\t\t\t\t\t\t<h3>Das Land, in dem Milch und Wein flie\xDFen</h3>\n\t\t\t\t\t\t<p>Besuchen Sie eine K\xE4semanufaktur, um den reichen Geschmack der K\xE4sesorten aus Galil\xE4a zu entdecken, und lernen Sie den Rhythmus der K\xE4seherstellung kennen. Ein fachkundiger K\xE4ser f\xFChrt Sie durch eine Verkostung einer Auswahl der einzigartigen Weich-, Hart- und halbfesten K\xE4sesorten der Region wie z.&nbsp;B. <em>Lebane</em>, ein cremiger und joghurtartiger Weichk\xE4se aus Schaf- oder Ziegenmilch, der h\xE4ufig mit lokalen Kr\xE4utern wie Za\u2018atar gemischt serviert wird, oder <em>Zefatit</em>, ein in einem K\xF6rbchen angerichteter Schafmilchtopfen, der nach der Region <em>Zefat</em> (oder Safed) benannt ist, in der er urspr\xFCnglich hergestellt wurde.</p>\n\t\t\t\t\t\t<div class=\"img-wrapper\">\n                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/culinary-in-galilee/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t \t</div>\n\t\t\t\t\t\t<p>Wenn Sie zu Ihrem K\xE4se gerne einen Wein genie\xDFen, sind Sie am richtigen Ort. Jeder Wein wird besser sein als der vorherige. In letzter Zeit sind durch eine Revolution in der Weinwirtschaft zahlreiche Boutique-Weing\xFCter entstanden, die auf dem variantenreichen Terroir Galil\xE4as in ihren Weinbergen Trauben anbauen, deren Geschmack die jeweilige Bodenbeschaffenheit detailliert widerspiegelt. Lassen Sie Ihren Blick \xFCber die weinbedeckten H\xFCgel schweifen, w\xE4hrend Sie angeleitet von den f\xFChrenden Winzern Israels in dunkel farbenen, fruchtigen, Rot- und frischen Wei\xDFweinen schwelgen. Erkunden Sie die Cuv\xE9es, aus denen die international preisgekr\xF6nten Weine entstanden sind, von denen viele au\xDFerhalb Israels nicht im Handel erh\xE4ltlich sind.</p>\t\t\t\t\t\n\t\t\t\t\t\t         \n         \t"};}},{id:"Rosh_Pina",bgImage:"/posts/bank/north1/1.jpg",mobBgImage:"/posts/bank/north1/M.jpg",title:"ROSH PINA",ctg:"north",isVid:false,smlTitle:"",html:function html(){return{__html:"\n                        <h2>Pastoraler Geheimtipp f\xFCr Touristen in Galil\xE4a</h2>\n                        \n\t\t\t\t\t\t\n\t\t\t\t\t \t<h3>Drehen Sie die Zeit zur\xFCck im malerischen Dorf in Galil\xE4a</h3>\n\t\t\t\t\t\t<p>Rosh Pina, auch bekannt als die Prinzessin von Galil\xE4a, bietet eine perfekte Mischung aus Natur, Kultur, Geschichte und Unterhaltung. Ein wundersch\xF6n restauriertes Dorf im Norden, in dem alte Olivenb\xE4ume und idyllische H\xE4user von goldenen Feldern umgeben sind: Rosh Pina ist genau der Ort f\xFCr Freizeit und Erholung, an dem Besucher das d\xF6rfliche Leben von vor einem Jahrhundert erleben k\xF6nnen.</p>\n\t\t\t\t\t\t<!--<div class=\"img-wrapper\">\n                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/rosh-pina/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t \t</div>-->\n\t\t\t\t\t\t<h3>Wo magische Stille nur von Vogelgezwitscher unterbrochen wird</h3>\n\t\t\t\t\t\t<p>Suchen Sie einen ruhigen Ort in der Natur, der an die Toskana oder die Provence erinnert? Dann fahren Sie Richtung Rosh Pina. Hier gibt es fernab der Sehensw\xFCrdigkeiten des Dorfes l\xE4ndliche Gebiete, die Sie in l\xE4ngst vergangene Zeiten zur\xFCckversetzen. Hier finden Sie eine Vielzahl von Gasth\xE4usern, in denen Sie warmherzig empfangen werden.</p>\n\t\t\t\t\t\t<p>In den romantischen Gassen des Dorfes, fernab vom Trubel der Gro\xDFstadt finden Sie Erholung und gleicherma\xDFen Inspiration.</p>\n\t\t\t\t\t\t<!--<div class=\"img-wrapper\">\n                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/rosh-pina/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t \t</div>-->\n\t\t\t\t\t\t<p>Tauchen Sie ein in die nat\xFCrliche Sch\xF6nheit, wandern Sie entlang der gr\xFCnen <strong>Wanderwege</strong> entlang des Fluss von Rosh Pina oder durch die <strong>G\xE4rten des Barons von Rothschild</strong>, der Berichten zufolge den gro\xDFen G\xE4rten von Versailles nachempfunden wurde. Atmen Sie die frische Luft ein und genie\xDFen Sie beim Schlendern die sch\xF6ne Aussicht. So werden Sie eins mit der Natur und k\xF6nnen auftanken.</p>\n\t\t\t\t\t\t<h3>Eine Ferienanlage mit einzigartigem, k\xFCnstlerischen Charme</h3>\n\t\t\t\t\t\t<p>Schlendern Sie die Kopfsteinpflasterstra\xDFen entlang, die an alte europ\xE4ische St\xE4dte erinnern, und Sie werden in eine herrliche kulturelle und k\xFCnstlerische Atmosph\xE4re eintauchen, die von den sanften H\xFCgeln Galil\xE4as umgeben sind. Ein Ort mit trendigen Caf\xE9s, Gourmetrestaurants, Kunstgalerien, Museen, Festivals, historischen St\xE4tten und Einkaufszentren. In der Stadt wimmelt es von Antiquit\xE4ten, Kultur, kulinarischen Gen\xFCssen, die gemeinsam Geschichten von der ersten \u201EGalil\xE4a Moshava\u201C und der Gr\xFCndung der j\xFCdischen Gemeinden in Israel erz\xE4hlen.</p>\n\t\t\t\t\t\t       \n         \t"};}},{id:"F_A_Q",bgImage:"/HomeSlider/Home/3.jpg",mobBgImage:"/HomeSlider/M/3.jpg",title:"FAQ",ctg:"TouristInfo",isVid:false,smlTitle:"",html:function html(){return{__html:"\n                        <h3>H\xE4ufig gestellte Fragen (FAQ) </h3>\n\n                                    <p>\n                                        <ol start=\"1\">\n\t\t\t\t\t\t\t\t\t         <li>\n\t\t\t\t\t\t\t\t                <strong>Ich bin als Tourist in Israel und bin besorgt, dass ich COVID-19 haben k\xF6nnte, an wen wende ich mich?</strong><br/>\n\t\t\t\t\t\t\t\t                Wenn Sie 38 \xB0C Fieber oder h\xF6her, Husten, Atembeschwerden oder andere Atemwegssymptome haben, m\xFCssen Sie sich sofort in Quarant\xE4ne begeben und die Notfall-Hotline 101 anrufen, um medizinischen Rat zu erhalten.<br>Gehen Sie auf keinen Fall in eine HMO-Klinik oder eine Notfallstation.</b>\n\t\t\t\t\t\t\t\t              </li>\n\t\t\t\t\t\t\t\t              <li>\n\t\t\t\t\t\t\t\t                <strong>Wann wird Israel wieder f\xFCr Besucher von au\xDFerhalb zug\xE4nglich sein?</strong><br/>\n\t\t\t\t\t\t\t\t                Zum gegenw\xE4rtigen Zeitpunkt ist kein Datum bekannt, an dem Israel f\xFCr Besucher von au\xDFerhalb zug\xE4nglich sein wird.\n\t\t\t\t\t\t\t\t              </li>\n\t\t\t\t\t\t\t\t\t       \n\t\t\t\t\t\t\t\t\t      </ol>\n                                    </p>\n                        <h3>One of the world's 25 best cities for foodies</h3>\n                        <p>F\xFCr einen Aufenthalt von bis zu drei Monaten ben\xF6tigen Reisende einen Reisepass, der mindestens sechs Monate \xFCber das Reisedatum hinaus, g\xFCltig ist. Menschen ohne Nationalit\xE4t ben\xF6tigen einen g\xFCltigen Passierschein sowie ein R\xFCckreisevisum in das ausstellende Land.</p>\n\t\t\t\t\t\t<p>Deutsche Reisende, die vor dem 01.01.1928 geboren sind, ben\xF6tigen ein Visum. Dieses kann bei der Israelischen Botschaft in Berlin beantragt werden.</p>\n\t\t\t\t\t\t<h3>Es gibt keine generellen Einreisebeschr\xE4nkungen f\xFCr Reisende, die mit arabischen Visavermerken im Reisepass nach Israel einreisen m\xF6chten.</h3>\n\t\t\t\t\t\t<p>&nbsp;Es kann sein, dass sich der Reisende einer Sicherheitsbefragung unterziehen und erkl\xE4rlich machen muss, welchen Zweck seine Reise in das entsprechende Land gehabt hat. Die endg\xFCltige Entscheidung \xFCber die Einreise trifft immer die Grenzbeh\xF6rde am Grenz\xFCbergang.<br>&nbsp;<br>Einwohnern der folgenden L\xE4nder werden geb\xFChrenfreie Touristenvisa, bzw eine automatisch erstellte Einreisekarte (\"Border Control Clearance\") an jedem Hafen oder Einreiseterminal nach Israel ausgestellt -&nbsp;<strong>es gibt keinen Passstempel mehr</strong>:</p>\n\t\t\t\t\t\t<p>Albanien, Andorra, Argentinien, Australien, Bahamas, Barbados, Belgien, Belize, Bolivien, Brasilien, Bulgarien, Chile, Costa Rica, D\xE4nemark, Deutschland (ab 1928 geborene), Dominica, Dominikanische Republik, Ecuador, El Salvador, Estland, Fiji, Finnland, Frankreich, Georgien, Gibraltar, Grenada, Griechenland, Gro\xDFbritannien, Guatemala, Haiti, Honduras, Hongkong, Irland, Island, Italien, Jamaika, Japan, Kanada, Kolumbien, Kroatien, Lettland, Lesotho, Liechtenstein, Litauen, Luxemburg, Macao, Makedonien, Malawi, Malta, Mauritius, Mexico, Mikronesien, Monaco, Mongolei, Montenegro, Niederlande, Neuseeland, Norwegen, \xD6sterreich, Palau, Panama, Paraguay, Peru, Philippinen, Polen, Portugal, Rum\xE4nien, Russische F\xF6deration, San Marino, Serbien (auch jugoslawische P\xE4sse),Singapur, Slowakei, Slowenien, St. Lucia, S\xFCdafrika, S\xFCdkorea, Spanien, St. Kitts &amp; Nevis, St. Vincent und die Grenadinen, Surinam, Swasiland, Schweden, Schweiz, Taiwan, Tonga, Trinidad &amp; Tobago, Tschechische Republik, Ukraine, Ungarn, Uruguay, Vatikanstaat, Vanuatu, Vereinigte Staaten von Amerika, Zentralafrikanische Republik, Zypern.<br>&nbsp;<br>F\xFCr weitere Informationen besuchen Sie :&nbsp;<a href=\"//embassies.gov.il/berlin/ConsularServices/Pages/local-visa-information.aspx\" target=\"_blank\">www.israel.de</a></p>\n\t\t\t\t\t\t<p>Kinder ben\xF6tigen f\xFCr die Einreise nach Israel einen Kinderreisepass mit einer Mindestg\xFCltigkeit von 6 Monaten.<br>Kinder die alleine oder nur mit einem Elternteil reisen, ben\xF6tigen die vom entsprechenden Konsulat beglaubigte Einverst\xE4ndniserkl\xE4rung beider bzw. des nicht mitreisenden Elternteils.</p>\n\t\t\t\t\t\t<h3>WIE LAUTEN DIE ZOLLBESTIMMUNGEN<span dir=\"RTL\">?</span></h3>\n\t\t\t\t\t\t<p>Die Ein- oder Ausfuhr von Geldmitteln (Bargeld, Barschecks, Reiseschecks) im Gegenwert von zusammen 80.000 Schekel und mehr muss angemeldet werden. Das entsprechende \u201EZoll-Formular Nr. 84\u201C kann telefonisch unter +972-2-658 7777 angefordert werden.</p>\n\t\t\t\t\t\t<p><a href=\"//embassies.gov.il/berlin/ConsularServices/Pages/Einreise.aspx\" target=\"_blank\">Welche Gegenst\xE4nde darf ich nach Israel einf\xFChren?&nbsp;</a><br>&nbsp;<br>Welche Vorschriften gibt es bez\xFCglich der Einfuhr von Haustieren nach Israel?<br>Pro Halter sind zwei Haustiere f\xFCr die Einreise erlaubt.<br>Sie ben\xF6tigen f\xFCr die Tiere<br>- ein amts\xE4rztliches Gesundheitszeugnis mit aktuellem Datum bis 7 Tage vor<br>Reiseantritt<br>- eine Erkl\xE4rung, dass sie das Tier mindestens seit 90 Tagen besitzen<br>- eine internationale Impfbescheinigung (gegen Tollwut/ nicht \xE4lter als 1 Jahr<br>und mind. 1 Monat vor Einreise)<br>- das Tier muss mindestens 3 Monate alt sein</p>\n\t\t\t\t\t\t<h3>IST ES SICHER, NACH ISRAEL ZU REISEN<span dir=\"RTL\">?</span></h3>\n\t\t\t\t\t\t<p>Israel ist f\xFCr Touristen eines der sichersten Reisel\xE4nder. 2016&nbsp;besuchten 3,06&nbsp;Mio. Touristen aus aller Welt das Heilige Land. 180.035&nbsp;G\xE4ste davon kamen aus Deutschland. Sie alle haben ohne besondere Vorkommnisse das Heilige Land bereist und sind wohlbehalten zur\xFCck nach Deutschland gekehrt.<br>Aufgrund der detaillierten Einreisebestimmungen konnten sich Besucher jederzeit sicher f\xFChlen in Israel und sich frei im Land bewegen. Die Heiligt\xFCmer, Sehensw\xFCrdigkeiten und Kulturerbest\xE4tten sind in der Regel ganzj\xE4hrig frei zug\xE4nglich.<br>Es ist jedoch ratsam, wie bei jedem anderen Reiseland auch, sich vor der Abreise \xFCber die aktuelle Situation vor Ort zu informieren.<br>Von den deutschen Besuchern kamen 70 Prozent als Individualreisende. An einer organisierten Rundreise nahmen 19 Prozent teil, w\xE4hrend sieben Prozent ein Pauschalangebot buchten.<br>Sollten Sie weitere Fragen zur Sicherheit haben kontaktieren Sie auch unser Tourismusb\xFCro in Berlin: Tel. 030 - 2039970 oder&nbsp;<a href=\"mailto:info-de@goisrael.gov.il\">info-de@goisrael.gov.il</a></p>\n\t\t\t\t\t\t<h3>D\xDCRFEN TOURISTEN BEREICHE BETRETEN, DIE AUSSERHALB DER VERANTWORTLICHKEIT ISRAELS LIEGEN<span dir=\"RTL\">?</span></h3>\n\t\t\t\t\t\t<p>Ein Durchgang zu den beiden Haupttouristenst\xE4dten Bethlehem und Jericho in pal\xE4stinensischer Verantwortung ist direkt und ohne vorherige Abfertigung oder erforderliche Genehmigung m\xF6glich.<br>&nbsp;<br>F\xFCr die Gebiete, die in der Verantwortung der PA liegen, wird empfohlen, Anfragen an das IDF Public Relations Office (B\xFCro f\xFCr \xD6ffentlichkeitsarbeit),<br>Fax: +972-2-5305724<br>zu senden. Alle Anfragen sollten enthalten: Name, Reisepassnationalit\xE4t und Nummer, Ziel, Name des Abreiseortes in das zu \xFCberquerende, pal\xE4stinensische Gebiet, falls bekannt; bei der \xDCberquerung mit dem Auto \u2013 Name und Details des Fahrers, sowie die Fahrzeugbriefnummer des Wagens. Antworten per Fax werden ausschlie\xDFlich an israelische Telefon/Faxnummern gesendet.</p>\n\t\t\t\t\t\t<h3>IST ES M\xD6GLICH, VON ISRAEL AUS NACH JORDANIEN ODER \xC4GYPTEN ZU REISEN?</h3>\n\t\t\t\t\t\t<p>Ja. Sie k\xF6nnen zwischen Israel, Jordanien und \xC4gypten hin- und herreisen. F\xFCr einen Ausflug nach \xC4gypten k\xF6nnen Sie den Grenz\xFCbergang Eilat/Taba benutzen. Das Visum f\xFCr \xC4gypten wird Ihnen direkt beim Grenz\xFCbergang (gegen Geb\xFChr) ausgestellt.</p>\n\t\t\t\t\t\t<p>In das Nachbarland Jordanien f\xFChren 3 Grenz\xFCberg\xE4nge:</p>\n\t\t\t\t\t\t<h3> Allenby-/King Hussein-Br\xFCcke</h3>\n\t\t\t\t\t\t<p>&nbsp;(hier ben\xF6tigen Sie vorab ein Visum, es wird nicht an der Grenze ausgestellt, es gelten besondere Konditionen)</p>\n\t\t\t\t\t\t<p>Die Grenze Allenby Bridge dient Pal\xE4stinensern und Touristen als \xDCbergang zwischen Israel und Jordanien sowie der Pal\xE4stinensischen Beh\xF6rde und Jordanien.<br>Zudem gibt es hier einen Fracht-Abschnitt, der den Warentransport zwischen Jordanien und der Pal\xE4stinensischen Autonomiebeh\xF6rde sowie zwischen Jordanien und Israel regelt.<br>Im Osloer Abkommen von 1994 wurde in Absprache mit der Pal\xE4stinensischen Autonomiebeh\xF6rde und mit der Unterzeichnung des Friedensabkommens festgelegt, dass der Grenz\xFCbergang Allenby Bridge der Israelischen Flughafenbeh\xF6rde unterstellt ist. Er liegt im Jordantal, \xF6stlich von Jericho (Yerikho), rund eine Autostunde sowohl vom israelischen Jerusalem als auch vom jordanischen Amman auf der k\xFCrzesten Strecke zwischen Amman und den St\xE4dten in Israels Zentrum entfernt. &nbsp;Er ist ein wichtiger Knotenpunkt im G\xFCterverkehrt zwischen Israel, der Pal\xE4stinensischen Autonomiebeh\xF6rde und Jordanien.<br>Israelis k\xF6nnen den Grenz\xFCbergang mit einem g\xFCltigen Visum der jordanischen Botschaft \xFCberqueren.<br>\xD6ffentliche Verkehrsmittel fahren von hier aus nach Jerusalem und Kirjat Schmona. Ebenso verkehren Einzel- und Sammeltaxis in alle Gegenden des Landes.</p>\n\t\t\t\t\t\t<p>Transfer&nbsp;<br>- Spezielle Tarif Taxen fahren in das ganze Land<br>- Taxiservice nach Ost-Jerusalem<br>- allgem. Taxen&nbsp;<br>- Buslinie 961 von Kiryat Shmona und von Jerusalem<br>- VIP Service (ca.110 $)</p>\n\t\t\t\t\t\t<p>Die Bushaltestelle befindet sich auf der Stra\xDFe Nr. 90 direkt neben dem oberen Eingangsbereich zur Grenze. Dieser Bereich kann nur mit dem Taxi angefahren werden. Passagiere k\xF6nnen nach \xFCberqueren der Grenze ein Taxi zum Bus nehmen und von dort nach Jerusalem oder bis in den Norden nach Tiberias fahren.</p>\n\t\t\t\t\t\t<p>Privatautos und Reisebusse d\xFCrfen nicht \xFCber die Grenze fahren.</p>\n\t\t\t\t\t\t<p>So - Do: 8.00 - 20.00 Uhr (Einreise nach Jordanien)<br>So - Do: 8.00 - 14.00 Uhr (Ausreise von Jordanien)<br>Fr/ Sa: &nbsp; 8.00 - 13.00 Uhr</p>\n\t\t\t\t\t\t<p>Hinweis: F\xFCr diesen Grenz\xFCbergang ben\xF6tigen Sie, wenn Sie von Israel nach Jordanien reisen m\xF6chten, vorab ein Visum. Es wird Ihnen kein Visum direkt vor Ort ausgestellt.</p>\n\t\t\t\t\t\t<p>Touristengruppen werden gebeten sich bei einer Einreise von Jordanien nach Israel vorab per Mail &nbsp;anzumelden:<br><a href=\"mailto:Allenby-info@iaa.gov.il\">Allenby-info@iaa.gov.il</a><br>Visa-Geb\xFChr: 173 NIS (ca. 35 EUR)<br>(ohne Gew\xE4hr)</p>\n\t\t\t\t\t\t<p>Der \xDCbergang ist am islamischen Neujahrstag und an Yom Kippur geschlossen.</p>\n\t\t\t\t\t\t<div>&nbsp;</div>\n\t\t\t\t\t\t<h3> Grenz\xFCbergang bei Eialt</h3>\n\t\t\t\t\t\t<p>F\xFCr Touristen-Gruppen&nbsp;werden vor Ort Visa ausgestellt, Einzelpersonen m\xFCssen ebenfalls vorab ein Visum beantragen.<br>Der Yitzhak-Rabin-Grenz\xFCbergang war der erste \xDCbergang, der nach dem Friedensabkommen zwischen Jordanien und Israel ge\xF6ffnet wurde. Er liegt ca. 3 km n\xF6rdlich von Eilat und dient vor allem Personen und Gruppen, die an kurzen Besuchen in den jeweiligen L\xE4ndern interessiert sind. Diese Touren und Tagesausfl\xFCge - speziell nach Petra/ Jordanien - werden \xFCberwiegend von den einzelnen Hotels und dem Tourist Office in Eilat organisiert.<br>Der Grenz\xFCbergang wird von Touristen und Israelis sowie f\xFCr den G\xFCterverkehr genutzt.</p>\n\t\t\t\t\t\t<p>Transfer zum und vom Grenz\xFCbergang<br>- mit dem Taxi<br>- dem Shared-Service-Taxi von Eilat<br>- privater PKW<br>Reisende mit dem PKW k\xF6nnen damit die Grenze passieren oder diesen am \xDCbergang parken.</p>\n\t\t\t\t\t\t<p>So - Do: 6.30 - 20.00 Uhr<br>Fr/ Sa: &nbsp; 8.00 - 20.00 Uhr<br>HINWEIS:<br>Bitte treffen Sie eine Stunde vor Schlie\xDFung am Grenz\xFCbergang ein.<br>Der \xDCbergang ist am islamischen Neujahrstag und an Yom Kippur geschlossen.</p>\n\t\t\t\t\t\t<p>Passierschein:<br>Am Yitzhak Rabin \xDCbergang erhalten israelische B\xFCrger und Touristen ein Visum \xFCber 2 Wochen, mit Ausnahme jener Touristen, die laut der jordanischen Bestimmungen ein Vorab-Visum ben\xF6tigen.<br>Geb\xFChr $ 56<br>(ohne Gew\xE4hr)</p>\n\t\t\t\t\t\t<div>&nbsp;</div>\n\t\t\t\t\t\t<h3> Sheikh Hussein - \xDCbergang/ Nordgrenze</h3>\n\t\t\t\t\t\t<p>&nbsp;(ganzj\xE4hrig 27/7 ge\xF6ffnet)</p>\n\t\t\t\t\t\t<p>Der Jordan-Grenz\xFCbergang liegt zwischen der Stadt Bet Sche'an und den Kibbuzim im Bet Sche\xB4an-Tal und ist der n\xF6rdliche Grenz\xFCbergang \xFCber den Jordan. Er befindet sich relativ nah an Amman, Haifa und dem Norden Israels und wird sowohl von Israelis als auch von Touristen genutzt. Busse und Taxis fahren von hier aus nach Bet Sche\xB4an.</p>\n\t\t\t\t\t\t<p>Je nach Nationalit\xE4t sollten Sie sich bei den entsprechenden Botschaften erkundigen, ob Sie ein Visum f\xFCr diese L\xE4nder ben\xF6tigen.</p>\n\t\t\t\t\t\t<p><span dir=\"RTL\"><a href=\"//de.visitjordan.com/generalinformation/gettingaround/bordercrossings.aspx\" target=\"_blank\"><strong><span dir=\"LTR\"> Weitere Informationen finden Sie auch beim Tourismusamt Jordanien</span></strong></a></span><br><a href=\"//international.visitjordan.com/generalinformation/entryintojordan.aspx#Northhttp://international.visitjordan.com/generalinformation/entryintojordan.aspx#North\" target=\"_blank\"><strong> Visakosten</strong></a></p>\n\t\t\t\t\t\t\t\t\t\t\t\t    \n         \t"};}},{id:"Electrical_Appliances",bgImage:"/HomeSlider/Home/3.jpg",mobBgImage:"/HomeSlider/M/3.jpg",title:"ELEKTRISCHE GERÄTE",ctg:"TouristInfo",isVid:false,smlTitle:"",html:function html(){return{__html:"\n                        <p<p dir=\"LTR\">Das einphasige Stromnetz in Israel liefert 220 Volt bei 50 Hertz. Die meisten Steckdosen in Israel haben drei Steckkontakte, aber die meisten von ihnen sind mit zweipoligen europ\xE4ischen Steckern kompatibel. Wer als Besucher mitgebrachte Rasierapparate, B\xFCgeleisen und andere Kleinger\xE4te verwenden m\xF6chte, ben\xF6tigt ggf. sowohl Transformatoren als auch Adapterstecker.</p>>Das einphasige Stromnetz in Israel liefert 220 Volt bei 50 Hertz. Die meisten Steckdosen in Israel haben drei Steckkontakte, aber die meisten von ihnen sind mit zweipoligen europ\xE4ischen Steckern kompatibel. Wer als Besucher mitgebrachte Rasierapparate, B\xFCgeleisen und andere Kleinger\xE4te verwenden m\xF6chte, ben\xF6tigt ggf. sowohl Transformatoren als auch Adapterstecker.</p>\n                        <p<p dir=\"LTR\"><a href=\"https://info.goisrael.com/en/things-to-do\" target=\"_blank\">Reiseempfehlungen auf der Website der Touristeninformation anzeigen</a><br><a href=\"https://info.goisrael.com/en/organized-tourism\" target=\"_blank\">Besucherservice auf der Website der Touristeninformation anzeigen</a></p>><a href=\"https://info.goisrael.com/en/things-to-do\" target=\"_blank\">Reiseempfehlungen auf der Website der Touristeninformation anzeigen</a><br><a href=\"https://info.goisrael.com/en/organized-tourism\" target=\"_blank\">Besucherservice auf der Website der Touristeninformation anzeigen</a></p>\n                        \t\t\t\t\t\t    \n         \t"};}},{id:"A_Magic_Place",bgImage:"/posts/bank/negev1/1.jpg",mobBgImage:"/posts/bank/negev1/M.jpg",title:"DIE NEGEV-WÜSTE EIN MAGISCHER ORT",ctg:"eilat-negev",isVid:false,smlTitle:"",html:function html(){return{__html:"\n                       <p>Die israelische W\xFCste bietet sich durch ihre atemberaubende Landschaft und zahlreiche Attraktionen als perfekter Ort f\xFCr ihren Urlaub an. In der Negev finden Besucher zahlreiche M\xF6glichkeiten f\xFCr spannende Erlebnisse.</p>\n\t\t\t\t\t\t<p>Israel ist ein kleines Land und die W\xFCste Negev macht 62&nbsp;% seiner Gesamtfl\xE4che aus. Charakteristisch f\xFCr die rot leuchtende W\xFCstenlandschaft sind ihre beeindruckenden geologischen Felsformationen. Besucher genie\xDFen hier die einzigartige unber\xFChrte, stille und majest\xE4tische Weite.</p>\n\t\t\t\t\t\t<div class=\"img-wrapper\">\n                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/a-magic-place/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t \t</div>\n\t\t\t\t\t\t<p>In der W\xFCste finden sich Spuren vergangener Zivilisationen und ihrer Landwirtschaft sowie andere arch\xE4ologische Fundst\xE4tten. Die Negev bildet einen unverwechselbaren Hintergrund f\xFCr die Begegnung mit den Nomadenst\xE4mmen - dem Volk der W\xFCste.</p>\n\t\t\t\t\t\t<p><strong>Gr\xFCnde, warum die W\xFCste Israels so besonders ist</strong>:</p>\n\t\t\t\t\t\t<ul style=\"padding-left: 18px;\">\n\t\t\t\t\t\t<li>\n\t\t\t\t\t\t<strong>Die W\xFCste liegt ganz in der N\xE4he</strong> - und ist nach einem nur vierst\xFCndigen Flug von Europa erreichbar. Israel verf\xFCgt \xFCber zwei internationale Flugh\xE4fen, Ben Gurion und Ovda, was die Anreise zur W\xFCste f\xFCr alle Reisenden kurz h\xE4lt (eine Stunde bis 90 Minuten).</li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t<div class=\"img-wrapper\">\n                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/a-magic-place/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t \t</div>\n\t\t\t\t\t\t<p>Ab November gibt es mehrere Direktfl\xFCge von Europa und Russland nach Ovda, z.&nbsp;B. mit <strong>Monarch</strong>, <strong>Ryanair</strong>, <strong>Wizzair</strong> und <strong>SAS</strong>.</p>\n\t\t\t\t\t\t<p\">Weitere Informationen finden Sie unter dem folgenden Link: <a href=\"//www.iaa.gov.il/en-US/airports/ovda/Pages/default.aspx\" target=\"_blank\">www.iaa.gov.il</a></p>\n\t\t\t\t\t\t<ul style=\"padding-left: 18px;\">\n\t\t\t\t\t\t<li>\n\t\t\t\t\t\t<strong>Vorbereitet auf Wanderer und Fahrradfahrer</strong>: In der W\xFCste finden sie zahlreiche markierte Wege. In Israel gibt es einige der eindrucksvollsten Wanderwege der Welt, und Hunderte von sicheren Routen f\xFChren durch die israelische W\xFCste. Eine Auswahl von Wanderwegen finden sie auf den folgenden Websites: <a href=\"//www.negevtour.co.il\" target=\"_blank\">www.negevtour.co.il</a> ; <a href=\"//www.en.aravaway.co.il\" target=\"_blank\">www.en.aravaway.co.il</a>&nbsp; &nbsp; &nbsp; &nbsp;</li>\n\t\t\t\t\t\t<li>\n\t\t\t\t\t\t<strong>Freundliche Bev\xF6lkerung</strong>: Die W\xFCstenbewohner sind sehr gastfreundlich und Machen das W\xFCstenerlebnis zu einer angenehmen und aufregenden Erfahrung f\xFCr alle Besucher.</li>\n\t\t\t\t\t\t<li>\n\t\t\t\t\t\t<strong>Aktivit\xE4ten f\xFCr Touristen</strong>: Parallel zur Entwicklung der Unterk\xFCnfte hat ein enormes Angebot touristischer Aktivit\xE4ten die Negev in den letzten Jahren zu einem beliebten, interessanten, vielseitigen und kreativen Reiseziel gemacht.</li>\n\t\t\t\t\t\t<li>\n\t\t\t\t\t\t<strong>Grandiose Panoramen</strong>: Heute genie\xDFen Touristen in gro\xDFer Zahl den Charme der Negev-W\xFCste mit ihren vielf\xE4ltigen Landschaften.\n\t\t\t\t\t\t<ul style=\"padding-left: 18px;\">\n\t\t\t\t\t\t<li>Im Norden warten die spektakul\xE4ren Sandd\xFCnen.</li>\n\t\t\t\t\t\t<li>Im Zentrum liegt der Ramon-Krater mit seinen rauen Klippen und saisonalen Wasserquellen.</li>\n\t\t\t\t\t\t<li>Im Osten f\xFChlt man sich in die afrikanische W\xFCste mit weiten Savannen und Akazienb\xE4umen versetzt.</li>\n\t\t\t\t\t\t<li>Und im S\xFCden findet man roten und schwarzen Granit, der mit dem Sandstein des Vorgebirges reizvolle Farbspiele bildet.</li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t<p>Bei einer ca. 3-st\xFCndigen Fahrt durch die W\xFCste k\xF6nnen sie das gesamte Spektrum der W\xFCstenlandschaft erleben und ihre Vielfalt genie\xDFen. In anderen W\xFCsten ist das nur mit langen Fahrten \xFCber viele Kilometer m\xF6glich.</p>\n\t\t\t\t\t\t<p>Viele Touristen entscheiden sich, 2 bis 3 Tage in der Negev-Region zu verbringen.</p>\n\t\t\t\t\t\t<ul style=\"padding-left: 18px;\">\n\t\t\t\t\t\t<li>\n\t\t\t\t\t\t<strong>Reisen in der Negev-W\xFCste ist sehr sicher.</strong> Die Rettungsteams, die bei Notf\xE4llen in der Region vor Ort sind, geh\xF6ren zu den am besten ausgebildeten Rettungskr\xE4ften der Welt und sind immer in der N\xE4he. Sollte ein Besucher medizinische Versorgung ben\xF6tigen, findet er in Israel moderne und erstklassige medizinische Einrichtungen.</li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t<h3>Weitere Informationen und Hinweise f\xFCr \xDCbernachtungen und sonstige Empfehlungen:</h3>\n\t\t\t\t\t\t<p><a href=\"//www.negevtour.co.il\" target=\"_blank\">www.negevtour.co.il</a></p>\n\t\t\t\t\t\t<p><a href=\"//www.en.aravaway.co.il\" target=\"_blank\">www.en.aravaway.co.il</a></p>\n\t\t\t\t\t\t<p>Reiseangebote</p>\t\t\t\t\t\t    \n         \t\n         \t"};}},{id:"The_Arava",bgImage:"/posts/bank/negev2/1.jpg",mobBgImage:"/posts/bank/negev2/M.jpg",title:"DIE ARAVA: ÜBERRASCHE DICH SELBST!",ctg:"eilat-negev",isVid:false,smlTitle:"",html:function html(){return{__html:"\n                       \n\t\t\t\t\t\t\n\t\t\t\t\t\t\n\n\t\t\t\t\t \t    <p>Zwischen der Menucha-Kreuzung im Norden bis zum ersten Kreisverkehr am Rand von Eilat, eingefasst von der Negev-W\xFCste und der Eilat-Gebirgskette im Westen und dem Edom-Gebirge im Osten: Das ist die Arava. Eine schmale, aber atemberaubender Landschaft, wo sie die W\xFCste mit allem, was sie zu bieten hat, <i>f\xFChlen</i> - zu zweit, mit der Familie oder in der Gruppe. Besucher k\xF6nnen die Arava auf verschiedene Weise erkunden - zu Fu\xDF, mit dem Fahrrad, dem Auto oder Bus. Die \xDCbernachtungsm\xF6glichkeiten reichen von Luxushotels \xFCber \u201EGlamping\u201C bis zum Schlafen im Freien unter dem Sternenhimmel. Hier stellen wir ihnen einige der Sehensw\xFCrdigkeiten und Aktivit\xE4ten vor, die sie nicht verpassen sollten:</p>\n\t\t\t\t\t\t\t<h3>Timna-Nationalpark</h3>\n\t\t\t\t\t\t\t<p>Das neue Besucherzentrum am Eingang zum Nationalpark hei\xDFt sie mit einer informativen Einf\xFChrung in die erstaunliche Landschaft von Timna willkommen. Hier sorgt von der Natur geformter roter Sandstein gemeinsam mit den schwarzen und wei\xDFen Felsen f\xFCr eine dramatische Szenerie. Der U-f\xF6rmige Timna-Nationalpark birgt Sch\xE4tze aus diversen Zeitaltern und erz\xE4hlt die Geschichte von \xE4gyptischen Kupferbergwerken, die bis heute Erz liefern, anhand echter Relikte und an den original Fundst\xE4tten.</p>\n\t\t\t\t\t\t\t<p>Im Timna-Park gibt es \xFCber 25 Wander- und Fahrradwege (darunter auch anspruchsvolle Trails) sowie Autostrecken mit fantasievollen Namen wie <b>Mushroom</b>, <b>Arches</b>, <b>Solomon\u2018s Pillar</b>, <b>Pink Canyon</b>, <b>Corkscrew</b> und <b>Faces</b>. Und es gibt noch mehr: eine exakte Replik des biblischen Tabernakels, das die Israelis bei ihrer Wanderung \xFCber die Sinai-Halbinsel mitf\xFChrten, ein See mit Tretbooten, Flaschenherstellung aus farbigem Sand und andere Kunsthandwerke, einen Fahrradverleih, einen beaufsichtigten Campingplatz und das King Solomon's Inn, wo sie eine Erfrischung in der W\xFCste genie\xDFen und Souvenirs kaufen k\xF6nnen.</p>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/the-arava/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t \t</div>\n\t\t\t\t\t\t\t<h3>Naturschutzgebiet Hai-Bar</h3>\n\t\t\t\t\t\t\t<p>Die Zielsetzung des Hai Bar Biblical Wildiife Reserveist die Wiedereinf\xFChrung von Tieren in die Natur Israels, die in der Bibel erw\xE4hnt werden.Heute leben die Tiere in ihren nat\xFCrlichen Habitaten gesch\xFCtz; sie werden gepflegt und k\xF6nnen von Besuchern beobachtet werden.. Dazu werden auf den Rundstrecken f\xFCr motorisierte Fahrzeuge auch Safaris angeboten, auf denen sie Oryxantilopen, Mendesantilopen und Strau\xDFe zu sehen bekommen, umgeben von W\xFCstenpflanzen, zu denen auch die biblische Akazie geh\xF6rt. CDs mit F\xFChrungen in zahlreichen Sprachen k\xF6nnen sie in unserem Shop k\xE4uflich erwerben. Gef\xFChrte Touren finden samstags um 11:00 Uhr statt - wenn die Tiere ihren \u201EBrunch\u201C bekommen. Es gibt auch einen Campingplatz mit Versorgungseinrichtungen.</p>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<h3>Eilat Gew\xFCrzfarm</sh3>\n\t\t\t\t\t\t\t<p>Die Farm forscht auf dem Gebiet der Marikultur. Sie befindet sich an der Kreuzung der antiken Gew\xFCrzroute und Meeresroute mit Blick auf das Edom-Gebirge. Seetang, Muscheln, Artemia-Krebse und K\xF6nig-Salomon-Zwergbarsche (nach dem Besitzer der Farm, der sie entdeckt hat, auch als Fridmans Zwergbarsch bzw. Pseudochromis fridmani bekannt) werden hier gezogen.</p>\n\t\t\t\t\t\t\t<p>Das Besucherzentrum ist ein Fest f\xFCr die Sinne. Nach dem Eintreten befindet man sich in einer Wolke von D\xFCften der unz\xE4hligen Gew\xFCrze, Gew\xFCrzmischungen und Aufg\xFCsse, die zum Kochen und zu medizinischen Zwecken verwendet werden. Hier gibt es auch besondere Kochger\xE4te und K\xFCchenhilfen, in deren Gebrauch sie das freundliche Personal gerne einweist.</p>\n\t\t\t\t\t\t\t<h3>\xD6kologisches Leben in Ne\xF3t Smad\xE1r</h3>\n\t\t\t\t\t\t\t<p>Spazieren sie selbst\xE4ndig durch die Gemeinde Ne\xF3t Smad\xE1r, in der es ein fantastisches Kunstzentrum zu entdecken gibt, dessen Aufbau \xFCber 13 Jahre gedauert hat. Erkunden sie das Gel\xE4nde, in dem eine Mischung Detailverliebtheit und Bodenst\xE4ndigkeit zum Ausdruck kommt, sowie die \xF6kologischen Weinberge des s\xFCdlichsten Weinguts in Israel.</p>\n\t\t\t\t\t\t\t<p>Im Kunstzentrum befinden sich Werkst\xE4tten von Kunsthandwerkern und eine Galerie, in der sie ihre Kunst ausstellen und verkaufen. Im Mittelpunkt des Bauwerks, gekennzeichnet durch seinen unverwechselbaren Turm, befindet sich ein Wasserschacht, mit dem das gesamte Geb\xE4ude anstelle einer konventionellen Klimaanlage gek\xFChlt wird. Alle Innen- und Au\xDFenfl\xE4chen des Zentrums sind mit Holzschnitzereien geschm\xFCckt, die von den Mitgliedern der Gemeinschaft angefertigt wurden.</p>\n\t\t\t\t\t\t\t<h3>Avara bei Nacht</h3>\n\t\t\t\t\t\t\t<p>Die Landschaft ver\xE4ndert sich in der Abendd\xE4mmerung: Das Edom-Gebirge wechselt zu immer dunkleren Rot- und Lilat\xF6nen und wird schlie\xDFlich im Sternen- und Mondlicht gebadet. Und wenn es Zeit wird, schlafen zu gehen, helfen wir ihnen, die passende und bequemste Unterkunft zu finden. Sie erreichen uns (WHO IS US? HERE IS JUST A NUMBER?) telefonisch unter +972 (8) 6616976.</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t    \n\t\t\t\t\t\t\t         \t\n         \t"};}},{id:"Action_Fun_In_Desert",bgImage:"/posts/bank/negev1/1.jpg",mobBgImage:"/posts/bank/negev1/M.jpg",title:"ACTION-SPAß IN DER WÜSTE ISRAELS",ctg:"eilat-negev",isVid:false,smlTitle:"",html:function html(){return{__html:"\n                       \n\t\t\t\t\t\t\t    \n\n\t\t\t\t\t\t\t \t<p>In der israelischen W\xFCste gibt es wunderbare Panoramablicke, historische Sehensw\xFCrdigkeiten und reihenweise M\xF6glichkeiten f\xFCr spa\xDFige Aktivit\xE4ten, die gr\xFCndlich mit der Vorstellung aufr\xE4umen, die W\xFCste sei ein karger Ort.</p>\n\t\t\t\t\t\t\t\t<h2>Die einzigartige W\xFCste</h2>\n\t\t\t\t\t\t\t\t<p>Die Sch\xF6nheit der Natur in den vier gro\xDFen W\xFCstenzonen - dem Toten Meer, dem Eilat-Gebirge, der Negev-W\xFCste und der Jud\xE4ische W\xFCste - wird ihnen die Sprache verschlagen. Touristen tauchen auf einer Wanderung durch das einzigartigen Farbspiel der Felsformationen des Ramon-Kraters und die dunkel gl\xFChenden T\xF6ne des Timna-Parks vor Eilat in eine andere Welt ein. Sich an den vielfarbigen H\xE4ngen abzuseilen oder auf dem staubigen W\xFCstentrail an seine Grenzen zu gehen ist noch besser, wenn am Ende eine erfrischende Oase wie Ein Gedi in der N\xE4he des Toten Meers lockt. Bei einer \xDCbernachtung auf einem der Campingpl\xE4tze mit umfassendem Serviceangebot werden sie mehr Sterne sehen, als sie je f\xFCr m\xF6glich gehalten haben. Und vielleicht erhaschen sie sogar einen Blick auf die scheuen, nachtaktiven Tiere der W\xFCste!</p>\n\t\t\t\t\t\t\t\t<p>Fr\xFChling, Herbst und Winter sind die besten Jahreszeiten f\xFCr einen Besuch im trockenen Klima der W\xFCsten Israels. Unternehmen sie in der ber\xFChmten Festung Masada eine Zeitreise in die Vergangenheit und erfahren sie mehr \xFCber das bittere Ende der letzten Schlachten der Juden gegen das r\xF6mische Reich und lassen sie sich vom Prunk des Palasts von K\xF6nig Herod den Atem rauben. Erforschen sie unerwartete byzantinische Ruinen und die erstaunliche Kultur der uralten, aus dem W\xFCstenfels geschlagenen Siedlungen der Nabat\xE4er, die auf ihre Erkundung warten.</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/action-fun/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t \t</div>\n\t\t\t\t\t\t\t\t<h2>Spa\xDF mit Action in der W\xFCste</h2>\n\t\t\t\t\t\t\t\t<p>Die W\xFCste Israels steckt voller spannender Aktivit\xE4ten. Bei einer aufregenden Jeep-Tour, die durch die einzigartige Landschaft der Negev-W\xFCste f\xFChrt, kann man auch schon einmal richtig durchgesch\xFCttelt werden. Oder sie mieten Mountain-Bikes, um sich selbst in der au\xDFergew\xF6hnlichen Sch\xF6nheit der farbigen Felsformationen im Timna Park oder auf den W\xFCstentrails herauszufordern. Entspannen sie sich gemeinsam mit der Familie oder Freunden bei einem entspannten Ausritt auf Pferden durch die Jud\xE4ische W\xFCste, oder genie\xDFen reife Datteln bei einem Glas Minztee bei den gastfreundlichen Beduinen in der Negev-W\xFCste.</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/action-fun/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t \t</div>\n\t\t\t\t\t\t\t\t<p>Reiben sie sich an den Ufern des Toten Meers mit dem heilendem Mineralschlamm ein, w\xE4hrend sie das Panorama mit den majest\xE4tischen Gebirgsz\xFCgen und dem blauen Wasser neben sich genie\xDFen. Extremsport-Fans k\xF6nnen sich beim Sandsurfen an den gewaltigen D\xFCnenh\xE4ngen der Negev-W\xFCste dem Nervenkitzel hingeben, der mit der rasenden Fahrt \xFCber die meilenweiten Sandfl\xE4chen einhergeht.</p>\n\t\t\t\t\t\t\t\t<p>In den W\xFCsten Israels wartet mehr Spa\xDF auf sie, als sie sich vorstellen k\xF6nnen.</p>\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t    \n\t\t\t\t\t\t\t         \t\n         \t"};}},{id:"Eilat_Sensational",bgImage:"/posts/bank/eilat2/1.jpg",mobBgImage:"/posts/bank/eilat2/M.jpg",title:"SENSATIONELL - EIN ENDLOS LANGER SOMMER",ctg:"eilat-negev",isVid:false,smlTitle:"",html:function html(){return{__html:"\n                       \n\t\t\t\t\t\t\t    <h3>Eilat ist die Stadt am Roten Meer und zugleich Israels beliebtester Ferienort, der jedes Jahr etwa 2,8 Millionen Besucher an die Str\xE4nde des atemberaubenden Roten Meeres lockt.</h3>\n\t\t\t\t\t\t\t\t<p >Eilat ist die s\xFCdlichste Stadt in Israel und bekannt f\xFCr eine spektakul\xE4re Kombination der umgebenden W\xFCstenlandschaft, dem sch\xF6nen Strand und der Sommersonne, die das ganze Jahr \xFCber scheint.</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/sensational/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t \t</div>\n\t\t\t\t\t\t\t\t<p >Ganz gleich, ob Sie mit der Familie, als Paar oder ganz allein in Eilat Urlaub machen, Sie werden eine Menge sehen und unternehmen. Unterk\xFCnfte finden sich von 5-Sterne-Luxushotels bis hin zu gem\xFCtlichen Privatunterk\xFCnften (Airbnb) und Jugendherbergen.</p>\n\t\t\t\t\t\t\t\t<p >Mit seinen 360 Sonnentagen im Jahr ist Eilat extrem popul\xE4r bei Touristen von nah und fern, die aus ihrem kalten Winterklima fl\xFCchten.</p>\n\t\t\t\t\t\t\t\t<p >Ein Besuch in Eilat ist ein unterhaltsames Erlebnis, bei dem Sie entspannen und gleichzeitig auftanken k\xF6nnen. Dieser lebendige Ferienort bietet eine F\xFClle an ganzj\xE4hrigen Aktivit\xE4ten und Attraktionen, ausgezeichneten Restaurants und Caf\xE9s, Einkaufszentren und angesagten Bars und Clubs.<br>Und das Beste? Alles in Eilat ist nur einen Katzensprung vom Strand entfernt.</p>\n\t\t\t\t\t\t\t\t<h3>Tauchen Sie ein ins Rote Meer</h3>\n\t\t\t\t\t\t\t\t<p >Eine einmalige Attraktion an sich ist Eilats fantastisches Rote Meer und seine 10 Kilometer lange K\xFCste, die den Mittelpunkt und die Hauptattraktion f\xFCr Touristen aus aller Welt darstellen.<br>Mit seinem sauberen, klaren und unerwartet k\xFChlen Wasser ist es ein willkommener R\xFCckzugsort von den hei\xDFen Temperaturen und trockenen Luft der Stadt. Viele Sehensw\xFCrdigkeiten und Attraktionen erwarten Sie an den Str\xE4nden von Eilat, ein perfekter Ort zum Sonnenbaden und Entspannen.</p>\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/sensational/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t \t</div><p >Extremsportliebhaber werden die Wassersport-Clubs entlang der S\xFCd- und Nordk\xFCste von Eilat lieben mit ihren Angeboten wie Jetskifahren, Bananenboot, Kayak- und Schlauchfahren und vieles mehr.</p>\n\t\t\t\t\t\t\t\t<h3>Sp\xFCren Sie die Atmosph\xE4re</h3>\n\t\t\t\t\t\t\t\t<p >Am Abend geht die hei\xDFe W\xFCstensonne in Eilat unter und die Pools und Str\xE4nde schlie\xDFen. Genau die Zeit, sich f\xFCr das fantastische Nachtleben in der Stadt fertig zu machen. Eilat h\xE4lt einen einzigartigen Rekord: die Stadt mit den meisten Clubs, Bars und Veranstaltungsorten pro Kopf in Israel. Es mangelt also nicht an Auswahlm\xF6glichkeiten f\xFCr einen vergn\xFCglichen Abend.</p>\n\t\t\t\t\t\t\t\t<h3>Ein W\xFCstenabenteuer</h3>\n\t\t\t\t\t\t\t\t<p >N\xF6rdlich der Stadt liegt die s\xFCdliche Arava, eine Region mit atemberaubenden Ausblicken auf die W\xFCste und ein Ort, der absolut zu empfehlen ist. Hier k\xF6nnen Sie die endlose Weite sp\xFCren und steilen Klippen und B\xE4chen folgen sowie durch T\xE4ler wandern und vieles mehr.</p>\n\t\t\t\t\t\t\t\t<p >Die farbenpr\xE4chtige und einzigartige Bergwelt von Eilat bietet nicht nur einen atemberaubenden Ausblick, sondern vor allem Naturliebhabern ein unvergessliches Erlebnis. Es gibt zahlreiche Routen und St\xE4tten zu besichtigen, die es sich lohnt &nbsp;zu Fu\xDF, mit dem Fahrrad, Auto oder dem Kamel zu erkunden. Extremsportler k\xF6nnen sogar Klettern oder sich an atemberaubenden Bergh\xE4ngen abseilen.</p>\n\t\t\t\t\t\t\t\t<p >Worauf warten Sie noch? Besuchen Sie Eilat. Ab in die Sonne.</p>\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t    \n\t\t\t\t\t\t\t         \t\n         \t"};}},{id:"Discover_Jerusalem",bgImage:"/posts/bank/jerusalem6/1.jpg",mobBgImage:"/posts/bank/jerusalem6/M.jpg",title:"JERUSALEM ENTDECKEN",ctg:"jerusalem",isVid:true,vidId:"1byfX1O7u4g",smlTitle:"",html:function html(){return{__html:"\n                       \n\t\t\t\t\t\t\t   \n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\n                                 <h2>Entdecken Sie die Geheimnisse des j\xFCdischen Jerusalem in der geschichtstr\xE4chtigen Altstadt</h2>\n\t\t\t\t\t\t\t \t<p>Begeben Sie sich auf eine unvergessliche spirituelle Reise in das atemberaubende Jerusalem</p>\n\t\t\t\t\t\t\t\t<p>Jerusalem l\xE4dt Sie ein \u2013 seien Sie gast dieser wunderbaren Stadt. Erklimmen Sie die Berge, flanieren Sie durch die Innenstadt und f\xFChlen Sie die einzigartige Mischung aus Vergangenheit und Gegenwart, dem Allt\xE4glichem und Au\xDFergew\xF6hnlichem. Als eine der \xE4ltesten St\xE4dte der Welt, heilig f\xFCr Juden, Christen und Muslime, bietet Jerusalem ein unvergleichliches Erlebnis f\xFCr die Sinne und den Geist.</p>\n\t\t\t\t\t\t\t\t<h3>Eintreten. </h3>\n\t\t\t\t\t\t\t\t<p>Das Herz der heiligsten Stadt im Judentum ist die Altstadt. Betreten Sie den historischen Eingang, das <em>Jaffator</em>, oder gehen Sie durch das <em>Zionstor</em>, das direkt zum <strong>j\xFCdischen Viertel </strong>f\xFChrt, eins der vier Stadtviertel der von Mauern umgebenen Stadt und weitestgehend Heimat von Juden seit dem Jahr 8 vor unserer Zeitrechnung. Gehen Sie durch die Gassen, sehen Sie sich die Menschen an, besuchen Sie den <strong>Cardo</strong>, Jerusalems \xE4lteste Hauptstra\xDFe und saugen Sie die einzigartige Atmosph\xE4re in sich auf. Sie wandern auf den Spuren des K\xF6nigs und Propheten \u2013 das ist etwas ganz Besonderes.</p>\n\t\t\t\t\t\t\t     <div class=\"img-wrapper\">\n\t\t                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/discover-jerusalem/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t \t</div>\n\t\t\t\t\t\t\t\t<h3>Erleben Sie, wie Geschichte lebendig wird und f\xFChlen Sie die tiefe spirituelle Energie innerhalb der Mauern</h3>\n\t\t\t\t\t\t\t\t<h3>Was liegt vor Ihnen. </h3>\n\t\t\t\t\t\t\t\t<p>Die letzten \xDCberreste der antiken Mauern, die den Zweiten Tempel umgaben, die <strong>Klagemauer</strong>, ist ein Symbol j\xFCdischer Sehns\xFCchte nach einer angestammten und geistigen Heimat. Gl\xE4ubige Juden beten auf dem Platz vor der Mauer ,der Platz, an dem laut Judentum Gott wohnt.&nbsp; Ganz gleich welchen Glauben Sie selbst haben, es ist ein Erlebnis voller Emotionen aber auch Demut. W\xFCrdigen Sie diesen Ort und hinterlassen Sie in der Mauer eine Notiz mit einem Gebet oder einem Wunsch</p>\n\t\t\t\t\t\t\t\t<h3>Was liegt daneben. </h3>\n\t\t\t\t\t\t\t\t<p>Jerusalem ist praktisch mit historischen St\xE4tten \xFCbers\xE4t und das Eintauchen in die Historie bekommt hier eine vollkommen neue Bedeutung.</p>\n\t\t\t\t\t\t\t\t<p>Machen Sie einen Rundgang durch die faszinierenden <strong>Klagemauertunnel</strong> und entdecken Sie die verborgenen Bereiche der Klagemauer. Geschichte wird lebendig, sobald Sie die unterirdischen G\xE4nge entlanggehen, entdecken Sie das Leben in Jerusalem w\xE4hrend der Zweiten Tempel-Periode und erfahren Sie alles \xFCber Kunst, Architektur und Bauweisen.</p>\n\t\t\t\t\t\t\t\t<p>Besuchen Sie die nahegelegene arch\xE4ologische interessante <strong>Davidsstadt</strong> und erfahren Sie mehr \xFCber die Geschichte der Stadt, die David vor 3.000 Jahren als vereinigte Hauptstadt der 12 V\xF6lker von Israel deklarierte. Machen Sie eine Reise zwischen den antiken Mauern und Festungen, verborgenen Quellen, an denen K\xF6nige gekr\xF6nt wurden und folgen Sie dem Pfad, auf dem die Einwohner Jerusalems nach der Eroberung der Stadt durch die R\xF6mer fl\xFCchteten.</p>\n\t\t\t\t\t\t\t\t<h3>Bestaunen Sie den atemberaubenden au\xDFergew\xF6hnlichen Ausblick und lassen Sie es sich gut gehen</h3>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/discover-jerusalem/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t \t</div>\n\t\t\t\t\t\t\t\t<h3>Was liegt dar\xFCber. </h3>\n\t\t\t\t\t\t\t\t<p>Urspr\xFCnglich zum Schutz der Stadt vor Eindringlingen erbaut, ist Jerusalem von Mauern umgeben. Heute haben Sie von den <strong>Mauern Jerusalems</strong> aus die M\xF6glichkeit, die Stadt aus einem anderen Blickwinkel zu erkunden. H\xF6ren Sie sich die Geschichten an und genie\xDFen Sie die Sch\xF6nheit dieser Stadt von oben.</p>\n\t\t\t\t\t\t\t\t<p>Sie haben gerade erst die Oberfl\xE4che erreicht.</p>\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t    \n\t\t\t\t\t\t\t         \t\n         \t"};}},{id:"Atractions_In_Eilat",bgImage:"/posts/bank/eilat1/1.jpg",mobBgImage:"/posts/bank/eilat1/M.jpg",title:"WAGEN SIE EINEN SPRUNG",ctg:"eilat-negev",isVid:true,vidId:"wTR-9PxXn-E",smlTitle:"",html:function html(){return{__html:"\n                                 <h2>Erleben Sie die Wasserattraktionen in Eilat</h2>\n\t\t\t\t\t\t\t \t<p>Erfreuen Sie sich an den Wasserattraktionen in Eilat und erleben Sie einen ultimativen Strandausflug</p>\n\t\t\t\t\t\t\t\t<p>Eilat ist die s\xFCdlichste Stadt in Israel umgeben von Wasser, eine nasse und wilde Abenteuerwelt wie sonst nirgendwo im Land. Eilat bietet erstklassige Str\xE4nde, Wassersport, Aktivit\xE4ten und Attraktionen, die aufgrund des warmen Klimas das ganze Jahr \xFCber ge\xF6ffnet sind.</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/atractions-in-eilat/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t \t</div>\n\t\t\t\t\t\t\t\t<p>Tauchen Sie Ihre Zehen in das klare, blaue Wasser an Eilats Str\xE4nden, die auf etwa zw\xF6lf Kilometern L\xE4nge Sand, eine Strandpromenade, Hotels und viele Attraktionen anbieten. Entspannen Sie an einem der abgelegeneren, ruhigen St\xE4nde im S\xFCden und schwimmen Sie um die Korallenriffs. Tauchen Sie ein in die lebhafte Touristenszene an den Str\xE4nden im Norden, an denen Hotels, Restaurants und Gesch\xE4fte auf Sie warten. Oder machen Sie einen Segelt\xF6rn und erkunden die Region vom Wasser aus: Sonne tanken, abschalten und Spa\xDF haben.</p>\n\t\t\t\t\t\t\t\t<p>Erforschen Sie die einzigartige Sch\xF6nheit des Coral Beach Naturreservats in Eilat. Ziehen Sie Ihre Schnorchelausr\xFCstung an und beobachten Sie unter Wasser die Meerestiere.</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/atractions-in-eilat/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t \t</div>\n\t\t\t\t\t\t\t\t<p>Eilat ist das Zentrum f\xFCr alle Wasseraktivit\xE4ten in Israel. Sp\xFCren Sie den Wind in Ihrem Haar und die Sonne auf Ihrer Haut, wenn Sie beim Wasserski, Jetski, Bananenboot, Surfen oder bei einer Glasbodenboot-Fahrt durch das Wasser schnellen. M\xF6chten Sie lieber \xFCber Wasser bleiben? Dann k\xF6nnen Sie beim Parasegeln \xFCber die Eilat Bay das Wasser von oben aus betrachten.</p>\n\t\t\t\t\t\t\t\t<p>Oder bevorzugen Sie Tiere in der freien Natur? Schwimmen oder schnorcheln Sie mit Delfinen im Eilat Dolphin Reef. An diesem einzigartigen, \xF6kologischen Standort inmitten eines bezaubernden Strandes k\xF6nnen Besucher Delfine beobachten und an spannenden Outdoor-Abenteuern teilnehmen. Oder haben Sie Lust auf ein Unterwassererlebnis, bei dem Sie nicht nass werden? Dann machen Sie einen Ausflug zum Eilat Underwater Observatory, ein faszinierender Einblick in das Leben unterhalb des Meeresspiegels kombiniert mit interaktiven Angeboten und Sonderausstellungen.</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t    \n\t\t\t\t\t\t\t         \t\n         \t"};}},{id:"The_Dolphin_Reef",bgImage:"/posts/bank/eilat1/1.jpg",mobBgImage:"/posts/bank/eilat1/M.jpg",title:"DAS DOLPHIN REEF EILAT",ctg:"eilat-negev",isVid:true,vidId:"HzBX-XW9T0c",smlTitle:"",html:function html(){return{__html:"\n                                 <h2>Eine unvergessliche Begegnung mit der Tierwelt</h2>\n\t\t\t\t\t\t\t \t\n\t\t\t\t\t\t\t \t<p>Begegnen Sie Delfinen in Eilats einzigartiger Meeresattraktion</p>\n\t\t\t\t\t\t\t\t<p>Das Dolphin Reef Eilat ist ein Wildgehege an den K\xFCste des Roten Meeres, wo Abenteuer mit Natur und Erholung aufeinandertrifft. Am Riff betreten Besucher einen Ort, der die Besucher sofort in seinen Bann zieht, &nbsp;Hier k\xF6nnen Sie Delfine in ihrer nat\xFCrlichen Umgebung begegnen; ein spektakul\xE4rer Strand, mit einer bl\xFCtenpr\xE4chtigen Pflanzenvielfalt und einer atemberaubenden Aussicht warten auf Sie.</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/the-dolphin-reef/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t \t</div>\n\t\t\t\t\t\t\t\t<p>An einem langgedehnten Pier kann man die heimischen gro\xDFen T\xFCmmler dabei beobachten, wie sie ihrer t\xE4glichen Routine nachgehen beim Essen, Spielen und Jagen und ihr Sozialverhalten studieren - hin und wieder werden f\xFCr Besucher auch begleitete Schnorchel- oder Tauch-G\xE4nge angeboten.</p>\n\t\t\t\t\t\t\t\t<p>Ein sch\xF6nes Erlebnis ist das Beobachten der Delfine w\xE4hrend der F\xFCtterung. Es ist spannend, Delfine beim Spielen zu Beobachten und das Kindliche in ihnen zu entdecken, wenn sie auf ihr Futter warten. Und wenn das Essen dann erst \u201Eangerichtet\u201C ist, l\xF6st die Freude der Tiere jedes Mal Beifall beim Publikum aus.</p>\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t<p>Die Sch\xF6nheit des Dolphin Reef liegt darin, dass Besucher ganz nah an die Tiere herankommen d\xFCrfen, z.B. beim Tauchen mit den Delfinen, und sie in ihrem \xD6kosystem beobachten k\xF6nnen. Auf sechs Meter Tiefe abtauchen und das grandiose und verborgene Leben erleben. Besucher k\xF6nnen auch an der Oberfl\xE4che mit den Delfinen schnorcheln und sich neben den Delfinen treiben lassen und mit ihnen interagieren.Bei allen Interaktionen obliegt es den Delfinen selbst \u201Emitzumachen\u201C.</p>\n\t\t\t\t\t\t\t\t<p>Am Entspannungspool des Dolphin Reef k\xF6nnen Besucher Alltagsstress und Hektik &nbsp;bei entspannter Musik ganz einfach abklingen lassen. F\xFCr das leibliche Wohl ist auch gesorgt, sodass Besucher diese sch\xF6ne Anlage nicht verlassen m\xFCssen.</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n         \t"};}},{id:"Jerusalem_",bgImage:"/posts/bank/jerusalem1/1.jpg",mobBgImage:"/posts/bank/jerusalem1/M.jpg",title:"ABENTEUER DURCH DIE ZEIT",ctg:"jerusalem",isVid:false,smlTitle:"",html:function html(){return{__html:"\n                             \n\t\t\t\t\t\t\t \t\n\t\t\t\t\t\t\t    \n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t \t<h2>EINE STADT DER MAGIE UND MIT EINER AUSSTRAHLUNG JENSEITS IHRER VORSTELLUNGSKRAFT</h2>\n\t\t\t\t\t\t\t\t<p>Jerusalem ist die Hauptstadt von Israel und bei weitem die ber\xFChmteste und faszinierendste Stadt der Welt mit ihrer Jahrtausende alten, glorreichen Geschichte, die in das moderne Leben integriert wird.</p>\n\t\t\t\t\t\t\t\t<p>Entdecken Sie die \xFCberw\xE4ltigende Kraft dieser 3.000 Jahre alten Stadt - ihre unz\xE4hligen historischen St\xE4tten und arch\xE4ologischen Wunder, ihre magischen Wege und herrlichen</p>\n\t\t\t\t\t\t\t\t<p>Aussichten, die garantiert einen bleibenden Eindruck hinterlassen. Gleichzeitig versprechen die modernen Attraktionen Spannung und Vergn\xFCgen rund um die Uhr f\xFCr alle Liebhaber von Kultur, Kunst, Musik und kulinarischen Gen\xFCssen.</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/jeru-salem/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t \t</div>\n\t\t\t\t\t\t\t\t<h3>Spazieren Sie durch 3.000 Jahre ruhmreiche Geschichte</h3>\n\t\t\t\t\t\t\t\t<p>Die Altstadt von Jerusalem ist bei allen Besuchern und auch bei Einheimischen sehr beliebt. Sie ist von einer antiken Mauer umgeben, die im Laufe der Geschichte wieder aufgebaut wurde. Es gibt sieben Tore, die zu historischen und heiligen St\xE4tten f\xFChren. Bahnen Sie sich Ihren Weg durch Pflasterstra\xDFen und eine \xFCber viertausend Jahre alte Geschichte, bei der Sie aus dem Staunen nicht mehr herauskommen, wenn moderne und vergangene Architekturen aufeinander treffen.</p>\n\t\t\t\t\t\t\t\t<h3>Lernen Sie das moderne, lebhafte Jerusalem kennen</h3>\n\t\t\t\t\t\t\t\t<p>Au\xDFerhalb der Altstadt finden Sie alles, was eine typische moderne Stadt zu bieten hat, wie Hotels, Promenaden, Restaurants und Einkaufszentren. Besuchen Sie Museen, wie das Israel Museum, die gr\xF6\xDFte Kultureinrichtung in Israel und weltweit f\xFChrend unter den Kunst- und Arch\xE4ologiemuseen, in denen u.a. die ber\xFCchtigten Schriftrollen vom Toten Meer (die \xE4ltesten biblischen Manuskripte) zu finden sind. Landwirtschaftsbetriebe, Weing\xFCter und Brauereien befinden sich um Jerusalem herum und bieten verschiedene Alternativen f\xFCr Feinschmecker. Von der traditionellen israelischen K\xFCche bis hin zu zeitgem\xE4\xDFer Cross-Over-K\xFCche in Kombination mit preisgekr\xF6nten Weinen und Bieren, die Enthusiasten aus aller Welt anlocken.</p>\n                                <div class=\"img-wrapper\">\n\t\t                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/jeru-salem/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t \t</div>\n\t\t\t\t\t\t\t\t<p>Besuchen Sie Mahane Yehude, ein bunter und lebhafter Markt mit einer attraktiven Mischung aus Kultur und k\xF6stlichen Aromen der hier angebotenen Delikatessen.&nbsp; Warten Sie den Sonnenuntergang ab und erleben Sie, wie sich der \u201EShuk\u201C in eine trendige Szene mit Live-Musik f\xFCr jeden Geschmack verwandelt. Eine wachsende \u201EStreet-Art\u201C-Galerie mit au\xDFergew\xF6hnlichem Essen und k\xF6stlichen Getr\xE4nken. Mahane Yehuda ist ein besonderes Erlebnis. Gehen Sie die Stra\xDFen entlang, machen Sie an einem Essstand halt, gehen Sie tanzen und genie\xDFen Sie dabei ein Getr\xE4nk.</p>\n\t\t\t\t\t\t\t\t<p>Mit Kunst, Geschichte, Kultur und seiner Vielfalt kann man in der Hauptstadt Israels eine tolle Zeit verbringen und sich dem historischen Charme und einem modernen Stadtleben hingeben. Wenn Sie in Jerusalem ankommen, k\xF6nnen Sie die Kultur, Arch\xE4ologie und Geschichte der vielen Nationen, die hier gelebt haben, gar nicht \xFCbersehen. Hier treffen sich Antike und Neuzeit zwischen den Mauern der Altstadt dieser einzigartigen Welthauptstadt.</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n         \t"};}},{id:"Haifa_Intoxicating_Beauty",bgImage:"/posts/bank/north1/1.jpg",mobBgImage:"/posts/bank/north1/M.jpg",title:"HAIFA BERAUSCHENDE SCHÖNHEIT",ctg:"north",isVid:true,vidId:"7_156GUZMF4",smlTitle:"",html:function html(){return{__html:"\n                                \n\t\t\t\t\t\t\t \t<p><em>St\xE4dtische Ruhe und verzaubernde Landschaften</em></p>\n\t\t\t\t\t\t\t\t<p>Mit seinen Steilklippen an der K\xFCste des Mittelmeers und den gr\xFCnen H\xFCgeln \xFCber dem Hafen von Haifa bietet die drittgr\xF6\xDFte Stadt Israels die malerischsten Ausblicke im ganzen Land. Haifa ist ein traumhaft sch\xF6ner, ruhiger Ort, an dem verschiedene Glaubensgemeinschaften miteinander leben \u2013 Haifa ist eine Lebensart. Gehen Sie entlang der Pinien spazieren und genie\xDFen Sie die kulturelle Diversit\xE4t, eine gesch\xE4ftige Intellektuellenszene, die friedliche Atmosph\xE4re und unverkennbare Sch\xF6nheit. Hier werden Sie inspiriert.</p>\n\t\t\t\t\t\t\t\t<h3>Umgeben Sie sich mit Ruhe und Zauber</h3>\n\t\t\t\t\t\t\t\t<p>Eine der wichtigsten Touristenattraktionen in Haifa sind die weltber\xFChmten <strong>G\xE4rten der Baha\u2018I</strong>. Sie wurden wegen ihres \u201Eau\xDFergew\xF6hnlichen universellen Wertes\u201C 2008 von der UNESCO zum Weltkulturerbe ernannt. Es ist ein au\xDFergew\xF6hnlich sch\xF6ner Ort, der j\xE4hrlich eine Million Besucher anlockt.</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/haifa-intoxicating-beauty/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t \t</div>\n\t\t\t\t\t\t\t\t<p>Starten Sie Ihren Besuch oben am Karmel-Gebirge auf der sehenswerten Louis Promenade. Bestaunen Sie den atemberaubenden Blick, der sich von Haifa bis zur gesamten K\xFCste und zu den entfernt gelegenen, gr\xFCnen Bergen in Galil\xE4a erstreckt.</p>\n\t\t\t\t\t\t\t\t<p>Erkunden Sie die G\xE4rten auf eigene Faust oder nehmen Sie an einer Gratisf\xFChrung teil. Gehen Sie die Terrassen mit ihren Hecken und Blumenbeeten entlang, die liebevoll angelegt wurden. Besichtigen Sie den goldenen Schrein des Bab, das Grabmal des Baha'i Propheten Herald undbewundern Sie die Farben und geometrischen Formen dieser einzigartigen h\xE4ngenden G\xE4rten und erfreuen Sie sich an der sp\xFCrbaren Ruhe.</p>\n\t\t\t\t\t\t\t\t<h3>Entdecken Sie das Herz der Kulturszene von Haifa</h3>\n\t\t\t\t\t\t\t\t<p>Die G\xE4rten der Baha\u2018I m\xFCnden in das Stadtviertel der Deutschen Kolonie. Sie wurde in den 1860ern von der deutschen Tempelbewegung erbaut. Heute ist sie das Herz der Kulturszene in Haifa und ein Touristikzentrum mit Restaurants, Bars, Galerien und Boutique-Hotels. Bummeln Sie die Pflasterstra\xDFen entlang, besuchen Sie die Galerien und erfreuen Sie sich an der sch\xF6nen Architektur. Essen und trinken Sie in lokalen Caf\xE9s und Restaurants, erkunden Sie das Nachtleben und tauchen Sie ein in das bunte Treiben. Und bevor Sie schlafen gehen, werfen Sie noch einen Blick nach oben und schauen sich die wundersch\xF6ne Beleuchtung an, die sich von den Baha\u2019I G\xE4rten erhebt. Es wird Ihr Herz erw\xE4rmen.</p>\n\t\t\t\t\t\t\t\t<p><a href=\"//www.visit-haifa.org/ger/\" target=\"_blank\">http://www.visit-haifa.org/ger/</a></p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n         \t"};}},{id:"The_Hula_Valley_Natural",bgImage:"/posts/bank/north2/1.jpg",mobBgImage:"/posts/bank/north2/M.jpg",title:"The Hula Valley Natural",ctg:"north",isVid:true,vidId:"h5TV5VwQeWY",smlTitle:"",html:function html(){return{__html:"\n                               \n\n\t\t\t\t\t\t\t \t<h3>Entdecken Sie eine der besten Vogelbeobachtungspl\xE4tze der Welt</h3>\n\t\t\t\t\t\t\t\t<p>Im Herzen des pittoresken Hula-Tals im Oberen Galil\xE4a, nur zwei Autostunden n\xF6rdlich von Tel Aviv, liegt zwischen majest\xE4tischen Bergketten ein au\xDFergew\xF6hnlich sch\xF6nes Fleckchen Erde: der Hula-See. Dieses international anerkannte Naturreservat gilt als einer der wichtigsten Vogelbeobachtungspl\xE4tze der Welt und ist eine Oase f\xFCr V\xF6gel und Naturliebhaber. Es bietet die seltene und einzigartige Gelegenheit, grenzenlose Natur zu erleben - ein einmaliges Erlebnis.</p>\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t<h3>Folgen Sie den V\xF6geln und bewundern Sie die Natur</h3>\n\t\t\t\t\t\t\t\t<p>Im Fr\xFChling und Herbst ziehen \xFCber 500 Millionen V\xF6gel mit knapp 400 Arten durch das Hula-Tal. Dieses Feuchtbiotop ist ein perfekter Zwischenstopp f\xFCr Kormorane, Reiher, Pelikane, Greifv\xF6gel und Kraniche.</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/hulla-valley-natural/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t \t</div>\n\t\t\t\t\t\t\t\t<p>Das Hula-Tal (auch Hebrew Agamon Hula genannt) wurde von BBC Wildlife unter die besten zehn Vogelbeobachtungspl\xE4tze &nbsp;weltweit gew\xE4hlt und zieht Vogelbeobachter aus aller Welt an. Kommen Sie zum internationalen Hula-Vogelfestival, das jedes Jahr im Herbst stattfindet, und genie\xDFen Sie ein einmaliges Erlebnis.</p>\n\t\t\t\t\t\t\t\t<p>Es gibt verschiedene M\xF6glichkeiten, Zeuge dieses umwerfenden Ph\xE4nomens zu werden. W\xE4hlen Sie einfach nur Ihr Abenteuer.</p>\n\t\t\t\t\t\t\t\t<p><strong>Erkunden Sie die Wege.</strong> Machen Sie einen Rundgang durch die wunderbar angelegten Wege des Parks. Sie k\xF6nnen zu Fu\xDF gehen, mit dem Rad oder mit einem Wagen die Pfade entlang fahren. Sie werden Obsthaine passieren und einen Einblick in das Feuchtbiotop erhalten.</p>\n\t\t\t\t\t\t\t\t<p><strong>Fahren Sie Traktor. </strong>Bei einer F\xFChrung in einem traktorbetriebenen \u201ESafariwagen\u201C dringen Sie tief in das Gel\xE4nde von Agamon vor. Mit dem getarnten Wagen bleiben Sie V\xF6geln \u201Everborgen\u201C und kommen deshalb in den Genuss einer hautnahen Begegnung mit diesen wundersch\xF6nen Kreaturen.</p>\n\t\t\t\t\t\t\t\t<p><strong>Sonnenaufgang und Nachtf\xFChrungen</strong> F\xFCr die Abenteurer unter Ihnen gibt es zwei spezielle F\xFChrungen. Bei der \u201ESunrise Tour\u201C erleben Sie eine einmalige Vogelsafari und die M\xF6glichkeit, zu fotografieren. Alternativ hierzu haben Sie bei der \u201ENight Owl Tour\u201C einen v\xF6llig anderen Blick auf das Reservat. Bei Lagerfeuer und Sternschnuppen k\xF6nnen Sie einen Blick auf das Leben von Wildkatzen, Nachtv\xF6geln und Flughunden erhaschen.</p>\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t<h3>Erweitern Sie Ihren Horizont und seien Sie hautnah beim Naturschutz dabei</h3>\n\t\t\t\t\t\t\t\t<p><em>Agamon</em> Hula wurde weltweit anerkannt f\xFCr sein nachhaltiges \xD6kosystem, das Natur, Tourismus und Landwirtschaft ausbalanciert.</p>\n\t\t\t\t\t\t\t\t<p>Besichtigen Sie die Beringungsstation f\xFCr V\xF6gel im Park und beobachten Sie die Naturschutzarbeiten. Machen Sie die \u201EBird Island Tour\u201C und vielleicht haben Sie die Chance, einen Vogel auszuwildern. Es gibt nichts besseres als das.</p>\n\t\t\t\t\t\t\t\t<p>Mit so vielen verschiedenen Tieren und dem unerm\xFCdlichen Einsatz im Naturschutz bietet das Hula-Tal ein Wohlf\xFChlerlebnis, das Ihnen Herz und Sinne \xF6ffnet.</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n         \t"};}},{id:"Feel_Pudelwohl",bgImage:"/posts/bank/deadsea1/1.jpg",mobBgImage:"/posts/bank/deadsea1/M.jpg",title:"DAS TOTE MEER",ctg:"deadsea",isVid:false,smlTitle:"",html:function html(){return{__html:"\n                               \n\n\t\t\t\t\t\t\t \t<h2>F\xFChlen Sie sich pudelwohl \u2013 am tiefstgelegenen Ort der Erde</h2>\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t \t<h3>Erholung auf h\xF6chstem Niveau</h3>\n\t\t\t\t\t\t\t\t<p>Das Tote Meer, das offiziell als der tiefstgelegene Ort der Erde (428 Meter unter dem Meeresspiegel) und ein Kandidat in der engeren Auswahlliste f\xFCr die sieben Naturwunder dieser Erde gilt, vereint nat\xFCrliche Sch\xF6nheit, spannende alte Geschichte und moderne Annehmlichkeiten zu einem faszinierenden und anregenden Urlaubserlebnis.</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/feel-pudelwohl/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t \t</div>\n\t\t\t\t\t\t\t\t<p>Von den heilenden Kr\xE4ften des kobaltblauen Wassers aus dem Toten Meer, \xFCber die atemberaubende Sch\xF6nheit der Umgebung bis hin zu den unz\xE4hligen faszinierenden Sehensw\xFCrdigkeiten, die diese Region bietet, ist das Tote Meer ein Ort der Ruhe, Gesundheit und Inspiration f\xFCr K\xF6rper und Geist.</p>\n\t\t\t\t\t\t\t\t<p>Lassen Sie sich auf dem Wasser treiben, nehmen Sie ein Schlammbad oder erkunden Sie an 330 Sonnentagen im Jahr die Region des Toten Meeres mit seinen eindrucksvollen Sehensw\xFCrdigkeiten, wie etwa nat\xFCrliche Heilb\xE4der, herrliche Wanderwege, Gourmet- und Fastfood-Restaurants sowie aufregende Attraktionen. Entlang des 75 Kilometer langen Hauptabschnitts mit seinen wundersch\xF6nen Str\xE4nden werden Sie au\xDFerdem Weltklasse-Hotels und Wellness-Einrichtungen finden f\xFCr ein wahrhaft verw\xF6hnendes Erlebnis.</p>\n                                \n\t\t\t\t\t\t\t\t<h3>Die magischen Str\xE4nde des Toten Meeres</h3>\n\t\t\t\t\t\t\t\t<p>Die Str\xE4nde des Toten Meeres sind beispiellos auf dieser Erde. Kilometerlange wundersch\xF6ne und gut erhaltene Str\xE4nde, wo Sie Sonne tanken und ihren Traumurlaub genie\xDFen k\xF6nnen. Suchen Sie einen der felsigen Sandstr\xE4nde aus und genie\xDFen Sie die atemberaubende Aussicht auf die unglaubliche Bergkulisse, die das Meer umgibt. Das warme Wasser des Toten Meeres ist immer ruhig und bietet sofort erstklassige Entspannung.</p>\n\t\t\t\t\t\t\t\t  <div class=\"img-wrapper\">\n\t\t                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/feel-pudelwohl/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t \t</div>\n\t\t\t\t\t\t\t\t<p>An der S\xFCdk\xFCste am niedrigsten Punkt der Erde werden Sie eine Reihe von Hotels finden, in denen Sie sich am Sonnenaufgang \xFCber das Meer erfreuen k\xF6nnen, der in kleinen Gew\xE4ssern, die mit Salzformationen \xFCbers\xE4t sind, ein fantastisches Farbspektrum hinterl\xE4sst. Um das Erlebnis am Toten Meer abzurunden, tragen Sie etwas samtigen Schlamm auf Ihre Haut auf, damit sie die kostbaren Mineralien aufnehmen kann. Der Schlamm aus dem Toten Meer hat nachweislich positive Auswirkungen auf Haut und K\xF6rper. Sie werden sich erfrischt f\xFChlen und Ihre Haut wird glatter und j\xFCnger aussehen. G\xF6nnen Sie sich dieses Verw\xF6hnprogramm. Sie haben es sich verdient. Machen Sie sich schmutzig mit dem Schlamm aus dem Toten Meer \u2013 er ist gesund!</p>\n\n\t\t\t\t\t\t\t\t<h3>Entdecken Sie die W\xFCste rund um das Tote Meer</h3>\n\t\t\t\t\t\t\t\t<p>Aber Sie k\xF6nnen sich nicht nur in Heilb\xE4dern erholen und im Toten Meer treiben lassen. Wenn Sie s\xFCdlich von Jerusalem reisen, machen Sie Halt beim Kibbutz Ein Gedi, eine nat\xFCrliche Oase an den H\xE4ngen der Jud\xE4ischen W\xFCste. Wandern Sie durch ein Naturschutzgebiet, in dem Sie wilde Tiere wie den Steinbock sehen und sich an den Wasserf\xE4llen und Teichen erfreuen, die an den Felsw\xE4nden hinabfallen. Ein Gedi bietet au\xDFerdem Hotelunterk\xFCnfte und Heilb\xE4der mit hei\xDFen Schwefelteichen. Dort werden auch verschiedene heilende und therapeutische Massagen angeboten. Setzen Sie Ihre Reise fort vom S\xFCden zu der Felsenfestung&nbsp; Masada, ein nationales Wahrzeichen mit einer starken historischen Verbindung. Es befindet sich oben auf einem Bergmassiv, das von Abenteuersuchenden erklommen werden kann oder aber auch bequem mit der Seilbahn zu erreichen ist.</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n         \t"};}},{id:"Aufschwung_Fur_Geist",bgImage:"/HomeSlider/Home/3.jpg",mobBgImage:"/HomeSlider/M/3.jpg",title:"DAS TOTE MEER",ctg:"deadsea_2",isVid:true,vidId:"KijyxSgDpuY",smlTitle:"",html:function html(){return{__html:"\n                               \n\n\t\t\t\t\t\t\t \t<h2>Aufschwung f\xFCr Geist und Seele am tiefst gelegenen Ort der Erde</h2>\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t \t<p>Entspannen Sie im wohltuenden Salz des Toten Meeres und erleben Sie einen unvergesslichen revitalisierenden Urlaub</p>\n\t\t\t\t\t\t\t\t<p>Mit seiner atemberaubenden, nat\xFCrlichen Sch\xF6nheit, seinen heilsamen, mineralhaltigen Heilquellen, der nachgewiesenen Heilqualit\xE4te und vielen einzigartigen Erlebnissen wundert es nicht, dass sich das Tote Meer zu einem der weltweit prominentesten Reiseziele entwickelt hat. Dieser mysteri\xF6se Salzsee hat alles, was Sie brauchen, um K\xF6rper und Geist perfekt zu entspannen.</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/aufschwung-fur-geist/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t \t</div>\n\t\t\t\t\t\t\t\t<p><strong>Entspannen</strong>. Salz, Schlamm, Sonne... und vieles mehr. Tauchen Sie ein in die nat\xFCrlichen (hei\xDFen) Schwefelquellen und genie\xDFen Sie die Heilbehandlungen. Vergessen Sie die Alltagshektik und lassen Sie die Seele baumeln. Genie\xDFen Sie einfach Ihren heilenden, revitalisierenden und erholsamen Urlaub.</p>\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t<h3>Erfreuen Sie sich an den kostbarsten Geschenken der Natur</h3>\n\t\t\t\t\t\t\t\t<p><strong>Sich treiben lassen. </strong>Dank des au\xDFergew\xF6hnlich hohen Salzgehaltes im Wasser, k\xF6nnen Sie ein kleines \u201EWunder\u201C vollbringen, indem Sie zwar nicht auf dem Wasser laufen, sich aber &nbsp;auf der Oberfl\xE4che treiben lassen k\xF6nnen. Gehen Sie ins Wasser, legen Sie sich hinein und lassen Sie der Natur ihren Lauf. Es kann einen Moment dauern, bis Sie sich daran gew\xF6hnt haben, aber wir versprechen Ihnen, es ist wie Magie.</p>\n\t\t\t\t\t\t\t\t<p><strong>Heilen. </strong>Wenn man die Region des Toten Meeres kommt, ist es als wenn man eine andere Welt betritt. Eine andere Sicht, eine andere Geschwindigkeit, andere Luft und sogar die Sonne ist anders.</p>\n\t\t\t\t\t\t\t\t  <div class=\"img-wrapper\">\n\t\t                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/aufschwung-fur-geist/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t \t</div>\n\t\t\t\t\t\t\t\t<p>Die spezielle Luft- und Lichtzusammensetzung ist das Resultat der besonderen geologischen Bedingungen der Region und der Hauptgrund f\xFCr ihre Heilkraft.</p>\n\t\t\t\t\t\t\t\t<p>Die Atmosph\xE4re ist anders, weil sich das Salz im Wasser in heilvolle Mineralstoffe aufl\xF6st, die Sie \xFCber die Luft aufnehmen. Die Sonne ist anders aufgrund des Standorts, so niedrig unter dem Meeresspiegel: sie ist schw\xE4cher und sch\xE4dliche UV-Strahlen werden gefiltert. Gehen Sie nach drau\xDFen und genie\xDFen Sie die kostbarsten Geschenke der Natur.</p>\n\t\t\t\t\t\t\t\t<p><strong>Entdecken Sie das Kind in sich und geben Sie sich der Heilung durch die Natur hin</strong></p>\n\t\t\t\t\t\t\t\t<p><strong>Machen Sie sich schmutzig</strong> \u2013 Der Schlamm des Toten Meeres hat nachweislich eine gesundheitsf\xF6rdernde Wirkung. Er verbessert, revitalisiert und entlastet Ihre Haut. Der Schlamm ist k\xE4uflich zu erwerben und kann zuhause angewandt werden. Aber warum sollten Sie sich die Gelegenheit nehmen lassen, sich mal wieder als Kind zu f\xFChlen. Reiben Sie sich an Ort und Stelle an einem der Str\xE4nde von Kopf bis Fu\xDF mit dem schwarzen Schlamm ein und sp\xFCren Sie die wohltuende Wirkung der Mineralien. Machen Sie ruhig ein Selfie. Sie werden sehen, Sie sind mit diesem Urlaubsfoto Klassiker nicht allein.</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n         \t"};}},{id:"TelAviv_And_Jerusalem",bgImage:"/HomeSlider/Home/3.jpg",mobBgImage:"/HomeSlider/M/3.jpg",title:"TEL AVIV & JERUSALEM",ctg:"telavivAndJerusalem",isVid:false,smlTitle:"",html:function html(){return{__html:"\n                                <h2>Impuls und Inspiration erg\xE4nzen sich zu DEM perfekten Reisepaket</h2>\n\t\t\t\t\t\t\t \t<p>Wo sonst k\xF6nnen Sie sich in der Sonne vergn\xFCgen, ein erstklassiges Kulturangebot genie\xDFen und sich in Veranstaltungen st\xFCrzen, die Geschichte geschrieben haben?</p>\n\t\t\t\t\t\t\t\t<p>Tel Aviv, eine pulsierende hochmoderne Metropole, umfasst Str\xE4nde mit feinem, goldenem Sand, eine hippe Atmosph\xE4re und viele M\xF6glichkeiten, sich bei herausragenden Speisen und Kaffee in einer nah\xF6stlichen Ambiente zu vergn\xFCgen. Nur vierzig Minuten entfernt erleben Sie einen v\xF6llig anderen Beat und Puls: Jerusalem, eine einzigartig sch\xF6ne Stadt. Man wird leicht nachvollziehen k\xF6nnen, weshalb so viele Menschen seit Tausenden von Jahren so begeistert von dieser Stadt sind.<br>Tel Aviv und Jerusalem sind zwar beides gesch\xE4ftige, vitale und malerische St\xE4dte, die unz\xE4hlige Attraktionen zu bieten haben, dennoch k\xF6nnten sie unterschiedlicher nicht sein. Abgesehen von ihrer geografischen Lage, sind ihre Landschaften, D\xFCfte und Ger\xFCche komplett unterschiedlich. Wo sonst k\xF6nnten Sie so leicht den ultimativen Strand mit einer der \xE4ltesten und heiligsten St\xE4dte der Geschichte verbinden?<br>Sehen Sie sich hier an, was Sie alles in Ihrem Urlaub in den beiden St\xE4dten unternehmen k\xF6nnen.</p>\n\t\t\t\t\t\t\t\t<h3>Tel Aviv \u2013 die Stadt die niemals schl\xE4ft</h3>\n\t\t\t\t\t\t\t\t<p>Sie sind in Tel Aviv gelandet... Erleben Sie den Reiz, der von der ersten hebr\xE4ischen Stadt aufgetischt wird. Entdecken Sie die azurblauen Farbnuancen des Mittelmeeres, die malerischen Flecken in der Wei\xDFen Stadt, ihre M\xE4rkte, Restaurants, besonderen Aromen und das schillernde Nachtleben. Tauchen Sie ein und sp\xFCren Sie, weshalb Tel Aviv als die Non-Stop-City bekannt ist: Saugen Sie die Lebensfreude dieser Stand rund um die Uhr auf.<br>Dann legen wir mal los.</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/telaviv-and-jerusalem/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t \t</div>\n\t\t\t\t\t\t\t\t<h3>Neve Tzedek</h3>\n\t\t\t\t\t\t\t\t<p>Entdecken Sie den Zauber dieser spektakul\xE4ren und wundersch\xF6n renovierten Stadtteils im S\xFCden der Tel Aviv Promenade, in der N\xE4he von Jaffa. Beginnen sie Ihren Morgen mit einem kulinarischen Erlebnis, einem typischen israelischen Fr\xFChst\xFCck: k\xF6stliche Backwaren, Eier, K\xE4se und Dips, gr\xFCner Salat, Orangensaft und nat\xFCrlich ausgezeichneten Kaffee. Die empfohlene Neve Zedek-Tour bringt Sie zu historischen Sehensw\xFCrdigkeiten und kleinen, wundervollen Museen.</p>\n\t\t\t\t\t\t\t\t<h3>Hatachana</h3>\n\t\t\t\t\t\t\t\t<p>Nach einer kurzen Verschnaufpause besichtigen Sie Hatachana ganz in der N\xE4he. Dort k\xF6nnen Sie renovierte Tempelanlagen besichtigen sowie den alten Bahnhof von Jaffa, der komplett neu gestaltet wurde. Die St\xE4tte erz\xE4hlt die Geschichte des Bahnhofs mit seiner Bahnlinie von Jaffa nach Jerusalem, die von 1892 bis 1948 in Betrieb war.</p>\n\t\t\t\t\t\t\t\t<h3>Jaffa</h3>\n\t\t\t\t\t\t\t\t<p>Als n\xE4chstes spazieren wir die atemberaubende Standpromenade von Tel Aviv nach Jaffa entlang. Wir empfehlen einen Besuch des Jaffa Port, der als einer der \xE4ltesten H\xE4fen der Welt gilt. Entspannen Sie in einem der vielen Caf\xE9s am Hafen und beobachten Sie die Fischer bei der Arbeit. Gehen Sie dann weiter zum farbenfrohen Flohmarkt, auf dem Sie sich Antiquit\xE4ten, armenische Keramik, die Hand der Fatima oder eins der zahlreichen Souvenirs g\xF6nnen k\xF6nnen. Nachts verwandelt sich der Ort in eine Bar-Hopping- und Gastronomieszene.</p>\n\t\t\t\t\t\t\t\t<h3>Mit dem Rad den Strand entlang</h3>\n\t\t\t\t\t\t\t\t<p>Tel Aviv ist bekannt als die Fahrradhauptstadt Israels. An einem sch\xF6nen Tag k\xF6nnen Sie sich ein Fahrrad an einer der Tel-O-Fun-Stationen oder an einer anderen Mietstation in der Stadt ausleihen. Eine Radtour von Neve Zedek zum Tel Baruch-Strand im Norden der Stadt macht unglaublich viel Spa\xDF.</p>\n\t\t\t\t\t\t\t\t<h3>Eretz Israel Museum</h3>\n\t\t\t\t\t\t\t\t<p>Wenn Sie sich im Norden der Stadt aufhalten, empfehlen wir Ihnen eine Besichtigung des Eretz Israel Museums. Es ist ein interdisziplin\xE4res Museum mit dem Schwerpunkt auf der Geschichte und Kultur Israels, in dem sich st\xE4ndige und Wechselausstellungen der Arch\xE4ologie, Ethnografie, Post und Philatelie, Folkore, Judaika, traditionellem Handwerk, Popart, Kulturgeschichte und lokalen Identit\xE4ten widmen.</p>\n\t\t\t\t\t\t\t\t<h3>Rothschild Boulevard</h3>\n\t\t\t\t\t\t\t\t<p>Suchen Sie nach einer einladenden Lage, wo Sie hervorragend speisen k\xF6nnen? Dann testen Sie doch mal eins der exquisiten Restaurants auf oder in der N\xE4he des Rothschild Boulevard, im Herzen der Stadt. Es ist eine der drei Zonen, die zur Wei\xDFen Stadt geh\xF6ren und von der UNESCO zum Weltkulturerbe erkl\xE4rt wurde. Diese Stra\xDFe, die das Flair von Tel Aviv perfekt auff\xE4ngt, bietet Ihnen eine erstklassige Gelegenheit, Menschen zu beobachten. Sie k\xF6nnen auch einen Spaziergang machen und die beeindruckende Bauhaus-Architektur auf sich wirken lassen, der alte Kiosk und die kleinen Museen, welche die faszinierende Geschichte von Tel Aviv und seinem ersten Stadtteil, Ahuzat Bayit, erz\xE4hlen.</p>\n\t\t\t\t\t\t\t\t<h3>Nachtleben</h3>\n\t\t\t\t\t\t\t\t<p>Wenn Sie in der Stadt bleiben m\xF6chten, k\xF6nnen Sie wahlweise eins der gro\xDFen Hotels direkt am Strand nahe der Promenade nehmen, oder eins der sch\xF6nen Boutique-Hotels. Und wenn Sie dann immer noch aktiv und bereit sind, auszugehen, sollten Sie jetzt eine der popul\xE4ren Bars, Nachtclubs, die Oper, eine Tanz-Performance oder eine der vielen Veranstaltungen und Festivals in Tel Aviv besuchen.<br>Hat Ihnen die Kostprobe vom guten Leben in Tel Aviv gefallen? Dann freuen Sie sich jetzt auf einen Trip nach Jerusalem. Er dauert nur 40 Minuten! Die Heilige Stadt wartet auf Sie!</p>\n\t\t\t\t\t\t\t\t<h3>Jerusalem \u2013 die sch\xF6nste Stadt der Welt</h3>\n\t\t\t\t\t\t\t\t<p>Entdecken Sie die drei heiligsten Religionen: Judentum, Islam und Christentum. Besichtigen Sie die historischen St\xE4tten, nehmen Sie die atemberaubenden D\xFCfte in sich auf, genie\xDFen Sie die besondere K\xFCche, atmen Sie die klare Bergluft ein und am\xFCsieren Sie sich bei den vielen Unterhaltungsm\xF6glichkeiten \xFCberall in der Stadt.</p>\n\t\t\t\t\t\t\t\t<h3>Ein Kerem</h3>\n\t\t\t\t\t\t\t\t<p>Noch vor den Toren der Stadt k\xF6nnen Sie das malerische Viertel Ein Kerem besichtigen.&nbsp; Es ist nur 20 Minuten Fahrt vom Stadtzentrum entfernt und bekannt f\xFCr seinen bezaubernden Charakter. Ein Kerem ist im Gr\xFCnen gelegen und bietet atemberaubende Ausblicke, eindrucksvolle Natursteinh\xE4user, Kirchen und Moscheen, faszinierende historische St\xE4tten, idyllische Gassen, Galerien und spezielle kleine Gesch\xE4fte, Caf\xE9s und ausgezeichnete Restaurants sowie exquisite alte und neue Hotels.</p>\n\t\t\t\t\t\t\t\t<h3>Bloomfield Museum der Wissenschaften</h3>\n\t\t\t\t\t\t\t\t<p>Jerusalems Museum der Wissenschaft ist ein magisches K\xF6nigreich f\xFCr Erwachsene und Kinder gleicherma\xDFen mit vielen beweglichen Objekten, optischen T\xE4uschungen, elektrischen Experimenten und allem, was unsere Welt komfortabler macht.</p>\n\t\t\t\t\t\t\t\t<h3>Die Altstadt</h3>\n\t\t\t\t\t\t\t\t<p>An erster Stelle auf dem Jerusalem-Reiseplan! Die Altstadt von Jerusalem ist - einfach ausgedr\xFCckt - eine antike Schatztruhe der Entdeckungen und Begeisterung. Das wahre Leben von Jerusalem spielt sich in den schmalen Stra\xDFen ab, den verwinkelten Gassen der Altstadt. Die besondere Atmosph\xE4re, die faszinierende Geschichte und Geheimnisse liegen hinter den antiken Gem\xE4uern verborgen. Besuchen Sie die Klagemauer und geben Sie sich der Unantastbarkeit der Tempelruinen hin. Sie k\xF6nnen in die Ritzen der Mauer Zettel mit Gebeten, W\xFCnschen und Danksagungen hineinstecken.</p>\n\t\t\t\t\t\t\t\t<p>Folgen Sie den Spuren Jesu Christi entlang der Via Dolorosa bis hin zur Grabeskirche \u2013 Ort der beiden heiligsten St\xE4tten des Christentums: der Ort, an dem Jesus von Nazareth gekreuzigt wurde und das leere Grab, aus dem er wieder auferstanden sein soll. Setzen Sie Ihre Route fort zum Berg Zion, auf dem Sie das Abendmahl (auch bekannt als der Abendmahlsaal) besichtigen k\xF6nnen, das traditionell am Ort des letzten Abendmahls stattfand. Besichtigen Sie anschlie\xDFend (wie Jesus es oft getan hat) den \xD6lberg f\xFCr einen kurzen Moment der Meditation am Getsemani, an dem Jesus predigte und mit seinen J\xFCngern die Nacht vor der Kreuzigung verbracht hat. Besteigen Sie das Dach des \xF6sterreichischen Hospiz zur Heiligen Familie f\xFCr eine herrliche Aussicht auf Jerusalem und die Altstadt.<br>Und wenn Sie noch tiefer in die Wurzeln des antiken Jerusalem eintauchen m\xF6chten, machen Sie eine Tour durch die Klagemauertunnel, besichtigen Sie den Felsendom, die heilige St\xE4tte, an der Mohammed in den Himmel aufgefahren sein soll, und die Erl\xF6serkirche, in der die sch\xF6nsten Orgeln von Israel zu finden sind.</p>\n\t\t\t\t\t\t\t\t<h3>Machane Yehuda Market</h3>\n\t\t\t\t\t\t\t\t<p>Sie waren heute viel unterwegs. Haben Sie schon Hunger? Sie k\xF6nnen jetzt den Machane Yehuda Market besuchen \u2013 Jerusalems belebten und emsigen Markt. Entlang der renommierten Marktst\xE4nde haben sich in den letzten Jahren viele Caf\xE9s und noble Lebensmittelgesch\xE4fte etabliert.</p>\n\t\t\t\t\t\t\t\t<h3>Einkaufen in Jerusalem</h3>\n\t\t\t\t\t\t\t\t<p>Sind Sie bereit f\xFCr eine Shopping- und Souvenir-Tour? Kaufen Sie armenische Keramik oder Judaika in speziellen Gesch\xE4ften in der Altstadt. Sie werden im Stadtzentrum auch Gesch\xE4fte finden, die eine F\xFClle verschiedener Souvenirs aus Israel anbieten. Auf der Ben-Yehuda-Promenade werden Sie unz\xE4hlige Bekleidungsgesch\xE4fte finden. Und denken Sie daran, die Secondhand-L\xE4den aufzusuchen, wenn Sie etwas Authentischeres kaufen m\xF6chten. Besuchen Sie auf jeden Fall das noble Einkaufszentrum Mamila Mall, das als eins der aktivsten Shoppingcenter der Stadt gilt.<br>Mit ihrem vielf\xE4ltigen Angebot, ihrer Einzigartigkeit und den kurzen Wegstrecken sind Jerusalem und Tel Aviv das perfekte Reiseziel. Gemeinsam verbinden beide St\xE4dte Geschichte mit Moderne, antike Artefakte mit moderner Kunst, Sonnenspa\xDF mit der spirituellsten Reise Ihres Lebens. Es kann kaum besser sein! Worauf warten Sie noch? Buchen Sie jetzt Ihre Reise!</p>\n\t\t\t\t\t\t\t\t<p>Weitere Informationen:</p>\n\t\t\t\t\t\t\t\t<p><a href=\"//www.visit-tel-aviv.com/\" target=\"_blank\">http://www.visit-tel-aviv.com/</a><br><a href=\"//www.itraveljerusalem.com/\" target=\"_blank\">http://www.itraveljerusalem.com</a></p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n         \t"};}},{id:"Caesarea_A_Time_Travel",bgImage:"/posts/bank/north1/1.jpg",mobBgImage:"/posts/bank/north1/M.jpg",title:"CAESAREA EINE ZEITREISE",ctg:"north",isVid:false,smlTitle:"",html:function html(){return{__html:"\n                               \n\t\t\t\t\t\t\t \t\n\t\t\t\t\t\t\t \t<p>Entdecken Sie die Wunder aus vergangenen Zeiten, die von einem der gr\xF6\xDFten Erbauer der Antike geschaffen wurden - K\xF6nig Herodes.</p>\n\t\t\t\t\t\t\t\t<p>In traumhafter Lage an den Ufern des t\xFCrkisfarbenen Mittelmeeres und weniger als eine Autostunden von Tel Aviv entfernt liegt das antike und wundersch\xF6ne Caesarea.</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/caesarea-time-travel/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t \t</div>\n\t\t\t\t\t\t\t\t<p>Die Stadt und ihre arch\xE4ologischen Wunder sind Zeugnis ihrer Bedeutung im Laufe der Jahrhunderte. Ein Besuch des Nationalparks und des antiken Hafens, ein Rundgang durch das r\xF6mische Hippodrom und Amphitheater sowie ein Spaziergang beim beeindruckenden Palast zwischen seinen vielen historischen Sch\xE4tzen gleicht einer Reise zur\xFCck in die Zeit der gro\xDFen Herrscher.</p>\n\t\t\t\t\t\t\t\t<p>Und auf jeden Fall sollten Sie sich \u201ETravel through Time experience\u201C ansehen, ein faszinierendes Erlebnis, bei dem es sich um eine kleine \u201ESound- und Lichtshow\u201C handelt, die Sie in die zauberhafte Geschichte von Caesarea mitnimmt und durch die Jahrhunderte f\xFChrt.</p>\n\t\t\t\t\t\t\t\t<p>Gespickt wird das Besuchererlebnis durch die nat\xFCrliche Sch\xF6nheit von Caesarea und seine modernen Annehmlichkeiten, wie etwa die sch\xF6nen, malerischen Restaurants und Caf\xE9s und dem einzigen Golfplatz im Land.</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n         \t"};}},{id:"What_To_Pack",bgImage:"/HomeSlider/Home/3.jpg",mobBgImage:"/HomeSlider/M/3.jpg",title:"WAS SOLLTEN SIE EINPACKEN?",ctg:"TouristInfo",isVid:false,smlTitle:"",html:function html(){return{__html:"\n                               \n\t\t\t\t\t\t\t \t\n\t\t\t\t\t\t\t \t<p>Israel ist ein modernes Land und Sie k\xF6nnen nahezu alles kaufen, was Sie w\xE4hrend Ihres Aufenthaltes brauchen: Kleidung, Kosmetik und Hygieneartikel.</p>\n\t\t\t\t\t\t\t\t<p>Wenn Sie Israel im Sommer bereisen, sollten Sie leichte Kleidung mitnehmen - kurz\xE4rmelige oder \xE4rmellose T-Shirts, kurze Hosen, Sandalen, Strandschuhe und Badesachen. Ein Sweatshirt oder eine Jacke sind von Vorteil, da es nachts vor allem in den Bergen und der W\xFCste k\xFChler werden kann.</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/what-to-pack/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t \t</div>\n\t\t\t\t\t\t\t\t<p>Wenn Sie Israel im Winter bereisen, ben\xF6tigen Sie w\xE4rmere Kleidung, ein Mantel (vorzugsweise auch ein Regenmantel), festes Schuhwerk, einen Regenschirm, Handschuhe, Schal und sonstige warme Kleidung. Es ist in Israel zwar nicht so kalt wie in Europa, aber es kann tags\xFCber regnen und k\xFChl sein.</p>\n\t\t\t\t\t\t\t\t<p>Es ist auch von Vorteil, einen Rucksack oder eine Tasche f\xFCr Tagesausfl\xFCge mitzunehmen. Wenn Sie nach Eilat oder ans Tote Meer reisen, sollten Sie Badesachen (Badeschuhe) mitnehmen, da es warm genug zum Schwimmen sein wird, auch im Winter.</p>\n\t\t\t\t\t\t\t\t<p>Sonnencreme, einen Sonnenhut und Sonnenbrille sind im ganzen Jahr hilfreich.</p>\n\t\t\t\t\t\t\t\t<p>Falls Sie wandern m\xF6chten, brauchen Sie auf jeden Fall gutes Schuhwerk und viel Trinkwasser, am besten in Feldflaschen. Falls Sie im Freien \xFCbernachten m\xF6chten, ben\xF6tigen Sie au\xDFerdem einen Schlafsack, ein Zelt und Campingausr\xFCstung. Die meisten Jugendherbergen stellen Bettw\xE4sche zur Verf\xFCgung.</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n         \t"};}},{id:"Majestic_Desert",bgImage:"/posts/bank/negev1/1.jpg",mobBgImage:"/posts/bank/negev1/M.jpg",title:"ISRAELS MAJESTÄTISCHE WÜSTE",ctg:"eilat-negev",isVid:false,smlTitle:"",html:function html(){return{__html:"\n                               \n\t\t\t\t\t\t\t \t\n\t\t\t\t\t\t\t \t\n\t\t\t\t\t\t\t \t<p>Der S\xFCden Israels ist das ideale Ziel f\xFCr Reisende, die Abenteuer in der freien Natur lieben. Er ist nur d\xFCnn besiedelt, zeichnet sich aber durch faszinierende Orte und Aktivit\xE4ten aus.</p>\n\t\t\t\t\t\t\t\t<p>Mit erstaunlichen Naturwundern und Sch\xF6nheiten bietet der S\xFCden Israels einen herrlichen Blick, der Ihnen den Atem rauben wird: von Sonnenauf- bis Sonnenuntergang.</p>\n\t\t\t\t\t\t\t\t<p dir=\"LTR\">Zwar eine W\xFCste, aber definitiv keine \xD6dnis: Hier gibt es so viel zu sehen und zu unternehmen. Der Negev zeichnet sich durch seine au\xDFergew\xF6hnlichen Gesteine und Formationen, bedeutenden Kulturdenkm\xE4ler und wundervollen Naturschutzgebiete aus, in denen Sie wandern, radfahren und kamelreiten, oder auch aufregende Safaritouren in der W\xFCste erleben k\xF6nnen.<br>Einfach ausgedr\xFCckt ist diese majest\xE4tische s\xFCdliche Region eines der kostbarsten Reicht\xFCmer des Landes und ein absolutes Muss auf der Reiseroute.</p>\n\t\t\t\t\t\t\t\t<h3>Ramon-Krater</h3>\n\t\t\t\t\t\t\t\t<p>Im Herzen der ausgedehnten Negev-W\xFCste liegt der Ramon-Krater, der weltweit gr\xF6\xDFte Erosionskrater, der auch unter dem Namen Machtesch Ramon bekannt ist. Er umfasst eine enorme Gesteinsvielfalt aus fantastischen Farben und Formen und ist ein \xFCberw\xE4ltigendes Naturph\xE4nomen mit einem Ausma\xDF von 40 km L\xE4nge und zwischen 2 bis 10 km Breite. Er hat die Form eines langen Herzens und bildet Israels gr\xF6\xDFten Nationalpark: das Ramon-Naturreservat.</p>\n\t\t\t\t\t\t\t\t<p>Weit weg von den Lichtern und Menschenmassen der Stadt beeindruckt der Ramon-Krater durch seinen mehrfarbigen Sandstein, seinen Vulkanfelsen und seine Fossilien und wird oft als Grand Canyon Israels bezeichnet.</p>\n\t\t\t\t\t\t\t\t<p>Die wahrhaftig atemberaubende Aussicht vom 300 m hohen Aussichtspunkt des Machtesch Ramon, der an eine Hollywood-Kulisse erinnert, ist f\xFCr Touristen aus aller Wellt das ganze Jahr \xFCber ein beeindruckendes Erlebnis.</p>\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t<h3>Sede Boker</h3>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/majestic-desert/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t \t</div>\n\t\t\t\t\t\t\t\t<p>Ein bemerkenswerter R\xFCckblick in die Geschichte des Staates Israel ist Sede Boker, ein Kibbuz, der urspr\xFCnglich von Siedlern gegr\xFCndet wurde, mit der Mission, den Negev Anfang der 50er Jahre zu besiedeln.</p>\n\t\t\t\t\t\t\t\t<p>Der fr\xFChere israelische Ministerpr\xE4sident David Ben Gurion hatte ein Haus in Sede Boker, das heute ein \xF6ffentliches Museum ist.</p>\n\t\t\t\t\t\t\t\t<h3>Vidor Center</h3>\n\t\t\t\t\t\t\t\t<p>Eine wirklich einzigartige Sehensw\xFCrdigkeit und ein multisensorisches Erlebnis der au\xDFergew\xF6hnlichen Natur der Region Arava. Center-Besucher k\xF6nnen fortschrittliche Landwirtschaftsmethoden, heimische Pflanzen- und Tierarten, klimatische Herausforderungen, und besondere Eigenschaften des Bodens und des Wassers in der W\xFCste erkunden.</p>\n\t\t\t\t\t\t\t\t<h3>Nevatim</h3>\n\t\t\t\t\t\t\t\t<p>Ein Besuch in Nevatim, der Heimat der Cochin-Juden, ist eine faszinierende Erfahrung.</p>\n\t\t\t\t\t\t\t\t<p>Die Cochin-Juden stammen urspr\xFCnglich aus Indien und sind nach der Staatsgr\xFCndung Israels immigriert. Sie glauben, aus einer der \xE4ltesten j\xFCdischen Gemeinschaften zu kommen.</p>\n\t\t\t\t\t\t\t\t<p>Das Zentrum f\xFCr das Cochin-Kulturgut in der Moshav Nevatim erz\xE4hlt die Geschichte dieser Gemeinschaft.</p>\n\t\t\t\t\t\t\t\t<h3>Das Beduinen-Erlebnis</h3>\n\t\t\t\t\t\t\t\t<p>Die Gastfreundschaft der Beduinen ist sowohl unter emotionalen als auch unter kulturellen Aspekten ein unvergleichliches Erlebnis.</p>\n\t\t\t\t\t\t\t\t<p>Beduinen in Israel sind eine Gruppe von Nomadenst\xE4mmen, die vor vielen hundert Jahren dort gelebt haben und hier immer noch auf traditionelle Weise leben. Sie werden Sie willkommen hei\xDFen in ihren H\xE4usern und in ihrem Leben und machen Sie mit ihren Sitten und Gebr\xE4uchen vertraut.</p>\n\t\t\t\t\t\t\t\t<p>Vom Kamelreiten bis hin zur traditionellen Beduinenk\xFCche und \xDCbernachtungen in Beduinenzelten - all das sind beeindruckende Sehensw\xFCrdigkeiten und eine Chance, in ein langes, vergessenes Leben wieder einzutauchen.</p>\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t<h3>Die kulinarischen K\xF6niginnen von Yeruham</h3>\n\t\t\t\t\t\t\t\t<p>F\xFCr ein wirklich denkw\xFCrdiges Erlebnis m\xFCssen Sie unbedingt \u201EDie kulinarischen K\xF6niginnen von Yeruham\u201C besuchen \u2013 Ein einzigartiges Projekt, wo wundervolle Frauen aus Yeruham Touristen aller Welt mit einer hervorragenden traditionellen Mahlzeit in ihren H\xE4usern begr\xFC\xDFen undf\xFCr unvergessliche Momente voller D\xFCfte, Farben und Geschmack sorgen.</p>\n\t\t\t\t\t\t\t\t<p>Lernen Sie das wirkliche Leben der Einheimischen durch ihre Geschichten kennen, w\xE4hrend Sie die original zubereiteten Delikatessen und die wundervolle Gastfreundschaft genie\xDFen.</p>\n\t\t\t\t\t\t\t\t<h3>Die Altstadt Be'er Sheva</h3>\n\t\t\t\t\t\t\t\t<p>Es hei\xDFt, dass Be'er Sheva von Abraham gegr\xFCndet wurde. Es ist eine der \xE4ltesten St\xE4dte im Land, die nachweislich vor tausenden von Jahren schon besiedelt wurde. Die Altstadt Be'er Sheva bietet ein faszinierendes Mosaik urbaner R\xE4ume und wenn Sie die Stadt erkunden, werden Sie auf einzigartige Architektur und jahrhundertelange Historie sto\xDFen.</p>\n\t\t\t\t\t\t\t\t<h3>Carasso Science Park</h3>\n\t\t\t\t\t\t\t\t<p>Neu in der Altstadt von Be\u2019er Sheva, streckt sich der Carasso Science Park \xFCber mehr als 17 Quadratmeter und ist somit der gr\xF6\xDFte Wissenschaftspark Israels.</p>\n\t\t\t\t\t\t\t\t<p>Der Carasso Science Park begeistert und besch\xE4ftigt Besucher jedes Alters mit Attraktionen, wie einem interaktiven Museum und einem wissenschaftlichen Garten mit Spielen und Aktivit\xE4ten zum mitmachen. Der Park bietet auch zehn Ausstellungen \xFCber verschiedene Themen an, wie: Gen-Technik, Kommunikation, Mikroelektronik, Kernenergie, und anderem.</p>\n\t\t\t\t\t\t\t\t<h3>Arad</h3>\n\t\t\t\t\t\t\t\t<p>Arad ist eine Stadt mit jungem Zeitgeist und reichhaltiger Erfahrung. Arad ist von wundersch\xF6nen Landschaften, der Beschaulichkeit einer W\xFCste und vielen Wanderwegen umgeben, die f\xFCr jedermann jeglichen Alters geeignet sind.</p>\n\t\t\t\t\t\t\t\t<p>Es gibt viele Sehensw\xFCrdigkeiten und zahlreiche Touristenst\xE4tten in und um die Stadt, also der perfekte Ausgangspunkt und Ihr Tor f\xFCr einen perfekten W\xFCstenurlaub.</p>\n\t\t\t\t\t\t\t\t<h3>Timna Park</h3>\n\t\t\t\t\t\t\t\t<p>Der Timna Park mit 60 Quadratkilometern ist ein hufeisenf\xF6rmiges Tal, umgeben von steilen Klippen, ein au\xDFerordentliches Erlebnis und ein absoluter Genuss f\xFCr Wanderbegeisterte. Hier werden Sie Zeugen der wunderbaren Werke der Natur, aber auch der herausragenden Tier- und Pflanzenwelt, die in der W\xFCste heimisch sind und unter extremen, trockenen Bedingungen leben. Mit vielen Attraktionen, buntem Sand und zerkl\xFCfteten Bergen wirkt der Timna Park bei Besuchern wie ein unvergleichbarer Magnet.</p>\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t<h3>Naturreservat Chai-Bar Yotvata</h3>\n\t\t\t\t\t\t\t\t<p>Das Naturreservat Chai-Bar Yotvata ist das in dieser Region gr\xF6\xDFte Zucht- und Ansiedlungszentrum f\xFCr Tiere, bevor sie ausgewildert werden. Das Reservat ist stolz auf seine wundervollen Attraktionen, die Tierliebhaber begeistern werden. Es umfasst ein Gehege mit Raubtieren und kleinen W\xFCstentieren, ein Observatorium f\xFCr nachtaktive Tiere, das sich auf 12 Quadratkilometer erstreckt und freilaufende Huf- und Weidetiere beherbergt.</p>\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t<h3>Extremabenteuer</h3>\n\t\t\t\t\t\t\t\t<p>Im S\xFCden Israels gibt es ein Traumreiseziel f\xFCr abenteuerhungrige Reisende. Sein einzigartiges und anspruchsvolles Terrain eignet sich ideal f\xFCr verschiedene Extremsportarten und -aktivit\xE4ten, wie etwa das Abseilen von Schluchten, Querfeldein- und Mountain-Biking, die in dieser Region \xE4u\xDFerst beliebt sind, ebenso wie Gel\xE4ndefahren.</p>\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\n\n         \t"};}},{id:"Transport",bgImage:"/HomeSlider/Home/3.jpg",mobBgImage:"/HomeSlider/M/3.jpg",title:"VERKEHRSMITTEL",ctg:"TouristInfo",isVid:false,smlTitle:"",html:function html(){return{__html:"\n                               \n\t\t\t\t\t\t\t \t<p >Israel ist ein kleines Land, sodass man \xFCberall schnell und bequem ankommt. Taxen sind in Israel f\xFCr den Stadt- und \xDCberlandverkehr \xFCblich und k\xF6nnen auf der Stra\xDFe angehalten oder telefonisch bzw. \xFCber spezielle internationale Apps wie etwa GetText gebucht werden.</p>\n\t\t\t\t\t\t\t\t<p >Haupts\xE4chlich werden Busse und der nationale Bahnverkehr genutzt, die ein bequemes und preisg\xFCnstiges Verkehrsmittel zu nahegelegen Zielen im Land sind.</p>\n\t\t\t\t\t\t\t\t<p >Zugauskunft: <a href=\"https://www.rail.co.il/en/\" target=\"_blank\" rel=\"noopener\">www.rail.co.il</a> / Telefon: 08-6831222 oder *5770.</p>\n\t\t\t\t\t\t\t\t<p >Busauskunft: <a href=\"https://www.egged.co.il/HomePage.aspx\" target=\"_blank\" rel=\"noopener\">Egged</a> oder<br><a href=\"//bus.gov.il/?language=en#/origindestination/1/0\"  target=\"_blank\" rel=\"noopener\">www.bus.co.il</a> / Telefon: 1-900-72-1111</p>\n\t\t\t\t\t\t\t\t<p >Tickets sind an Ticketschaltern an Busbahnh\xF6fen der St\xE4dte oder direkt beim Fahrer erh\xE4ltlich. Die meisten Buslinien fahren nicht am Sabbat oder an j\xFCdischen Feiertagen. Der Betrieb endet freitagnachmittags und wird samstagabends wieder aufgenommen.</p>\n\t\t\t\t\t\t\t\t<p >Studenten k\xF6nnen zu g\xFCnstigeren Tarifen Intercity-Buslinien nutzen. Hierf\xFCr m\xFCssen Sie beim Kartenkauf einen g\xFCltigen internationalen Studentenausweis vorlegen.</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/transportation/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t \t</div>\n\t\t\t\t\t\t\t\t<h3>Smart Ride-Karte - Rav Kav</h3>\n\t\t\t\t\t\t\t\t<p >Touristen k\xF6nnen eine sogenannten Rav Kav Card kaufen. Sie kann f\xFCr einen g\xFCnstigen Preis &nbsp;im Bus gekauft und dann mit einem normalen Multi-Ride- oder Single-Ticket wieder aufgeladen werden, normalerweise im Rahmen eines Regionen-Rabatts von 20%.</p>\n\t\t\t\t\t\t\t\t<p >Touristen k\xF6nnen keine Pers\xF6nliche Rav Kav Card kaufen, auf der die pers\xF6nlichen Daten des Fahrgastes stehen, diese ist nur f\xFCr Einwohner.</p>\n\t\t\t\t\t\t\t\t<p >Bitte beachten Sie:</p>\n\t\t\t\t\t\t\t\t<p >-&nbsp;Die Rav Kav kann f\xFCr die Zahlung f\xFCr den Transport mehrerer Fahrg\xE4ste benutzt werden,</p>\n\t\t\t\t\t\t\t\t<p >-&nbsp;Kinder zahlen genauso viel wie Erwachsene.</p>\n\t\t\t\t\t\t\t\t<p >-&nbsp;Die Rav Kav kann in einer Region genutzt werden und nicht zwischen Regionen, es sei denn, sie wurde speziell f\xFCr die gew\xFCnschten Routen wieder aufgeladen.</p>\n\t\t\t\t\t\t\t\t<p >-&nbsp;In manchen Regionen kann man Tageskarten innerhalb einer Region kaufen.<br><br>Please give Price List here!</p>\n\t\t\t\t\t\t\t\t<h3>Inlandsfl\xFCge</h3>\n\t\t\t\t\t\t\t\t<p >Israel ist ein kleines Land und daher lohnt es sich nur, zwischen Eilat und Tel Aviv zu fliegen. Verschiedene Fluggesellschaften bieten Fl\xFCge von Eilat zum Flughafen Ben Gurion oder Sde Dov im Norden von Tel Aviv an. Die Flugtarife sind g\xFCnstig, aber nat\xFCrlich h\xF6her als ein Busticket.</p>\n\t\t\t\t\t\t\t\t<p >Es gibt auch Privatunternehmen, die auf Anfrage spezielle Fl\xFCge innerhalb des Landes anbieten.</p>\n\t\t\t\t\t\t\t\t<p >Arkia: <a href=\"https://www.arkia.com/flights-in-israel\" target=\"_blank\" rel=\"noopener\">www.arkia.com/flights-in-israel</a> Telefon: 00 972 3 690 2222,</p>\n\t\t\t\t\t\t\t\t<p>Israair: <a href=\"https://int.israirairlines.com/cat_domestic.asp\"  target=\"_blank\" rel=\"noopener\">&nbsp;int.israirairlines.com/cat_domestic.asp</a> Telefon: 00 972 3 795 5777</p>\n\t\t\t\t\t\t\t\t<h3>Autovermietung</h3>\n\t\t\t\t\t\t\t\t<p>Die meisten internationalen Mietwagenfirmen und lokale Firmen haben B\xFCros in den Gro\xDFst\xE4dten und am Flughafen Ben Gurion. Es ist zu empfehlen, einen Wagen vom Ausland aus im Voraus zu reservieren.</p>\n\t\t\t\t\t\t\t\t<p>Um ein Auto zu mieten, muss man \xE4lter als 24 Jahre sein und einen g\xFCltigen internationalen F\xFChrerschein sowie eine Kreditkarte haben.</p>\n\t\t\t\t\t\t\t\t<p>Das Stra\xDFensystem in Israel ist fl\xE4chendeckend und in der Regel deutlich beschildert (auf Hebr\xE4isch, Englisch und Arabisch).</p>\n\t\t\t\t\t\t\t\t<h3>Autofahren in Israel</sh3>\n\t\t\t\t\t\t\t\t<p><strong>Das Mindestalter</strong> f\xFCr Autofahrer ist in Israel 17 Jahre und es herrscht Rechtsverkehr. Die Geschwindigkeitsbegrenzung liegt bei 30 bis 50&nbsp;km/h in St\xE4dten, 80 bis 90&nbsp;km/h auf Landstra\xDFen sowie 130&nbsp;km/h auf Autobahnen und der Route Nr. 6. Sicherheitsgurt sind Pflicht. Und wenn Sie das Nachtleben in der Stadt genie\xDFen, denken Sie daran, dass die Promillegrenze beim Fahren bei Null Prozent liegt. Organisieren Sie daher einen Fahrer, damit Sie unbesorgt genie\xDFen k\xF6nnen.</p>\n\t\t\t\t\t\t\t\t<h3>Highway 6</h3>\n\t\t\t\t\t\t\t\t<p>Highway 6 betreibt ein elektronisches Mautsystem, das weder Schranken an Ein- und Ausfahrten noch Ampeln hat, sodass der Verkehr frei flie\xDFen kann. Fortgeschrittene Computersysteme (wie etwa elektronische Mautstellen), die an der Autobahn montiert sind, erkennen Fahrzeuge, kategorisieren Geb\xFChrenarten (Abos oder nicht registriert) und ermitteln die Anzahl an Autobahnabschnitten, die jedes Fahrzeug passiert. Jede Fahrt wird automatisch erfasst und berechnet. F\xFCr Fahrer ist es \xE4u\xDFerst komfortabel und sicher bei einem Geschwindigkeitslimit von 130 km/h.</p>\n\t\t\t\t\t\t\t\t<p>Touristen mit einem Mietwagen werden \xFCber Kreditkarte abgerechnet. Informationen zu Bedingungen und Tarifen erhalten Sie bei Ihrer Autovermietung.</p>\n\t\t\t\t\t\t\t\t<p>Die meisten Autovermietungen bieten keine Versicherung f\xFCr die Regionen in der Pal\xE4stinensischen Beh\xF6rde f\xFCr das Westjordanland an. Touristen, die mit einem Mietwagen in diese Regionen fahren m\xF6chten, wird empfohlen, eine entsprechende Versicherung abzuschlie\xDFen.<br>&nbsp;</p>\n\t\t\t\t\t\t\t\t<p>PLEASE ADD:<br><br><strong>Route 1 Jerusalem - Totes Meer</strong></p>\n\t\t\t\t\t\t\t\t<p>Sie k\xF6nnen mit ihrem Wagen problemlos auf der Bundesstra\xDFe 1 von Jerusalem direkt an das Tote Meer fahren. Sie passieren dabei lediglich zwei Checkpoints.<br><br><strong>Route 90 Totes Meer \u2013 See Genezareth</strong><br><br>Auch die Bundesstra\xDFe 90 k\xF6nnen Sie in der Regel problemlos mit ihrem Mietwagen entlangfahren. Die Bundesstra\xDFe 90 verbindet auf direktem Weg das Tote Meer mit dem See Genezareth. Auch hier passieren Sie nur zwei Checkpoints.<br>(Es gibt einige Ausnahmen vereinzelter Mietwagenfirmen, die das Passieren der Route 90 nicht gestatten. Informieren Sie sich diesbez\xFCglich im Vorfeld)</p>\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n         \t"};}},{id:"Shoping_In_Israel",bgImage:"/posts/bank/jerusalem4/1.jpg",mobBgImage:"/posts/bank/jerusalem4/M.jpg",title:"EINZIGARTIGES KAUFERLEBNIS IN ISRAEL",ctg:"jerusalem",isVid:false,smlTitle:"",html:function html(){return{__html:"\n                               \n\t\t\t\t\t\t\t \t\n\t\t\t\t\t\t\t \t<p>Israel ist auch das Land der sch\xF6nen Dinge. Aufgrund der verschiedenen Religionen und kulturellen Hintergr\xFCnde seiner Bewohner finden Sie hier auch die unterschiedlichsten Formen an Souvenirs. Auf den M\xE4rkten, in den Gesch\xE4ften und Galerien werden Sie eine unglaubliche F\xFClle an Produkten sehen, bei denen sicher etwas f\xFCr Sie dabei ist und sich ebenso als sch\xF6ne Urlaubserinnerung und Geschenk f\xFCr ihre Freunde und Familie eignet.</p>\n\t\t\t\t\t\t\t\t<h3>Souvenirs von den heiligen St\xE4tten</h3>\n\t\t\t\t\t\t\t\t<p>Einige der sch\xF6nsten Momente Ihrer Reise in Israel warten auf Sie an den heiligen St\xE4tten Israels in Gali\xE4a und Jerusalem. Auff\xE4llige blaue und wei\xDFe Keramik aus Armenien, die mit Familienmotiven dekoriert sind, werden gerne als Erinnerungst\xFCcke mitgenommen. Jahrhundertealte Handwerkskunst verzieren mit Olivenholz und Perlmutt jetzt Bibeln, Schachteln, Broschen und viele andere Gegenst\xE4nde, die Ihren Aufenthalt in guter Erinnerung behalten.</p>\n\t\t\t\t\t\t\t\t<h3>Einzigartige Judaika</h3>\n\t\t\t\t\t\t\t\t<p>Was w\xFCrde sich nicht besser als Erinnerung an Safed, Jerusalem oder Jaffa eignen als das sch\xF6ne j\xFCdische Kunsthandwerk, auch Judaika genannt. Empfinden Sie den Sabbat nach und schm\xFCcken Sie ihren Tisch zuhause mit einem handbestickten Challah- oder Matzah-Bezug (leicht und einfach zu verstauen!), oder Kerzen, einem Kidduschbecher oder nehmen Sie eine Chanukkah-Menora in zeitgem\xE4\xDFem oder traditionellen Silber, aus Zinn, Glas oder Keramik als Erinnerung mit. Mesusas (eine Schriftrollenkapsel f\xFCr den T\xFCrpfosten) eignen sich perfekt als Einweihungsgeschenk und ein Gebetsschal ist eine lebenslange Bar/Bat Mitzwah-Erinnerung.</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/shoping-in-israel/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t \t</div>\n\t\t\t\t\t\t\t\t<h3>Produkte aus dem Toten Meer</h3>\n\t\t\t\t\t\t\t\t<p>Israel ist Heimat des weltgr\xF6\xDFten Heilbads - das Tote Meer. Nach einem Bad in seinem mineralienreichen Wasser f\xFChlen sich Ihre Haut und Ihre Haare seidig weich an. Und ja, es wird auch in Flaschen abgef\xFCllt! Sie k\xF6nnen ein ganzes Produktsortiment an Mineralien aus dem Toten Meer kaufen, wundersch\xF6n als Geschenk aus Israel verpackt.</p>\n\t\t\t\t\t\t\t\t<h3>Einkaufen</h3>\n\t\t\t\t\t\t\t\t<p>Sicher m\xF6chten Sie durch die Fabrikoutlets schlendern, um sich dort auf die Suche zu begeben nach neuen Lieblingsst\xFCcken f\xFCr ihren Kleiderschrank und um die angesagten Outfits der weltber\xFChmten israelischen Modedesigner zu entdecken. Ebenfalls beliebt: die sch\xF6ne kreative Babybekleidung aus 100% Baumwolle, die Sie m\xFChelos in Ihrem Koffer verstauen und als Geschenk mitbringen k\xF6nnen. Haben Sie sich die F\xFC\xDFe in Israel platt gelaufen? Bevor Sie nachhause fliegen sollten Sie sich noch ein paar bequeme, in Israel gefertigte Sandalen oder Schuhe zum unschlagbaren Preis kaufen.</p>\n\t\t\t\t\t\t\t\t<h3>Schmuck</h3>\n\t\t\t\t\t\t\t\t<p>Israelische Schmuckdesigner verbreiten sich mehr und mehr bei eleganten Juwelieren weltweit. Wenn Sie bei den Designern in Israel kaufen, sind sie direkt an der Quelle. Trendige Armreifen sind hoch im Rennen mit ihren mehrfarbigen Kristallen und Perlen, in scheinbar endlosen Schattierungen. Au\xDFerdem Kreationen in elegantem gr\xFCn-blauem Malachit (Eilat-Stein), an denen man erkennen kann, dass Sie in Israel waren.</p>\n\t\t\t\t\t\t\t\t<p>Israel ist seit langem ber\xFChmt f\xFCr seine geschliffenen Diamanten und f\xFCr das Wissen und die Kompetenz seiner Diamatenexperten. Als diamantenexportierendes Land kann Israel in diesem Bereich einen Kaufvorteil anbieten. Au\xDFerdem haben Sie die M\xF6glichkeit, eine Diamantenmanufaktur zu besichtigen, in der Sie alles Wissenswerte \xFCber diesen Industriezweig erfahren.</p>\n\t\t\t\t\t\t\t\t<h3>Nicht zu vergessen das Essen</h3>\n\t\t\t\t\t\t\t\t<p>Ein gro\xDFartiges Souvenir sind auch die vielen Feinschmeckerprodukte mit Delikatessen der Landesk\xFCche in Israel. Es gibt Gew\xFCrze wie die biblische Ysop-Pflanze und s\xFC\xDFe Datteln sch\xF6n verpackt als Mitbringsel f\xFCr zuhause sowie eine Vielzahl verschiedener Kr\xE4utertees, Honig, preisgekr\xF6nte Weine und andere Produkte.</p>\n\t\t\t\t\t\t\t\t<p>Und wenn Sie mit Ihren Geschenken am Flughafen ankommen, kommen Sie auch noch in den Genuss der Mehrwertsteuerr\xFCckerstattung bei K\xE4ufen im Wert von \xFCber 100 US-Dollar in teilnehmenden Gesch\xE4ften.</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n         \t"};}},{id:"Park_Timna",bgImage:"/posts/bank/negev4/1.jpg",mobBgImage:"/posts/bank/negev4/M.jpg",title:"TIMNA PARK",ctg:"eilat-negev",isVid:true,vidId:"Id0U0OeDs7Y",smlTitle:"",html:function html(){return{__html:"\n                                <h2>Ein begeisterndes W\xFCstenabenteuer</h2>\n\t\t\t\t\t\t\t \t\n\t\t\t\t\t\t\t \t<p>Erkunden Sie die nat\xFCrliche Sch\xF6nheit und spannende Attraktionen des Timna Parks</p>\n\t\t\t\t\t\t\t\t<p>Der Timna Park ist ein einmaliges Erlebnis nur 20 Minuten von Eilat entfernt im Herzen der W\xFCste Negev und eingebettet inmitten einer atemberaubenden Naturkulisse. Zahlreiche Attraktionen und Aktivit\xE4ten vereinen Natur, historische Altert\xFCmer und Abenteuer auf einem weitl\xE4ufigen Gel\xE4nde, das Besuchern aller Altersgruppen und Interessen jede Menge Unterhaltung bietet.</p>\n\t\t\t\t\t\t\t\t<h3>Werden Sie Zeuge eines herausragenden Naturph\xE4nomens</h3>\n\t\t\t\t\t\t\t\t<p>Bestaunen Sie beim Spazieren durch den Park die <strong>einzigartigen Felsformationen </strong>mit interessanten Namen und seltenen Formen, die Sie mit der Hand ber\xFChren k\xF6nnen; \u201CMushroom,\u201D \u201CMushroom &amp; a Half,\u201D \u201CPink Canyon,\u201D \u201CArches,\u201D \u201CSolomon\u2019s Pillars\u201D und \u201CValley of Rock Drawings -\u201D sie bezeichnen das Leben einer l\xE4ngst vergangenen Zeit.</p>\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t<h3>Wandern in freier Natur</h3>\n\t\t\t\t\t\t\t\t<p>Starten Sie an einem der 20 gut beschilderten <strong>Wanderwege</strong>, die sich im Schwierigkeitsgrad unterscheiden und auf die jeweiligen Bed\xFCrfnisse und F\xE4higkeiten zugeschnitten sind. Wandern Sie auf spektakul\xE4ren, geologisch und arch\xE4ologisch bedeutsamen Wegen oder gehen Sie ganz gem\xFCtlich den im Schatten liegenden <strong>Timna Lake</strong> und seinem angrenzenden Campingplatz entlang, vorbei an K\xF6nig Solomons Khan-Restaurant, wo man W\xFCstenhandwerk wie etwa Flaschen hergestellt aus gef\xE4rbtem Sand findet oder Tretboote ausleihen kann.</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/park-timna/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t \t</div>\n\t\t\t\t\t\t\t\t<p>Sind Sie mehr f\xFCr <strong>Extremsport</strong>? Wie w\xE4re es mit Abseilen von den Klippen, Seilbahn fahren und einer Radtour im Park, danach f\xFChlen Sie sich garantiert wie neu geboren.</p>\n\t\t\t\t\t\t\t\t<h3>Erleben Sie alte Zeiten</h3>\n\t\t\t\t\t\t\t\t<p>Bei einer F\xFChrung durch den wieder aufgebauten <strong>Tabernakel </strong>(\u201EH\xFCtte\u201C oder auch \u201EGasthaus\u201C), der mit einer Nachbildung des Altars, dem Allerheiligsten und der Arche vervollst\xE4ndigt wurde, erfahren Sie alles \xFCber die biblische Geschichte in der W\xFCste.&nbsp; J\xFCngere Besucher stehen zum Teil ehrf\xFCrchtig vor der Reproduktion dieses Heiligtums, das Gott den Juden befohlen hat, in der W\xFCste aufzubauen - \xE4ltere Besucher hingegen neigen dazu die Rekonstruktion auf ihre historische Pr\xE4zision hin zu untersuchen.</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/park-timna/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t \t</div>\n\t\t\t\t\t\t\t\t<p>Timna Park. Hier trifft die Geschichte auf Abenteuerlust.</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n         \t"};}},{id:"Passport_Visa",bgImage:"/HomeSlider/Home/3.jpg",mobBgImage:"/HomeSlider/M/3.jpg",title:"REISEPASS UND VISUM",ctg:"TouristInfo",isVid:false,smlTitle:"",html:function html(){return{__html:"\n                               \n\t\t\t\t\t\t\t \t\n\t\t\t\t\t\t\t \t<p>Alle Besucher m\xFCssen bei ihrer Ankunft in Israel einen Pass vorweisen, der mindestens sechs Monate ab Ausreisedatum g\xFCltig ist. Menschen, die keine Staatangeh\xF6rigkeit besitzen, m\xFCssen einen g\xFCltigen Passierschein sowie ein Visum f\xFCr die R\xFCckreise in das Land mit sich f\xFChren, von dem es ausgestellt wurde.</p>\n\t\t\t\t\t\t\t\t<p>Besucher sind berechtigt, sich ab ihrer Ankunft bis zu drei Monate in Israel aufzuhalten gem\xE4\xDF der Bedingungen des f\xFCr sie ausgestellten Visums. Besucher, die in Israel arbeiten m\xF6chten, m\xFCssen eine Anfrage auf ein spezielles Visum an das Ministry of the Interior (Innenministerium) stellen.</p>\n\t\t\t\t\t\t\t\t<p>Israel stempelt keine P\xE4sse mehr an Flugh\xE4fen sowie an den meisten Landesgrenzen. Jedoch kann es aufgrund technischer Probleme manchmal dazu kommen, dass an Grenzkontrollen auf die Methode des Stempels im Pass zur\xFCckgegriffen wird. Wir empfehlen, dass Touristen, die von Israel aus weiter in arabische L\xE4nder reisen m\xF6chten, einen <strong>offiziellen Antrag</strong> stellen, ihren Pass nicht mit einem israelischen Stempel zu versehen. Der Tourist muss den Beamten \xFCber diesen Antrag in Kenntnis setzen, bevor die Dokumente gestempelt werden.<br><br><strong>Der \u201EElectronic Gate Pass\u201C</strong></p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/passports-visa/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t \t</div>\n\t\t\t\t\t\t\t\t<p>Nach Artikel 13 des Gesetzes \xFCber die Einreise nach Israel von 1952 kann ein offizieller Inspektor oder Polizist die Identifizierung und den Nachweis des rechtlichen Status in Israel anfordern. Zu diesem Zweck wird an der Grenzkontrollstation per Knopfdruck eine Karte inklusive der wichtigsten Angaben des Reisenden (entnommen der ersten Seite des Passes) ausgedruckt. Auf der Karte werden auch das Ankunftsdatum und die Visaangaben angezeigt. Diese Karte ist der \u201EElectronic Gate Pass. Es ist ein neues und modernes technisches System, das ma\xDFgeblich dazu beitr\xE4gt, die Bed\xFCrfnisse der verschiedenen Einwanderungs-, Sicherheits-, Flughafen- und Touristikbeh\xF6rden zu erf\xFCllen, und das Touristen den erforderlichen Nachweise ihres Visastatus belegt. <strong>Der \u201EElectronic Gate Pass\u201C ersetzt das System, bei dem der Pass gestempelt wird.</strong> Am Flughafen erm\xF6glicht diese Karte dem Reisenden, den Ankunftsterminal ohne weitere Verz\xF6gerung zu verlassen.</p>\n\t\t\t\t\t\t\t\t<p><strong>Der Gate Pass ist ein amtlicher Ausweis f\xFCr den Aufenthalt in Israel. </strong>Wir bitte alle Touristen, die Karte als Nachweis ihres Visastatus immer mit sich zu f\xFChren. Am Flughafen und an festgelegten Grenz\xFCberg\xE4ngen erm\xF6glicht diese Karte dem Reisenden, den Ankunftsterminal zu verlassen und sich zur Gep\xE4ckausgabe zu begeben.</p>\n\t\t\t\t\t\t\t\t<p><strong>Touristen werden gebeten, die Karte als Nachweis immer mit sich zu f\xFChren.</strong></p>\n\t\t\t\t\t\t\t\t<h3>Weitere Visinformationen</h3>\n\t\t\t\t\t\t\t\t<p><a href=\"//embassies.gov.il/berlin/ConsularServices/visainformation/Pages/Visainformation.aspx\">http://embassies.gov.il/berlin/ConsularServices/visainformation/Pages/Visainformation.aspx</a></p>\n\t\t\t\t\t\t\t\t<h3>Touristenvisa</h3>\n\t\t\t\t\t\t\t\t<p>Wir hei\xDFen Sie in Israel herzlich willkommen. Viele L\xE4nder haben ein Visumsbefreiungsabkommen mit Israel, das ihren Einwohnern erm\xF6glicht, Israel zu besuchen, ohne im Vorfeld ein Visum auszustellen. Vor Reiseantritt sollten Reisende, die auf ihrem Weg in andere Zielgebiete in Israel Zwischenstopp machen m\xF6chten, pr\xFCfen, ob Sie ein Touristenvisum im Voraus beantragen m\xFCssen. Die Liste der L\xE4nder in folgendem Link gibt an, aus welchen L\xE4ndern Touristen im Voraus ein Visum beantragen m\xFCssen.</p>\n\t\t\t\t\t\t\t\t<p><a href=\"//mfa.gov.il/MFA/ConsularServices/Documents/VisaRequirements-Tourists.pdf\">http://mfa.gov.il/MFA/ConsularServices/Documents/VisaRequirements-Tourists.pdf</a></p>\n\t\t\t\t\t\t\t\t<p>Alle Reisenden, die aus visumsbefreiten L\xE4ndern kommen, m\xFCssen einen maschineleserlichen Pass am Eingangsflughafen vorweisen, um in Israel ohne Visum einzureisen; ansonsten ist ein Visum erforderlich. Dies gilt f\xFCr Touristen, die mit einem Passierschein aus L\xE4ndern mit Visumbefreiung kommen.</p>\n\t\t\t\t\t\t\t\t<h3>Aufenthaltsverl\xE4ngerung</h3>\n\t\t\t\t\t\t\t\t<p>Ihr Visum kann bei einem Ministry of the Interior (Innenministerium) in Ihrer N\xE4he verl\xE4ngert werden (gegen Geb\xFChr). Bitte rufen Sie hierzu an unter: Durchwahl 3450 oder w\xE4hlen Sie 12223450.</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n         \t"};}},{id:"Stay_In_THe_Negev",bgImage:"/posts/bank/negev3/1.jpg",mobBgImage:"/posts/bank/negev3/M.jpg",title:"ÜBERNACHTEN IN DER NEGEV WÜSTE",ctg:"eilat-negev",isVid:false,smlTitle:"",html:function html(){return{__html:"\n                               \n\t\t\t\t\t\t\t \t\n\t\t\t\t\t\t\t \t<p>Bei einer Reise in den Negev warten nicht nur grandiose Panoramen und die Stille der Natur auf Sie, die einem bei dem Gedanken an eine W\xFCste sofort vor dem inneren Auge entstehen. Selbstverst\xE4ndlich findet man die Sch\xF6nheit der Natur, die Ruhe und die wundervollen Ausblicke, die sich W\xFCstenreisende w\xFCnschen - der Negev ist aber auch ein Ort, der Urlaubsm\xF6glichkeiten mit dem vollen Komfort der westlichen Welt und spannenden, abenteuerlichen Aktivit\xE4ten zu bieten hat.</p>\n\t\t\t\t\t\t\t\t<p>Im Negev finden Sie eine gro\xDFe Auswahl an \xDCbernachtungsm\xF6glichkeiten. Die gew\xE4hlte Unterkunft ist nicht nur ein Platz zum \xDCbernachten, sondern bietet Ihnen die Gelegenheit, das unbestreitbare Juwel des Negev kennen zu lernen \u2013 die Menschen vor Ort. Von den Kibbuz-Bewohnern \xFCber abgelegen lebende Bauern bis hin zu den Beduinen: Die Bewohner des Negev sind warmherzige und hilfsbereite Gastgeber. Hier folgt eine kleine Auswahl der Unterbringungsm\xF6glichkeiten, die im Negev auf Sie warten:</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/stay-in-negev/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t \t</div>\n\t\t\t\t\t\t\t\t<p>Hotels \u2013 Im Negev gibt es eine gro\xDFe Auswahl an Hotels, die von Budget-Hotels bis zu preisgekr\xF6nten 5-Sterne-Luxushotels reichen, in denen Sie sich w\xE4hrend Ihrer Auszeit in der W\xFCste stilvoll entspannen k\xF6nnen.</p>\n\t\t\t\t\t\t\t\t<p>Hostels \u2013 erschwingliche Unterk\xFCnfte, die sich vor allem an junge Reisende richten. Hier genie\xDFen viele Touristen die Gelegenheit, sich mit anderen gleichgesinnten Reisenden aus der ganzen Welt zu treffen, sich zu unterhalten und abends andere Menschen kennenzulernen und oft dauerhafte Freundschaften zu kn\xFCpfen.</p>\n\t\t\t\t\t\t\t\t<p>Zimmers - Die israelische Version des Bed and Breakfast, normalerweise getrennt von den eigenen vier W\xE4nden der Eigent\xFCmer. Zimmers sind oft etwas abgelegene und gem\xFCtliche Unterk\xFCnfte, die sich gut f\xFCr Reisende auf der Suche nach Romantik und Ruhe eignen.&nbsp;</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/stay-in-negev/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t \t</div>\n\t\t\t\t\t\t\t\t<p>Hotelzelte der Beduinen \u2013 Diese wahrhaft einzigartige und authentische Form der Gastfreundschaft ist ein absolutes Muss im Negev. Sie lernen die Lebensweise der einheimischen Beduinen kennen und haben die au\xDFergew\xF6hnliche Chance, an ihren Br\xE4uchen in ihrer nat\xFCrlichen Umgebung teilzuhaben \u2013 sehr zu empfehlen.</p>\n\t\t\t\t\t\t\t\t<p>Khans \u2013 Noch eine einzigartige Unterbringungsform im Negev. Die beliebten Kahns sind gro\xDFe Freiluftkomplexe, in denen Sie in H\xFCtten oder Gemeinschaftsschlafr\xE4umen \xFCbernachten und alle Einrichtungen f\xFCr den t\xE4glichen Bedarf finden. Kahns sind h\xE4ufig eine einfachere und rustikalere Form der Unterbringung, sie sind aber auch eine ausgezeichnete M\xF6glichkeit, die entspannte Atmosph\xE4re der Region zu genie\xDFen, mit anderen Reisenden und Einheimischen in Kontakt zu kommen und sich als Teil der nat\xFCrlichen W\xFCstenlandschaft zu f\xFChlen.</p>\n\t\t\t\t\t\t\t\t<p>Abgelegene Bauernh\xF6fe \u2013 Abgelegene Bauernh\xF6fe haben sich in j\xFCngerer Zeit als Form der Unterkunft entwickelt. Hier kommen G\xE4ste \xFCber die gesamte Negev-Region verteilt in den G\xE4stezimmern uriger, abgeschiedener Familienbetriebe unter.&nbsp; Sie verbinden eine ruhige Atmosph\xE4re mit heimischem Komfort. Die Geh\xF6fte bieten Privatsph\xE4re, unglaubliche Panoramen und eine Gelegenheit, die sagenhafte W\xFCstenatmosph\xE4re des Negev wie ein Einheimischer zu erleben.</p>\n\t\t\t\t\t\t\t\t<p>Kibbuz -&nbsp;Eine typisch israelische Form der Kommune: Unterk\xFCnfte im Kibbuz bieten gute Leistungen zu erschwinglichen Preisen. Der wahre Reiz der Kibbuzim liegt aber ohne Zweifel in ihrer besonderen Atmosph\xE4re und dem Gemeinschaftsgef\xFChl, das die freundliche, offenherzige und gastfreundliche Stimmung der Bewohner verbreitet und das einen angenehmen und unvergesslichen Aufenthalt garantiert.</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n         \t"};}},{id:"Desert_Adventure",bgImage:"/posts/bank/negev2/1.jpg",mobBgImage:"/posts/bank/negev2/M.jpg",title:"DER NEGEV",ctg:"eilat-negev",isVid:false,smlTitle:"",html:function html(){return{__html:"\n                                <h2>Der Negev er perfekte Ort f\xFCr Ihr pers\xF6nliches W\xFCstenabenteuer</h2>\n\t\t\t\t\t\t\t \t\n\t\t\t\t\t\t\t \t<p>F\xFCr einen atemberaubend, erholsamen Urlaub unter der W\xFCstensonne gibt es keinen besseren Ort als den Negev.</p>\n\t\t\t\t\t\t\t\t<p >Ein Besuch in Israels Negev W\xFCste wird Sie begeistern. Der Negev bedeckt mehr als die H\xE4lfte der gesamten Landfl\xE4che Israels und ist reich an Sand, Sonne, Naturschutzgebieten und touristischen Attraktionen. Das macht die s\xFCdliche Region des Landes zu einem absoluten Muss auf Ihrer n\xE4chsten Israelreise, besonders wenn Sie eine klare, sternenhelle Nacht in der israelischen W\xFCste erleben m\xF6chten.</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/desert-adventure/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t \t</div>\n\t\t\t\t\t\t\t\t<h3 >Entspannen Sie sich inmitten der Sch\xF6nheit der Natur</h3>\n\t\t\t\t\t\t\t\t<p >Fahren Sie nach S\xFCden in die israelische Negev W\xFCste, wo Sand und Sonne zusammentreffen, und lernen Sie die Region \xFCber ihre interessanten Wanderwege, atemberaubenden Ausblicke, historischen St\xE4tten und touristischen Attraktionen genauer kennen. Sie k\xF6nnen zahlreiche Aktivit\xE4ten ausprobieren, die Ihren individuellen Interessen entsprechen, und sich dabei unter die Einheimischen mischen, majest\xE4tische Tiere beobachten und historische Kulturen kennenlernen. Besuchen Sie den Ramon Krater, wo Ihr Blick in unendliche Weiten schweift. Entrollen Sie eine Yogamatte oder setzen Sie sich direkt in den farbigen Sand, um einen Moment tiefer Entspannung und intensiver Meditation zu genie\xDFen. Wenn die Sonne untergeht und der Himmel sich mit Sternen f\xFCllt, fahren Sie in ein Beduinen-Camp, wo G\xE4ste wie K\xF6nige mit k\xF6stlichen Leckereien verw\xF6hnt werden, aufregende Kamelritte machen oder in der W\xFCste zelten k\xF6nnen. Oder Sie reisen entlang der Weihrauchroute und besuchen die vier St\xE4dte, die durch den Handel mit Gew\xFCrzen zu Reichtum kamen und heute Weltkulturerbe sind.</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/desert-adventure/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t \t</div>\n\t\t\t\t\t\t\t\t<h3 >Familienurlaub unter dem W\xFCstenhimmel ist das Gr\xF6\xDFte</h3>\n\t\t\t\t\t\t\t\t<p >In der W\xFCste Israels werden die Bed\xFCrfnisse jeder Familie auf Reisen mit spannenden Aktivit\xE4ten und wunderbarer Gastfreundschaft erf\xFCllt - wobei in kurzer Zeit auch zahlreiche moderne Hotels und malerische G\xE4steh\xE4user erreichbar sind. Der Negev steckt voller erstaunlicher Sehensw\xFCrdigkeiten und Aktivit\xE4ten und ist ein gro\xDFartiger Ort, um sich auf einfache Weise zu vergn\xFCgen, z.&nbsp;B. mit einer Wanderung durch die Nationalparks, beim Radfahren auf den Radwegen der Region oder auf Touren mit dem Jeep (oder ATV) \xFCber die D\xFCnenk\xE4mme und -t\xE4ler. Bereits der Aufenthalt in der unglaublichen Weite und den H\xFCgeln der Region ist ein aufregendes Abenteuer, unabh\xE4ngig von der Aktivit\xE4t, die Sie w\xE4hlen. Und wenn Sie Ihren Urlaub entspannter verbringen m\xF6chten, besuchen Sie eines der Weing\xFCter im Negev, tr\xE4umen an einer kristallklaren Quelle im Herzen der israelischen W\xFCste oder lassen sich \xFCber einen Bauernhof im S\xFCden f\xFChren, um sich in den Obstg\xE4rten zu erfrischen. Sie k\xF6nnen Ihren Besuch in der W\xFCste auch nutzen, um sich nach einer kurzen Weiterreise im salzigen Toten Meer treiben zu lassen und Ihre Haut mit dem samtigen Schlamm der Region zu reinigen.</p>\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n         \t"};}},{id:"Adventures_In_Galilea",bgImage:"/posts/bank/north3/1.jpg",mobBgImage:"/posts/bank/north3/M.jpg",title:"AKTIVURLAUB IN GALILÄA",ctg:"north",isVid:false,smlTitle:"",html:function html(){return{__html:"\n                                <h2>Aktiv Abenteuer erleben in Galil\xE4a</h2>\n\t\t\t\t\t\t\t \t\n\t\t\t\t\t\t\t \t<p>Die Vielfalt der Fl\xFCsse und Seen und die K\xFCste Galil\xE4as bieten jede Menge Spa\xDF f\xFCr alle Altersgruppen. Abenteuerlustige sp\xFCren beim Kajakrennen im Wildwasser mit ihren Freunden die Gischt auf den Gesichtern, w\xE4hrend Familien oder Paare sich gemeinsam auf einem der vielen Fl\xFCsse Galil\xE4as an den k\xFChlen gr\xFCnen Ufern entlang treiben lassen. Abk\xFChlung finden Sie auch beim aufregendem Wassersport wie Wasserski, Tubing oder Kitesurfen auf dem See Genezareth. Bei Touristen ist es sehr beliebt, sich an den hei\xDFen Sandstr\xE4nden Galil\xE4as entlang der K\xFCste zu entspannen oder die geheimnisvoll leuchtende Sch\xF6nheit der Rosh Hanikra-Grotten zu bewundern.</p>\n\t\t\t\t\t\t\t\t<p>Und wer mag, kann zu Lande, in der Luft und auf dem Wasser der Extremsportart seiner Wahl nachgehen. Aktivtouristen holen sich Ihren Adrenalinkick beim Fallschirmspringen, Offroad-Fahrten \xFCber raue Bergpfade oder beim Abseilen an anspruchsvollen Klippen. Im Winter lockt das Hermon-Gebirge Wintersportler mit Ski und Snowboarding auf leichten oder anspruchsvollen Pisten.</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/adventures-in-galilea/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t \t</div>\n\t\t\t\t\t\t\t\t<h3>Der atemberaubende Reichtum der Natur Galil\xE4as</h3>\n\t\t\t\t\t\t\t\t<p>Galil\xE4a ist mit einer F\xFClle landschaftlich reizvoller Gebiete gesegnet, wo Familien, Paare Alleinreisende und Gruppen die Umwelt auf Wanderungen genie\xDFen, die Tierwelt bestaunen oder einfach nur ein Picknick in der Stille der Natur genie\xDFen k\xF6nnen. Bei Ausritten zu Pferde auf ruhigen Wegen oder beim Wandern oder Radfahren auf gut markierten Pfaden belohnt Galil\xE4a Sie immer mit seiner Sch\xF6nheit und mit Spa\xDF und Spannung. Erleben Sie die Natur auf entspannte Art und Weise beim Beobachten von V\xF6geln und Wildtieren im Naturschutzgebiet Hula Valley, oder lassen Sie sich beim Aufsteigen in einem Hei\xDFluftballon in der Gilboa von dem Flickenteppich aus Wald, Feldern und Fl\xFCssen, der sich unter Ihnen ausbreitet, begeistern. Ein Erlebnis ganz anderer Art wartet beim Eintauchen in die religi\xF6se Atmosph\xE4re der heiligen St\xE4tten von Christen, Juden und Baha\u2018i auf Sie.</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/adventures-in-galilea/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t \t</div>\n\t\t\t\t\t\t\t\t<p>Die vielen Wanderwege in Galil\xE4a ziehen das ganze Jahr lang Wanderer jeden Alters an. Ob Sie lieber schattige Spazierg\xE4nge entlang sanfter B\xE4che, den Nervenkitzel beim Bergsteigen und Abseilen oder die fantastische Aussicht vom Gipfel nach einem anspruchsvollen Anstieg genie\xDFen, hier finden Sie den perfekten Weg f\xFCr sich. In Galil\xE4a stehen Ihnen alle Optionen offen.</p>\n\t\t\t\t\t\t\t\t<p>photo credit: Itamar Grinberg</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n         \t"};}},{id:"Eilat_",bgImage:"/posts/bank/eilat1/1.jpg",mobBgImage:"/posts/bank/eilat1/M.jpg",title:"WAS MACHT EILAT ZUM ULTIMATIVEN URLAUBSZIEL?",ctg:"eilat-negev",isVid:false,smlTitle:"",html:function html(){return{__html:"\n                               <h2>Erkunden Sie die Stadt des ewigen Sonnenscheins</h2>\n\t\t\t\t\t\t\t \t\n\t\t\t\t\t\t\t \t<p><strong>Eilat</strong>, die s\xFCdlichste Stadt Israels, bietet Ihnen alles, was Sie f\xFCr einen perfekten Urlaub brauchen. Ob Sie romantisch in den Urlaub starten m\xF6chten, einen Familienurlaub planen, ein actionreiches Abenteuer suchen oder auf ein Partywochenende mit Ihren Freunden aus sind: dieser lebhafte Ferienort am Roten Meer ist das richtige Reiseziel f\xFCr Sie. Die Mittelmeersonne, kristallklares Wasser, entspannende SPAs, ein pulsierendes Nachtleben, steuerfreies Einkaufen und unz\xE4hlige Attraktionen - das ist Eilat f\xFCr Sie!</p>\n\t\t\t\t\t\t\t\t<p><strong>Baden Sie in der Sonne! </strong>Weil in Eilat das ganze Jahr \xFCber die Sonne scheint, ist die beste Zeit f\xFCr einen Besuch ... jederzeit! Selbst wenn Europa mitten im eisigen Winter friert, finden Sie in Eilat eine Zuflucht vor der K\xE4lte. Springen Sie kurzentschlossen ins Flugzeug, um sich nach wenigen Stunden ganz neu belebt zu f\xFChlen.</p>\n\t\t\t\t\t\t\t\t<p><strong>W\xE4hlen Sie Ihr zu Hause f\xFCr den Urlaub. </strong>Hostels und kosteng\xFCnstige Herbergen oder Luxushotels der Weltklasse und Boutique-Hotels stehen zur Auswahl. Ebenso familien- und gruppenfreundliche Ferienanlagen oder abgeschiedene, ruhige und romantische Ferienh\xE4user - Eilat bietet eine gro\xDFe Vielfalt an Unterk\xFCnften f\xFCr jedes Budget und jeden Bedarf.</p>\n\t\t\t\t\t\t\t\t<p><strong>Springen Sie ins Wasser.</strong> Mit \xFCber 7 Kilometern atemberaubender K\xFCste am Roten Meer hat Eilat in Sachen Wassersport viel zu bieten. Von Schnorcheln und Tauchen bis hin zu Windsurfen, Kitesurfen, Segeln und vielem mehr - in dieser Stadt finden Sie immer das passende Angebot.</p>\n                                <div class=\"img-wrapper\">\n\t\t                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/eilat1/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t \t</div>\n\t\t\t\t\t\t\t\t<p>Erleben Sie das <strong>Dolphin's Reef</strong>, einen familienfreundlichen \xD6ko-Strand mit einem wundersch\xF6nen botanischen Garten, Entspannungspools und der Hauptattraktion - einer Chance, Delphine zu beobachten, sie zu ber\xFChren, mit ihnen zu schwimmen und zu tauchen. (<em>Und keine Sorge: \xDCber alle Interaktionen mit den Delphinen entscheiden diese wundervollen Gesch\xF6pfen vollkommen nach eigenem Willen.</em>)</p>\n\t\t\t\t\t\t\t\t<p>Besuchen Sie das <strong>Unterwasser-Observatorium</strong>, eine der beliebtesten Attraktionen von Eilat, in dem Sie und Ihre Familie die einzigartige Unterwasserwelt des Roten Meeres kennenlernen k\xF6nnen. Durch die riesigen Glasfenster k\xF6nnen Sie die Haie, Schildkr\xF6ten, Stachelrochen und farbenfrohen Fische des Roten Meers beobachten. Auf einer Fahrt mit einem Glasbodenschiff werden Sie sich wie ein Teil dieser magischen Unterwasserwelt f\xFChlen.</p>\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t<p>Verpassen Sie nicht das weltber\xFChmte <strong>Naturreservat Coral Beach</strong> mit seinem atemberaubenden Korallenriff. Beim Schnorcheln und Tauchen sehen Sie die farbenfrohen Fische und au\xDFergew\xF6hnlichen Wasserpflanzen in diesem seltenen empfindlichen nat\xFCrlichen Lebensraum aus unmittelbarer N\xE4he.</p>\n\t\t\t\t\t\t\t\t<p><strong>Erleben Sie ein W\xFCstenabenteuer. </strong>Die W\xFCste Negev hat einige der spektakul\xE4rsten Panoramarouten in Israel zu bieten. Beim Wandern, auf dem Mountainbike oder bei einer Jeep-Tour haben Sie Gelegenheit, die Sch\xF6nheit in Ihrer Umgebung zu entdecken und zu bestaunen.</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/eilat1/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t \t</div>\n\t\t\t\t\t\t\t\t<p>Nur 25 Kilometer n\xF6rdlich von Eilat liegt das <strong>Timna Park Valley</strong>. Machen Sie eine Tour mit, erkunden Sie die wundersch\xF6ne Landschaft und die besonderen Spuren der ersten Kupfermine der Welt und genie\xDFen Sie die vielen Attraktionen, die dort auf Familien und Abenteurer warten.</p>\n\t\t\t\t\t\t\t\t<p>Noch mehr Abenteuer gef\xE4llig? Von der Stadt aus erreichen Sie ganz einfach die \xFCbrigen Regionen Israels. Unternehmen Sie einen Tagesausflug an das Tote Meer oder nach Jerusalem.</p>\n\t\t\t\t\t\t\t\t<p><strong>Entspannen Sie sich. </strong>Eilat ist eine entspannte Stadt, in der Sie relaxen und sich wirklich ausruhen k\xF6nnen. Diesem Charakter entsprechend finden Sie dort fantastische SPAs, in denen Sie sich mit zahlreichen Behandlungen von traditionellen Massagen bis hin zur Aquatherapie verw\xF6hnen lassen k\xF6nnen. <em>Vertrauen Sie uns, es lohnt sich!</em></p>\n\t\t\t\t\t\t\t\t<p><strong>Einkaufen, Speisen, Trinken und Feiern. </strong>Shoppen Sie im Basar an der Promenade, auf der luxuri\xF6sen Einkaufsmeile und in den zahlreichen Einkaufszentren der Stadt - alles ZOLLFREI!</p>\n\t\t\t\t\t\t\t\t<p><strong>Feiern Sie durch die Nacht.</strong> Lassen Sie sich von der beeindruckenden audiovisuellen Show des musikalischen Springbrunnens unterhalten: Auf Sie wartet eine Show im Broadway-Stil, die Tanz, Akrobatik, Lichteffekte, ein gro\xDFartiger Soundtrack und viele weitere \xDCberraschungen miteinander kombiniert.</p>\n\t\t\t\t\t\t\t\t<p>Essen Sie in einem der vielen Restaurants oder einer Bar in der Stadt, um danach die Tanzfl\xE4che in einem Club zu erobern.</p>\n\t\t\t\t\t\t\t\t<p>Es gibt nichts Besseres.</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n         \t"};}},{id:"Mystic_And_Worldly_Meeting",bgImage:"/posts/bank/north1/1.jpg",mobBgImage:"/posts/bank/north1/M.jpg",title:"SAFED",ctg:"north",isVid:true,vidId:"i3_ihL51bHo",smlTitle:"",html:function html(){return{__html:"\n                               \n\t\t\t\t\t\t\t \t\n                                <h2>Wo Mystik und Weltliches aufeinandertreffen</h2>\n\t\t\t\t\t\t\t \t<p><strong>Tauchen Sie ein in die Kunst und eine heilige Atmosph\xE4re, um sich f\xFCr Ihr Leben inspirieren zu lassen</strong></p>\n\t\t\t\t\t\t\t\t<p>Das weithin unbegrenzte Panorama und die unber\xFChrte Bergluft von Safed werden Sie sofort bei Ihrer Ankunft in ihren Bann ziehen. Diese atemberaubende alte Bergstadt ist als Hauptstadt der historischen und modernen j\xFCdischen Mystik und als h\xF6chste Stadt Galil\xE4as und ganz Israels bekannt - in geologischer und spiritueller Hinsicht. Safed geh\xF6rt zu den vier heiligen St\xE4dten im Judentum und vibriert mit einer sp\xFCrbaren mystischen Kraft, die Sie in Erstaunen versetzen wird.</p>\n\t\t\t\t\t\t\t\t<p>Nur eine kurze Fahrt vom biblischen See Genezareth entfernt, empf\xE4ngt Sie Safed mit malerischen Kopfsteinpflasterstra\xDFen und inspirierender Architektur. Lauschen Sie auf die Geschichten der zahlreichen Seelen, die ihre Geheimnisse in den Mauern der alten Festung der Kreuzritter, die Zeugin der mamlukischen, osmanischen und britischer Einfl\xFCsse wurde, bewahren. Sie ist ein Mahnmal f\xFCr den Unabh\xE4ngigkeitskrieg w\xE4hrend die au\xDFergew\xF6hnlichen Synagogen und antiken Gr\xE4ber weiterhin die reiche Geschichte des Ortes verk\xF6rpern und so mit ihnen teilen.</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/mystic-and-worldly-meeting/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t \t</div>\n\t\t\t\t\t\t\t\t<p><strong>Die ewige Hauptstadt der Kabbalah</strong></p>\n\t\t\t\t\t\t\t\t<p>Von Rabbi Shimon Bar-Yohai, der im 2. Jahrhundert das unter dem Namen Zohar bekannte Basiswerk \xFCber die Kabbalah verfasste, bis zu Ari HaKadosh, dem Vater der zeitgen\xF6ssischen Kabbalah, war Safed immer die Heimat der wichtigsten Mystiker des Judentums und ihrer Sch\xFCler. Es war Ari HaKadosh, der im 16. Jahrhundert die kabbalistischen Lehren \u201Edemokratisierte\u201C, indem er sie neu auslegte - so dass die Kabbalah auch f\xFCr Laien erreichbar wurde.</p>\n\t\t\t\t\t\t\t\t<p>Wenn Sie sich Ihren Weg von einer Synagoge zur n\xE4chsten suchen, werden Sie sp\xFCren, warum Safed zur ewigen Heimat einer so langen Linie spirituell Suchender wurde, unabh\xE4ngig von allem, was die Geschichte f\xFCr sie vorgesehen haben mochte. Die Abuhav-Synagoge, deren architektonische Elemente den numerischen Mystizismus verk\xF6rpern, die Ari Ashkenazi-Synagoge, die Ari HaKadosh gewidmet ist, und die Yosef Caro-Synagoge werden Sie auf einer Reise durch die Zeit und in die oberen Zirkel der Mystik begleiten.</p>\n\t\t\t\t\t\t\t\t<p><strong>Eine Altstadt voller Inspirationen</strong></p>\n\t\t\t\t\t\t\t\t<p>Bereichern Sie Ihre Reise um weitere unvergessliche Momente, indem Sie durch die verwinkelten Kopfsteinpflastergassen der Altstadt spazieren, die einzigartigen Steingeb\xE4ude betrachten und schlie\xDFlich zur K\xFCnstlerkolonie gelangen. Dieser Teil der Altstadt beherbergt hochwertige Galerien, in denen Sie die exquisiten Werke einheimischer K\xFCnstler und vielf\xE4ltige Judaica finden k\xF6nnen - das ideale Viertel f\xFCr Liebhaber aller K\xFCnste. F\xFCr Kulturbeflissene f\xFChrt au\xDFerdem kein Weg an einem Besuch im Puppenmuseum und im Museum f\xFCr Druckkunst vorbei.</p>\n\t\t\t\t\t\t\t\t<p>Safed kann f\xFCr Ihren K\xF6rper genauso nahrhaft sein wie f\xFCr Ihre Seele - die vielseitige Gastronomie der Altstadt h\xE4lt f\xFCr jeden Geschmack und Geldbeutel das Richtige bereit. Von jemenitischen Pfannkuchen und Speisen von den Stra\xDFenst\xE4nden bis hin zu unerwarteten K\xF6stlichkeiten in den Restaurants finden Sie in dieser liebenswerten Stadt mit reichhaltiger Tradition alles, was Sie gesucht haben - und noch viel mehr.</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n         \t"};}},{id:"Nazareth_The_Historical_Center",bgImage:"/posts/bank/north2/1.jpg",mobBgImage:"/posts/bank/north2/M.jpg",title:"NAZARETH: EIN JUWEL MIT VIELEN FACETTEN",ctg:"north",isVid:false,smlTitle:"",html:function html(){return{__html:"\n                               \n\t\t\t\t\t\t\t \t\n\t\t\t\t\t\t\t \t<p>Nazareth ist weltweit als die Stadt bekannt, in der Jesus aufwuchs, und ist ein beliebtes Reiseziel f\xFCr christliche Pilger. Diese Stadt ist ein wahres Juwel, das darauf wartet, von Ihnen entdeckt zu werden. Die P\xE4pste Johannes Paul II. und Benedikt XVI. haben die Stadt bei ihren Besuchen in der Region aufgesucht, ebenso wie Zehntausende von Touristen, die jedes Jahr nach Nazareth str\xF6men.</p>\n\t\t\t\t\t\t\t\t<p>Unz\xE4hlige heilige St\xE4tten, eine ereignisreiche Geschichte, farbenfrohe M\xE4rkte, eine dynamische kulinarische Szene, erstaunliche Gastfreundschaft und zahlreiche Sehensw\xFCrdigkeiten sind nur eine Auswahl der Gr\xFCnde, warum eine Reise nach Israel nur mit einem Aufenthalt in Nazareth komplett ist.</p>\n\t\t\t\t\t\t\t\t<p>Erleben Sie die spannende, faszinierende, multikulturelle Vielfalt dieser Stadt. Sie werden sich verlieben.</p>\n\t\t\t\t\t\t\t\t<h3>Gehen Sie in den Fu\xDFspuren von Jesus von Nazareth</h3>\n\t\t\t\t\t\t\t\t<p>Erkunden Sie die Wiege des Christentums und nehmen dabei die einzigartige spirituelle Atmosph\xE4re der Stadt in sich auf. Wandeln Sie in den Fu\xDFspuren von Jesus von Nazareth, der hier mit seiner Familie seine Kindheit und Jugend verbrachte.</p>\n\t\t\t\t\t\t\t\t<p>Besuchen Sie die faszinierende <strong>Verk\xFCndigungsbasilika</strong>, die dem christlichem Glauben zufolge genau an dem Ort steht, wo der Engel Gabriel Maria verk\xFCndigte, dass sie mit Jesus schwanger sei. Besuchen Sie die bezaubernde Kirche <strong>St. Gabriel</strong> und waten Sie durch den <strong>Marienbrunnen</strong>, dessen Wasser Heilkr\xE4fte besitzen soll. Und lassen Sie nicht die <strong>Synagogenkirche</strong> aus, die auf den Ruinen der alten Synagoge Jesu gebaut sein soll.</p>\n                                  <div class=\"img-wrapper\">\n\t\t                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/nazareth-the-historical-center/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t \t</div>\n\t\t\t\t\t\t\t\t<p>Erkunden Sie weitere Teile der Stadt und lassen Sie sich von Ihren vielen Sehensw\xFCrdigkeiten bezaubern. Besuchen Sie das <strong>Dorf Nazareth</strong> und das <strong>internationale Zentrum \u201EMaria von Nazareth\u201C</strong>, wo die Geschichte zum Leben erwacht. Wandern Sie zum<strong> Berg Precipice</strong>, wo der \xDCberlieferung zufolge das Volk von Nazareth versuchte, Jesus in den Abgrund zu sto\xDFen. Nehmen Sie die besondere Energie des Ortes und den atemberaubenden Panoramablick in sich auf.</p>\n\t\t\t\t\t\t\t\t<p>Tipp: Weil es so viel zu tun und zu sehen gibt, k\xF6nnte eine F\xFChrung das Richtige f\xFCr den Besuch sein. Nichts ist so gut, wie einen Ort aus der Perspektive der Einheimischen kennenzulernen.</p>\n\t\t\t\t\t\t\t\t<p><strong>Lernen Sie die zahlreichen Sehensw\xFCrdigkeiten und die ber\xFChmte Gastfreundschaft von Nazareth kennen</strong></p>\n\t\t\t\t\t\t\t\t<p>Die gr\xF6\xDFte arabische Stadt Israels hat seit Ihren Urspr\xFCngen als kleines Dorf zu R\xF6merzeiten einen weiten Weg zur\xFCckgelegt: Heute ist sie eine aufregende, moderne und lebendige Mini-Metropole mit aktiver Kulturszene, spannender Kulinarik und ber\xFChmter Gastfreundschaft.</p>\n\t\t\t\t\t\t\t\t<p>Lassen Sie sich ein auf ein Stadtabenteuer. Wandern Sie durch die Kopfsteinpflastergassen der lebhaften M\xE4rkte und nehmen Sie die Ger\xFCche, Aromen und Ger\xE4usche in sich auf. Setzen Sie sich in ein Caf\xE9 und erfreuen Sie sich an dem guten Essen und dem authentischen kulturellen Leben. Dabei stehen immer auch Musik und faszinierende Gespr\xE4che auf dem Men\xFC. Essen Sie in den einheimischen Restaurants, um einige der besten und kreativsten Gerichte zu genie\xDFen, die Sie je probiert haben. Unser Tipp: Auf keinen Fall das Dessert vergessen!</p>\n\t\t\t\t\t\t\t\t<p>Erkunden Sie die Architektur und die Museen der Stadt und besuchen Sie vielleicht sogar eine \u201EHalva\u201C-Fabrik. \xDCbernachten Sie in einem der zahlreichen Hotels, Gasth\xE4usern, Hostels oder nutzen Sie eine der sonstigen M\xF6glichkeiten. Aus der Ferne ert\xF6nen die Kirchenglocken, die jeden Tag um Mittag in perfekter Harmonie l\xE4uten, um dem Augenblick der Verk\xFCndigung zu gedenken. In Nazareth laufen alle F\xE4den zusammen.</p>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n         \t"};}},{id:9,ctg:"telaviv",bgImage:"/posts/bank/crazy-night/1.jpg",mobBgImage:"/posts/bank/crazy-night/M.jpg",isVid:true,vidId:"ogEN7aRT0SM",title:"Auf der Suche nach dem ultimativen Nachtleben?",smltitle:"",html:function html(){return{__html:"\n\n                               <div class=\"ac-cradit\">\n                                <span class=\"ac-cradit-text\">Credits:</span>\n                                    <br/>\n                                    <span class=\"ac-cradit-text-1\">Tel Aviv Jaffa municipality<br/></span<\n                                    <span class=\"ac-cradit-text-2\">UDINI prodactions<br/></span>\n                                </div>\n                                <p></p>\n                                </div>\n                               <h2>\n                                 Buche jetzt deinen Trip nach Tel Aviv!\n\n                               </h2>\n                               <p>\n                                 Amazing nightlife in Tel Aviv <a href=\"https://en.citiesbreak.com/Posts/telaviv/Amazing_Nightlife\" target=\"_blank\">Click here >> </a>\n                               </p>\n                                "};}},{id:10,ctg:"jerusalem",bgImage:"/posts/bank/heart-of-the-world/1.jpg",mobBgImage:"/posts/bank/heart-of-the-world/M.jpg",isVid:true,vidId:"nLKWDp5uA-U",title:"Jerusalem - Das Herz der Welt",smltitle:"",html:function html(){return{__html:"\n                               \n                                "};}},{id:"Privacy_Policy",ctg:"telaviv",bgImage:"/HomeSlider/desktop/1.jpg",mobBgImage:"/HomeSlider/M/3.jpg",isVid:false,title:"PRIVACY POLICY",smltitle:"",html:function html(){return{__html:"\n  \n  \n                  <p><u><span>Last updated</span></u><span>: March 4, 2020</span></p>\n                  \n                  <h3><span>OUR COMMITMENT TO YOU</span><span>&nbsp;</span></h3>\n                  <p>We, at&nbsp;The Israeli government, the Ministry of Tourism (\"<strong>us</strong>\", \"<strong>we</strong>\" or the<strong>&nbsp;\"Ministry</strong>\") respect the privacy of our users (each, a \"<strong>User</strong>\" or \"<strong>you</strong>\") and are committed to protect the privacy of Users who access, download, install, register, use or engage with our website, our mobile application(s), and any other service we provide (the<strong>&nbsp;</strong>\"<strong>Website</strong>\" and \"<strong>App</strong>\" respectively, and collectively the \"<strong>Service(s)</strong>\"). &nbsp;</p>\n                  <p>We've prepared this Privacy Policy to outline our practices with respect to collecting, using and disclosing your information when you use the Services. We encourage you to read this Privacy Policy carefully and use it to make informed decisions. By using the Services, you agree to the terms of this Privacy Policy and your continued use of the Services constitutes your ongoing agreement to the Privacy Policy.</p>\n                  \n                  <h3><span>CONTENTS</span></h3>\n                  <p>\n                    <a href=\"#Grounds\" style=\"color:#000\"><span>1. </span>GROUNDS FOR DATA COLLECTION</a><br/>\n  \n                    <a href=\"#WhatType\" style=\"color:#000\"><span>2. </span>WHAT TYPE OF DATA WE COLLECT?</a><br/>\n  \n                    <a href=\"#HowDoWeUse\" style=\"color:#000\"><span>3. </span>HOW DO WE USE THE DATA WE COLLECT?</a><br/>\n  \n                    <a href=\"#Tracking\" style=\"color:#000\"><span>4. </span>TRACKING TECHNOLOGIES</a><br/>\n  \n                    <a href=\"#WitWhom\" style=\"color:#000\"><span>5. </span>WITH WHOM DO WE SHARE YOUR PERSONAL DATA?</a><br/>\n  \n                    <a href=\"#HowWeProtect\" style=\"color:#000\"><span>6. </span>HOW WE PROTECT YOUR INFORMATION</a><br/>\n  \n                    <a href=\"#Retention\" style=\"color:#000\"><span>7. </span>RETENTION</a><br/>\n  \n                    <a href=\"#UserRigths\" style=\"color:#000\"><span>8. </span>USER RIGHTS</a><br/>\n  \n                    <a href=\"#Transfer\" style=\"color:#000\"><span>9. </span>TRANSFER OF DATA OUTSIDE THE EEA</a><br/>\n  \n                    <a href=\"#OurPolicy\" style=\"color:#000\"><span>10. </span>OUR POLICY TOWARD CHILDREN</a><br/>\n  \n                    <a href=\"#HowToContactUs\" style=\"color:#000\"><span>11. </span>HOW TO CONTACT US?</a><br/>\n  \n                    <a href=\"#Updates\" style=\"color:#000\"><span>12. </span>UPDATES TO THIS POLICY</a><br/>\n                  </p>\n  \n                  \n                  <h3 id=\"Grounds\"><span>GROUNDS FOR DATA COLLECTION</span><span>&nbsp;</span></h3>\n                  <p><span>Processing of your \u201C<strong>Personal Data</strong>\u201D (meaning any information which may potentially allow your identification, either directly or by using reasonable means) is necessary for the performance of our contractual obligations towards you, for providing you with our Services and the operation of our Website, to protect our legitimate interests and for compliance with legal and regulatory obligations to which we are subject.</span></p>\n                  <p><span>When you use our Services, you consent to the collection, storage, use, disclosure and other uses of your Personal Information as described in this Privacy Policy.</span></p>\n                  \n                  <h3 id=\"WhatType\"><span>WHAT TYPE OF DATA WE COLLECT?</span></h3>\n                  <h3><span>Personal Data</span></h3>\n                  <p><span>In the course of using the Services, we may collect certain Personal Data to provide and improve the Services, to contact or identify you, to enable you to access certain parts of the Service</span><span>&nbsp;or as otherwise indicated in this Policy. We collect the following Personal Data about you</span><span>:</span></p>\n                  <ul style=\"list-style-type: disc;margin-left:0in;\">\n                    <li><span>When you send us an email&nbsp;</span><span>or contact us through a contact form on the Website, we will collect your name and email address so we could respond to your inquiry. We may also collect any Personal Data that you choose to include in your inquiry to us.</span></li>\n                    <li><span>Our webserver may also automatically collect your IP address, and unique online identifiers. These details are pseudonymized (cannot directly identify you) and are collected for the purpose of delivering relevant content and operating and improving our Service.</span></li>\n                  </ul>\n                  <h3><span>Non-Personal Data</span></h3>\n                  <p><span>We also collect data about the use of our Service and the characteristics and activities of users, in order to operate it and improve it. We may collect the following non-Personal Data:&nbsp;</span><span>Your operating system, device type, session start/stop time, time zone, network connection type (e.g., Wi-Fi, cellular), your general location (city and country), and general information regarding your browser and device.</span></p>\n                  <p><span>If we combine Personal Data with non-Personal Data, the combined data will be treated as Personal Data.&nbsp;</span></p>\n                  \n                  <h3 id=\"HowDoWeUse\"><span>HOW DO WE USE THE DATA WE COLLECT?</span></h3>\n                  <ul>\n                    <li><strong><span>Provision of the Service</span></strong><em><span>&nbsp;\u2013&nbsp;</span></em><span>we will use the Personal Data you provide us for the provision and improvement of our Service, providing customer support and to respond to your queries.&nbsp;</span></li>\n                    <li><strong><span>Service announcements</span></strong><span>&nbsp;- we will use your Personal Data to communicate with you and to keep you informed of our latest updates to our Service and offer you service offers.</span></li>\n                    <li><strong><span>Analytics, surveys and research</span></strong><span>&nbsp;- from time to time, we may conduct surveys or test features, and analyze the data we have to develop, evaluate and improve these features, all in order to improve our Services and offerings, and think of new and exciting features for our users.</span></li>\n                    <li><strong><span>Protecting our interests</span></strong><em><span>&nbsp;-&nbsp;</span></em><span>we may use your Personal Data when we believe it\u2019s necessary in order to take precautions against liabilities, investigate and defend ourselves against any third party claims or allegations, investigate and protect ourselves from fraud, protect the security or integrity of our services and protect the rights and property of the Ministry, its users and/or partners.&nbsp;</span></li>\n                    <li><strong><span>Enforcing of policies</span></strong><span>&nbsp;- we may use your Personal Data in order to enforce our policies, including but not limited to our <a href=\"https://goisrael.com/Posts/telaviv/Privacy_Policy\" style=\"text-decoration:underline;color:#000\" target=\"_blank\"> Terms </a></span><span style=\"line-height:115%;font-family:Calibri;font-size:8.0pt;color:windowtext;\">\n                       \n                      </span><span style=\"line-height:;font-family:Calibri;line-height:;color:windowtext;\">.&nbsp;</span></li>\n                    <li><strong><span>Compliance with legal and regulatory requirements</span></strong><span>&nbsp;- we may use your Personal Data to investigate violations, and as required by law, regulation or other governmental authority, or to comply with a subpoena or similar legal process.</span></li>\n                    <li><strong><span>Newsletter</span></strong><span>&nbsp;- we may use your Personal Data in order to send you our newsletter, if you subscribed to it. &nbsp;</span>\n                      <ol style=\"list-style-type: circle;\">\n                        <li><u><span>Opt-out of receiving our newsletter</span></u><span>&nbsp;- You may choose not to receive our newsletter by clicking on the \u201Cunsubscribe\u201D link contained therein. Please note that even if you unsubscribe, we may continue to send you Service-related updates and notifications, or reply to your queries and feedback you provide us.&nbsp;</span></li>\n                      </ol>\n                    </li>\n                  </ul>\n                  \n                  <h3 id=\"Tracking\"><span>TRACKING TECHNOLOGIES</span></h3>\n                  <p><span>When you visit or access our Services we use (and authorize 3<sup>rd</sup> parties to use) pixels, cookies, events and other technologies (collectively, \"<strong>Tracking Technologies</strong>\"). Those allow us to automatically collect information about you, your device and your online behavior, in order to enhance your navigation in our Services, improve our Services\u2019 performance, perform analytics and customize your experience. In addition, we may merge data we have with data collected through these tracking technologies and data we may obtain from other sources and, as a result, such data may become Personal Data.</span></p>\n                  <p>If you do not accept the use of cookies by us, please disable cookies by following the instructions below. However, please note that disabling cookies might seriously affect the function, User experience and other features of our Services.</p>\n                  <h3>Types of Tracking Technologies We Use</h3>\n                  <p>There are two broad categories of cookies: (a) <strong>First party cookies</strong>, served directly by us to your computer or mobile device, and (b) <strong>Third party cookies</strong>, served by a third party. We use third party cookies for functionality, performance and analytics, and social media purposes.</p>\n                  <p>Cookies can remain on your computer or mobile device for different periods of time. Some cookies are \"session cookies\" and expires upon closing of your browser. Other cookies are \"persistent cookies\", meaning that they survive after your browser is closed. They can be used by websites to recognize your computer when you open your browser and browse the Internet again.</p>\n                  <p>For example, we use a performance tracking technology tool called \u201C<strong>Google Analytics</strong>\u201D to collect information about the use of the Website. Google Analytics collects information such as how often users visit this site, what pages they visit when they do so, and what other sites they used prior to coming to this Site. We use the information we get from Google Analytics to maintain and improve the Site and our products. We do not combine the information collected through the use of Google Analytics with personally identifiable information. Google\u2019s ability to use and share information collected by Google Analytics about your visits to this Site is restricted by the Google Analytics Terms of Service, available at \n                    <a href=\"//www.google.com/analytics/terms/us.html\" target=\"_blank\" style=\"text-decoration:underline;color:#000\">www.google.com/analytics/</a>, and the Google Privacy Policy, available at \n                    <a href=\"//www.google.com/policies/privacy/\" target=\"_blank\" style=\"text-decoration:underline;color:#000\">www.google.com/policies/</a>. You can opt-out of Google's collection of Personal Data through Google Analytics by downloading and installing the Google Analytics Opt-out Browser Add-on, available at \n                    <a href=\"https://tools.google.com/dlpage/gaoptout\" target=\"_blank\" style=\"text-decoration:underline;color:#000\">tools.google.com/dlpage/gaoptout</a>.\n                  </p>\n                  <h3><span>Interest-Based Advertising &amp; User Choice</span></h3>\n                  <p>Through our Services, we may display advertisements that are tailored to you, for example ads or partner services that are based on your recent browsing behavior. In order to tailor advertisements and services in which you might be interested, we as well as certain third parties may use Tracking Technologies to display advertisements based on your visits to the Websites, to target advertisements to you for products and services in which you might be interested, and to measure the effectiveness of the ads. You can turn off certain third party Tracking Technologies used for behavioral advertising purposes by visiting the Network Advertising Initiative&nbsp;or by visiting the&nbsp;DAA opt-out program&nbsp;or the&nbsp;EDAA consumer choice page&nbsp;(if you reside in the EU) using the links provided below. Please note that certain Tracking Technologies operate at the device and browser level, so to fully opt-out across devices, you will need to do so on each device and browser individually, as described below as well.</p>\n                  <h3><span>How to Manage Your Tracking Technologies Settings</span></h3>\n                  <p>There are various ways in which you can manage and control your Tracking Technologies settings. Please remember that, by deleting or blocking Tracking Technologies, some of the features of the Services may not work properly or as effectively.</p>\n                  <p style=\"margin-bottom:6.0pt;\"><strong>Turning off cookies via your web browser\n                      <br>&nbsp;\n                    </strong>Most web browsers will provide you with some general information about cookies, enable you to see what cookies are stored on your device, allow you to delete them all or on an individual basis, and enable you to block or allow cookies for all websites or individually selected websites. You can also normally turn off third party cookies separately. Please note that the settings offered by a browser or device often only apply to that particular browser or device. Information about cookies is usually found in the \"Help\" section of the web browser. Below are some links to some commonly used web browsers:</p>\n                  <p>\n                    <a href=\"https://support.google.com/chrome/answer/95647?hl=en\" target=\"_blank\" style=\"text-decoration:underline;color:#000\"><span>Google Chrome</span></a><br/>\n  \n                    <a href=\"https://support.microsoft.com/en-us/kb/260971\" target=\"_blank\" style=\"text-decoration:underline;color:#000\"><span>Internet Explorer</span></a><br/>\n  \n                    <a href=\"https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer\" target=\"_blank\" style=\"text-decoration:underline;color:#000\"><span>Mozilla Firefox</span></a><br/>\n  \n                    <a href=\"https://support.apple.com/kb/PH5042?locale=en_US\" target=\"_blank\" style=\"text-decoration:underline;color:#000\"><span>Safari (Desktop)</span></a><br/>\n  \n                    <a href=\"https://support.apple.com/en-us/HT201265\" target=\"_blank\" style=\"text-decoration:underline;color:#000\"><span>Safari (Mobile)</span></a><br/>\n  \n                    <a href=\"//support.google.com/ics/nexus/bin/answer.py?hl=en&amp;answer=2425067\" target=\"_blank\" style=\"text-decoration:underline;color:#000\"><span>Android Browser</span></a><br/>\n  \n                    <a href=\"//www.opera.com/help\" target=\"_blank\" style=\"text-decoration:underline;color:#000\"><span>Opera</span></a><br/>\n  \n                    <a href=\"//www.opera.com/help/mobile/android#privacy\" target=\"_blank\" style=\"text-decoration:underline;color:#000\"><span>Opera Mobile</span></a>\n                  </p>\n                  <p>For other browsers, please consult the documentation that your browser manufacturer provides.</p>\n                  <p style=\"margin-bottom:6.0pt;\"><strong>Turning off third party cookies\n                      <br>&nbsp;\n                    </strong>You can turn off certain third party targeting/advertising cookies by visiting the following link:&nbsp;\n                    <a href=\"//www.networkadvertising.org/choices/\" target=\"_blank\" style=\"text-decoration:underline;color:#000\">Network Advertising Initiative</a>.\n                  </p>\n                  <h3><span>Other helpful resources</span><br/></h3>\n                  <p>\n                  <span>To learn more about advertisers\u2019 use of cookies the following links may be helpful:</span><br/>\n                    <a href=\"//www.youronlinechoices.eu/\" target=\"_blank\" style=\"text-decoration:underline;color:#000\"><span>European Interactive Digital Advertising Alliance (EU)</span></a><br/>\n  \n                    <a href=\"//www.iab.net/\" target=\"_blank\" style=\"text-decoration:underline;color:#000\"><span>Internet Advertising Bureau (US)</span></a><br/>\n  \n                    <a href=\"//www.iabeurope.eu/\" target=\"_blank\" style=\"text-decoration:underline;color:#000\"><span>Internet Advertising Bureau (EU)</span></a>\n                  </p>\n                  <p style=\"margin-top:6.0pt;margin-right:0in;margin-bottom:.0001pt;margin-left:0in;text-align:justify;\"><strong>Turning off cookies on a mobile device</strong></h3>\n                  <p>You can-opt out of certain types of interest-based advertising, by accessing the \u201Csettings\u201D on your device:</p>\n                  <ul style=\"list-style-type: disc;margin-left:undefined;\">\n                    <li><strong><span>If you're using an Apple device</span></strong><span>&nbsp;you can configure your device to limit ad tracking to by clicking on \"settings\" &gt; \"privacy\" &gt; \"advertising\" and toggling \"limit ad tracking\" to \u2018on.\u2019</span></strong></li>\n                    <li><strong><span>If you're using an Android device</span></strong><span>&nbsp;you can opt out of most app-based tracking for advertising by opening the \"Google Settings\" app on your device, selecting \"Ads\", and then selecting the option to opt-out of interest-based ads.</span></strong></li>\n                  </ul>\n                  <p>Please note that the above information may change when manufacturers update their systems. Also note, that your device may use another platform, not described above. In that case, please consult the manufacturer documentation for further instructions.</p>\n                  \n                  <h3 id=\"WitWhom\"><span>WITH WHOM DO WE SHARE YOUR PERSONAL DATA?</span></h3>\n                  <ul>\n                    <li><strong><span>Internal concerned parties</span></strong><span>&nbsp;- we may share your information with other</span><span style=\"color:windowtext;\">&nbsp;</span><span>government ministries, as well as our employees, as needed to provide our Services.</span></li>\n                    <li><strong><span>Business partners</span></strong><span>&nbsp;- we may share your information with business partners such as storage and analytics providers who help us provide you with our Services. These third parties may have access to your Personal Data so that they may perform these tasks on our behalf, but they are obligated to comply with the highest security standards and applicable data protection legislation, and may not use your Personal Data for any other purpose.</span></li>\n                    <li><strong><span>Compliance with laws and law enforcement entities</span></strong><span>&nbsp;- we cooperate with other governmental agencies and law enforcement officials to enforce and comply with the law. We will disclose Personal Data about you to government or law enforcement officials or private parties if we, in our sole discretion, believe necessary or appropriate to respond to claims and legal process (including but not limited to subpoenas), to protect our or a third party's property and rights, to protect the safety of the public or any person, or to prevent or stop any activity we may consider to be, or to pose a risk of being, illegal, unethical, inappropriate or legally actionable.&nbsp;</span></li>\n                  </ul>\n                  \n                  <h3 id=\"HowWeProtect\"><span>HOW WE PROTECT YOUR INFORMATION</span></h3>\n                  <p><span>We have implemented administrative, technical, and physical safeguards to help prevent unauthorized access, use, or disclosure of your Personal Data. Your data is stored on secure servers and isn\u2019t publicly available. We limit access of your information only to those employees or partners on a \u201Cneed to know\u201D basis, in order to enable the carrying out of the agreement between us.&nbsp;</span></p>\n                  <p><span>While we seek to protect your information to ensure that it is kept confidential, we cannot absolutely guarantee its security. You should be aware that there is always some risk involved in transmitting information over the internet. While we strive to protect your Personal Data, we cannot ensure or warrant the security and privacy of your Personal Data or other content you transmit using the Service, and you do so at your own risk.&nbsp;</span></p>\n                  \n                  <h3 id=\"Retention\"><span>RETENTION</span></h3>\n                  <p><span>We will retain your Personal Data for as long as necessary to provide our Services, and as necessary to comply with our legal obligations, resolve disputes, and enforce our policies. Retention periods will be determined taking into account the type of information that is collected and the purpose for which it is collected, bearing in mind the requirements applicable to the situation and the need to destroy outdated, unused information at the earliest reasonable time. Under applicable regulations, we will keep records containing Personal Data, communications and anything else as required by applicable laws and regulations.&nbsp;</span></p>\n                  \n                  <h3  id=\"UserRigths\"><span>USER RIGHTS</span></h3>\n                  <h4><strong><span style=\"font-family:&quot;Calibri&quot;,sans-serif;color:windowtext;font-style:normal;\">EU User Rights</span></strong></h4>\n                  <p><span>As an EU resident, you may request to:&nbsp;</span></p>\n                  <ol start=\"1\" style=\"list-style-type: lower-alpha;margin-left: 0px;\">\n                    <li><span>Receive confirmation as to whether or not Personal Data concerning you is being processed, and access your stored Personal Data, together with supplementary information.&nbsp;</span></li>\n                    <li><span>Receive a copy of Personal Data you directly volunteer to us in a structured, commonly used and machine-readable format.&nbsp;</span></li>\n                    <li><span>Request rectification of your Personal Data that is in our control.</span></li>\n                    <li><span>Request erasure of your Personal Data.&nbsp;</span></li>\n                    <li><span>Object to the processing of Personal Data by us.&nbsp;</span></li>\n                    <li><span>Request to restrict processing of your Personal Data by us.</span></li>\n                    <li><span>Lodge a complaint with a supervisory authority.</span></li>\n                  </ol>\n                  <p><span>Please note that these rights pertain to EU residents only, are not absolute, and may be subject to our own legitimate interests and regulatory requirements.&nbsp;</span></p>\n                  <p><span>Users Outside the EU -&nbsp;</span></strong><span>Some of the aforementioned rights are applicable in certain jurisdictions outside the EU as well. Users residing outside the EU are welcome to contact us for any questions or requests by using the details provided below.</span></p>\n                  \n                  <h3 id=\"Transfer\"><span>TRANSFER OF DATA OUTSIDE THE EEA</span><span>&nbsp;</span></h3>\n                  <p><span>If you reside in the European Union (\"<strong>EU</strong>\"), please note that some data recipients may be located outside the EEA. In such cases we will transfer your data only to such countries as approved by the European Commission as providing adequate level of data protection, or enter into legal agreements ensuring an adequate level of data protection.</span></p>\n                  \n                  <h3 id=\"OurPolicy\"><span>OUR POLICY TOWARD CHILDREN</span></h3>\n                  <p>We do not knowingly collect or solicit personal information from anyone under 18 years of age, (or the age of consent as determined under the applicable laws where the individual resides; \u201C<strong>Age of Consent</strong>\u201D). By accessing, using or interacting with our Services, you certify to us that you are not under the Age of Consent. In the event that we learn that we have collected personal information from an individual under the Age of Consent without verification of parental consent, we will delete that information upon discovery. If you believe that we might have any information from or about an individual under the Age of Consent, then please contact us through the contact details available below.</p>\n                  \n                  <h3 id=\"HowToContactUs\"><span>HOW TO CONTACT US?</span></h3>\n                  <p><span>If you wish to exercise any of the aforementioned rights, or receive more information, please contact us using the details below:</span><br/>Email:<a href=\"mailto:Dpo@tourism.gov.il\" style=\"text-decoration:underline;color:#000\"> Dpo@tourism.gov.il</a>\n                  </p>\n                  \n                  <h3 id=\"Updates\"><span>UPDATES TO THIS POLICY</span></h3>\n                  <p>This Privacy Policy is subject to changes from time to time, in our sole discretion. The most current version will always be posted on our Services (as reflected in the \"Last Updated\" heading). You are advised to check for updates regularly. By continuing to access or use our Services after any revisions become effective, you agree to be bound by the updated Privacy Policy.&nbsp;</p>\n  \n                                 \n                              "};}},{id:"Destination_For_All",ctg:"TouristInfo",bgImage:"/posts/bank/plan-your-trip/1.jpg",mobBgImage:"/posts/bank/plan-your-trip/M.jpg",isVid:true,vidId:"QWA7qwsbbGY",title:"EIN REISEZIEL FÜR JEDEN GESCHMACK",smltitle:"",html:function html(){return{__html:"\n\t\t\n\t\t\n\t\t\t\t\t<p>Israels Besucherzahlen verzeichnen ein beispielloses Wachstum. Immer mehr Menschen aus aller Welt erf\xFCllen sich ihren Traum von einer Reise nach Israel. Das Ministerium f\xFCr Tourismus setzt sich daf\xFCr ein, dass jeder, der einen Besuch machen m\xF6chte, dies auch tun kann \u2013 ungeachtet m\xF6glicher Beeintr\xE4chtigungen.</p>\n\t\t\t\t\t<p>Im Hinblick auf Barrierefreiheit ist Israels Gesetzgebung weltweit f\xFChrend. Von der Infrastruktur bis zum Service bietet Israel beste Voraussetzungen, um einen problemlosen und angenehmen Aufenthalt zu erm\xF6glichen.</p>\n\t\t\t\t\t<p class=\"ac-margin-bottom-5\">Nachfolgend finden Sie Links zu allen Einrichtungen, die einen reibungslosen und barrierefreien Aufenthalt erm\xF6glichen und gew\xE4hrleisten.</p>\n\t\t\t\t   <div class=\"img-wrapper\">\n\t\t\t\t\t   <img src="+"https://goisrael.com/assets/img//posts/destination-for-all/1.jpg"+" class=\"img-responsive\">\n\t\t\t\t\t</div><br>\n\t\t\t\t\t<h2 class=\"ac-margin-bottom-20\">Nichtregierungsorganisationen (NGOs) im Tourismus</h2>\n\t\t\t\t\t<p><b>Keren Kayemeth LeIsrael</b></p>\n\t\t\t\t\t<p><u>Barrierefreie W\xE4lder, Parks und Sehensw\xFCrdigkeiten in Israel</u><br/>\n\t\t\t\t\tIn den letzten Jahren hat sich das KKL-JNF in seinen W\xE4ldern und Parks um die Schaffung geeigneter Einrichtungen f\xFCr Menschen mit k\xF6rperlichen Beeintr\xE4chtigungen bem\xFCht. Ziel ist es, die Natur allen Bev\xF6lkerungsgruppen zug\xE4nglich zu machen \u2013 indem eine Umgebung geschaffen wird, in der sich Menschen mit eingeschr\xE4nkter Mobilit\xE4t sicher und bequem bewegen k\xF6nnen. Dar\xFCber hinaus ist man einen Schritt weiter gegangen und hat mit einzigartigen Projekten in Sonderschulen die Natur auf den Schulhof gebracht. \n\t\t\t\t\t<br/>\n\t\t\t\t\t<a href=\"//www.kkl-jnf.org/tourism-and-recreation/accessible-forests-parks-sites-israel/\" target=\"_blank\">www.kkl-jnf.org</a>\n\t\t\t\t   </p>\n\t\t\n\t\t\t\t \t<p><b>Israelische Natur- und Parkbeh\xF6rde</b></p>\n\n\t\t\t\t   <p>\n\t\t\t\t   Die INPA hat in den letzten Jahren viel daf\xFCr geleistet, ihre Einrichtungen f\xFCr Menschen mit Behinderungen zug\xE4nglich zu machen. In allen Nationalparks und Naturreservaten, an historischen Sehensw\xFCrdigkeiten und Kulturdenkm\xE4lern wird an der Verbesserung der Zugangsm\xF6glichkeiten und der Bereitstellung von Zugangshilfen gearbeitet.\n\t\t\t\t   </p>\n\n\t\t\t\t   <p>\n\t\t\t\t  \t Die INPA setzt alles daran, die Zahl der Besucher mit Behinderungen zu erh\xF6hen, die die St\xE4tten mit all ihren Aktivit\xE4ten besichtigen und genie\xDFen k\xF6nnen.\n\t\t\t\t\tAuf der Website finden Sie weitere Informationen und entsprechende Karten. \n\t\t\t\t\t<br/>\n\t\t\t\t\t<a href=\"https://www.parks.org.il\">\n\t\t\t\t\t\twww.parks.org.il \n\t\t\t\t\t</a>\n\t\t\t\t   </p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t<img src="+"https://goisrael.com/assets/img//posts/destination-for-all/2.jpg"+" class=\"img-responsive\">\n\t\t\t\t </div><br>\n\t\t\t\t\t <p><b>Yad Sarah f\xFCr Touristen (Yad Sarah for Tourists)</b></p>\n\t\t\t\t\t <p>\n\t\t\t\t\t \tReisen ins Ausland stellen f\xFCr Menschen mit besonderen Bed\xFCrfnissen eine besondere Herausforderung dar. Yad Sarah for Tourists bietet Hilfe, die einen angenehmen und erholsamen Urlaub f\xFCr Betroffene und ihre Familie erm\xF6glicht. Sobald die Pl\xE4ne mit dem Tourismusb\xFCro ausgearbeitet sind, kann sich der Besucher entspannt zur\xFCcklehnen \u2013 in dem Wissen, dass alle Vorbereitungen in den kompetenten H\xE4nden eines Yad Sarah-Vertreters liegen.\n\t\t\t\t\t </p>\n\t\t\t\t   \n\t\t\t\t\t\t<p> <u>Einige der verf\xFCgbaren Services:</u>:<br/>\n\t\t\t\t\t\t \n\t\t\t\t\t\t\u2022  Ausleihe ben\xF6tigter medizinischer Ausr\xFCstung. Die Lieferung in ein Hotel oder eine Unterkunft kann gegen eine geringe Geb\xFChr organisiert werden.<br/>\n\t\t\t\t\t\t\u2022  Besondere Ausstattung des Hotelzimmers, um den Aufenthalt komfortabler zu gestalten, einschlie\xDFlich spezieller Betten, St\xFChle etc.<br/>\n\t\t\t\t\t\t\u2022  Ausleihe von Sauerstoffflaschen/Konzentratoren.<br/>\n\t\t\t\t\t\t\u2022  Transport in rollstuhlgerechten Kleinbussen, einschlie\xDFlich des Transfers zum und vom Flughafen und zum Besuch von Sehensw\xFCrdigkeiten.<br/>\n\t\t\t\t\t\t\u2022  Empfehlung von Reisef\xFChrern, die auf die F\xFChrung von Touristen mit eingeschr\xE4nkter Mobilit\xE4t und besonderen Bed\xFCrfnissen spezialisiert sind, einschlie\xDFlich Beratung \xFCber leicht zug\xE4ngliche touristische Ziele.<br/>\n\t\t\t\t\t\t<br/>\n\t\t\t\t\t\tDer pers\xF6nliche Service von Yad Sarah ist nach vorheriger Absprache mit dem Touristenb\xFCro f\xFCr jeden Reisenden mit besonderen Bed\xFCrfnissen in ganz Israel verf\xFCgbar.<br/>\n\t\t\t\t\t\n\t\t\t\t\tF\xFCr weitere Informationen oder um einen Transport oder eine Tour zu arrangieren, rufen Sie bitte das Touristenb\xFCro unter +972-2-6444382 an oder senden Sie eine E-Mail an\n\t\t\t\t\t<a href=\"mailto:chaimvi@yadsarah.org.il\">chaimvi@yadsarah.org.il </a>\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t<img src="+"https://goisrael.com/assets/img//posts/destination-for-all/3.jpg"+" class=\"img-responsive\">\n\t\t\t\t </div><br>\n\t\t\t\t\t<p><b>Access Israel</b></p>\n\t\t\t\t\t<p>Access Israel ist eine gemeinn\xFCtzige Organisation, die den Zugang und die Integration von Menschen mit Behinderungen und \xE4lteren Menschen in allen Lebensbereichen f\xF6rdert. Access Israel wurde 1999 von Yuval Wagner, einem ehemaligen Hubschrauberpiloten gegr\xFCndet, der infolge eines Helikopterunfalls an den Rollstuhl gefesselt war. Access Israel realisiert verschiedene Projekte mit dem Ziel einer vollst\xE4ndig zug\xE4nglichen und integrativen Gesellschaft, darunter Aufkl\xE4rungsprojekte in Schulen, Beratung in Sachen Barrierefreiheit f\xFCr Firmen, Kurse zum Thema Barrierefreiheit, Geb\xE4rdensprachkurse, Konferenzen zu verschiedenen Themen und vieles mehr. Dar\xFCber hinaus setzt sich Access Israel f\xFCr die F\xF6rderung der Barrierefreiheit im israelischen Recht ein, betreibt ein Beschwerdezentrum f\xFCr Barrierefreiheit und organisiert Veranstaltungen zur Aufkl\xE4rung der \xD6ffentlichkeit. Access Israel f\xF6rdert die Barrierefreiheit und die Integration in allen Lebensbereichen, in der Bildung, im Tourismus, in der Kultur, \n\t\t\t\t\t\tin Notsituationen und mehr. Besuchen Sie die <br/>\n\t\t\t\t\t\t<a href=\"https://www.aisrael.org/?CategoryID=3030\" target=\"_blank\">Accessible Tourism on Access Israel website</a></p>\n\t\t\n\t\t\t\t\t\t<p><u>LOTEM</u> ist Israels gr\xF6\xDFte Organisation f\xFCr Outdoor-Lernaktivit\xE4ten f\xFCr Kinder mit besonderen Bed\xFCrfnissen, die sowohl p\xE4dagogische Aktivit\xE4ten im Freien als auch barrierefreie Wanderungen anbietet. Surin Hershko, ein Kriegsheld, der 1976 bei der Operation Entebbe schwer verletzt wurde, ist Gr\xFCnder und Vorsitzender von LOTEM. Seine Inspiration kommt aus dem Herzen: \"Kindern das Grundrecht zu geben, das Leben im Freien zu genie\xDFen, ist der Sinn meines Lebens und erf\xFCllt mich mit gro\xDFer Freude.\" Der Hauptsitz, Emek HaShalom (Tal des Friedens), ist eine 40 Hektar gro\xDFe Farm im Norden Israels nahe Yokneam. Die Farm liegt in der Mitte eines wundersch\xF6nen Tals, umgeben von bl\xFChender Natur und einem friedlich dahinflie\xDFenden Fluss. Sie bietet praktische Lern- und Lebenserfahrung mit einem Lehrgarten, rollstuhlgerechten Oliven- und Weinpressen, einer B\xE4ckerei und rollstuhlgerechten Wegen.</p>\n\t\t\t\t\t\t<p><u>LOTEM</u> versteht die bedeutende Rolle, die die Natur im Leben der Menschen in Israel spielt und die immense Wirkung, die der Zugang zur Gesellschaft hat \u2013 nicht nur f\xFCr Einzelne mit besonderen Bed\xFCrfnissen, sondern auch f\xFCr deren Familie und die Gemeinschaft. Als Teil seiner Arbeit mit der sichergestellt werden soll, dass kein Mitglied der Gesellschaft zur\xFCckbleibt, bietet LOTEM Kindern und Erwachsenen mit besonderen Anforderungen die M\xF6glichkeit, im ganzen Land an Aktivit\xE4ten in freier Natur teilzunehmen und zu lernen. www.lotem.net  \n\t\t\t\t\t\t<a href=\"https://www.lotem.net/?page_id=386\" target=\"_blank\">www.lotem.net</a></p>\n\t\t\n\t\t\t\t\t\t<h2 class=\"ac-margin-bottom-20 ac-margin-top-20\"> Verkehrsmittel</h2>\n\t\t\t\t\t\t<p><b>Israelische Flughafenbeh\xF6rde</b></p>\n\t\t\t\t\t\t<p>Die israelische Flughafenbeh\xF6rde ist in den ihr unterstehenden Einrichtungen gesetzlich zur Bereitstellung einer Infrastruktur verpflichtet, die der Barrierefreiheit von Passagieren mit besonderen Bed\xFCrfnissen dient. Nach den Transportvorschriften liegt die Verantwortung f\xFCr die Abfertigung der betreuten Flugg\xE4ste und ihres Gep\xE4cks ab dem Zeitpunkt ihres Eintretens in das Terminal oder ihres Aussteigens aus dem Flugzeug bei der jeweiligen Fluggesellschaft, mit der die Flugg\xE4ste reisen. Die eigentliche Dienstleistung am Flughafen Ben Gurion wird von speziellen Abfertigungsunternehmen erbracht. Der Service umfasst die Begleitung und Unterst\xFCtzung behinderter Passagiere im Rahmen von Abflug und Ankunft. <br/>\n\t\t\t\t\t\t<a href=\"https://www.iaa.gov.il/en-us/airports/bengurion/pages/accessibility.aspx\" target=\"_blank\">www.iaa.gov.il</a></p>\n\t\t\t\t\t\t<p><b>Diese Abfertigungsgesellschaften k\xFCmmern sich vor Ort:</b></p>\n\t\t\t\t\t\t<p>Aero Handling: <a href=\"//www.aerohandling.com/\" target=\"_blank\">www.aerohandling.com</a><br/>\n\t\t\t\t\t\tLaufer Aviation: GHI: <a href=\"//lauferghi.com/\" target=\"_blank\">www.lauferghi.com</a><br/>\n\t\t\t\t\t\tQAS: <a href=\"//www.qasisrael.co.il\" target=\"_blank\">www.qasisrael.co.il</a><br/>\n\t\t\n\t\t\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+"https://goisrael.com/assets/img/posts/destination-for-all/4.jpg"+" class=\"img-responsive\">\n\t\t\t\t\t </div><br>\n\t\t\n\t\t\t\t\t\t<p>Hotline des Verkehrsministeriums (Ortsgespr\xE4ch) <a href=\"tel:5678*\">5678*</a></p>\n\t\t\t\t\t\t\n\t\t\t\t\t\t<p><b>\xD6ffentliche Verkehrsmittel</b></p>\n\t\t\t\t\t\t<p><u>Z\xFCge:</u> Sollten Sie beim Einsteigen in den Zug oder beim Verlassen des Zuges Hilfe durch einen Mitarbeiter am Bahnhof ben\xF6tigen, stimmen Sie Ihre Reise bitte im Voraus mit 'Israel Railways' ab, entweder \xFCber die Website oder \xFCber die Service-Hotline unter <a href=\"tel:*5770\">*5770</a>.</p>\n\t\t\t\t\t\t \n\t\t\t\t\t\t<p><u>Israel Railways\u2018</u> tut sein M\xF6glichstes, um Ihnen einen optimalen Service zu bieten, selbst wenn Sie Ihre Reise nicht im Voraus abgestimmt haben.</p>\n\t\t\t\t\t\t<p>Bitte stimmen Sie Fahrten zwischen 20:00 Uhr und 06:00 Uhr morgens sowie Fahrten am Samstagabend in jedem Fall im Voraus ab.</p>\n\t\t\t\t\t\t<p><u>Busse</u>: Alle Stadtbuslinien sind so eingerichtet, dass sie f\xFCr alle zug\xE4nglich sind. \xDCberlandbusse sind teilweise zug\xE4nglich.</p>\n\t\t\t\t\t\t<p><u>Taxis</u>: Es ist eher unwahrscheinlich unterwegs ein barrierefreies Taxi zu bekommen. Es wird empfohlen, ein Taxi aus  <a href=\"https://www.aisrael.org/?CategoryID=2657&ArticleID=64179\" target=\"_blank\">aus dieser Liste </a>vorzubestellen.</p>\n\t\t\n\t\t\n\t\t\t\t\t\t<h2  class=\"ac-margin-bottom-20 ac-margin-top-20\">Unterk\xFCnfte</h2>\n\t\t\t\t\t\t<p>Alle Arten von Unterk\xFCnften in Israel, die 7 oder mehr Zimmer haben, sind gesetzlich verpflichtet, mindestens 1 barrierefreies Zimmer anzubieten. Alle Anbieter mit mindestens 25 Mitarbeitern m\xFCssen au\xDFerdem einen Beauftragten f\xFCr Barrierefreiheit haben. Diese Gesetze stellen sicher, dass es in Israel keine Gegend gibt, in der nicht die perfekte Unterkunftsl\xF6sung gefunden werden kann. Eine E-Mail-Koordination der Anforderungen vor dem Besuch ist zu empfehlen.</p>\n\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+"https://goisrael.com/assets/img/posts/destination-for-all/5.jpg"+" class=\"img-responsive\">\n\t\t\t\t\t </div><br>\n\t\t\t\t\t\t\n\t\t\t\t\t\t\n\t\t\t\t\t\t<div id=\"ac-left-nav\">\n\t\t\t\t\t\t<h2 class=\"ac-margin-bottom-20 pr-fs-28 chapter-title inline-block\">\n\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: Guide.ShowChaptersIndex -->\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"ng-binding\">Accessibility for those with special needs at the beaches:</span>\n\t\t\t\t\t\t\t\t\t\t</h2>\n\t\t\t\t\t\t<ul id=\"chaptersList\" class=\"list-unstyled xs-mb-0\">\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t<!-- ngRepeat: chapter in Guide.Chapters -->\n\t\t\t\t\t\t\t\t<li data-show=\"1\" class=\"ac-active ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope light-gray-e7-background blue-border-right-5px\" ng-repeat=\"chapter in Guide.Chapters\" ng-class=\"getDecorationForLi($index)\" ng-click=\"openChapterMenu(false,$index);updateChapterIndex($index);\" role=\"button\" tabindex=\"0\">\n\t\t\t\t\t\t\t\t\t<!-- ngIf: Guide.ShowChaptersIndex -->\n\t\t\t\t\t\t\t\t\t<span ng-class=\"CurrChapterindex == ($index) ? 'reforma-bold ': ''\" class=\"blue-txt description-txt nounderline  ng-binding reforma-bold\">Northern District</span>\t\t\t\t\t\t                  \n\t\t\t\t\t\t\t\t\t<img src=\""+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/a-down.png")+"\" class=\"img-responsive a-arrow-img\" alt=\"\">\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t</li><!-- end ngRepeat: chapter in Guide.Chapters -->\n\t\t\t\t\t\t\t\t<li data-show=\"2\" class=\"ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope\" ng-repeat=\"chapter in Guide.Chapters\" ng-class=\"getDecorationForLi($index)\" ng-click=\"openChapterMenu(false,$index);updateChapterIndex($index);\" role=\"button\" tabindex=\"0\" >\n\t\t\t\t\t\t\t\t\t<span ng-class=\"CurrChapterindex == ($index) ? 'reforma-bold ': ''\" class=\"blue-txt description-txt reforma nounderline  ng-binding\">Haifa District</span>\n\t\t\t\t\t\t\t\t\t<img src=\""+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/a-down.png")+"\" class=\"img-responsive a-arrow-img\" alt=\"\">\n\t\t\t\t\t\t\t\t</li><!-- end ngRepeat: chapter in Guide.Chapters -->\n\t\t\t\t\t\t\t\t<li data-show=\"3\" class=\"ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope\" ng-repeat=\"chapter in Guide.Chapters\" ng-class=\"getDecorationForLi($index)\" ng-click=\"openChapterMenu(false,$index);updateChapterIndex($index);\" role=\"button\" tabindex=\"0\" >\n\t\t\t\t\t\t\t\t\t<span ng-class=\"CurrChapterindex == ($index) ? 'reforma-bold ': ''\" class=\"blue-txt description-txt reforma nounderline  ng-binding\">Central District</span>\n\t\t\t\t\t\t\t\t\t<img src=\""+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/a-down.png")+"\" class=\"img-responsive a-arrow-img\" alt=\"\">\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t</li><!-- end ngRepeat: chapter in Guide.Chapters -->\n\t\t\t\t\t\t\t\t<div class=\"clear show-on-mobile\"></div>\n\t\t\t\t\t\t\t\t<li data-show=\"4\" class=\"ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope\" ng-repeat=\"chapter in Guide.Chapters\" ng-class=\"getDecorationForLi($index)\" ng-click=\"openChapterMenu(false,$index);updateChapterIndex($index);\" role=\"button\" tabindex=\"0\" >\n\t\t\t\t\t\t\t\t\t<span ng-class=\"CurrChapterindex == ($index) ? 'reforma-bold ': ''\" class=\"blue-txt description-txt reforma nounderline  ng-binding\">Tel Aviv District</span>\n\t\t\t\t\t\t\t\t\t<img src=\""+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/a-down.png")+"\" class=\"img-responsive a-arrow-img\" alt=\"\">\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t<!-- end ngRepeat: chapter in Guide.Chapters --><li data-show=\"5\" class=\"ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope\" ng-repeat=\"chapter in Guide.Chapters\" ng-class=\"getDecorationForLi($index)\" ng-click=\"openChapterMenu(false,$index);updateChapterIndex($index);\" role=\"button\" tabindex=\"0\" >\n\t\t\t\t\t\t\t\t\t<span ng-class=\"CurrChapterindex == ($index) ? 'reforma-bold ': ''\" class=\"blue-txt description-txt reforma nounderline  ng-binding\">Southern District</span>\n\t\t\t\t\t\t\t\t\t<img src=\""+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/a-down.png")+"\" class=\"img-responsive a-arrow-img\" alt=\"\">\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t</li><!-- end ngRepeat: chapter in Guide.Chapters -->\n\t\t\t\t\t\t\t\t<div class=\"clear\"></div>\n\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t</div>\n\t\t\n\t\t\t\t\t\t<div id=\"res\">\n\t\t\t\t\t\t\t<!-- ac part -->\n\t\t\t\t\t\t\t<div class=\"ac-part ac-part-1 ac-part-active\">\n\t\t\n\t\t\t\t\t\t\t\t<div ng-include=\"chapterItem\" class=\"row row-gov ng-scope\">\n\t\t\t\t\t\t\t\t\t<!-- Sub Title -->\n\t\t\t\t\t\t\t\t\t<div class=\"col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope\">\n\t\t\t\t\t\t\t\t\t\t<h2 class=\"h2 gray-txt pr-fs-28 chapter-title inline-block\">\n\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: Guide.ShowChaptersIndex -->\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"ng-binding\">Northern District</span>\n\t\t\t\t\t\t\t\t\t\t</h2>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\n\t\t\t\t\t\t\t\t\t<div class=\"col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope\">\n\t\t\t\t\t\t\t\t\t\t<!-- IMAGE TAG  ------->\n\t\t\t\t\t\t\t\t\t\t<!--- Image-->\n\t\t\n\t\t\t\t\t\t\t\t<!-- ngIf: CurrChapter.Image --><div ng-if=\"CurrChapter.Image\" class=\"row row-gov no-gutters ng-scope\">\n\t\t\t\t\t\t\t\t\t<div class=\"position-relative col-lg-10 lg-p-0\">\n\t\t\t\t\t\t\t\t\t\t<!-- ngIf: CurrChapter.Image.ClickURLRef -->\n\t\t\n\t\t\t\t\t\t\t\t\t\t<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if=\"!CurrChapter.Image.ClickURLRef\" class=\"ng-scope\">\n\t\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->\n\t\t\t\t\t\t\t\t\t\t<!--Image desc-->\n\t\t\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"position-absolute\">\n\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: CurrChapter.Image --><div ng-if=\"CurrChapter.Image\" class=\"xs-mb-10 ng-scope\">\n\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"small-txt ng-binding\"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"small-txt ng-binding\"></span>\n\t\t\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: CurrChapter.Image -->\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div><!-- end ngIf: CurrChapter.Image -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- End IMAGE TAG  ------->\n\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"row row-gov no-gutters\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--Content Text-->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div id=\"GuidesChapterContent-1\" style=\"overflow: hidden;\" ng-bind-html=\"CurrChapter.Content | to_trusted\" fixed-tables=\"\" class=\"xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding\"><div class=\"table-responsive\"><div><div class=\"changeWidth0\" style=\"width: auto;\"></div><table cellpadding=\"1\" cellspacing=\"1\" style=\"width: 100%;\" class=\"table ui-responsive\" data-mode=\"reflow\" data-role=\"table\">\n\t\t\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Kineret Municipal Unio</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Parking&nbsp;&nbsp; &nbsp;</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Tzinbari</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Berniki</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>At the nearby Shikmim beach</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Shikmim</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Hukok</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Amnon</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Kinar</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Doga</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Closed</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Tze\u2019elon</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Kursi</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>At the nearby Levanon beach</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Levanon</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Halukim</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>At the nearby Levanon beach</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>At the nearby Levanon beach</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Shizaf</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Dugit \u2013 Golan</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Gofra</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Tiberias</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Guy</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Galei Kineret - Rimonim</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Leonardo Pacific</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Closed for renovations</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Coco Hot / Holiday Inn</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Jordan Valley Regional Council</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Ein Gev Vacation</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Ginnosar</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Migdal Regional Council</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Restal Magdala</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Mateh Asher Regional Council</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Banana Beach Achziv</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Nahariya</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Sokolov</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Galil Central</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Acco</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Argaman Central</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Hatmarim</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t\t\t</table></div></div>\n\t\t\n\t\t\t\t\t\t\t\t<p>&nbsp;</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--Chapters/Collapse-->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"col-12\" id=\"accordion\" role=\"tablist\" aria-multiselectable=\"true\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngRepeat: collapse in CurrChapter.Collapses -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--End of Chapters/Collapse-->\n\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"col-12 xs-mb-25 lg-mb-30\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Files for Download-->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Files for Download-->\n\t\t\t\t\t\t\t\t<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->\n\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: !isOnPrintMode --><div ng-if=\"!isOnPrintMode\" class=\"ng-scope\">\n\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if=\"Guide.Chapters.length > 1\" class=\"ng-scope\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- horizontal line -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"row row-gov xs-mb-25 lg-mb-30 xs-mb-25 \">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"horizontal-line\"></div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: Guide.Chapters.length > 1 -->\n\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--arrows subject nav  \u05D3\u05E4\u05D3\u05D5\u05E3-->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-end\" ng-class=\"{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--  \u05DC\u05D3\u05E3 \u05D4\u05E7\u05D5\u05D3\u05DD -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: CurrChapterindex > 0 -->\n\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--  \u05DC\u05D3\u05E3 \u05D4\u05D1\u05D0 -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div ng-show=\"CurrChapterindex < lastIndex\" class=\"col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer\" ng-click=\"updateChapterIndex(CurrChapterindex + 1)\" role=\"button\" tabindex=\"0\" aria-hidden=\"false\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"guideBreakLine xs-ml-10 pull-left width-100 text-left height100\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"small-txt gray-txt width-100\">Next page:</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"reforma description-txt blue-txt width-100 ng-binding\">Haifa District</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"icon-arrow-left toflipInEng h3 blue-txt\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: !isOnPrintMode -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<!-- ac- part -->\n\t\t\n\t\t\t\t\t\t\t<!-- ac part 2 -->\n\t\t\t\t\t\t\t<div class=\"ac-part ac-part-2\">\n\t\t\t\t\t\t\t<div ng-include=\"chapterItem\" class=\"row row-gov ng-scope\">\n\t\t\t\t\t\t\t<!-- Sub Title -->\n\t\t\t\t\t\t\t<div class=\"col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope\">\n\t\t\t\t\t\t\t\t<h2 class=\"h2 gray-txt pr-fs-28 chapter-title inline-block\">\n\t\t\t\t\t\t\t\t\t<!-- ngIf: Guide.ShowChaptersIndex -->\n\t\t\t\t\t\t\t\t\t<span class=\"ng-binding\">Haifa District</span>\n\t\t\t\t\t\t\t\t</h2>\n\t\t\t\t\t\t\t</div>\n\t\t\n\t\t\t\t\t\t\t<div class=\"col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope\">\n\t\t\t\t\t\t\t\t<!-- IMAGE TAG  ------->\n\t\t\t\t\t\t\t\t<!--- Image-->\n\t\t\n\t\t<!-- ngIf: CurrChapter.Image --><div ng-if=\"CurrChapter.Image\" class=\"row row-gov no-gutters ng-scope\">\n\t\t<div class=\"position-relative col-lg-10 lg-p-0\">\n\t\t\t<!-- ngIf: CurrChapter.Image.ClickURLRef -->\n\t\t\n\t\t\t<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if=\"!CurrChapter.Image.ClickURLRef\" class=\"ng-scope\">\n\t\t\t</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->\n\t\t\t<!--Image desc-->\n\t\t\t<div>\n\t\t\t\t<div class=\"position-absolute\">\n\t\t\t\t\t<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->\n\t\t\t\t</div>\n\t\t\t\t<!-- ngIf: CurrChapter.Image --><div ng-if=\"CurrChapter.Image\" class=\"xs-mb-10 ng-scope\">\n\t\t\t\t\t<span class=\"small-txt ng-binding\"></span>\n\t\t\t\t\t<span class=\"small-txt ng-binding\"></span>\n\t\t\t\t</div><!-- end ngIf: CurrChapter.Image -->\n\t\t\t</div>\n\t\t</div>\n\t\t</div><!-- end ngIf: CurrChapter.Image -->\n\t\t\t\t\t\t\t\t<!-- End IMAGE TAG  ------->\n\t\t\n\t\t\t\t\t\t\t\t<div class=\"row row-gov no-gutters\">\n\t\t\t\t\t\t\t\t\t<!--Content Text-->\n\t\t\t\t\t\t\t\t\t<div id=\"GuidesChapterContent-2\" style=\"overflow: hidden;\" ng-bind-html=\"CurrChapter.Content | to_trusted\" fixed-tables=\"\" class=\"xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding\"><div class=\"table-responsive\"><div><div class=\"changeWidth0\" style=\"width: auto;\"></div><table align=\"left\" cellpadding=\"1\" cellspacing=\"1\" style=\"width: 100%;\" class=\"table ui-responsive\" data-mode=\"reflow\" data-role=\"table\">\n\t\t<tbody>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Kiryat Yam</strong></td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Zevulun</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Haifa</strong></td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Zamir 1</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Zamir 2</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Neot Kiryat Haim Central</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Bat Galim 1</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Bat Galim 2</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Hof Hacarmel Regional Council</strong></td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Dor Central 2</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Neve Yam</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Aqueduct</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Jisr a-Zarka Regional Council</strong></td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Jisr</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Hadera</strong></td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Kfar Yam&nbsp;</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Olga Central 2</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t</tbody>\n\t\t</table></div></div>\n\t\t\n\t\t<p>&nbsp;</p>\n\t\t</div>\n\t\t\n\t\t\t\t\t\t\t\t\t<!--Chapters/Collapse-->\n\t\t\t\t\t\t\t\t\t<div class=\"col-12\" id=\"accordion\" role=\"tablist\" aria-multiselectable=\"true\">\n\t\t\t\t\t\t\t\t\t\t<!-- ngRepeat: collapse in CurrChapter.Collapses -->\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\n\t\t\t\t\t\t\t\t\t<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->\n\t\t\t\t\t\t\t\t\t<!--End of Chapters/Collapse-->\n\t\t\n\t\t\t\t\t\t\t\t\t<div class=\"col-12 xs-mb-25 lg-mb-30\">\n\t\t\t\t\t\t\t\t\t\t<!-- Files for Download-->\n\t\t\t\t\t\t\t\t\t\t<!-- Files for Download-->\n\t\t<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->\n\t\t\n\t\t\t\t\t\t\t\t\t\t<!-- ngIf: !isOnPrintMode --><div ng-if=\"!isOnPrintMode\" class=\"ng-scope\">\n\t\t\n\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if=\"Guide.Chapters.length > 1\" class=\"ng-scope\">\n\t\t\t\t\t\t\t\t\t\t\t\t<!-- horizontal line -->\n\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"row row-gov xs-mb-25 lg-mb-30 xs-mb-25 \">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"horizontal-line\"></div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: Guide.Chapters.length > 1 -->\n\t\t\n\t\t\t\t\t\t\t\t\t\t\t<!--arrows subject nav  \u05D3\u05E4\u05D3\u05D5\u05E3-->\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-end\" ng-class=\"{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]\">\n\t\t\t\t\t\t\t\t\t\t\t\t<!--  \u05DC\u05D3\u05E3 \u05D4\u05E7\u05D5\u05D3\u05DD -->\n\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: CurrChapterindex > 0 --><div ng-if=\"CurrChapterindex > 0\" class=\"col-6 list-unstyled xs-float-start ie-display-flex flex-start ie-flex-start hover-Pointer ng-scope\" ng-click=\"updateChapterIndex(CurrChapterindex - 1)\" role=\"button\" tabindex=\"0\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"icon-arrow-right toflipInEng h3 blue-txt\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"xs-mr-20 lg-mr-10 guideBreakLine width-100 text-right height100\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"small-txt gray-txt width-100\"> Previous page:</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"reforma description-txt blue-txt width-100 ng-binding\">Northern District</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: CurrChapterindex > 0 -->\n\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t<!--  \u05DC\u05D3\u05E3 \u05D4\u05D1\u05D0 -->\n\t\t\t\t\t\t\t\t\t\t\t\t<div ng-show=\"CurrChapterindex < lastIndex\" class=\"col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer\" ng-click=\"updateChapterIndex(CurrChapterindex + 1)\" role=\"button\" tabindex=\"0\" aria-hidden=\"false\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"guideBreakLine xs-ml-10 pull-left width-100 text-left height100\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"small-txt gray-txt width-100\">Next page:</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"reforma description-txt blue-txt width-100 ng-binding\">Central District</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"icon-arrow-left toflipInEng h3 blue-txt\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: !isOnPrintMode -->\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<!-- end ac part-2 -->\n\t\t\n\t\t\t\t\t\t\t<!-- ac-part-3 -->\n\t\t\t\t\t\t\t<div class=\"ac-part ac-part-3\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div ng-include=\"chapterItem\" class=\"row row-gov ng-scope\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Sub Title -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<h2 class=\"h2 gray-txt pr-fs-28 chapter-title inline-block\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: Guide.ShowChaptersIndex -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"ng-binding\">Central District</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</h2>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- IMAGE TAG  ------->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--- Image-->\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t<!-- ngIf: CurrChapter.Image --><div ng-if=\"CurrChapter.Image\" class=\"row row-gov no-gutters ng-scope\">\n\t\t\t\t\t\t\t\t\t<div class=\"position-relative col-lg-10 lg-p-0\">\n\t\t\t\t\t\t\t\t\t\t<!-- ngIf: CurrChapter.Image.ClickURLRef -->\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if=\"!CurrChapter.Image.ClickURLRef\" class=\"ng-scope\">\n\t\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->\n\t\t\t\t\t\t\t\t\t\t<!--Image desc-->\n\t\t\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"position-absolute\">\n\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: CurrChapter.Image --><div ng-if=\"CurrChapter.Image\" class=\"xs-mb-10 ng-scope\">\n\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"small-txt ng-binding\"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"small-txt ng-binding\"></span>\n\t\t\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: CurrChapter.Image -->\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div><!-- end ngIf: CurrChapter.Image -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- End IMAGE TAG  ------->\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"row row-gov no-gutters\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--Content Text-->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div id=\"GuidesChapterContent-3\" style=\"overflow: hidden;\" ng-bind-html=\"CurrChapter.Content | to_trusted\" fixed-tables=\"\" class=\"xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding\"><div class=\"table-responsive\"><div><div class=\"changeWidth0\" style=\"width: auto;\"></div><table cellpadding=\"1\" cellspacing=\"1\" style=\"width: 100%;\" class=\"table ui-responsive\" data-mode=\"reflow\" data-role=\"table\">\n\t\t\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Emek Hefer Regional Council</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Michmoret \u2013 Station number 1</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Michmoret \u2013 Station number 2</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Joint with number 1</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Beit Yannai</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>NeUrim Beach</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Netanya</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Kiryat Tzanz</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>HaOnot Beach</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Parking</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Ampi Beach</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Herzl</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Sironit Beach A</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Sironit Beach B</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Argaman Beach</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Poleg Beach</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Bathrooms only</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Hof Hasharon Regional Council</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Shefayim (Ga\u2019ash)</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Rishon Le-Zion</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Beach number 1 \u2013 Hakachol (Blue) Beach</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Beach number 2 \u2013 Neve Hof Beach</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Beach number 3 \u2013 Hofit Beach</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Beach number 4 \u2013 Tel Yonah Beach</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Beach number 5 \u2013 Hayeladim (Children\u2019s) Beach</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Beach number 6 \u2013 separate beach</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Gan Raveh Regional Council</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Palmahim Beach</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t\t\t</table></div></div>\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t<p>&nbsp;</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--Chapters/Collapse-->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"col-12\" id=\"accordion\" role=\"tablist\" aria-multiselectable=\"true\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngRepeat: collapse in CurrChapter.Collapses -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--End of Chapters/Collapse-->\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"col-12 xs-mb-25 lg-mb-30\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Files for Download-->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Files for Download-->\n\t\t\t\t\t\t\t\t<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: !isOnPrintMode --><div ng-if=\"!isOnPrintMode\" class=\"ng-scope\">\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if=\"Guide.Chapters.length > 1\" class=\"ng-scope\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- horizontal line -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"row row-gov xs-mb-25 lg-mb-30 xs-mb-25 \">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"horizontal-line\"></div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: Guide.Chapters.length > 1 -->\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--arrows subject nav  \u05D3\u05E4\u05D3\u05D5\u05E3-->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-end\" ng-class=\"{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--  \u05DC\u05D3\u05E3 \u05D4\u05E7\u05D5\u05D3\u05DD -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: CurrChapterindex > 0 --><div ng-if=\"CurrChapterindex > 0\" class=\"col-6 list-unstyled xs-float-start ie-display-flex flex-start ie-flex-start hover-Pointer ng-scope\" ng-click=\"updateChapterIndex(CurrChapterindex - 1)\" role=\"button\" tabindex=\"0\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"icon-arrow-right toflipInEng h3 blue-txt\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"xs-mr-20 lg-mr-10 guideBreakLine width-100 text-right height100\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"small-txt gray-txt width-100\"> Previous page:</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"reforma description-txt blue-txt width-100 ng-binding\">Haifa District</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: CurrChapterindex > 0 -->\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--  \u05DC\u05D3\u05E3 \u05D4\u05D1\u05D0 -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div ng-show=\"CurrChapterindex < lastIndex\" class=\"col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer\" ng-click=\"updateChapterIndex(CurrChapterindex + 1)\" role=\"button\" tabindex=\"0\" aria-hidden=\"false\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"guideBreakLine xs-ml-10 pull-left width-100 text-left height100\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"small-txt gray-txt width-100\">Next page:</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"reforma description-txt blue-txt width-100 ng-binding\">Tel Aviv District</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"icon-arrow-left toflipInEng h3 blue-txt\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: !isOnPrintMode -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<!-- end ac-part-3 -->\n\t\t\n\t\t\t\t\t\t\t<!-- ac-part-4 -->\n\t\t\t\t\t\t\t<div class=\"ac-part ac-part-4\">\n\t\t\t\t\t\t\t<div ng-include=\"chapterItem\" class=\"row row-gov ng-scope\">\n\t\t\t\t\t<!-- Sub Title -->\n\t\t\t\t\t<div class=\"col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope\">\n\t\t\t\t\t\t<h2 class=\"h2 gray-txt pr-fs-28 chapter-title inline-block\">\n\t\t\t\t\t\t\t<!-- ngIf: Guide.ShowChaptersIndex -->\n\t\t\t\t\t\t\t<span class=\"ng-binding\">Tel Aviv District</span>\n\t\t\t\t\t\t</h2>\n\t\t\t\t\t</div>\n\t\t\n\t\t\t\t\t<div class=\"col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope\">\n\t\t\t\t\t\t<!-- IMAGE TAG  ------->\n\t\t\t\t\t\t<!--- Image-->\n\t\t\n\t\t<!-- ngIf: CurrChapter.Image --><div ng-if=\"CurrChapter.Image\" class=\"row row-gov no-gutters ng-scope\">\n\t\t<div class=\"position-relative col-lg-10 lg-p-0\">\n\t\t<!-- ngIf: CurrChapter.Image.ClickURLRef -->\n\t\t\n\t\t<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if=\"!CurrChapter.Image.ClickURLRef\" class=\"ng-scope\">\n\t\t</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->\n\t\t<!--Image desc-->\n\t\t<div>\n\t\t<div class=\"position-absolute\">\n\t\t\t<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->\n\t\t</div>\n\t\t<!-- ngIf: CurrChapter.Image --><div ng-if=\"CurrChapter.Image\" class=\"xs-mb-10 ng-scope\">\n\t\t\t<span class=\"small-txt ng-binding\"></span>\n\t\t\t<span class=\"small-txt ng-binding\"></span>\n\t\t</div><!-- end ngIf: CurrChapter.Image -->\n\t\t</div>\n\t\t</div>\n\t\t</div><!-- end ngIf: CurrChapter.Image -->\n\t\t\t\t\t\t<!-- End IMAGE TAG  ------->\n\t\t\n\t\t\t\t\t\t<div class=\"row row-gov no-gutters\">\n\t\t\t\t\t\t\t<!--Content Text-->\n\t\t\t\t\t\t\t<div id=\"GuidesChapterContent-4\" style=\"overflow: hidden;\" ng-bind-html=\"CurrChapter.Content | to_trusted\" fixed-tables=\"\" class=\"xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding\"><div class=\"table-responsive\"><div><div class=\"changeWidth0\" style=\"width: auto;\"></div><table cellpadding=\"1\" cellspacing=\"1\" style=\"width: 100%;\" class=\"table ui-responsive\" data-mode=\"reflow\" data-role=\"table\">\n\t\t<tbody>\n\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Herzliya</strong></td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td><strong>Name of beach</strong></td>\n\t\t<td><strong>Parking</strong></td>\n\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t<td><strong>Access to shade</strong></td>\n\t\t<td><strong>Access to water</strong></td>\n\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Nof Yam</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Hasharon&nbsp;&nbsp; &nbsp;Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Zevulun</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Acadia North Beach&nbsp;&nbsp; &nbsp;</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Acadia South Beach</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Acadia South Beach \u2013 Disabled</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Separate beach</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Tel Aviv - Jaffa</strong></td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td><strong>Name of beach</strong></td>\n\t\t<td><strong>Parking</strong></td>\n\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t<td><strong>Access to shade</strong></td>\n\t\t<td><strong>Access to water</strong></td>\n\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>HaTzuk Beach \u2013 Station number 1</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Tel Baruch Beach \u2013 Station number 1</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Nordau (Metzitzim) Beach</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Nordau separate beach</td>\n\t\t<td>Yes</td>\n\t\t<td>Bathrooms only</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Gordon</td>\n\t\t<td>No</td>\n\t\t<td>Bathrooms only</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Bograshov</td>\n\t\t<td>No</td>\n\t\t<td>Bathrooms only</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Allenby (Jerusalem)</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Charles Clore</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Jaffa \u2013 Givat HaAliyah</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Hilton North</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>HaTzuk Beach \u2013 Station number 2</td>\n\t\t<td>Yes</td>\n\t\t<td>Bathrooms only</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Frishman</td>\n\t\t<td>No</td>\n\t\t<td>Bathrooms only</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Aviv Beach</td>\n\t\t<td>No</td>\n\t\t<td>Bathrooms only</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Bat Yam</strong></td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td><strong>Name of beach</strong></td>\n\t\t<td><strong>Parking</strong></td>\n\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t<td><strong>Access to shade</strong></td>\n\t\t<td><strong>Access to water</strong></td>\n\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>HaSela \u2013 Station number 1</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>HaSela \u2013 Station number 2</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>HaSela \u2013 Station number 3</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Sample Beach</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Riviera</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Separate beach</td>\n\t\t<td>Yes</td>\n\t\t<td>Bathrooms only</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Tayo</td>\n\t\t<td>Yes</td>\n\t\t<td>Bathrooms only</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t</tr>\n\t\t</tbody>\n\t\t</table></div></div>\n\t\t\n\t\t<p>&nbsp;</p>\n\t\t</div>\n\t\t\n\t\t\t\t\t\t\t<!--Chapters/Collapse-->\n\t\t\t\t\t\t\t<div class=\"col-12\" id=\"accordion\" role=\"tablist\" aria-multiselectable=\"true\">\n\t\t\t\t\t\t\t\t<!-- ngRepeat: collapse in CurrChapter.Collapses -->\n\t\t\t\t\t\t\t</div>\n\t\t\n\t\t\t\t\t\t\t<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->\n\t\t\t\t\t\t\t<!--End of Chapters/Collapse-->\n\t\t\n\t\t\t\t\t\t\t<div class=\"col-12 xs-mb-25 lg-mb-30\">\n\t\t\t\t\t\t\t\t<!-- Files for Download-->\n\t\t\t\t\t\t\t\t<!-- Files for Download-->\n\t\t<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->\n\t\t\n\t\t\t\t\t\t\t\t<!-- ngIf: !isOnPrintMode --><div ng-if=\"!isOnPrintMode\" class=\"ng-scope\">\n\t\t\n\t\t\t\t\t\t\t\t\t<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if=\"Guide.Chapters.length > 1\" class=\"ng-scope\">\n\t\t\t\t\t\t\t\t\t\t<!-- horizontal line -->\n\t\t\t\t\t\t\t\t\t\t<div class=\"row row-gov xs-mb-25 lg-mb-30 xs-mb-25 \">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"horizontal-line\"></div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: Guide.Chapters.length > 1 -->\n\t\t\n\t\t\t\t\t\t\t\t\t<!--arrows subject nav  \u05D3\u05E4\u05D3\u05D5\u05E3-->\n\t\t\t\t\t\t\t\t\t<div class=\"row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-end\" ng-class=\"{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]\">\n\t\t\t\t\t\t\t\t\t\t<!--  \u05DC\u05D3\u05E3 \u05D4\u05E7\u05D5\u05D3\u05DD -->\n\t\t\t\t\t\t\t\t\t\t<!-- ngIf: CurrChapterindex > 0 --><div ng-if=\"CurrChapterindex > 0\" class=\"col-6 list-unstyled xs-float-start ie-display-flex flex-start ie-flex-start hover-Pointer ng-scope\" ng-click=\"updateChapterIndex(CurrChapterindex - 1)\" role=\"button\" tabindex=\"0\">\n\t\t\t\t\t\t\t\t\t\t\t<i class=\"icon-arrow-right toflipInEng h3 blue-txt\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"xs-mr-20 lg-mr-10 guideBreakLine width-100 text-right height100\">\n\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"small-txt gray-txt width-100\"> Previous page:</span>\n\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"reforma description-txt blue-txt width-100 ng-binding\">Central District</span>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: CurrChapterindex > 0 -->\n\t\t\n\t\t\t\t\t\t\t\t\t\t<!--  \u05DC\u05D3\u05E3 \u05D4\u05D1\u05D0 -->\n\t\t\t\t\t\t\t\t\t\t<div ng-show=\"CurrChapterindex < lastIndex\" class=\"col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer\" ng-click=\"updateChapterIndex(CurrChapterindex + 1)\" role=\"button\" tabindex=\"0\" aria-hidden=\"false\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"guideBreakLine xs-ml-10 pull-left width-100 text-left height100\">\n\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"small-txt gray-txt width-100\">Next page:</span>\n\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"reforma description-txt blue-txt width-100 ng-binding\">Southern District</span>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<i class=\"icon-arrow-left toflipInEng h3 blue-txt\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div><!-- end ngIf: !isOnPrintMode -->\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<!-- end ac-part-4 -->\n\t\t\n\t\t\t\t\t\t\t<!-- ac-part-5 -->\n\t\t\t\t\t\t\t<div class=\"ac-part ac-part-5\">\n\t\t\t\t\t\t\t<div ng-include=\"chapterItem\" class=\"row row-gov ng-scope\">\n\t\t\t\t\t\t\t<!-- Sub Title -->\n\t\t\t\t\t\t\t<div class=\"col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope\">\n\t\t\t\t\t\t\t\t<h2 class=\"h2 gray-txt pr-fs-28 chapter-title inline-block\">\n\t\t\t\t\t\t\t\t\t<!-- ngIf: Guide.ShowChaptersIndex -->\n\t\t\t\t\t\t\t\t\t<span class=\"ng-binding\">Southern District</span>\n\t\t\t\t\t\t\t\t</h2>\n\t\t\t\t\t\t\t</div>\n\t\t\n\t\t\t\t\t\t\t<div class=\"col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope\">\n\t\t\t\t\t\t\t\t<!-- IMAGE TAG  ------->\n\t\t\t\t\t\t\t\t<!--- Image-->\n\t\t\n\t\t<!-- ngIf: CurrChapter.Image --><div ng-if=\"CurrChapter.Image\" class=\"row row-gov no-gutters ng-scope\">\n\t\t<div class=\"position-relative col-lg-10 lg-p-0\">\n\t\t\t<!-- ngIf: CurrChapter.Image.ClickURLRef -->\n\t\t\n\t\t\t<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if=\"!CurrChapter.Image.ClickURLRef\" class=\"ng-scope\">\n\t\t\t</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->\n\t\t\t<!--Image desc-->\n\t\t\t<div>\n\t\t\t\t<div class=\"position-absolute\">\n\t\t\t\t\t<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->\n\t\t\t\t</div>\n\t\t\t\t<!-- ngIf: CurrChapter.Image --><div ng-if=\"CurrChapter.Image\" class=\"xs-mb-10 ng-scope\">\n\t\t\t\t\t<span class=\"small-txt ng-binding\"></span>\n\t\t\t\t\t<span class=\"small-txt ng-binding\"></span>\n\t\t\t\t</div><!-- end ngIf: CurrChapter.Image -->\n\t\t\t</div>\n\t\t</div>\n\t\t</div><!-- end ngIf: CurrChapter.Image -->\n\t\t\t\t\t\t\t\t<!-- End IMAGE TAG  ------->\n\t\t\n\t\t\t\t\t\t\t\t<div class=\"row row-gov no-gutters\">\n\t\t\t\t\t\t\t\t\t<!--Content Text-->\n\t\t\t\t\t\t\t\t\t<div id=\"GuidesChapterContent-5\" style=\"overflow: hidden;\" ng-bind-html=\"CurrChapter.Content | to_trusted\" fixed-tables=\"\" class=\"xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding\"><div class=\"table-responsive\"><div><div class=\"changeWidth0\" style=\"width: auto;\"></div><table cellpadding=\"1\" cellspacing=\"1\" style=\"width: 100%;\" class=\"table ui-responsive\" data-mode=\"reflow\" data-role=\"table\">\n\t\t<tbody>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Ashdod</strong></td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Mei Ami Beach</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Bathrooms only</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Lido</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Bathrooms only</td>\n\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t<td>&nbsp;</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Oranim</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Bathrooms only</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Hakshatot</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Bathrooms only</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Separate beach</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Bathrooms only</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Rova K</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Bathrooms only</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Riviera</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Bathrooms only</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td colspan=\"6\" style=\"text-align: center;\"><strong>Hof Ashkelon Regional Council</strong></td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Nitzanim</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Zikim</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Ashkelon</strong></td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Bar Kochva North</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Bar Kochva South</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Delila North</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Delila South</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Ashkelon National Park Beach</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Bathrooms only</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Separate beach</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>\u05DC\u05D0</td>\n\t\t\t\t<td>\u05DC\u05D0</td>\n\t\t\t\t<td>\u05DC\u05D0</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Tamar Regional Council</strong></td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Mazor Springs</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Meridian Beach</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Hod Hotel Beach</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Tzel Harim</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Under construction&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Crown Plaza Beach</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Lot</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Lot\u2019s Wife</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Under construction&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t<td>Under construction&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t<td>Under construction&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Ein Bokek South</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Under construction&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t<td>Under construction&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t<td>Under construction&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Daniel Hotel Beach</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Under construction&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t<td>Under construction&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Solarium Beach</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Isrotel Beach</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>International Beach</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Leonardo Plaza Beach</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Zohar Springs (North)</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Separate beach</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Leonardo Club Beach</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Eilat&nbsp;&nbsp; &nbsp;</strong></td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td><br>\n\t\t\t\tSeparate beach</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Herod\u2019s beach</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Bathrooms only</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td><br>\n\t\t\t\tNorthwestern Beach</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Bathrooms only</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t</tr>\n\t\t</tbody>\n\t\t</table></div></div>\n\t\t\n\t\t<p>&nbsp;</p>\n\t\t</div>\n\t\t\n\t\t\t\t\t\t\t\t\t<!--Chapters/Collapse-->\n\t\t\t\t\t\t\t\t\t<div class=\"col-12\" id=\"accordion\" role=\"tablist\" aria-multiselectable=\"true\">\n\t\t\t\t\t\t\t\t\t\t<!-- ngRepeat: collapse in CurrChapter.Collapses -->\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\n\t\t\t\t\t\t\t\t\t<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->\n\t\t\t\t\t\t\t\t\t<!--End of Chapters/Collapse-->\n\t\t\n\t\t\t\t\t\t\t\t\t<div class=\"col-12 xs-mb-25 lg-mb-30\">\n\t\t\t\t\t\t\t\t\t\t<!-- Files for Download-->\n\t\t\t\t\t\t\t\t\t\t<!-- Files for Download-->\n\t\t<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->\n\t\t\n\t\t\t\t\t\t\t\t\t\t<!-- ngIf: !isOnPrintMode --><div ng-if=\"!isOnPrintMode\" class=\"ng-scope\">\n\t\t\n\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if=\"Guide.Chapters.length > 1\" class=\"ng-scope\">\n\t\t\t\t\t\t\t\t\t\t\t\t<!-- horizontal line -->\n\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"row row-gov xs-mb-25 lg-mb-30 xs-mb-25 \">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"horizontal-line\"></div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: Guide.Chapters.length > 1 -->\n\t\t\n\t\t\t\t\t\t\t\t\t\t\t<!--arrows subject nav  \u05D3\u05E4\u05D3\u05D5\u05E3-->\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-start\" ng-class=\"{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]\">\n\t\t\t\t\t\t\t\t\t\t\t\t<!--  \u05DC\u05D3\u05E3 \u05D4\u05E7\u05D5\u05D3\u05DD -->\n\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: CurrChapterindex > 0 --><div ng-if=\"CurrChapterindex > 0\" class=\"col-6 list-unstyled xs-float-start ie-display-flex flex-start ie-flex-start hover-Pointer ng-scope\" ng-click=\"updateChapterIndex(CurrChapterindex - 1)\" role=\"button\" tabindex=\"0\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"icon-arrow-right toflipInEng h3 blue-txt\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"xs-mr-20 lg-mr-10 guideBreakLine width-100 text-right height100\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"small-txt gray-txt width-100\"> Previous page:</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"reforma description-txt blue-txt width-100 ng-binding\">Tel Aviv District</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: CurrChapterindex > 0 -->\n\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t<!--  \u05DC\u05D3\u05E3 \u05D4\u05D1\u05D0 -->\n\t\t\t\t\t\t\t\t\t\t\t\t<div ng-show=\"CurrChapterindex < lastIndex\" class=\"col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer ng-hide\" ng-click=\"updateChapterIndex(CurrChapterindex + 1)\" role=\"button\" tabindex=\"0\" aria-hidden=\"true\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"guideBreakLine xs-ml-10 pull-left width-100 text-left height100\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"small-txt gray-txt width-100\">Next page:</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"reforma description-txt blue-txt width-100 ng-binding\"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"icon-arrow-left toflipInEng h3 blue-txt\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: !isOnPrintMode -->\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<!-- end ac-part-5 -->\n\t\t\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/destination-for-all/6.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t </div><br>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t"};}}];

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Loader_css__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Loader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Loader_css__);
var Loader=function Loader(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"spinner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bounce1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bounce2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bounce3"}));};/* harmony default export */ __webpack_exports__["a"] = (Loader);

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(111);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(66);
var global = __webpack_require__(7);
var isForced = __webpack_require__(77);
var redefine = __webpack_require__(24);
var InternalMetadataModule = __webpack_require__(78);
var iterate = __webpack_require__(79);
var anInstance = __webpack_require__(83);
var isObject = __webpack_require__(14);
var fails = __webpack_require__(13);
var checkCorrectnessOfIteration = __webpack_require__(132);
var setToStringTag = __webpack_require__(48);
var inheritIfRequired = __webpack_require__(133);

module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = global[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor = NativeConstructor;
  var exported = {};

  var fixMethod = function (KEY) {
    var nativeMethod = NativePrototype[KEY];
    redefine(NativePrototype, KEY,
      KEY == 'add' ? function add(value) {
        nativeMethod.call(this, value === 0 ? 0 : value);
        return this;
      } : KEY == 'delete' ? function (key) {
        return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
      } : KEY == 'get' ? function get(key) {
        return IS_WEAK && !isObject(key) ? undefined : nativeMethod.call(this, key === 0 ? 0 : key);
      } : KEY == 'has' ? function has(key) {
        return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
      } : function set(key, value) {
        nativeMethod.call(this, key === 0 ? 0 : key, value);
        return this;
      }
    );
  };

  // eslint-disable-next-line max-len
  if (isForced(CONSTRUCTOR_NAME, typeof NativeConstructor != 'function' || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
    new NativeConstructor().entries().next();
  })))) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule.REQUIRED = true;
  } else if (isForced(CONSTRUCTOR_NAME, true)) {
    var instance = new Constructor();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    // eslint-disable-next-line no-new
    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new NativeConstructor();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      Constructor = wrapper(function (dummy, iterable) {
        anInstance(dummy, Constructor, CONSTRUCTOR_NAME);
        var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
        if (iterable != undefined) iterate(iterable, that[ADDER], that, IS_MAP);
        return that;
      });
      Constructor.prototype = NativePrototype;
      NativePrototype.constructor = Constructor;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

    // weak collections should not contains .clear method
    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
  }

  exported[CONSTRUCTOR_NAME] = Constructor;
  $({ global: true, forced: Constructor != NativeConstructor }, exported);

  setToStringTag(Constructor, CONSTRUCTOR_NAME);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(7);
var getOwnPropertyDescriptor = __webpack_require__(67).f;
var createNonEnumerableProperty = __webpack_require__(18);
var redefine = __webpack_require__(24);
var setGlobal = __webpack_require__(39);
var copyConstructorProperties = __webpack_require__(120);
var isForced = __webpack_require__(77);

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(17);
var propertyIsEnumerableModule = __webpack_require__(117);
var createPropertyDescriptor = __webpack_require__(37);
var toIndexedObject = __webpack_require__(27);
var toPrimitive = __webpack_require__(69);
var has = __webpack_require__(12);
var IE8_DOM_DEFINE = __webpack_require__(70);

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),
/* 68 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(17);
var fails = __webpack_require__(13);
var createElement = __webpack_require__(71);

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(7);
var isObject = __webpack_require__(14);

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(73);

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store.inspectSource != 'function') {
  store.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

module.exports = store.inspectSource;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(7);
var setGlobal = __webpack_require__(39);

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__(41);
var store = __webpack_require__(73);

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.6.4',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(12);
var toIndexedObject = __webpack_require__(27);
var indexOf = __webpack_require__(123).indexOf;
var hiddenKeys = __webpack_require__(29);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(45);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(13);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var hiddenKeys = __webpack_require__(29);
var isObject = __webpack_require__(14);
var has = __webpack_require__(12);
var defineProperty = __webpack_require__(15).f;
var uid = __webpack_require__(42);
var FREEZING = __webpack_require__(126);

var METADATA = uid('meta');
var id = 0;

var isExtensible = Object.isExtensible || function () {
  return true;
};

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + ++id, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZING && meta.REQUIRED && isExtensible(it) && !has(it, METADATA)) setMetadata(it);
  return it;
};

var meta = module.exports = {
  REQUIRED: false,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

hiddenKeys[METADATA] = true;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(19);
var isArrayIteratorMethod = __webpack_require__(127);
var toLength = __webpack_require__(76);
var bind = __webpack_require__(81);
var getIteratorMethod = __webpack_require__(130);
var callWithSafeIterationClosing = __webpack_require__(131);

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var iterate = module.exports = function (iterable, fn, that, AS_ENTRIES, IS_ITERATOR) {
  var boundFunction = bind(fn, that, AS_ENTRIES ? 2 : 1);
  var iterator, iterFn, index, length, result, next, step;

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = toLength(iterable.length); length > index; index++) {
        result = AS_ENTRIES
          ? boundFunction(anObject(step = iterable[index])[0], step[1])
          : boundFunction(iterable[index]);
        if (result && result instanceof Result) return result;
      } return new Result(false);
    }
    iterator = iterFn.call(iterable);
  }

  next = iterator.next;
  while (!(step = next.call(iterator)).done) {
    result = callWithSafeIterationClosing(iterator, boundFunction, step.value, AS_ENTRIES);
    if (typeof result == 'object' && result && result instanceof Result) return result;
  } return new Result(false);
};

iterate.stop = function (result) {
  return new Result(true, result);
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(13);

module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(129);

// optional / simple context binding
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__(47);
var classofRaw = __webpack_require__(68);
var wellKnownSymbol = __webpack_require__(9);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};


/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  } return it;
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(19);
var aPossiblePrototype = __webpack_require__(134);

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineProperty = __webpack_require__(15).f;
var create = __webpack_require__(49);
var redefineAll = __webpack_require__(138);
var bind = __webpack_require__(81);
var anInstance = __webpack_require__(83);
var iterate = __webpack_require__(79);
var defineIterator = __webpack_require__(50);
var setSpecies = __webpack_require__(142);
var DESCRIPTORS = __webpack_require__(17);
var fastKey = __webpack_require__(78).fastKey;
var InternalStateModule = __webpack_require__(28);

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, CONSTRUCTOR_NAME);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        index: create(null),
        first: undefined,
        last: undefined,
        size: 0
      });
      if (!DESCRIPTORS) that.size = 0;
      if (iterable != undefined) iterate(iterable, that[ADDER], that, IS_MAP);
    });

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var entry = getEntry(that, key);
      var previous, index;
      // change existing entry
      if (entry) {
        entry.value = value;
      // create new entry
      } else {
        state.last = entry = {
          index: index = fastKey(key, true),
          key: key,
          value: value,
          previous: previous = state.last,
          next: undefined,
          removed: false
        };
        if (!state.first) state.first = entry;
        if (previous) previous.next = entry;
        if (DESCRIPTORS) state.size++;
        else that.size++;
        // add to index
        if (index !== 'F') state.index[index] = entry;
      } return that;
    };

    var getEntry = function (that, key) {
      var state = getInternalState(that);
      // fast case
      var index = fastKey(key);
      var entry;
      if (index !== 'F') return state.index[index];
      // frozen object case
      for (entry = state.first; entry; entry = entry.next) {
        if (entry.key == key) return entry;
      }
    };

    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        var that = this;
        var state = getInternalState(that);
        var data = state.index;
        var entry = state.first;
        while (entry) {
          entry.removed = true;
          if (entry.previous) entry.previous = entry.previous.next = undefined;
          delete data[entry.index];
          entry = entry.next;
        }
        state.first = state.last = undefined;
        if (DESCRIPTORS) state.size = 0;
        else that.size = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = this;
        var state = getInternalState(that);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.next;
          var prev = entry.previous;
          delete state.index[entry.index];
          entry.removed = true;
          if (prev) prev.next = next;
          if (next) next.previous = prev;
          if (state.first == entry) state.first = next;
          if (state.last == entry) state.last = prev;
          if (DESCRIPTORS) state.size--;
          else that.size--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        var state = getInternalState(this);
        var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.next : state.first) {
          boundFunction(entry.value, entry.key, this);
          // revert to the last existing entry
          while (entry && entry.removed) entry = entry.previous;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(this, key);
      }
    });

    redefineAll(C.prototype, IS_MAP ? {
      // 23.1.3.6 Map.prototype.get(key)
      get: function get(key) {
        var entry = getEntry(this, key);
        return entry && entry.value;
      },
      // 23.1.3.9 Map.prototype.set(key, value)
      set: function set(key, value) {
        return define(this, key === 0 ? 0 : key, value);
      }
    } : {
      // 23.2.3.1 Set.prototype.add(value)
      add: function add(value) {
        return define(this, value = value === 0 ? 0 : value, value);
      }
    });
    if (DESCRIPTORS) defineProperty(C.prototype, 'size', {
      get: function () {
        return getInternalState(this).size;
      }
    });
    return C;
  },
  setStrong: function (C, CONSTRUCTOR_NAME, IS_MAP) {
    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
    var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
    var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    defineIterator(C, CONSTRUCTOR_NAME, function (iterated, kind) {
      setInternalState(this, {
        type: ITERATOR_NAME,
        target: iterated,
        state: getInternalCollectionState(iterated),
        kind: kind,
        last: undefined
      });
    }, function () {
      var state = getInternalIteratorState(this);
      var kind = state.kind;
      var entry = state.last;
      // revert to the last existing entry
      while (entry && entry.removed) entry = entry.previous;
      // get next entry
      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
        // or finish the iteration
        state.target = undefined;
        return { value: undefined, done: true };
      }
      // return step by kind
      if (kind == 'keys') return { value: entry.key, done: false };
      if (kind == 'values') return { value: entry.value, done: false };
      return { value: [entry.key, entry.value], done: false };
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(CONSTRUCTOR_NAME);
  }
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getPrototypeOf = __webpack_require__(87);
var createNonEnumerableProperty = __webpack_require__(18);
var has = __webpack_require__(12);
var wellKnownSymbol = __webpack_require__(9);
var IS_PURE = __webpack_require__(41);

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

var returnThis = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

if (IteratorPrototype == undefined) IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if (!IS_PURE && !has(IteratorPrototype, ITERATOR)) {
  createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(12);
var toObject = __webpack_require__(140);
var sharedKey = __webpack_require__(40);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(141);

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.getprototypeof
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__(47);
var redefine = __webpack_require__(24);
var toString = __webpack_require__(143);

// `Object.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__(144).charAt;
var InternalStateModule = __webpack_require__(28);
var defineIterator = __webpack_require__(50);

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(7);
var DOMIterables = __webpack_require__(145);
var ArrayIteratorMethods = __webpack_require__(146);
var createNonEnumerableProperty = __webpack_require__(18);
var wellKnownSymbol = __webpack_require__(9);

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
}


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(23);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(93);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(53);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(174)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Helpers = exports.ScrollElement = exports.ScrollLink = exports.animateScroll = exports.scrollSpy = exports.Events = exports.scroller = exports.Element = exports.Button = exports.Link = undefined;

var _Link = __webpack_require__(189);

var _Link2 = _interopRequireDefault(_Link);

var _Button = __webpack_require__(193);

var _Button2 = _interopRequireDefault(_Button);

var _Element = __webpack_require__(194);

var _Element2 = _interopRequireDefault(_Element);

var _scroller = __webpack_require__(31);

var _scroller2 = _interopRequireDefault(_scroller);

var _scrollEvents = __webpack_require__(57);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

var _scrollSpy = __webpack_require__(55);

var _scrollSpy2 = _interopRequireDefault(_scrollSpy);

var _animateScroll = __webpack_require__(97);

var _animateScroll2 = _interopRequireDefault(_animateScroll);

var _scrollLink = __webpack_require__(54);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

var _scrollElement = __webpack_require__(99);

var _scrollElement2 = _interopRequireDefault(_scrollElement);

var _Helpers = __webpack_require__(195);

var _Helpers2 = _interopRequireDefault(_Helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Link = _Link2.default;
exports.Button = _Button2.default;
exports.Element = _Element2.default;
exports.scroller = _scroller2.default;
exports.Events = _scrollEvents2.default;
exports.scrollSpy = _scrollSpy2.default;
exports.animateScroll = _animateScroll2.default;
exports.ScrollLink = _scrollLink2.default;
exports.ScrollElement = _scrollElement2.default;
exports.Helpers = _Helpers2.default;
exports.default = { Link: _Link2.default, Button: _Button2.default, Element: _Element2.default, scroller: _scroller2.default, Events: _scrollEvents2.default, scrollSpy: _scrollSpy2.default, animateScroll: _animateScroll2.default, ScrollLink: _scrollLink2.default, ScrollElement: _scrollElement2.default, Helpers: _Helpers2.default };

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(32);

var _utils2 = _interopRequireDefault(_utils);

var _smooth = __webpack_require__(191);

var _smooth2 = _interopRequireDefault(_smooth);

var _cancelEvents = __webpack_require__(192);

var _cancelEvents2 = _interopRequireDefault(_cancelEvents);

var _scrollEvents = __webpack_require__(57);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Gets the easing type from the smooth prop within options.
 */
var getAnimationType = function getAnimationType(options) {
  return _smooth2.default[options.smooth] || _smooth2.default.defaultEasing;
};
/*
 * Function helper
 */
var functionWrapper = function functionWrapper(value) {
  return typeof value === 'function' ? value : function () {
    return value;
  };
};
/*
 * Wraps window properties to allow server side rendering
 */
var currentWindowProperties = function currentWindowProperties() {
  if (typeof window !== 'undefined') {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame;
  }
};

/*
 * Helper function to never extend 60fps on the webpage.
 */
var requestAnimationFrameHelper = function () {
  return currentWindowProperties() || function (callback, element, delay) {
    window.setTimeout(callback, delay || 1000 / 60, new Date().getTime());
  };
}();

var makeData = function makeData() {
  return {
    currentPositionY: 0,
    startPositionY: 0,
    targetPositionY: 0,
    progress: 0,
    duration: 0,
    cancel: false,

    target: null,
    containerElement: null,
    to: null,
    start: null,
    deltaTop: null,
    percent: null,
    delayTimeout: null
  };
};

var currentPositionY = function currentPositionY(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollTop;
  } else {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
  }
};

var scrollContainerHeight = function scrollContainerHeight(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollHeight - containerElement.offsetHeight;
  } else {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
  }
};

var animateScroll = function animateScroll(easing, options, timestamp) {
  var data = options.data;

  // Cancel on specific events
  if (!options.ignoreCancelEvents && data.cancel) {
    if (_scrollEvents2.default.registered['end']) {
      _scrollEvents2.default.registered['end'](data.to, data.target, data.currentPositionY);
    }
    return;
  };

  data.deltaTop = Math.round(data.targetPositionY - data.startPositionY);

  if (data.start === null) {
    data.start = timestamp;
  }

  data.progress = timestamp - data.start;

  data.percent = data.progress >= data.duration ? 1 : easing(data.progress / data.duration);

  data.currentPositionY = data.startPositionY + Math.ceil(data.deltaTop * data.percent);

  if (data.containerElement && data.containerElement !== document && data.containerElement !== document.body) {
    data.containerElement.scrollTop = data.currentPositionY;
  } else {
    window.scrollTo(0, data.currentPositionY);
  }

  if (data.percent < 1) {
    var easedAnimate = animateScroll.bind(null, easing, options);
    requestAnimationFrameHelper.call(window, easedAnimate);
    return;
  }

  if (_scrollEvents2.default.registered['end']) {
    _scrollEvents2.default.registered['end'](data.to, data.target, data.currentPositionY);
  }
};

var setContainer = function setContainer(options) {
  options.data.containerElement = !options ? null : options.containerId ? document.getElementById(options.containerId) : options.container && options.container.nodeType ? options.container : document;
};

var animateTopScroll = function animateTopScroll(y, options, to, target) {
  options.data = options.data || makeData();

  window.clearTimeout(options.data.delayTimeout);

  _cancelEvents2.default.subscribe(function () {
    options.data.cancel = true;
  });

  setContainer(options);

  options.data.start = null;
  options.data.cancel = false;
  options.data.startPositionY = currentPositionY(options);
  options.data.targetPositionY = options.absolute ? y : y + options.data.startPositionY;

  if (options.data.startPositionY === options.data.targetPositionY) {
    if (_scrollEvents2.default.registered['end']) {
      _scrollEvents2.default.registered['end'](options.data.to, options.data.target, options.data.currentPositionY);
    }
    return;
  }

  options.data.deltaTop = Math.round(options.data.targetPositionY - options.data.startPositionY);

  options.data.duration = functionWrapper(options.duration)(options.data.deltaTop);
  options.data.duration = isNaN(parseFloat(options.data.duration)) ? 1000 : parseFloat(options.data.duration);
  options.data.to = to;
  options.data.target = target;

  var easing = getAnimationType(options);
  var easedAnimate = animateScroll.bind(null, easing, options);

  if (options && options.delay > 0) {
    options.data.delayTimeout = window.setTimeout(function () {
      if (_scrollEvents2.default.registered['begin']) {
        _scrollEvents2.default.registered['begin'](options.data.to, options.data.target);
      }
      requestAnimationFrameHelper.call(window, easedAnimate);
    }, options.delay);
    return;
  }

  if (_scrollEvents2.default.registered['begin']) {
    _scrollEvents2.default.registered['begin'](options.data.to, options.data.target);
  }
  requestAnimationFrameHelper.call(window, easedAnimate);
};

var proceedOptions = function proceedOptions(options) {
  options = _extends({}, options);
  options.data = options.data || makeData();
  options.absolute = true;
  return options;
};

var scrollToTop = function scrollToTop(options) {
  animateTopScroll(0, proceedOptions(options));
};

var scrollTo = function scrollTo(toY, options) {
  animateTopScroll(toY, proceedOptions(options));
};

var scrollToBottom = function scrollToBottom(options) {
  options = proceedOptions(options);
  setContainer(options);
  animateTopScroll(scrollContainerHeight(options), options);
};

var scrollMore = function scrollMore(toY, options) {
  options = proceedOptions(options);
  setContainer(options);
  animateTopScroll(currentPositionY(options) + toY, options);
};

exports.default = {
  animateTopScroll: animateTopScroll,
  getAnimationType: getAnimationType,
  scrollToTop: scrollToTop,
  scrollToBottom: scrollToBottom,
  scrollTo: scrollTo,
  scrollMore: scrollMore
};

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _passiveEventListeners = __webpack_require__(56);

var _utils = __webpack_require__(32);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scrollHash = {
  mountFlag: false,
  initialized: false,
  scroller: null,
  containers: {},

  mount: function mount(scroller) {
    this.scroller = scroller;

    this.handleHashChange = this.handleHashChange.bind(this);
    window.addEventListener('hashchange', this.handleHashChange);

    this.initStateFromHash();
    this.mountFlag = true;
  },
  mapContainer: function mapContainer(to, container) {
    this.containers[to] = container;
  },
  isMounted: function isMounted() {
    return this.mountFlag;
  },
  isInitialized: function isInitialized() {
    return this.initialized;
  },
  initStateFromHash: function initStateFromHash() {
    var _this = this;

    var hash = this.getHash();
    if (hash) {
      window.setTimeout(function () {
        _this.scrollTo(hash, true);
        _this.initialized = true;
      }, 10);
    } else {
      this.initialized = true;
    }
  },
  scrollTo: function scrollTo(to, isInit) {
    var scroller = this.scroller;
    var element = scroller.get(to);
    if (element && (isInit || to !== scroller.getActiveLink())) {
      var container = this.containers[to] || document;
      scroller.scrollTo(to, { container: container });
    }
  },
  getHash: function getHash() {
    return _utils2.default.getHash();
  },
  changeHash: function changeHash(to) {
    if (this.isInitialized() && _utils2.default.getHash() !== to) {
      _utils2.default.pushHash(to);
    }
  },
  handleHashChange: function handleHashChange() {
    this.scrollTo(this.getHash());
  },
  unmount: function unmount() {
    this.scroller = null;
    this.containers = null;
    window.removeEventListener('hashchange', this.handleHashChange);
  }
};

exports.default = scrollHash;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(22);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _scroller = __webpack_require__(31);

var _scroller2 = _interopRequireDefault(_scroller);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = function (Component) {
  var Element = function (_React$Component) {
    _inherits(Element, _React$Component);

    function Element(props) {
      _classCallCheck(this, Element);

      var _this = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));

      _this.childBindings = {
        domNode: null
      };
      return _this;
    }

    _createClass(Element, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (typeof window === 'undefined') {
          return false;
        }
        this.registerElems(this.props.name);
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
          this.registerElems(this.props.name);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (typeof window === 'undefined') {
          return false;
        }
        _scroller2.default.unregister(this.props.name);
      }
    }, {
      key: 'registerElems',
      value: function registerElems(name) {
        _scroller2.default.register(name, this.childBindings.domNode);
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Component, _extends({}, this.props, { parentBindings: this.childBindings }));
      }
    }]);

    return Element;
  }(_react2.default.Component);

  ;

  Element.propTypes = {
    name: _propTypes2.default.string,
    id: _propTypes2.default.string
  };

  return Element;
};

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);
var settle = __webpack_require__(200);
var buildURL = __webpack_require__(202);
var parseHeaders = __webpack_require__(203);
var isURLSameOrigin = __webpack_require__(204);
var createError = __webpack_require__(102);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(205);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(201);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 105 */
/***/ (function(module, exports) {

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction(target) {
    return typeof target === 'function';
}

module.exports = {
    isFunction : isFunction,
    isArray : isArray,
    each : each
};


/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DealItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UI_UI__ = __webpack_require__(2);
var DealItem=function DealItem(props){var callToActionText=props.callToActionText!==undefined?props.callToActionText:'BUCHEN SIE JETZT';var cssClass=props.cssClass!==undefined?props.cssClass:'';var isReminder=props.isReminder!==undefined?props.isReminder:'';var job=props.job!==undefined?props.job:'';var new_day=new Date();// alert(new_day);
var corrent_month=new_day.getMonth();// alert(corrent_month);
var chinise_blackfriday=new_day.getDate();var world_blackfriday=new_day.getDate();var blackfriday_friday_html='';if((chinise_blackfriday===11||world_blackfriday===29)&&corrent_month===10){blackfriday_friday_html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-black-friday'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'https://en.citiesbreak.com/twocities/assets/img/sale.png',className:'img-responsive',alt:'sale'}));}var jobHTML=null;if(job!==''){jobHTML=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'job-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'(',job,')');}var html=null;if(isReminder){html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"deal-item "+cssClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank','data-agent':props.brand,href:props.bookNowLink},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'brand-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,props.brand)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'deal-img-desc-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'deal-desc-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:props.descFontSize},Object(__WEBPACK_IMPORTED_MODULE_1__Utility_Utility__["i" /* limitText */])(props.desc,100))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'deal-img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UI_UI__["j" /* Img */],{desktopImg:props.brandImg}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'price-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,props.price,jobHTML)))));}else{html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"deal-item "+cssClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',href:props.bookNowLink},blackfriday_friday_html,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'brand-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,props.brand)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'price-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'small'},'Ab'),' ',props.price,jobHTML)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'deal-img-desc-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'deal-desc-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:props.descFontSize},Object(__WEBPACK_IMPORTED_MODULE_1__Utility_Utility__["i" /* limitText */])(props.desc,100))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'deal-img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UI_UI__["j" /* Img */],{desktopImg:props.brandImg}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'book-now-wrapper'},callToActionText,' ','>'))));}return html;};

/***/ }),
/* 107 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(109);
module.exports = __webpack_require__(114);


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(110).enable();
  window.Promise = __webpack_require__(112);
}

// fetch() polyfill for making API calls.
__webpack_require__(113);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(36);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(64);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(64);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 113 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_es_map__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_es_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_es_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_es_set__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_es_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_es_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raf_polyfill__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raf_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_raf_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_css__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ie_css__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ie_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ie_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ff_css__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ff_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ff_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fonts_fonts_css__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fonts_fonts_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__fonts_fonts_css__);
// import registerServiceWorker from './registerServiceWorker';
window.matchMedia=window.matchMedia||function(){return{matches:false,addListener:function addListener(){},removeListener:function removeListener(){}};};// const browserHistory = {};
var basename="/";// const basename = "/";
__WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["a" /* BrowserRouter */],{basename:basename,forceRefresh:true},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__App__["a" /* default */],null)),document.getElementById('root'));// registerServiceWorker();

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(116);
__webpack_require__(88);
__webpack_require__(89);
__webpack_require__(90);
var path = __webpack_require__(44);

module.exports = path.Map;


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var collection = __webpack_require__(65);
var collectionStrong = __webpack_require__(85);

// `Map` constructor
// https://tc39.github.io/ecma262/#sec-map-objects
module.exports = collection('Map', function (init) {
  return function Map() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(13);
var classof = __webpack_require__(68);

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(7);
var inspectSource = __webpack_require__(72);

var WeakMap = global.WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(12);
var ownKeys = __webpack_require__(121);
var getOwnPropertyDescriptorModule = __webpack_require__(67);
var definePropertyModule = __webpack_require__(15);

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(43);
var getOwnPropertyNamesModule = __webpack_require__(122);
var getOwnPropertySymbolsModule = __webpack_require__(125);
var anObject = __webpack_require__(19);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(75);
var enumBugKeys = __webpack_require__(46);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertynames
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__(27);
var toLength = __webpack_require__(76);
var toAbsoluteIndex = __webpack_require__(124);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(45);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),
/* 125 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(13);

module.exports = !fails(function () {
  return Object.isExtensible(Object.preventExtensions({}));
});


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(9);
var Iterators = __webpack_require__(25);

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_SYMBOL = __webpack_require__(80);

module.exports = NATIVE_SYMBOL
  // eslint-disable-next-line no-undef
  && !Symbol.sham
  // eslint-disable-next-line no-undef
  && typeof Symbol.iterator == 'symbol';


/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(82);
var Iterators = __webpack_require__(25);
var wellKnownSymbol = __webpack_require__(9);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(19);

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (error) {
    var returnMethod = iterator['return'];
    if (returnMethod !== undefined) anObject(returnMethod.call(iterator));
    throw error;
  }
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(9);

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);
var setPrototypeOf = __webpack_require__(84);

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    typeof (NewTarget = dummy.constructor) == 'function' &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);

module.exports = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(17);
var definePropertyModule = __webpack_require__(15);
var anObject = __webpack_require__(19);
var objectKeys = __webpack_require__(136);

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(75);
var enumBugKeys = __webpack_require__(46);

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(43);

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(24);

module.exports = function (target, src, options) {
  for (var key in src) redefine(target, key, src[key], options);
  return target;
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__(86).IteratorPrototype;
var create = __webpack_require__(49);
var createPropertyDescriptor = __webpack_require__(37);
var setToStringTag = __webpack_require__(48);
var Iterators = __webpack_require__(25);

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(38);

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(13);

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(43);
var definePropertyModule = __webpack_require__(15);
var wellKnownSymbol = __webpack_require__(9);
var DESCRIPTORS = __webpack_require__(17);

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineProperty(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(47);
var classof = __webpack_require__(82);

// `Object.prototype.toString` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(45);
var requireObjectCoercible = __webpack_require__(38);

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),
/* 145 */
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(27);
var addToUnscopables = __webpack_require__(147);
var Iterators = __webpack_require__(25);
var InternalStateModule = __webpack_require__(28);
var defineIterator = __webpack_require__(50);

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.github.io/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.github.io/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.github.io/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.github.io/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
// https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(9);
var create = __webpack_require__(49);
var definePropertyModule = __webpack_require__(15);

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(149);
__webpack_require__(88);
__webpack_require__(89);
__webpack_require__(90);
var path = __webpack_require__(44);

module.exports = path.Set;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var collection = __webpack_require__(65);
var collectionStrong = __webpack_require__(85);

// `Set` constructor
// https://tc39.github.io/ecma262/#sec-set-objects
module.exports = collection('Set', function (init) {
  return function Set() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(151).polyfill()


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(152)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)))

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.12.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var h=__webpack_require__(36),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113;n&&Symbol.for("react.suspense_list");
var z=n?Symbol.for("react.memo"):60115,aa=n?Symbol.for("react.lazy"):60116;n&&Symbol.for("react.fundamental");n&&Symbol.for("react.responder");n&&Symbol.for("react.scope");var A="function"===typeof Symbol&&Symbol.iterator;
function B(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
function E(a,b,c){this.props=a;this.context=b;this.refs=D;this.updater=c||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(B(85));this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,c){this.props=a;this.context=b;this.refs=D;this.updater=c||C}var H=G.prototype=new F;
H.constructor=G;h(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,l=null;if(null!=b)for(e in void 0!==b.ref&&(l=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var k=Array(f),m=0;m<f;m++)k[m]=arguments[m+2];d.children=k}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:l,props:d,_owner:J.current}}
function ba(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,c,e){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var l=0;l<a.length;l++){d=a[l];var f=b+T(d,l);g+=S(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),l=
0;!(d=a.next()).done;)d=d.value,f=b+T(d,l++),g+=S(d,f,c,e);else if("object"===d)throw c=""+a,Error(B(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function U(a,b,c){return null==a?0:S(a,"",b,c)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ca(a,b){a.func.call(a.context,b,a.count++)}
function da(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,e,c,function(a){return a}):null!=a&&(N(a)&&(a=ba(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+c)),e.push(a))}function V(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(O,"$&/")+"/");b=Q(b,g,e,d);U(a,da,b);R(b)}function W(){var a=I.current;if(null===a)throw Error(B(321));return a}
var X={Children:{map:function(a,b,c){if(null==a)return a;var e=[];V(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=Q(null,null,b,c);U(a,ca,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){if(!N(a))throw Error(B(143));return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:x,render:a}},lazy:function(a){return{$$typeof:aa,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
b,c){return W().useImperativeHandle(a,b,c)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,c){return W().useReducer(a,b,c)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,Profiler:u,StrictMode:t,Suspense:y,createElement:M,cloneElement:function(a,b,c){if(null===a||void 0===a)throw Error(B(267,a));var e=h({},a.props),d=a.key,g=a.ref,l=a._owner;
if(null!=b){void 0!==b.ref&&(g=b.ref,l=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(k in b)K.call(b,k)&&!L.hasOwnProperty(k)&&(e[k]=void 0===b[k]&&void 0!==f?f[k]:b[k])}var k=arguments.length-2;if(1===k)e.children=c;else if(1<k){f=Array(k);for(var m=0;m<k;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,key:d,ref:g,props:e,_owner:l}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.12.0",
__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:I,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:h}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.12.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(36),q=__webpack_require__(155);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));var ba=null,ca={};
function da(){if(ba)for(var a in ca){var b=ca[a],c=ba.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!ea[c]){if(!b.extractEvents)throw Error(u(97,a));ea[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(fa.hasOwnProperty(h))throw Error(u(99,h));fa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ha(k[e],g,h);e=!0}else f.registrationName?(ha(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ha(a,b,c){if(ia[a])throw Error(u(100,a));ia[a]=b;ja[a]=b.eventTypes[c].dependencies}var ea=[],fa={},ia={},ja={};function ka(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var la=!1,ma=null,na=!1,oa=null,pa={onError:function(a){la=!0;ma=a}};function qa(a,b,c,d,e,f,g,h,k){la=!1;ma=null;ka.apply(pa,arguments)}
function ra(a,b,c,d,e,f,g,h,k){qa.apply(this,arguments);if(la){if(la){var l=ma;la=!1;ma=null}else throw Error(u(198));na||(na=!0,oa=l)}}var sa=null,ua=null,va=null;function wa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=va(c);ra(d,b,void 0,a);a.currentTarget=null}function xa(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function ya(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var za=null;function Aa(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)wa(a,b[d],c[d]);else b&&wa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ba(a){null!==a&&(za=xa(za,a));a=za;za=null;if(a){ya(a,Aa);if(za)throw Error(u(95));if(na)throw a=oa,na=!1,oa=null,a;}}
var Ca={injectEventPluginOrder:function(a){if(ba)throw Error(u(101));ba=Array.prototype.slice.call(a);da()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!ca.hasOwnProperty(c)||ca[c]!==d){if(ca[c])throw Error(u(102,c));ca[c]=d;b=!0}}b&&da()}};
function Da(a,b){var c=a.stateNode;if(!c)return null;var d=sa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,b,typeof c));
return c}var Ea=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Ea.hasOwnProperty("ReactCurrentDispatcher")||(Ea.ReactCurrentDispatcher={current:null});Ea.hasOwnProperty("ReactCurrentBatchConfig")||(Ea.ReactCurrentBatchConfig={suspense:null});
var Fa=/^(.*)[\\\/]/,w="function"===typeof Symbol&&Symbol.for,Ga=w?Symbol.for("react.element"):60103,Ha=w?Symbol.for("react.portal"):60106,Ia=w?Symbol.for("react.fragment"):60107,Ja=w?Symbol.for("react.strict_mode"):60108,Ka=w?Symbol.for("react.profiler"):60114,La=w?Symbol.for("react.provider"):60109,Ma=w?Symbol.for("react.context"):60110,Na=w?Symbol.for("react.concurrent_mode"):60111,Oa=w?Symbol.for("react.forward_ref"):60112,Pa=w?Symbol.for("react.suspense"):60113,Qa=w?Symbol.for("react.suspense_list"):
60120,Ra=w?Symbol.for("react.memo"):60115,Sa=w?Symbol.for("react.lazy"):60116;w&&Symbol.for("react.fundamental");w&&Symbol.for("react.responder");w&&Symbol.for("react.scope");var Ta="function"===typeof Symbol&&Symbol.iterator;function Ua(a){if(null===a||"object"!==typeof a)return null;a=Ta&&a[Ta]||a["@@iterator"];return"function"===typeof a?a:null}
function Va(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function Wa(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case Ia:return"Fragment";case Ha:return"Portal";case Ka:return"Profiler";case Ja:return"StrictMode";case Pa:return"Suspense";case Qa:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case Ma:return"Context.Consumer";case La:return"Context.Provider";case Oa:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case Ra:return Wa(a.type);case Sa:if(a=1===a._status?a._result:null)return Wa(a)}return null}function Xa(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=Wa(a.type);c=null;d&&(c=Wa(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Fa,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
var Ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),Za=null,$a=null,ab=null;function bb(a){if(a=ua(a)){if("function"!==typeof Za)throw Error(u(280));var b=sa(a.stateNode);Za(a.stateNode,a.type,b)}}function cb(a){$a?ab?ab.push(a):ab=[a]:$a=a}function db(){if($a){var a=$a,b=ab;ab=$a=null;bb(a);if(b)for(a=0;a<b.length;a++)bb(b[a])}}function eb(a,b){return a(b)}function fb(a,b,c,d){return a(b,c,d)}function gb(){}
var hb=eb,ib=!1,jb=!1;function kb(){if(null!==$a||null!==ab)gb(),db()}new Map;var lb=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,mb=Object.prototype.hasOwnProperty,nb={},ob={};
function pb(a){if(mb.call(ob,a))return!0;if(mb.call(nb,a))return!1;if(lb.test(a))return ob[a]=!0;nb[a]=!0;return!1}function qb(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function rb(a,b,c,d){if(null===b||"undefined"===typeof b||qb(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function B(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var D={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new B(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new B(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new B(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new B(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new B(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){D[a]=new B(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){D[a]=new B(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){D[a]=new B(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){D[a]=new B(a,5,!1,a.toLowerCase(),null,!1)});var sb=/[\-:]([a-z])/g;function tb(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(sb,
tb);D[b]=new B(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(sb,tb);D[b]=new B(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(sb,tb);D[b]=new B(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!1)});
D.xlinkHref=new B("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!0)});function ub(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}
function vb(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(rb(b,c,e,d)&&(c=null),d||null===e?pb(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function wb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function xb(a){var b=wb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function yb(a){a._valueTracker||(a._valueTracker=xb(a))}function zb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=wb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function Ab(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Bb(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=ub(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Cb(a,b){b=b.checked;null!=b&&vb(a,"checked",b,!1)}
function Eb(a,b){Cb(a,b);var c=ub(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Fb(a,b.type,c):b.hasOwnProperty("defaultValue")&&Fb(a,b.type,ub(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Gb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Fb(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Hb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Ib(a,b){a=n({children:void 0},b);if(b=Hb(b.children))a.children=b;return a}
function Jb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+ub(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Kb(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Lb(a,b){var c=b.value;if(null==c){c=b.defaultValue;b=b.children;if(null!=b){if(null!=c)throw Error(u(92));if(Array.isArray(b)){if(!(1>=b.length))throw Error(u(93));b=b[0]}c=b}null==c&&(c="")}a._wrapperState={initialValue:ub(c)}}
function Mb(a,b){var c=ub(b.value),d=ub(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Nb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Ob={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Pb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Qb(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Pb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Rb,Sb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Ob.svg||"innerHTML"in a)a.innerHTML=b;else{Rb=Rb||document.createElement("div");Rb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Rb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Tb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Ub(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Vb={animationend:Ub("Animation","AnimationEnd"),animationiteration:Ub("Animation","AnimationIteration"),animationstart:Ub("Animation","AnimationStart"),transitionend:Ub("Transition","TransitionEnd")},Wb={},Xb={};
Ya&&(Xb=document.createElement("div").style,"AnimationEvent"in window||(delete Vb.animationend.animation,delete Vb.animationiteration.animation,delete Vb.animationstart.animation),"TransitionEvent"in window||delete Vb.transitionend.transition);function Yb(a){if(Wb[a])return Wb[a];if(!Vb[a])return a;var b=Vb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Xb)return Wb[a]=b[c];return a}var Zb=Yb("animationend"),$b=Yb("animationiteration"),ac=Yb("animationstart"),bc=Yb("transitionend"),cc="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" ");
function ec(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function fc(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function gc(a){if(ec(a)!==a)throw Error(u(188));}
function hc(a){var b=a.alternate;if(!b){b=ec(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return gc(e),a;if(f===d)return gc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function ic(a){a=hc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var jc,kc,lc,mc=!1,nc=[],oc=null,pc=null,qc=null,rc=new Map,sc=new Map,tc=[],uc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),vc="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function wc(a){var b=xc(a);uc.forEach(function(c){yc(c,a,b)});vc.forEach(function(c){yc(c,a,b)})}function zc(a,b,c,d){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:d}}function Ac(a,b){switch(a){case "focus":case "blur":oc=null;break;case "dragenter":case "dragleave":pc=null;break;case "mouseover":case "mouseout":qc=null;break;case "pointerover":case "pointerout":rc.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":sc.delete(b.pointerId)}}
function Bc(a,b,c,d,e){if(null===a||a.nativeEvent!==e)return a=zc(b,c,d,e),null!==b&&(b=Cc(b),null!==b&&kc(b)),a;a.eventSystemFlags|=d;return a}function Dc(a,b,c,d){switch(b){case "focus":return oc=Bc(oc,a,b,c,d),!0;case "dragenter":return pc=Bc(pc,a,b,c,d),!0;case "mouseover":return qc=Bc(qc,a,b,c,d),!0;case "pointerover":var e=d.pointerId;rc.set(e,Bc(rc.get(e)||null,a,b,c,d));return!0;case "gotpointercapture":return e=d.pointerId,sc.set(e,Bc(sc.get(e)||null,a,b,c,d)),!0}return!1}
function Ec(a){var b=Fc(a.target);if(null!==b){var c=ec(b);if(null!==c)if(b=c.tag,13===b){if(b=fc(c),null!==b){a.blockedOn=b;q.unstable_runWithPriority(a.priority,function(){lc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Gc(a){if(null!==a.blockedOn)return!1;var b=Hc(a.topLevelType,a.eventSystemFlags,a.nativeEvent);if(null!==b){var c=Cc(b);null!==c&&kc(c);a.blockedOn=b;return!1}return!0}
function Ic(a,b,c){Gc(a)&&c.delete(b)}function Jc(){for(mc=!1;0<nc.length;){var a=nc[0];if(null!==a.blockedOn){a=Cc(a.blockedOn);null!==a&&jc(a);break}var b=Hc(a.topLevelType,a.eventSystemFlags,a.nativeEvent);null!==b?a.blockedOn=b:nc.shift()}null!==oc&&Gc(oc)&&(oc=null);null!==pc&&Gc(pc)&&(pc=null);null!==qc&&Gc(qc)&&(qc=null);rc.forEach(Ic);sc.forEach(Ic)}function Kc(a,b){a.blockedOn===b&&(a.blockedOn=null,mc||(mc=!0,q.unstable_scheduleCallback(q.unstable_NormalPriority,Jc)))}
function Lc(a){function b(b){return Kc(b,a)}if(0<nc.length){Kc(nc[0],a);for(var c=1;c<nc.length;c++){var d=nc[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==oc&&Kc(oc,a);null!==pc&&Kc(pc,a);null!==qc&&Kc(qc,a);rc.forEach(b);sc.forEach(b);for(c=0;c<tc.length;c++)d=tc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<tc.length&&(c=tc[0],null===c.blockedOn);)Ec(c),null===c.blockedOn&&tc.shift()}
function Mc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Nc(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Oc(a,b,c){if(b=Da(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a)}
function Pc(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Nc(b);for(b=c.length;0<b--;)Oc(c[b],"captured",a);for(b=0;b<c.length;b++)Oc(c[b],"bubbled",a)}}function Qc(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Da(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a))}function Rc(a){a&&a.dispatchConfig.registrationName&&Qc(a._targetInst,null,a)}
function Sc(a){ya(a,Pc)}function Tc(){return!0}function Uc(){return!1}function E(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?Tc:Uc;this.isPropagationStopped=Uc;return this}
n(E.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=Tc)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=Tc)},persist:function(){this.isPersistent=Tc},isPersistent:Uc,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=Uc;this._dispatchInstances=this._dispatchListeners=null}});E.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
E.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;Vc(c);return c};Vc(E);function Wc(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function Xc(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Vc(a){a.eventPool=[];a.getPooled=Wc;a.release=Xc}var Yc=E.extend({animationName:null,elapsedTime:null,pseudoElement:null}),Zc=E.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),$c=E.extend({view:null,detail:null}),ad=$c.extend({relatedTarget:null});
function bd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var cd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},dd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},ed={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function gd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=ed[a])?!!b[a]:!1}function hd(){return gd}
var id=$c.extend({key:function(a){if(a.key){var b=cd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=bd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?dd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:hd,charCode:function(a){return"keypress"===a.type?bd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?bd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),jd=0,kd=0,ld=!1,md=!1,nd=$c.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:hd,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=jd;jd=a.screenX;return ld?"mousemove"===a.type?a.screenX-
b:0:(ld=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;var b=kd;kd=a.screenY;return md?"mousemove"===a.type?a.screenY-b:0:(md=!0,0)}}),od=nd.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),pd=nd.extend({dataTransfer:null}),qd=$c.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:hd}),rd=E.extend({propertyName:null,
elapsedTime:null,pseudoElement:null}),sd=nd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),td=[["blur","blur",0],["cancel","cancel",0],["click","click",0],["close","close",0],["contextmenu","contextMenu",0],["copy","copy",0],["cut","cut",0],["auxclick","auxClick",0],["dblclick","doubleClick",0],["dragend","dragEnd",
0],["dragstart","dragStart",0],["drop","drop",0],["focus","focus",0],["input","input",0],["invalid","invalid",0],["keydown","keyDown",0],["keypress","keyPress",0],["keyup","keyUp",0],["mousedown","mouseDown",0],["mouseup","mouseUp",0],["paste","paste",0],["pause","pause",0],["play","play",0],["pointercancel","pointerCancel",0],["pointerdown","pointerDown",0],["pointerup","pointerUp",0],["ratechange","rateChange",0],["reset","reset",0],["seeked","seeked",0],["submit","submit",0],["touchcancel","touchCancel",
0],["touchend","touchEnd",0],["touchstart","touchStart",0],["volumechange","volumeChange",0],["drag","drag",1],["dragenter","dragEnter",1],["dragexit","dragExit",1],["dragleave","dragLeave",1],["dragover","dragOver",1],["mousemove","mouseMove",1],["mouseout","mouseOut",1],["mouseover","mouseOver",1],["pointermove","pointerMove",1],["pointerout","pointerOut",1],["pointerover","pointerOver",1],["scroll","scroll",1],["toggle","toggle",1],["touchmove","touchMove",1],["wheel","wheel",1],["abort","abort",
2],[Zb,"animationEnd",2],[$b,"animationIteration",2],[ac,"animationStart",2],["canplay","canPlay",2],["canplaythrough","canPlayThrough",2],["durationchange","durationChange",2],["emptied","emptied",2],["encrypted","encrypted",2],["ended","ended",2],["error","error",2],["gotpointercapture","gotPointerCapture",2],["load","load",2],["loadeddata","loadedData",2],["loadedmetadata","loadedMetadata",2],["loadstart","loadStart",2],["lostpointercapture","lostPointerCapture",2],["playing","playing",2],["progress",
"progress",2],["seeking","seeking",2],["stalled","stalled",2],["suspend","suspend",2],["timeupdate","timeUpdate",2],[bc,"transitionEnd",2],["waiting","waiting",2]],ud={},vd={},wd=0;for(;wd<td.length;wd++){var yd=td[wd],zd=yd[0],Ad=yd[1],Bd=yd[2],Cd="on"+(Ad[0].toUpperCase()+Ad.slice(1)),Dd={phasedRegistrationNames:{bubbled:Cd,captured:Cd+"Capture"},dependencies:[zd],eventPriority:Bd};ud[Ad]=Dd;vd[zd]=Dd}
var Ed={eventTypes:ud,getEventPriority:function(a){a=vd[a];return void 0!==a?a.eventPriority:2},extractEvents:function(a,b,c,d){var e=vd[a];if(!e)return null;switch(a){case "keypress":if(0===bd(c))return null;case "keydown":case "keyup":a=id;break;case "blur":case "focus":a=ad;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=nd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
pd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=qd;break;case Zb:case $b:case ac:a=Yc;break;case bc:a=rd;break;case "scroll":a=$c;break;case "wheel":a=sd;break;case "copy":case "cut":case "paste":a=Zc;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=od;break;default:a=E}b=a.getPooled(e,b,c,d);Sc(b);return b}},Fd=q.unstable_UserBlockingPriority,
Gd=q.unstable_runWithPriority,Hd=Ed.getEventPriority,Id=10,Jd=[];
function Kd(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=Fc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Mc(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=a.eventSystemFlags,h=null,k=0;k<ea.length;k++){var l=ea[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=xa(h,l))}Ba(h)}}
var Ld=!0;function F(a,b){Md(b,a,!1)}function Md(a,b,c){switch(Hd(b)){case 0:var d=Nd.bind(null,b,1);break;case 1:d=Od.bind(null,b,1);break;default:d=Pd.bind(null,b,1)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function Nd(a,b,c){ib||gb();var d=Pd,e=ib;ib=!0;try{fb(d,a,b,c)}finally{(ib=e)||kb()}}function Od(a,b,c){Gd(Fd,Pd.bind(null,a,b,c))}
function Qd(a,b,c,d){if(Jd.length){var e=Jd.pop();e.topLevelType=a;e.eventSystemFlags=b;e.nativeEvent=c;e.targetInst=d;a=e}else a={topLevelType:a,eventSystemFlags:b,nativeEvent:c,targetInst:d,ancestors:[]};try{if(b=Kd,c=a,jb)b(c,void 0);else{jb=!0;try{hb(b,c,void 0)}finally{jb=!1,kb()}}}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,Jd.length<Id&&Jd.push(a)}}
function Pd(a,b,c){if(Ld)if(0<nc.length&&-1<uc.indexOf(a))a=zc(null,a,b,c),nc.push(a);else{var d=Hc(a,b,c);null===d?Ac(a,c):-1<uc.indexOf(a)?(a=zc(d,a,b,c),nc.push(a)):Dc(d,a,b,c)||(Ac(a,c),Qd(a,b,c,null))}}function Hc(a,b,c){var d=Mc(c);d=Fc(d);if(null!==d){var e=ec(d);if(null===e)d=null;else{var f=e.tag;if(13===f){d=fc(e);if(null!==d)return d;d=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;d=null}else e!==d&&(d=null)}}Qd(a,b,c,d);return null}
function Rd(a){if(!Ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var Sd=new ("function"===typeof WeakMap?WeakMap:Map);function xc(a){var b=Sd.get(a);void 0===b&&(b=new Set,Sd.set(a,b));return b}
function yc(a,b,c){if(!c.has(a)){switch(a){case "scroll":Md(b,"scroll",!0);break;case "focus":case "blur":Md(b,"focus",!0);Md(b,"blur",!0);c.add("blur");c.add("focus");break;case "cancel":case "close":Rd(a)&&Md(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===cc.indexOf(a)&&F(a,b)}c.add(a)}}
var Td={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Ud=["Webkit","ms","Moz","O"];Object.keys(Td).forEach(function(a){Ud.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Td[b]=Td[a]})});function Vd(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||Td.hasOwnProperty(a)&&Td[a]?(""+b).trim():b+"px"}
function Wd(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=Vd(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Xd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Yd(a,b){if(b){if(Xd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function Zd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}function $d(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=xc(a);b=ja[b];for(var d=0;d<b.length;d++)yc(b[d],a,c)}function ae(){}
function be(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ce(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function de(a,b){var c=ce(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ce(c)}}
function ee(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?ee(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function fe(){for(var a=window,b=be();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=be(a.document)}return b}
function ge(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var he="$",ie="/$",je="$?",ke="$!",le=null,me=null;function ne(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function oe(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var pe="function"===typeof setTimeout?setTimeout:void 0,qe="function"===typeof clearTimeout?clearTimeout:void 0;function re(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function se(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===he||c===ke||c===je){if(0===b)return a;b--}else c===ie&&b++}a=a.previousSibling}return null}var te=Math.random().toString(36).slice(2),ue="__reactInternalInstance$"+te,ve="__reactEventHandlers$"+te,we="__reactContainere$"+te;
function Fc(a){var b=a[ue];if(b)return b;for(var c=a.parentNode;c;){if(b=c[we]||c[ue]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=se(a);null!==a;){if(c=a[ue])return c;a=se(a)}return b}a=c;c=a.parentNode}return null}function Cc(a){a=a[ue]||a[we];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function xe(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function ye(a){return a[ve]||null}var ze=null,Ae=null,Be=null;
function Ce(){if(Be)return Be;var a,b=Ae,c=b.length,d,e="value"in ze?ze.value:ze.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return Be=e.slice(a,1<d?1-d:void 0)}var De=E.extend({data:null}),Ee=E.extend({data:null}),Fe=[9,13,27,32],Ge=Ya&&"CompositionEvent"in window,He=null;Ya&&"documentMode"in document&&(He=document.documentMode);
var Ie=Ya&&"TextEvent"in window&&!He,Je=Ya&&(!Ge||He&&8<He&&11>=He),Ke=String.fromCharCode(32),Le={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Me=!1;
function Ne(a,b){switch(a){case "keyup":return-1!==Fe.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Oe(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Pe=!1;function Qe(a,b){switch(a){case "compositionend":return Oe(b);case "keypress":if(32!==b.which)return null;Me=!0;return Ke;case "textInput":return a=b.data,a===Ke&&Me?null:a;default:return null}}
function Re(a,b){if(Pe)return"compositionend"===a||!Ge&&Ne(a,b)?(a=Ce(),Be=Ae=ze=null,Pe=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return Je&&"ko"!==b.locale?null:b.data;default:return null}}
var Se={eventTypes:Le,extractEvents:function(a,b,c,d){var e;if(Ge)b:{switch(a){case "compositionstart":var f=Le.compositionStart;break b;case "compositionend":f=Le.compositionEnd;break b;case "compositionupdate":f=Le.compositionUpdate;break b}f=void 0}else Pe?Ne(a,c)&&(f=Le.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=Le.compositionStart);f?(Je&&"ko"!==c.locale&&(Pe||f!==Le.compositionStart?f===Le.compositionEnd&&Pe&&(e=Ce()):(ze=d,Ae="value"in ze?ze.value:ze.textContent,Pe=!0)),f=De.getPooled(f,
b,c,d),e?f.data=e:(e=Oe(c),null!==e&&(f.data=e)),Sc(f),e=f):e=null;(a=Ie?Qe(a,c):Re(a,c))?(b=Ee.getPooled(Le.beforeInput,b,c,d),b.data=a,Sc(b)):b=null;return null===e?b:null===b?e:[e,b]}},Te={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Ue(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Te[a.type]:"textarea"===b?!0:!1}
var Ve={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function We(a,b,c){a=E.getPooled(Ve.change,a,b,c);a.type="change";cb(c);Sc(a);return a}var Xe=null,Ye=null;function Ze(a){Ba(a)}function $e(a){var b=xe(a);if(zb(b))return a}function af(a,b){if("change"===a)return b}var bf=!1;Ya&&(bf=Rd("input")&&(!document.documentMode||9<document.documentMode));
function cf(){Xe&&(Xe.detachEvent("onpropertychange",df),Ye=Xe=null)}function df(a){if("value"===a.propertyName&&$e(Ye))if(a=We(Ye,a,Mc(a)),ib)Ba(a);else{ib=!0;try{eb(Ze,a)}finally{ib=!1,kb()}}}function ef(a,b,c){"focus"===a?(cf(),Xe=b,Ye=c,Xe.attachEvent("onpropertychange",df)):"blur"===a&&cf()}function ff(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return $e(Ye)}function gf(a,b){if("click"===a)return $e(b)}function hf(a,b){if("input"===a||"change"===a)return $e(b)}
var jf={eventTypes:Ve,_isInputEventSupported:bf,extractEvents:function(a,b,c,d){var e=b?xe(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=af;else if(Ue(e))if(bf)g=hf;else{g=ff;var h=ef}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=gf);if(g&&(g=g(a,b)))return We(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Fb(e,"number",e.value)}},kf={mouseEnter:{registrationName:"onMouseEnter",
dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},lf,mf={eventTypes:kf,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;
e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?Fc(b):null,null!==b&&(f=ec(b),b!==f||5!==b.tag&&6!==b.tag))b=null}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===a){var h=nd;var k=kf.mouseLeave;var l=kf.mouseEnter;var m="mouse"}else if("pointerout"===a||"pointerover"===a)h=od,k=kf.pointerLeave,l=kf.pointerEnter,m="pointer";a=null==g?e:xe(g);e=null==b?e:xe(b);k=h.getPooled(k,g,c,d);k.type=m+"leave";k.target=
a;k.relatedTarget=e;d=h.getPooled(l,b,c,d);d.type=m+"enter";d.target=e;d.relatedTarget=a;h=g;m=b;if(h&&m)a:{l=h;a=m;g=0;for(b=l;b;b=Nc(b))g++;b=0;for(e=a;e;e=Nc(e))b++;for(;0<g-b;)l=Nc(l),g--;for(;0<b-g;)a=Nc(a),b--;for(;g--;){if(l===a||l===a.alternate)break a;l=Nc(l);a=Nc(a)}l=null}else l=null;a=l;for(l=[];h&&h!==a;){g=h.alternate;if(null!==g&&g===a)break;l.push(h);h=Nc(h)}for(h=[];m&&m!==a;){g=m.alternate;if(null!==g&&g===a)break;h.push(m);m=Nc(m)}for(m=0;m<l.length;m++)Qc(l[m],"bubbled",k);for(m=
h.length;0<m--;)Qc(h[m],"captured",d);if(c===lf)return lf=null,[k];lf=c;return[k,d]}};function nf(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var of="function"===typeof Object.is?Object.is:nf,pf=Object.prototype.hasOwnProperty;function qf(a,b){if(of(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!pf.call(b,c[d])||!of(a[c[d]],b[c[d]]))return!1;return!0}
var rf=Ya&&"documentMode"in document&&11>=document.documentMode,sf={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},tf=null,uf=null,vf=null,wf=!1;
function xf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(wf||null==tf||tf!==be(c))return null;c=tf;"selectionStart"in c&&ge(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return vf&&qf(vf,c)?null:(vf=c,a=E.getPooled(sf.select,uf,a,b),a.type="select",a.target=tf,Sc(a),a)}
var yf={eventTypes:sf,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=xc(e);f=ja.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?xe(b):window;switch(a){case "focus":if(Ue(e)||"true"===e.contentEditable)tf=e,uf=b,vf=null;break;case "blur":vf=uf=tf=null;break;case "mousedown":wf=!0;break;case "contextmenu":case "mouseup":case "dragend":return wf=!1,xf(c,d);case "selectionchange":if(rf)break;
case "keydown":case "keyup":return xf(c,d)}return null}};Ca.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));var zf=Cc;sa=ye;ua=zf;va=xe;Ca.injectEventPluginsByName({SimpleEventPlugin:Ed,EnterLeaveEventPlugin:mf,ChangeEventPlugin:jf,SelectEventPlugin:yf,BeforeInputEventPlugin:Se});new Set;var Af=[],Bf=-1;function G(a){0>Bf||(a.current=Af[Bf],Af[Bf]=null,Bf--)}
function I(a,b){Bf++;Af[Bf]=a.current;a.current=b}var Cf={},J={current:Cf},K={current:!1},Df=Cf;function Ef(a,b){var c=a.type.contextTypes;if(!c)return Cf;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Ff(a){G(K,a);G(J,a)}function Gf(a){G(K,a);G(J,a)}function Hf(a,b,c){if(J.current!==Cf)throw Error(u(168));I(J,b,a);I(K,c,a)}function If(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,Wa(b)||"Unknown",e));return n({},c,{},d)}function Jf(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||Cf;Df=J.current;I(J,b,a);I(K,K.current,a);return!0}
function Kf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(b=If(a,b,Df),d.__reactInternalMemoizedMergedChildContext=b,G(K,a),G(J,a),I(J,b,a)):G(K,a);I(K,c,a)}
var Lf=q.unstable_runWithPriority,Mf=q.unstable_scheduleCallback,Nf=q.unstable_cancelCallback,Of=q.unstable_shouldYield,Pf=q.unstable_requestPaint,Qf=q.unstable_now,Rf=q.unstable_getCurrentPriorityLevel,Sf=q.unstable_ImmediatePriority,Tf=q.unstable_UserBlockingPriority,Uf=q.unstable_NormalPriority,Vf=q.unstable_LowPriority,Wf=q.unstable_IdlePriority,Xf={},Yf=void 0!==Pf?Pf:function(){},Zf=null,$f=null,ag=!1,bg=Qf(),cg=1E4>bg?Qf:function(){return Qf()-bg};
function dg(){switch(Rf()){case Sf:return 99;case Tf:return 98;case Uf:return 97;case Vf:return 96;case Wf:return 95;default:throw Error(u(332));}}function eg(a){switch(a){case 99:return Sf;case 98:return Tf;case 97:return Uf;case 96:return Vf;case 95:return Wf;default:throw Error(u(332));}}function fg(a,b){a=eg(a);return Lf(a,b)}function gg(a,b,c){a=eg(a);return Mf(a,b,c)}function hg(a){null===Zf?(Zf=[a],$f=Mf(Sf,ig)):Zf.push(a);return Xf}function jg(){if(null!==$f){var a=$f;$f=null;Nf(a)}ig()}
function ig(){if(!ag&&null!==Zf){ag=!0;var a=0;try{var b=Zf;fg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Zf=null}catch(c){throw null!==Zf&&(Zf=Zf.slice(a+1)),Mf(Sf,jg),c;}finally{ag=!1}}}var kg=3;function lg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function mg(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var ng={current:null},og=null,pg=null,qg=null;function rg(){qg=pg=og=null}
function sg(a,b){var c=a.type._context;I(ng,c._currentValue,a);c._currentValue=b}function tg(a){var b=ng.current;G(ng,a);a.type._context._currentValue=b}function ug(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}
function vg(a,b){og=a;qg=pg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(wg=!0),a.firstContext=null)}function xg(a,b){if(qg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)qg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===pg){if(null===og)throw Error(u(308));pg=b;og.dependencies={expirationTime:0,firstContext:b,responders:null}}else pg=pg.next=b}return a._currentValue}var yg=!1;
function zg(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Ag(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function Bg(a,b){return{expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Cg(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function Dg(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=zg(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=zg(a.memoizedState),e=c.updateQueue=zg(c.memoizedState)):d=a.updateQueue=Ag(e):null===e&&(e=c.updateQueue=Ag(d));null===e||d===e?Cg(d,b):null===d.lastUpdate||null===e.lastUpdate?(Cg(d,b),Cg(e,b)):(Cg(d,b),e.lastUpdate=b)}
function Eg(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=zg(a.memoizedState):Fg(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function Fg(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Ag(b));return b}
function Gg(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-4097|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case 2:yg=!0}return d}
function Hg(a,b,c,d,e){yg=!1;b=Fg(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,l=f;null!==k;){var m=k.expirationTime;m<e?(null===g&&(g=k,f=l),h<m&&(h=m)):(Ig(m,k.suspenseConfig),l=Gg(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k)));k=k.next}m=null;for(k=b.firstCapturedUpdate;null!==k;){var C=k.expirationTime;C<e?(null===m&&(m=k,null===g&&(f=l)),h<C&&(h=C)):(l=Gg(a,b,k,l,c,d),null!==
k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k)));k=k.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=l);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;Jg(h);a.expirationTime=h;a.memoizedState=l}
function Kg(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);Lg(b.firstEffect,c);b.firstEffect=b.lastEffect=null;Lg(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function Lg(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;if("function"!==typeof c)throw Error(u(191,c));c.call(d)}a=a.nextEffect}}
var Mg=Ea.ReactCurrentBatchConfig,Ng=(new aa.Component).refs;function Og(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var Sg={isMounted:function(a){return(a=a._reactInternalFiber)?ec(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Pg(),e=Mg.suspense;d=Qg(d,a,e);e=Bg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Dg(a,e);Rg(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Pg(),e=Mg.suspense;d=Qg(d,a,e);e=Bg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Dg(a,e);Rg(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Pg(),d=Mg.suspense;
c=Qg(c,a,d);d=Bg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);Dg(a,d);Rg(a,c)}};function Tg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!qf(c,d)||!qf(e,f):!0}
function Ug(a,b,c){var d=!1,e=Cf;var f=b.contextType;"object"===typeof f&&null!==f?f=xg(f):(e=L(b)?Df:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Ef(a,e):Cf);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Sg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Vg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Sg.enqueueReplaceState(b,b.state,null)}
function Wg(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Ng;var f=b.contextType;"object"===typeof f&&null!==f?e.context=xg(f):(f=L(b)?Df:J.current,e.context=Ef(a,f));f=a.updateQueue;null!==f&&(Hg(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(Og(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Sg.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(Hg(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Xg=Array.isArray;
function Yg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Ng&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Zg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function $g(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=ah(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=bh(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=Yg(a,b,c),d.return=a,d;d=ch(c.type,c.key,c.props,null,a.mode,d);d.ref=Yg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=dh(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=eh(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function C(a,b,c){if("string"===typeof b||"number"===typeof b)return b=bh(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Ga:return c=ch(b.type,b.key,b.props,null,a.mode,c),c.ref=Yg(a,null,b),c.return=a,c;case Ha:return b=dh(b,a.mode,c),b.return=a,b}if(Xg(b)||
Ua(b))return b=eh(b,a.mode,c,null),b.return=a,b;Zg(a,b)}return null}function y(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Ga:return c.key===e?c.type===Ia?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case Ha:return c.key===e?l(a,b,c,d):null}if(Xg(c)||Ua(c))return null!==e?null:m(a,b,c,d,null);Zg(a,c)}return null}function H(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Ga:return a=a.get(null===d.key?c:d.key)||null,d.type===Ia?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case Ha:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Xg(d)||Ua(d))return a=a.get(c)||null,m(b,a,d,e,null);Zg(b,d)}return null}function z(e,g,h,k){for(var l=null,m=null,r=g,x=g=0,A=null;null!==r&&x<h.length;x++){r.index>x?(A=r,r=null):A=r.sibling;var p=y(e,r,h[x],k);if(null===p){null===r&&(r=A);break}a&&
r&&null===p.alternate&&b(e,r);g=f(p,g,x);null===m?l=p:m.sibling=p;m=p;r=A}if(x===h.length)return c(e,r),l;if(null===r){for(;x<h.length;x++)r=C(e,h[x],k),null!==r&&(g=f(r,g,x),null===m?l=r:m.sibling=r,m=r);return l}for(r=d(e,r);x<h.length;x++)A=H(r,e,x,h[x],k),null!==A&&(a&&null!==A.alternate&&r.delete(null===A.key?x:A.key),g=f(A,g,x),null===m?l=A:m.sibling=A,m=A);a&&r.forEach(function(a){return b(e,a)});return l}function ta(e,g,h,k){var l=Ua(h);if("function"!==typeof l)throw Error(u(150));h=l.call(h);
if(null==h)throw Error(u(151));for(var m=l=null,r=g,x=g=0,A=null,p=h.next();null!==r&&!p.done;x++,p=h.next()){r.index>x?(A=r,r=null):A=r.sibling;var z=y(e,r,p.value,k);if(null===z){null===r&&(r=A);break}a&&r&&null===z.alternate&&b(e,r);g=f(z,g,x);null===m?l=z:m.sibling=z;m=z;r=A}if(p.done)return c(e,r),l;if(null===r){for(;!p.done;x++,p=h.next())p=C(e,p.value,k),null!==p&&(g=f(p,g,x),null===m?l=p:m.sibling=p,m=p);return l}for(r=d(e,r);!p.done;x++,p=h.next())p=H(r,e,x,p.value,k),null!==p&&(a&&null!==
p.alternate&&r.delete(null===p.key?x:p.key),g=f(p,g,x),null===m?l=p:m.sibling=p,m=p);a&&r.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===Ia&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Ga:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===Ia:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===Ia?f.props.children:f.props,h);d.ref=Yg(a,k,f);d.return=a;a=d;break a}else{c(a,
k);break}else b(a,k);k=k.sibling}f.type===Ia?(d=eh(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=ch(f.type,f.key,f.props,null,a.mode,h),h.ref=Yg(a,d,f),h.return=a,a=h)}return g(a);case Ha:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=dh(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===
typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=bh(f,a.mode,h),d.return=a,a=d),g(a);if(Xg(f))return z(a,d,f,h);if(Ua(f))return ta(a,d,f,h);l&&Zg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var fh=$g(!0),gh=$g(!1),hh={},ih={current:hh},jh={current:hh},kh={current:hh};function lh(a){if(a===hh)throw Error(u(174));return a}
function mh(a,b){I(kh,b,a);I(jh,a,a);I(ih,hh,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Qb(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=Qb(b,c)}G(ih,a);I(ih,b,a)}function nh(a){G(ih,a);G(jh,a);G(kh,a)}function oh(a){lh(kh.current);var b=lh(ih.current);var c=Qb(b,a.type);b!==c&&(I(jh,a,a),I(ih,c,a))}function ph(a){jh.current===a&&(G(ih,a),G(jh,a))}var M={current:0};
function qh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===je||c.data===ke))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function rh(a,b){return{responder:a,props:b}}
var sh=Ea.ReactCurrentDispatcher,N=Ea.ReactCurrentBatchConfig,th=0,uh=null,O=null,vh=null,wh=null,P=null,xh=null,yh=0,zh=null,Ah=0,Bh=!1,Ch=null,Gh=0;function Q(){throw Error(u(321));}function Hh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!of(a[c],b[c]))return!1;return!0}
function Ih(a,b,c,d,e,f){th=f;uh=b;vh=null!==a?a.memoizedState:null;sh.current=null===vh?Jh:Kh;b=c(d,e);if(Bh){do Bh=!1,Gh+=1,vh=null!==a?a.memoizedState:null,xh=wh,zh=P=O=null,sh.current=Kh,b=c(d,e);while(Bh);Ch=null;Gh=0}sh.current=Lh;a=uh;a.memoizedState=wh;a.expirationTime=yh;a.updateQueue=zh;a.effectTag|=Ah;a=null!==O&&null!==O.next;th=0;xh=P=wh=vh=O=uh=null;yh=0;zh=null;Ah=0;if(a)throw Error(u(300));return b}
function Mh(){sh.current=Lh;th=0;xh=P=wh=vh=O=uh=null;yh=0;zh=null;Ah=0;Bh=!1;Ch=null;Gh=0}function Nh(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===P?wh=P=a:P=P.next=a;return P}function Oh(){if(null!==xh)P=xh,xh=P.next,O=vh,vh=null!==O?O.next:null;else{if(null===vh)throw Error(u(310));O=vh;var a={memoizedState:O.memoizedState,baseState:O.baseState,queue:O.queue,baseUpdate:O.baseUpdate,next:null};P=null===P?wh=a:P.next=a;vh=O.next}return P}
function Ph(a,b){return"function"===typeof b?b(a):b}
function Qh(a){var b=Oh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;if(0<Gh){var d=c.dispatch;if(null!==Ch){var e=Ch.get(c);if(void 0!==e){Ch.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);of(f,b.memoizedState)||(wg=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var g=b.baseUpdate;f=b.baseState;null!==g?(null!==d&&(d.next=null),d=g.next):d=null!==d?d.next:null;if(null!==
d){var h=e=null,k=d,l=!1;do{var m=k.expirationTime;m<th?(l||(l=!0,h=g,e=f),m>yh&&(yh=m,Jg(yh))):(Ig(m,k.suspenseConfig),f=k.eagerReducer===a?k.eagerState:a(f,k.action));g=k;k=k.next}while(null!==k&&k!==d);l||(h=g,e=f);of(f,b.memoizedState)||(wg=!0);b.memoizedState=f;b.baseUpdate=h;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
function Rh(a){var b=Nh();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={last:null,dispatch:null,lastRenderedReducer:Ph,lastRenderedState:a};a=a.dispatch=Sh.bind(null,uh,a);return[b.memoizedState,a]}function Th(a){return Qh(Ph,a)}function Uh(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===zh?(zh={lastEffect:null},zh.lastEffect=a.next=a):(b=zh.lastEffect,null===b?zh.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,zh.lastEffect=a));return a}
function Vh(a,b,c,d){var e=Nh();Ah|=a;e.memoizedState=Uh(b,c,void 0,void 0===d?null:d)}function Wh(a,b,c,d){var e=Oh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&Hh(d,g.deps)){Uh(0,c,f,d);return}}Ah|=a;e.memoizedState=Uh(b,c,f,d)}function Xh(a,b){return Vh(516,192,a,b)}function Yh(a,b){return Wh(516,192,a,b)}
function Zh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function $h(){}function ai(a,b){Nh().memoizedState=[a,void 0===b?null:b];return a}function bi(a,b){var c=Oh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Hh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Sh(a,b,c){if(!(25>Gh))throw Error(u(301));var d=a.alternate;if(a===uh||null!==d&&d===uh)if(Bh=!0,a={expirationTime:th,suspenseConfig:null,action:c,eagerReducer:null,eagerState:null,next:null},null===Ch&&(Ch=new Map),c=Ch.get(b),void 0===c)Ch.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{var e=Pg(),f=Mg.suspense;e=Qg(e,a,f);f={expirationTime:e,suspenseConfig:f,action:c,eagerReducer:null,eagerState:null,next:null};var g=b.last;if(null===g)f.next=f;else{var h=g.next;null!==h&&
(f.next=h);g.next=f}b.last=f;if(0===a.expirationTime&&(null===d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var k=b.lastRenderedState,l=d(k,c);f.eagerReducer=d;f.eagerState=l;if(of(l,k))return}catch(m){}finally{}Rg(a,e)}}
var Lh={readContext:xg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},Jh={readContext:xg,useCallback:ai,useContext:xg,useEffect:Xh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Vh(4,36,Zh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Vh(4,36,a,b)},useMemo:function(a,b){var c=Nh();b=void 0===b?null:b;a=a();c.memoizedState=
[a,b];return a},useReducer:function(a,b,c){var d=Nh();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=Sh.bind(null,uh,a);return[d.memoizedState,a]},useRef:function(a){var b=Nh();a={current:a};return b.memoizedState=a},useState:Rh,useDebugValue:$h,useResponder:rh,useDeferredValue:function(a,b){var c=Rh(a),d=c[0],e=c[1];Xh(function(){q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===b?null:b;try{e(a)}finally{N.suspense=
c}})},[a,b]);return d},useTransition:function(a){var b=Rh(!1),c=b[0],d=b[1];return[ai(function(b){d(!0);q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===a?null:a;try{d(!1),b()}finally{N.suspense=c}})},[a,c]),c]}},Kh={readContext:xg,useCallback:bi,useContext:xg,useEffect:Yh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Wh(4,36,Zh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Wh(4,36,a,b)},useMemo:function(a,b){var c=Oh();b=void 0===b?
null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Hh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:Qh,useRef:function(){return Oh().memoizedState},useState:Th,useDebugValue:$h,useResponder:rh,useDeferredValue:function(a,b){var c=Th(a),d=c[0],e=c[1];Yh(function(){q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===b?null:b;try{e(a)}finally{N.suspense=c}})},[a,b]);return d},useTransition:function(a){var b=Th(!1),c=b[0],d=b[1];return[bi(function(b){d(!0);q.unstable_next(function(){var c=
N.suspense;N.suspense=void 0===a?null:a;try{d(!1),b()}finally{N.suspense=c}})},[a,c]),c]}},ci=null,di=null,ei=!1;function fi(a,b){var c=gi(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function hi(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function ii(a){if(ei){var b=di;if(b){var c=b;if(!hi(a,b)){b=re(c.nextSibling);if(!b||!hi(a,b)){a.effectTag=a.effectTag&-1025|2;ei=!1;ci=a;return}fi(ci,c)}ci=a;di=re(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,ei=!1,ci=a}}function ji(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;ci=a}
function ki(a){if(a!==ci)return!1;if(!ei)return ji(a),ei=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!oe(b,a.memoizedProps))for(b=di;b;)fi(a,b),b=re(b.nextSibling);ji(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===ie){if(0===b){di=re(a.nextSibling);break a}b--}else c!==he&&c!==ke&&c!==je||b++}a=a.nextSibling}di=null}}else di=ci?re(a.stateNode.nextSibling):null;return!0}
function li(){di=ci=null;ei=!1}var mi=Ea.ReactCurrentOwner,wg=!1;function R(a,b,c,d){b.child=null===a?gh(b,null,c,d):fh(b,a.child,c,d)}function ni(a,b,c,d,e){c=c.render;var f=b.ref;vg(b,e);d=Ih(a,b,c,d,f,e);if(null!==a&&!wg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),oi(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function pi(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!qi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ri(a,b,g,d,e,f);a=ch(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:qf,c(e,d)&&a.ref===b.ref))return oi(a,b,f);b.effectTag|=1;a=ah(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
function ri(a,b,c,d,e,f){return null!==a&&qf(a.memoizedProps,d)&&a.ref===b.ref&&(wg=!1,e<f)?oi(a,b,f):si(a,b,c,d,f)}function ti(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function si(a,b,c,d,e){var f=L(c)?Df:J.current;f=Ef(b,f);vg(b,e);c=Ih(a,b,c,d,f,e);if(null!==a&&!wg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),oi(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function ui(a,b,c,d,e){if(L(c)){var f=!0;Jf(b)}else f=!1;vg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Ug(b,c,d,e),Wg(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=xg(l):(l=L(c)?Df:J.current,l=Ef(b,l));var m=c.getDerivedStateFromProps,C="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;C||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Vg(b,g,d,l);yg=!1;var y=b.memoizedState;k=g.state=y;var H=b.updateQueue;null!==H&&(Hg(b,H,d,g,e),k=b.memoizedState);h!==d||y!==k||K.current||yg?("function"===typeof m&&(Og(b,c,m,d),k=b.memoizedState),(h=yg||Tg(b,c,h,d,y,k,l))?(C||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:mg(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=xg(l):(l=L(c)?Df:J.current,l=Ef(b,l)),m=c.getDerivedStateFromProps,(C=
"function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Vg(b,g,d,l),yg=!1,k=b.memoizedState,y=g.state=k,H=b.updateQueue,null!==H&&(Hg(b,H,d,g,e),y=b.memoizedState),h!==d||k!==y||K.current||yg?("function"===typeof m&&(Og(b,c,m,d),y=b.memoizedState),(m=yg||Tg(b,c,h,d,k,y,l))?(C||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||
("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,y,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,y,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=
d,b.memoizedState=y),g.props=d,g.state=y,g.context=l,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return vi(a,b,c,d,f,e)}
function vi(a,b,c,d,e,f){ti(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Kf(b,c,!1),oi(a,b,f);d=b.stateNode;mi.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=fh(b,a.child,null,f),b.child=fh(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Kf(b,c,!0);return b.child}function wi(a){var b=a.stateNode;b.pendingContext?Hf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Hf(a,b.context,!1);mh(a,b.containerInfo)}
var xi={dehydrated:null,retryTime:0};
function yi(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1,b);if(null===a){void 0!==e.fallback&&ii(b);if(g){g=e.fallback;e=eh(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=eh(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=xi;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=gh(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=ah(a,a.pendingProps,0);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=ah(d,e,d.expirationTime);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=xi;b.child=c;return d}c=fh(b,a.child,e.children,c);b.memoizedState=
null;return b.child=c}a=a.child;if(g){g=e.fallback;e=eh(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=eh(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=xi;b.child=e;return c}b.memoizedState=null;return b.child=fh(b,a,e.children,c)}
function zi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);ug(a.return,b)}function Ai(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function Bi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&zi(a,c);else if(19===a.tag)zi(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d,b);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===qh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);Ai(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===qh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}Ai(b,!0,c,null,f,b.lastEffect);break;case "together":Ai(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function oi(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Jg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=ah(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=ah(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}function Ci(a){a.effectTag|=4}var Hi,Ii,Ji,Ki;
Hi=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Ii=function(){};
Ji=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;lh(ih.current);a=null;switch(c){case "input":f=Ab(g,f);d=Ab(g,d);a=[];break;case "option":f=Ib(g,f);d=Ib(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Kb(g,f);d=Kb(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=ae)}Yd(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ia.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,""+l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(ia.hasOwnProperty(h)?(null!=l&&$d(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;(b.updateQueue=e)&&Ci(b)}};Ki=function(a,b,c,d){c!==d&&Ci(b)};
function Li(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function Mi(a){switch(a.tag){case 1:L(a.type)&&Ff(a);var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:nh(a);Gf(a);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return ph(a),null;case 13:return G(M,a),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return G(M,a),null;case 4:return nh(a),null;case 10:return tg(a),null;default:return null}}function Ni(a,b){return{value:a,source:b,stack:Xa(b)}}
var Oi="function"===typeof WeakSet?WeakSet:Set;function Pi(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=Xa(c));null!==c&&Wa(c.type);b=b.value;null!==a&&1===a.tag&&Wa(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Qi(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ri(a,c)}}function Si(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ri(a,c)}else b.current=null}
function Ti(a,b){switch(b.tag){case 0:case 11:case 15:Ui(2,0,b);break;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:mg(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}break;case 3:case 5:case 6:case 4:case 17:break;default:throw Error(u(163));}}
function Ui(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if(0!==(d.tag&a)){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}0!==(d.tag&b)&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
function Vi(a,b,c){"function"===typeof Wi&&Wi(b);switch(b.tag){case 0:case 11:case 14:case 15:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;fg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ri(g,h)}}a=a.next}while(a!==d)})}break;case 1:Si(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Qi(b,c);break;case 5:Si(b);break;case 4:Xi(a,b,c)}}
function Yi(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;null!==b&&Yi(b)}function Zi(a){return 5===a.tag||3===a.tag||4===a.tag}
function $i(a){a:{for(var b=a.return;null!==b;){if(Zi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Tb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Zi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){var f=5===e.tag||6===e.tag;if(f){var g=f?e.stateNode:e.stateNode.instance;if(c)if(d){f=b;var h=g;g=c;8===f.nodeType?f.parentNode.insertBefore(h,g):f.insertBefore(h,g)}else b.insertBefore(g,c);else d?(h=b,8===h.nodeType?(f=h.parentNode,f.insertBefore(g,h)):(f=h,f.appendChild(g)),h=h._reactRootContainer,null!==h&&void 0!==h||null!==f.onclick||(f.onclick=ae)):b.appendChild(g)}else if(4!==
e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function Xi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Vi(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Vi(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function aj(a,b){switch(b.tag){case 0:case 11:case 14:case 15:Ui(4,8,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[ve]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Cb(c,d);Zd(a,e);b=Zd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?Wd(c,h):"dangerouslySetInnerHTML"===g?Sb(c,h):"children"===g?Tb(c,h):vb(c,g,h,b)}switch(a){case "input":Eb(c,d);break;case "textarea":Mb(c,
d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Jb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Jb(c,!!d.multiple,d.defaultValue,!0):Jb(c,!!d.multiple,d.multiple?[]:"",!1))}}}break;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;break;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Lc(b.containerInfo));break;case 12:break;case 13:c=b;null===b.memoizedState?d=!1:(d=!0,c=b.child,bj=cg());
if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=Vd("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=f;continue}else if(null!==a.child){a.child.return=
a;a=a.child;continue}if(a===c)break a;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}cj(b);break;case 19:cj(b);break;case 17:break;case 20:break;case 21:break;default:throw Error(u(163));}}function cj(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Oi);b.forEach(function(b){var d=dj.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}var ej="function"===typeof WeakMap?WeakMap:Map;
function fj(a,b,c){c=Bg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){gj||(gj=!0,hj=d);Pi(a,b)};return c}
function ij(a,b,c){c=Bg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Pi(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===jj?jj=new Set([this]):jj.add(this),Pi(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var kj=Math.ceil,lj=Ea.ReactCurrentDispatcher,mj=Ea.ReactCurrentOwner,S=0,nj=8,oj=16,pj=32,qj=0,rj=1,sj=2,tj=3,uj=4,vj=5,T=S,U=null,V=null,W=0,X=qj,wj=null,xj=1073741823,yj=1073741823,zj=null,Aj=0,Bj=!1,bj=0,Cj=500,Y=null,gj=!1,hj=null,jj=null,Dj=!1,Ej=null,Fj=90,Gj=null,Hj=0,Ij=null,Jj=0;function Pg(){return(T&(oj|pj))!==S?1073741821-(cg()/10|0):0!==Jj?Jj:Jj=1073741821-(cg()/10|0)}
function Qg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=dg();if(0===(b&4))return 99===d?1073741823:1073741822;if((T&oj)!==S)return W;if(null!==c)a=lg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=lg(a,150,100);break;case 97:case 96:a=lg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==U&&a===W&&--a;return a}
function Rg(a,b){if(50<Hj)throw Hj=0,Ij=null,Error(u(185));a=Kj(a,b);if(null!==a){var c=dg();1073741823===b?(T&nj)!==S&&(T&(oj|pj))===S?Lj(a):(Z(a),T===S&&jg()):Z(a);(T&4)===S||98!==c&&99!==c||(null===Gj?Gj=new Map([[a,b]]):(c=Gj.get(a),(void 0===c||c>b)&&Gj.set(a,b)))}}
function Kj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(U===e&&(Jg(b),X===uj&&Mj(e,W)),Nj(e,b));return e}
function Oj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Pj(a,b))return b;b=a.lastPingedTime;a=a.nextKnownPendingLevel;return b>a?b:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=hg(Lj.bind(null,a));else{var b=Oj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Pg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Xf&&Nf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?hg(Lj.bind(null,a)):gg(d,Qj.bind(null,a),{timeout:10*(1073741821-b)-cg()});a.callbackNode=b}}}
function Qj(a,b){Jj=0;if(b)return b=Pg(),Rj(a,b),Z(a),null;var c=Oj(a);if(0!==c){b=a.callbackNode;if((T&(oj|pj))!==S)throw Error(u(327));Sj();a===U&&c===W||Tj(a,c);if(null!==V){var d=T;T|=oj;var e=Uj(a);do try{Vj();break}catch(h){Wj(a,h)}while(1);rg();T=d;lj.current=e;if(X===rj)throw b=wj,Tj(a,c),Mj(a,c),Z(a),b;if(null===V)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=X,U=null,d){case qj:case rj:throw Error(u(345));case sj:Rj(a,2<c?2:c);break;case tj:Mj(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Xj(e));if(1073741823===xj&&(e=bj+Cj-cg(),10<e)){if(Bj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Tj(a,c);break}}f=Oj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=pe(Yj.bind(null,a),e);break}Yj(a);break;case uj:Mj(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Xj(e));if(Bj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Tj(a,c);break}e=Oj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==yj?d=10*(1073741821-yj)-cg():1073741823===xj?d=0:(d=10*(1073741821-xj)-5E3,e=cg(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*kj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=pe(Yj.bind(null,a),d);break}Yj(a);break;case vj:if(1073741823!==xj&&null!==zj){f=xj;var g=zj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=cg()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){Mj(a,c);a.timeoutHandle=
pe(Yj.bind(null,a),d);break}}Yj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Qj.bind(null,a)}}return null}
function Lj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if(a.finishedExpirationTime===b)Yj(a);else{if((T&(oj|pj))!==S)throw Error(u(327));Sj();a===U&&b===W||Tj(a,b);if(null!==V){var c=T;T|=oj;var d=Uj(a);do try{Zj();break}catch(e){Wj(a,e)}while(1);rg();T=c;lj.current=d;if(X===rj)throw c=wj,Tj(a,b),Mj(a,b),Z(a),c;if(null!==V)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;U=null;Yj(a);Z(a)}}return null}
function ak(){if(null!==Gj){var a=Gj;Gj=null;a.forEach(function(a,c){Rj(c,a);Z(c)});jg()}}function bk(a,b){var c=T;T|=1;try{return a(b)}finally{T=c,T===S&&jg()}}function ck(a,b){var c=T;T&=-2;T|=nj;try{return a(b)}finally{T=c,T===S&&jg()}}
function Tj(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,qe(c));if(null!==V)for(c=V.return;null!==c;){var d=c;switch(d.tag){case 1:var e=d.type.childContextTypes;null!==e&&void 0!==e&&Ff(d);break;case 3:nh(d);Gf(d);break;case 5:ph(d);break;case 4:nh(d);break;case 13:G(M,d);break;case 19:G(M,d);break;case 10:tg(d)}c=c.return}U=a;V=ah(a.current,null,b);W=b;X=qj;wj=null;yj=xj=1073741823;zj=null;Aj=0;Bj=!1}
function Wj(a,b){do{try{rg();Mh();if(null===V||null===V.return)return X=rj,wj=b,null;a:{var c=a,d=V.return,e=V,f=b;b=W;e.effectTag|=2048;e.firstEffect=e.lastEffect=null;if(null!==f&&"object"===typeof f&&"function"===typeof f.then){var g=f,h=0!==(M.current&1),k=d;do{var l;if(l=13===k.tag){var m=k.memoizedState;if(null!==m)l=null!==m.dehydrated?!0:!1;else{var C=k.memoizedProps;l=void 0===C.fallback?!1:!0!==C.unstable_avoidThisFallback?!0:h?!1:!0}}if(l){var y=k.updateQueue;if(null===y){var H=new Set;
H.add(g);k.updateQueue=H}else y.add(g);if(0===(k.mode&2)){k.effectTag|=64;e.effectTag&=-2981;if(1===e.tag)if(null===e.alternate)e.tag=17;else{var z=Bg(1073741823,null);z.tag=2;Dg(e,z)}e.expirationTime=1073741823;break a}f=void 0;e=b;var ta=c.pingCache;null===ta?(ta=c.pingCache=new ej,f=new Set,ta.set(g,f)):(f=ta.get(g),void 0===f&&(f=new Set,ta.set(g,f)));if(!f.has(e)){f.add(e);var r=dk.bind(null,c,g,e);g.then(r,r)}k.effectTag|=4096;k.expirationTime=b;break a}k=k.return}while(null!==k);f=Error((Wa(e.type)||
"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+Xa(e))}X!==vj&&(X=sj);f=Ni(f,e);k=d;do{switch(k.tag){case 3:g=f;k.effectTag|=4096;k.expirationTime=b;var x=fj(k,g,b);Eg(k,x);break a;case 1:g=f;var A=k.type,p=k.stateNode;if(0===(k.effectTag&64)&&("function"===typeof A.getDerivedStateFromError||null!==p&&"function"===typeof p.componentDidCatch&&
(null===jj||!jj.has(p)))){k.effectTag|=4096;k.expirationTime=b;var t=ij(k,g,b);Eg(k,t);break a}}k=k.return}while(null!==k)}V=ek(V)}catch(v){b=v;continue}break}while(1)}function Uj(){var a=lj.current;lj.current=Lh;return null===a?Lh:a}function Ig(a,b){a<xj&&2<a&&(xj=a);null!==b&&a<yj&&2<a&&(yj=a,zj=b)}function Jg(a){a>Aj&&(Aj=a)}function Zj(){for(;null!==V;)V=fk(V)}function Vj(){for(;null!==V&&!Of();)V=fk(V)}
function fk(a){var b=gk(a.alternate,a,W);a.memoizedProps=a.pendingProps;null===b&&(b=ek(a));mj.current=null;return b}
function ek(a){V=a;do{var b=V.alternate;a=V.return;if(0===(V.effectTag&2048)){a:{var c=b;b=V;var d=W;var e=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:L(b.type)&&Ff(b);break;case 3:nh(b);Gf(b);e=b.stateNode;e.pendingContext&&(e.context=e.pendingContext,e.pendingContext=null);(null===c||null===c.child)&&ki(b)&&Ci(b);Ii(b);break;case 5:ph(b);d=lh(kh.current);var f=b.type;if(null!==c&&null!=b.stateNode)Ji(c,b,f,e,d),c.ref!==b.ref&&(b.effectTag|=128);else if(e){var g=
lh(ih.current);if(ki(b)){e=b;var h=e.stateNode;c=e.type;var k=e.memoizedProps,l=d;h[ue]=e;h[ve]=k;f=void 0;d=h;switch(c){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(h=0;h<cc.length;h++)F(cc[h],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Bb(d,k);F("invalid",d);$d(l,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!k.multiple};F("invalid",d);$d(l,"onChange");break;case "textarea":Lb(d,k),F("invalid",d),$d(l,"onChange")}Yd(c,k);h=null;for(f in k)k.hasOwnProperty(f)&&(g=k[f],"children"===f?"string"===typeof g?d.textContent!==g&&(h=["children",g]):"number"===typeof g&&d.textContent!==""+g&&(h=["children",""+g]):ia.hasOwnProperty(f)&&null!=g&&$d(l,f));switch(c){case "input":yb(d);Gb(d,k,!0);break;case "textarea":yb(d);Nb(d,k);break;case "select":case "option":break;default:"function"===typeof k.onClick&&
(d.onclick=ae)}f=h;e.updateQueue=f;e=null!==f?!0:!1;e&&Ci(b)}else{c=b;l=f;k=e;h=9===d.nodeType?d:d.ownerDocument;g===Ob.html&&(g=Pb(l));g===Ob.html?"script"===l?(k=h.createElement("div"),k.innerHTML="<script>\x3c/script>",h=k.removeChild(k.firstChild)):"string"===typeof k.is?h=h.createElement(l,{is:k.is}):(h=h.createElement(l),"select"===l&&(l=h,k.multiple?l.multiple=!0:k.size&&(l.size=k.size))):h=h.createElementNS(g,l);k=h;k[ue]=c;k[ve]=e;Hi(k,b,!1,!1);b.stateNode=k;l=f;c=e;var m=d,C=Zd(l,c);switch(l){case "iframe":case "object":case "embed":F("load",
k);d=c;break;case "video":case "audio":for(d=0;d<cc.length;d++)F(cc[d],k);d=c;break;case "source":F("error",k);d=c;break;case "img":case "image":case "link":F("error",k);F("load",k);d=c;break;case "form":F("reset",k);F("submit",k);d=c;break;case "details":F("toggle",k);d=c;break;case "input":Bb(k,c);d=Ab(k,c);F("invalid",k);$d(m,"onChange");break;case "option":d=Ib(k,c);break;case "select":k._wrapperState={wasMultiple:!!c.multiple};d=n({},c,{value:void 0});F("invalid",k);$d(m,"onChange");break;case "textarea":Lb(k,
c);d=Kb(k,c);F("invalid",k);$d(m,"onChange");break;default:d=c}Yd(l,d);h=void 0;g=l;var y=k,H=d;for(h in H)if(H.hasOwnProperty(h)){var z=H[h];"style"===h?Wd(y,z):"dangerouslySetInnerHTML"===h?(z=z?z.__html:void 0,null!=z&&Sb(y,z)):"children"===h?"string"===typeof z?("textarea"!==g||""!==z)&&Tb(y,z):"number"===typeof z&&Tb(y,""+z):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ia.hasOwnProperty(h)?null!=z&&$d(m,h):null!=z&&vb(y,h,z,C))}switch(l){case "input":yb(k);
Gb(k,c,!1);break;case "textarea":yb(k);Nb(k,c);break;case "option":null!=c.value&&k.setAttribute("value",""+ub(c.value));break;case "select":d=k;d.multiple=!!c.multiple;k=c.value;null!=k?Jb(d,!!c.multiple,k,!1):null!=c.defaultValue&&Jb(d,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof d.onClick&&(k.onclick=ae)}(e=ne(f,e))&&Ci(b)}null!==b.ref&&(b.effectTag|=128)}else if(null===b.stateNode)throw Error(u(166));break;case 6:if(c&&null!=b.stateNode)Ki(c,b,c.memoizedProps,e);else{if("string"!==
typeof e&&null===b.stateNode)throw Error(u(166));d=lh(kh.current);lh(ih.current);ki(b)?(e=b,f=e.stateNode,d=e.memoizedProps,f[ue]=e,(e=f.nodeValue!==d)&&Ci(b)):(f=b,e=(9===d.nodeType?d:d.ownerDocument).createTextNode(e),e[ue]=f,b.stateNode=e)}break;case 11:break;case 13:G(M,b);e=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=d;break a}e=null!==e;f=!1;null===c?void 0!==b.memoizedProps.fallback&&ki(b):(d=c.memoizedState,f=null!==d,e||null===d||(d=c.child.sibling,null!==d&&(k=b.firstEffect,
null!==k?(b.firstEffect=d,d.nextEffect=k):(b.firstEffect=b.lastEffect=d,d.nextEffect=null),d.effectTag=8)));if(e&&!f&&0!==(b.mode&2))if(null===c&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))X===qj&&(X=tj);else{if(X===qj||X===tj)X=uj;0!==Aj&&null!==U&&(Mj(U,W),Nj(U,Aj))}if(e||f)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:nh(b);Ii(b);break;case 10:tg(b);break;case 9:break;case 14:break;case 17:L(b.type)&&Ff(b);break;case 19:G(M,b);e=b.memoizedState;if(null===
e)break;f=0!==(b.effectTag&64);k=e.rendering;if(null===k)if(f)Li(e,!1);else{if(X!==qj||null!==c&&0!==(c.effectTag&64))for(c=b.child;null!==c;){k=qh(c);if(null!==k){b.effectTag|=64;Li(e,!1);f=k.updateQueue;null!==f&&(b.updateQueue=f,b.effectTag|=4);null===e.lastEffect&&(b.firstEffect=null);b.lastEffect=e.lastEffect;e=d;for(f=b.child;null!==f;)d=f,c=e,d.effectTag&=2,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null,k=d.alternate,null===k?(d.childExpirationTime=0,d.expirationTime=c,d.child=null,
d.memoizedProps=null,d.memoizedState=null,d.updateQueue=null,d.dependencies=null):(d.childExpirationTime=k.childExpirationTime,d.expirationTime=k.expirationTime,d.child=k.child,d.memoizedProps=k.memoizedProps,d.memoizedState=k.memoizedState,d.updateQueue=k.updateQueue,c=k.dependencies,d.dependencies=null===c?null:{expirationTime:c.expirationTime,firstContext:c.firstContext,responders:c.responders}),f=f.sibling;I(M,M.current&1|2,b);b=b.child;break a}c=c.sibling}}else{if(!f)if(c=qh(k),null!==c){if(b.effectTag|=
64,f=!0,d=c.updateQueue,null!==d&&(b.updateQueue=d,b.effectTag|=4),Li(e,!0),null===e.tail&&"hidden"===e.tailMode&&!k.alternate){b=b.lastEffect=e.lastEffect;null!==b&&(b.nextEffect=null);break}}else cg()>e.tailExpiration&&1<d&&(b.effectTag|=64,f=!0,Li(e,!1),b.expirationTime=b.childExpirationTime=d-1);e.isBackwards?(k.sibling=b.child,b.child=k):(d=e.last,null!==d?d.sibling=k:b.child=k,e.last=k)}if(null!==e.tail){0===e.tailExpiration&&(e.tailExpiration=cg()+500);d=e.tail;e.rendering=d;e.tail=d.sibling;
e.lastEffect=b.lastEffect;d.sibling=null;e=M.current;e=f?e&1|2:e&1;I(M,e,b);b=d;break a}break;case 20:break;case 21:break;default:throw Error(u(156,b.tag));}b=null}e=V;if(1===W||1!==e.childExpirationTime){f=0;for(d=e.child;null!==d;)c=d.expirationTime,k=d.childExpirationTime,c>f&&(f=c),k>f&&(f=k),d=d.sibling;e.childExpirationTime=f}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=V.firstEffect),null!==V.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=
V.firstEffect),a.lastEffect=V.lastEffect),1<V.effectTag&&(null!==a.lastEffect?a.lastEffect.nextEffect=V:a.firstEffect=V,a.lastEffect=V))}else{b=Mi(V,W);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=V.sibling;if(null!==b)return b;V=a}while(null!==V);X===qj&&(X=vj);return null}function Xj(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Yj(a){var b=dg();fg(99,ik.bind(null,a,b));return null}
function ik(a,b){do Sj();while(null!==Ej);if((T&(oj|pj))!==S)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Xj(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===U&&(V=U=null,W=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=T;T|=pj;mj.current=null;le=Ld;var g=fe();if(ge(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(Db){h=null;break a}var C=0,y=-1,H=-1,z=0,ta=0,r=g,x=null;b:for(;;){for(var A;;){r!==h||0!==l&&3!==r.nodeType||(y=C+l);r!==m||0!==k&&3!==r.nodeType||(H=C+k);3===r.nodeType&&(C+=r.nodeValue.length);if(null===(A=r.firstChild))break;x=r;r=A}for(;;){if(r===g)break b;x===h&&++z===l&&(y=C);x===m&&++ta===k&&(H=C);if(null!==(A=r.nextSibling))break;r=x;x=r.parentNode}r=A}h=-1===y||-1===H?null:{start:y,end:H}}else h=null}h=h||{start:0,end:0}}else h=
null;me={focusedElem:g,selectionRange:h};Ld=!1;Y=e;do try{jk()}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var p=Y.effectTag;p&16&&Tb(Y.stateNode,"");if(p&128){var t=Y.alternate;if(null!==t){var v=t.ref;null!==v&&("function"===typeof v?v(null):v.current=null)}}switch(p&1038){case 2:$i(Y);Y.effectTag&=-3;break;case 6:$i(Y);Y.effectTag&=-3;aj(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=-1025;aj(Y.alternate,
Y);break;case 4:aj(Y.alternate,Y);break;case 8:l=Y,Xi(g,l,h),Yi(l)}Y=Y.nextEffect}}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);v=me;t=fe();p=v.focusedElem;h=v.selectionRange;if(t!==p&&p&&p.ownerDocument&&ee(p.ownerDocument.documentElement,p)){null!==h&&ge(p)&&(t=h.start,v=h.end,void 0===v&&(v=t),"selectionStart"in p?(p.selectionStart=t,p.selectionEnd=Math.min(v,p.value.length)):(v=(t=p.ownerDocument||document)&&t.defaultView||window,v.getSelection&&(v=v.getSelection(),
l=p.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!v.extend&&g>h&&(l=h,h=g,g=l),l=de(p,g),m=de(p,h),l&&m&&(1!==v.rangeCount||v.anchorNode!==l.node||v.anchorOffset!==l.offset||v.focusNode!==m.node||v.focusOffset!==m.offset)&&(t=t.createRange(),t.setStart(l.node,l.offset),v.removeAllRanges(),g>h?(v.addRange(t),v.extend(m.node,m.offset)):(t.setEnd(m.node,m.offset),v.addRange(t))))));t=[];for(v=p;v=v.parentNode;)1===v.nodeType&&t.push({element:v,left:v.scrollLeft,top:v.scrollTop});
"function"===typeof p.focus&&p.focus();for(p=0;p<t.length;p++)v=t[p],v.element.scrollLeft=v.left,v.element.scrollTop=v.top}me=null;Ld=!!le;le=null;a.current=c;Y=e;do try{for(p=d;null!==Y;){var Dh=Y.effectTag;if(Dh&36){var dc=Y.alternate;t=Y;v=p;switch(t.tag){case 0:case 11:case 15:Ui(16,32,t);break;case 1:var fd=t.stateNode;if(t.effectTag&4)if(null===dc)fd.componentDidMount();else{var hk=t.elementType===t.type?dc.memoizedProps:mg(t.type,dc.memoizedProps);fd.componentDidUpdate(hk,dc.memoizedState,
fd.__reactInternalSnapshotBeforeUpdate)}var Eh=t.updateQueue;null!==Eh&&Kg(t,Eh,fd,v);break;case 3:var Fh=t.updateQueue;if(null!==Fh){g=null;if(null!==t.child)switch(t.child.tag){case 5:g=t.child.stateNode;break;case 1:g=t.child.stateNode}Kg(t,Fh,g,v)}break;case 5:var xk=t.stateNode;null===dc&&t.effectTag&4&&ne(t.type,t.memoizedProps)&&xk.focus();break;case 6:break;case 4:break;case 12:break;case 13:if(null===t.memoizedState){var Di=t.alternate;if(null!==Di){var Ei=Di.memoizedState;if(null!==Ei){var Fi=
Ei.dehydrated;null!==Fi&&Lc(Fi)}}}break;case 19:case 17:case 20:case 21:break;default:throw Error(u(163));}}if(Dh&128){t=void 0;var xd=Y.ref;if(null!==xd){var Gi=Y.stateNode;switch(Y.tag){case 5:t=Gi;break;default:t=Gi}"function"===typeof xd?xd(t):xd.current=t}}Y=Y.nextEffect}}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);Y=null;Yf();T=f}else a.current=c;if(Dj)Dj=!1,Ej=a,Fj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&
(jj=null);1073741823===b?a===Ij?Hj++:(Hj=0,Ij=a):Hj=0;"function"===typeof kk&&kk(c.stateNode,d);Z(a);if(gj)throw gj=!1,a=hj,hj=null,a;if((T&nj)!==S)return null;jg();return null}function jk(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Ti(Y.alternate,Y);0===(a&512)||Dj||(Dj=!0,gg(97,function(){Sj();return null}));Y=Y.nextEffect}}function Sj(){if(90!==Fj){var a=97<Fj?97:Fj;Fj=90;return fg(a,lk)}}
function lk(){if(null===Ej)return!1;var a=Ej;Ej=null;if((T&(oj|pj))!==S)throw Error(u(331));var b=T;T|=pj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:Ui(128,0,c),Ui(0,64,c)}}catch(d){if(null===a)throw Error(u(330));Ri(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}T=b;jg();return!0}function mk(a,b,c){b=Ni(c,b);b=fj(a,b,1073741823);Dg(a,b);a=Kj(a,1073741823);null!==a&&Z(a)}
function Ri(a,b){if(3===a.tag)mk(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){mk(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===jj||!jj.has(d))){a=Ni(b,a);a=ij(c,a,1073741823);Dg(c,a);c=Kj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function dk(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);U===a&&W===c?X===uj||X===tj&&1073741823===xj&&cg()-bj<Cj?Tj(a,W):Bj=!0:Pj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,a.finishedExpirationTime===c&&(a.finishedExpirationTime=0,a.finishedWork=null),Z(a)))}function dj(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Pg(),b=Qg(b,a,null));a=Kj(a,b);null!==a&&Z(a)}var gk;
gk=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)wg=!0;else{if(d<c){wg=!1;switch(b.tag){case 3:wi(b);li();break;case 5:oh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Jf(b);break;case 4:mh(b,b.stateNode.containerInfo);break;case 10:sg(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return yi(a,b,c);I(M,M.current&
1,b);b=oi(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1,b);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return Bi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current,b);if(!d)return null}return oi(a,b,c)}wg=!1}}else wg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Ef(b,J.current);vg(b,c);e=Ih(null,b,d,a,e,c);b.effectTag|=1;if("object"===
typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;Mh();if(L(d)){var f=!0;Jf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&Og(b,d,g,a);e.updater=Sg;b.stateNode=e;e._reactInternalFiber=b;Wg(b,d,a,c);b=vi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;Va(e);if(1!==e._status)throw e._result;
e=e._result;b.type=e;f=b.tag=nk(e);a=mg(e,a);switch(f){case 0:b=si(null,b,e,a,c);break;case 1:b=ui(null,b,e,a,c);break;case 11:b=ni(null,b,e,a,c);break;case 14:b=pi(null,b,e,mg(e.type,a),d,c);break;default:throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),si(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),ui(a,b,d,e,c);case 3:wi(b);d=b.updateQueue;if(null===d)throw Error(u(282));e=b.memoizedState;e=null!==e?e.element:
null;Hg(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)li(),b=oi(a,b,c);else{if(e=b.stateNode.hydrate)di=re(b.stateNode.containerInfo.firstChild),ci=b,e=ei=!0;if(e)for(c=gh(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),li();b=b.child}return b;case 5:return oh(b),null===a&&ii(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,oe(d,e)?g=null:null!==f&&oe(d,f)&&(b.effectTag|=16),ti(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=
b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&ii(b),null;case 13:return yi(a,b,c);case 4:return mh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=fh(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),ni(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;
e=b.pendingProps;g=b.memoizedProps;f=e.value;sg(b,f);if(null!==g){var h=g.value;f=of(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!K.current){b=oi(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=Bg(c,null),l.tag=2,Dg(h,l));h.expirationTime<c&&(h.expirationTime=
c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);ug(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,vg(b,c),e=xg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;
case 14:return e=b.type,f=mg(e,b.pendingProps),f=mg(e.type,f),pi(a,b,e,f,d,c);case 15:return ri(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Jf(b)):a=!1,vg(b,c),Ug(b,d,e,c),Wg(b,d,e,c),vi(null,b,d,!0,a,c);case 19:return Bi(a,b,c)}throw Error(u(156,b.tag));};var kk=null,Wi=null;
function ok(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);kk=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Wi=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function pk(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function gi(a,b,c,d){return new pk(a,b,c,d)}
function qi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function nk(a){if("function"===typeof a)return qi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===Oa)return 11;if(a===Ra)return 14}return 2}
function ah(a,b){var c=a.alternate;null===c?(c=gi(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function ch(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)qi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case Ia:return eh(c.children,e,f,b);case Na:g=8;e|=7;break;case Ja:g=8;e|=1;break;case Ka:return a=gi(12,c,b,e|8),a.elementType=Ka,a.type=Ka,a.expirationTime=f,a;case Pa:return a=gi(13,c,b,e),a.type=Pa,a.elementType=Pa,a.expirationTime=f,a;case Qa:return a=gi(19,c,b,e),a.elementType=Qa,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case La:g=
10;break a;case Ma:g=9;break a;case Oa:g=11;break a;case Ra:g=14;break a;case Sa:g=16;d=null;break a}throw Error(u(130,null==a?a:typeof a,""));}b=gi(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function eh(a,b,c,d){a=gi(7,a,d,b);a.expirationTime=c;return a}function bh(a,b,c){a=gi(6,a,null,b);a.expirationTime=c;return a}
function dh(a,b,c){b=gi(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function qk(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Pj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function Mj(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function Nj(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Rj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function rk(a,b,c,d){var e=b.current,f=Pg(),g=Mg.suspense;f=Qg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(ec(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=If(c,k,h);break a}}c=h}else c=Cf;null===b.context?b.context=c:b.pendingContext=c;b=Bg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);Dg(e,b);Rg(e,f);return f}function sk(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function tk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function uk(a,b){tk(a,b);(a=a.alternate)&&tk(a,b)}
function vk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new qk(a,b,c),e=gi(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;a[we]=d.current;c&&0!==b&&wc(9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}vk.prototype.render=function(a,b){rk(a,this._internalRoot,null,void 0===b?null:b)};vk.prototype.unmount=function(a){var b=this._internalRoot,c=void 0===a?null:a,d=b.containerInfo;rk(null,b,null,function(){d[we]=null;null!==c&&c()})};
function wk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function yk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new vk(a,0,b?{hydrate:!0}:void 0)}
function zk(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=sk(g);h.call(a)}}rk(b,g,a,e)}else{f=c._reactRootContainer=yk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=sk(g);k.call(a)}}ck(function(){rk(b,g,a,e)})}return sk(g)}function Ak(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ha,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
jc=function(a){if(13===a.tag){var b=lg(Pg(),150,100);Rg(a,b);uk(a,b)}};kc=function(a){if(13===a.tag){Pg();var b=kg++;Rg(a,b);uk(a,b)}};lc=function(a){if(13===a.tag){var b=Pg();b=Qg(b,a,null);Rg(a,b);uk(a,b)}};
Za=function(a,b,c){switch(b){case "input":Eb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=ye(d);if(!e)throw Error(u(90));zb(d);Eb(d,e)}}}break;case "textarea":Mb(a,c);break;case "select":b=c.value,null!=b&&Jb(a,!!c.multiple,b,!1)}};eb=bk;
fb=function(a,b,c,d){var e=T;T|=4;try{return fg(98,a.bind(null,b,c,d))}finally{T=e,T===S&&jg()}};gb=function(){(T&(1|oj|pj))===S&&(ak(),Sj())};hb=function(a,b){var c=T;T|=2;try{return a(b)}finally{T=c,T===S&&jg()}};function Bk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!wk(b))throw Error(u(200));return Ak(a,b,null,c)}
var Ck={createPortal:Bk,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=ic(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){if(!wk(b))throw Error(u(200));return zk(null,a,b,!0,c)},render:function(a,b,c){if(!wk(b))throw Error(u(200));return zk(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){if(!wk(c))throw Error(u(200));
if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return zk(a,b,c,!1,d)},unmountComponentAtNode:function(a){if(!wk(a))throw Error(u(40));return a._reactRootContainer?(ck(function(){zk(null,null,a,!1,function(){a._reactRootContainer=null;a[we]=null})}),!0):!1},unstable_createPortal:function(){return Bk.apply(void 0,arguments)},unstable_batchedUpdates:bk,flushSync:function(a,b){if((T&(oj|pj))!==S)throw Error(u(187));var c=T;T|=1;try{return fg(99,a.bind(null,b))}finally{T=c,jg()}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Cc,
xe,ye,Ca.injectEventPluginsByName,fa,Sc,function(a){ya(a,Rc)},cb,db,Pd,Ba,Sj,{current:!1}]}};
(function(a){var b=a.findFiberByHostInstance;return ok(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Ea.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=ic(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:Fc,bundleType:0,version:"16.12.0",
rendererPackageName:"react-dom"});var Dk={default:Ck},Ek=Dk&&Ck||Dk;module.exports=Ek.default||Ek;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(156);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.18.0
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=Math.floor((c-1)/2),e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};exports.unstable_cancelCallback=function(a){a.callback=null};
exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_requestPaint=Z;exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_Profiling=null;


/***/ }),
/* 157 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 158 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Routes_Routes__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_css__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Loader_Loader__ = __webpack_require__(63);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this));_this.handleLoader=function(){_this.setState({isLoading:false});};_this.state={isLoading:true,currentBrowser:Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["d" /* getBrowser */])()// https://tc39.github.io/ecma262/#sec-array.prototype.find
};if(!Array.prototype.find){Object.defineProperty(Array.prototype,'find',{value:function value(predicate){// 1. Let O be ? ToObject(this value).
if(this==null){throw new TypeError('"this" is null or not defined');}var o=Object(this);// 2. Let len be ? ToLength(? Get(O, "length")).
var len=o.length>>>0;// 3. If IsCallable(predicate) is false, throw a TypeError exception.
if(typeof predicate!=='function'){throw new TypeError('predicate must be a function');}// 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
var thisArg=arguments[1];// 5. Let k be 0.
var k=0;// 6. Repeat, while k < len
while(k<len){// a. Let Pk be ! ToString(k).
// b. Let kValue be ? Get(O, Pk).
// c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
// d. If testResult is true, return kValue.
var kValue=o[k];if(predicate.call(thisArg,kValue,k,o)){return kValue;}// e. Increase k by 1.
k++;}// 7. Return undefined.
return undefined;}});}return _this;}_createClass(App,[{key:'render',value:function render(){var _this2=this;var cssClass='desktopVersion ';if(Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["h" /* isMobile */])()){cssClass=' MobileVersion ';}var version=this.state.currentBrowser.version;version=parseInt(version);// alert(this.state.currentBrowser)
var html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'App '+this.state.currentBrowser.name+'  '+this.state.currentBrowser.name+'-'+version+' '+cssClass},window.scrollTo(0,0),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Routes_Routes__["a" /* Routes */],null));if(this.state.isLoading===true){html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'App '+this.state.currentBrowser},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Loader_Loader__["a" /* default */],null));window.setTimeout(function(){_this2.handleLoader();},500);}return html;}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Pages_Home_Home__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Pages_SpacielDeals_SpacielDeals__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Pages_LiveShows_LiveShows__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Pages_ExporeTelAvivAndJerusalem_ExporeTelAvivAndJerusalem__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Pages_TermsOfUse_TermsOfUse__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Pages_ThingsToDo_ThingsToDo__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Pages_WhereToGo_WhereToGo__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Pages_FAQ_FAQ__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Pages_TelAvivPage_TelAvivPage__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Pages_JerusalemPage_JerusalemPage__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Pages_CulinaryPage_CulinaryPage__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Pages_DeadSeaPage_DeadSeaPage__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Pages_TouristInfo_TouristInfoPage__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Pages_EilatNegevPage_EilatNegevPage__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Pages_NorthPage_NorthPage__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Pages_CoronaVirusPage_CoronaVirus__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Posts_Videos_Videos__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Posts_Concerts_Concerts__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Posts_Posts_Posts__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Pages_Gallery_TA_GalleryTA__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Pages_Gallery_JA_GalleryJA__ = __webpack_require__(297);
/*
DEFINE CLIENT APP ROUTS 
*/// pages
// Posts
// Gallery
var Routes=function Routes(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/TelAvivPage',component:__WEBPACK_IMPORTED_MODULE_10__Pages_TelAvivPage_TelAvivPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/EilatNegevPage',component:__WEBPACK_IMPORTED_MODULE_15__Pages_EilatNegevPage_EilatNegevPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/NorthPage',component:__WEBPACK_IMPORTED_MODULE_16__Pages_NorthPage_NorthPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/JerusalemPage',component:__WEBPACK_IMPORTED_MODULE_11__Pages_JerusalemPage_JerusalemPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/CulinaryPage',component:__WEBPACK_IMPORTED_MODULE_12__Pages_CulinaryPage_CulinaryPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/DeadSeaPage',component:__WEBPACK_IMPORTED_MODULE_13__Pages_DeadSeaPage_DeadSeaPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/TourisInfoPage',component:__WEBPACK_IMPORTED_MODULE_14__Pages_TouristInfo_TouristInfoPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/CoronaVirusPage',component:__WEBPACK_IMPORTED_MODULE_17__Pages_CoronaVirusPage_CoronaVirus__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/FAQ',component:__WEBPACK_IMPORTED_MODULE_9__Pages_FAQ_FAQ__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/thingsToDo',component:__WEBPACK_IMPORTED_MODULE_7__Pages_ThingsToDo_ThingsToDo__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/whereToGo',component:__WEBPACK_IMPORTED_MODULE_8__Pages_WhereToGo_WhereToGo__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/bestDeals',component:__WEBPACK_IMPORTED_MODULE_3__Pages_SpacielDeals_SpacielDeals__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/Gallery/:galleryId',component:__WEBPACK_IMPORTED_MODULE_21__Pages_Gallery_TA_GalleryTA__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/Gallery/',component:__WEBPACK_IMPORTED_MODULE_21__Pages_Gallery_TA_GalleryTA__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/TermsOfUse',component:__WEBPACK_IMPORTED_MODULE_6__Pages_TermsOfUse_TermsOfUse__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/Videos',component:__WEBPACK_IMPORTED_MODULE_5__Pages_ExporeTelAvivAndJerusalem_ExporeTelAvivAndJerusalem__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Posts/Videos/:ctgId/:vidId',component:__WEBPACK_IMPORTED_MODULE_18__Posts_Videos_Videos__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Posts/:ctgId/:id',component:__WEBPACK_IMPORTED_MODULE_20__Posts_Posts_Posts__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/',component:__WEBPACK_IMPORTED_MODULE_2__Pages_Home_Home__["a" /* default */]}));};

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(51);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(164);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);


/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction) {
    throw new Error(prefix);
  } else {
    throw new Error(prefix + ": " + (message || ''));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (invariant);


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(51);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(172);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(52);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(91);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(176);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(178);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(95);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(180);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(52);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(182);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(53);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(95);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(53);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(186);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(93);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_scroll__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactjs_popup__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_lazyload__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Components_Deals_DealItem__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Components_Footer_Footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Components_SimpleSlider_SimpleSlider__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Home_css__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Home_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__Home_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import AgreeCookies from '../../Components/AgreeCookies/AgreeCookies'
// private class data
var galleryObj1={img:"Home/7.jpg",link:"/Pages/Gallery/ta",text:"TEL AVIV"};var galleryObj2={img:"Home/8.jpg",link:"/Pages/Gallery/ja",text:"JERUSALEM"};var galleryObj3={img:"Home/9.jpg",link:"/Pages/Gallery/deadsea",text:"DAS TOTE MEER"};var galleryObj4={img:"Home/10.jpg",link:"/Pages/Gallery/yp",text:"IHRE FOTOS"};function Shuffle(o){for(var j,x,i=o.length;i;j=parseInt(Math.random()*i),x=o[--i],o[i]=o[j],o[j]=x){}return o;}var Home=function(_Component){_inherits(Home,_Component);function Home(props){_classCallCheck(this,Home);var _this=_possibleConstructorReturn(this,(Home.__proto__||Object.getPrototypeOf(Home)).call(this,props));_this.updateDimensions=function(){var w=window,d=document,documentElement=d.documentElement,body=d.getElementsByTagName("body")[0],width=w.innerWidth||documentElement.clientWidth||body.clientWidth;// height = w.innerHeight|| documentElement.clientHeight|| body.clientHeight;
_this.setState({width:width});};_this.openModal=function(id){var url=Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["f" /* getUrl */])()+"instagram-api.php?ID="+id;// var url = 'https://www.instagram.com/p/'+id+'/?tagged=takeme2telaviv&__a=1';
__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url,{}).then(function(res){var obj=res.data;var userinfo=obj.graphql.shortcode_media;var likes=userinfo.edge_media_preview_like.count;var username=userinfo.owner.username;var caption=userinfo.edge_media_to_caption.edges[0].node.text;var userProfileImg=userinfo.owner.profile_pic_url;// console.log(username);
_this.setState({open:true,instagramId:id,instagramUserImg:userProfileImg,instagramCaption:caption,instagramUserName:username,instagramLikes:likes});});};_this.closeModal=function(){_this.setState({open:false});};_this.playVideo=function(event){// alert(this.state.imageState);
_this.setState({imageState:false});};_this.playVideo2=function(event){// alert(this.state.imageState);
_this.setState({imageState2:false});};_this.playVideo3=function(event){// alert(this.state.imageState);
_this.setState({imageState3:false});};_this.playVideo4=function(event){// alert(this.state.imageState);
_this.setState({imageState4:false});};_this.playVideo5=function(event){// alert(this.state.imageState);
_this.setState({imageState5:false});};_this.playVideo6=function(event){// alert(this.state.imageState);
_this.setState({imageState6:false});};_this.playVideo7=function(event){// alert(this.state.imageState);
_this.setState({imageState7:false});};_this.playVideo8=function(event){// alert(this.state.imageState);
_this.setState({imageState8:false});};_this.playVideo9=function(event){// alert(this.state.imageState);
_this.setState({imageState9:false});};_this.playVideo10=function(event){// alert(this.state.imageState);
_this.setState({imageState10:false});};_this.closeAlert=function(event){document.getElementById("travel-alert").style.display="none";};_this.setVideoMobile=function(vidId,id){// alert('setVideoMobile : ' +   vidId);
_this.setState({MobileVidId1:vidId,MobileVidId1Elm:id});};_this.setVideoMobile2=function(vidId,id){// alert('setVideoMobile : ' +   vidId);
_this.setState({MobileVidId2:vidId,MobileVidId2Elm:id});};_this.setVideoMobile3=function(vidId,id){// alert('setVideoMobile : ' +   vidId);
_this.setState({MobileVidId3:vidId,MobileVidId3Elm:id});};_this.setVideo=function(vidId,ctg){// alert("ss");
if(ctg==="culinary"||ctg==="culinarytelaviv"||ctg==="culinaryjerusalem"||ctg==="culinarynorth"){_this.setState({culinaryVid:vidId});var e=document.getElementById("CULINARY");__WEBPACK_IMPORTED_MODULE_2_react_scroll__["animateScroll"].scrollTo(e.offsetTop-100);if(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["h" /* isMobile */]){_this.setState({imageState7:false});}}else{var elm=document.getElementById("expore-tel-aviv-and-jerusalem");__WEBPACK_IMPORTED_MODULE_2_react_scroll__["animateScroll"].scrollTo(elm.offsetTop-100);_this.setState({exporeTelAvivAndjerusalemMainVid:vidId});if(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["h" /* isMobile */]){_this.setState({imageState8:false});}}};_this.setCurrentFaq=function(id){var faq=[].concat(_toConsumableArray(_this.state.faq));var current=faq.find(function(o){return o.id===id;});if(current.isOpen===true){current.isOpen=false;}else{current.isOpen=true;}_this.setState({faq:faq});};_this.handleisVidClick=function(){_this.setState({isVidClick:!_this.state.isVidClick});};_this.playVideo=_this.playVideo.bind(_this);_this.playVideo2=_this.playVideo2.bind(_this);_this.playVideo3=_this.playVideo3.bind(_this);_this.playVideo4=_this.playVideo4.bind(_this);_this.state={isVidClick:false,instagramData:[],instagramDataMobile:[],northArrMobile:[],// isLoading : true;
// exporeTelAvivAndjerusalemMainVid: "5nqL-oIC0GA", old video
// exporeTelAvivAndjerusalemMainVid: "nLKWDp5uA-U", changed at 17.05.2020
exporeTelAvivAndjerusalemMainVid:"FYtk8JMMZRE",eurovisionMainVid:"5PAjhoH0NWU",TelAvivAndjerusalemVideoState:0,culinaryVid:"jfyHxk8ZRrI",culinaryVidState:0,faq:__WEBPACK_IMPORTED_MODULE_9__Data_Data__["c" /* faqData */],telAvivWeather:20,waterTemp:20,jerusalemWeather:20,deadSeaWeather:15,shirCssClass:" btn-shir",supportCssClass:" new-support-btn",open:false,instagramId:null,instagramUserImg:null,instagramCaption:null,instagramUserName:null,instagramLikes:null,imageState:true,imageState2:true,imageState3:true,imageState4:true,imageState5:true,imageState6:true,imageState7:true,imageState8:true,imageState9:true,imageState10:true,width:0,MobileVidId1:"",MobileVidId1Elm:"",MobileVidId2:"",MobileVidId2Elm:"",MobileVidId3:"",MobileVidId3Elm:"",isInit:true};return _this;}_createClass(Home,[{key:"componentWillMount",value:function componentWillMount(){this.updateDimensions();}},{key:"componentWillUnmount",value:function componentWillUnmount(){window.removeEventListener("resize",this.updateDimensions);}},{key:"componentDidMount",value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["a" /* asyncgetWeather */])(),Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["c" /* geinstagramData */])()]).then(function(response){var weather=response[0];var instagramData=response[1];// console.log( typeof weather);
// console.log( weather);
var weather2=weather;if(typeof weather==='string'&&weather.includes("float")){// Variable is a string
// console.log('Is float in string');
var str=weather.substring(weather.indexOf("{")+1);var str2="{"+str;// console.log(str2);
weather2=JSON.parse(str2);}else if((typeof weather==="undefined"?"undefined":_typeof(weather))==='object'&&weather!==null){// Variable is an object
// console.log('Variable is an object');
weather2=weather.data;// console.log(weather2);
}else if(typeof weather==='string'&&!weather.includes("float")){// console.log('Is NOt  float in string');
var _str=weather.substring(weather.indexOf("{")+1);var _str2="{"+_str;// console.log(str2);
weather2=JSON.parse(_str2);}//  else {
//   // Variable is neither a string nor an object
//   console.log('Variable is neither a string nor an object');
// }
_this2.setState({instagramData:instagramData.posts,deadSeaWeather:weather2.deadsea.temperature,jerusalemWeather:weather2.jerusalem.temperature,telAvivWeather:weather2.telaviv.temperature,waterTemp:weather2.telaviv.water_temp});});window.addEventListener("resize",this.updateDimensions);}//This was added for mobile youtube butn play
},{key:"render",value:function render(){var _this3=this;var remindersHtml=__WEBPACK_IMPORTED_MODULE_9__Data_Data__["a" /* Reminders */].map(function(o,i){var cssClass="";if(o.hasOwnProperty("cssClass")){cssClass=o.cssClass;}var job="";if(o.hasOwnProperty("job")){job=o.job;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Components_Deals_DealItem__["a" /* DealItem */],{brand:o.site,isReminder:true,price:"“"+o.quote+"”",desc:"",brandImg:o.img,cssClass:cssClass,ctg:o.ctg,job:o.job,callToActionText:"READ MORE"});});var sliderSettings={dots:false,autoplay:true,// lazyLoad: 'ondemand',
infinite:true,lazyLoad:"ondemand",cssEase:"linear",slidesToShow:this.props.items!==undefined?this.props.items:3,slidesToScroll:3,responsive:[{breakpoint:1000,settings:{slidesToShow:2,slidesToScroll:2}},{breakpoint:600,settings:{slidesToShow:1,slidesToScroll:1}}]};var sliderSettings2={dots:false,autoplay:true,// lazyLoad: 'ondemand',
infinite:true,lazyLoad:"ondemand",cssEase:"linear",slidesToShow:this.props.items!==undefined?this.props.items:3,slidesToScroll:3,responsive:[{breakpoint:1000,settings:{slidesToShow:2,slidesToScroll:1}},{breakpoint:600,settings:{slidesToShow:1,slidesToScroll:1}}]};var culinaryArr=[];var postsArr=[];var videoArr=[];var eurovisionArr=[];var eilatNegevArr=[];var jerusalemArr=[];var telavivArr=[];var northArr=[];var deadseaArr=[];__WEBPACK_IMPORTED_MODULE_9__Data_Data__["d" /* newPosts */].map(function(o){// console.log('o' , o);
if(o.ctg==="culinary"||o.ctg==="culinarytelaviv"||o.ctg==="culinaryjerusalem"||o.ctg==="culinarynorth"){culinaryArr.push(o);}else if(o.ctg==="eurovision"){eurovisionArr.push(o);}else if(o.ctg==="eilat-negev"){eilatNegevArr.push(o);}else if(o.ctg==="north"){northArr.push(o);}else if(o.ctg==="jerusalem"){jerusalemArr.push(o);}else if(o.ctg==="telaviv"){telavivArr.push(o);}else if(o.ctg==="deadsea"){deadseaArr.push(o);}else{postsArr.push(o);}});// console.log("newVideos:", newVideos);
__WEBPACK_IMPORTED_MODULE_9__Data_Data__["e" /* newVideos */].map(function(o){// console.log('o' , o);
if(o.isVid===true||o.forVidPage===true){videoArr.push(o);}});// videoArr = Shuffle(videoArr);
// console.log('Shuffle vid' , videoArr);
var videoMobileArr=[];if(videoArr.length>0){var size=1;if(this.state.width<1000){size=2;}if(this.state.width<600){size=4;}while(videoArr.length){// console.log( 'easd' ,  postsArr.splice(0,4) );
videoMobileArr.push(videoArr.splice(0,size));}}var videosHtml=null;if(videoMobileArr.length>0){videosHtml=videoMobileArr.map(function(arr,i){return arr.map(function(o,i){var title=o.title;var url="Posts/"+o.ctg+"/"+o.id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["q" /* VideoSliderItem */],{key:i,title:o.title,desc:o.desc,img:o.img,link:url,doBlank:true,mobileId:"",click:function click(){_this3.setVideo(o.vidId,o.ctg);}});});});videosHtml=videosHtml.map(function(o,i){// console.log(o);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:i},o);});}var postsHtml=postsArr.map(function(o,i){// const url = "/Posts/" + o.id ;
var url="/Posts/"+o.ctg+"/"+o.id;if(o.hasOwnProperty("showOnHome")&&o.showOnHome===false){}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["n" /* PostSliderItem */],{key:i,title:o.title,desc:o.sml_desc,doBlank:true,img:o.img,link:url});}});var deadseamObileArr=[];if(deadseaArr.length>0){var size=1;if(this.state.width<1000){size=2;}if(this.state.width<600){size=4;}while(deadseaArr.length){// console.log( 'easd' ,  deadseaArr.splice(0,4) );
deadseamObileArr.push(deadseaArr.splice(0,size));}}var deadseaPostsHtml=null;if(deadseamObileArr.length>0){deadseaPostsHtml=deadseamObileArr.map(function(arr,i){return arr.map(function(o,i){var title=o.title;var url="Posts/"+o.ctg+"/"+o.id;// if ( this.state.width < 1000 ){
//     title = o.title + ' >';
// }
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["n" /* PostSliderItem */],{key:i,title:title,desc:o.sml_desc,doBlank:true,img:o.img,link:url});});});deadseaPostsHtml=deadseaPostsHtml.map(function(o,i){// console.log(o);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:i},o);});}var eilatNegevmObileArr=[];if(eilatNegevArr.length>0){var size=1;if(this.state.width<1000){size=2;}if(this.state.width<600){size=4;}while(eilatNegevArr.length){// console.log( 'easd' ,  eilatNegevArr.splice(0,4) );
eilatNegevmObileArr.push(eilatNegevArr.splice(0,size));}}var eilatNegevPostsHtml=null;if(eilatNegevmObileArr.length>0){eilatNegevPostsHtml=eilatNegevmObileArr.map(function(arr,i){return arr.map(function(o,i){var title=o.title;var url="Posts/"+o.ctg+"/"+o.id;// if ( this.state.width < 1000 ){
//     title = o.title + ' >';
// }
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["n" /* PostSliderItem */],{key:i,title:title,desc:o.sml_desc,doBlank:true,img:o.img,link:url});});});eilatNegevPostsHtml=eilatNegevPostsHtml.map(function(o,i){// console.log(o);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:i},o);});}var jerusalemmObileArr=[];if(jerusalemArr.length>0){var size=1;if(this.state.width<1000){size=2;}if(this.state.width<600){size=4;}while(jerusalemArr.length){// console.log( 'easd' ,  jerusalemArr.splice(0,4) );
jerusalemmObileArr.push(jerusalemArr.splice(0,size));}}var jerusalemPostsHtml=null;if(jerusalemmObileArr.length>0){jerusalemPostsHtml=jerusalemmObileArr.map(function(arr,i){return arr.map(function(o,i){var title=o.title;var url="Posts/"+o.ctg+"/"+o.id;// if ( this.state.width < 1000 ){
//     title = o.title + ' >';
// }
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["n" /* PostSliderItem */],{key:i,title:title,desc:o.sml_desc,doBlank:true,img:o.img,link:url});});});jerusalemPostsHtml=jerusalemPostsHtml.map(function(o,i){// console.log(o);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:i},o);});}var telavivmObileArr=[];if(telavivArr.length>0){var size=1;if(this.state.width<1000){size=2;}if(this.state.width<600){size=4;}while(telavivArr.length){// console.log( 'easd' ,  telavivArr.splice(0,4) );
telavivmObileArr.push(telavivArr.splice(0,size));}}var telavivPostsHtml=null;if(telavivmObileArr.length>0){telavivPostsHtml=telavivmObileArr.map(function(arr,i){return arr.map(function(o,i){var title=o.title;var url="Posts/"+o.ctg+"/"+o.id;// if ( this.state.width < 1000 ){
//     title = o.title + ' >';
// }
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["n" /* PostSliderItem */],{key:i,title:title,desc:o.sml_desc,doBlank:true,img:o.img,link:url});});});telavivPostsHtml=telavivPostsHtml.map(function(o,i){// console.log(o);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:i},o);});}var northmObileArr=[];if(northArr.length>0){var size=1;if(this.state.width<1000){size=2;}if(this.state.width<600){size=4;}while(northArr.length){// console.log( 'easd' ,  northArr.splice(0,4) );
northmObileArr.push(northArr.splice(0,size));}}var northPostsHtml=null;if(northmObileArr.length>0){northPostsHtml=northmObileArr.map(function(arr,i){return arr.map(function(o,i){var title=o.title;var url="Posts/"+o.ctg+"/"+o.id;// if ( this.state.width < 1000 ){
//     title = o.title + ' >';
// }
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["n" /* PostSliderItem */],{key:i,title:title,desc:o.sml_desc,doBlank:true,img:o.img,link:url});});});northPostsHtml=northPostsHtml.map(function(o,i){// console.log(o);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:i},o);});}var culinaryMobileArr=[];if(culinaryArr.length>0){var size=1;if(this.state.width<1000){size=2;}if(this.state.width<600){size=4;}while(culinaryArr.length){// console.log( 'easd' ,  culinaryArr.splice(0,4) );
culinaryMobileArr.push(culinaryArr.splice(0,size));}}var culinaryHtml=null;if(culinaryMobileArr.length>0){culinaryHtml=culinaryMobileArr.map(function(arr,i){return arr.map(function(o,i){var title=o.title;var url="Posts/"+o.ctg+"/"+o.id;// if ( this.state.width < 1000 ){
//     title = o.title + ' >';
// }
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["q" /* VideoSliderItem */],{key:i,title:o.title,desc:o.desc,img:o.img,link:url,doBlank:true,mobileId:"",click:function click(){_this3.setVideo(o.vidId,o.ctg);}});});});culinaryHtml=culinaryHtml.map(function(o,i){// console.log(o);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:i},o);});}var eurovisionHtml=eurovisionArr.map(function(o,i){// const url = "/Posts/" + o.id ;
var url="/Posts/"+o.ctg+"/"+o.id;if(o.hasOwnProperty("showOnHome")&&o.showOnHome===false){}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["n" /* PostSliderItem */],{key:i,title:o.title,desc:o.sml_desc,doBlank:true,img:o.img,link:url});}});var date1=new Date();var hasBean=[];var notHasBean=[];__WEBPACK_IMPORTED_MODULE_9__Data_Data__["f" /* showsArr */].map(function(o,i){var isTodayBigger=Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["b" /* compareDates */])(date1,o.date);if(isTodayBigger===true||o.date==="30.12.2017"||o.date==="21.06.2018"){// o.cssClass +=" addOpacity ";
// hasBean.push(o);
}else{o.cssClass="";notHasBean.push(o);}});// marge two array into array
var newshowsArr=[].concat(notHasBean,hasBean);var concertsmObileArr=[];if(newshowsArr.length>0){var size=1;if(this.state.width<1000){size=2;}if(this.state.width<600){size=4;}while(newshowsArr.length){// console.log( 'easd' ,  newshowsArr.splice(0,4) );
concertsmObileArr.push(newshowsArr.splice(0,size));}}var concertSHtml=null;if(concertsmObileArr.length>0){concertSHtml=concertsmObileArr.map(function(arr,i){return arr.map(function(o,i){var title=o.title;if(_this3.state.width<1000){title=o.title;}var url="Posts/Concerts/"+o.id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["n" /* PostSliderItem */],{key:o.id,title:title,desc:o.sml_desc,doBlank:true,img:o.img,link:url});});});concertSHtml=concertSHtml.map(function(o,i){// console.log(o);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:i},o);});}var faqHtml=this.state.faq.map(function(o){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["e" /* FaqItem */],{q:o.q,answer:o.answer,key:o.id,isOpen:o.isOpen,click:function click(){_this3.setCurrentFaq(o.id);}});});var instagramHtml=null;var img1Url="Home/Mobile/1.jpg";var img2Url="Home/Mobile/2.jpg";var img3Url="Home/Mobile/3.jpg";var img4Url="Home/Mobile/4.jpg";var callToActionHtml="";var twoCitesOneBreakVid="";var euroVisionVid="";var culinaryVid="";var galleryHTML=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["k" /* ImgAndText */],{img:galleryObj1.img,cssClass:"col-100",link:galleryObj1.link,text:galleryObj1.text}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["k" /* ImgAndText */],{img:galleryObj3.img,cssClass:"col-100",link:galleryObj3.link,text:galleryObj3.text}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["k" /* ImgAndText */],{img:galleryObj2.img,cssClass:"col-100",link:galleryObj2.link,text:galleryObj2.text}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["k" /* ImgAndText */],{img:galleryObj4.img,cssClass:"col-100",link:galleryObj4.link,text:galleryObj4.text}));if(this.state.width>1000){callToActionHtml=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["b" /* AnimateCallToAction */],{src:"btn_shir.png",cssClass:this.state.shirCssClass,link:"/international/Pages/bestDeals"}));img1Url="Home/1.jpg";img2Url="Home/2.jpg";img3Url="Home/3.jpg";img4Url="Home/4.jpg";{/*euroVisionVid = <div className="hide-on-mobile">
                <ResponsiveYouTubeIframe vidId={this.state.eurovisionMainVid}  />
              </div>*/}{/*twoCitesOneBreakVid = <div className="hide-on-mobile">
                <ResponsiveYouTubeIframe vidId={this.state.exporeTelAvivAndjerusalemMainVid}  />
              </div>*/}{/*culinaryVid = <div className="hide-on-mobile">
        <ResponsiveYouTubeIframe vidId={this.state.culinaryVid} />
      </div>
      galleryHTML = <div className="row more-info-row">
                      <ImgAndText img={galleryObj1.img} cssClass={" col-33"} link={galleryObj1.link} text={galleryObj1.text} />
                      <ImgAndText img={galleryObj2.img} cssClass={" col-33"} link={galleryObj2.link} text={galleryObj2.text} />
                      <ImgAndText img={galleryObj3.img} cssClass={" col-33"} link={galleryObj3.link} text={galleryObj3.text} />

                  </div>*/}}else{galleryHTML=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row more-info-row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["k" /* ImgAndText */],{img:galleryObj1.img,cssClass:" col-33",link:galleryObj1.link,text:galleryObj1.text}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["k" /* ImgAndText */],{img:galleryObj2.img,cssClass:" col-33",link:galleryObj2.link,text:galleryObj2.text}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["k" /* ImgAndText */],{img:galleryObj3.img,cssClass:" col-33",link:galleryObj3.link,text:galleryObj3.text}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["k" /* ImgAndText */],{img:galleryObj4.img,cssClass:" col-33",link:galleryObj4.link,text:galleryObj4.text}));}var instagramData=this.state.instagramData;// console.log('instagramData: ' , instagramData);
var insta_size=2;// if ( this.state.width < 1000 ) {
//     size = 4;
// }
if(this.state.width<600){insta_size=4;}if(instagramData.length>0){while(instagramData.length>0){this.state.instagramDataMobile.push(instagramData.splice(0,insta_size));}}if(this.state.instagramDataMobile.length>0){instagramHtml=this.state.instagramDataMobile.map(function(arr,i){return arr.map(function(o,i){var imgLink="instagram/"+o.id+".jpg";if(_this3.state.width<600){imgLink="instagram/Mobile/"+o.id+".jpg";}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:o.id,onClick:function onClick(){_this3.openModal(o.id);}}," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["l" /* InstagremSliderItem */],{title:o.publishBy,cssClass:"InstagremSliderItem-"+i,img:imgLink}));});});// console.log('instagramHtml2' , instagramHtml2);
instagramHtml=instagramHtml.map(function(o,i){// console.log(o);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:i},o);});}var currentInstagramLikeUrl="https://www.instagram.com/p/"+this.state.instagramId+"/";var currentInstagramUrl="https://www.instagram.com/"+this.state.instagramUserName+"/";var currentInstagramImgUrl="instagram/"+this.state.instagramId+".jpg";var a=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["h" /* HomeSlider */],{isHomeSlider:true,waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}));// if ( this.state.isVidClick === true ){
//   a = <section className="home-section caruasel-wrapper banners-caruasel-wrapper" id="part-1" >
//   <ResponsiveYouTubeIframe vidId={"5PAjhoH0NWU"} />
//   </section>
// }
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"page align-center page-home"},callToActionHtml,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["p" /* TravelAlert */],{click:this.closeAlert}),a,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["g" /* HomeDeals */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:50},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding weather-section hide-on-mobile",id:"weather-section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["i" /* HomeTitle */],null,"HILFREICHE INFORMATIONEN"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"weather-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["r" /* WeatherIcon */],{label:"FLUGDAUER",temp:"4h25"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["r" /* WeatherIcon */],{label:"WASSERTEMPERATUR",temp:this.state.waterTemp}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["r" /* WeatherIcon */],{label:"TEL AVIV WETTER",temp:this.state.telAvivWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["r" /* WeatherIcon */],{label:"JERUSALEM WETTER",temp:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["r" /* WeatherIcon */],{label:"DAS TOTE MEER WETTER",temp:this.state.deadSeaWeather}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:50},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding weather-section",id:"video"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["i" /* HomeTitle */],null,"PLANEN SIE IHRE REISE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["h" /* isMobile */])()&&this.state.imageState?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["a" /* ActivaImg */],{src:"PostCarousel/video_mob/activa-img-explure-israel.jpg",click:this.playVideo}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:"YiVOqHHMGo4"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"more-info-wrapper add-margin-top"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row more-info-row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["k" /* ImgAndText */],{img:img1Url,cssClass:"first",link:"/Pages/whereToGo",text:"SEHEN >"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["k" /* ImgAndText */],{img:img2Url,cssClass:"last",link:"/Pages/thingsToDo",text:"ERLEBEN >"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row more-info-row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["k" /* ImgAndText */],{img:img4Url,cssClass:"first",link:"/Pages/TourisInfoPage",text:"TOURISTENINFO >"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["k" /* ImgAndText */],{img:img3Url,cssClass:"last",link:"/Pages/Videos",text:"VIDEOS >"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:100},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding weather-section",id:"expore-tel-aviv-and-jerusalem"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["i" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Pages/thingsToDo",className:"ac-plan-your-trip"},"ES GIBT MEHR ZU ERLEBEN")),Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["h" /* isMobile */])()&&this.state.imageState8?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["a" /* ActivaImg */],{src:"PostCarousel/video_mob/activa-img-more-things-todo.jpg",click:this.playVideo8}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:this.state.exporeTelAvivAndjerusalemMainVid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"video-slider-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},videosHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:400},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding weather-section",id:"jerusalem-posts"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["i" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Pages/JerusalemPage",className:"ac-jerusalem-posts"},"JERUSALEM")),Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["h" /* isMobile */])()&&this.state.imageState9?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["a" /* ActivaImg */],{src:"PostCarousel/video_mob/activa-img-jerusalem.jpg",click:this.playVideo9}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:"nLKWDp5uA-U"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"video-slider-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},jerusalemPostsHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:400},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding weather-section",id:"telaviv-posts"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["i" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Pages/TelavivPage",className:"ac-telaviv-posts"},"TEL AVIV")),Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["h" /* isMobile */])()&&this.state.imageState10?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["a" /* ActivaImg */],{src:"PostCarousel/video_mob/activa-img-telaviv.jpg",click:this.playVideo10}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:"XDei1Zy_cu4"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"video-slider-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},telavivPostsHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:100},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding weather-section",id:"CULINARY"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["i" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Pages/CulinaryPage",className:"ac-coolinary-exp"},"DIE BESTEN SPEISEN DER WELT")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["h" /* isMobile */])()&&this.state.imageState7?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["a" /* ActivaImg */],{src:"PostCarousel/video_mob/activa-img-culinary.jpg",click:this.playVideo7}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:this.state.culinaryVid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"video-slider-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},culinaryHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:400},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding weather-section",id:"deadsea-posts"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["i" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Pages/DeadSeaPage",className:"ac-dead-posts"},"DAS TOTE MEER")),Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["h" /* isMobile */])()&&this.state.imageState2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["a" /* ActivaImg */],{src:"PostCarousel/video_mob/activa-img-deadsea.jpg",click:this.playVideo2}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:"8p4qfkneH1c"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"video-slider-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},deadseaPostsHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:400},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding weather-section",id:"eilat-negev-posts"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["i" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Pages/EilatNegevPage",className:"ac-eilat-negev-posts"},"NEGEV UND EILAT")),Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["h" /* isMobile */])()&&this.state.imageState3?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["a" /* ActivaImg */],{src:"PostCarousel/video_mob/activa-img-negev-eilat.jpg",click:this.playVideo3}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:"ZdnNT-GDJv4"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"video-slider-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},eilatNegevPostsHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:400},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding weather-section",id:"north"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["i" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Pages/NorthPage",className:"ac-north-posts"},"NOORDEN")),Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["h" /* isMobile */])()&&this.state.imageState4?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["a" /* ActivaImg */],{src:"PostCarousel/video_mob/activa-img-north.jpg",click:this.playVideo4}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:"fZ_WdHpHRT8"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"video-slider-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings2},northPostsHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:400},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding weather-section",id:"instagram"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["i" /* HomeTitle */],null,"IHRE FOTOS VON ISRAEL"),Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["h" /* isMobile */])()&&this.state.imageState5?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["a" /* ActivaImg */],{src:"PostCarousel/video_mob/activa-img-insta.jpg",click:this.playVideo5}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:"z0OoUqKkwwM"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"ac-credit-home"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Credit:Fabio Wibmer")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"video-slider-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},instagramHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:400},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding weather-section",id:"shows"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["i" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Pages/liveShows",className:"ac-shows"},"TRIFF ALL DEINE STARS & ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",{className:"show-on-mobile"})," ","EVENTS IN TEL AVIV")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"video-slider-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},concertSHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:400},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding weather-section",id:"gallery"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["i" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Pages/Gallery/",className:"ac-gallery-home-page"},"GALERIE")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),galleryHTML,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:400},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding ",id:"faq"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["i" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Pages/FAQ",className:"ac-faq"},"FAQ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"faq-wrapper"},faqHtml),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["g" /* HomeDeals */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:400},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Components_Footer_Footer__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactjs_popup__["a" /* default */],{open:this.state.open,closeOnDocumentClick:true,onClose:this.closeModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"close",onClick:this.closeModal},"\xD7"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"userImgInstagram"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["j" /* Img */],{desktopImg:currentInstagramImgUrl})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"user-info-instagram"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",href:currentInstagramUrl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"userProfileImgWrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:this.state.instagramUserImg})),"@",this.state.instagramUserName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"instagramCaption"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,this.state.instagramCaption!==null?Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["i" /* limitText */])(this.state.instagramCaption,130):""))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",href:currentInstagramLikeUrl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"like-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["j" /* Img */],{desktopImg:"like.png"}))))));}}]);return Home;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Home);

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _scrollLink = __webpack_require__(54);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LinkElement = function (_React$Component) {
  _inherits(LinkElement, _React$Component);

  function LinkElement() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LinkElement);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LinkElement.__proto__ || Object.getPrototypeOf(LinkElement)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
      return _react2.default.createElement(
        'a',
        _this.props,
        _this.props.children
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return LinkElement;
}(_react2.default.Component);

;

exports.default = (0, _scrollLink2.default)(LinkElement);

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = throttle;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  /*
   * https://github.com/oblador/angular-scroll (duScrollDefaultEasing)
   */
  defaultEasing: function defaultEasing(x) {
    if (x < 0.5) {
      return Math.pow(x * 2, 2) / 2;
    }
    return 1 - Math.pow((1 - x) * 2, 2) / 2;
  },
  /*
   * https://gist.github.com/gre/1650294
   */
  // no easing, no acceleration
  linear: function linear(x) {
    return x;
  },
  // accelerating from zero velocity
  easeInQuad: function easeInQuad(x) {
    return x * x;
  },
  // decelerating to zero velocity
  easeOutQuad: function easeOutQuad(x) {
    return x * (2 - x);
  },
  // acceleration until halfway, then deceleration
  easeInOutQuad: function easeInOutQuad(x) {
    return x < .5 ? 2 * x * x : -1 + (4 - 2 * x) * x;
  },
  // accelerating from zero velocity 
  easeInCubic: function easeInCubic(x) {
    return x * x * x;
  },
  // decelerating to zero velocity π
  easeOutCubic: function easeOutCubic(x) {
    return --x * x * x + 1;
  },
  // acceleration until halfway, then deceleration 
  easeInOutCubic: function easeInOutCubic(x) {
    return x < .5 ? 4 * x * x * x : (x - 1) * (2 * x - 2) * (2 * x - 2) + 1;
  },
  // accelerating from zero velocity 
  easeInQuart: function easeInQuart(x) {
    return x * x * x * x;
  },
  // decelerating to zero velocity 
  easeOutQuart: function easeOutQuart(x) {
    return 1 - --x * x * x * x;
  },
  // acceleration until halfway, then deceleration
  easeInOutQuart: function easeInOutQuart(x) {
    return x < .5 ? 8 * x * x * x * x : 1 - 8 * --x * x * x * x;
  },
  // accelerating from zero velocity
  easeInQuint: function easeInQuint(x) {
    return x * x * x * x * x;
  },
  // decelerating to zero velocity
  easeOutQuint: function easeOutQuint(x) {
    return 1 + --x * x * x * x * x;
  },
  // acceleration until halfway, then deceleration 
  easeInOutQuint: function easeInOutQuint(x) {
    return x < .5 ? 16 * x * x * x * x * x : 1 + 16 * --x * x * x * x * x;
  }
};

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _passiveEventListeners = __webpack_require__(56);

var events = ['mousedown', 'mousewheel', 'touchmove', 'keydown'];

exports.default = {
  subscribe: function subscribe(cancelEvent) {
    return typeof document !== 'undefined' && events.forEach(function (event) {
      return (0, _passiveEventListeners.addPassiveEventListener)(document, event, cancelEvent);
    });
  }
};

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _scrollLink = __webpack_require__(54);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonElement = function (_React$Component) {
  _inherits(ButtonElement, _React$Component);

  function ButtonElement() {
    _classCallCheck(this, ButtonElement);

    return _possibleConstructorReturn(this, (ButtonElement.__proto__ || Object.getPrototypeOf(ButtonElement)).apply(this, arguments));
  }

  _createClass(ButtonElement, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'input',
        this.props,
        this.props.children
      );
    }
  }]);

  return ButtonElement;
}(_react2.default.Component);

;

exports.default = (0, _scrollLink2.default)(ButtonElement);

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _scrollElement = __webpack_require__(99);

var _scrollElement2 = _interopRequireDefault(_scrollElement);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ElementWrapper = function (_React$Component) {
  _inherits(ElementWrapper, _React$Component);

  function ElementWrapper() {
    _classCallCheck(this, ElementWrapper);

    return _possibleConstructorReturn(this, (ElementWrapper.__proto__ || Object.getPrototypeOf(ElementWrapper)).apply(this, arguments));
  }

  _createClass(ElementWrapper, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      // Remove `parentBindings` from props
      var newProps = _extends({}, this.props);
      if (newProps.parentBindings) {
        delete newProps.parentBindings;
      }

      return _react2.default.createElement(
        'div',
        _extends({}, newProps, { ref: function ref(el) {
            _this2.props.parentBindings.domNode = el;
          } }),
        this.props.children
      );
    }
  }]);

  return ElementWrapper;
}(_react2.default.Component);

;

ElementWrapper.propTypes = {
  name: _propTypes2.default.string,
  id: _propTypes2.default.string
};

exports.default = (0, _scrollElement2.default)(ElementWrapper);

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* DEPRECATED */

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(22);

var utils = __webpack_require__(32);
var scrollSpy = __webpack_require__(55);
var defaultScroller = __webpack_require__(31);
var PropTypes = __webpack_require__(5);
var scrollHash = __webpack_require__(98);

var protoTypes = {
  to: PropTypes.string.isRequired,
  containerId: PropTypes.string,
  container: PropTypes.object,
  activeClass: PropTypes.string,
  spy: PropTypes.bool,
  smooth: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  offset: PropTypes.number,
  delay: PropTypes.number,
  isDynamic: PropTypes.bool,
  onClick: PropTypes.func,
  duration: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
  absolute: PropTypes.bool,
  onSetActive: PropTypes.func,
  onSetInactive: PropTypes.func,
  ignoreCancelEvents: PropTypes.bool,
  hashSpy: PropTypes.bool
};

var Helpers = {
  Scroll: function Scroll(Component, customScroller) {

    console.warn("Helpers.Scroll is deprecated since v1.7.0");

    var scroller = customScroller || defaultScroller;

    var Scroll = function (_React$Component) {
      _inherits(Scroll, _React$Component);

      function Scroll(props) {
        _classCallCheck(this, Scroll);

        var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, props));

        _initialiseProps.call(_this);

        _this.state = {
          active: false
        };
        return _this;
      }

      _createClass(Scroll, [{
        key: 'getScrollSpyContainer',
        value: function getScrollSpyContainer() {
          var containerId = this.props.containerId;
          var container = this.props.container;

          if (containerId) {
            return document.getElementById(containerId);
          }

          if (container && container.nodeType) {
            return container;
          }

          return document;
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (this.props.spy || this.props.hashSpy) {
            var scrollSpyContainer = this.getScrollSpyContainer();

            if (!scrollSpy.isMounted(scrollSpyContainer)) {
              scrollSpy.mount(scrollSpyContainer);
            }

            if (this.props.hashSpy) {
              if (!scrollHash.isMounted()) {
                scrollHash.mount(scroller);
              }
              scrollHash.mapContainer(this.props.to, scrollSpyContainer);
            }

            if (this.props.spy) {
              scrollSpy.addStateHandler(this.stateHandler);
            }

            scrollSpy.addSpyHandler(this.spyHandler, scrollSpyContainer);

            this.setState({
              container: scrollSpyContainer
            });
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          scrollSpy.unmount(this.stateHandler, this.spyHandler);
        }
      }, {
        key: 'render',
        value: function render() {
          var className = "";

          if (this.state && this.state.active) {
            className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
          } else {
            className = this.props.className;
          }

          var props = _extends({}, this.props);

          for (var prop in protoTypes) {
            if (props.hasOwnProperty(prop)) {
              delete props[prop];
            }
          }

          props.className = className;
          props.onClick = this.handleClick;

          return React.createElement(Component, props);
        }
      }]);

      return Scroll;
    }(React.Component);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.scrollTo = function (to, props) {
        scroller.scrollTo(to, _extends({}, _this2.state, props));
      };

      this.handleClick = function (event) {

        /*
         * give the posibility to override onClick
         */

        if (_this2.props.onClick) {
          _this2.props.onClick(event);
        }

        /*
         * dont bubble the navigation
         */

        if (event.stopPropagation) event.stopPropagation();
        if (event.preventDefault) event.preventDefault();

        /*
         * do the magic!
         */
        _this2.scrollTo(_this2.props.to, _this2.props);
      };

      this.stateHandler = function () {
        if (scroller.getActiveLink() !== _this2.props.to) {
          if (_this2.state !== null && _this2.state.active && _this2.props.onSetInactive) {
            _this2.props.onSetInactive();
          }
          _this2.setState({ active: false });
        }
      };

      this.spyHandler = function (y) {

        var scrollSpyContainer = _this2.getScrollSpyContainer();

        if (scrollHash.isMounted() && !scrollHash.isInitialized()) {
          return;
        }

        var to = _this2.props.to;
        var element = null;
        var elemTopBound = 0;
        var elemBottomBound = 0;
        var containerTop = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var containerCords = scrollSpyContainer.getBoundingClientRect();
          containerTop = containerCords.top;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var cords = element.getBoundingClientRect();
          elemTopBound = cords.top - containerTop + y;
          elemBottomBound = elemTopBound + cords.height;
        }

        var offsetY = y - _this2.props.offset;
        var isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
        var isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
        var activeLink = scroller.getActiveLink();

        if (isOutside) {
          if (to === activeLink) {
            scroller.setActiveLink(void 0);
          }

          if (_this2.props.hashSpy && scrollHash.getHash() === to) {
            scrollHash.changeHash();
          }

          if (_this2.props.spy && _this2.state.active) {
            _this2.setState({ active: false });
            _this2.props.onSetInactive && _this2.props.onSetInactive();
          }

          return scrollSpy.updateStates();
        }

        if (isInside && activeLink !== to) {
          scroller.setActiveLink(to);

          _this2.props.hashSpy && scrollHash.changeHash(to);

          if (_this2.props.spy) {
            _this2.setState({ active: true });
            _this2.props.onSetActive && _this2.props.onSetActive(to);
          }
          return scrollSpy.updateStates();
        }
      };
    };

    ;

    Scroll.propTypes = protoTypes;

    Scroll.defaultProps = { offset: 0 };

    return Scroll;
  },
  Element: function Element(Component) {

    console.warn("Helpers.Element is deprecated since v1.7.0");

    var Element = function (_React$Component2) {
      _inherits(Element, _React$Component2);

      function Element(props) {
        _classCallCheck(this, Element);

        var _this3 = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));

        _this3.childBindings = {
          domNode: null
        };
        return _this3;
      }

      _createClass(Element, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (typeof window === 'undefined') {
            return false;
          }
          this.registerElems(this.props.name);
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
          if (this.props.name !== prevProps.name) {
            this.registerElems(this.props.name);
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (typeof window === 'undefined') {
            return false;
          }
          defaultScroller.unregister(this.props.name);
        }
      }, {
        key: 'registerElems',
        value: function registerElems(name) {
          defaultScroller.register(name, this.childBindings.domNode);
        }
      }, {
        key: 'render',
        value: function render() {
          return React.createElement(Component, _extends({}, this.props, { parentBindings: this.childBindings }));
        }
      }]);

      return Element;
    }(React.Component);

    ;

    Element.propTypes = {
      name: PropTypes.string,
      id: PropTypes.string
    };

    return Element;
  }
};

module.exports = Helpers;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);
var bind = __webpack_require__(100);
var Axios = __webpack_require__(198);
var defaults = __webpack_require__(60);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(104);
axios.CancelToken = __webpack_require__(211);
axios.isCancel = __webpack_require__(103);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(212);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 197 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(60);
var utils = __webpack_require__(8);
var InterceptorManager = __webpack_require__(206);
var dispatchRequest = __webpack_require__(207);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(102);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);
var transformData = __webpack_require__(208);
var isCancel = __webpack_require__(103);
var defaults = __webpack_require__(60);
var isAbsoluteURL = __webpack_require__(209);
var combineURLs = __webpack_require__(210);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(104);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.on = on;
exports.off = off;
function on(el, eventName, callback, opts) {
  opts = opts || false;
  if (el.addEventListener) {
    el.addEventListener(eventName, callback, opts);
  } else if (el.attachEvent) {
    el.attachEvent("on" + eventName, function (e) {
      callback.call(el, e || window.event);
    });
  }
}

function off(el, eventName, callback, opts) {
  opts = opts || false;
  if (el.removeEventListener) {
    el.removeEventListener(eventName, callback, opts);
  } else if (el.detachEvent) {
    el.detachEvent("on" + eventName, callback);
  }
}

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * @fileOverview Find scroll parent
 */

exports.default = function (node) {
  if (!(node instanceof HTMLElement)) {
    return document.documentElement;
  }

  var excludeStaticParent = node.style.position === 'absolute';
  var overflowRegex = /(scroll|auto)/;
  var parent = node;

  while (parent) {
    if (!parent.parentNode) {
      return node.ownerDocument || document.documentElement;
    }

    var style = window.getComputedStyle(parent);
    var position = style.position;
    var overflow = style.overflow;
    var overflowX = style['overflow-x'];
    var overflowY = style['overflow-y'];

    if (position === 'static' && excludeStaticParent) {
      parent = parent.parentNode;
      continue;
    }

    if (overflowRegex.test(overflow) && overflowRegex.test(overflowX) && overflowRegex.test(overflowY)) {
      return parent;
    }

    parent = parent.parentNode;
  }

  return node.ownerDocument || node.documentElement || document.documentElement;
};

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = debounce;
function debounce(func, wait, immediate) {
  var timeout = void 0;
  var args = void 0;
  var context = void 0;
  var timestamp = void 0;
  var result = void 0;

  var later = function later() {
    var last = +new Date() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) {
          context = null;
          args = null;
        }
      }
    }
  };

  return function debounced() {
    context = this;
    args = arguments;
    timestamp = +new Date();

    var callNow = immediate && !timeout;
    if (!timeout) {
      timeout = setTimeout(later, wait);
    }

    if (callNow) {
      result = func.apply(context, args);
      context = null;
      args = null;
    }

    return result;
  };
}

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = throttle;
/*eslint-disable */
function throttle(fn, threshhold, scope) {
  threshhold || (threshhold = 250);
  var last, deferTimer;
  return function () {
    var context = scope || this;

    var now = +new Date(),
        args = arguments;
    if (last && now < last + threshhold) {
      // hold on to it
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fn.apply(context, args);
      }, threshhold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
}

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(218);


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(219);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 219 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var BrowserInfo = /** @class */ (function () {
    function BrowserInfo(name, version, os) {
        this.name = name;
        this.version = version;
        this.os = os;
    }
    return BrowserInfo;
}());
exports.BrowserInfo = BrowserInfo;
var NodeInfo = /** @class */ (function () {
    function NodeInfo(version) {
        this.version = version;
        this.name = 'node';
        this.os = process.platform;
    }
    return NodeInfo;
}());
exports.NodeInfo = NodeInfo;
var BotInfo = /** @class */ (function () {
    function BotInfo() {
        this.bot = true; // NOTE: deprecated test name instead
        this.name = 'bot';
        this.version = null;
        this.os = null;
    }
    return BotInfo;
}());
exports.BotInfo = BotInfo;
// tslint:disable-next-line:max-line-length
var SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var SEARCHBOT_OS_REGEX = /(nuhk)|(Googlebot)|(Yammybot)|(Openbot)|(Slurp)|(MSNBot)|(Ask Jeeves\/Teoma)|(ia_archiver)/;
var REQUIRED_VERSION_PARTS = 3;
var userAgentRules = [
    ['aol', /AOLShield\/([0-9\._]+)/],
    ['edge', /Edge\/([0-9\._]+)/],
    ['edge-ios', /EdgiOS\/([0-9\._]+)/],
    ['yandexbrowser', /YaBrowser\/([0-9\._]+)/],
    ['vivaldi', /Vivaldi\/([0-9\.]+)/],
    ['kakaotalk', /KAKAOTALK\s([0-9\.]+)/],
    ['samsung', /SamsungBrowser\/([0-9\.]+)/],
    ['silk', /\bSilk\/([0-9._-]+)\b/],
    ['miui', /MiuiBrowser\/([0-9\.]+)$/],
    ['beaker', /BeakerBrowser\/([0-9\.]+)/],
    ['edge-chromium', /Edg\/([0-9\.]+)/],
    [
        'chromium-webview',
        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/,
    ],
    ['chrome', /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/],
    ['phantomjs', /PhantomJS\/([0-9\.]+)(:?\s|$)/],
    ['crios', /CriOS\/([0-9\.]+)(:?\s|$)/],
    ['firefox', /Firefox\/([0-9\.]+)(?:\s|$)/],
    ['fxios', /FxiOS\/([0-9\.]+)/],
    ['opera-mini', /Opera Mini.*Version\/([0-9\.]+)/],
    ['opera', /Opera\/([0-9\.]+)(?:\s|$)/],
    ['opera', /OPR\/([0-9\.]+)(:?\s|$)/],
    ['ie', /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/],
    ['ie', /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/],
    ['ie', /MSIE\s(7\.0)/],
    ['bb10', /BB10;\sTouch.*Version\/([0-9\.]+)/],
    ['android', /Android\s([0-9\.]+)/],
    ['ios', /Version\/([0-9\._]+).*Mobile.*Safari.*/],
    ['safari', /Version\/([0-9\._]+).*Safari/],
    ['facebook', /FBAV\/([0-9\.]+)/],
    ['instagram', /Instagram\s([0-9\.]+)/],
    ['ios-webview', /AppleWebKit\/([0-9\.]+).*Mobile/],
    ['ios-webview', /AppleWebKit\/([0-9\.]+).*Gecko\)$/],
    ['searchbot', SEARCHBOX_UA_REGEX],
];
var operatingSystemRules = [
    ['iOS', /iP(hone|od|ad)/],
    ['Android OS', /Android/],
    ['BlackBerry OS', /BlackBerry|BB10/],
    ['Windows Mobile', /IEMobile/],
    ['Amazon OS', /Kindle/],
    ['Windows 3.11', /Win16/],
    ['Windows 95', /(Windows 95)|(Win95)|(Windows_95)/],
    ['Windows 98', /(Windows 98)|(Win98)/],
    ['Windows 2000', /(Windows NT 5.0)|(Windows 2000)/],
    ['Windows XP', /(Windows NT 5.1)|(Windows XP)/],
    ['Windows Server 2003', /(Windows NT 5.2)/],
    ['Windows Vista', /(Windows NT 6.0)/],
    ['Windows 7', /(Windows NT 6.1)/],
    ['Windows 8', /(Windows NT 6.2)/],
    ['Windows 8.1', /(Windows NT 6.3)/],
    ['Windows 10', /(Windows NT 10.0)/],
    ['Windows ME', /Windows ME/],
    ['Open BSD', /OpenBSD/],
    ['Sun OS', /SunOS/],
    ['Chrome OS', /CrOS/],
    ['Linux', /(Linux)|(X11)/],
    ['Mac OS', /(Mac_PowerPC)|(Macintosh)/],
    ['QNX', /QNX/],
    ['BeOS', /BeOS/],
    ['OS/2', /OS\/2/],
    ['Search Bot', SEARCHBOT_OS_REGEX],
];
function detect(userAgent) {
    if (!!userAgent) {
        return parseUserAgent(userAgent);
    }
    if (typeof navigator !== 'undefined') {
        return parseUserAgent(navigator.userAgent);
    }
    return getNodeVersion();
}
exports.detect = detect;
function parseUserAgent(ua) {
    // opted for using reduce here rather than Array#first with a regex.test call
    // this is primarily because using the reduce we only perform the regex
    // execution once rather than once for the test and for the exec again below
    // probably something that needs to be benchmarked though
    var matchedRule = ua !== '' &&
        userAgentRules.reduce(function (matched, _a) {
            var browser = _a[0], regex = _a[1];
            if (matched) {
                return matched;
            }
            var uaMatch = regex.exec(ua);
            return !!uaMatch && [browser, uaMatch];
        }, false);
    if (!matchedRule) {
        return null;
    }
    var name = matchedRule[0], match = matchedRule[1];
    if (name === 'searchbot') {
        return new BotInfo();
    }
    var versionParts = match[1] && match[1].split(/[._]/).slice(0, 3);
    if (versionParts) {
        if (versionParts.length < REQUIRED_VERSION_PARTS) {
            versionParts = __spreadArrays(versionParts, createVersionParts(REQUIRED_VERSION_PARTS - versionParts.length));
        }
    }
    else {
        versionParts = [];
    }
    return new BrowserInfo(name, versionParts.join('.'), detectOS(ua));
}
exports.parseUserAgent = parseUserAgent;
function detectOS(ua) {
    for (var ii = 0, count = operatingSystemRules.length; ii < count; ii++) {
        var _a = operatingSystemRules[ii], os = _a[0], regex = _a[1];
        var match = regex.test(ua);
        if (match) {
            return os;
        }
    }
    return null;
}
exports.detectOS = detectOS;
function getNodeVersion() {
    var isNode = typeof process !== 'undefined' && process.version;
    return isNode ? new NodeInfo(process.version.slice(1)) : null;
}
exports.getNodeVersion = getNodeVersion;
function createVersionParts(count) {
    var output = [];
    for (var ii = 0; ii < count; ii++) {
        output.push('0');
    }
    return output;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)))

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Validator Class 
 * @DESC  simplae validation class
*/var Validator=function(){function Validator(){_classCallCheck(this,Validator);}_createClass(Validator,[{key:'simpleValidation',value:function simpleValidation(o){if(o.val===''){this.show_popup(o.err_1);return false;}else{return true;}}// email validation 
},{key:'email_validation',value:function email_validation(o){if(o.val===""){this.show_popup(o.err_1);return false;}else{if(o.expression.test(o.val)===false){this.show_popup(o.err_2);return false;}else{return true;}}}// regx validation 
},{key:'regx_validation',value:function regx_validation(obj){if(obj.val===''){this.show_popup(obj.err_1);return false;}else{if(obj.expression.test(obj.val)){return true;}else{this.show_popup(obj.err_2);return false;}}}// alert 
},{key:'show_popup',value:function show_popup(msg){alert(msg);}}]);return Validator;}();/* harmony default export */ __webpack_exports__["a"] = (Validator);

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _slider = __webpack_require__(223);

var _slider2 = _interopRequireDefault(_slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _slider2.default;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _innerSlider = __webpack_require__(224);

var _json2mq = __webpack_require__(231);

var _json2mq2 = _interopRequireDefault(_json2mq);

var _defaultProps = __webpack_require__(233);

var _defaultProps2 = _interopRequireDefault(_defaultProps);

var _innerSliderUtils = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(234);

var Slider = function (_React$Component) {
  _inherits(Slider, _React$Component);

  function Slider(props) {
    _classCallCheck(this, Slider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.innerSliderRefHandler = function (ref) {
      return _this.innerSlider = ref;
    };

    _this.slickPrev = function () {
      return _this.innerSlider.slickPrev();
    };

    _this.slickNext = function () {
      return _this.innerSlider.slickNext();
    };

    _this.slickGoTo = function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _this.innerSlider.slickGoTo(slide, dontAnimate);
    };

    _this.slickPause = function () {
      return _this.innerSlider.pause("paused");
    };

    _this.slickPlay = function () {
      return _this.innerSlider.autoPlay("play");
    };

    _this.state = {
      breakpoint: null
    };
    _this._responsiveMediaHandlers = [];
    return _this;
  }

  Slider.prototype.media = function media(query, handler) {
    // javascript handler for  css media query
    enquire.register(query, handler);
    this._responsiveMediaHandlers.push({ query: query, handler: handler });
  };

  // handles responsive breakpoints


  Slider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // performance monitoring
    //if (process.env.NODE_ENV !== 'production') {
    //const { whyDidYouUpdate } = require('why-did-you-update')
    //whyDidYouUpdate(React)
    //}
    if (this.props.responsive) {
      var breakpoints = this.props.responsive.map(function (breakpt) {
        return breakpt.breakpoint;
      });
      // sort them in increasing order of their numerical value
      breakpoints.sort(function (x, y) {
        return x - y;
      });

      breakpoints.forEach(function (breakpoint, index) {
        // media query for each breakpoint
        var bQuery = void 0;
        if (index === 0) {
          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
        } else {
          bQuery = (0, _json2mq2.default)({
            minWidth: breakpoints[index - 1] + 1,
            maxWidth: breakpoint
          });
        }
        // when not using server side rendering
        (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
          _this2.setState({ breakpoint: breakpoint });
        });
      });

      // Register media query for full screen. Need to support resize from small to large
      // convert javascript object to media query string
      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });

      (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
        _this2.setState({ breakpoint: null });
      });
    }
  };

  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
    this._responsiveMediaHandlers.forEach(function (obj) {
      enquire.unregister(obj.query, obj.handler);
    });
  };

  Slider.prototype.render = function render() {
    var _this3 = this;

    var settings;
    var newProps;
    if (this.state.breakpoint) {
      newProps = this.props.responsive.filter(function (resp) {
        return resp.breakpoint === _this3.state.breakpoint;
      });
      settings = newProps[0].settings === "unslick" ? "unslick" : _extends({}, _defaultProps2.default, this.props, newProps[0].settings);
    } else {
      settings = _extends({}, _defaultProps2.default, this.props);
    }

    // force scrolling by one if centerMode is on
    if (settings.centerMode) {
      if (settings.slidesToScroll > 1 && "production" !== "production") {
        console.warn("slidesToScroll should be equal to 1 in centerMode, you are using " + settings.slidesToScroll);
      }
      settings.slidesToScroll = 1;
    }
    // force showing one slide and scrolling by one if the fade mode is on
    if (settings.fade) {
      if (settings.slidesToShow > 1 && "production" !== "production") {
        console.warn("slidesToShow should be equal to 1 when fade is true, you're using " + settings.slidesToShow);
      }
      if (settings.slidesToScroll > 1 && "production" !== "production") {
        console.warn("slidesToScroll should be equal to 1 when fade is true, you're using " + settings.slidesToScroll);
      }
      settings.slidesToShow = 1;
      settings.slidesToScroll = 1;
    }

    // makes sure that children is an array, even when there is only 1 child
    var children = _react2.default.Children.toArray(this.props.children);

    // Children may contain false or null, so we should filter them
    // children may also contain string filled with spaces (in certain cases where we use jsx strings)
    children = children.filter(function (child) {
      if (typeof child === "string") {
        return !!child.trim();
      }
      return !!child;
    });

    // rows and slidesPerRow logic is handled here
    if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
      console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
      settings.variableWidth = false;
    }
    var newChildren = [];
    var currentWidth = null;
    for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
      var newSlide = [];
      for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
        var row = [];
        for (var k = j; k < j + settings.slidesPerRow; k += 1) {
          if (settings.variableWidth && children[k].props.style) {
            currentWidth = children[k].props.style.width;
          }
          if (k >= children.length) break;
          row.push(_react2.default.cloneElement(children[k], {
            key: 100 * i + 10 * j + k,
            tabIndex: -1,
            style: {
              width: 100 / settings.slidesPerRow + "%",
              display: "inline-block"
            }
          }));
        }
        newSlide.push(_react2.default.createElement(
          "div",
          { key: 10 * i + j },
          row
        ));
      }
      if (settings.variableWidth) {
        newChildren.push(_react2.default.createElement(
          "div",
          { key: i, style: { width: currentWidth } },
          newSlide
        ));
      } else {
        newChildren.push(_react2.default.createElement(
          "div",
          { key: i },
          newSlide
        ));
      }
    }

    if (settings === "unslick") {
      var className = "regular slider " + (this.props.className || "");
      return _react2.default.createElement(
        "div",
        { className: className },
        newChildren
      );
    } else if (newChildren.length <= settings.slidesToShow) {
      settings.unslick = true;
    }
    return _react2.default.createElement(
      _innerSlider.InnerSlider,
      _extends({ ref: this.innerSliderRefHandler }, settings),
      newChildren
    );
  };

  return Slider;
}(_react2.default.Component);

exports.default = Slider;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.InnerSlider = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(22);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _initialState = __webpack_require__(225);

var _initialState2 = _interopRequireDefault(_initialState);

var _lodash = __webpack_require__(226);

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = __webpack_require__(34);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(35);

var _track = __webpack_require__(227);

var _dots = __webpack_require__(228);

var _arrows = __webpack_require__(229);

var _resizeObserverPolyfill = __webpack_require__(230);

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InnerSlider = exports.InnerSlider = function (_React$Component) {
  _inherits(InnerSlider, _React$Component);

  function InnerSlider(props) {
    _classCallCheck(this, InnerSlider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.listRefHandler = function (ref) {
      return _this.list = ref;
    };

    _this.trackRefHandler = function (ref) {
      return _this.track = ref;
    };

    _this.adaptHeight = function () {
      if (_this.props.adaptiveHeight && _this.list) {
        var elem = _this.list.querySelector("[data-index=\"" + _this.state.currentSlide + "\"]");
        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
      }
    };

    _this.componentWillMount = function () {
      _this.ssrInit();
      _this.props.onInit && _this.props.onInit();
      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
    };

    _this.componentDidMount = function () {
      var spec = _extends({ listRef: _this.list, trackRef: _this.track }, _this.props);
      _this.updateState(spec, true, function () {
        _this.adaptHeight();
        _this.props.autoplay && _this.autoPlay("update");
      });
      if (_this.props.lazyLoad === "progressive") {
        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
      }
      _this.ro = new _resizeObserverPolyfill2.default(function () {
        if (_this.state.animating) {
          _this.onWindowResized(false); // don't set trackStyle hence don't break animation
          _this.callbackTimers.push(setTimeout(function () {
            return _this.onWindowResized();
          }, _this.props.speed));
        } else {
          _this.onWindowResized();
        }
      });
      _this.ro.observe(_this.list);
      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
      });
      // To support server-side rendering
      if (!window) {
        return;
      }
      if (window.addEventListener) {
        window.addEventListener("resize", _this.onWindowResized);
      } else {
        window.attachEvent("onresize", _this.onWindowResized);
      }
    };

    _this.componentWillUnmount = function () {
      if (_this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
      }
      if (_this.lazyLoadTimer) {
        clearInterval(_this.lazyLoadTimer);
      }
      if (_this.callbackTimers.length) {
        _this.callbackTimers.forEach(function (timer) {
          return clearTimeout(timer);
        });
        _this.callbackTimers = [];
      }
      if (window.addEventListener) {
        window.removeEventListener("resize", _this.onWindowResized);
      } else {
        window.detachEvent("onresize", _this.onWindowResized);
      }
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
    };

    _this.componentWillReceiveProps = function (nextProps) {
      var spec = _extends({
        listRef: _this.list,
        trackRef: _this.track
      }, nextProps, _this.state);
      var setTrackStyle = false;
      for (var _iterator = Object.keys(_this.props), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var key = _ref;

        if (!nextProps.hasOwnProperty(key)) {
          setTrackStyle = true;
          break;
        }
        if (_typeof(nextProps[key]) === "object" || typeof nextProps[key] === "function") {
          continue;
        }
        if (nextProps[key] !== _this.props[key]) {
          setTrackStyle = true;
          break;
        }
      }
      _this.updateState(spec, setTrackStyle, function () {
        if (_this.state.currentSlide >= _react2.default.Children.count(nextProps.children)) {
          _this.changeSlide({
            message: "index",
            index: _react2.default.Children.count(nextProps.children) - nextProps.slidesToShow,
            currentSlide: _this.state.currentSlide
          });
        }
        if (nextProps.autoplay) {
          _this.autoPlay("update");
        } else {
          _this.pause("paused");
        }
      });
    };

    _this.componentDidUpdate = function () {
      _this.checkImagesLoad();
      _this.props.onReInit && _this.props.onReInit();
      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
      // if (this.props.onLazyLoad) {
      //   this.props.onLazyLoad([leftMostSlide])
      // }
      _this.adaptHeight();
    };

    _this.onWindowResized = function (setTrackStyle) {
      if (_this.debouncedResize) _this.debouncedResize.cancel();
      _this.debouncedResize = (0, _lodash2.default)(function () {
        return _this.resizeWindow(setTrackStyle);
      }, 50);
      _this.debouncedResize();
    };

    _this.resizeWindow = function () {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (!_reactDom2.default.findDOMNode(_this.track)) return;
      var spec = _extends({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props, _this.state);
      _this.updateState(spec, setTrackStyle, function () {
        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
      });
      // animating state should be cleared while resizing, otherwise autoplay stops working
      _this.setState({
        animating: false
      });
      clearTimeout(_this.animationEndCallback);
      delete _this.animationEndCallback;
    };

    _this.updateState = function (spec, setTrackStyle, callback) {
      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
      spec = _extends({}, spec, updatedState, { slideIndex: updatedState.currentSlide });
      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
      spec = _extends({}, spec, { left: targetLeft });
      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);
      if (setTrackStyle || _react2.default.Children.count(_this.props.children) !== _react2.default.Children.count(spec.children)) {
        updatedState["trackStyle"] = trackStyle;
      }
      _this.setState(updatedState, callback);
    };

    _this.ssrInit = function () {
      if (_this.props.variableWidth) {
        var _trackWidth = 0,
            _trackLeft = 0;
        var childrenWidths = [];
        var preClones = (0, _innerSliderUtils.getPreClones)(_extends({}, _this.props, _this.state, {
          slideCount: _this.props.children.length
        }));
        var postClones = (0, _innerSliderUtils.getPostClones)(_extends({}, _this.props, _this.state, {
          slideCount: _this.props.children.length
        }));
        _this.props.children.forEach(function (child) {
          childrenWidths.push(child.props.style.width);
          _trackWidth += child.props.style.width;
        });
        for (var i = 0; i < preClones; i++) {
          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
        }
        for (var _i2 = 0; _i2 < postClones; _i2++) {
          _trackWidth += childrenWidths[_i2];
        }
        for (var _i3 = 0; _i3 < _this.state.currentSlide; _i3++) {
          _trackLeft += childrenWidths[_i3];
        }
        var _trackStyle = {
          width: _trackWidth + "px",
          left: -_trackLeft + "px"
        };
        if (_this.props.centerMode) {
          var currentWidth = childrenWidths[_this.state.currentSlide] + "px";
          _trackStyle.left = "calc(" + _trackStyle.left + " + (100% - " + currentWidth + ") / 2 ) ";
        }
        _this.setState({
          trackStyle: _trackStyle
        });
        return;
      }
      var childrenCount = _react2.default.Children.count(_this.props.children);
      var spec = _extends({}, _this.props, _this.state, { slideCount: childrenCount });
      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
      var slideWidth = 100 / slideCount;
      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
      if (_this.props.centerMode) {
        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
      }
      var trackStyle = {
        width: trackWidth + "%",
        left: trackLeft + "%"
      };
      _this.setState({
        slideWidth: slideWidth + "%",
        trackStyle: trackStyle
      });
    };

    _this.checkImagesLoad = function () {
      var images = document.querySelectorAll(".slick-slide img");
      var imagesCount = images.length,
          loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
        };
        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;
          image.onclick = function () {
            prevClickHandler();
            image.parentNode.focus();
          };
        }
        if (!image.onload) {
          if (_this.props.lazyLoad) {
            image.onload = function () {
              _this.adaptHeight();
              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
            };
          } else {
            image.onload = handler;
            image.onerror = function () {
              handler();
              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
            };
          }
        }
      });
    };

    _this.progressiveLazyLoad = function () {
      var slidesToLoad = [];
      var spec = _extends({}, _this.props, _this.state);
      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }
      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }
      if (slidesToLoad.length > 0) {
        _this.setState(function (state) {
          return {
            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
          };
        });
        if (_this.props.onLazyLoad) {
          _this.props.onLazyLoad(slidesToLoad);
        }
      } else {
        if (_this.lazyLoadTimer) {
          clearInterval(_this.lazyLoadTimer);
          delete _this.lazyLoadTimer;
        }
      }
    };

    _this.slideHandler = function (index) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
          asNavFor = _this$props.asNavFor,
          beforeChange = _this$props.beforeChange,
          onLazyLoad = _this$props.onLazyLoad,
          speed = _this$props.speed,
          afterChange = _this$props.afterChange;
      // capture currentslide before state is updated

      var currentSlide = _this.state.currentSlide;

      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_extends({
        index: index
      }, _this.props, _this.state, {
        trackRef: _this.track,
        useCSS: _this.props.useCSS && !dontAnimate
      })),
          state = _slideHandler.state,
          nextState = _slideHandler.nextState;

      if (!state) return;
      beforeChange && beforeChange(currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this.state.lazyLoadedList.indexOf(value) < 0;
      });
      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
      _this.setState(state, function () {
        asNavFor && asNavFor.innerSlider.state.currentSlide !== currentSlide && asNavFor.innerSlider.slideHandler(index);
        if (!nextState) return;
        _this.animationEndCallback = setTimeout(function () {
          var animating = nextState.animating,
              firstBatch = _objectWithoutProperties(nextState, ["animating"]);

          _this.setState(firstBatch, function () {
            _this.callbackTimers.push(setTimeout(function () {
              return _this.setState({ animating: animating });
            }, 10));
            afterChange && afterChange(state.currentSlide);
            delete _this.animationEndCallback;
          });
        }, speed);
      });
    };

    _this.changeSlide = function (options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var spec = _extends({}, _this.props, _this.state);
      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
      if (targetSlide !== 0 && !targetSlide) return;
      if (dontAnimate === true) {
        _this.slideHandler(targetSlide, dontAnimate);
      } else {
        _this.slideHandler(targetSlide);
      }
    };

    _this.clickHandler = function (e) {
      if (_this.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }
      _this.clickable = true;
    };

    _this.keyHandler = function (e) {
      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
      dir !== "" && _this.changeSlide({ message: dir });
    };

    _this.selectHandler = function (options) {
      _this.changeSlide(options);
    };

    _this.disableBodyScroll = function () {
      var preventDefault = function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
      };
      window.ontouchmove = preventDefault;
    };

    _this.enableBodyScroll = function () {
      window.ontouchmove = null;
    };

    _this.swipeStart = function (e) {
      if (_this.props.verticalSwiping) {
        _this.disableBodyScroll();
      }
      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
      state !== "" && _this.setState(state);
    };

    _this.swipeMove = function (e) {
      var state = (0, _innerSliderUtils.swipeMove)(e, _extends({}, _this.props, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      if (state["swiping"]) {
        _this.clickable = false;
      }
      _this.setState(state);
    };

    _this.swipeEnd = function (e) {
      var state = (0, _innerSliderUtils.swipeEnd)(e, _extends({}, _this.props, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      var triggerSlideHandler = state["triggerSlideHandler"];
      delete state["triggerSlideHandler"];
      _this.setState(state);
      if (triggerSlideHandler === undefined) return;
      _this.slideHandler(triggerSlideHandler);
      if (_this.props.verticalSwiping) {
        _this.enableBodyScroll();
      }
    };

    _this.slickPrev = function () {
      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({ message: "previous" });
      }, 0));
    };

    _this.slickNext = function () {
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({ message: "next" });
      }, 0));
    };

    _this.slickGoTo = function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      slide = Number(slide);
      if (isNaN(slide)) return "";
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "index",
          index: slide,
          currentSlide: _this.state.currentSlide
        }, dontAnimate);
      }, 0));
    };

    _this.play = function () {
      var nextIndex;
      if (_this.props.rtl) {
        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
      } else {
        if ((0, _innerSliderUtils.canGoNext)(_extends({}, _this.props, _this.state))) {
          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
        } else {
          return false;
        }
      }

      _this.slideHandler(nextIndex);
    };

    _this.autoPlay = function (playType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
      var autoplaying = _this.state.autoplaying;
      if (playType === "update") {
        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
          return;
        }
      } else if (playType === "leave") {
        if (autoplaying === "paused" || autoplaying === "focused") {
          return;
        }
      } else if (playType === "blur") {
        if (autoplaying === "paused" || autoplaying === "hovered") {
          return;
        }
      }
      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
      _this.setState({ autoplaying: "playing" });
    };

    _this.pause = function (pauseType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
        _this.autoplayTimer = null;
      }
      var autoplaying = _this.state.autoplaying;
      if (pauseType === "paused") {
        _this.setState({ autoplaying: "paused" });
      } else if (pauseType === "focused") {
        if (autoplaying === "hovered" || autoplaying === "playing") {
          _this.setState({ autoplaying: "focused" });
        }
      } else {
        // pauseType  is 'hovered'
        if (autoplaying === "playing") {
          _this.setState({ autoplaying: "hovered" });
        }
      }
    };

    _this.onDotsOver = function () {
      return _this.props.autoplay && _this.pause("hovered");
    };

    _this.onDotsLeave = function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    };

    _this.onTrackOver = function () {
      return _this.props.autoplay && _this.pause("hovered");
    };

    _this.onTrackLeave = function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    };

    _this.onSlideFocus = function () {
      return _this.props.autoplay && _this.pause("focused");
    };

    _this.onSlideBlur = function () {
      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
    };

    _this.render = function () {
      var className = (0, _classnames2.default)("slick-slider", _this.props.className, {
        "slick-vertical": _this.props.vertical,
        "slick-initialized": true
      });
      var spec = _extends({}, _this.props, _this.state);
      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding"]);
      var pauseOnHover = _this.props.pauseOnHover;

      trackProps = _extends({}, trackProps, {
        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
        focusOnSelect: _this.props.focusOnSelect ? _this.selectHandler : null
      });

      var dots;
      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
        var pauseOnDotsHover = _this.props.pauseOnDotsHover;

        dotProps = _extends({}, dotProps, {
          clickHandler: _this.changeSlide,
          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
        });
        dots = _react2.default.createElement(_dots.Dots, dotProps);
      }

      var prevArrow, nextArrow;
      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      arrowProps.clickHandler = _this.changeSlide;

      if (_this.props.arrows) {
        prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
        nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
      }

      var verticalHeightStyle = null;

      if (_this.props.vertical) {
        verticalHeightStyle = {
          height: _this.state.listHeight
        };
      }

      var centerPaddingStyle = null;

      if (_this.props.vertical === false) {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: "0px " + _this.props.centerPadding
          };
        }
      } else {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: _this.props.centerPadding + " 0px"
          };
        }
      }

      var listStyle = _extends({}, verticalHeightStyle, centerPaddingStyle);
      var touchMove = _this.props.touchMove;
      var listProps = {
        className: "slick-list",
        style: listStyle,
        onClick: _this.clickHandler,
        onMouseDown: touchMove ? _this.swipeStart : null,
        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onMouseUp: touchMove ? _this.swipeEnd : null,
        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onTouchStart: touchMove ? _this.swipeStart : null,
        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onTouchEnd: touchMove ? _this.swipeEnd : null,
        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
      };

      var innerSliderProps = {
        className: className,
        dir: "ltr"
      };

      if (_this.props.unslick) {
        listProps = { className: "slick-list" };
        innerSliderProps = { className: className };
      }
      return _react2.default.createElement(
        "div",
        innerSliderProps,
        !_this.props.unslick ? prevArrow : "",
        _react2.default.createElement(
          "div",
          _extends({ ref: _this.listRefHandler }, listProps),
          _react2.default.createElement(
            _track.Track,
            _extends({ ref: _this.trackRefHandler }, trackProps),
            _this.props.children
          )
        ),
        !_this.props.unslick ? nextArrow : "",
        !_this.props.unslick ? dots : ""
      );
    };

    _this.list = null;
    _this.track = null;
    _this.state = _extends({}, _initialState2.default, {
      currentSlide: _this.props.initialSlide,
      slideCount: _react2.default.Children.count(_this.props.children)
    });
    _this.callbackTimers = [];
    _this.clickable = true;
    _this.debouncedResize = null;
    return _this;
  }

  return InnerSlider;
}(_react2.default.Component);

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var initialState = {
  animating: false,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: false,
  edgeDragged: false,
  initialized: false,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: false,
  slideCount: null,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: false, // used by swipeEvent. differentites between touch and swipe.
  swiping: false,
  touchObject: { startX: 0, startY: 0, curX: 0, curY: 0 },
  trackStyle: {},
  trackWidth: 0
};

exports.default = initialState;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Track = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(34);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;

  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }
  slickCloned = index < 0 || index >= spec.slideCount;
  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }
  var slickCurrent = index === spec.currentSlide;
  return {
    "slick-slide": true,
    "slick-active": slickActive,
    "slick-center": slickCenter,
    "slick-cloned": slickCloned,
    "slick-current": slickCurrent // dubious in case of RTL
  };
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }

  if (spec.fade) {
    style.position = "relative";
    if (spec.vertical) {
      style.top = -spec.index * parseInt(spec.slideHeight);
    } else {
      style.left = -spec.index * parseInt(spec.slideWidth);
    }
    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
    style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    style.WebkitTransition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
  }

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  return child.key || fallbackKey;
};

var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];
  var childrenCount = _react2.default.Children.count(spec.children);
  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);

  _react2.default.Children.forEach(spec.children, function (elem, index) {
    var child = void 0;
    var childOnClickOptions = {
      message: "children",
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    };

    // in case of lazyLoad, whether or not we want to fetch the slide
    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
      child = elem;
    } else {
      child = _react2.default.createElement("div", null);
    }
    var childStyle = getSlideStyle(_extends({}, spec, { index: index }));
    var slideClass = child.props.className || "";
    var slideClasses = getSlideClasses(_extends({}, spec, { index: index }));
    // push a cloned element of the desired slide
    slides.push(_react2.default.cloneElement(child, {
      key: "original" + getKey(child, index),
      "data-index": index,
      className: (0, _classnames2.default)(slideClasses, slideClass),
      tabIndex: "-1",
      "aria-hidden": !slideClasses["slick-active"],
      style: _extends({ outline: "none" }, child.props.style || {}, childStyle),
      onClick: function onClick(e) {
        child.props && child.props.onClick && child.props.onClick(e);
        if (spec.focusOnSelect) {
          spec.focusOnSelect(childOnClickOptions);
        }
      }
    }));

    // if slide needs to be precloned or postcloned
    if (spec.infinite && spec.fade === false) {
      var preCloneNo = childrenCount - index;
      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
        key = -preCloneNo;
        if (key >= startIndex) {
          child = elem;
        }
        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
        preCloneSlides.push(_react2.default.cloneElement(child, {
          key: "precloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames2.default)(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _extends({}, child.props.style || {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);
            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }

      if (childrenCount !== spec.slidesToShow) {
        key = childrenCount + index;
        if (key < endIndex) {
          child = elem;
        }
        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
        postCloneSlides.push(_react2.default.cloneElement(child, {
          key: "postcloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames2.default)(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _extends({}, child.props.style || {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);
            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }
    }
  });

  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};

var Track = exports.Track = function (_React$PureComponent) {
  _inherits(Track, _React$PureComponent);

  function Track() {
    _classCallCheck(this, Track);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Track.prototype.render = function render() {
    var slides = renderSlides(this.props);
    var _props = this.props,
        onMouseEnter = _props.onMouseEnter,
        onMouseOver = _props.onMouseOver,
        onMouseLeave = _props.onMouseLeave;

    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
    return _react2.default.createElement(
      "div",
      _extends({
        className: "slick-track",
        style: this.props.trackStyle
      }, mouseEvents),
      slides
    );
  };

  return Track;
}(_react2.default.PureComponent);

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Dots = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(34);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getDotCount = function getDotCount(spec) {
  var dots;

  if (spec.infinite) {
    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  } else {
    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
  }

  return dots;
};

var Dots = exports.Dots = function (_React$PureComponent) {
  _inherits(Dots, _React$PureComponent);

  function Dots() {
    _classCallCheck(this, Dots);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Dots.prototype.clickHandler = function clickHandler(options, e) {
    // In Autoplay the focus stays on clicked button even after transition
    // to next slide. That only goes away by click somewhere outside
    e.preventDefault();
    this.props.clickHandler(options);
  };

  Dots.prototype.render = function render() {
    var _this2 = this;

    var dotCount = getDotCount({
      slideCount: this.props.slideCount,
      slidesToScroll: this.props.slidesToScroll,
      slidesToShow: this.props.slidesToShow,
      infinite: this.props.infinite
    });

    // Apply join & split to Array to pre-fill it for IE8
    //
    // Credit: http://stackoverflow.com/a/13735425/1849458
    var _props = this.props,
        onMouseEnter = _props.onMouseEnter,
        onMouseOver = _props.onMouseOver,
        onMouseLeave = _props.onMouseLeave;

    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
    var dots = Array.apply(null, Array(dotCount + 1).join("0").split("")).map(function (x, i) {
      var leftBound = i * _this2.props.slidesToScroll;
      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
      var className = (0, _classnames2.default)({
        "slick-active": _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
      });

      var dotOptions = {
        message: "dots",
        index: i,
        slidesToScroll: _this2.props.slidesToScroll,
        currentSlide: _this2.props.currentSlide
      };

      var onClick = _this2.clickHandler.bind(_this2, dotOptions);
      return _react2.default.createElement(
        "li",
        { key: i, className: className },
        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
      );
    });

    return _react2.default.cloneElement(this.props.appendDots(dots), _extends({
      className: this.props.dotsClass
    }, mouseEvents));
  };

  return Dots;
}(_react2.default.PureComponent);

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.NextArrow = exports.PrevArrow = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(34);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PrevArrow = exports.PrevArrow = function (_React$PureComponent) {
  _inherits(PrevArrow, _React$PureComponent);

  function PrevArrow() {
    _classCallCheck(this, PrevArrow);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
    if (e) {
      e.preventDefault();
    }
    this.props.clickHandler(options, e);
  };

  PrevArrow.prototype.render = function render() {
    var prevClasses = { "slick-arrow": true, "slick-prev": true };
    var prevHandler = this.clickHandler.bind(this, { message: "previous" });

    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
      prevClasses["slick-disabled"] = true;
      prevHandler = null;
    }

    var prevArrowProps = {
      key: "0",
      "data-role": "none",
      className: (0, _classnames2.default)(prevClasses),
      style: { display: "block" },
      onClick: prevHandler
    };
    var customProps = {
      currentSlide: this.props.currentSlide,
      slideCount: this.props.slideCount
    };
    var prevArrow = void 0;

    if (this.props.prevArrow) {
      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
    } else {
      prevArrow = _react2.default.createElement(
        "button",
        _extends({ key: "0", type: "button" }, prevArrowProps),
        " ",
        "Previous"
      );
    }

    return prevArrow;
  };

  return PrevArrow;
}(_react2.default.PureComponent);

var NextArrow = exports.NextArrow = function (_React$PureComponent2) {
  _inherits(NextArrow, _React$PureComponent2);

  function NextArrow() {
    _classCallCheck(this, NextArrow);

    return _possibleConstructorReturn(this, _React$PureComponent2.apply(this, arguments));
  }

  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
    if (e) {
      e.preventDefault();
    }
    this.props.clickHandler(options, e);
  };

  NextArrow.prototype.render = function render() {
    var nextClasses = { "slick-arrow": true, "slick-next": true };
    var nextHandler = this.clickHandler.bind(this, { message: "next" });

    if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
      nextClasses["slick-disabled"] = true;
      nextHandler = null;
    }

    var nextArrowProps = {
      key: "1",
      "data-role": "none",
      className: (0, _classnames2.default)(nextClasses),
      style: { display: "block" },
      onClick: nextHandler
    };
    var customProps = {
      currentSlide: this.props.currentSlide,
      slideCount: this.props.slideCount
    };
    var nextArrow = void 0;

    if (this.props.nextArrow) {
      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
    } else {
      nextArrow = _react2.default.createElement(
        "button",
        _extends({ key: "1", type: "button" }, nextArrowProps),
        " ",
        "Next"
      );
    }

    return nextArrow;
  };

  return NextArrow;
}(_react2.default.PureComponent);

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(21)))

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var camel2hyphen = __webpack_require__(232);

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and '
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', '
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

module.exports = json2mq;

/***/ }),
/* 232 */
/***/ (function(module, exports) {

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultProps = {
  accessibility: true,
  adaptiveHeight: false,
  afterChange: null,
  appendDots: function appendDots(dots) {
    return _react2.default.createElement(
      "ul",
      { style: { display: "block" } },
      dots
    );
  },
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  beforeChange: null,
  centerMode: false,
  centerPadding: "50px",
  className: "",
  cssEase: "ease",
  customPaging: function customPaging(i) {
    return _react2.default.createElement(
      "button",
      null,
      i + 1
    );
  },
  dots: false,
  dotsClass: "slick-dots",
  draggable: true,
  easing: "linear",
  edgeFriction: 0.35,
  fade: false,
  focusOnSelect: false,
  infinite: true,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: false,
  pauseOnFocus: false,
  pauseOnHover: true,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: false,
  slide: "div",
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: true,
  swipeEvent: null,
  swipeToSlide: false,
  touchMove: true,
  touchThreshold: 5,
  useCSS: true,
  useTransform: true,
  variableWidth: false,
  vertical: false,
  waitForAnimate: true
};

exports.default = defaultProps;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQueryDispatch = __webpack_require__(235);
module.exports = new MediaQueryDispatch();


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQuery = __webpack_require__(236);
var Util = __webpack_require__(105);
var each = Util.each;
var isFunction = Util.isFunction;
var isArray = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor : MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction(options)) {
            options = { match : options };
        }
        if(!isArray(options)) {
            options = [options];
        }
        each(options, function(handler) {
            if (isFunction(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

module.exports = MediaQueryDispatch;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var QueryHandler = __webpack_require__(237);
var each = __webpack_require__(105).each;

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor : MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler : function(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear : function() {
        each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

module.exports = MediaQuery;


/***/ }),
/* 237 */
/***/ (function(module, exports) {

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor : QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

module.exports = QueryHandler;


/***/ }),
/* 238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 239 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 240 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Deals_css__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Deals_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Deals_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DealItem__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SimpleSlider_SimpleSlider__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Utility_Utility__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Deals=function(_Component){_inherits(Deals,_Component);function Deals(props){_classCallCheck(this,Deals);var _this=_possibleConstructorReturn(this,(Deals.__proto__||Object.getPrototypeOf(Deals)).call(this,props));_this.image_url=Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["e" /* getImgUrl */])();_this.dealsSliderSettings={dots:true,infinite:true,cssEase:'linear',autoplay:true,lazyLoad:'ondemand',slidesToShow:_this.props.items!=undefined?_this.props.items:3,slidesToScroll:1,responsive:[{breakpoint:1000,settings:{slidesToShow:1,slidesToScroll:1}}]};_this.deals=[{title:'Tel Aviv Air',desc:'Hamburg – Tel Aviv Non Stop, Handgepäck bis 8 kg,16.12.2021 – 31.03.2022',price:'99 € ',logo:'Deals/tlv.jpg',link:'https://tlv-air.com/en/home-en/',cssclass:'unic-deal-1',book_now:'BUCHEN SIE JETZT'},{title:'Fit Reisen',desc:'Hotel Ein Gedi ***ˢ Kuren und entspannen am Toten Meer, 7 Nächte im DZ inkl. HP & Eintritt ins Ein Gedi Health Spa',price:'589 € ',logo:'Deals/Fit Reisen.jpg',link:'https://www.fitreisen.de/hotel-ein-gedi-ein-gedi-totes-meer-h347/?utm_source=teaser_extern&utm_medium=fva&utm_campaign=israel1#dmin=7&p=347P2NN',cssclass:'unic-deal-1',book_now:'BUCHEN SIE JETZT'},{title:'Fit Reisen',desc:'Lot Spa Hotel **** Wellness & Entspannung (auch als Klimakuraufenthalt), 7 Nächte im DZ inkl. HP & Eintritt zum Spa ',price:' 609 € ',logo:'Deals/Fit Reisen.jpg',link:'https://www.fitreisen.de/lot-spa-hotel-ein-bokek-totes-meer-h343/?utm_source=teaser_extern&utm_medium=fva&utm_campaign=israel2#dmin=7&p=343P1NN',cssclass:'unic-deal-1',book_now:'BUCHEN SIE JETZT'},{title:'Israel Rail',desc:'8-Tage-Tour Israel Highlights mit der Bahn',price:'699 € ',logo:'Deals/Israel Rail.jpg',link:'https://israelrail.com/de/tours/israel-highlights-mit-der-bahn-8-tage/',cssclass:'unic-deal-1',book_now:'BUCHEN SIE JETZT'},{title:'DerTour',desc:'Hotel Savoy**** Stylisches Boutique-Hotel in Tel Aviv 5 Nächte/Frühstück, Transfers, Flug ab Deutschland',price:'721 € ',logo:'Deals/DerTour.jpg',link:'https://www.dertour.de/hotel/savoy-hotel-TLV01118VA?ttid=PF&bdid=i&toid=dy&hid=TLV01118&ptid=VA&ssnid=W21&na=2&nc=0&ap=BER&nn=5&mnth=2022-01-16&fidd=2022-01-16&fird=2022-01-21&fid=00&fir=00&fcd=BERTLV&fcr=TLVBER&fiswt=1&fddtd=202201160700&fddta=202201161215&frdtd=202201211310&frdta=202201211645&fad=U2&far=U2&rid=RB&bid=BB&bcid=RB+B&lndpu=%2Fangebote%2F%3Fpdaf%3DBER%26pdf%3D4030573%26psdf%3D2022-01-16%26psdsf%3D2022-01-16%26pedf%3D2022-01-21%26pedsf%3D2022-01-21%26searchMode%3Dflexible%26pnnfl%3D5%26pnnfh%3D8%26pna%3D2%26pnc%3D0%26ttid%3DPF&dft=apx',cssclass:'unic-deal-1',book_now:'BUCHEN SIE JETZT'},{title:'Israel Tours & Travel',desc:'EIN EINMALIGES ERLEBNISREISE IN DER ARAVA WÜSTE 7 NÄCHTE Ü/F',price:'759 € ',logo:'Deals/Israel Tours & Travel.jpg',link:'https://www.israel-tours-travel.de/kibbutzelifaz',cssclass:'unic-deal-1',book_now:'BUCHEN SIE JETZT'},{title:'Ventus Reisen',desc:'Individuelle Reise nach Tel Aviv und Jerusalem mit Bus-Ausflügen zu den wichtigsten Sehenswürdigkeiten',price:'858 € ',logo:'Deals/Ventus Reisen.jpg',link:'https://www.ventus-reisen.de/408-israel-tel-aviv-und-jerusalem/',cssclass:'unic-deal-1',book_now:'BUCHEN SIE JETZT'},{title:'Israel Tours & Travel',desc:'CITY BREAK, JERUSALEM & TEL AVIV 8 tägige Reise in Jerusalem und Tel Aviv',price:'949 € ',logo:'Deals/Israel Tours & Travel.jpg',link:'https://www.israel-tours-travel.de/citybreaktelavivundjerusalem',cssclass:'unic-deal-1',book_now:'BUCHEN SIE JETZT'},{title:'Israel Tours & Travel',desc:'ISRAEL HIGHLIGHTS 8 TÄGIGE RUNDREISE  INKL. 7 Ü/HP, TRANSFERS, DEUTSCHSPRECHENDER REISELETER, ALLE EINTRITTGELDER',price:'956 € ',logo:'Deals/Israel Tours & Travel.jpg',link:'https://www.israel-tours-travel.de/israelrundreisen',cssclass:'unic-deal-1',book_now:'BUCHEN SIE JETZT'},{title:'DerTour',desc:'Rundreise Israel entdecken ab/bis Tel Aviv 7 Nächte/Halbpension, Rundreise mit Dt. Sprechende Reiseleitung',price:'1041 € ',logo:'Deals/DerTour.jpg',link:'https://www.dertour.de/ibe/rundreise/detail?tab=angebote&locationCode=MKT_IL&locationName=Israel&serviceCode=TLV99101&productType=TOUR&serviceName=Israel+entdecken&productLineCode=VA&seasonId=21-11%2F10&earliestStart=16.01.2022&latestStart=23.01.2022&numberOfAdults=2&numberOfChildren=0&numberOfUnits=1&withDetails=true&sortByLowestPrice=true',cssclass:'unic-deal-1',book_now:'BUCHEN SIE JETZT'},{title:'Diesenhaus',desc:'10 Tage Israel-Rundreise mit Mietwagen. Großes Programm, ausgewählte Hotels',price:'1095 € ',logo:'Deals/Diesenhaus.jpg',link:'https://www.diesenhaus.de/reiseprogramm/reise/10-tage-israel-rundreise-mit-mietwagen/',cssclass:'unic-deal-2',book_now:'BUCHEN SIE JETZT'},{title:'Diesenhaus',desc:'8 Tage Klassische Israel-Rundreise. Ideal, um das Land kennenzulernen: Jerusalem, Galiläa, Totes Meer',price:'1105 € ',logo:'Deals/Diesenhaus.jpg',link:'https://www.diesenhaus.de/reiseprogramm/reise/israel-rundreise/',cssclass:'unic-deal-3',book_now:'BUCHEN SIE JETZT'},{title:'Ventus Reisen',desc:'Individuelle 10-tägige Privatreise als Selbstfahrer-Reise im Mietwagen',price:' 1281 € ',logo:'Deals/Ventus Reisen.jpg',link:'https://www.ventus-reisen.de/399-israel-an-den-urspruengen-von-weltreligionen/',cssclass:'unic-deal-1',book_now:'BUCHEN SIE JETZT'},{title:'Berge & Meer',desc:'8-tägige Rundreise durch das Heilige Land mit Bad im Toten Meer, See Genezareth & Galiläa, Nazareth, Bethlehem & Jerusalem ',price:' 1299 € ',logo:'Deals/Berge & Meer.jpg',link:'https://www.berge-meer.de/angebote/israel-rundreise-von-netanya-bis-tel-aviv-inkl-bad-im-toten-meer',cssclass:'unic-deal-1',book_now:'BUCHEN SIE JETZT'},{title:'Botros Tours',desc:'Rundreise „Geschichte, Kultur und Begegnung“ 8-tägige Rundreise inkl. Flüge Wien – Tel Aviv – Wien, Halbpension',price:'1490 € ',logo:'Deals/Botros Tours.jpg',link:'https://www.botrostours.at/product.php?id=5036',cssclass:'unic-deal-3',book_now:'BUCHEN SIE JETZT'},{title:'Botros Tours',desc:'Rundreise „Ein Land, Zwei Völker 8-tägige Rundreise inkl. Flüge Wien – Tel Aviv – Wien, Halbpension',price:'1540 € ',logo:'Deals/Botros Tours.jpg',link:'https://www.botrostours.at/product.php?id=5038',cssclass:'unic-deal-3',book_now:'BUCHEN SIE JETZT'},{title:'Biblische Reisen',desc:'JERUSALEM - Stadt der drei Religionen 8-tägige Studienreise mit Begegnungen Linienflug, Halbpension, Rundfahrten und Ausflüge, Alle Eintrittsgelder',price:'1640 € ',logo:'Deals/Biblische Reisen.jpg',link:'https://biblische-reisen.de/katalogreisen/nahost/heiliges_land/hlk67_jerusalem-stadt_der_drei_religionen',cssclass:'unic-deal-4',book_now:'BUCHEN SIE JETZT'},{title:'Laufreisen',desc:"Israel: Jerusalem Marathon, Halbmarathon und 10 km Run'n'Hike Israel vom 23.03.2022 bis 30.03.2022",price:'1699 € ',logo:'Deals/Laufreisen.jpg',link:'https://www.laufreisen.de/reisen/jerusalem',cssclass:'unic-deal-3',book_now:'BUCHEN SIE JETZT'},{title:'Diesenhaus',desc:'9 Tage Höhepunkte Israels inkl. Flug. Alle wichtigen Sehenswürdigkeiten und Orte				',price:'1705 € ',logo:'Deals/Diesenhaus.jpg',link:'https://www.diesenhaus.de/reiseprogramm/reise/9-tage-rundreise-israel-sonntags-inkl-flug/',cssclass:'unic-deal-1',book_now:'BUCHEN SIE JETZT'},{title:'Biblische Reisen',desc:'Im Land der Bibel 8-tägige Studienreise Linienflug,  Halbpension, Rundfahrten und Ausflüge, Alle Eintrittsgelder',price:'1750 € ',logo:'Deals/Biblische Reisen.jpg',link:'https://biblische-reisen.de/katalogreisen/nahost/israel/hlk06_im_land_der_bibel',cssclass:'unic-deal-4',book_now:'BUCHEN SIE JETZT'},{title:'Israelreise.de',desc:'Israel - Botschafterreise der Sächsischen Israelfreunde e.V. inkl. HP, Trinkgelder, Flüge',price:'1820 € ',logo:'Deals/jahre.jpg',link:'https://www.israelreise.de/rundreisen/r/a/israel-botschafterreise-der-saechsischen-israelfreunde-ev/3/',cssclass:'unic-deal-4',book_now:'BUCHEN SIE JETZT'},{title:'Biblische Reisen',desc:'Auf den Spuren Jesu 9-tägige Studienreise Linienflug, Halbpension, Rundfahrten und Ausflüge, Alle Eintrittsgelder',price:'1990 € ',logo:'Deals/Biblische Reisen.jpg',link:'https://biblische-reisen.de/katalogreisen/nahost/israel/hlk09_auf_den_spuren_jesu',cssclass:'unic-deal-4',book_now:'BUCHEN SIE JETZT'},{title:'Studiosus',desc:'Heiliges Land - eine kompakte  Studienreise ins Heilige Land - 8 Tage',price:'1995 € ',logo:'Deals/Studiosus.jpg',link:'https://www.studiosus.com/Israel/Studienreise/Rundreise/3601--Israel-Heiliges-Land--Fluganreise',cssclass:'unic-deal-4',book_now:'BUCHEN SIE JETZT'},{title:'Emmausreisen',desc:'19. bis 27. März 2022: Heiliges Land – Entdeckungen im Land der Bibel - 9 Tage',price:'1995 € ',logo:'Deals/Emmausreisen.jpg',link:'https://www.emmaus-reisen.de/tour/19-bis-27-maerz-2022-heiliges-land-entdeckungen-im-land-der-bibel-2hlp2002/',cssclass:'unic-deal-4',book_now:'BUCHEN SIE JETZT'},{title:'Emmausreisen',desc:'02. bis 10. April 2022: HEILIGES LAND – Entdeckungen im Land der Bibel - 9 Tage',price:'1995 € ',logo:'Deals/Emmausreisen.jpg',link:'https://www.emmaus-reisen.de/tour/02-bis-10-april-2022-heiliges-land-entdeckungen-im-land-der-bibel-2hlp2006/',cssclass:'unic-deal-4',book_now:'BUCHEN SIE JETZT'},// {
//     title: "ABS Travel",
//     desc: "Insight Israel | 18-30 9 tägige Rundreise für junge Erwachsene im Alter von 18 - 30 Jahre",
//     price: " CHF 2’230 ",
//     logo: "Deals/ABSTravel.jpg",
//     link: "https://www.abstravel.ch/jugendreise",
//     cssclass: "unic-deal-1",
//     book_now: "BUCHEN SIE JETZT"
// },
{title:'Hauser Exkursionen',desc:'9-tägige Wanderreise von der Wüste Negev zum Toten Meer und nach Galiläa mit kulturellen Höhepunkten in Masada und Jerusalem',price:'2095 € ',logo:'Deals/Hauser Exkursionen.jpg',link:'https://www.hauser-exkursionen.de/reise/israel-krater-wueste-totes-meer',cssclass:'unic-deal-4',book_now:'BUCHEN SIE JETZT'},{title:'Schechinger Tours',desc:'Israel – Frühlingsreise vom 17.03.-27.03.2022',price:'2099 € ',logo:'Deals/Schechinger Tours.jpg',link:'https://www.schechingertours.de/israelreise/israel-fruehlingsreise-mit-lutz-scheufler-2/',cssclass:'unic-deal-4',book_now:'BUCHEN SIE JETZT'},{title:'Schechinger Tours',desc:'Israelreise wenn die Wüste blüht vom 03.03. – 13.03.2022',price:'2099 € ',logo:'Deals/Schechinger Tours.jpg',link:'https://www.schechingertours.de/israelreise/israelreise-wenn-die-wueste-blueht-mit-wolfgang-und-sieglinde-wangler-pfalzgrafenweiler-und-walter-und-marianne-schechinger-wildberg-sulz-am-eck/',cssclass:'unic-deal-4',book_now:'BUCHEN SIE JETZT'},{title:'Studiosus',desc:'smart & small - Vom Sandstrand bis zur Klagemauer - 10 Tage',price:'2165 € ',logo:'Deals/Studiosus.jpg',link:'https://www.studiosus.com/Israel,Pal%C3%A4stinensische-Gebiete smart-and-small/3644E--Israel-vom-Sandstrand-bis-zur-Klagemauer--Eigenanreise',cssclass:'unic-deal-4',book_now:'BUCHEN SIE JETZT'},{title:'Biblische Reisen',desc:'Ostern im Heiligen Land 8-tägige biblische Studienreise zu Ostern Linienflug,  Halbpension, Rundfahrten und Ausflüge, Alle Eintrittsgelder',price:'2325 € ',logo:'Deals/Biblische Reisen.jpg',link:'https://biblische-reisen.de/katalogreisen/nahost/israel/hlk40_ostern_im_heiligen_land',cssclass:'unic-deal-4',book_now:'BUCHEN SIE JETZT'},{title:'Emmausreisen',desc:'09. bis 19. April 2022: Heiliges Land zum Osterfest - 11 Tage',price:'2345 € ',logo:'Deals/Emmausreisen.jpg',link:'https://www.emmaus-reisen.de/tour/09-bis-19-april-2022-heiliges-land-zum-osterfest-2hlp2008/',cssclass:'unic-deal-4',book_now:'BUCHEN SIE JETZT'},{title:'Biblische Reisen',desc:'Das Land der Bibel neu entdeckt 8-tägige Studienreise Linienflug,  Halbpension, Rundfahrten und Ausflüge, Alle Eintrittsgelder',price:'2390 € ',logo:'Deals/Biblische Reisen.jpg',link:'https://biblische-reisen.de/katalogreisen/nahost/israel/hlk22_das_land_der_bibel_neu_entdeckt',cssclass:'unic-deal-4',book_now:'BUCHEN SIE JETZT'},{title:'Studiosus',desc:'Studienreise - Heiliges Land in kleiner Gruppe - 8 Tage',price:'2395 € ',logo:'Deals/Studiosus.jpg',link:'https://www.studiosus.com/Israel/Studienreise/Rundreise/3611--Israel-Heiliges-Land-in-kleiner-Gruppe--Fluganreise',cssclass:'unic-deal-4',book_now:'BUCHEN SIE JETZT'},{title:'Emmausreisen',desc:'21. bis 31. März 2022: Heiliges Land – Entdeckungen im Land der Bibel - 11 Tage',price:'2485 € ',logo:'Deals/Emmausreisen.jpg',link:'https://www.emmaus-reisen.de/tour/heiliges-land-entdeckungen-im-land-der-bibel-2hlp2007/',cssclass:'unic-deal-4',book_now:'BUCHEN SIE JETZT'},{title:'Emmausreisen',desc:'04. bis 14. April 2022: Heiliges Land – Orte besuchen, die aus der Bibel vertraut sind - 11 Tage',price:'2495 € ',logo:'Deals/Emmausreisen.jpg',link:'https://www.emmaus-reisen.de/tour/04-bis-14-april-2022-heiliges-land-orte-besuchen-die-aus-der-bibel-vertraut-sind-2hlp2001/',cssclass:'unic-deal-4',book_now:'BUCHEN SIE JETZT'},{title:'Hauser Exkursionen',desc:'10-tägige Wanderreise auf dem Israel National Trail durch die Wüste Negev zum Roten Meer mit Besuch von Jerusalem und Tel Aviv',price:'2498 € ',logo:'Deals/Hauser Exkursionen.jpg',link:'https://www.hauser-exkursionen.de/reise/israel-aus-der-wueste-in-die-heilige-stadt?variant=2022',cssclass:'unic-deal-4',book_now:'BUCHEN SIE JETZT'},{title:'Eberhardt',desc:'Silvester in Israel, 7 Tage',price:'2498 € ',logo:'Deals/Eberhardt.jpg',link:'https://www.eberhardt-travel.de/reise/fernreisen/israel/telaviv-jerusalem/il-yytlv',cssclass:'unic-deal-7',book_now:'BUCHEN SIE JETZT'},{title:'Hauser Exkursionen',desc:'9-tägige Wanderreise durch die Berge Galiläas und die Judäische Wüste bis nach Jerusalem',price:'2595 € ',logo:'Deals/Hauser Exkursionen.jpg',link:'https://www.hauser-exkursionen.de/reise/israel-der-jerusalem-weg',cssclass:'unic-deal-4',book_now:'BUCHEN SIE JETZT'},{title:'Eberhardt',desc:'Wanderreise Israel, 13 Tage, ca. 60 Wanderkilometer',price:'2748 € ',logo:'Deals/Eberhardt.jpg',link:'https://www.eberhardt-travel.de/reise/wanderreisen/israel-totes-meer/see-genezareth-totes-meer/il-aktiv',cssclass:'unic-deal-8',book_now:'BUCHEN SIE JETZT'},{title:'Weltweitwandern',desc:'10 tägige Wanderreise - Von Galiläa bis in die Negev Wüste',price:'2790 € ',logo:'Deals/Weltweitwandern.jpg',link:'https://www.weltweitwandern.at/asien/israel/israel-wege-nach-jerusalem/',cssclass:'unic-deal-9',book_now:'BUCHEN SIE JETZT'},{title:'Biblische Reisen',desc:'Die Welt hinter den Bibeltexten 10-tägige Archäologische Studienreise Linienflug, Halbpension, Rundfahrten und Ausflüge, Alle Eintrittsgelder',price:'2960 € ',logo:'Deals/Biblische Reisen.jpg',link:'https://biblische-reisen.de/katalogreisen/nahost/heiliges_land/hlk60_die_welt_hinter_den_bibeltexten',cssclass:'unic-deal-4',book_now:'BUCHEN SIE JETZT'},{title:'Eberhardt',desc:'ausführliche Rundreise durch Israel mit Studienreisecharakter, 11 Tage',price:'2998 € ',logo:'Deals/Eberhardt.jpg',link:'https://www.eberhardt-travel.de/reise/fernreisen/israel-totes-meer/jerusalem-bethlehem/il-isr11',cssclass:'unic-deal-10',book_now:'BUCHEN SIE JETZT'},{title:'Studiosus',desc:'Klassik Studienreise - alte Kulturen junges Land - 10 Tage',price:'3095 € ',logo:'Deals/Studiosus.jpg',link:'https://www.studiosus.com/Israel/3621--Israel-alte-Kulturen-junges-Land--Fluganreise',cssclass:'unic-deal-10',book_now:'BUCHEN SIE JETZT'},{title:'Bike Tour',desc:'In 14 Tagen mit dem Fahrrad quer durch Israel, vom fruchtbaren grünen Norden, dem See Genezareth und dem Toten Meer entlang durch die Wüste  bis ans Rote Meer.',price:'3310 € ',logo:'Deals/Bike Tour_.jpg',link:'https://www.bike-tour.ch/',cssclass:'unic-deal-10',book_now:'BUCHEN SIE JETZT'},{title:'Studiosus',desc:'Studienreise - Große Israelreise - 15 Tage',price:'3495 € ',logo:'Deals/Studiosus.jpg',link:'https://www.studiosus.com/Israel/Studienreise/Rundreise/3602--Israel-die-Gro%C3%9Fe-Israelreise--Fluganreise',cssclass:'unic-deal-4',book_now:'BUCHEN SIE JETZT'},{title:'Eberhardt',desc:'Israel für Rollstuhlfahrer, 12 Tage',price:'3998 € ',logo:'Deals/Eberhardt.jpg',link:'https://www.eberhardt-travel.de/reise/reisen-mit-rollstuhl/israel/jerusalem/il-isrbh',cssclass:'unic-deal-11',book_now:'BUCHEN SIE JETZT'}];return _this;}_createClass(Deals,[{key:'render',value:function render(){var dealsHtml=this.deals.map(function(o){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__DealItem__["a" /* DealItem */],{key:o.title,brand:o.title,price:o.price,brandImg:o.logo,desc:o.desc,bookNowLink:o.link,descFontSize:o.fontSize});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'deals-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SimpleSlider_SimpleSlider__["a" /* default */],{settings:this.dealsSliderSettings},' ',dealsHtml,' '),' ');}}]);return Deals;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Deals);

/***/ }),
/* 242 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fast_deep_equal__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fast_deep_equal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fast_deep_equal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_youtube_player__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_youtube_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_youtube_player__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * Check whether a `props` change should result in the video being updated.
 *
 * @param {Object} prevProps
 * @param {Object} props
 */
function shouldUpdateVideo(prevProps, props) {
  // A changing video should always trigger an update
  if (prevProps.videoId !== props.videoId) {
    return true;
  }

  // Otherwise, a change in the start/end time playerVars also requires a player
  // update.
  var prevVars = prevProps.opts.playerVars || {};
  var vars = props.opts.playerVars || {};

  return prevVars.start !== vars.start || prevVars.end !== vars.end;
}

/**
 * Neutralise API options that only require a video update, leaving only options
 * that require a player reset. The results can then be compared to see if a
 * player reset is necessary.
 *
 * @param {Object} opts
 */
function filterResetOptions(opts) {
  return _extends({}, opts, {
    playerVars: _extends({}, opts.playerVars, {
      autoplay: 0,
      start: 0,
      end: 0
    })
  });
}

/**
 * Check whether a `props` change should result in the player being reset.
 * The player is reset when the `props.opts` change, except if the only change
 * is in the `start` and `end` playerVars, because a video update can deal with
 * those.
 *
 * @param {Object} prevProps
 * @param {Object} props
 */
function shouldResetPlayer(prevProps, props) {
  return !__WEBPACK_IMPORTED_MODULE_2_fast_deep_equal___default()(filterResetOptions(prevProps.opts), filterResetOptions(props.opts));
}

/**
 * Check whether a props change should result in an id or className update.
 *
 * @param {Object} prevProps
 * @param {Object} props
 */
function shouldUpdatePlayer(prevProps, props) {
  return prevProps.id !== props.id || prevProps.className !== props.className;
}

var YouTube = function (_React$Component) {
  _inherits(YouTube, _React$Component);

  function YouTube(props) {
    _classCallCheck(this, YouTube);

    var _this = _possibleConstructorReturn(this, (YouTube.__proto__ || Object.getPrototypeOf(YouTube)).call(this, props));

    _this.onPlayerReady = function (event) {
      return _this.props.onReady(event);
    };

    _this.onPlayerError = function (event) {
      return _this.props.onError(event);
    };

    _this.onPlayerStateChange = function (event) {
      _this.props.onStateChange(event);
      switch (event.data) {

        case YouTube.PlayerState.ENDED:
          _this.props.onEnd(event);
          break;

        case YouTube.PlayerState.PLAYING:
          _this.props.onPlay(event);
          break;

        case YouTube.PlayerState.PAUSED:
          _this.props.onPause(event);
          break;

        default:
      }
    };

    _this.onPlayerPlaybackRateChange = function (event) {
      return _this.props.onPlaybackRateChange(event);
    };

    _this.onPlayerPlaybackQualityChange = function (event) {
      return _this.props.onPlaybackQualityChange(event);
    };

    _this.createPlayer = function () {
      // do not attempt to create a player server-side, it won't work
      if (typeof document === 'undefined') return;
      // create player
      var playerOpts = _extends({}, _this.props.opts, {
        // preload the `videoId` video if one is already given
        videoId: _this.props.videoId
      });
      _this.internalPlayer = __WEBPACK_IMPORTED_MODULE_3_youtube_player___default()(_this.container, playerOpts);
      // attach event handlers
      _this.internalPlayer.on('ready', _this.onPlayerReady);
      _this.internalPlayer.on('error', _this.onPlayerError);
      _this.internalPlayer.on('stateChange', _this.onPlayerStateChange);
      _this.internalPlayer.on('playbackRateChange', _this.onPlayerPlaybackRateChange);
      _this.internalPlayer.on('playbackQualityChange', _this.onPlayerPlaybackQualityChange);
    };

    _this.resetPlayer = function () {
      return _this.internalPlayer.destroy().then(_this.createPlayer);
    };

    _this.updatePlayer = function () {
      _this.internalPlayer.getIframe().then(function (iframe) {
        if (_this.props.id) iframe.setAttribute('id', _this.props.id);else iframe.removeAttribute('id');
        if (_this.props.className) iframe.setAttribute('class', _this.props.className);else iframe.removeAttribute('class');
      });
    };

    _this.updateVideo = function () {
      if (typeof _this.props.videoId === 'undefined' || _this.props.videoId === null) {
        _this.internalPlayer.stopVideo();
        return;
      }

      // set queueing options
      var autoplay = false;
      var opts = {
        videoId: _this.props.videoId
      };
      if ('playerVars' in _this.props.opts) {
        autoplay = _this.props.opts.playerVars.autoplay === 1;
        if ('start' in _this.props.opts.playerVars) {
          opts.startSeconds = _this.props.opts.playerVars.start;
        }
        if ('end' in _this.props.opts.playerVars) {
          opts.endSeconds = _this.props.opts.playerVars.end;
        }
      }

      // if autoplay is enabled loadVideoById
      if (autoplay) {
        _this.internalPlayer.loadVideoById(opts);
        return;
      }
      // default behaviour just cues the video
      _this.internalPlayer.cueVideoById(opts);
    };

    _this.refContainer = function (container) {
      _this.container = container;
    };

    _this.container = null;
    _this.internalPlayer = null;
    return _this;
  }

  /**
    * Expose PlayerState constants for convenience. These constants can also be
    * accessed through the global YT object after the YouTube IFrame API is instantiated.
    * https://developers.google.com/youtube/iframe_api_reference#onStateChange
    */


  _createClass(YouTube, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.createPlayer();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (shouldUpdatePlayer(prevProps, this.props)) {
        this.updatePlayer();
      }

      if (shouldResetPlayer(prevProps, this.props)) {
        this.resetPlayer();
      }

      if (shouldUpdateVideo(prevProps, this.props)) {
        this.updateVideo();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      /**
       * Note: The `youtube-player` package that is used promisifies all Youtube
       * Player API calls, which introduces a delay of a tick before it actually
       * gets destroyed. Since React attempts to remove the element instantly
       * this method isn't quick enough to reset the container element.
       */
      this.internalPlayer.destroy();
    }

    /**
     * https://developers.google.com/youtube/iframe_api_reference#onReady
     *
     * @param {Object} event
     *   @param {Object} target - player object
     */


    /**
     * https://developers.google.com/youtube/iframe_api_reference#onError
     *
     * @param {Object} event
     *   @param {Integer} data  - error type
     *   @param {Object} target - player object
     */


    /**
     * https://developers.google.com/youtube/iframe_api_reference#onStateChange
     *
     * @param {Object} event
     *   @param {Integer} data  - status change type
     *   @param {Object} target - actual YT player
     */


    /**
     * https://developers.google.com/youtube/iframe_api_reference#onPlaybackRateChange
     *
     * @param {Object} event
     *   @param {Float} data    - playback rate
     *   @param {Object} target - actual YT player
     */


    /**
     * https://developers.google.com/youtube/iframe_api_reference#onPlaybackQualityChange
     *
     * @param {Object} event
     *   @param {String} data   - playback quality
     *   @param {Object} target - actual YT player
     */


    /**
     * Initialize the Youtube Player API on the container and attach event handlers
     */


    /**
     * Shorthand for destroying and then re-creating the Youtube Player
     */


    /**
     * Method to update the id and class of the Youtube Player iframe.
     * React should update this automatically but since the Youtube Player API
     * replaced the DIV that is mounted by React we need to do this manually.
     */


    /**
     * Call Youtube Player API methods to update the currently playing video.
     * Depeding on the `opts.playerVars.autoplay` this function uses one of two
     * Youtube Player API methods to update the video.
     */

  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: this.props.containerClassName },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { id: this.props.id, className: this.props.className, ref: this.refContainer })
      );
    }
  }]);

  return YouTube;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

YouTube.propTypes = {
  videoId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,

  // custom ID for player element
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,

  // custom class name for player element
  className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  // custom class name for player container element
  containerClassName: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,

  // https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
  opts: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any),

  // event subscriptions
  onReady: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onError: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onPlay: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onPause: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onEnd: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onStateChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onPlaybackRateChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onPlaybackQualityChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
};
YouTube.defaultProps = {
  id: null,
  className: null,
  opts: {},
  containerClassName: '',
  onReady: function onReady() {},
  onError: function onError() {},
  onPlay: function onPlay() {},
  onPause: function onPause() {},
  onEnd: function onEnd() {},
  onStateChange: function onStateChange() {},
  onPlaybackRateChange: function onPlaybackRateChange() {},
  onPlaybackQualityChange: function onPlaybackQualityChange() {}
};
YouTube.PlayerState = {
  UNSTARTED: -1,
  ENDED: 0,
  PLAYING: 1,
  PAUSED: 2,
  BUFFERING: 3,
  CUED: 5
};


/* harmony default export */ __webpack_exports__["a"] = (YouTube);

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;

module.exports = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    var arrA = isArray(a)
      , arrB = isArray(b)
      , i
      , length
      , key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    if (arrA != arrB) return false;

    var dateA = a instanceof Date
      , dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();

    var regexpA = a instanceof RegExp
      , regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();

    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length)
      return false;

    for (i = length; i-- !== 0;)
      if (!hasProp.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  return a!==a && b!==b;
};


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _sister = __webpack_require__(246);

var _sister2 = _interopRequireDefault(_sister);

var _loadYouTubeIframeApi = __webpack_require__(247);

var _loadYouTubeIframeApi2 = _interopRequireDefault(_loadYouTubeIframeApi);

var _YouTubePlayer = __webpack_require__(249);

var _YouTubePlayer2 = _interopRequireDefault(_YouTubePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @typedef YT.Player
 * @see https://developers.google.com/youtube/iframe_api_reference
 * */

/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
 */
var youtubeIframeAPI = void 0;

/**
 * A factory function used to produce an instance of YT.Player and queue function calls and proxy events of the resulting object.
 *
 * @param maybeElementId Either An existing YT.Player instance,
 * the DOM element or the id of the HTML element where the API will insert an <iframe>.
 * @param options See `options` (Ignored when using an existing YT.Player instance).
 * @param strictState A flag designating whether or not to wait for
 * an acceptable state when calling supported functions. Default: `false`.
 * See `FunctionStateMap.js` for supported functions and acceptable states.
 */

exports.default = function (maybeElementId) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var strictState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var emitter = (0, _sister2.default)();

  if (!youtubeIframeAPI) {
    youtubeIframeAPI = (0, _loadYouTubeIframeApi2.default)(emitter);
  }

  if (options.events) {
    throw new Error('Event handlers cannot be overwritten.');
  }

  if (typeof maybeElementId === 'string' && !document.getElementById(maybeElementId)) {
    throw new Error('Element "' + maybeElementId + '" does not exist.');
  }

  options.events = _YouTubePlayer2.default.proxyEvents(emitter);

  var playerAPIReady = new Promise(function (resolve) {
    if ((typeof maybeElementId === 'undefined' ? 'undefined' : _typeof(maybeElementId)) === 'object' && maybeElementId.playVideo instanceof Function) {
      var player = maybeElementId;

      resolve(player);
    } else {
      // asume maybeElementId can be rendered inside
      // eslint-disable-next-line promise/catch-or-return
      youtubeIframeAPI.then(function (YT) {
        // eslint-disable-line promise/prefer-await-to-then
        var player = new YT.Player(maybeElementId, options);

        emitter.on('ready', function () {
          resolve(player);
        });

        return null;
      });
    }
  });

  var playerApi = _YouTubePlayer2.default.promisifyPlayer(playerAPIReady, strictState);

  playerApi.on = emitter.on;
  playerApi.off = emitter.off;

  return playerApi;
};

module.exports = exports['default'];

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Sister;

/**
* @link https://github.com/gajus/sister for the canonical source repository
* @license https://github.com/gajus/sister/blob/master/LICENSE BSD 3-Clause
*/
Sister = function () {
    var sister = {},
        events = {};

    /**
     * @name handler
     * @function
     * @param {Object} data Event data.
     */

    /**
     * @param {String} name Event name.
     * @param {handler} handler
     * @return {listener}
     */
    sister.on = function (name, handler) {
        var listener = {name: name, handler: handler};
        events[name] = events[name] || [];
        events[name].unshift(listener);
        return listener;
    };

    /**
     * @param {listener}
     */
    sister.off = function (listener) {
        var index = events[listener.name].indexOf(listener);

        if (index !== -1) {
            events[listener.name].splice(index, 1);
        }
    };

    /**
     * @param {String} name Event name.
     * @param {Object} data Event data.
     */
    sister.trigger = function (name, data) {
        var listeners = events[name],
            i;

        if (listeners) {
            i = listeners.length;
            while (i--) {
                listeners[i].handler(data);
            }
        }
    };

    return sister;
};

module.exports = Sister;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loadScript = __webpack_require__(248);

var _loadScript2 = _interopRequireDefault(_loadScript);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (emitter) {
  /**
   * A promise that is resolved when window.onYouTubeIframeAPIReady is called.
   * The promise is resolved with a reference to window.YT object.
   */
  var iframeAPIReady = new Promise(function (resolve) {
    if (window.YT && window.YT.Player && window.YT.Player instanceof Function) {
      resolve(window.YT);

      return;
    } else {
      var protocol = window.location.protocol === 'http:' ? 'http:' : 'https:';

      (0, _loadScript2.default)(protocol + '//www.youtube.com/iframe_api', function (error) {
        if (error) {
          emitter.trigger('error', error);
        }
      });
    }

    var previous = window.onYouTubeIframeAPIReady;

    // The API will call this function when page has finished downloading
    // the JavaScript for the player API.
    window.onYouTubeIframeAPIReady = function () {
      if (previous) {
        previous();
      }

      resolve(window.YT);
    };
  });

  return iframeAPIReady;
};

module.exports = exports['default'];

/***/ }),
/* 248 */
/***/ (function(module, exports) {


module.exports = function load (src, opts, cb) {
  var head = document.head || document.getElementsByTagName('head')[0]
  var script = document.createElement('script')

  if (typeof opts === 'function') {
    cb = opts
    opts = {}
  }

  opts = opts || {}
  cb = cb || function() {}

  script.type = opts.type || 'text/javascript'
  script.charset = opts.charset || 'utf8';
  script.async = 'async' in opts ? !!opts.async : true
  script.src = src

  if (opts.attrs) {
    setAttributes(script, opts.attrs)
  }

  if (opts.text) {
    script.text = '' + opts.text
  }

  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
  onend(script, cb)

  // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload
  if (!script.onload) {
    stdOnEnd(script, cb);
  }

  head.appendChild(script)
}

function setAttributes(script, attrs) {
  for (var attr in attrs) {
    script.setAttribute(attr, attrs[attr]);
  }
}

function stdOnEnd (script, cb) {
  script.onload = function () {
    this.onerror = this.onload = null
    cb(null, script)
  }
  script.onerror = function () {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null
    cb(new Error('Failed to load ' + this.src), script)
  }
}

function ieOnEnd (script, cb) {
  script.onreadystatechange = function () {
    if (this.readyState != 'complete' && this.readyState != 'loaded') return
    this.onreadystatechange = null
    cb(null, script) // there is no way to catch loading errors in IE8
  }
}


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _debug = __webpack_require__(250);

var _debug2 = _interopRequireDefault(_debug);

var _functionNames = __webpack_require__(253);

var _functionNames2 = _interopRequireDefault(_functionNames);

var _eventNames = __webpack_require__(254);

var _eventNames2 = _interopRequireDefault(_eventNames);

var _FunctionStateMap = __webpack_require__(255);

var _FunctionStateMap2 = _interopRequireDefault(_FunctionStateMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable promise/prefer-await-to-then */

var debug = (0, _debug2.default)('youtube-player');

var YouTubePlayer = {};

/**
 * Construct an object that defines an event handler for all of the YouTube
 * player events. Proxy captured events through an event emitter.
 *
 * @todo Capture event parameters.
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 */
YouTubePlayer.proxyEvents = function (emitter) {
  var events = {};

  var _loop = function _loop(eventName) {
    var onEventName = 'on' + eventName.slice(0, 1).toUpperCase() + eventName.slice(1);

    events[onEventName] = function (event) {
      debug('event "%s"', onEventName, event);

      emitter.trigger(eventName, event);
    };
  };

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = _eventNames2.default[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var eventName = _step.value;

      _loop(eventName);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return events;
};

/**
 * Delays player API method execution until player state is ready.
 *
 * @todo Proxy all of the methods using Object.keys.
 * @todo See TRICKY below.
 * @param playerAPIReady Promise that resolves when player is ready.
 * @param strictState A flag designating whether or not to wait for
 * an acceptable state when calling supported functions.
 * @returns {Object}
 */
YouTubePlayer.promisifyPlayer = function (playerAPIReady) {
  var strictState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var functions = {};

  var _loop2 = function _loop2(functionName) {
    if (strictState && _FunctionStateMap2.default[functionName]) {
      functions[functionName] = function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return playerAPIReady.then(function (player) {
          var stateInfo = _FunctionStateMap2.default[functionName];
          var playerState = player.getPlayerState();

          // eslint-disable-next-line no-warning-comments
          // TODO: Just spread the args into the function once Babel is fixed:
          // https://github.com/babel/babel/issues/4270
          //
          // eslint-disable-next-line prefer-spread
          var value = player[functionName].apply(player, args);

          // TRICKY: For functions like `seekTo`, a change in state must be
          // triggered given that the resulting state could match the initial
          // state.
          if (stateInfo.stateChangeRequired ||

          // eslint-disable-next-line no-extra-parens
          Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerState) === -1) {
            return new Promise(function (resolve) {
              var onPlayerStateChange = function onPlayerStateChange() {
                var playerStateAfterChange = player.getPlayerState();

                var timeout = void 0;

                if (typeof stateInfo.timeout === 'number') {
                  timeout = setTimeout(function () {
                    player.removeEventListener('onStateChange', onPlayerStateChange);

                    resolve();
                  }, stateInfo.timeout);
                }

                if (Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerStateAfterChange) !== -1) {
                  player.removeEventListener('onStateChange', onPlayerStateChange);

                  clearTimeout(timeout);

                  resolve();
                }
              };

              player.addEventListener('onStateChange', onPlayerStateChange);
            }).then(function () {
              return value;
            });
          }

          return value;
        });
      };
    } else {
      functions[functionName] = function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return playerAPIReady.then(function (player) {
          // eslint-disable-next-line no-warning-comments
          // TODO: Just spread the args into the function once Babel is fixed:
          // https://github.com/babel/babel/issues/4270
          //
          // eslint-disable-next-line prefer-spread
          return player[functionName].apply(player, args);
        });
      };
    }
  };

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = _functionNames2.default[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var functionName = _step2.value;

      _loop2(functionName);
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return functions;
};

exports.default = YouTubePlayer;
module.exports = exports['default'];

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(251);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = Object({"NODE_ENV":"production","PUBLIC_URL":""}).DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)))

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(252);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 252 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Functions
 */
exports.default = ['cueVideoById', 'loadVideoById', 'cueVideoByUrl', 'loadVideoByUrl', 'playVideo', 'pauseVideo', 'stopVideo', 'getVideoLoadedFraction', 'cuePlaylist', 'loadPlaylist', 'nextVideo', 'previousVideo', 'playVideoAt', 'setShuffle', 'setLoop', 'getPlaylist', 'getPlaylistIndex', 'setOption', 'mute', 'unMute', 'isMuted', 'setVolume', 'getVolume', 'seekTo', 'getPlayerState', 'getPlaybackRate', 'setPlaybackRate', 'getAvailablePlaybackRates', 'getPlaybackQuality', 'setPlaybackQuality', 'getAvailableQualityLevels', 'getCurrentTime', 'getDuration', 'removeEventListener', 'getVideoUrl', 'getVideoEmbedCode', 'getOptions', 'getOption', 'addEventListener', 'destroy', 'setSize', 'getIframe'];
module.exports = exports['default'];

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 * `volumeChange` is not officially supported but seems to work
 * it emits an object: `{volume: 82.6923076923077, muted: false}`
 */
exports.default = ['ready', 'stateChange', 'playbackQualityChange', 'playbackRateChange', 'error', 'apiChange', 'volumeChange'];
module.exports = exports['default'];

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PlayerStates = __webpack_require__(256);

var _PlayerStates2 = _interopRequireDefault(_PlayerStates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  pauseVideo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PAUSED],
    stateChangeRequired: false
  },
  playVideo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING],
    stateChangeRequired: false
  },
  seekTo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING, _PlayerStates2.default.PAUSED],
    stateChangeRequired: true,

    // TRICKY: `seekTo` may not cause a state change if no buffering is
    // required.
    timeout: 3000
  }
};
module.exports = exports['default'];

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  BUFFERING: 3,
  ENDED: 0,
  PAUSED: 2,
  PLAYING: 1,
  UNSTARTED: -1,
  VIDEO_CUED: 5
};
module.exports = exports["default"];

/***/ }),
/* 257 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
var Http=__WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({// baseURL: 'https://en.citiesbreak.com',
});/* harmony default export */ __webpack_exports__["a"] = (Http);

/***/ }),
/* 259 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 260 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 261 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Footer_Footer__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SpacielDeals=function(_Component){_inherits(SpacielDeals,_Component);function SpacielDeals(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SpacielDeals);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SpacielDeals.__proto__||Object.getPrototypeOf(SpacielDeals)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SpacielDeals,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["g" /* getWeather */])(function(Weather){console.log("Weather",Weather);_this2.setState({telAvivWeather:Weather.telAvivWeather,waterTemp:Weather.water_temp,jerusalemWeather:Weather.jerusalemWeather});});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page align-center page-SpacielDeals'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["h" /* HomeSlider */],{isHomeSlider:true,waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["g" /* HomeDeals */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Footer_Footer__["a" /* default */],null));}}]);return SpacielDeals;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SpacielDeals);

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__innerPage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LiveShows_css__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LiveShows_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__LiveShows_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LiveShows=function(_Component){_inherits(LiveShows,_Component);function LiveShows(){var _ref;var _temp,_this,_ret;_classCallCheck(this,LiveShows);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=LiveShows.__proto__||Object.getPrototypeOf(LiveShows)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(LiveShows,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_3__Utility_Utility__["g" /* getWeather */])(function(Weather){console.log("Weather",Weather);_this2.setState({telAvivWeather:Weather.telAvivWeather,waterTemp:Weather.water_temp,jerusalemWeather:Weather.jerusalemWeather});});}},{key:'render',value:function render(){var counter=0;var counter2=0;var hasBean=[];var date1=new Date();var concertSHtml=__WEBPACK_IMPORTED_MODULE_2__Data_Data__["f" /* showsArr */].map(function(o,i){var cssClass="newAddOpacity";var html="";if(counter%4===0){cssClass="first newAddOpacity";}if(o.isDouble===true){cssClass="double-singer newAddOpacity";}var isTodayBigger=Object(__WEBPACK_IMPORTED_MODULE_3__Utility_Utility__["b" /* compareDates */])(date1,o.date);if(isTodayBigger===true||o.date==="30.12.2017"||o.date==="21.06.2018"){cssClass+=" addOpacity ";hasBean.push(o);}else{counter++;var url="/Posts/Concerts/"+o.id;if(url==="/Posts/Concerts/undefined"){cssClass="no-inner-page newAddOpacity";}// if (o.title === "UNITE WITH TOMORROWLAND")
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["c" /* ConcertSliderItem */],{key:i,title:o.title,desc:o.date,img:o.img,link:url,cssClass:cssClass});}});// remove unnaccery shows
hasBean.splice(-3,hasBean.length%4+1);// hasBean.splice(-1,1);
// hasBean.splice(-1,1);
var hasBeanSHtml=hasBean.map(function(o,i){var cssClass="newAddOpacity";var html="";if(counter2%4===0){cssClass=" ";}cssClass+=" addOpacity newAddOpacity";counter2++;var url="/Posts/Concerts/"+o.id;// if (o.title === "UNITE WITH TOMORROWLAND")
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["c" /* ConcertSliderItem */],{key:i,title:o.title,desc:o.date,img:o.img,link:url,cssClass:cssClass});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-page align-center page-LiveShows'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["h" /* HomeSlider */],{waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'live-shows-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["i" /* HomeTitle */],null,'LIVE SHOWS'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'live-shows-wrapper'},concertSHtml,hasBeanSHtml,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["g" /* HomeDeals */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__["a" /* default */],null));}}]);return LiveShows;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* unused harmony default export */ var _unused_webpack_default_export = (LiveShows);

/***/ }),
/* 264 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__innerPage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ExporeTelAvivAndJerusalem_css__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ExporeTelAvivAndJerusalem_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ExporeTelAvivAndJerusalem_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ExporeTelAvivAndJerusalem=function(_Component){_inherits(ExporeTelAvivAndJerusalem,_Component);function ExporeTelAvivAndJerusalem(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ExporeTelAvivAndJerusalem);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ExporeTelAvivAndJerusalem.__proto__||Object.getPrototypeOf(ExporeTelAvivAndJerusalem)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ExporeTelAvivAndJerusalem,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_3__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log( typeof weather);
// console.log( weather);
var weather2=weather;if(typeof weather==='string'&&weather.includes("float")){// Variable is a string
// console.log('Is float in string');
var str=weather.substring(weather.indexOf("{")+1);var str2="{"+str;// console.log(str2);
weather2=JSON.parse(str2);}else if((typeof weather==='undefined'?'undefined':_typeof(weather))==='object'&&weather!==null){// Variable is an object
// console.log('Variable is an object');
weather2=weather.data;// console.log(weather2);
}else if(typeof weather==='string'&&!weather.includes("float")){// console.log('Is NOt  float in string');
var _str=weather.substring(weather.indexOf("{")+1);var _str2="{"+_str;// console.log(str2);
weather2=JSON.parse(_str2);}//  else {
//   // Variable is neither a string nor an object
//   console.log('Variable is neither a string nor an object');
// }
_this2.setState({deadSeaWeather:weather2.deadsea.temperature,jerusalemWeather:weather2.jerusalem.temperature,telAvivWeather:weather2.telaviv.temperature,waterTemp:weather2.telaviv.water_temp});});}},{key:'render',value:function render(){// get all posts 
var posts=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2__Data_Data__["d" /* newPosts */]));// get video posts 
var nonVidPosts=posts.filter(function(o,i){return(o.isVid===true||o.forVidPage===true)&&o.isDouble!==true;});var concertSHtml=nonVidPosts.map(function(o,i){var cssClass="";var html="";if(i%4===0){cssClass=" first";}var url="/Posts/Videos/"+o.ctg+'/'+o.id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["q" /* VideoSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-page align-center page-ExporeTelAvivAndJerusalem'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["d" /* CoverSection */],{desktopImg:'/posts/bank/page-videos/1.jpg',mobileImg:'/posts/bank/page-videos/M.jpg',cssClass:'telaviv',waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'live-shows-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["i" /* HomeTitle */],null,'VIDEOS'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:'FYtk8JMMZRE'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'live-shows-wrapper'},concertSHtml),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["g" /* HomeDeals */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__["a" /* default */],null));}}]);return ExporeTelAvivAndJerusalem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ExporeTelAvivAndJerusalem);

/***/ }),
/* 266 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Footer_Footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TermsOfUse_css__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TermsOfUse_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__TermsOfUse_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TermsOfUse=function(_Component){_inherits(TermsOfUse,_Component);function TermsOfUse(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TermsOfUse);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TermsOfUse.__proto__||Object.getPrototypeOf(TermsOfUse)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TermsOfUse,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log( typeof weather);
// console.log( weather);
var weather2=weather;if(typeof weather==='string'&&weather.includes("float")){// Variable is a string
// console.log('Is float in string');
var str=weather.substring(weather.indexOf("{")+1);var str2="{"+str;// console.log(str2);
weather2=JSON.parse(str2);}else if((typeof weather==='undefined'?'undefined':_typeof(weather))==='object'&&weather!==null){// Variable is an object
// console.log('Variable is an object');
weather2=weather.data;// console.log(weather2);
}else if(typeof weather==='string'&&!weather.includes("float")){// console.log('Is NOt  float in string');
var _str=weather.substring(weather.indexOf("{")+1);var _str2="{"+_str;// console.log(str2);
weather2=JSON.parse(_str2);}//  else {
//   // Variable is neither a string nor an object
//   console.log('Variable is neither a string nor an object');
// }
_this2.setState({deadSeaWeather:weather2.deadsea.temperature,jerusalemWeather:weather2.jerusalem.temperature,telAvivWeather:weather2.telaviv.temperature,waterTemp:weather2.telaviv.water_temp});});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page align-left page-TermsOfUse'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["h" /* HomeSlider */],{waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["i" /* HomeTitle */],null,'Terms of Use'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'General'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The Israeli Ministry of Tourism (hereinafter- the Ministry) offers the information on this website (hereinafter- the service) subject to your acceptance, with no amendments whatsoever, of the terms, conditions and notifications contained herein. By using the Service you signify your agreement to all such terms, conditions and notifications. Please read these Terms of Use carefully before using the Service. If you do not agree to all these terms, you may not use the Service. The term \u201CUser\u201D as follows shall mean each person who establishes or accesses a connection to the service.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Liability'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The information provided to User is provided for his convenience only. Information that concerns third parties should be verified with the service providers themselves before making a decision based on the information shown.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'It is emphasized that the businesses whose details are provided in the Service are not supervised or reviewed by the Ministry and are not under its responsibility, and the Ministry therefore is not responsible in any way for the service provided to any visitor, including the quality and nature of the physical facilities or the service, the prices charged, the visitor\u2019s satisfaction, etc. The Ministry shall not be held liable for any damage caused to User and/or to any visitor in the course of any visit or use made based on the information provided to him/her by the Service. The information provided to User informs of the existence per se of the businesses (attractions, accommodation, events, etc.) and is not in any way a specific recommendation to use a particular business. Full responsibility for the service is imposed on the service provider. The information provided on the Service may not be construed as endorsement, approval, recommendation or favoring of the use of a particular service or of a visit to a particular site and/or business. The Ministry shall not be held liable for the suitability of the Service to User\u2019s needs. Furthermore, the Ministry shall not be held liable for errors or mistakes in the information provided to User which was not produced by the Ministry but is received from third parties.. User alone is responsible for the way in which he/she uses the Service. The Ministry shall not be held liable for any damage caused to User or to any third party as a direct or indirect result of using the Service, including damage caused due to the use of software applications downloaded directly through the Service or activated as a result of the use of the Service, including Java, JavaScript and ActiveX. For purposes of this section, \u201CThe Ministry\u201D includes its employees and representatives.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Links'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'As part of the Service, the Service may provide links to other websites. The following conditions apply to the use of those links, without derogating from the other conditions in these Terms of Use. The links are provided solely for the convenience of User. Regarding links to external sites which are not owned by the State of Israel (third party sites), unless otherwise stipulated on this Site, no legal or commercial relationship exists between the Ministry and the owners of third party sites, and the Ministry has no control over or right to material found on those sites. The Ministry is not responsible for the content of third party sites and/or for information on commercial or noncommercial products or services offered on them, including the nature or quality thereof. It is recommended to check the information with the service providers or with another relevant party. Links to third party sites may not be construed as endorsement, approval, recommendation or favoring by the State of Israel of those linked-to sites, including documents and other material found on them, of the operators of said sites and of the products or services presented and/or offered on them. At the time each link was included in this Service, the information contained on the linked-to site was found to be compatible with the purposes of the Service and the link itself was functional. However, it is possible that with the passage of time changes have occurred in the linked-to site. If User feels that the linked-to site or material is inappropriate, or if User finds that the link is no longer operational, he/she is requested to inform the Ministry via email at: NitsanI@tourism.gov.il'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Deals/packages'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The Ministry serves as an information channel and is not responsible whatsoever for the packages advertised herein by third commercial parties. Any and all purchases of packages appearing on this page shall not take place on the Ministry\u2019s platform and the purchase shall be performed on the platform of the entity who is advertising the package. Full responsibility for the service is imposed on the service provider and not the Ministry of Tourism. The packages are neither supervised nor reviewed by the Ministry and are not under its responsibility, therefore it is recommended to verify the information with the service providers themselves before making a decision based on the information shown.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Copyright'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The copyrights of the website and its content belong to the Ministry. Subject to copyright law, User may not copy, redistribute, retransmit or publish protected material, without the prior written consent of the Ministry.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Contacting the Ministry'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Any question regarding this Service and other questions relating to the Ministry\u2019s sphere of activity may be addressed directly to the Ministry by email at: NitsanI@tourism.gov.il'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Official Publications of the State of Israel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'In the event of a conflict or inconsistency between material published in the Service and material appearing in official written publications of the State of Israel, only the material contained in such official publications shall be deemed correct.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Copyright Infringement Notification'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'If you believe your copyright-protected work was posted on this page without authorization, you may submit a copyright infringement notification by e-mail to nitsani@tourism.gov.il. Notification and requests should be submitted by the copyright owner or an agent authorized to act on the owner\u2019s behalf.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Defamation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'If you believe that any content uploaded, posted or published on this website is defamatory, please submit your notification by e-mail to NitsanI@tourism.gov.il.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Footer_Footer__["a" /* default */],null));}}]);return TermsOfUse;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TermsOfUse);

/***/ }),
/* 268 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__innerPage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ThingsToDo_css__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ThingsToDo_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ThingsToDo_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ThingsToDo=function(_Component){_inherits(ThingsToDo,_Component);function ThingsToDo(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ThingsToDo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ThingsToDo.__proto__||Object.getPrototypeOf(ThingsToDo)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ThingsToDo,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_3__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log( typeof weather);
// console.log( weather);
var weather2=weather;if(typeof weather==='string'&&weather.includes("float")){// Variable is a string
// console.log('Is float in string');
var str=weather.substring(weather.indexOf("{")+1);var str2="{"+str;// console.log(str2);
weather2=JSON.parse(str2);}else if((typeof weather==='undefined'?'undefined':_typeof(weather))==='object'&&weather!==null){// Variable is an object
// console.log('Variable is an object');
weather2=weather.data;// console.log(weather2);
}else if(typeof weather==='string'&&!weather.includes("float")){// console.log('Is NOt  float in string');
var _str=weather.substring(weather.indexOf("{")+1);var _str2="{"+_str;// console.log(str2);
weather2=JSON.parse(_str2);}//  else {
//   // Variable is neither a string nor an object
//   console.log('Variable is neither a string nor an object');
// }
_this2.setState({deadSeaWeather:weather2.deadsea.temperature,jerusalemWeather:weather2.jerusalem.temperature,telAvivWeather:weather2.telaviv.temperature,waterTemp:weather2.telaviv.water_temp});});window.addEventListener("resize",this.updateDimensions);}},{key:'render',value:function render(){// get all posts 
var posts=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2__Data_Data__["d" /* newPosts */]));// get non video posts and culinary posts
var nonVidPosts=posts.filter(function(o,i){// return  o.isVid === false  || o.ctg === 'culinary' || o.isDouble === true;
return o.ctg==='culinary'||o.ctg==='jerusalem'||o.ctg==='telaviv'||o.ctg==='deadsea'||o.ctg==='deadsea_2'||o.ctg==='telavivAndJerusalem';});var thingsToDoPosts=[].concat(_toConsumableArray(posts));//  const thingsToDoPosts = posts.filter((o , i )=>{
//   return (o.isDouble == false);
// })
var postsHtml=thingsToDoPosts.map(function(o,i){// console.log('o' , o);
var cssClass="";var html="";if(i%4===0){cssClass=" first";}var url=null;var component=null;if(o.isVid===true){url="/Posts/Videos/"+o.ctg+'/'+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["q" /* VideoSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}else{// url = "/Posts/" + o.id ;
url="/Posts/"+o.ctg+'/'+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["n" /* PostSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}return component;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-page align-center page-ExporeTelAvivAndJerusalem page-thingsToDo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["d" /* CoverSection */],{desktopImg:'/posts/bank/page-thingstodo/1.jpg',mobileImg:'/posts/bank/page-thingstodo/M.jpg',cssClass:'jerusalim',waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'live-shows-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["i" /* HomeTitle */],null,'ERLEBEN'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'live-shows-wrapper'},postsHtml),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["g" /* HomeDeals */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__["a" /* default */],null));}}]);return ThingsToDo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ThingsToDo);

/***/ }),
/* 270 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lazyload__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_scroll__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Components_Footer_Footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Components_SimpleSlider_SimpleSlider__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__innerPage_css__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__innerPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__innerPage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__WhereToGo_css__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__WhereToGo_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__WhereToGo_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// private class data 
var PageObj1={img:'wtg1.jpg',img_mob:'wtg1-mob.jpg',link:'/Pages/TelAvivPage',text:'TEL AVIV'};var PageObj2={img:'wtg2.jpg',img_mob:'wtg2-mob.jpg',link:'/Pages/JerusalemPage',text:'JERUSALEM'};var PageObj3={img:'wtg3.jpg',img_mob:'wtg3.jpg',link:'/Pages/DeadSeaPage',text:'DAS TOTE MEER'};var PageObj4={img:'wtg5.jpg',img_mob:'wtg5.jpg',link:'/Pages/NorthPage',text:'NOORDEN'};var PageObj5={img:'wtg4.jpg',img_mob:'wtg4.jpg',link:'/Pages/EilatNegevPage',text:'NEGEV UND TEILAT'};var PageObj6={img_mob:'wtg6-mob.jpg',link:'/Pages/thingsToDo',text:'SEHEN'};var WhereToGo=function(_Component){_inherits(WhereToGo,_Component);function WhereToGo(){var _ref;var _temp,_this,_ret;_classCallCheck(this,WhereToGo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=WhereToGo.__proto__||Object.getPrototypeOf(WhereToGo)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0,telAvivVideo:"XDei1Zy_cu4",telAvivVideoState:0,jerusalemVideo:"k4OwoEk5wMw",jerusalemVideoState:0,deadSeaVideo:"DzEJxjnC_UQ",deadSeaVideoState:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(WhereToGo,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log( typeof weather);
// console.log( weather);
var weather2=weather;if(typeof weather==='string'&&weather.includes("float")){// Variable is a string
// console.log('Is float in string');
var str=weather.substring(weather.indexOf("{")+1);var str2="{"+str;// console.log(str2);
weather2=JSON.parse(str2);}else if((typeof weather==='undefined'?'undefined':_typeof(weather))==='object'&&weather!==null){// Variable is an object
// console.log('Variable is an object');
weather2=weather.data;// console.log(weather2);
}else if(typeof weather==='string'&&!weather.includes("float")){// console.log('Is NOt  float in string');
var _str=weather.substring(weather.indexOf("{")+1);var _str2="{"+_str;// console.log(str2);
weather2=JSON.parse(_str2);}//  else {
//   // Variable is neither a string nor an object
//   console.log('Variable is neither a string nor an object');
// }
_this2.setState({deadSeaWeather:weather2.deadsea.temperature,jerusalemWeather:weather2.jerusalem.temperature,telAvivWeather:weather2.telaviv.temperature,waterTemp:weather2.telaviv.water_temp});});window.addEventListener("resize",this.updateDimensions);}},{key:'render',value:function render(){var _React$createElement;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-page align-center page-whereToGo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'relative'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["d" /* CoverSection */],{desktopImg:'/posts/bank/page-wheretogo/1.jpg',mobileImg:'/posts/bank/page-wheretogo/M.jpg',cssClass:'jerusalim',waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'home-section home-section-padding weather-section',id:'expore-tel-aviv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container ac-flex ac-flex-column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["i" /* HomeTitle */],null,'SEHEN'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-row ac-flex ac-flex-row ac-flex-row-mob'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-inner-50 ac-margin-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["k" /* ImgAndText */],{img:PageObj1.img,img_mob:PageObj1.img_mob,cssClass:" col-100",link:PageObj1.link,text:PageObj1.text}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'show_more button',href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/TelAvivPage'},'Weiterlesen >>')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-inner-50'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["k" /* ImgAndText */],{img:PageObj2.img,img_mob:PageObj2.img_mob,cssClass:" col-100",link:PageObj2.link,text:PageObj2.text}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'show_more button',href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/JerusalemPage'},'Weiterlesen >>'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-row ac-flex ac-flex-row ac-flex-row-mob'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-inner-33'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["k" /* ImgAndText */],{img:PageObj3.img,img_mob:PageObj3.img_mob,cssClass:" col-100",link:PageObj3.link,text:PageObj3.text}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'show_more button',href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/DeadSeaPage'},'Weiterlesen >>')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-inner-33  ac-margin'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["k" /* ImgAndText */],(_React$createElement={img:PageObj4.img,img_mob:PageObj6.img_mob},_defineProperty(_React$createElement,'img_mob',PageObj4.img_mob),_defineProperty(_React$createElement,'cssClass'," col-100"),_defineProperty(_React$createElement,'link',PageObj4.link),_defineProperty(_React$createElement,'text',PageObj4.text),_React$createElement)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'show_more button',href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/NorthPage'},'Weiterlesen >>')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-inner-33'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["k" /* ImgAndText */],{img:PageObj5.img,img_mob:PageObj5.img_mob,cssClass:" col-100",link:PageObj5.link,text:PageObj5.text}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'show_more button',href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/EilatNegevPage'},'Weiterlesen >>')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-inner-33 show-on-mobile ac-margin'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["k" /* ImgAndText */],{img_mob:PageObj6.img_mob,cssClass:" col-100",link:PageObj6.link,text:PageObj6.text}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'show_more button',href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/thingsToDo'},'Weiterlesen >>'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_Footer_Footer__["a" /* default */],null));}}]);return WhereToGo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (WhereToGo);

/***/ }),
/* 272 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__ = __webpack_require__(4);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FAQ=function(_Component){_inherits(FAQ,_Component);function FAQ(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FAQ);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FAQ.__proto__||Object.getPrototypeOf(FAQ)).call.apply(_ref,[this].concat(args))),_this),_this.state={faq:__WEBPACK_IMPORTED_MODULE_3__Data_Data__["c" /* faqData */],telAvivWeather:0,waterTemp:0,jerusalemWeather:0},_this.setCurrentFaq=function(id){var faq=[].concat(_toConsumableArray(_this.state.faq));var current=faq.find(function(o){return o.id===id;});if(current.isOpen===true){current.isOpen=false;}else{current.isOpen=true;}_this.setState({faq:faq});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FAQ,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log( typeof weather);
// console.log( weather);
var weather2=weather;if(typeof weather==='string'&&weather.includes("float")){// Variable is a string
// console.log('Is float in string');
var str=weather.substring(weather.indexOf("{")+1);var str2="{"+str;// console.log(str2);
weather2=JSON.parse(str2);}else if((typeof weather==='undefined'?'undefined':_typeof(weather))==='object'&&weather!==null){// Variable is an object
// console.log('Variable is an object');
weather2=weather.data;// console.log(weather2);
}else if(typeof weather==='string'&&!weather.includes("float")){// console.log('Is NOt  float in string');
var _str=weather.substring(weather.indexOf("{")+1);var _str2="{"+_str;// console.log(str2);
weather2=JSON.parse(_str2);}//  else {
//   // Variable is neither a string nor an object
//   console.log('Variable is neither a string nor an object');
// }
_this2.setState({deadSeaWeather:weather2.deadsea.temperature,jerusalemWeather:weather2.jerusalem.temperature,telAvivWeather:weather2.telaviv.temperature,waterTemp:weather2.telaviv.water_temp});});}},{key:'render',value:function render(){var _this3=this;var faqHtml=this.state.faq.map(function(o){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["e" /* FaqItem */],{q:o.q,answer:o.answer,isOpen:o.isOpen,click:function click(){_this3.setCurrentFaq(o.id);}});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page align-center page-FAQ inner-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["h" /* HomeSlider */],{waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["i" /* HomeTitle */],null,'FAQ'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'faq-wrapper'},faqHtml),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__["a" /* default */],null));}}]);return FAQ;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (FAQ);

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__innerPage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TelAvivPage_css__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TelAvivPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__TelAvivPage_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TelAvivPage=function(_Component){_inherits(TelAvivPage,_Component);function TelAvivPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TelAvivPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TelAvivPage.__proto__||Object.getPrototypeOf(TelAvivPage)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TelAvivPage,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_3__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log( typeof weather);
// console.log( weather);
var weather2=weather;if(typeof weather==='string'&&weather.includes("float")){// Variable is a string
// console.log('Is float in string');
var str=weather.substring(weather.indexOf("{")+1);var str2="{"+str;// console.log(str2);
weather2=JSON.parse(str2);}else if((typeof weather==='undefined'?'undefined':_typeof(weather))==='object'&&weather!==null){// Variable is an object
// console.log('Variable is an object');
weather2=weather.data;// console.log(weather2);
}else if(typeof weather==='string'&&!weather.includes("float")){// console.log('Is NOt  float in string');
var _str=weather.substring(weather.indexOf("{")+1);var _str2="{"+_str;// console.log(str2);
weather2=JSON.parse(_str2);}//  else {
//   // Variable is neither a string nor an object
//   console.log('Variable is neither a string nor an object');
// }
_this2.setState({deadSeaWeather:weather2.deadsea.temperature,jerusalemWeather:weather2.jerusalem.temperature,telAvivWeather:weather2.telaviv.temperature,waterTemp:weather2.telaviv.water_temp});});window.addEventListener("resize",this.updateDimensions);}},{key:'render',value:function render(){// get all posts 
var posts=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2__Data_Data__["d" /* newPosts */]));// get non video posts and culinary posts
var telAvivPosts=posts.filter(function(o,i){return(o.ctg==='telaviv'||o.ctg==='telavivAndJerusalem'||o.ctg==='culinarytelaviv')&&o.isDouble!==true;// return o.ctg === 'telaviv' || o.ctg === 'telavivAndJerusalem';
});// const thingsToDoPosts = [ ...posts ];
var postsHtml=telAvivPosts.map(function(o,i){// console.log('o' , o);
var cssClass="";var html="";if(i%4===0){cssClass=" first";}var url=null;var component=null;if(o.isVid===true){url="/Posts/Videos/"+o.ctg+'/'+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["q" /* VideoSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}else{// url = "/Posts/" + o.id ;
url="/Posts/"+o.ctg+'/'+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["n" /* PostSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}return component;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-page align-center page-telaviv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["d" /* CoverSection */],{desktopImg:'/posts/bank/page-telaviv/1.jpg',mobileImg:'/posts/bank/page-telaviv/M.jpg',cssClass:'telaviv',waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'live-shows-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["i" /* HomeTitle */],null,'TEL AVIV'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:"ExuWHatIrKE"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'live-shows-wrapper'},postsHtml),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["g" /* HomeDeals */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__["a" /* default */],null));}}]);return TelAvivPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TelAvivPage);

/***/ }),
/* 275 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__innerPage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__JerusalemPage_css__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__JerusalemPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__JerusalemPage_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var JerusalemPage=function(_Component){_inherits(JerusalemPage,_Component);function JerusalemPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,JerusalemPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=JerusalemPage.__proto__||Object.getPrototypeOf(JerusalemPage)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(JerusalemPage,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_3__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log( typeof weather);
// console.log( weather);
var weather2=weather;if(typeof weather==='string'&&weather.includes("float")){// Variable is a string
// console.log('Is float in string');
var str=weather.substring(weather.indexOf("{")+1);var str2="{"+str;// console.log(str2);
weather2=JSON.parse(str2);}else if((typeof weather==='undefined'?'undefined':_typeof(weather))==='object'&&weather!==null){// Variable is an object
// console.log('Variable is an object');
weather2=weather.data;// console.log(weather2);
}else if(typeof weather==='string'&&!weather.includes("float")){// console.log('Is NOt  float in string');
var _str=weather.substring(weather.indexOf("{")+1);var _str2="{"+_str;// console.log(str2);
weather2=JSON.parse(_str2);}//  else {
//   // Variable is neither a string nor an object
//   console.log('Variable is neither a string nor an object');
// }
_this2.setState({deadSeaWeather:weather2.deadsea.temperature,jerusalemWeather:weather2.jerusalem.temperature,telAvivWeather:weather2.telaviv.temperature,waterTemp:weather2.telaviv.water_temp});});window.addEventListener("resize",this.updateDimensions);}},{key:'render',value:function render(){// get all posts 
var posts=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2__Data_Data__["d" /* newPosts */]));// get non video posts and culinary posts
var jerusalemPosts=posts.filter(function(o,i){return(o.ctg==='jerusalem'||o.ctg==='culinaryjerusalem')&&o.isDouble!==true;// return o.ctg === 'jerusalem' ;
});// const thingsToDoPosts = [ ...posts ];
var postsHtml=jerusalemPosts.map(function(o,i){// console.log('o' , o);
var cssClass="";var html="";if(i%4===0){cssClass=" first";}var url=null;var component=null;if(o.isVid===true){url="/Posts/Videos/"+o.ctg+'/'+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["q" /* VideoSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}else{// url = "/Posts/" + o.id ;
url="/Posts/"+o.ctg+'/'+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["n" /* PostSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}return component;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-page align-center page-jerusalem'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["d" /* CoverSection */],{desktopImg:'/posts/bank/page-jerusalem/1.jpg',mobileImg:'/posts/bank/page-jerusalem/M.jpg',cssClass:'jerusalim',waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'live-shows-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["i" /* HomeTitle */],null,'JERUSALEM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:"nLKWDp5uA-U"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'live-shows-wrapper'},postsHtml),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["g" /* HomeDeals */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__["a" /* default */],null));}}]);return JerusalemPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (JerusalemPage);

/***/ }),
/* 277 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__innerPage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CulinaryPage_css__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CulinaryPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__CulinaryPage_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CulinaryPage=function(_Component){_inherits(CulinaryPage,_Component);function CulinaryPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CulinaryPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CulinaryPage.__proto__||Object.getPrototypeOf(CulinaryPage)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CulinaryPage,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_3__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log( typeof weather);
// console.log( weather);
var weather2=weather;if(typeof weather==='string'&&weather.includes("float")){// Variable is a string
// console.log('Is float in string');
var str=weather.substring(weather.indexOf("{")+1);var str2="{"+str;// console.log(str2);
weather2=JSON.parse(str2);}else if((typeof weather==='undefined'?'undefined':_typeof(weather))==='object'&&weather!==null){// Variable is an object
// console.log('Variable is an object');
weather2=weather.data;// console.log(weather2);
}else if(typeof weather==='string'&&!weather.includes("float")){// console.log('Is NOt  float in string');
var _str=weather.substring(weather.indexOf("{")+1);var _str2="{"+_str;// console.log(str2);
weather2=JSON.parse(_str2);}//  else {
//   // Variable is neither a string nor an object
//   console.log('Variable is neither a string nor an object');
// }
_this2.setState({deadSeaWeather:weather2.deadsea.temperature,jerusalemWeather:weather2.jerusalem.temperature,telAvivWeather:weather2.telaviv.temperature,waterTemp:weather2.telaviv.water_temp});});window.addEventListener("resize",this.updateDimensions);}},{key:'render',value:function render(){// get all posts 
var posts=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2__Data_Data__["d" /* newPosts */]));// get non video posts and culinary posts
var culinaryPosts=posts.filter(function(o,i){return(o.ctg==='culinary'||o.ctg==='culinarynorth'||o.ctg==='culinaryjerusalem'||o.ctg==='culinarytelaviv')&&o.isDouble!==true;});// const thingsToDoPosts = [ ...posts ];
var postsHtml=culinaryPosts.map(function(o,i){// console.log('o' , o);
var cssClass="";var html="";if(i%4===0){cssClass=" first";}var url=null;var component=null;if(o.isVid===true){url="/Posts/Videos/"+o.ctg+'/'+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["q" /* VideoSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}else{// url = "/Posts/" + o.id ;
url="/Posts/"+o.ctg+'/'+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["n" /* PostSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}return component;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-page align-center page-culinary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["d" /* CoverSection */],{desktopImg:'/posts/bank/page-jerusalem/1.jpg',mobileImg:'/posts/bank/page-jerusalem/M.jpg',cssClass:'jerusalim',waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'live-shows-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["i" /* HomeTitle */],null,'KULINARISCH'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:"jfyHxk8ZRrI"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'live-shows-wrapper'},postsHtml),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["g" /* HomeDeals */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__["a" /* default */],null));}}]);return CulinaryPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CulinaryPage);

/***/ }),
/* 279 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__innerPage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DeadSeaPage_css__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DeadSeaPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__DeadSeaPage_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DeadSeaPage=function(_Component){_inherits(DeadSeaPage,_Component);function DeadSeaPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DeadSeaPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DeadSeaPage.__proto__||Object.getPrototypeOf(DeadSeaPage)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DeadSeaPage,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_3__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log( typeof weather);
// console.log( weather);
var weather2=weather;if(typeof weather==='string'&&weather.includes("float")){// Variable is a string
// console.log('Is float in string');
var str=weather.substring(weather.indexOf("{")+1);var str2="{"+str;// console.log(str2);
weather2=JSON.parse(str2);}else if((typeof weather==='undefined'?'undefined':_typeof(weather))==='object'&&weather!==null){// Variable is an object
// console.log('Variable is an object');
weather2=weather.data;// console.log(weather2);
}else if(typeof weather==='string'&&!weather.includes("float")){// console.log('Is NOt  float in string');
var _str=weather.substring(weather.indexOf("{")+1);var _str2="{"+_str;// console.log(str2);
weather2=JSON.parse(_str2);}//  else {
//   // Variable is neither a string nor an object
//   console.log('Variable is neither a string nor an object');
// }
_this2.setState({deadSeaWeather:weather2.deadsea.temperature,jerusalemWeather:weather2.jerusalem.temperature,telAvivWeather:weather2.telaviv.temperature,waterTemp:weather2.telaviv.water_temp});});window.addEventListener("resize",this.updateDimensions);}},{key:'render',value:function render(){// get all posts 
var posts=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2__Data_Data__["d" /* newPosts */]));// get non video posts and culinary posts
var deadseaPosts=posts.filter(function(o,i){return o.ctg==='deadsea'&&o.isDouble!==true;});// const thingsToDoPosts = [ ...posts ];
var postsHtml=deadseaPosts.map(function(o,i){// console.log('o' , o);
var cssClass="";var html="";if(i%4===0){cssClass=" first";}var url=null;var component=null;if(o.isVid===true){url="/Posts/Videos/"+o.ctg+'/'+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["q" /* VideoSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}else{// url = "/Posts/" + o.id ;
url="/Posts/"+o.ctg+'/'+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["n" /* PostSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}return component;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-page align-center page-deadsea'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["h" /* HomeSlider */],{waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'live-shows-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["i" /* HomeTitle */],null,'DAS TOTE MEER'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:"8p4qfkneH1c"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'live-shows-wrapper'},postsHtml),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["g" /* HomeDeals */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__["a" /* default */],null));}}]);return DeadSeaPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (DeadSeaPage);

/***/ }),
/* 281 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__innerPage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TouristInfoPage_css__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TouristInfoPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__TouristInfoPage_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TouristInfoPage=function(_Component){_inherits(TouristInfoPage,_Component);function TouristInfoPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TouristInfoPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TouristInfoPage.__proto__||Object.getPrototypeOf(TouristInfoPage)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TouristInfoPage,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_3__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log( typeof weather);
// console.log( weather);
var weather2=weather;if(typeof weather==='string'&&weather.includes("float")){// Variable is a string
// console.log('Is float in string');
var str=weather.substring(weather.indexOf("{")+1);var str2="{"+str;// console.log(str2);
weather2=JSON.parse(str2);}else if((typeof weather==='undefined'?'undefined':_typeof(weather))==='object'&&weather!==null){// Variable is an object
// console.log('Variable is an object');
weather2=weather.data;// console.log(weather2);
}else if(typeof weather==='string'&&!weather.includes("float")){// console.log('Is NOt  float in string');
var _str=weather.substring(weather.indexOf("{")+1);var _str2="{"+_str;// console.log(str2);
weather2=JSON.parse(_str2);}//  else {
//   // Variable is neither a string nor an object
//   console.log('Variable is neither a string nor an object');
// }
_this2.setState({deadSeaWeather:weather2.deadsea.temperature,jerusalemWeather:weather2.jerusalem.temperature,telAvivWeather:weather2.telaviv.temperature,waterTemp:weather2.telaviv.water_temp});});window.addEventListener("resize",this.updateDimensions);}},{key:'render',value:function render(){// get all posts 
var posts=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2__Data_Data__["b" /* TouristInfoPosts */]));// get non video posts and culinary posts
var telAvivPosts=posts.filter(function(o,i){return o.ctg==='TouristInfo';});// const thingsToDoPosts = [ ...posts ];
var postsHtml=telAvivPosts.map(function(o,i){// console.log('o' , o);
var cssClass="";var html="";if(i%4===0){cssClass=" first";}var url=null;var component=null;if(o.isVid===true){url="/Posts/Videos/"+o.ctg+'/'+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["q" /* VideoSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}else{// url = "/Posts/" + o.id ;
url="/Posts/"+o.ctg+'/'+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["n" /* PostSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}return component;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-page align-center page-touristinfo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["d" /* CoverSection */],{desktopImg:'/posts/bank/page-tourist/1.jpg',mobileImg:'/posts/bank/page-tourist/M.jpg',cssClass:'telaviv',waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'live-shows-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["i" /* HomeTitle */],null,'TOURISTENINFO'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:"ExuWHatIrKE"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'live-shows-wrapper'},postsHtml),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["g" /* HomeDeals */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__["a" /* default */],null));}}]);return TouristInfoPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TouristInfoPage);

/***/ }),
/* 283 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__innerPage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EilatNegevPage_css__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EilatNegevPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__EilatNegevPage_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EilatNegevPage=function(_Component){_inherits(EilatNegevPage,_Component);function EilatNegevPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,EilatNegevPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=EilatNegevPage.__proto__||Object.getPrototypeOf(EilatNegevPage)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(EilatNegevPage,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_3__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log( typeof weather);
// console.log( weather);
var weather2=weather;if(typeof weather==='string'&&weather.includes("float")){// Variable is a string
// console.log('Is float in string');
var str=weather.substring(weather.indexOf("{")+1);var str2="{"+str;// console.log(str2);
weather2=JSON.parse(str2);}else if((typeof weather==='undefined'?'undefined':_typeof(weather))==='object'&&weather!==null){// Variable is an object
// console.log('Variable is an object');
weather2=weather.data;// console.log(weather2);
}else if(typeof weather==='string'&&!weather.includes("float")){// console.log('Is NOt  float in string');
var _str=weather.substring(weather.indexOf("{")+1);var _str2="{"+_str;// console.log(str2);
weather2=JSON.parse(_str2);}//  else {
//   // Variable is neither a string nor an object
//   console.log('Variable is neither a string nor an object');
// }
_this2.setState({deadSeaWeather:weather2.deadsea.temperature,jerusalemWeather:weather2.jerusalem.temperature,telAvivWeather:weather2.telaviv.temperature,waterTemp:weather2.telaviv.water_temp});});window.addEventListener("resize",this.updateDimensions);}},{key:'render',value:function render(){// get all posts 
var posts=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2__Data_Data__["d" /* newPosts */]));// get non video posts and culinary posts
var eilatnegevPosts=posts.filter(function(o,i){return o.ctg==='eilat-negev'&&o.isDouble!==true;});// const thingsToDoPosts = [ ...posts ];
var postsHtml=eilatnegevPosts.map(function(o,i){// console.log('o' , o);
var cssClass="";var html="";if(i%4===0){cssClass=" first";}var url=null;var component=null;if(o.isVid===true){url="/Posts/Videos/"+o.ctg+'/'+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["q" /* VideoSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}else{// url = "/Posts/" + o.id ;
url="/Posts/"+o.ctg+'/'+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["n" /* PostSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}return component;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-page align-center page-eilatnegev'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["h" /* HomeSlider */],{waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'live-shows-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["i" /* HomeTitle */],null,'NEGEV UND EILAT'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:"ZdnNT-GDJv4"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'live-shows-wrapper'},postsHtml),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["g" /* HomeDeals */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__["a" /* default */],null));}}]);return EilatNegevPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (EilatNegevPage);

/***/ }),
/* 285 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__innerPage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NorthPage_css__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NorthPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__NorthPage_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NorthPage=function(_Component){_inherits(NorthPage,_Component);function NorthPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NorthPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NorthPage.__proto__||Object.getPrototypeOf(NorthPage)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NorthPage,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_3__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log( typeof weather);
// console.log( weather);
var weather2=weather;if(typeof weather==='string'&&weather.includes("float")){// Variable is a string
// console.log('Is float in string');
var str=weather.substring(weather.indexOf("{")+1);var str2="{"+str;// console.log(str2);
weather2=JSON.parse(str2);}else if((typeof weather==='undefined'?'undefined':_typeof(weather))==='object'&&weather!==null){// Variable is an object
// console.log('Variable is an object');
weather2=weather.data;// console.log(weather2);
}else if(typeof weather==='string'&&!weather.includes("float")){// console.log('Is NOt  float in string');
var _str=weather.substring(weather.indexOf("{")+1);var _str2="{"+_str;// console.log(str2);
weather2=JSON.parse(_str2);}//  else {
//   // Variable is neither a string nor an object
//   console.log('Variable is neither a string nor an object');
// }
_this2.setState({deadSeaWeather:weather2.deadsea.temperature,jerusalemWeather:weather2.jerusalem.temperature,telAvivWeather:weather2.telaviv.temperature,waterTemp:weather2.telaviv.water_temp});});window.addEventListener("resize",this.updateDimensions);}},{key:'render',value:function render(){// get all posts 
var posts=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2__Data_Data__["d" /* newPosts */]));// get non video posts and culinary posts
var northPosts=posts.filter(function(o,i){return(o.ctg==='north'||o.ctg==='culinarynorth')&&o.isDouble!==true;// return o.ctg === 'north' ;
});// const thingsToDoPosts = [ ...posts ];
var postsHtml=northPosts.map(function(o,i){// console.log('o' , o);
var cssClass="";var html="";if(i%4===0){cssClass=" first";}var url=null;var component=null;if(o.isVid===true){url="/Posts/Videos/"+o.ctg+'/'+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["q" /* VideoSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}else{// url = "/Posts/" + o.id ;
url="/Posts/"+o.ctg+'/'+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["n" /* PostSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}return component;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-page align-center page-north'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["h" /* HomeSlider */],{waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'live-shows-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["i" /* HomeTitle */],null,'NOORDEN'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:"fZ_WdHpHRT8"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'live-shows-wrapper'},postsHtml),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["g" /* HomeDeals */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__["a" /* default */],null));}}]);return NorthPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NorthPage);

/***/ }),
/* 287 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Footer_Footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CoronaVirus_css__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CoronaVirus_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__CoronaVirus_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CoronaVirus=function(_Component){_inherits(CoronaVirus,_Component);function CoronaVirus(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CoronaVirus);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CoronaVirus.__proto__||Object.getPrototypeOf(CoronaVirus)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CoronaVirus,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log( typeof weather);
// console.log( weather);
var weather2=weather;if(typeof weather==='string'&&weather.includes("float")){// Variable is a string
// console.log('Is float in string');
var str=weather.substring(weather.indexOf("{")+1);var str2="{"+str;// console.log(str2);
weather2=JSON.parse(str2);}else if((typeof weather==='undefined'?'undefined':_typeof(weather))==='object'&&weather!==null){// Variable is an object
// console.log('Variable is an object');
weather2=weather.data;// console.log(weather2);
}else if(typeof weather==='string'&&!weather.includes("float")){// console.log('Is NOt  float in string');
var _str=weather.substring(weather.indexOf("{")+1);var _str2="{"+_str;// console.log(str2);
weather2=JSON.parse(_str2);}//  else {
//   // Variable is neither a string nor an object
//   console.log('Variable is neither a string nor an object');
// }
_this2.setState({deadSeaWeather:weather2.deadsea.temperature,jerusalemWeather:weather2.jerusalem.temperature,telAvivWeather:weather2.telaviv.temperature,waterTemp:weather2.telaviv.water_temp});});window.addEventListener('resize',this.updateDimensions);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page align-left page-Corona-virus'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_Menu_Menu__["a" /* default */],null),!Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["h" /* isMobile */])()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["d" /* CoverSection */],{desktopImg:'/HomeSlider/corona.jpg',mobileImg:'/HomeSlider/M/uk/4.jpg',cssClass:'north',waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-corona-mobile-video'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:'yE5MV_10cZw'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-new-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-new-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'ac-pink'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'ac-pink ac-pink ac-margin-top-1 ac-bigger'},'Willkommen zur\xFCck'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Reisen nach Israel f\xFCr vollst\xE4ndig geimpfte Ausl\xE4nder'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Ab dem 1. November 2021 d\xFCrfen ausl\xE4ndische Staatsangeh\xF6rige, die vollst\xE4ndig geimpft sind, unter folgenden Bedingungen nach Israel einreisen:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'1. Personen, die sich in den letzten 14 Tagen vor der Einreise nach Israel nicht in einem roten Land aufgehalten haben.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'2. Personen, die mit einem von der Weltgesundheitsorganisation (WHO) zugelassenen Impfstoff geimpft sind, unterliegen den nachstehenden Bedingungen.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'3. Die Einreise darf ausschlie\xDFlich \xFCber den Flughafen Ben Gurion erfolgen. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'4. Es gibt kein anderes Hindernis f\xFCr Ihre Einreise nach Israel. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'5. Ausl\xE4ndische Staatsangeh\xF6rige, die die oben genannten Bedingungen nicht erf\xFCllen, k\xF6nnen dennoch \xFCber das ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://survey.gov.il/he/PCR2',target:'_blank',rel:'noopener'},'Ausnahmekomitee (Exceptions Committee)'),' die Einreise nach Israel beantragen.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'ac-pink'},'Zugelassene Impfstoffe'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'ac-align-left-15'},'Die folgenden Impfstoffe sind von Israel zugelassen: Moderna, Biontec/Pfizer, Johnson & Johnson \u2013 Janssen, AstraZeneca, Covishield, Sinopharm, Sinovac, SputniK-V (vorbehaltlich der nachstehenden Bedingungen).'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'ac-align-left-15'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Welche Personen gelten in Israel als vollst\xE4ndig geimpft?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'ac-align-left-15'},'Mit Biontec /Pfizer / Moderna / AstraZeneca / Sinovac oder Sinopharm geimpfte Ausl\xE4nder:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'\u25CF Wenn Sie zwei Impfungen erhalten, m\xFCssen mindestens 14 Tage seit zweiter Impfung bei der Einreise nach Israel vergangen sein. (Jedoch nicht mehr als 180 Tage darf bei Ausreise aus Israel zur\xFCckliegen).'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'\u25CF Personen mit einer Auffrischungsimpfung ("Booster" oder auch "Drittimpfung") der zuvor genannten Impfstoffe, sofern diese bei Einreise mindestens 14 Tage vor der Einreise erfolgt ist.')),'\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'ac-align-left-15'},' Mit dem Johnson & Johnson-Janssen-Impfstoff geimpfte Ausl\xE4nder:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'\u25CF Vor Einreise nach Israel m\xFCssen mindestens 14 Tage seit der Impfung vergangen sein. (Die Impfung darf bei Ausreise aus Israel maximal 180 Tage zur\xFCckliegen).'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'\u25CF Personen mit einer Auffrischungsimpfung ("Booster" oder auch "Drittimpfung") der zuvor genannten Impfstoffe, sofern diese bei Einreise mindestens vor 14 Tagen erfolgt ist.')),'\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'ac-align-left-15'},'Mit dem Sputnik-Impfstoff geimpfte Ausl\xE4nder:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'\u25CF Ausl\xE4nder, die mit dem Sputnik-Impfstoff geimpft wurden, seit 15.11.21 und die in einem serologischen COVID-Antik\xF6rpertest in Israel positiv getestet wurden (Sie m\xFCssen isoliert werden, bis ein positives Ergebnis vorliegt).'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'\u25CF Sie m\xFCssen zwei Impfungen erhalten, und es m\xFCssen mindestens 14 Tage seit der zweiten Impfung bei der Einreise nach Israel vergangen sein. (Jedoch nicht mehr als 180 Tage bei Ausreise aus Israel).'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'\u25CF Personen mit einer Auffrischungsimpfung ("Booster" oder auch "Drittimpfung") der zuvor genannten Impfstoffe, sofern diese bei Einreise mindestens vor 14 Tagen erfolgt ist.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Einreise nach Israel f\xFCr Personen, die sich vollst\xE4ndig von COVID erholt haben')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'ac-align-left-15'},'Ausl\xE4ndische Staatsangeh\xF6rige, die sich von COVID erholt haben, d\xFCrfen nach Israel einreisen, wenn sie ein digitales Zertifikat besitzen, das vom Israelisches Gesundheitssystem  digital verifiziert werden kann und auf einem positiven Ergebnis in einem Nukleins\xE4ureamplifikationstest (NAAT) (molekularer Test \xE4hnlich der Polymerase-Kettenreaktion (PCR) basiert.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'\u25CF Bei der Einreise nach Israel m\xFCssen seit dem positiven Testergebnis mindestens 11 Tage vergangen sein (aber nicht mehr als 190 Tage nach der Ausreise aus Israel).'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'\u25CF Die Impfung muss mit einem von der Weltgesundheitsorganisation (WHO) zugelassenen Impfstoffe erfolgt sein.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#_ednref1',name:'_edn1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'* Entry for recoverees is only applicable for those coming from countries that issue certificates that the Israeli MOH systems can digitally authenticate, which is not available for people traveling from the USA or Canada'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Der Prozess der Einreise nach Israel')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'ac-wrpr-num'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'ac-num-li'},'1. Sie m\xFCssen h\xF6chstens 72 Stunden vor Ihrem Flug einen Polymerase-Kettenreaktion (PCR)-Test durchf\xFChren.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'ac-num-li'},'2. Sie m\xFCssen vor der Einreise nach Israel eine Passagiererkl\xE4rung ausf\xFCllen.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'\u25CF Passagiere, die \xFCber ein \xFCberpr\xFCfbares digitales Zertifikat verf\xFCgen, sollten ihre Impf- oder Genesungszertifikat scannen oder auf das Formular f\xFCr ankommende Passagiere hochladen und vor dem Einsteigen in das Flugzeug einen "Gr\xFCnen Pass" erhalten.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'\u25CF Passagiere, die kein \xFCberpr\xFCfbares digitales Zertifikat haben, geben ihren Impfstatus im Formular f\xFCr ankommende Passagiere an und f\xFCllen einen Antrag zur Verk\xFCrzung der Isolationszeit aus. Dann f\xFCgen sie die entsprechenden Dokumente bei, um vor dem Einsteigen in das Flugzeug einen gr\xFCnen Pass zu erhalten.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'ac-num-li'},'3. Beim Einsteigen in das Flugzeug m\xFCssen folgende Dokumente vorgelegt werden.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'\u25CF Dokumentation eines negativen Polymerase-Kettenreaktion (PCR)-Tests, der bis zu 72 Stunden vor dem Flug durchgef\xFChrt wurde.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'\u25CF Best\xE4tigung der Abgabe einer ankommenden Passagiererkl\xE4rung.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'\u25CF Impfbescheinigung \xFCber die Durchf\xFChrung von Impfungen gem\xE4\xDF den vorstehenden Bestimmungen.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'\u25CF Wiederherstellungsbescheinigung, die vom Israelischen Gesundheitssystem digital verifiziert werden kann und auf eine Erholung gem\xE4\xDF den oben genannten Bestimmungen hinweist.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'\u25CF Ein digitales Zertifikat, das die Erholung von COVID gem\xE4\xDF den obigen Bestimmungen best\xE4tigt. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'\u25CF Ausnahmegenehmigung des israelischen Innenministeriums (Gilt f\xFCr Sonderf\xE4lle, geplante Reisen und f\xFCr Gruppen)'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'ac-num-li'},'4. Die Bev\xF6lkerungsbeh\xF6rde am Flughafen Ben Gurion f\xFChrt stichprobenartige Dokumentations\xFCberpr\xFCfung durch.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'ac-num-li'},'5. Bei der Landung am Flughafen Ben Gurion muss ein Polymerase-Kettenreaktion (PCR)-Test durchgef\xFChrt werden. Sie m\xFCssen sich in Isolation begeben, bis ein negatives Ergebnis vorliegt, oder f\xFCr 24 Stunden, je nachdem, was fr\xFCher eintritt.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'ac-num-li'},'6. Reisende, die mit Sputnik-Impfstoffen geimpft wurden, unterziehen sich einem serologischen Test am Flughafen Ben Gurion und isolieren sich bis zum positiven Testergebnis. (Dies wird zus\xE4tzlich zur Isolierung bis zum negativen Ergebnis des Polymerase-Kettenreaktion (PCR)-Tests bei der Landung durchgef\xFChrt).')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'ac-align-center'},'F\xFCr die Liste der L\xE4nder, die Zertifikate ausstellen, die vom Israelisches Gesundheitssystem digital verifiziert werden kann',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://ec.europa.eu/info/live-work-travel-eu/coronavirus-response/safe-covid-19-vaccines-europeans/eu-digital-covid-certificate_en',target:'_blank',rel:'noopener',className:'ac-align-center'},'https://ec.europa.eu/info/live-work-travel-eu/coronavirus-response/safe-covid-19-vaccines-europeans/eu-digital-covid-certificate_en')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'ac-align-center'},'F\xFCr die vollst\xE4ndigen Angaben zum Eingabeprotokoll klicken Sie hier:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://corona.health.gov.il/en/directives/air-travel-covid19-green/?tab=by-air',className:'ac-align-left-15',target:'_blank',rel:'noopener'},'https://corona.health.gov.il/en/directives/air-travel-covid19-green/?tab=by-air')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'ac-align-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\xB7 Die oben genannten Richtlinien sind hier zu Ihrer Information aufgef\xFChrt. Im Zweifelsfall lesen Sie bitte hierzu die auf der Website des israelischen Gesundheitsministeriums ver\xF6ffentlichten Richtlinien, da die dortigen Informationen die aktuellen und genauesten sind.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://corona.health.gov.il/en/directives/air-travel-covid19-green/?tab=by-air',className:'ac-align-center',target:'_blank',rel:'noopener'},'https://corona.health.gov.il/en/directives/air-travel-covid19-green/?tab=by-air')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'ac-pink'},'Bis bald in Israel')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-inner-video'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:'LSb4Lmuw_Kw'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Footer_Footer__["a" /* default */],null));}}]);return CoronaVirus;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CoronaVirus);

/***/ }),
/* 289 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_Footer_Footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Posts_css__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Posts_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Posts_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Videos_css__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Videos_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Videos_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PostsData__ = __webpack_require__(62);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VideoPosts=function(_Component){_inherits(VideoPosts,_Component);function VideoPosts(){var _ref;var _temp,_this,_ret;_classCallCheck(this,VideoPosts);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=VideoPosts.__proto__||Object.getPrototypeOf(VideoPosts)).call.apply(_ref,[this].concat(args))),_this),_this.state={id:_this.props.match.params.vidId,ctgId:_this.props.match.params.ctgId},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(VideoPosts,[{key:'componentWillMount',value:function componentWillMount(){}},{key:'componentDidMount',value:function componentDidMount(){}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){}},{key:'render',value:function render(){var _this2=this;var counter=0;var videosHtml=null;var mixVideos=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_9__PostsData__["b" /* newPostdata */]));var shuffleData=Object(__WEBPACK_IMPORTED_MODULE_4__Utility_Utility__["j" /* shuffle */])(mixVideos);var current=__WEBPACK_IMPORTED_MODULE_9__PostsData__["b" /* newPostdata */].find(function(o){console.log("o: ",o);if(_this2.props.match.params.ctgId!=undefined){if(o.hasOwnProperty("ctg")){if(typeof o.id=='number'){return parseInt(o.id)===parseInt(_this2.state.id)&&o.ctg===_this2.state.ctgId;}else{return o.id===_this2.state.id&&o.ctg===_this2.state.ctgId;}}}});if(this.props.match.params.ctgId!=undefined){videosHtml=shuffleData.map(function(o,i){if(o.hasOwnProperty("ctg")){if(o.ctg===_this2.props.match.params.ctgId){// alert('o.ctg:', o.ctg);
var postFromPostData=__WEBPACK_IMPORTED_MODULE_5__Data_Data__["d" /* newPosts */].find(function(obj,index){return obj.id===o.id&&obj.ctg===o.ctg;});console.log('postFromPostData',postFromPostData);if(postFromPostData!=undefined&&postFromPostData.id!==current.id){counter++;if(counter<=3){var component=null;var url="/Posts/Videos/"+o.ctg+"/"+o.id;if(o.isVid===true){component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["q" /* VideoSliderItem */],{key:i,title:postFromPostData.title,desc:postFromPostData.sml_desc,img:postFromPostData.side_img,link:url});}else{url="/Posts/"+o.ctg+"/"+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["n" /* PostSliderItem */],{key:i,title:postFromPostData.title,desc:postFromPostData.sml_desc,img:postFromPostData.side_img,link:url});}return component;}}}else if(o.ctg==='culinary'||o.ctg==='culinaryjerusalem'||o.ctg==='culinarytelaviv'||o.ctg==='culinarynorth'){// alert('o.ctg:', o.ctg);
var _postFromPostData=__WEBPACK_IMPORTED_MODULE_5__Data_Data__["d" /* newPosts */].find(function(obj,index){return obj.id===o.id&&obj.ctg===o.ctg;});console.log('postFromPostData',_postFromPostData);if(_postFromPostData!=undefined&&_postFromPostData.id!==current.id){counter++;if(counter<=3){var _component=null;var _url="/Posts/Videos/"+o.ctg+"/"+o.id;if(o.isVid===true){_component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["q" /* VideoSliderItem */],{key:i,title:_postFromPostData.title,desc:_postFromPostData.sml_desc,img:_postFromPostData.side_img,link:_url});}else{_url="/Posts/"+o.ctg+"/"+o.id;_component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["n" /* PostSliderItem */],{key:i,title:_postFromPostData.title,desc:_postFromPostData.sml_desc,img:_postFromPostData.side_img,link:_url});}return _component;}}}}});}var html=null;if(current!=undefined){console.log("current",current);var vidHTML=null;var smlTitle=null;var title=null;if(current.isVid===true){vidHTML=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:current.vidId});}title=current.title;var smltitle=current.hasOwnProperty("smltitle")?current.smltitle:current.smlTitle;var titleHTML=null;var smlTitleHTML=null;if(smltitle!==''){titleHTML=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'page-section-big-title'},title);smlTitleHTML=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["i" /* HomeTitle */],null,smltitle);}else{titleHTML=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'page-section-big-title'});smlTitleHTML=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["i" /* HomeTitle */],null,title);}html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-post post post-type-videos inner-post-'+current.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'post-data'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-post-banner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["j" /* Img */],{desktopImg:current.bgImage,mobileImg:current.mobBgImage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container align-center white'},titleHTML)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col-75'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},smlTitleHTML,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),vidHTML,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'html-wrapper',dangerouslySetInnerHTML:current.html()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["g" /* HomeDeals */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col-25 sidebar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["i" /* HomeTitle */],null,'\xC4HNLICHE VIDEOS'),videosHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_Footer_Footer__["a" /* default */],null));}return html;}}]);return VideoPosts;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* withRouter */])(VideoPosts));

/***/ }),
/* 291 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_Footer_Footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Loader_Loader__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Posts_css__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Posts_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Posts_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PostsData__ = __webpack_require__(62);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ConcertsPosts=function(_Component){_inherits(ConcertsPosts,_Component);function ConcertsPosts(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ConcertsPosts);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ConcertsPosts.__proto__||Object.getPrototypeOf(ConcertsPosts)).call.apply(_ref,[this].concat(args))),_this),_this.state={id:_this.props.match.params.id},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ConcertsPosts,[{key:'componentWillMount',value:function componentWillMount(){}},{key:'componentDidMount',value:function componentDidMount(){}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){}},{key:'render',value:function render(){var _this2=this;var counter=0;var currDate=new Date();var videosHtml=Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["j" /* shuffle */])(__WEBPACK_IMPORTED_MODULE_6__Data_Data__["f" /* showsArr */]).map(function(o,i){var cssClass='';var isTodayBigger=Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["b" /* compareDates */])(currDate,o.date);counter++;if(counter<=3&&!isTodayBigger===true){var url="/Posts/Concerts/"+o.id;if(url==="/Posts/Concerts/undefined"){cssClass="no-inner-page";}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["c" /* ConcertSliderItem */],{key:i,title:o.title,desc:o.date,img:o.img,link:url,cssClass:cssClass});}else{counter--;}});var current=__WEBPACK_IMPORTED_MODULE_9__PostsData__["a" /* ShowsPostsData */].find(function(o){return o.id==_this2.props.match.params.id;});var html=null;if(current!=undefined){html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-post post post-type-Concerts inner-post-'+current.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'post-data'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-post-banner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["j" /* Img */],{desktopImg:current.bgImage,mobileImg:current.mobBgImage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container align-center white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'page-section-big-title'},current.title))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col-75'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'html-wrapper',dangerouslySetInnerHTML:current.html()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["g" /* HomeDeals */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col-25 sidebar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["i" /* HomeTitle */],null,'MEHR LIVE KONZERT'),videosHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_Footer_Footer__["a" /* default */],null));}return html;}}]);return ConcertsPosts;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* withRouter */])(ConcertsPosts));

/***/ }),
/* 293 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_Footer_Footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Posts_css__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Posts_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Posts_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Posts_css__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Posts_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Posts_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PostsData__ = __webpack_require__(62);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Posts=function(_Component){_inherits(Posts,_Component);function Posts(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Posts);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Posts.__proto__||Object.getPrototypeOf(Posts)).call.apply(_ref,[this].concat(args))),_this),_this.state={id:_this.props.match.params.vidId,ctgId:_this.props.match.params.ctgId},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Posts,[{key:'componentWillMount',value:function componentWillMount(){// console.log(this.props.match.params)
}},{key:'componentDidMount',value:function componentDidMount(){}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){}},{key:'render',value:function render(){var _this2=this;var counter=0;var videosHtml=null;var mixVideos=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_9__PostsData__["b" /* newPostdata */]));var limitRelatedPost=3;// alert(this.props.match.params.id);
if(this.props.match.params.id==="34"){limitRelatedPost=2;}var shuffleData=Object(__WEBPACK_IMPORTED_MODULE_4__Utility_Utility__["j" /* shuffle */])(mixVideos);var current=__WEBPACK_IMPORTED_MODULE_9__PostsData__["b" /* newPostdata */].find(function(o){if(_this2.props.match.params.ctgId!=undefined){if(o.hasOwnProperty("ctg")){// console.log('o' , o);
return o.id==_this2.props.match.params.id&&o.ctg==_this2.props.match.params.ctgId;}}else{return o.id===_this2.props.match.params.id;}});// console.log("current" , current);
if(this.props.match.params.ctgId!=undefined){videosHtml=shuffleData.map(function(o,i){if(o.hasOwnProperty("ctg")){// if (  o.ctg === this.props.match.params.ctgId  && parseInt(o.id) !== parseInt(this.props.match.params.id) ) {
if(o.ctg===_this2.props.match.params.ctgId){var postFromPostData=__WEBPACK_IMPORTED_MODULE_5__Data_Data__["d" /* newPosts */].find(function(obj,index){return obj.id===o.id&&obj.ctg===o.ctg;});console.log('postFromPostData',postFromPostData);if(postFromPostData!=undefined&&postFromPostData.id!==current.id){counter++;if(counter<=limitRelatedPost){var component=null;var url="/Posts/Videos/"+o.ctg+"/"+o.id;if(o.isVid===true){component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["q" /* VideoSliderItem */],{key:i,title:postFromPostData.title,desc:postFromPostData.sml_desc,img:postFromPostData.img,link:url});}else{url="/Posts/"+o.ctg+"/"+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["n" /* PostSliderItem */],{key:i,title:postFromPostData.title,desc:postFromPostData.sml_desc,img:postFromPostData.img,link:url});}return component;}}}else if(o.ctg==='culinary'||o.ctg==='culinaryjerusalem'||o.ctg==='culinarytelaviv'||o.ctg==='culinarynorth'){// alert('o.ctg:', o.ctg);
var _postFromPostData=__WEBPACK_IMPORTED_MODULE_5__Data_Data__["d" /* newPosts */].find(function(obj,index){return obj.id===o.id&&obj.ctg===o.ctg;});console.log('postFromPostData',_postFromPostData);if(_postFromPostData!=undefined&&_postFromPostData.id!==current.id){counter++;if(counter<=3){var _component=null;var _url="/Posts/Videos/"+o.ctg+"/"+o.id;if(o.isVid===true){_component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["q" /* VideoSliderItem */],{key:i,title:_postFromPostData.title,desc:_postFromPostData.sml_desc,img:_postFromPostData.side_img,link:_url});}else{_url="/Posts/"+o.ctg+"/"+o.id;_component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["n" /* PostSliderItem */],{key:i,title:_postFromPostData.title,desc:_postFromPostData.sml_desc,img:_postFromPostData.side_img,link:_url});}return _component;}}}if(o.ctg===_this2.props.match.params.ctgId){var postFromTouristData=__WEBPACK_IMPORTED_MODULE_5__Data_Data__["b" /* TouristInfoPosts */].find(function(obj,index){return obj.id===o.id&&obj.ctg===o.ctg;});console.log('postFromTouristData',postFromTouristData);if(postFromTouristData!=undefined){counter++;if(counter<=limitRelatedPost){var _component2=null;var _url2="/Posts/Videos/"+o.ctg+"/"+o.id;if(o.isVid===true){_component2=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["q" /* VideoSliderItem */],{key:i,title:postFromTouristData.title,desc:postFromTouristData.sml_desc,img:postFromTouristData.img,link:_url2});}else{_url2="/Posts/"+o.ctg+"/"+o.id;_component2=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["n" /* PostSliderItem */],{key:i,title:postFromTouristData.title,desc:postFromTouristData.sml_desc,img:postFromTouristData.img,link:_url2});}return _component2;}}}}});}var html=null;var smlTitle=null;var title=null;if(current!=undefined){console.log('success');var vidHTML=null;if(current.isVid===true){vidHTML=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:current.vidId});}var _title=current.title;var smltitle=current.hasOwnProperty("smltitle")?current.smltitle:current.smlTitle;var titleHTML=null;var smlTitleHTML=null;if(smltitle!==''){titleHTML=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'page-section-big-title'},_title);smlTitleHTML=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["i" /* HomeTitle */],null,smltitle);}else{titleHTML=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'page-section-big-title'});smlTitleHTML=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["i" /* HomeTitle */],null,_title);}// client custom req
console.log('this.state',this.state);// if ( current.id === 5 ) {
//   titleHTML = '';
// }
html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-post post post-type-videos post-type-posts inner-post-'+current.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'post-data'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-post-banner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["j" /* Img */],{desktopImg:current.bgImage,mobileImg:current.mobBgImage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container align-center white'},titleHTML)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col-75'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},smlTitleHTML,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),vidHTML,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'html-wrapper',dangerouslySetInnerHTML:current.html()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["g" /* HomeDeals */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col-25 sidebar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["i" /* HomeTitle */],null,'\xC4HNLICHE POSTS'),videosHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_Footer_Footer__["a" /* default */],null));}return html;}}]);return Posts;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* withRouter */])(Posts));

/***/ }),
/* 295 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_lazyload__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Components_SimpleSlider_SimpleSlider__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_reactjs_popup__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Components_Footer_Footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Components_Loader_Loader__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Gallery_css__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Gallery_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__Gallery_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GalleryTA=function(_Component){_inherits(GalleryTA,_Component);function GalleryTA(){var _ref;var _temp,_this,_ret;_classCallCheck(this,GalleryTA);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=GalleryTA.__proto__||Object.getPrototypeOf(GalleryTA)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,instagramData:[],instagramDataMobile:[],instagramId:null,instagramUserImg:null,instagramCaption:null,instagramUserName:null,instagramLikes:null,waterTemp:0,jerusalemWeather:0,open:false,isInstaOpen:false,openInstagram:false,id:null,isLoader:false,ctg:'',galleryId:'',relatedGalery:[{title:'TEL AVIV',cityId:'ta'},{title:'DAS TOTE MEER',cityId:'deadsea'},{title:'JERUSALEM',cityId:'ja'},{title:'EILAT',cityId:'eilat'},{title:'NEGEV',cityId:'negev'},{title:'CAESAREA',cityId:'caesarea'},{title:'HAIFA',cityId:'haifa'},{title:'CULINARY',cityId:'culinary'},{title:'GALILEE',cityId:'galilee'},{title:'IHRE FOTOS',cityId:'yp'}]},_this.OpenLoader=function(){_this.setState({isLoader:true});console.log('LOADERLOADERLOADER:',_this.state.isLoader);},_this.openModel2=function(id){_this.setState({isLoader:true});// var url ='https://view.activated.co.il/twocities/de/instagram-api.php?ID=' + id; 
// var url = 'https://www.instagram.com/p/' + id; 
// window.open(url);
setTimeout(function(){var url=Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'instagram-api.php?ID='+id;var url='https://en.citiesbreak.com/instagram-api.php?ID='+id;// var url = 'https://new.goisrael.com/eu/instagram-api.php?ID=' + id; 
console.log('id:',id);// alert(url);
// var url = 'https://www.instagram.com/p/'+id+'/?tagged=takeme2telaviv&__a=1';
__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url,{}).then(function(res){var obj=res.data;_this.setState({isLoader:false});if(obj==null){var url='https://www.instagram.com/p/'+id;window.open(url);}else{var userinfo=obj.graphql.shortcode_media;var likes=userinfo.edge_media_preview_like.count;var username=userinfo.owner.username;var caption=userinfo.edge_media_to_caption.edges[0].node.text;var userProfileImg=userinfo.owner.profile_pic_url;console.log(username);_this.setState({isInstaOpen:true,instagramId:id,instagramUserImg:userProfileImg,instagramCaption:caption,instagramUserName:username,instagramLikes:likes});}});},2000);},_this.openModal=function(id,ctg){_this.setState({open:true,ctg:ctg,id:id});},_this.closeModal=function(){_this.setState({open:false});},_this.closeModal2=function(){_this.setState({isInstaOpen:false});},_this.updateDimensions=function(){var w=window,d=document,documentElement=d.documentElement,body=d.getElementsByTagName('body')[0],width=w.innerWidth||documentElement.clientWidth||body.clientWidth;// height = w.innerHeight|| documentElement.clientHeight|| body.clientHeight;
_this.setState({width:width});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(GalleryTA,[{key:'componentWillMount',value:function componentWillMount(){this.updateDimensions();}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('scroll',this.handleScroll);window.removeEventListener('resize',this.updateDimensions);}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var galleryId='noGalleryId';var videoId='';var cityName='';var stopLoopAt=32;console.log(this.props);if(this.props.match.params.galleryId!==undefined){galleryId=this.props.match.params.galleryId;if(galleryId==='ja'){videoId='V0Acsw3Hf_M';stopLoopAt=32;cityName='JERUSALEM';}else if(galleryId==='ta'){videoId='5nqL-oIC0GA';stopLoopAt=28;cityName='TEL AVIV';}else if(galleryId==='deadsea'){videoId='M627s8TdaB8';stopLoopAt=13;cityName='DAS TOTE MEER';}else if(galleryId==='eilat'){videoId='ZdnNT-GDJv4';stopLoopAt=17;cityName='EILAT';}else if(galleryId==='caesarea'){videoId='eLZ433_S6HI';stopLoopAt=4;cityName='CAESAREA';}else if(galleryId==='negev'){videoId='XxWa_MNm5x8';stopLoopAt=17;cityName='NEGEV';}else if(galleryId==='haifa'){videoId='3ahATaKkhBk';stopLoopAt=17;cityName='HAIFA';}else if(galleryId==='culinary'){videoId='JQD9JpMaw9g';stopLoopAt=13;cityName='CULINARY';}else if(galleryId==='galilee'){videoId='ImobrsxsKl8';stopLoopAt=17;cityName='GALILEE';}else if(galleryId==='markets'){videoId='2CSCe2WC7Ns';stopLoopAt=13;cityName='MARKETS';}else if(galleryId==='yp'){videoId='M627s8TdaB8';stopLoopAt=102;cityName='IHRE FOTOS';}}Promise.all([Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["a" /* asyncgetWeather */])(),Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["c" /* geinstagramData */])()]).then(function(response){var weather=response[0];var instagramData=response[1];// console.log( typeof weather);
// console.log( weather);
var weather2=weather;if(typeof weather==='string'&&weather.includes("float")){// Variable is a string
// console.log('Is float in string');
var str=weather.substring(weather.indexOf("{")+1);var str2="{"+str;// console.log(str2);
weather2=JSON.parse(str2);}else if((typeof weather==='undefined'?'undefined':_typeof(weather))==='object'&&weather!==null){// Variable is an object
// console.log('Variable is an object');
weather2=weather.data;// console.log(weather2);
}else if(typeof weather==='string'&&!weather.includes("float")){// console.log('Is NOt  float in string');
var _str=weather.substring(weather.indexOf("{")+1);var _str2="{"+_str;// console.log(str2);
weather2=JSON.parse(_str2);}//  else {
//   // Variable is neither a string nor an object
//   console.log('Variable is neither a string nor an object');
// }
_this2.setState({deadSeaWeather:weather2.deadsea.temperature,jerusalemWeather:weather2.jerusalem.temperature,telAvivWeather:weather2.telaviv.temperature,waterTemp:weather2.telaviv.water_temp,instagramData:instagramData.posts,galleryId:galleryId,videoId:videoId,cityName:cityName,stopLoopAt:stopLoopAt});});}},{key:'render',value:function render(){var _this3=this;// let count  = 30;
var gallery=[];for(var i=1;i<=32;i++){gallery.push({id:i});};var sliderSettings={dots:false,autoplay:true,// lazyLoad: 'ondemand',
infinite:true,lazyLoad:"ondemand",cssEase:'linear',slidesToShow:3,slidesToScroll:3,responsive:[{breakpoint:1000,settings:{slidesToShow:2,slidesToScroll:2}},{breakpoint:600,settings:{slidesToShow:2,slidesToScroll:1}}]};var singleGalleryImg='';var singleGalleryImgMob='';var galleryHtml='';var galleryHtml2='';var galleryHtml3='';var galleryHtml4='';var galleryHtml5='';var galleryHtml6='';var galleryHtml7='';var galleryHtml8='';var galleryHtml9='';var galleryHtml10='';var stopLoopAt='';var finatlHtmlToRender='';var videoId='';var relatedGaleryHtml=null;{/*let cover = <HomeSlider waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather} />;*/}var cover=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["d" /* CoverSection */],{desktopImg:'/posts/bank/page-gallery/1.jpg',mobileImg:'/posts/bank/page-gallery/M.jpg',cssClass:'telaviv',waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather});var cityName='';var cssClass='';var instagramHtml=null;var bigImgPath="gallery/ta/big/"+this.state.id+".jpg";if(this.state.ctg==='ja'){bigImgPath="gallery/ja/big/"+this.state.id+".jpg";}else if(this.state.ctg==='deadsea'){bigImgPath="gallery/deadsea/big/"+this.state.id+".jpg";}else if(this.state.ctg==='eilat'){bigImgPath="gallery/eilat/big/"+this.state.id+".jpg";}else if(this.state.ctg==='caesarea'){bigImgPath="gallery/caesarea/big/"+this.state.id+".jpg";}else if(this.state.ctg==='negev'){bigImgPath="gallery/negev/big/"+this.state.id+".jpg";}else if(this.state.ctg==='haifa'){bigImgPath="gallery/haifa/big/"+this.state.id+".jpg";}else if(this.state.ctg==='culinary'){bigImgPath="gallery/culinary/big/"+this.state.id+".jpg";}else if(this.state.ctg==='galilee'){bigImgPath="gallery/galilee/big/"+this.state.id+".jpg";}else if(this.state.ctg==='markets'){bigImgPath="gallery/markets/big/"+this.state.id+".jpg";}if(this.props.match.params.galleryId===undefined){var instagramData=this.state.instagramData;var size=1;// if ( this.state.width < 600 ) {
//     size = 4;
// }
if(instagramData.length>0){while(instagramData.length>0){this.state.instagramDataMobile.push(instagramData.splice(0,size));}}if(this.state.instagramDataMobile.length>0){instagramHtml=this.state.instagramDataMobile.map(function(arr,i){return arr.map(function(o,i){var imgLink="instagram/"+o.id+".jpg";if(_this3.state.width<600){imgLink="instagram/Mobile/"+o.id+".jpg";}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:o.id,onClick:function onClick(){_this3.openModel2(o.id);}},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["l" /* InstagremSliderItem */],{title:o.publishBy,cssClass:'InstagremSliderItem-'+i,img:"instagram/"+o.id+".jpg"}));});});// console.log('instagramHtml2' , instagramHtml2);
instagramHtml=instagramHtml.map(function(o,i){// console.log(o);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:i},o);});}var _currentInstagramLikeUrl='https://www.instagram.com/p/'+this.state.instagramId+'/';var _currentInstagramUrl='https://www.instagram.com/'+this.state.instagramUserName+'/';var _currentInstagramImgUrl="instagram/"+this.state.instagramId+".jpg";// alert('currentInstagramImgUrl : ' +currentInstagramImgUrl);
// alert('currentInstagramUrl : ' +currentInstagramUrl);
// alert('currentInstagramLikeUrl : ' +currentInstagramLikeUrl);
galleryHtml=gallery.map(function(o,i){console.log(o);var cssClass='col';if(i%3===0){cssClass+=" first ";}if(i<=28){var imgPath="gallery/ta/small/"+o.id+".jpg";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass,key:o.id,onClick:function onClick(){_this3.openModal(o.id,'ta');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:imgPath}));}});galleryHtml2=gallery.map(function(o,i){var cssClass='col';if(i<=32){var imgPath="gallery/ja/small/"+o.id+".jpg";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass,key:o.id,onClick:function onClick(){_this3.openModal(o.id,'ja');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:imgPath}));}});galleryHtml3=gallery.map(function(o,i){var cssClass='col';if(i<=13){var imgPath="gallery/deadsea/small/"+o.id+".jpg";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass,key:o.id,onClick:function onClick(){_this3.openModal(o.id,'deadsea');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:imgPath}));}});galleryHtml4=gallery.map(function(o,i){var cssClass='col';if(i<=17){var imgPath="gallery/eilat/small/"+o.id+".jpg";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass,key:o.id,onClick:function onClick(){_this3.openModal(o.id,'eilat');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:imgPath}));}});galleryHtml5=gallery.map(function(o,i){var cssClass='col';if(i<=4){var imgPath="gallery/caesarea/small/"+o.id+".jpg";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass,key:o.id,onClick:function onClick(){_this3.openModal(o.id,'caesarea');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:imgPath}));}});galleryHtml6=gallery.map(function(o,i){var cssClass='col';if(i<=17){var imgPath="gallery/negev/small/"+o.id+".jpg";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass,key:o.id,onClick:function onClick(){_this3.openModal(o.id,'negev');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:imgPath}));}});galleryHtml7=gallery.map(function(o,i){var cssClass='col';if(i<=5){var imgPath="gallery/haifa/small/"+o.id+".jpg";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass,key:o.id,onClick:function onClick(){_this3.openModal(o.id,'haifa');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:imgPath}));}});galleryHtml8=gallery.map(function(o,i){var cssClass='col';if(i<=13){var imgPath="gallery/culinary/small/"+o.id+".jpg";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass,key:o.id,onClick:function onClick(){_this3.openModal(o.id,'culinary');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:imgPath}));}});galleryHtml9=gallery.map(function(o,i){var cssClass='col';if(i<=17){var imgPath="gallery/galilee/small/"+o.id+".jpg";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass,key:o.id,onClick:function onClick(){_this3.openModal(o.id,'galilee');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:imgPath}));}});galleryHtml10=gallery.map(function(o,i){var cssClass='col';if(i<=13){var imgPath="gallery/markets/small/"+o.id+".jpg";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass,key:o.id,onClick:function onClick(){_this3.openModal(o.id,'markets');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:imgPath}));}});finatlHtmlToRender=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'post-data'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner',id:'instagram'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* HomeTitle */],null,'IHRE FOTOS VON ISRAEL'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gallery-html-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},instagramHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button show_more',href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/yp'},'ALLE BILDER >>')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_lazyload___default.a,{height:200,once:true,offset:50},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner',id:'tel-aviv-gallery'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/ta'},'TEL AVIV')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gallery-html-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},galleryHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button show_more',href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/ta'},'ALLE BILDER >>'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_lazyload___default.a,{height:200,once:true,offset:50},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/ja'},'JERUSALEM')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gallery-html-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},galleryHtml2),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button show_more',href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/ja'},'ALLE BILDER >>')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_lazyload___default.a,{height:200,once:true,offset:50},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/deadsea'},'DAS TOTE MEER')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gallery-html-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},galleryHtml3)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button show_more',href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/deadsea'},'ALLE BILDER >>'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_lazyload___default.a,{height:200,once:true,offset:50},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/eilat'},'EILAT')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gallery-html-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},galleryHtml4)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button show_more',href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/eilat'},'ALLE BILDER >>'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_lazyload___default.a,{height:200,once:true,offset:50},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/caesarea'},'CAESAREA')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gallery-html-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},galleryHtml5)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button show_more',href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/caesarea'},'ALLE BILDER >>'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_lazyload___default.a,{height:200,once:true,offset:50},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/negev'},'NEGEV')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gallery-html-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},galleryHtml6)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button show_more',href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/negev'},'ALLE BILDER >>'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_lazyload___default.a,{height:200,once:true,offset:50},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/haifa'},'HAIFA')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gallery-html-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},galleryHtml7)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button show_more',href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/haifa'},'ALLE BILDER >>'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_lazyload___default.a,{height:200,once:true,offset:50},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/culinary'},'KULINARISCH')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gallery-html-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},galleryHtml8)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button show_more',href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/culinary'},'ALLE BILDER >>'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_lazyload___default.a,{height:200,once:true,offset:50},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/galilee'},'GALILEE')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gallery-html-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},galleryHtml9)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button show_more',href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/galilee'},'ALLE BILDER >>'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_lazyload___default.a,{height:200,once:true,offset:50},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/markets'},'MARKETS')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gallery-html-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},galleryHtml10)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button show_more',href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/markets'},'ALLE BILDER >>')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactjs_popup__["a" /* default */],{open:this.state.isInstaOpen,closeOnDocumentClick:true,onClose:this.closeModal2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'close',onClick:this.closeModal2},'\xD7'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'userImgInstagram'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:_currentInstagramImgUrl})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user-info-instagram'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',href:_currentInstagramUrl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'userProfileImgWrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.state.instagramUserImg})),'@',this.state.instagramUserName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'instagramCaption'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.state.instagramCaption!=null?Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["i" /* limitText */])(this.state.instagramCaption,130):''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',href:_currentInstagramLikeUrl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'like-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:"like.png"}))))));__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactjs_popup__["a" /* default */],{open:this.state.open,closeOnDocumentClick:true,onClose:this.closeModal2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'close',onClick:this.closeModal2},'\xD7'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'userImgInstagram'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:_currentInstagramImgUrl})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user-info-instagram'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',href:_currentInstagramUrl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'userProfileImgWrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.state.instagramUserImg})),'@',this.state.instagramUserName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'instagramCaption'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.state.instagramCaption!=null?Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["i" /* limitText */])(this.state.instagramCaption,130):''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',href:_currentInstagramLikeUrl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'like-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:"like.png"})))));}else{var galleryId=this.state.galleryId;var imgToShow='';if(galleryId==='ta'){imgToShow='1.jpg';}else if(galleryId==='ja'){imgToShow='4.jpg';}else if(galleryId==='deadsea'){imgToShow='6.jpg';}else if(galleryId==='eilat'){imgToShow='1.jpg';}if(galleryId==='ta'||galleryId==='deadsea'||galleryId==='ja'||galleryId==='eilat'||galleryId==='negev'||galleryId==='caesarea'||galleryId==='haifa'||galleryId==='galilee'||galleryId==='culinary'||galleryId==='markets'){cover=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:'gallery/'+'/ctg/Main/'+galleryId+'.jpg',mobileImg:'gallery/'+'/ctg/Mobile/'+galleryId+'.jpg'});bigImgPath="gallery/"+galleryId+"/big/"+this.state.id+".jpg";galleryHtml=gallery.map(function(o,i){var cssClass='col';if(_this3.state.stopLoopAt%3!=0&&i===_this3.state.stopLoopAt-1){// cssClass += ' last';
cssClass+='';}if(i<=_this3.state.stopLoopAt){var imgPath="gallery/"+galleryId+"/small/"+o.id+".jpg";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass,key:o.id,onClick:function onClick(){_this3.openModal(o.id,galleryId);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:imgPath}));}});}else if(galleryId==='yp'){// console.log("this.props.match.params.galleryId 10_10 :", this.props.match.params.galleryId);
cover=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:'gallery/ctg/Main/'+galleryId+'.jpg',mobileImg:'gallery/'+'ctg/Mobile/'+galleryId+'.jpg'});galleryHtml=this.state.instagramData.map(function(o,i){var obj_id=o.id;var obj_publishBy=o.publishBy;// console.log('OOOOO:', o);
// return arr.map((o , i) =>  {
var imgLink="instagram/"+o.id+".jpg";if(_this3.state.width<600){imgLink="instagram/Mobile/"+o.id+".jpg";}// console.log('imgLink' , imgLink);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-wrapper-img-instagram',onClick:function onClick(){console.log('obj_id:',obj_id);_this3.openModel2(obj_id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:imgLink}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-wrapper-publish-by'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'ac-publish-by'},'@',obj_publishBy)));// });
});// console.log('instagramHtml2' , instagramHtml2);
galleryHtml=galleryHtml.map(function(o,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:i},o);});}relatedGaleryHtml=this.state.relatedGalery.map(function(o,i){var link='/Pages/Gallery/'+o.cityId;if(o.cityId!==galleryId){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["f" /* GallerSideBarItem */],{key:i,title:o.title,link:link,img:'gallery/'+'/ctg/'+o.cityId+'.jpg'});}});finatlHtmlToRender=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'post-data'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col-75'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* HomeTitle */],null,this.state.cityName),this.state.galleryId==='yp'?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:this.state.videoId}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gallery-html-wrapper'},galleryHtml),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col-25 sidebar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* HomeTitle */],null,'GALERIE'),relatedGaleryHtml,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'show_more button',href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery'},'ALLE BILDER >>'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'})));}var currentInstagramUrl='https://www.instagram.com/'+this.state.instagramUserName+'/';var currentInstagramImgUrl="instagram/"+this.state.instagramId+".jpg";var currentInstagramLikeUrl='https://www.instagram.com/p/'+this.state.instagramId+'/';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"page align-center page-Gallery inner-post gallery-"+this.state.galleryId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Components_Menu_Menu__["a" /* default */],null),cover,finatlHtmlToRender,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactjs_popup__["a" /* default */],{open:this.state.open,closeOnDocumentClick:true,onClose:this.closeModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'close',onClick:this.closeModal},'\xD7'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:bigImgPath}))),this.state.isLoader===true?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-wrapper-loading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Components_Loader_Loader__["a" /* default */],null)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactjs_popup__["a" /* default */],{open:this.state.isInstaOpen,closeOnDocumentClick:true,onClose:this.closeModal2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'close',onClick:this.closeModal2},'\xD7'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'userImgInstagram'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:currentInstagramImgUrl})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user-info-instagram'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',href:currentInstagramUrl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'userProfileImgWrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.state.instagramUserImg})),'@',this.state.instagramUserName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'instagramCaption'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.state.instagramCaption!=null?Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["i" /* limitText */])(this.state.instagramCaption,130):''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',href:currentInstagramLikeUrl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'like-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:"like.png"}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Components_Footer_Footer__["a" /* default */],null));}}]);return GalleryTA;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* withRouter */])(GalleryTA));

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lazyload__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reactjs_popup__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Components_Footer_Footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Gallery_css__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Gallery_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Gallery_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GalleryJA=function(_Component){_inherits(GalleryJA,_Component);function GalleryJA(){var _ref;var _temp,_this,_ret;_classCallCheck(this,GalleryJA);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=GalleryJA.__proto__||Object.getPrototypeOf(GalleryJA)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0,open:false,id:null},_this.openModal=function(id){_this.setState({open:true,id:id});},_this.closeModal=function(){_this.setState({open:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(GalleryJA,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_4__Utility_Utility__["g" /* getWeather */])(function(Weather){console.log("Weather",Weather);_this2.setState({telAvivWeather:Weather.telAvivWeather,waterTemp:Weather.water_temp,jerusalemWeather:Weather.jerusalemWeather});});}},{key:'render',value:function render(){var _this3=this;var count=26;var gallery=[];for(var i=1;i<=count;i++){gallery.push({id:i});};var galleryHtml=gallery.map(function(o,i){var cssClass='col col-30';if(i%3===0){cssClass+=" first ";}var imgPath="gallery/JA/small/"+o.id+".jpg";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass,onClick:function onClick(){_this3.openModal(o.id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["j" /* Img */],{desktopImg:imgPath}));});var bigImgPath="gallery/JA/big/"+this.state.id+".jpg";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page align-center page-Gallery inner-post'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'post-data'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["h" /* HomeSlider */],{waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col-75'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["i" /* HomeTitle */],null,'jerusalem'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gallery-html-wrapper'},galleryHtml))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactjs_popup__["a" /* default */],{open:this.state.open,closeOnDocumentClick:true,onClose:this.closeModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'close',onClick:this.closeModal},'\xD7'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["j" /* Img */],{desktopImg:bigImgPath})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_Footer_Footer__["a" /* default */],null));}}]);return GalleryJA;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(GalleryJA));

/***/ }),
/* 298 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 299 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.e45b2e0e.js